import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Accept string, number and boolean values */
  CustomGenericScalar: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   *
   * `Geometry` scalar may be represented in a few ways:
   * - Well-known text (WKT)
   * - Hexadecimal (HEX)
   * - GeoJSON
   *
   */
  Geometry: any;
  /** Arbitrary JSON Properties for features */
  JSONScalar: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  NullableID: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export type AbstractDetailInput = {
  id?: InputMaybe<Scalars['ID']>;
  idNumber?: InputMaybe<Scalars['String']>;
  issuedOn?: InputMaybe<Scalars['Date']>;
  photo?: InputMaybe<Scalars['String']>;
  validTill?: InputMaybe<Scalars['Date']>;
};

export type AccountStatement = {
  __typename?: 'AccountStatement';
  closingBalance?: Maybe<Scalars['Decimal']>;
  creditLimit?: Maybe<Scalars['Decimal']>;
  creditUsed?: Maybe<Scalars['Decimal']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<StatementCustomer>;
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  issuer?: Maybe<StatementIssuer>;
  openingBalance?: Maybe<Scalars['Decimal']>;
  statementDate?: Maybe<Scalars['Date']>;
  totalCredit?: Maybe<Scalars['Decimal']>;
  totalDebit?: Maybe<Scalars['Decimal']>;
  transactions?: Maybe<Array<Maybe<StatementTransaction>>>;
};

export type AccountType = {
  __typename?: 'AccountType';
  accountType: CommonAccountCategoryType;
  /** Final Outstanding Amount */
  balance: Scalars['Float'];
  bankDetail?: Maybe<BankDetailType>;
  baseuserSet: Array<DeliveryAgentManagementType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  distributioncentreSet: Array<DistributionCentreType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
  /** Account in which the transaction took place */
  transactionSet: Array<TransactionGraphType>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};

export type AddAccountTransactionMutation = {
  __typename?: 'AddAccountTransactionMutation';
  accountTransaction?: Maybe<TransactionGraphType>;
};

export type AddCompanyMutation = {
  __typename?: 'AddCompanyMutation';
  company?: Maybe<CompanyType>;
};

export type AddDemandMutation = {
  __typename?: 'AddDemandMutation';
  demands?: Maybe<Array<Maybe<DemandType>>>;
};

/** This is used only for addition of DC */
export type AddDistributionCentreMutation = {
  __typename?: 'AddDistributionCentreMutation';
  distributionCentre?: Maybe<DistributionCentreLocationType>;
};

export type AddGroupMutation = {
  __typename?: 'AddGroupMutation';
  group?: Maybe<GroupType>;
};

export type AddNewBookingMutation = {
  __typename?: 'AddNewBookingMutation';
  trip?: Maybe<TripType>;
};

export type AddNewScheduleMutation = {
  __typename?: 'AddNewScheduleMutation';
  schedules?: Maybe<Array<Maybe<ScheduleType>>>;
};

export type AddNotificationMutation = {
  __typename?: 'AddNotificationMutation';
  notification?: Maybe<NotificationType>;
};

export type AddOneAssignedRoutePointMutation = {
  __typename?: 'AddOneAssignedRoutePointMutation';
  assignedRoutePoint?: Maybe<AssignedRoutePointType>;
};

export type AddOrUpdateUserMutation = {
  __typename?: 'AddOrUpdateUserMutation';
  user?: Maybe<BaseUserType>;
};

export type AddPlotCommoditySampleMutation = {
  __typename?: 'AddPlotCommoditySampleMutation';
  plotCommodity?: Maybe<PlotCommodityType>;
};

export type AddPriceBenchmarkRecommendation = {
  __typename?: 'AddPriceBenchmarkRecommendation';
  banchmarkRecommendation?: Maybe<PriceBenchmarkRecommendationType>;
};

/** Approve a grade price and optionally update its schedule's crop group and grade. */
export type AddPriceToGradePriceMutation = {
  __typename?: 'AddPriceToGradePriceMutation';
  gradePrice?: Maybe<GradePriceType>;
  schedule?: Maybe<ScheduleType>;
  scheduleRequest?: Maybe<ScheduleRequestType>;
};

export type AddRemarkProductionItem = {
  __typename?: 'AddRemarkProductionItem';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddRemarkProductionItemInput = {
  lineProductionItemId: Scalars['ID'];
  remark: Scalars['String'];
};

export type AddStockTransactionMutation = {
  __typename?: 'AddStockTransactionMutation';
  stockTransaction?: Maybe<StockTransactionType>;
};

export type AddTemporaryOrder = {
  __typename?: 'AddTemporaryOrder';
  order?: Maybe<OrderType>;
};

export type AddUpdateAddressMutation = {
  __typename?: 'AddUpdateAddressMutation';
  userAddress?: Maybe<BaseUserAddressType>;
};

/** BaseUser, Contact, KYCDetail, BankDetail */
export type AddUpdateBasicFarmerMutation = {
  __typename?: 'AddUpdateBasicFarmerMutation';
  user?: Maybe<BaseUserType>;
};

export type AddUpdateBasicPlotMutation = {
  __typename?: 'AddUpdateBasicPlotMutation';
  plot?: Maybe<PlotType>;
};

/** BaseUser, Contact, KYCDetail */
export type AddUpdateBasicVendorMutation = {
  __typename?: 'AddUpdateBasicVendorMutation';
  user?: Maybe<BaseUserType>;
};

export type AddUpdateBatchInwardMutation = {
  __typename?: 'AddUpdateBatchInwardMutation';
  booking?: Maybe<BookingType>;
  response?: Maybe<Scalars['String']>;
};

export type AddUpdateBatchStockMutation = {
  __typename?: 'AddUpdateBatchStockMutation';
  batchStock?: Maybe<BatchStockType>;
};

export type AddUpdateBeatMutation = {
  __typename?: 'AddUpdateBeatMutation';
  beat?: Maybe<BeatType>;
};

export type AddUpdateBeatVisitActionsMutation = {
  __typename?: 'AddUpdateBeatVisitActionsMutation';
  beatVisitActions?: Maybe<Array<Maybe<BeatVisitActionType>>>;
};

export type AddUpdateBeatVisitMutation = {
  __typename?: 'AddUpdateBeatVisitMutation';
  beatVisit?: Maybe<BeatVisitType>;
};

export type AddUpdateBenchmarkData = {
  __typename?: 'AddUpdateBenchmarkData';
  banchmarkMetadata?: Maybe<PriceBenchmarkMetadataType>;
};

export type AddUpdateBulkInwardMutation = {
  __typename?: 'AddUpdateBulkInwardMutation';
  trip?: Maybe<TripType>;
};

export type AddUpdateBusinessPointOfContacts = {
  __typename?: 'AddUpdateBusinessPointOfContacts';
  pointOfContacts?: Maybe<BaseUserType>;
};

export type AddUpdateBusinessRegistrationMutation = {
  __typename?: 'AddUpdateBusinessRegistrationMutation';
  business?: Maybe<FamilyGroupType>;
};

export type AddUpdateConsolidatedOrderMutation = {
  __typename?: 'AddUpdateConsolidatedOrderMutation';
  order?: Maybe<OrderType>;
};

/** Create or update a credit facility for a user. */
export type AddUpdateCreditMutation = {
  __typename?: 'AddUpdateCreditMutation';
  credit?: Maybe<CreditType>;
};

export type AddUpdateCropVariety = {
  __typename?: 'AddUpdateCropVariety';
  variety?: Maybe<CommodityVarietyType>;
};

export type AddUpdateDcStockTakeConfigMuation = {
  __typename?: 'AddUpdateDCStockTakeConfigMuation';
  stockConfig?: Maybe<DcStockTakeConfigType>;
};

export type AddUpdateDcStorageLocationMutation = {
  __typename?: 'AddUpdateDCStorageLocationMutation';
  storageLocation?: Maybe<DcStorageLocationType>;
};

export type AddUpdateDeliveryBatchMutation = {
  __typename?: 'AddUpdateDeliveryBatchMutation';
  booking?: Maybe<BookingType>;
};

export type AddUpdateDepartmentMutation = {
  __typename?: 'AddUpdateDepartmentMutation';
  department?: Maybe<DepartmentType>;
};

export type AddUpdateDepotMutation = {
  __typename?: 'AddUpdateDepotMutation';
  depot?: Maybe<DepotType>;
};

/** Affects VehicleTransportDetail, Schedule, Trip, Booking */
export type AddUpdateDispatchMutation = {
  __typename?: 'AddUpdateDispatchMutation';
  trip?: Maybe<TripType>;
};

export type AddUpdateDockDetailMutation = {
  __typename?: 'AddUpdateDockDetailMutation';
  dockDetail?: Maybe<DockDetailType>;
};

export type AddUpdateDockMutation = {
  __typename?: 'AddUpdateDockMutation';
  dock?: Maybe<DockType>;
};

export type AddUpdateFarmerMutation = {
  __typename?: 'AddUpdateFarmerMutation';
  farmer?: Maybe<BaseUserType>;
};

export type AddUpdateInwardAllocationMutation = {
  __typename?: 'AddUpdateInwardAllocationMutation';
  inward?: Maybe<InwardAllocationType>;
};

export type AddUpdateLoadingBatchMutation = {
  __typename?: 'AddUpdateLoadingBatchMutation';
  booking?: Maybe<BookingType>;
};

export type AddUpdateNotificationTemplateMutation = {
  __typename?: 'AddUpdateNotificationTemplateMutation';
  template?: Maybe<NotificationTemplateType>;
};

export type AddUpdateNotificationTemplateV1 = {
  __typename?: 'AddUpdateNotificationTemplateV1';
  template?: Maybe<NewNotificationTemplateType>;
};

export type AddUpdateOrderTransactionMutation = {
  __typename?: 'AddUpdateOrderTransactionMutation';
  orderTransaction?: Maybe<OrderTransactionType>;
};

export type AddUpdateOrderTransactionsMutation = {
  __typename?: 'AddUpdateOrderTransactionsMutation';
  orderTransactions: Array<Maybe<OrderTransactionType>>;
};

export type AddUpdatePackagingMaterialMutation = {
  __typename?: 'AddUpdatePackagingMaterialMutation';
  packagingMaterial?: Maybe<PackagingMaterialType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddUpdatePackingAllotmentMutation = {
  __typename?: 'AddUpdatePackingAllotmentMutation';
  packingAllotment?: Maybe<PackingAllotmentType>;
};

/**
 * Single mutation to create/update/delete a Production with nested items & children.
 *
 * Behavior:
 * - If input.id is present -> update that Production; else create a new one.
 * - If input.delete=True and id provided -> hard delete Production (cascade).
 * - For items and their children:
 *     - id absent & delete False -> create
 *     - id present & delete False -> update
 *     - id present & delete True  -> delete
 *     (New + delete is ignored)
 */
export type AddUpdateProduction = {
  __typename?: 'AddUpdateProduction';
  error?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  production?: Maybe<ProductionType>;
};

export type AddUpdateQualitySampleMinimalMutation = {
  __typename?: 'AddUpdateQualitySampleMinimalMutation';
  inwards?: Maybe<Array<Maybe<InwardType>>>;
};

export type AddUpdateQualitySampleMutation = {
  __typename?: 'AddUpdateQualitySampleMutation';
  sample?: Maybe<QualitySampleType>;
};

export type AddUpdateQuickVehicleMutation = {
  __typename?: 'AddUpdateQuickVehicleMutation';
  vehicle?: Maybe<VehicleType>;
};

export type AddUpdateReportTemplate = {
  __typename?: 'AddUpdateReportTemplate';
  reportTemplate?: Maybe<ReportTemplateType>;
};

export type AddUpdateReviewMutation = {
  __typename?: 'AddUpdateReviewMutation';
  review?: Maybe<SellableItemReviewType>;
};

export type AddUpdateRouteAssignmentMutation = {
  __typename?: 'AddUpdateRouteAssignmentMutation';
  routeAssignment?: Maybe<RouteAssignmentType>;
};

export type AddUpdateRouteMutation = {
  __typename?: 'AddUpdateRouteMutation';
  route?: Maybe<RouteType>;
};

export type AddUpdateScheduleTransportMutation = {
  __typename?: 'AddUpdateScheduleTransportMutation';
  detail?: Maybe<VehicleTransportDetailType>;
};

/**
 * Add/Update Sellable Item mutaiton. The mutaiton will also populate taxes data from base
 * sellable_item if the current sellable_item is a variant.
 */
export type AddUpdateSellableItemMutation = {
  __typename?: 'AddUpdateSellableItemMutation';
  sellableItem?: Maybe<SellableItemType>;
};

export type AddUpdateSellableItemStockMutation = {
  __typename?: 'AddUpdateSellableItemStockMutation';
  sellableItemStock?: Maybe<SellableItemStockType>;
};

export type AddUpdateShopPointOfContacts = {
  __typename?: 'AddUpdateShopPointOfContacts';
  pointOfContacts?: Maybe<BaseUserType>;
};

export type AddUpdateShopRegistrationMutation = {
  __typename?: 'AddUpdateShopRegistrationMutation';
  shop?: Maybe<ShopType>;
};

export type AddUpdateSkuTypeMutation = {
  __typename?: 'AddUpdateSkuTypeMutation';
  skuType?: Maybe<SkuGraphType>;
};

export type AddUpdateStockEntryItemsMutation = {
  __typename?: 'AddUpdateStockEntryItemsMutation';
  stockEntryItems?: Maybe<Array<Maybe<StockEntryItemType>>>;
};

/** Used for updating the status of the approval requests. */
export type AddUpdateStockTakeApprovalMutation = {
  __typename?: 'AddUpdateStockTakeApprovalMutation';
  approvalRequest?: Maybe<Array<Maybe<StockTakeApprovalRequestType>>>;
};

/** This mutation creates beat for assignee for current date if current date false in recurrence. */
export type AddUpdateSupBeatMutation = {
  __typename?: 'AddUpdateSupBeatMutation';
  beat?: Maybe<SupBeatType>;
};

export type AddUpdateSurveyAreaMutation = {
  __typename?: 'AddUpdateSurveyAreaMutation';
  surveyArea?: Maybe<SurveyAreaLocationType>;
};

export type AddUpdateUnloadingBatchMutation = {
  __typename?: 'AddUpdateUnloadingBatchMutation';
  booking?: Maybe<BookingType>;
};

export type AddUpdateVariantFromBatchStockMutation = {
  __typename?: 'AddUpdateVariantFromBatchStockMutation';
  batchStock?: Maybe<BatchStockType>;
  sellableItem?: Maybe<SellableItemType>;
  sellableItemStock?: Maybe<SellableItemStockType>;
};

export type AddUpdateVehicleCertificationMutation = {
  __typename?: 'AddUpdateVehicleCertificationMutation';
  vehicle?: Maybe<VehicleType>;
};

export type AddUpdateVehicleContract = {
  __typename?: 'AddUpdateVehicleContract';
  contract?: Maybe<ContractType>;
};

export type AddUpdateVehicleDiemnsionsMutation = {
  __typename?: 'AddUpdateVehicleDiemnsionsMutation';
  vehicle?: Maybe<Array<Maybe<VehicleType>>>;
};

export type AddUpdateVehicleDriverMutation = {
  __typename?: 'AddUpdateVehicleDriverMutation';
  driver?: Maybe<BaseUserType>;
};

export type AddUpdateVehicleMutation = {
  __typename?: 'AddUpdateVehicleMutation';
  vehicle?: Maybe<VehicleType>;
};

export type AddUpdateVehicleOwnerMutation = {
  __typename?: 'AddUpdateVehicleOwnerMutation';
  owner?: Maybe<BaseUserType>;
};

export type AddVehicleExpenseMutation = {
  __typename?: 'AddVehicleExpenseMutation';
  expense?: Maybe<ExpenseType>;
};

export type AddVehiclePaymentMutation = {
  __typename?: 'AddVehiclePaymentMutation';
  payment?: Maybe<PaymentType>;
};

export type AddVendorToAssignmentMutation = {
  __typename?: 'AddVendorToAssignmentMutation';
  assignedRoutePoint?: Maybe<AssignedRoutePointType>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  geofenceRadius?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type AddressOutput = {
  __typename?: 'AddressOutput';
  address?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  village?: Maybe<Scalars['String']>;
  w3wName?: Maybe<Scalars['String']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  address?: Maybe<Scalars['String']>;
  baseuseraddressSet: Array<BaseUserAddressType>;
  /** Beat Completed Location */
  beatSet: Array<BeatType>;
  billedOrders: Array<AnnotatedOrderType>;
  booking?: Maybe<BookingType>;
  depotSet: Array<DepotType>;
  distributioncentreSet: Array<DistributionCentreType>;
  district?: Maybe<Scalars['String']>;
  dockSet: Array<DockType>;
  /** Vendor's Business Address */
  familygroupSet: Array<FamilyGroupType>;
  /** Specify raduis if it is geofence */
  geofenceRadius: Scalars['Int'];
  geopoint?: Maybe<GeometryObjectType>;
  geopointFlipped?: Maybe<GeometryObjectType>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  locationLogs: Array<TripStepLogType>;
  longitude: Scalars['Float'];
  marketyardSet: Array<MarketYardType>;
  mediaentitySet: Array<MediaEntityType>;
  orderSet: Array<AnnotatedOrderType>;
  orderitembatchSet: Array<OrderItemBatchType>;
  pincode?: Maybe<Scalars['String']>;
  plotSet: Array<PlotType>;
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  shippingSet: Array<ShippingType>;
  /** Shop Address */
  shopSet: Array<ShopType>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<StateType>;
  stockentryitemSet: Array<StockEntryItemType>;
  taluka?: Maybe<Scalars['String']>;
  tripstepSet: Array<TripStepType>;
  usersLocated: Array<DeliveryAgentManagementType>;
  village: Scalars['String'];
  visitEndedAt: Array<BeatVisitType>;
  visitStartedAt: Array<BeatVisitType>;
  w3wName?: Maybe<Scalars['String']>;
};

export type AggregateFilterInput = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  routeId?: InputMaybe<Scalars['ID']>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
};

export type AggregatorDetail = {
  __typename?: 'AggregatorDetail';
  payments?: Maybe<AggregatorPaymentsDetail>;
  returnStocks?: Maybe<AggregatorStocksDetail>;
  sku?: Maybe<AggregatorSkuDetail>;
  trips?: Maybe<AggregatorTripsDetail>;
};

export type AggregatorPaymentsDetail = {
  __typename?: 'AggregatorPaymentsDetail';
  /** Amount collected by delivery agent */
  collectedByAggregator?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['Date']>;
  /** Order value delivery agent is carrying */
  paymentsActualOrderValue?: Maybe<Scalars['Float']>;
  /** Actual amount pending with delivery agent */
  remainingToBeTakenByCompany?: Maybe<Scalars['Float']>;
  /** Amount settled by delivery agent */
  setteledByAggregator?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Date']>;
  /** Actual amount company has to collect from delivery agent, calculated againts items he delivered */
  toBeCollectedByCompany?: Maybe<Scalars['Float']>;
  /** Amount unsettled by delivery agent */
  unsetteledByAggregator?: Maybe<Scalars['Float']>;
};

export type AggregatorSkuDetail = {
  __typename?: 'AggregatorSkuDetail';
  /** Sku collected */
  collected?: Maybe<Scalars['Int']>;
  /** Sku delivered */
  delivered?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  /** Sku loaded */
  loaded?: Maybe<Scalars['Int']>;
  /** Sku settled */
  settled?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['Date']>;
  /** Sku unsettled */
  unsettled?: Maybe<Scalars['Int']>;
};

export type AggregatorStocksDetail = {
  __typename?: 'AggregatorStocksDetail';
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  /** Stock delivered */
  stockDelivered?: Maybe<Scalars['Int']>;
  /** Stock returned by vendor */
  stockReturnedByVendor?: Maybe<Scalars['Int']>;
  /** Stock settled */
  stockSettled?: Maybe<Scalars['Int']>;
  /** Total stock */
  stockTotal?: Maybe<Scalars['Int']>;
  /** Stock Undelivered, is with Delivery Agent */
  stockUndelivered?: Maybe<Scalars['Int']>;
  /** Stock unsettled */
  stockUnsettled?: Maybe<Scalars['Int']>;
};

export type AggregatorSummary = {
  __typename?: 'AggregatorSummary';
  addresses?: Maybe<Array<Maybe<AddressType>>>;
  areas?: Maybe<Scalars['Int']>;
  payments?: Maybe<AggregatorPaymentsDetail>;
  returnStocks?: Maybe<AggregatorStocksDetail>;
  sku?: Maybe<AggregatorSkuDetail>;
  total?: Maybe<Scalars['Int']>;
  trips?: Maybe<AggregatorTripsDetail>;
  unsettled?: Maybe<Scalars['Int']>;
  working?: Maybe<Scalars['Int']>;
};

export type AggregatorTripFilterInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AggregatorTripsDetail = {
  __typename?: 'AggregatorTripsDetail';
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  /** Trips Completed */
  tripsCompleted?: Maybe<Scalars['Int']>;
  /** Trips Incomplete */
  tripsIncomplete?: Maybe<Scalars['Int']>;
  /** Trips Settled */
  tripsSettled?: Maybe<Scalars['Int']>;
  /** Total Trips */
  tripsTotal?: Maybe<Scalars['Int']>;
  /** Trips Unsettled */
  tripsUnsettled?: Maybe<Scalars['Int']>;
  /** Upcoming Trips */
  tripsUpcoming?: Maybe<Scalars['Int']>;
};

export type AlertObject = {
  __typename?: 'AlertObject';
  date?: Maybe<Scalars['Date']>;
  message?: Maybe<Scalars['String']>;
};

export type AllAggregatorFilterInput = {
  departmentId: Scalars['ID'];
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  /** Returns list of aggregators who have unsettled trips or stocks or payments */
  isUnsettled?: InputMaybe<Scalars['Boolean']>;
  /** Returns list of aggregators who have unsettled payments */
  isUnsettledPayments?: InputMaybe<Scalars['Boolean']>;
  /** Returns list of aggregators who have unsettled Stocks */
  isUnsettledStocks?: InputMaybe<Scalars['Boolean']>;
  /** Returns list of aggregators who have unsettled trips */
  isUnsettledTrips?: InputMaybe<Scalars['Boolean']>;
};

export type AllDemandItems = {
  __typename?: 'AllDemandItems';
  demands?: Maybe<Array<Maybe<DemandType>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AllDockFilterInput = {
  archive?: InputMaybe<Scalars['Boolean']>;
  depotId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type AllGroupsFilterInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AllVehicleFilterInput = {
  amountDue?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  departmentId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleType?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AnnotatedOrderType = {
  __typename?: 'AnnotatedOrderType';
  approvedReturnOrderCount?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<AddressType>;
  billingDoc: Array<BillingDocType>;
  bookingsByTrip?: Maybe<Array<Maybe<BookingType>>>;
  collectionLog?: Maybe<CollectionLogType>;
  crateBarcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  crateCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  dcCollectionLog?: Maybe<DcCollectionLogType>;
  deliveredQuantitySum?: Maybe<Scalars['Int']>;
  deliveryStatus: OrderDeliveryStatus;
  discount?: Maybe<DiscountType>;
  dynamicSalesIncharge?: Maybe<SurveyAreaLocationType>;
  id: Scalars['ID'];
  isConsolidated?: Maybe<Scalars['Boolean']>;
  isParentOrder?: Maybe<Scalars['Boolean']>;
  itemAggregate?: Maybe<ItemAggregateType>;
  metadata: Scalars['JSONString'];
  orderBookings: Array<BookingType>;
  orderCategory: OrderOrderCategory;
  orderItems?: Maybe<Array<Maybe<OrderItemType>>>;
  orderStatus: OrderOrderStatus;
  orderingDc?: Maybe<DistributionCentreType>;
  otp: Scalars['Int'];
  outstandingAmount: Scalars['Float'];
  paymentMethod: OrderPaymentMethod;
  paymentStatus: OrderPaymentStatus;
  pendingReturnOibCount?: Maybe<Scalars['Int']>;
  pendingReturnOrderCount?: Maybe<Scalars['Int']>;
  pickupDate?: Maybe<Scalars['Date']>;
  pickupSlotFromTime?: Maybe<Scalars['Time']>;
  pickupSlotToTime?: Maybe<Scalars['Time']>;
  pickupType?: Maybe<OrderPickupType>;
  placedBy?: Maybe<DeliveryAgentManagementType>;
  placedIn?: Maybe<DepartmentType>;
  pocName: Scalars['String'];
  pocNumber: Scalars['String'];
  rejectedReturnOrderCount?: Maybe<Scalars['Int']>;
  remark: Scalars['String'];
  salesIncharge?: Maybe<DeliveryAgentManagementType>;
  selectedPickupSlot?: Maybe<TimeSlotType>;
  shippingAddress: AddressType;
  shippingCharges: Scalars['Float'];
  shippingMethod: OrderShippingMethod;
  shop?: Maybe<ShopType>;
  soNumber?: Maybe<Scalars['String']>;
  statusLogs: Array<OrderStatusLogType>;
  subOrders: Array<AnnotatedOrderType>;
  targetDc?: Maybe<DistributionCentreType>;
  taxes: Array<TaxType>;
  totalAmount: Scalars['Float'];
  totalPaid?: Maybe<Scalars['Float']>;
  totalPaidAndSettled?: Maybe<Scalars['Float']>;
  totalWeight?: Maybe<Scalars['Float']>;
  trackingCode: Scalars['String'];
  transactionAmount?: Maybe<AggregatorPaymentsDetail>;
  transactions?: Maybe<Array<Maybe<OrderTransactionType>>>;
  transactionsPaymentMethod?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: DeliveryAgentManagementType;
};


export type AnnotatedOrderTypeBookingsByTripArgs = {
  isSkuUnsettled?: InputMaybe<Scalars['Boolean']>;
  isStockUnsettled?: InputMaybe<Scalars['Boolean']>;
  tripId?: InputMaybe<Scalars['ID']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type AnnotatedOrderTypeItemAggregateArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type AnnotatedOrderTypeOrderItemsArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type AnnotatedOrderTypeTransactionAmountArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
};


export type AnnotatedOrderTypeTransactionsArgs = {
  status?: InputMaybe<Scalars['String']>;
};

export type ApplyDiscountMutation = {
  __typename?: 'ApplyDiscountMutation';
  order?: Maybe<OrderType>;
};

/** An enumeration. */
export enum ApprovalRequestStatus {
  /** Approved */
  APR = 'APR',
  /** Approved Under Deviation */
  AUD = 'AUD',
  /** Hold */
  HLD = 'HLD',
  /** Pending */
  PEN = 'PEN',
  /** Rejected */
  REJ = 'REJ'
}

export type ApproveReturnRequestInput = {
  orderItemBatchId?: InputMaybe<Scalars['ID']>;
  pickupType?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  returnReason?: InputMaybe<Scalars['String']>;
  returnType?: InputMaybe<Scalars['String']>;
  salesInchargeId?: InputMaybe<Scalars['ID']>;
};

export type ApproveReturnRequestMutation = {
  __typename?: 'ApproveReturnRequestMutation';
  orderItemBatches?: Maybe<Array<Maybe<OrderItemBatchType>>>;
};

export type ApprovedTradeProfileType = {
  __typename?: 'ApprovedTradeProfileType';
  alottedYield: Scalars['Float'];
  approvedBy?: Maybe<DeliveryAgentManagementType>;
  availableYield: Scalars['Float'];
  boxCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  linetradeprofileSet: Array<LineTradeProfileType>;
  shipmentPlan: ShipmentPlanType;
  tradeProfile: TradeProfileType;
  tradeYear?: Maybe<TradeYearType>;
  updatedAt: Scalars['DateTime'];
};

export type AreaWiseFilterInput = {
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AssignedRoutePointFilterInput = {
  assignementId?: InputMaybe<Scalars['ID']>;
  routeId?: InputMaybe<Scalars['ID']>;
};

export type AssignedRoutePointType = {
  __typename?: 'AssignedRoutePointType';
  assignment: RouteAssignmentType;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  id: Scalars['ID'];
  point?: Maybe<GeometryObjectType>;
  returnRequestApproved?: Maybe<Array<Maybe<OrderItemBatchType>>>;
  sequence: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
  visitByBeat?: Maybe<BeatVisitType>;
  visitee: DeliveryAgentManagementType;
};


export type AssignedRoutePointTypeVisitByBeatArgs = {
  beatId?: InputMaybe<Scalars['ID']>;
};

export type AssignedTripsFilterInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  skuStatus?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  tripCount?: InputMaybe<Scalars['Int']>;
  tripStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  varieties?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type BankDetailInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  bank?: InputMaybe<Scalars['Int']>;
  bankId?: InputMaybe<Scalars['Int']>;
  branchName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ifscCode?: InputMaybe<Scalars['String']>;
};

export type BankDetailType = {
  __typename?: 'BankDetailType';
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountSet: Array<AccountType>;
  attachments: Array<MediaEntityType>;
  bank: BankType;
  branchName: Scalars['String'];
  id: Scalars['ID'];
  ifscCode: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
  user?: Maybe<DeliveryAgentManagementType>;
};

export type BankType = {
  __typename?: 'BankType';
  bankdetailSet: Array<BankDetailType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** An enumeration. */
export enum BaseUserAddressAddressType {
  /** Home */
  HM = 'HM',
  /** Hotel */
  HT = 'HT',
  /** Other */
  OT = 'OT',
  /** Work */
  WK = 'WK'
}

export type BaseUserAddressType = {
  __typename?: 'BaseUserAddressType';
  address: AddressType;
  addressType: BaseUserAddressAddressType;
  id: Scalars['ID'];
  name: Scalars['String'];
  user: DeliveryAgentManagementType;
};

/** An enumeration. */
export enum BaseUserEducation {
  /** Bachelor(s) Degree */
  BH = 'BH',
  /** Master(s) Degree */
  MS = 'MS',
  /** No education */
  NO = 'NO',
  /** PHD */
  PH = 'PH',
  /** 10th Pass */
  TN = 'TN',
  /** 12th Pass */
  TW = 'TW'
}

export enum BaseUserEducationEnum {
  BACHELORS = 'BACHELORS',
  DOCTORATE = 'DOCTORATE',
  MASTERS = 'MASTERS',
  NO_EDUCATION = 'NO_EDUCATION',
  TENTH_PASS = 'TENTH_PASS',
  TWLTH_PASS = 'TWLTH_PASS'
}

/** An enumeration. */
export enum BaseUserGender {
  /** Female */
  FM = 'FM',
  /** Male */
  ML = 'ML'
}

export enum BaseUserGenderEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export type BaseUserInput = {
  customerId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<BaseUserMetadataInput>;
  number?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type BaseUserMetadata = {
  __typename?: 'BaseUserMetadata';
  acceptsTnc?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyAddress?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  employmentTypeCurrentCompany?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['Float']>;
  gstNumber?: Maybe<Scalars['String']>;
  icardIssuedDate?: Maybe<Scalars['String']>;
  instituteName?: Maybe<Scalars['String']>;
  interviewDate?: Maybe<Scalars['String']>;
  joiningDate?: Maybe<Scalars['String']>;
  laptopIssuedDate?: Maybe<Scalars['String']>;
  panNumber?: Maybe<Scalars['String']>;
  personalEmail?: Maybe<Scalars['String']>;
  previousOrganisation?: Maybe<Scalars['String']>;
  recentBeatVisit?: Maybe<Scalars['String']>;
  resignationDate?: Maybe<Scalars['String']>;
  resignationDateCurrentCompany?: Maybe<Scalars['String']>;
  secondaryNumber?: Maybe<Scalars['String']>;
  versionEcommerceApp?: Maybe<Scalars['String']>;
  versionFmsApp?: Maybe<Scalars['String']>;
  visitingCardIssuedDate?: Maybe<Scalars['String']>;
  yearOfPassing?: Maybe<Scalars['String']>;
};

export type BaseUserMetadataInput = {
  acceptsTnc?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  employmentTypeCurrentCompany?: InputMaybe<EmployementType>;
  experience?: InputMaybe<Scalars['Float']>;
  gstNumber?: InputMaybe<Scalars['String']>;
  icardIssuedDate?: InputMaybe<Scalars['String']>;
  instituteName?: InputMaybe<Scalars['String']>;
  interviewDate?: InputMaybe<Scalars['String']>;
  joiningDate?: InputMaybe<Scalars['String']>;
  laptopIssuedDate?: InputMaybe<Scalars['String']>;
  panNumber?: InputMaybe<Scalars['String']>;
  personalEmail?: InputMaybe<Scalars['String']>;
  previousOrganisation?: InputMaybe<Scalars['String']>;
  resignationDate?: InputMaybe<Scalars['String']>;
  resignationDateCurrentCompany?: InputMaybe<Scalars['String']>;
  secondaryNumber?: InputMaybe<Scalars['String']>;
  versionEcommerceApp?: InputMaybe<Scalars['String']>;
  versionFmsApp?: InputMaybe<Scalars['String']>;
  visitingCardIssuedDate?: InputMaybe<Scalars['String']>;
  yearOfPassing?: InputMaybe<Scalars['String']>;
};

export type BaseUserOtpType = {
  __typename?: 'BaseUserOtpType';
  created: Scalars['DateTime'];
  expiry: Scalars['DateTime'];
  id: Scalars['ID'];
  otp: Scalars['Int'];
  updated: Scalars['DateTime'];
  user: DeliveryAgentManagementType;
};

/** An enumeration. */
export enum BaseUserStatus {
  /** Available */
  AV = 'AV',
  /** Busy */
  BS = 'BS',
  /** Not Available */
  NA = 'NA',
  /** On Leave */
  OL = 'OL'
}

export type BaseUserSuperviseSummaryFilterInput = {
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  routeId?: InputMaybe<Scalars['ID']>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
};

export type BaseUserType = {
  __typename?: 'BaseUserType';
  accounts?: Maybe<Array<Maybe<CommonAccountType>>>;
  accountsCreated: Array<AccountType>;
  accountsUpdated: Array<AccountType>;
  address?: Maybe<AddressType>;
  allocatedDistributionCentre?: Maybe<CommonDistributionCentreType>;
  allocatedSurveyArea?: Maybe<CommonSurveyAreaType>;
  approvedItems: Array<OrderItemType>;
  approvedRequests: Array<StockTakeApprovalRequestType>;
  approvedtradeprofileSet: Array<ApprovedTradeProfileType>;
  areaIncharge: Array<PackagingMaterialType>;
  assignedBeats: Array<SupBeatType>;
  assignedPlots: Array<PlotCommodityType>;
  assignedRoutes: Array<RouteAssignmentType>;
  assignedroutepoints: Array<AssignedRoutePointType>;
  bankDetails: Array<BankDetailType>;
  beatVisited: Array<BeatVisitType>;
  beatVisits: Array<BeatVisitType>;
  beatplanSet: Array<BeatPlanType>;
  beats?: Maybe<Array<Maybe<GeneralBeatType>>>;
  blockRemark?: Maybe<Scalars['String']>;
  certifications: Array<FarmerCertificationType>;
  collections: Array<CollectionLogType>;
  companies: Array<CompanyType>;
  companyCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creditSet?: Maybe<Array<Maybe<CreditType>>>;
  currentDepartment?: Maybe<DepartmentType>;
  customerId: Scalars['String'];
  dateJoined: Scalars['DateTime'];
  /** Users Date of Birth */
  dateOfBirth?: Maybe<Scalars['Date']>;
  dcstoragelocationSet: Array<DcStorageLocationType>;
  deliveredOrderValue?: Maybe<Scalars['Float']>;
  demandSet: Array<DemandType>;
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  departments: Array<DepartmentType>;
  distributioncentreSet: Array<DistributionCentreType>;
  dockdetailSet: Array<DockDetailType>;
  documents?: Maybe<Array<Maybe<GeneralCertificationType>>>;
  drivenVehicles: Array<VehicleType>;
  education?: Maybe<BaseUserEducation>;
  email: Scalars['String'];
  familyGroup?: Maybe<FamilyGroupType>;
  familyGroupHierarchy?: Maybe<FamilyGroupHierarchyType>;
  familygroupSet: Array<FamilyGroupType>;
  farmer: Array<PackagingMaterialType>;
  fieldSupervisor: Array<PackagingMaterialType>;
  firebaseToken: Scalars['String'];
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  gateInInwards: Array<TripType>;
  gateOutInwards: Array<TripType>;
  gatelogsSet: Array<GateLogType>;
  gender?: Maybe<BaseUserGender>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: Array<GroupType>;
  harvestingTeam: Array<PackagingMaterialType>;
  id: Scalars['ID'];
  insuranceDetails: Array<InsuranceDetailType>;
  inwardStatusLogs: Array<InwardStatusLogType>;
  inwards: Array<InwardType>;
  inwardsAmcBourn: Array<InwardType>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  isBlocked?: Maybe<Scalars['Boolean']>;
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  /** Select type to maintain access level */
  isSuperadmin: Scalars['Boolean'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  kiteReferenceId?: Maybe<Scalars['String']>;
  kycDetails: Array<KycDetailType>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  lastVisitDate?: Maybe<Scalars['DateTime']>;
  licenceDetails: Array<LicenceDetailType>;
  managedCompanies: Array<CompanyType>;
  metadata?: Maybe<BaseUserMetadata>;
  myBeatPlans: Array<BeatPlanType>;
  myOrders: Array<AnnotatedOrderType>;
  mySales: Array<AnnotatedOrderType>;
  myTransactions: Array<OrderTransactionType>;
  nameAsPerPan?: Maybe<Scalars['String']>;
  notificationSet: Array<NotificationType>;
  notificationlogSet: Array<NotificationLogType>;
  notificationsSent: Array<NotificationType>;
  notificationsTriggered: Array<NotificationTriggerType>;
  notificationtriggerSet: Array<NotificationTriggerType>;
  /** Primary phone number user for contact purposes */
  number: Scalars['String'];
  orderValueFluctuation?: Maybe<Scalars['Float']>;
  otp?: Maybe<BaseUserOtpType>;
  outstandingAmount?: Maybe<Scalars['Float']>;
  ownedVehicles: Array<VehicleType>;
  packingallotmentSet: Array<PackingAllotmentSelectorType>;
  password: Scalars['String'];
  paymentSet: Array<PaymentType>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Photo of the user. */
  photo?: Maybe<Scalars['String']>;
  placedOrders: Array<AnnotatedOrderType>;
  plotVisitor: Array<PackagingMaterialType>;
  plots: Array<PlotType>;
  pmSupervisor: Array<PackagingMaterialType>;
  previousTotalOrderValue?: Maybe<Scalars['Float']>;
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  primaryAccount?: Maybe<AccountType>;
  primaryDcs: Array<DistributionCentreType>;
  productionProductionCreated: Array<ProductionType>;
  productionProductionUpdated: Array<ProductionType>;
  productionProductionitemCreated: Array<ProductionItemType>;
  productionProductionitemUpdated: Array<ProductionItemType>;
  productionitemSet: Array<ProductionItemType>;
  recordedTransactions: Array<OrderTransactionType>;
  referenceId: Scalars['String'];
  rejectionPercentage?: Maybe<Scalars['Float']>;
  reportexportlogSet: Array<ReportExportLogType>;
  reportsCreated: Array<ReportTemplateType>;
  reporttemplateSet: Array<ReportTemplateType>;
  requested: Array<StockTakeApprovalRequestType>;
  requestedItems: Array<OrderItemType>;
  requests: Array<StockTakeApprovalRequestType>;
  requestsApproved: Array<ScheduleRequestType>;
  returnablePackagingGoods?: Maybe<Scalars['Int']>;
  routepoints: Array<RoutePointType>;
  savedAddress: Array<BaseUserAddressType>;
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  schedulesAmcBourn: Array<ScheduleType>;
  schedulesCompleted: Array<ScheduleType>;
  schedulesForDate?: Maybe<Array<Maybe<ScheduleType>>>;
  secondaryNumbers: Array<ContactType>;
  sellableitemreviewSet: Array<SellableItemReviewType>;
  seller?: Maybe<SellerType>;
  shopSet: Array<ShopType>;
  shopsManaged: Array<ShopType>;
  status: BaseUserStatus;
  statusObj?: Maybe<ClientStatusType>;
  stockentryitemSet: Array<StockEntryItemType>;
  stocktransactionSet: Array<StockTransactionType>;
  summary?: Maybe<SuperviseSummaryType>;
  superviseAssignedroutepointCreated: Array<AssignedRoutePointType>;
  superviseAssignedroutepointUpdated: Array<AssignedRoutePointType>;
  superviseBeatvisitCreated: Array<BeatVisitType>;
  superviseBeatvisitUpdated: Array<BeatVisitType>;
  superviseBeatvisitactionCreated: Array<BeatVisitActionType>;
  superviseBeatvisitactionUpdated: Array<BeatVisitActionType>;
  superviseRouteCreated: Array<RouteType>;
  superviseRouteUpdated: Array<RouteType>;
  superviseRouteassignmentCreated: Array<RouteAssignmentType>;
  superviseRouteassignmentUpdated: Array<RouteAssignmentType>;
  superviseRoutepointCreated: Array<RoutePointType>;
  superviseRoutepointUpdated: Array<RoutePointType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  surveyableAreas: Array<SurveyAreaLocationType>;
  surveyareaSet: Array<SurveyAreaLocationType>;
  totalBeatCount?: Maybe<Scalars['Int']>;
  totalOrderCount?: Maybe<Scalars['Int']>;
  totalOrderValue?: Maybe<Scalars['Float']>;
  /** User who recorded the transaction */
  transactionSet: Array<TransactionGraphType>;
  transportProvider: Array<ScheduleType>;
  tripSet: Array<TripType>;
  tripsSupervised: Array<TripType>;
  unsettledPayment?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  userCredits: Array<CreditType>;
  /** Specific permissions for this user. */
  userPermissions: Array<PermissionType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  visitBeatCount?: Maybe<Scalars['Int']>;
  visitCount?: Maybe<Scalars['Int']>;
  vtEcommerceCreditCreated: Array<CreditType>;
  vtEcommerceCreditUpdated: Array<CreditType>;
  vtFuelManagementFueldistributorCreated: Array<FuelDistributorType>;
  vtFuelManagementFueldistributorUpdated: Array<FuelDistributorType>;
  vtFuelManagementFueldistributoritemCreated: Array<FuelDistributorItemType>;
  vtFuelManagementFueldistributoritemUpdated: Array<FuelDistributorItemType>;
};


export type BaseUserTypeAccountsArgs = {
  accountType_Codename?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BaseUserTypeBeatsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
};


export type BaseUserTypeCreditSetArgs = {
  status?: InputMaybe<Scalars['String']>;
};


export type BaseUserTypeSchedulesForDateArgs = {
  date: Scalars['Date'];
};


export type BaseUserTypeSummaryArgs = {
  filters?: InputMaybe<BaseUserSuperviseSummaryFilterInput>;
};


export type BaseUserTypeTotalBeatCountArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type BaseUserTypeVisitBeatCountArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type BatchStockBySellableItem = {
  __typename?: 'BatchStockBySellableItem';
  sellableItem?: Maybe<SellableItemType>;
  suppliedBy?: Maybe<DistributionCentreType>;
  totalConsumedQuantity?: Maybe<Scalars['Int']>;
  totalQuantity?: Maybe<Scalars['Int']>;
};

export type BatchStockBySellableItemFilterInput = {
  addedOn?: InputMaybe<Scalars['Date']>;
  availableQuantity_Gt?: InputMaybe<Scalars['Int']>;
  batchStockIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  quantity_Gt?: InputMaybe<Scalars['Int']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  suppliedById?: InputMaybe<Scalars['ID']>;
};

export type BatchStockFilterInput = {
  currentStockCount_Gt?: InputMaybe<Scalars['Int']>;
  expiryOn_Gt?: InputMaybe<Scalars['Date']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  suppliedById?: InputMaybe<Scalars['ID']>;
};

export type BatchStockInput = {
  alternateStockCount?: InputMaybe<Scalars['Int']>;
  coaCertificate?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  currentStockCount?: InputMaybe<Scalars['Int']>;
  dumpedStockCount?: InputMaybe<Scalars['Int']>;
  expiryOn?: InputMaybe<Scalars['Date']>;
  holdStockCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  intransitStockCount?: InputMaybe<Scalars['Int']>;
  manufacturedById?: InputMaybe<Scalars['ID']>;
  manufacturedOn?: InputMaybe<Scalars['Date']>;
  parentBatchStockId?: InputMaybe<Scalars['ID']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  skuId?: InputMaybe<Scalars['ID']>;
  suppliedById: Scalars['ID'];
  totalQuantity?: InputMaybe<Scalars['Int']>;
};

export type BatchStockRateType = {
  __typename?: 'BatchStockRateType';
  addedOn: Scalars['Date'];
  availableQuantity?: Maybe<Scalars['Int']>;
  batchStock: BatchStockType;
  category: Scalars['String'];
  consumedQuantity: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  holdQuantity: Scalars['Int'];
  id: Scalars['ID'];
  orderItems: Array<OrderItemBatchType>;
  quantity: Scalars['Int'];
  quantityInApproval: Scalars['Int'];
  rate: Scalars['Float'];
  referenceItemStock?: Maybe<SellableItemStockType>;
  remainingQuantity?: Maybe<Scalars['Int']>;
  soldOn?: Maybe<Scalars['Date']>;
  stockTakeCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type BatchStockRateTypeStockTakeCountArgs = {
  addedOn?: InputMaybe<Scalars['Date']>;
};

export type BatchStockType = {
  __typename?: 'BatchStockType';
  alternateStockCount: Scalars['Int'];
  availableQuantity?: Maybe<Scalars['Int']>;
  batchstockSet: Array<BatchStockType>;
  childBatchStocks?: Maybe<Array<Maybe<BatchStockType>>>;
  coaCertificate?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currentStockCount: Scalars['Int'];
  dumpedStockCount: Scalars['Int'];
  expiryOn?: Maybe<Scalars['Date']>;
  holdStockCount: Scalars['Int'];
  id: Scalars['ID'];
  intransitStockCount: Scalars['Int'];
  items: Array<OrderItemBatchType>;
  manufacturedBy?: Maybe<DistributionCentreType>;
  manufacturedOn?: Maybe<Scalars['Date']>;
  parentBatchStock?: Maybe<BatchStockType>;
  rates: Array<BatchStockRateType>;
  sellableItem: SellableItemType;
  sku?: Maybe<SkuGraphType>;
  stockEntryItems?: Maybe<Array<Maybe<StockEntryItemType>>>;
  suppliedBy?: Maybe<DistributionCentreType>;
  totalQuantity: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type BatchStockTypeStockEntryItemsArgs = {
  addedOn?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
};

export type BatchStockWiseVisibility = {
  __typename?: 'BatchStockWiseVisibility';
  batchStock?: Maybe<BatchStockType>;
  closing?: Maybe<Scalars['Float']>;
  delivered?: Maybe<Scalars['Float']>;
  directSale?: Maybe<Scalars['Float']>;
  disposal?: Maybe<Scalars['Float']>;
  inTransit?: Maybe<Scalars['Float']>;
  inwarded?: Maybe<Scalars['Float']>;
  opening?: Maybe<Scalars['Float']>;
  returned?: Maybe<Scalars['Float']>;
};

export type BatchStockWiseVisibilityDispatchDateWise = {
  __typename?: 'BatchStockWiseVisibilityDispatchDateWise';
  batchCodename?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['Date']>;
  dispatchDate?: Maybe<Scalars['Date']>;
  dispatchQuantity?: Maybe<Scalars['Int']>;
  disposalQuantity?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  saleQuantity?: Maybe<Scalars['Int']>;
  sellableItem_Name?: Maybe<Scalars['String']>;
  systemStock?: Maybe<Scalars['Int']>;
};

export type BatchStockWiseVisibilityFilterInput = {
  excludeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sellableItemId: Scalars['ID'];
  suppliedById: Scalars['ID'];
};

export type BeatPlanFilterInput = {
  date?: InputMaybe<Scalars['Date']>;
  plannedBy?: InputMaybe<Scalars['ID']>;
  plannedIn?: InputMaybe<Scalars['ID']>;
  salesman?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum BeatPlanStatus {
  /** Completed */
  CP = 'CP',
  /** Discarded */
  DS = 'DS',
  /** Idle */
  IL = 'IL',
  /** Not Started */
  NS = 'NS',
  /** On Beat */
  OB = 'OB',
  /** Settled */
  ST = 'ST'
}

export type BeatPlanType = {
  __typename?: 'BeatPlanType';
  attachments: Array<MediaEntityType>;
  beats?: Maybe<Array<Maybe<BeatType>>>;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  plannedBy: DeliveryAgentManagementType;
  plannedEndTime?: Maybe<Scalars['DateTime']>;
  plannedIn: DepartmentType;
  plannedStartTime?: Maybe<Scalars['DateTime']>;
  remark?: Maybe<Scalars['String']>;
  salesman: DeliveryAgentManagementType;
  startTime?: Maybe<Scalars['DateTime']>;
  status: BeatPlanStatus;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};


export type BeatPlanTypeBeatsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum BeatStatus {
  /** Archived */
  ARC = 'ARC',
  /** Completed */
  CMP = 'CMP',
  /** Cancelled */
  CNL = 'CNL',
  /** Scheduled */
  SCH = 'SCH'
}

export type BeatType = {
  __typename?: 'BeatType';
  attachments: Array<MediaEntityType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  objectId: Scalars['Int'];
  otp: Scalars['Int'];
  plan: BeatPlanType;
  relatedTo?: Maybe<BaseUserType>;
  remark?: Maybe<Scalars['String']>;
  status: BeatStatus;
  updatedAt: Scalars['DateTime'];
  visitCategory: BeatVisitCategory;
  /** Beat Completed Location */
  visitedAt?: Maybe<AddressType>;
  visitedOn?: Maybe<Scalars['DateTime']>;
};

export type BeatVisitActionInput = {
  action?: InputMaybe<Scalars['String']>;
  actionDetails?: InputMaybe<Scalars['JSONScalar']>;
  id?: InputMaybe<Scalars['ID']>;
  isProductive?: InputMaybe<Scalars['Boolean']>;
};

export type BeatVisitActionType = {
  __typename?: 'BeatVisitActionType';
  /** Action taken by the visitee */
  action: Scalars['String'];
  actionDetails: Scalars['JSONString'];
  beatVisit: BeatVisitType;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  id: Scalars['ID'];
  isProductive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};

/** An enumeration. */
export enum BeatVisitCategory {
  /** Feedback */
  FDB = 'FDB',
  /** Other */
  OT = 'OT',
  /** Resale */
  RSL = 'RSL',
  /** Visit */
  VST = 'VST'
}

export type BeatVisitFilterInput = {
  beatId?: InputMaybe<Scalars['ID']>;
  dateGte?: InputMaybe<Scalars['Date']>;
  dateLte?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  isProductive?: InputMaybe<Scalars['Boolean']>;
  routeId?: InputMaybe<Scalars['ID']>;
  visiteeId?: InputMaybe<Scalars['ID']>;
  visitorId?: InputMaybe<Scalars['ID']>;
};

export type BeatVisitType = {
  __typename?: 'BeatVisitType';
  actions: Array<BeatVisitActionType>;
  attachments: Array<MediaEntityType>;
  beat: SupBeatType;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  duration?: Maybe<DurationType>;
  durationSec?: Maybe<Scalars['Float']>;
  /** Visit completion time */
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isProductive: Scalars['Boolean'];
  leftAt?: Maybe<AddressType>;
  paymentCollected: Scalars['Float'];
  pickupOrderCount: Scalars['Int'];
  placedOrderAmount: Scalars['Float'];
  placedOrderCount: Scalars['Int'];
  remark?: Maybe<Scalars['String']>;
  returnRequestCount: Scalars['Int'];
  routeDetails: Scalars['JSONString'];
  routeName?: Maybe<Scalars['String']>;
  routePointDetails: Scalars['JSONString'];
  /** Visit start time */
  startTime?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
  visitedAt?: Maybe<AddressType>;
  visitee: DeliveryAgentManagementType;
  visitor: DeliveryAgentManagementType;
};

export type BillingDocType = {
  __typename?: 'BillingDocType';
  billingDocNumber: Scalars['String'];
  erpRefCode: Scalars['String'];
  id: Scalars['ID'];
  invoice?: Maybe<MediaEntityType>;
  metadata: Scalars['JSONString'];
  order: AnnotatedOrderType;
  trip?: Maybe<TripType>;
};

export type BookInput = {
  bookingId?: InputMaybe<Scalars['Int']>;
  despatchPhotoLink?: InputMaybe<MediaInput>;
  despatchedQuantity?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
};

export type BookingExtraSkuType = {
  __typename?: 'BookingExtraSKUType';
  booking: BookingType;
  id: Scalars['ID'];
  isFilled: Scalars['Boolean'];
  loadedQuantity: Scalars['Int'];
  remark?: Maybe<Scalars['String']>;
  settledQuantity: Scalars['Int'];
  sku: SkuGraphType;
  unloadedQuantity: Scalars['Int'];
};

export type BookingExtraSkuInput = {
  id?: InputMaybe<Scalars['ID']>;
  loadedQuantity?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  settledQuantity?: InputMaybe<Scalars['Int']>;
  skuId?: InputMaybe<Scalars['ID']>;
  unloadedQuantity?: InputMaybe<Scalars['Int']>;
};

export type BookingGradePriceInput = {
  grade?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  priceLimit?: InputMaybe<Scalars['Float']>;
  priceUnit?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BookingStatus {
  /** Booked */
  BKD = 'BKD',
  /** Confirmed by Aggregator */
  CFA = 'CFA',
  /** Confirmed by Supplier */
  CFF = 'CFF',
  /** Completed */
  CMP = 'CMP',
  /** Cancelled */
  CNL = 'CNL',
  /** Inwarding */
  INW = 'INW',
  /** Picked up */
  PKD = 'PKD'
}

export type BookingType = {
  __typename?: 'BookingType';
  approvalStatus?: Maybe<Scalars['String']>;
  bookingextraskuSet: Array<BookingExtraSkuType>;
  collectedSkus: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customerVisibility: Scalars['Boolean'];
  date: Scalars['Date'];
  despatchPhoto?: Maybe<MediaEntityType>;
  despatchRemark?: Maybe<Scalars['String']>;
  despatchedQuantity?: Maybe<Scalars['Int']>;
  driverDespatchPhoto?: Maybe<MediaEntityType>;
  driverDespatchRemark?: Maybe<Scalars['String']>;
  driverLoadingApproval?: Maybe<Scalars['Boolean']>;
  driverUnloadingApproval?: Maybe<Scalars['Boolean']>;
  driverVerification?: Maybe<Scalars['Boolean']>;
  extraSkuLoadedCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  inwards: Array<InwardType>;
  leftSkus: Scalars['Int'];
  loadedSkus: Scalars['Int'];
  loadingSequence: Scalars['Int'];
  order?: Maybe<AnnotatedOrderType>;
  orderItem?: Maybe<OrderItemType>;
  otp: Scalars['Int'];
  pickupAddress?: Maybe<AddressType>;
  pickupTime?: Maybe<Scalars['DateTime']>;
  potentialQuantity?: Maybe<Scalars['Int']>;
  procuredQuantity: Scalars['Int'];
  qcRequestCreatedById?: Maybe<Scalars['String']>;
  qualityChecks?: Maybe<Array<Maybe<QualityParameterType>>>;
  qualitySample?: Maybe<QualitySampleType>;
  requiredQuantity: Scalars['Int'];
  schedule: ScheduleType;
  sequenceNumber: Scalars['Int'];
  settledQuantity?: Maybe<Scalars['Int']>;
  settledSkus: Scalars['Int'];
  settlementRemark?: Maybe<Scalars['String']>;
  status: BookingStatus;
  statusObj?: Maybe<ClientStatusType>;
  timeSlot?: Maybe<TimeSlotRequirementType>;
  trip?: Maybe<TripType>;
  tripsteplogSet: Array<TripStepLogType>;
  unsettledSkus?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type BookingsByTripFilterInput = {
  bookingId?: InputMaybe<Scalars['ID']>;
  destinationDcId?: InputMaybe<Scalars['ID']>;
  orderItemId?: InputMaybe<Scalars['ID']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  sourceDcId?: InputMaybe<Scalars['ID']>;
  tripId?: InputMaybe<Scalars['ID']>;
};

export type BookingsFilterInput = {
  aggregatorId: Scalars['ID'];
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  secondarySkuTypeId?: InputMaybe<Scalars['ID']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  /**  'settled' | 'unsettled' */
  status?: InputMaybe<Scalars['String']>;
};

export type BulkAddGateLogsInput = {
  gateNumberId?: InputMaybe<Scalars['ID']>;
  gateStatus: Scalars['String'];
  scheduleId: Scalars['ID'];
};

export type BulkAddGateLogsMutation = {
  __typename?: 'BulkAddGateLogsMutation';
  createdLogs?: Maybe<Array<Maybe<GateLogType>>>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkAddVehicleDepartmentMutation = {
  __typename?: 'BulkAddVehicleDepartmentMutation';
  vehicles?: Maybe<Array<Maybe<VehicleType>>>;
};

export type BulkApproveItemInput = {
  shipmentPlanId: Scalars['ID'];
  tradeProfileId: Scalars['ID'];
};

export type BulkApproveTradeProfilesInput = {
  emptyShipmentPlanId?: InputMaybe<Scalars['ID']>;
  items: Array<InputMaybe<BulkApproveItemInput>>;
};

export type BulkApproveTradeProfilesPayload = {
  __typename?: 'BulkApproveTradeProfilesPayload';
  created?: Maybe<Array<Maybe<ApprovedTradeProfileType>>>;
  error?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** Deprecated! */
export type BulkAssignmentMutation = {
  __typename?: 'BulkAssignmentMutation';
  trips?: Maybe<Array<Maybe<TripType>>>;
};

export type BulkOrderItemApproval = {
  __typename?: 'BulkOrderItemApproval';
  orderItems?: Maybe<Array<Maybe<OrderItemType>>>;
};

export type BulkPaymentSettleMutation = {
  __typename?: 'BulkPaymentSettleMutation';
  orderTransaction?: Maybe<Array<Maybe<OrderTransactionType>>>;
};

export type BulkSkuSettleMutation = {
  __typename?: 'BulkSkuSettleMutation';
  bookings?: Maybe<Array<Maybe<BookingType>>>;
};

export type BulkStockSettleMutation = {
  __typename?: 'BulkStockSettleMutation';
  bookings?: Maybe<Array<Maybe<BookingType>>>;
};

/** Used for creating approval requests based on stock entry items. */
export type BulkStockTakeApprovalMutation = {
  __typename?: 'BulkStockTakeApprovalMutation';
  approvalRequests?: Maybe<Array<Maybe<StockTakeApprovalRequestType>>>;
};

export type BulkTripSettleMutation = {
  __typename?: 'BulkTripSettleMutation';
  trips?: Maybe<Array<Maybe<TripType>>>;
};

export type BulkUpdateDepartmentMetadataMutation = {
  __typename?: 'BulkUpdateDepartmentMetadataMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkUpdateDriverApprovalMutation = {
  __typename?: 'BulkUpdateDriverApprovalMutation';
  booking?: Maybe<Array<Maybe<BookingType>>>;
};

export type BulkUpdateOrderMutation = {
  __typename?: 'BulkUpdateOrderMutation';
  order?: Maybe<Array<Maybe<OrderType>>>;
};

export type BulkUpdatePlotCommodityMutation = {
  __typename?: 'BulkUpdatePlotCommodityMutation';
  plotCommodities?: Maybe<Array<Maybe<PlotCommodityType>>>;
};

export type BulkUpdateShopMutation = {
  __typename?: 'BulkUpdateShopMutation';
  shops?: Maybe<Array<Maybe<ShopType>>>;
};

export type BulkUpdateUserRefByIdInput = {
  customerId: Scalars['String'];
  id: Scalars['Int'];
  referenceId: Scalars['String'];
};

export type BulkUpdateUserRefByIdMutation = {
  __typename?: 'BulkUpdateUserRefByIdMutation';
  users?: Maybe<Array<Maybe<BaseUserType>>>;
};

export type BulkUpdateUsersMutation = {
  __typename?: 'BulkUpdateUsersMutation';
  users?: Maybe<Array<Maybe<BaseUserType>>>;
};

export type BulkUpdateVehicleStatusMutation = {
  __typename?: 'BulkUpdateVehicleStatusMutation';
  vehicles?: Maybe<Array<Maybe<VehicleType>>>;
};

export type BulkUpdateVehicleUsersMutation = {
  __typename?: 'BulkUpdateVehicleUsersMutation';
  users?: Maybe<Array<Maybe<BaseUserType>>>;
};

export type BusinessCategoryFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type BusinessCategoryType = {
  __typename?: 'BusinessCategoryType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  familygroupSet: Array<FamilyGroupType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CashHandoverMutation = {
  __typename?: 'CashHandoverMutation';
  transactions?: Maybe<Array<Maybe<TransactionGraphType>>>;
};

export type CertificationGraphType = {
  __typename?: 'CertificationGraphType';
  certificationSet: Array<GeneralCertificationType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  commodityvarietySet: Array<CommodityVarietyType>;
  farmercertificationSet: Array<FarmerCertificationType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plotcertificationSet: Array<PlotCertificationType>;
  plotcommoditycertificationSet: Array<PlotCommodityCertificationType>;
};

export type CertificationInput = {
  certificationNumber?: InputMaybe<Scalars['String']>;
  certificationType?: InputMaybe<Scalars['Int']>;
};

export type ChangePasswordMutation = {
  __typename?: 'ChangePasswordMutation';
  user?: Maybe<BaseUserType>;
};

export type ClientStatusType = {
  __typename?: 'ClientStatusType';
  id?: Maybe<Scalars['Int']>;
  intent?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CollectionInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  distributionCentreId: Scalars['ID'];
  logsFilter?: InputMaybe<LogsFilter>;
};

export type CollectionLogType = {
  __typename?: 'CollectionLogType';
  cashCollection: Scalars['Float'];
  cashHandover: Scalars['Float'];
  chequeCollection: Scalars['Float'];
  chequeHandover: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  distributionCentre: DistributionCentreType;
  id: Scalars['ID'];
  orderTransactions: Array<OrderTransactionType>;
  orders: Array<AnnotatedOrderType>;
  outstanding: Scalars['Float'];
  recordedBy: DeliveryAgentManagementType;
  updatedAt: Scalars['DateTime'];
};

export type CollectionTotalType = {
  __typename?: 'CollectionTotalType';
  handedOver?: Maybe<Scalars['Float']>;
  pending?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type CollectionType = {
  __typename?: 'CollectionType';
  cashCollectionSum?: Maybe<Scalars['Float']>;
  cashHandoverSum?: Maybe<Scalars['Float']>;
  chequeCollectionSum?: Maybe<Scalars['Float']>;
  chequeHandoverSum?: Maybe<Scalars['Float']>;
  outstandingSum?: Maybe<Scalars['Float']>;
  user?: Maybe<BaseUserType>;
};

export type ColorGroupType = {
  __typename?: 'ColorGroupType';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  shipmentplanSet: Array<ShipmentPlanType>;
};

/** An enumeration. */
export enum CommodityGroupPricingDoneOn {
  /** SKU Type */
  SKU = 'SKU',
  /** UOM Type */
  UOM = 'UOM'
}

export type CommodityGroupType = {
  __typename?: 'CommodityGroupType';
  benchmarkFrequencyCount: Scalars['Int'];
  benchmarkFrequencyDays: Scalars['Int'];
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  demandSet: Array<DemandType>;
  id: Scalars['ID'];
  isBenchmarkMandatory: Scalars['Boolean'];
  isFinishedGood: Scalars['Boolean'];
  isKeyValueProduct: Scalars['Boolean'];
  isRawMaterial: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  plotcommoditySet: Array<PlotCommodityType>;
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  pricingDoneOn: CommodityGroupPricingDoneOn;
  pricingFormula?: Maybe<Scalars['String']>;
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  secondaryVarieties: Array<CommodityVarietyType>;
  skuType?: Maybe<SkuGraphType>;
  uomType?: Maybe<SiUnitType>;
  varieties: Array<CommodityVarietyType>;
};

export type CommodityType = {
  __typename?: 'CommodityType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  shopSet: Array<ShopType>;
  varieties: Array<CommodityVarietyType>;
};

export type CommodityVarietyType = {
  __typename?: 'CommodityVarietyType';
  commodity: CommodityType;
  commodityvarietySet: Array<CommodityVarietyType>;
  createdAt: Scalars['DateTime'];
  defaultTraderDepartments: Array<DepartmentType>;
  demandSet: Array<DemandType>;
  departmentSet: Array<DepartmentType>;
  estimatedProduce: Scalars['Float'];
  groups: Array<CommodityGroupType>;
  harvestGrades: Array<HarvestGradeType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  marketyardSet: Array<MarketYardType>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  packagingMaterialFlow: Scalars['Boolean'];
  parentVariety?: Maybe<CommodityVarietyType>;
  plotcommoditySet: Array<PlotCommodityType>;
  preferredCertification?: Maybe<CertificationGraphType>;
  preferredSku?: Maybe<SkuGraphType>;
  primaryGroup?: Maybe<CommodityGroupType>;
  productionbatchSet: Array<ProductionBatchType>;
  qualityParameters: Array<QualityParameterType>;
  referenceId: Scalars['String'];
  regionpercentdetailSet: Array<RegionPercentDetailType>;
  scheduleSet: Array<ScheduleType>;
  sellablevarietySet: Array<SellableVarietyType>;
  shipmentplanSet: Array<ShipmentPlanType>;
  standardDeduction: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type CommonAccountCategoryType = {
  __typename?: 'CommonAccountCategoryType';
  accountSet: Array<AccountType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CommonAccountType = {
  __typename?: 'CommonAccountType';
  accountType: CommonAccountCategoryType;
  /** Final Outstanding Amount */
  balance: Scalars['Float'];
  bankDetail?: Maybe<BankDetailType>;
  baseuserSet: Array<DeliveryAgentManagementType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  distributioncentreSet: Array<DistributionCentreType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
  /** Account in which the transaction took place */
  transactionSet: Array<TransactionGraphType>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};

export type CommonDistributionCentreType = {
  __typename?: 'CommonDistributionCentreType';
  address: AddressType;
  allowedDepartments: Array<DepartmentType>;
  alternateSalesSlots: Array<TimeSlotType>;
  archive: Scalars['Boolean'];
  areaCateredFlipped?: Maybe<GeometryObjectType>;
  assignedCpc?: Maybe<DistributionCentreType>;
  codename: Scalars['String'];
  colorCode: Scalars['String'];
  consolidatedOrders: Array<AnnotatedOrderType>;
  createdAt: Scalars['DateTime'];
  currentStockPercentage?: Maybe<Scalars['Float']>;
  dcStocks: Array<SellableItemStockType>;
  dcstocktakeconfigSet: Array<DcStockTakeConfigType>;
  deliveryConditions: Scalars['JSONString'];
  deliverySlots: Array<TimeSlotType>;
  deliveryTaxes: Array<TaxType>;
  depot?: Maybe<DepotType>;
  distributioncentreSet: Array<DistributionCentreType>;
  docks: Array<DockType>;
  geometry?: Maybe<GeometryObjectType>;
  groupVisibility: Array<GroupType>;
  id: Scalars['ID'];
  maintenanceSlots: Array<TimeSlotType>;
  manufacturedStocks: Array<BatchStockType>;
  myLogs: Array<DcCollectionLogType>;
  name: Scalars['String'];
  photos: Array<MediaEntityType>;
  pickupSlots: Array<TimeSlotType>;
  placedOrders: Array<AnnotatedOrderType>;
  pointOfContacts: Array<DeliveryAgentManagementType>;
  primaryAccount?: Maybe<AccountType>;
  primaryPoc?: Maybe<DeliveryAgentManagementType>;
  shipments: Array<ShippingType>;
  storageLocations: Array<DcStorageLocationType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  suppliedStocks: Array<BatchStockType>;
  surveyareaSet: Array<SurveyAreaLocationType>;
  transactionLogs: Array<CollectionLogType>;
  updateFromAreaCateredFlipped: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  useCreditFeature: Scalars['Boolean'];
};

export type CommonSurveyAreaType = {
  __typename?: 'CommonSurveyAreaType';
  areaCateredFlipped?: Maybe<GeometryObjectType>;
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  distributionCentre?: Maybe<DistributionCentreType>;
  geometry: GeometryObjectType;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  primaryUser?: Maybe<DeliveryAgentManagementType>;
  routes: Array<RouteType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  updateFromAreaCateredFlipped: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  users: Array<DeliveryAgentManagementType>;
};

/** An enumeration. */
export enum CompanyKind {
  /** Main */
  MAIN = 'MAIN',
  /** Zone */
  ZONE = 'ZONE'
}

export type CompanyType = {
  __typename?: 'CompanyType';
  assignedToUser: Array<DeliveryAgentManagementType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  demandSet: Array<DemandType>;
  departments: Array<DepartmentType>;
  displayName: Scalars['String'];
  harvestprojectionSet: Array<HarvestProjectionType>;
  id: Scalars['ID'];
  kind: CompanyKind;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  plotSet: Array<PlotType>;
  primaryPoc?: Maybe<DeliveryAgentManagementType>;
  raisedDemands: Array<DemandType>;
  scheduleSet: Array<ScheduleType>;
  shopSet: Array<ShopType>;
};

export type ConsolidatedOrderItem = {
  __typename?: 'ConsolidatedOrderItem';
  orderingItemStock?: Maybe<SellableItemStockType>;
  sellableItem?: Maybe<SellableItemType>;
  sellableItemStock?: Maybe<SellableItemStockType>;
  sourceDcRate?: Maybe<Scalars['Float']>;
  stockCount?: Maybe<Scalars['Int']>;
  totalQuantity?: Maybe<Scalars['Int']>;
};

export type ContactType = {
  __typename?: 'ContactType';
  id: Scalars['ID'];
  number: Scalars['String'];
  user: DeliveryAgentManagementType;
};

export type ContractGraphType = {
  __typename?: 'ContractGraphType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  contractSet: Array<ContractType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ContractRecurringExpenseInput = {
  cost: Scalars['Float'];
  id?: InputMaybe<Scalars['ID']>;
  shiftId: Scalars['ID'];
  unitCount: Scalars['Int'];
};

export type ContractRecurringExpenseType = {
  __typename?: 'ContractRecurringExpenseType';
  contract: ContractType;
  cost: Scalars['Float'];
  id: Scalars['ID'];
  shift: TimeSlotType;
  unitCount: Scalars['Int'];
};

/** An enumeration. */
export enum ContractStatus {
  /** Active */
  AC = 'AC',
  /** Completed */
  CM = 'CM',
  /** Expired */
  EX = 'EX',
  /** In-Active */
  IA = 'IA'
}

export type ContractType = {
  __typename?: 'ContractType';
  attachments: Array<MediaEntityType>;
  contractCode?: Maybe<Scalars['String']>;
  contractType: ContractGraphType;
  contractrecurringexpenseSet: Array<ContractRecurringExpenseType>;
  createdAt: Scalars['DateTime'];
  dailyAllowance: Scalars['Float'];
  endDate: Scalars['Date'];
  expenseSet: Array<ExpenseType>;
  id: Scalars['ID'];
  number: Scalars['String'];
  objectId: Scalars['Int'];
  paymentSet: Array<PaymentType>;
  resourceAmount: Scalars['Int'];
  startDate: Scalars['Date'];
  status: ContractStatus;
  totalExpense: Scalars['Float'];
  totalOutstanding?: Maybe<Scalars['Float']>;
  totalPaid: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

/** Cash deposition mutation */
export type CreateBulkTransactionMutation = {
  __typename?: 'CreateBulkTransactionMutation';
  transactions?: Maybe<Array<Maybe<TransactionGraphType>>>;
};

export type CreateFuelDistributor = {
  __typename?: 'CreateFuelDistributor';
  fuelDistributor?: Maybe<FuelDistributorType>;
};

export type CreateFuelDistributorItem = {
  __typename?: 'CreateFuelDistributorItem';
  fuelDistributorItem?: Maybe<FuelDistributorItemType>;
};

export type CreateReturnRequestInput = {
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  /** Pass in case of updation while creating/updating return request */
  orderItemBatchId?: InputMaybe<Scalars['ID']>;
  parentOrderItemBatchId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  returnReason?: InputMaybe<Scalars['String']>;
  returnType?: InputMaybe<Scalars['String']>;
};

export type CreateReturnRequestMutation = {
  __typename?: 'CreateReturnRequestMutation';
  orderItemBatches?: Maybe<Array<Maybe<OrderItemBatchType>>>;
};

export type CreateTransactionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  date?: InputMaybe<Scalars['Date']>;
  remark?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['ID']>;
};

export type CreateUpdateShipmentPlan = {
  __typename?: 'CreateUpdateShipmentPlan';
  message?: Maybe<Scalars['String']>;
  shipmentPlan?: Maybe<ShipmentPlanType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreditFilterInput = {
  endDate_Gte?: InputMaybe<Scalars['Date']>;
  endDate_Lte?: InputMaybe<Scalars['Date']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  startDate_Gte?: InputMaybe<Scalars['Date']>;
  startDate_Lte?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum CreditStatus {
  /** Active */
  ACT = 'ACT',
  /** Approved */
  APR = 'APR',
  /** Expired */
  EXP = 'EXP',
  /** Rejected */
  REJ = 'REJ',
  /** Requested */
  REQ = 'REQ',
  /** Suspended */
  SUS = 'SUS'
}

export type CreditSummary = {
  __typename?: 'CreditSummary';
  activeUsers?: Maybe<Scalars['Int']>;
  remainingAmount?: Maybe<Scalars['Float']>;
  totalCreditSanctioned?: Maybe<Scalars['Float']>;
  totalUtilized?: Maybe<Scalars['Float']>;
};

export type CreditType = {
  __typename?: 'CreditType';
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  paymentCycleDays: Scalars['Int'];
  remainingAmount: Scalars['Float'];
  settledCreditOrders?: Maybe<Array<Maybe<OrderType>>>;
  startDate?: Maybe<Scalars['Date']>;
  status: CreditStatus;
  totalAmount: Scalars['Float'];
  unsettledCreditOrders?: Maybe<Array<Maybe<OrderType>>>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
  usedAmount: Scalars['Float'];
  user: DeliveryAgentManagementType;
  verificationRemark?: Maybe<Scalars['String']>;
  verifiedBy?: Maybe<DeliveryAgentManagementType>;
  verifiedOn?: Maybe<Scalars['DateTime']>;
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  id: Scalars['ID'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  transactionSet: Array<TransactionGraphType>;
};

export type CustomerSales = {
  __typename?: 'CustomerSales';
  customers?: Maybe<Array<Maybe<BaseUserType>>>;
  summary?: Maybe<SummaryOfVendorBySalesman>;
};

export type DcCollectionLogFilterInput = {
  date?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type DcCollectionLogType = {
  __typename?: 'DCCollectionLogType';
  cashClosing: Scalars['Float'];
  cashCollection: Scalars['Float'];
  cashDeposit: Scalars['Float'];
  cashOpening: Scalars['Float'];
  chequeClosing: Scalars['Float'];
  chequeCollection: Scalars['Float'];
  chequeDeposit: Scalars['Float'];
  chequeOpening: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  creditSaleClosing: Scalars['Float'];
  creditSaleOpening: Scalars['Float'];
  date: Scalars['Date'];
  distributionCentre: DistributionCentreType;
  id: Scalars['ID'];
  netSale: Scalars['Float'];
  orderTransactions: Array<OrderTransactionType>;
  orders: Array<AnnotatedOrderType>;
  othersCollection: Scalars['Float'];
  reconciliationStatus: Scalars['String'];
  transactions: Array<TransactionGraphType>;
  updatedAt: Scalars['DateTime'];
};

export type DcLogFundFlowInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type DcStockTakeConfigFilterInput = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  itemCategory?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum DcStockTakeConfigItemCategory {
  /** SKU */
  SKU = 'SKU',
  /** Sellable Item */
  SLI = 'SLI'
}

export type DcStockTakeConfigType = {
  __typename?: 'DCStockTakeConfigType';
  distributionCentre: DistributionCentreType;
  endDay: Scalars['Int'];
  endTime: Scalars['Time'];
  id: Scalars['ID'];
  itemCategory: DcStockTakeConfigItemCategory;
  startDay: Scalars['Int'];
  startTime: Scalars['Time'];
};

export type DcStorageLocationType = {
  __typename?: 'DCStorageLocationType';
  archive: Scalars['Boolean'];
  codename: Scalars['String'];
  colorCode: Scalars['String'];
  distributionCentre: DistributionCentreType;
  id: Scalars['ID'];
  name: Scalars['String'];
  responsiblePerson?: Maybe<DeliveryAgentManagementType>;
  subLocations: Array<DcSubLocationType>;
};

export type DcSubLocationFilterInput = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type DcSubLocationInput = {
  archive?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  responsiblePersonId?: InputMaybe<Scalars['ID']>;
};

export type DcSubLocationType = {
  __typename?: 'DCSubLocationType';
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  stockEntries: Array<StockEntryItemType>;
  storageLocation: DcStorageLocationType;
};

export type DcWiseStockVisibility = {
  __typename?: 'DCWiseStockVisibility';
  closing?: Maybe<Scalars['Float']>;
  dc?: Maybe<DistributionCentreType>;
  delivered?: Maybe<Scalars['Float']>;
  directSale?: Maybe<Scalars['Float']>;
  disposal?: Maybe<Scalars['Float']>;
  inTransit?: Maybe<Scalars['Float']>;
  inwarded?: Maybe<Scalars['Float']>;
  opening?: Maybe<Scalars['Float']>;
  returned?: Maybe<Scalars['Float']>;
};

export type DmsTripStepType = {
  __typename?: 'DMSTripStepType';
  canDeliver?: Maybe<Scalars['Boolean']>;
  canLoad?: Maybe<Scalars['Boolean']>;
  canUnload?: Maybe<Scalars['Boolean']>;
  distributionCenter?: Maybe<DistributionCentreType>;
};

export type DataSourceInput = {
  codename?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceType = {
  __typename?: 'DataSourceType';
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultVariables: Scalars['JSONString'];
  description: Scalars['String'];
  id: Scalars['ID'];
  inputs?: Maybe<Scalars['JSONScalar']>;
  isActive: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Optional data source to dynamically fetch users */
  notificationtemplateSet: Array<NewNotificationTemplateType>;
  outputs?: Maybe<Scalars['JSONScalar']>;
  referenceQuery: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DelBaseUserMutation = {
  __typename?: 'DelBaseUserMutation';
  user?: Maybe<BaseUserType>;
};

export type DelDepartmentMutation = {
  __typename?: 'DelDepartmentMutation';
  departmentId?: Maybe<Scalars['Int']>;
};

export type DelGroupMutation = {
  __typename?: 'DelGroupMutation';
  groupId?: Maybe<Scalars['Int']>;
};

export type DelPlotSchedulesMutation = {
  __typename?: 'DelPlotSchedulesMutation';
  plotCommodityId?: Maybe<Scalars['Int']>;
};

export type DelScheduleMutation = {
  __typename?: 'DelScheduleMutation';
  schedules?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type DelSkuTypeMutation = {
  __typename?: 'DelSkuTypeMutation';
  skuId?: Maybe<Scalars['String']>;
};

export type DelVehicleMutation = {
  __typename?: 'DelVehicleMutation';
  vehicle?: Maybe<VehicleType>;
};

export type DeleteAssignedRoutePointMutation = {
  __typename?: 'DeleteAssignedRoutePointMutation';
  message?: Maybe<Scalars['String']>;
};

export type DeleteBankDetail = {
  __typename?: 'DeleteBankDetail';
  response?: Maybe<Scalars['String']>;
};

export type DeleteBaseUserAddressMutation = {
  __typename?: 'DeleteBaseUserAddressMutation';
  user?: Maybe<BaseUserType>;
};

export type DeleteCertification = {
  __typename?: 'DeleteCertification';
  response?: Maybe<Scalars['String']>;
};

export type DeleteInwardsMutation = {
  __typename?: 'DeleteInwardsMutation';
  inwards?: Maybe<Array<Maybe<InwardType>>>;
};

export type DeleteMedia = {
  __typename?: 'DeleteMedia';
  response?: Maybe<Scalars['String']>;
};

export type DeleteOrdersMutation = {
  __typename?: 'DeleteOrdersMutation';
  orderIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteSurveyArea = {
  __typename?: 'DeleteSurveyArea';
  response?: Maybe<Scalars['String']>;
};

/** Deprecated! */
export type DeliverBookingMutation = {
  __typename?: 'DeliverBookingMutation';
  booking?: Maybe<BookingType>;
};

export type DeliverOrderMutation = {
  __typename?: 'DeliverOrderMutation';
  order?: Maybe<OrderType>;
};

export type DeliveryAddressOutput = {
  __typename?: 'DeliveryAddressOutput';
  address?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  village?: Maybe<Scalars['String']>;
  w3wName?: Maybe<Scalars['String']>;
};

export type DeliveryAgentManagementType = {
  __typename?: 'DeliveryAgentManagementType';
  accountsCreated: Array<AccountType>;
  accountsUpdated: Array<AccountType>;
  activeAreas?: Maybe<Array<Maybe<Scalars['String']>>>;
  address?: Maybe<AddressType>;
  aggregatorSettlementDetail?: Maybe<AggregatorDetail>;
  approvedItems: Array<OrderItemType>;
  approvedRequests: Array<StockTakeApprovalRequestType>;
  approvedtradeprofileSet: Array<ApprovedTradeProfileType>;
  areaIncharge: Array<PackagingMaterialType>;
  areas?: Maybe<Array<Maybe<BookingType>>>;
  assignedBeats: Array<SupBeatType>;
  assignedPlots: Array<PlotCommodityType>;
  assignedRoutes: Array<RouteAssignmentType>;
  assignedroutepoints: Array<AssignedRoutePointType>;
  bankDetails: Array<BankDetailType>;
  beatVisited: Array<BeatVisitType>;
  beatVisits: Array<BeatVisitType>;
  beatplanSet: Array<BeatPlanType>;
  blockRemark?: Maybe<Scalars['String']>;
  certifications: Array<FarmerCertificationType>;
  collections: Array<CollectionLogType>;
  companies: Array<CompanyType>;
  companyCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creditSet: Array<CreditType>;
  currentDepartment?: Maybe<DepartmentType>;
  customerId: Scalars['String'];
  dateJoined: Scalars['DateTime'];
  /** Users Date of Birth */
  dateOfBirth?: Maybe<Scalars['Date']>;
  dcstoragelocationSet: Array<DcStorageLocationType>;
  demandSet: Array<DemandType>;
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  departments: Array<DepartmentType>;
  distributioncentreSet: Array<DistributionCentreType>;
  dockdetailSet: Array<DockDetailType>;
  documents?: Maybe<Array<Maybe<GeneralCertificationType>>>;
  drivenVehicles: Array<VehicleType>;
  education?: Maybe<BaseUserEducation>;
  email: Scalars['String'];
  familyGroup?: Maybe<FamilyGroupType>;
  familyGroupHierarchy?: Maybe<FamilyGroupHierarchyType>;
  familygroupSet: Array<FamilyGroupType>;
  farmer: Array<PackagingMaterialType>;
  fieldSupervisor: Array<PackagingMaterialType>;
  firebaseToken: Scalars['String'];
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  gateInInwards: Array<TripType>;
  gateOutInwards: Array<TripType>;
  gatelogsSet: Array<GateLogType>;
  gender?: Maybe<BaseUserGender>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: Array<GroupType>;
  harvestingTeam: Array<PackagingMaterialType>;
  id: Scalars['ID'];
  insuranceDetails: Array<InsuranceDetailType>;
  inwardStatusLogs: Array<InwardStatusLogType>;
  inwards: Array<InwardType>;
  inwardsAmcBourn: Array<InwardType>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  isBlocked?: Maybe<Scalars['Boolean']>;
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  /** Select type to maintain access level */
  isSuperadmin: Scalars['Boolean'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  kiteReferenceId?: Maybe<Scalars['String']>;
  kycDetails: Array<KycDetailType>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  licenceDetails: Array<LicenceDetailType>;
  managedCompanies: Array<CompanyType>;
  metadata: Scalars['JSONString'];
  myBeatPlans: Array<BeatPlanType>;
  myOrders: Array<AnnotatedOrderType>;
  mySales: Array<AnnotatedOrderType>;
  myTransactions: Array<OrderTransactionType>;
  nameAsPerPan?: Maybe<Scalars['String']>;
  notificationSet: Array<NotificationType>;
  notificationlogSet: Array<NotificationLogType>;
  notificationsSent: Array<NotificationType>;
  notificationsTriggered: Array<NotificationTriggerType>;
  notificationtriggerSet: Array<NotificationTriggerType>;
  /** Primary phone number user for contact purposes */
  number: Scalars['String'];
  otp?: Maybe<BaseUserOtpType>;
  ownedVehicles: Array<VehicleType>;
  packingallotmentSet: Array<PackingAllotmentSelectorType>;
  password: Scalars['String'];
  paymentSet: Array<PaymentType>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Photo of the user. */
  photo?: Maybe<Scalars['String']>;
  placedOrders: Array<AnnotatedOrderType>;
  plotVisitor: Array<PackagingMaterialType>;
  plots: Array<PlotType>;
  pmSupervisor: Array<PackagingMaterialType>;
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  primaryAccount?: Maybe<AccountType>;
  primaryDcs: Array<DistributionCentreType>;
  productionProductionCreated: Array<ProductionType>;
  productionProductionUpdated: Array<ProductionType>;
  productionProductionitemCreated: Array<ProductionItemType>;
  productionProductionitemUpdated: Array<ProductionItemType>;
  productionitemSet: Array<ProductionItemType>;
  recordedTransactions: Array<OrderTransactionType>;
  referenceId: Scalars['String'];
  reportexportlogSet: Array<ReportExportLogType>;
  reportsCreated: Array<ReportTemplateType>;
  reporttemplateSet: Array<ReportTemplateType>;
  requested: Array<StockTakeApprovalRequestType>;
  requestedItems: Array<OrderItemType>;
  requests: Array<StockTakeApprovalRequestType>;
  requestsApproved: Array<ScheduleRequestType>;
  routepoints: Array<RoutePointType>;
  savedAddress: Array<BaseUserAddressType>;
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  schedulesAmcBourn: Array<ScheduleType>;
  schedulesCompleted: Array<ScheduleType>;
  schedulesForDate?: Maybe<Array<Maybe<ScheduleType>>>;
  secondaryNumbers: Array<ContactType>;
  sellableitemreviewSet: Array<SellableItemReviewType>;
  seller?: Maybe<SellerType>;
  shopSet: Array<ShopType>;
  shopsManaged: Array<ShopType>;
  status: BaseUserStatus;
  stockentryitemSet: Array<StockEntryItemType>;
  stocktransactionSet: Array<StockTransactionType>;
  superviseAssignedroutepointCreated: Array<AssignedRoutePointType>;
  superviseAssignedroutepointUpdated: Array<AssignedRoutePointType>;
  superviseBeatvisitCreated: Array<BeatVisitType>;
  superviseBeatvisitUpdated: Array<BeatVisitType>;
  superviseBeatvisitactionCreated: Array<BeatVisitActionType>;
  superviseBeatvisitactionUpdated: Array<BeatVisitActionType>;
  superviseRouteCreated: Array<RouteType>;
  superviseRouteUpdated: Array<RouteType>;
  superviseRouteassignmentCreated: Array<RouteAssignmentType>;
  superviseRouteassignmentUpdated: Array<RouteAssignmentType>;
  superviseRoutepointCreated: Array<RoutePointType>;
  superviseRoutepointUpdated: Array<RoutePointType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  surveyableAreas: Array<SurveyAreaLocationType>;
  surveyareaSet: Array<SurveyAreaLocationType>;
  /** User who recorded the transaction */
  transactionSet: Array<TransactionGraphType>;
  transportProvider: Array<ScheduleType>;
  tripSet: Array<TripType>;
  tripsSupervised: Array<TripType>;
  unsettledDetail?: Maybe<UnsettledDetail>;
  updatedAt: Scalars['DateTime'];
  userCredits: Array<CreditType>;
  /** Specific permissions for this user. */
  userPermissions: Array<PermissionType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  vtEcommerceCreditCreated: Array<CreditType>;
  vtEcommerceCreditUpdated: Array<CreditType>;
  vtFuelManagementFueldistributorCreated: Array<FuelDistributorType>;
  vtFuelManagementFueldistributorUpdated: Array<FuelDistributorType>;
  vtFuelManagementFueldistributoritemCreated: Array<FuelDistributorItemType>;
  vtFuelManagementFueldistributoritemUpdated: Array<FuelDistributorItemType>;
};


export type DeliveryAgentManagementTypeAggregatorSettlementDetailArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};


export type DeliveryAgentManagementTypeSchedulesForDateArgs = {
  date: Scalars['Date'];
};


export type DeliveryAgentManagementTypeUnsettledDetailArgs = {
  departmentId: Scalars['ID'];
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type DeliveryConditionInput = {
  deliveryCosts?: InputMaybe<Array<InputMaybe<DeliveryCostInput>>>;
  estimatedDelta?: InputMaybe<Scalars['String']>;
  extraSapCodes?: InputMaybe<ExtraSapCodes>;
  gstDetails?: InputMaybe<GstDetailsInput>;
  isManufacturingPlant?: InputMaybe<Scalars['Boolean']>;
  minCartValue?: InputMaybe<Scalars['Float']>;
};

export type DeliveryConditionType = {
  __typename?: 'DeliveryConditionType';
  deliveryCosts?: Maybe<Array<Maybe<DeliveryCostType>>>;
  estimatedDelta?: Maybe<Scalars['String']>;
  extraSapCodes?: Maybe<ExtraSapCodesType>;
  gstDetails?: Maybe<GstDetailsType>;
  isManufacturingPlant?: Maybe<Scalars['Boolean']>;
  minCartValue?: Maybe<Scalars['Float']>;
};

export type DeliveryCostInput = {
  costRange?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  deliveryCost?: InputMaybe<Scalars['Float']>;
};

export type DeliveryCostType = {
  __typename?: 'DeliveryCostType';
  costRange?: Maybe<Array<Maybe<Scalars['Float']>>>;
  deliveryCost?: Maybe<Scalars['Float']>;
};

export type DeliveryOrderItemBatchInput = {
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  deliveredQuantity: Scalars['Int'];
  id: Scalars['ID'];
};

export type DeliveryStockMovementMutation = {
  __typename?: 'DeliveryStockMovementMutation';
  bookings?: Maybe<Array<Maybe<BookingType>>>;
};

export type DemandFilterInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  depot_Id?: InputMaybe<Scalars['ID']>;
  groupVisibility_Name?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  variety_Id?: InputMaybe<Scalars['ID']>;
};

export type DemandPriceSummary = {
  __typename?: 'DemandPriceSummary';
  avgPrice?: Maybe<Scalars['Float']>;
  maxPrice?: Maybe<Scalars['Float']>;
  minPrice?: Maybe<Scalars['Float']>;
};

export type DemandType = {
  __typename?: 'DemandType';
  allowAggregatorVehicle: Scalars['Boolean'];
  allowOwnVehicle: Scalars['Boolean'];
  attachments: Array<MediaEntityType>;
  bookingQuantityLimit?: Maybe<Scalars['Float']>;
  broadcastTime: Scalars['DateTime'];
  company?: Maybe<CompanyType>;
  companyVisibility: Array<CompanyType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  dateTill?: Maybe<Scalars['Date']>;
  depot: DepotType;
  description?: Maybe<Scalars['String']>;
  gradePrices: Array<GradePriceType>;
  groupVisibility: Array<GroupType>;
  id: Scalars['ID'];
  inwardedQuantity?: Maybe<Scalars['Float']>;
  isLive: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  name: Scalars['String'];
  plotCommodity?: Maybe<PlotCommodityType>;
  priceSummary?: Maybe<DemandPriceSummary>;
  raisedBy: DeliveryAgentManagementType;
  raisedThrough: DepartmentType;
  timeSlots: Array<TimeSlotRequirementType>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  variety: CommodityVarietyType;
  varietyGroup?: Maybe<CommodityGroupType>;
  verifiedById?: Maybe<Scalars['String']>;
};

export type DepartmentAccessType = {
  __typename?: 'DepartmentAccessType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  departmentSet: Array<DepartmentType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** An enumeration. */
export enum DepartmentDepartmentType {
  /** Export Department */
  EX = 'EX',
  /** Processing Department */
  PR = 'PR',
  /** Retail Department */
  RT = 'RT',
  /** Wholesale Department */
  WH = 'WH'
}

/** An enumeration. */
export enum DepartmentInvoiceType {
  /** Sap Billing Doc */
  SPBD = 'SPBD',
  /** Sap Invoice */
  SPIN = 'SPIN',
  /** Vesatogo Invoice */
  VTIN = 'VTIN'
}

/** An enumeration. */
export enum DepartmentPricingDoneOn {
  /** UOM Type */
  QTY = 'QTY',
  /** SKU Type */
  SKU = 'SKU'
}

export type DepartmentType = {
  __typename?: 'DepartmentType';
  access?: Maybe<DepartmentAccessType>;
  activeMembers: Array<DeliveryAgentManagementType>;
  allowedDepots: Array<DepotType>;
  assignedTrips: Array<TripType>;
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  baseuserSet: Array<DeliveryAgentManagementType>;
  beatplanSet: Array<BeatPlanType>;
  codename?: Maybe<Scalars['String']>;
  companies: Array<CompanyType>;
  controlPricing: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  defaultPerUnit: Array<SkuGraphType>;
  defaultTraderVarieties?: Maybe<Array<Maybe<CommodityVarietyType>>>;
  demandSet: Array<DemandType>;
  demandWhatsappApproval: Scalars['Boolean'];
  departmentType: DepartmentDepartmentType;
  departmentTypeDisplay?: Maybe<Scalars['String']>;
  distributioncentreSet: Array<DistributionCentreType>;
  gateEntryRequired: Scalars['Boolean'];
  gateNumbers: Array<GateNumberType>;
  generatePoAfterInward: Scalars['Boolean'];
  generatePoPlotWise: Scalars['Boolean'];
  harvestprojectionSet: Array<HarvestProjectionType>;
  hasDynamicStock: Scalars['Boolean'];
  holdingareaSet: Array<HoldingAreaType>;
  id: Scalars['ID'];
  invoiceType: DepartmentInvoiceType;
  inwardAllocation: Scalars['Boolean'];
  isB2c?: Maybe<Scalars['Boolean']>;
  kiteReferenceId?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  newGatePass: Scalars['Boolean'];
  optionalPricing: Scalars['Boolean'];
  orderSet: Array<AnnotatedOrderType>;
  packagingMaterialFlow: Scalars['Boolean'];
  payuCredentials?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  preferredDepot?: Maybe<DepotType>;
  priceApprovalFlow: Scalars['Boolean'];
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  pricingDoneOn?: Maybe<DepartmentPricingDoneOn>;
  productionSet: Array<ProductionType>;
  productionlineSet: Array<ProductionLineType>;
  purchaseUnderZoneCompany: Scalars['Boolean'];
  qcSubscription: Scalars['Boolean'];
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  sellableitemSet: Array<SellableItemType>;
  sellableitemstockSet: Array<SellableItemStockType>;
  sendInwardSms: Scalars['Boolean'];
  shouldCrossPo: Scalars['Boolean'];
  stockentryitemSet: Array<StockEntryItemType>;
  stocktransactionSet: Array<StockTransactionType>;
  togoSubscription: Scalars['Boolean'];
  tripSteps: Array<TripStepType>;
  updatedAt: Scalars['DateTime'];
  varieties?: Maybe<Array<Maybe<CommodityVarietyType>>>;
  vehicleSet: Array<VehicleType>;
  whatsappOnOrderStatus: Scalars['Boolean'];
};


export type DepartmentTypeDefaultTraderVarietiesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DepartmentTypeVarietiesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type DepositPendingInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  dcId: Scalars['ID'];
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DepotType = {
  __typename?: 'DepotType';
  allowedDepartments: Array<DepartmentType>;
  codename: Scalars['String'];
  demands: Array<DemandType>;
  distributionCentre?: Maybe<DistributionCentreType>;
  docks: Array<DockType>;
  holdingareaSet: Array<HoldingAreaType>;
  id: Scalars['ID'];
  location: AddressType;
  name: Scalars['String'];
  preferredDepartments: Array<DepartmentType>;
  productionlineSet: Array<ProductionLineType>;
  scheduleSet: Array<ScheduleType>;
  schedulesEnded: Array<ScheduleType>;
  schedulesStarted: Array<ScheduleType>;
  tripsEndedIn: Array<TripType>;
  tripsStartedFrom: Array<TripType>;
  unloadingsublocationSet: Array<UnloadingSubLocationType>;
  uuid: Scalars['UUID'];
  vehiclesLocated: Array<VehicleType>;
};

export type Destination = {
  __typename?: 'Destination';
  id?: Maybe<Scalars['Int']>;
  village?: Maybe<Scalars['String']>;
};

export type DiscountType = {
  __typename?: 'DiscountType';
  banner?: Maybe<MediaEntityType>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  discountConditions: Scalars['JSONString'];
  endDate: Scalars['Date'];
  flat: Scalars['Float'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  orderSet: Array<AnnotatedOrderType>;
  orderitemSet: Array<OrderItemType>;
  percentage: Scalars['Float'];
  startDate: Scalars['Date'];
  updatedAt: Scalars['DateTime'];
};

export type DispatchBookingItem = {
  id?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  quantity: Scalars['Int'];
  scheduleId?: InputMaybe<Scalars['ID']>;
  sequenceNumber: Scalars['Int'];
};

export type DistributionCentreLocationInput = {
  archive?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Scalars['ID']>;
  isManufacturingPlant?: InputMaybe<Scalars['Boolean']>;
  pointOfContacts?: InputMaybe<Scalars['ID']>;
  sample?: InputMaybe<Scalars['String']>;
};

export type DistributionCentreLocationType = {
  __typename?: 'DistributionCentreLocationType';
  bbox?: Maybe<Scalars['GenericScalar']>;
  geometry?: Maybe<GeometryObjectType>;
  id: Scalars['ID'];
  properties?: Maybe<DistributionCentreProperties>;
  type?: Maybe<Scalars['String']>;
};

export type DistributionCentreProperties = {
  __typename?: 'DistributionCentreProperties';
  address: AddressType;
  allowedDepartments: Array<DepartmentType>;
  alternateSalesSlots: Array<TimeSlotType>;
  archive: Scalars['Boolean'];
  areaCateredFlipped?: Maybe<GeometryObjectType>;
  assignedCpc?: Maybe<DistributionCentreType>;
  bankDetails?: Maybe<Array<Maybe<BankDetailType>>>;
  certifications?: Maybe<Array<Maybe<GeneralCertificationType>>>;
  codename: Scalars['String'];
  colorCode: Scalars['String'];
  companyCode?: Maybe<Scalars['String']>;
  consolidatedOrders: Array<AnnotatedOrderType>;
  createdAt: Scalars['DateTime'];
  currentStockPercentage?: Maybe<Scalars['Float']>;
  customerCode?: Maybe<Scalars['String']>;
  dcStocks: Array<SellableItemStockType>;
  dcstocktakeconfigSet: Array<DcStockTakeConfigType>;
  deliveryConditions?: Maybe<DeliveryConditionType>;
  deliverySlots: Array<TimeSlotType>;
  deliveryTaxes: Array<TaxType>;
  depot?: Maybe<DepotType>;
  distributioncentreSet: Array<DistributionCentreType>;
  docks: Array<DockType>;
  groupVisibility: Array<GroupType>;
  maintenanceSlots: Array<TimeSlotType>;
  manufacturedStocks: Array<BatchStockType>;
  myLogs: Array<DcCollectionLogType>;
  name: Scalars['String'];
  partnerCode?: Maybe<Scalars['String']>;
  photos: Array<MediaEntityType>;
  pickupSlots: Array<TimeSlotType>;
  placedOrders: Array<AnnotatedOrderType>;
  plantCode?: Maybe<Scalars['String']>;
  pointOfContacts: Array<DeliveryAgentManagementType>;
  primaryAccount?: Maybe<AccountType>;
  primaryPoc?: Maybe<DeliveryAgentManagementType>;
  salesOfcCode?: Maybe<Scalars['String']>;
  shipments: Array<ShippingType>;
  storageLocations: Array<DcStorageLocationType>;
  storeCode?: Maybe<Scalars['String']>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  suppliedStocks: Array<BatchStockType>;
  surveyareaSet: Array<SurveyAreaLocationType>;
  transactionLogs: Array<CollectionLogType>;
  updateFromAreaCateredFlipped: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  useCreditFeature: Scalars['Boolean'];
};

export type DistributionCentreType = {
  __typename?: 'DistributionCentreType';
  address: AddressType;
  allowedDepartments: Array<DepartmentType>;
  alternateSalesSlots: Array<TimeSlotType>;
  archive: Scalars['Boolean'];
  areaCateredFlipped?: Maybe<GeometryObjectType>;
  assignedCpc?: Maybe<DistributionCentreType>;
  codename: Scalars['String'];
  colorCode: Scalars['String'];
  consolidatedOrders: Array<AnnotatedOrderType>;
  createdAt: Scalars['DateTime'];
  currentStockPercentage?: Maybe<Scalars['Float']>;
  dcStocks: Array<SellableItemStockType>;
  dcstocktakeconfigSet: Array<DcStockTakeConfigType>;
  deliveryConditions: Scalars['JSONString'];
  deliverySlots: Array<TimeSlotType>;
  deliveryTaxes: Array<TaxType>;
  depot?: Maybe<DepotType>;
  distributioncentreSet: Array<DistributionCentreType>;
  docks: Array<DockType>;
  geometry?: Maybe<GeometryObjectType>;
  groupVisibility: Array<GroupType>;
  id: Scalars['ID'];
  maintenanceSlots: Array<TimeSlotType>;
  manufacturedStocks: Array<BatchStockType>;
  myLogs: Array<DcCollectionLogType>;
  name: Scalars['String'];
  photos: Array<MediaEntityType>;
  pickupSlots: Array<TimeSlotType>;
  placedOrders: Array<AnnotatedOrderType>;
  pointOfContacts?: Maybe<Array<Maybe<BaseUserType>>>;
  primaryAccount?: Maybe<AccountType>;
  primaryPoc?: Maybe<DeliveryAgentManagementType>;
  shipments: Array<ShippingType>;
  storageLocations: Array<DcStorageLocationType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  suppliedStocks: Array<BatchStockType>;
  surveyareaSet: Array<SurveyAreaLocationType>;
  transactionLogs: Array<CollectionLogType>;
  updateFromAreaCateredFlipped: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  useCreditFeature: Scalars['Boolean'];
};


export type DistributionCentreTypePointOfContactsArgs = {
  groupsId?: InputMaybe<Scalars['ID']>;
};

/** Deprecated! */
export type DockAssignMutation = {
  __typename?: 'DockAssignMutation';
  trip?: Maybe<TripType>;
};

/** An enumeration. */
export enum DockDetailKind {
  /** Delivery */
  DELIVERY = 'DELIVERY',
  /** Loading */
  LOADING = 'LOADING',
  /** Unloading */
  UNLOADING = 'UNLOADING'
}

export type DockDetailType = {
  __typename?: 'DockDetailType';
  dock: DockType;
  id: Scalars['ID'];
  kind: DockDetailKind;
  supervisor: DeliveryAgentManagementType;
  trip: TripType;
};

export type DockType = {
  __typename?: 'DockType';
  address?: Maybe<AddressType>;
  archive: Scalars['Boolean'];
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  depot?: Maybe<DepotType>;
  details: Array<DockDetailType>;
  distributionCentre?: Maybe<DistributionCentreType>;
  id: Scalars['ID'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  tripsLoaded: Array<TripType>;
};

export type DriverApprovalInputType = {
  driverLoadingApproval?: InputMaybe<Scalars['Boolean']>;
  driverUnloadingApproval?: InputMaybe<Scalars['Boolean']>;
  driverVerification?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type DriverLoadingVerificationMutation = {
  __typename?: 'DriverLoadingVerificationMutation';
  trip?: Maybe<TripType>;
};

export type DriverVerificationInput = {
  bookingId?: InputMaybe<Scalars['Int']>;
  despatchPhotoLink?: InputMaybe<MediaInput>;
  driverVerification?: InputMaybe<Scalars['Boolean']>;
  remark?: InputMaybe<Scalars['String']>;
};

export type DurationType = {
  __typename?: 'DurationType';
  hours?: Maybe<Scalars['Int']>;
  minutes?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Int']>;
};

export type EcomMediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  mediaType: Scalars['String'];
  url: Scalars['String'];
};

export enum EcommerceUserType {
  CUSTOMER = 'CUSTOMER',
  VENDOR = 'VENDOR'
}

/** An enumeration. */
export enum EmployementType {
  IN_PLANT_TRAINEE = 'IN_PLANT_TRAINEE',
  NAPS = 'NAPS',
  ON_PROBATION = 'ON_PROBATION',
  ON_THE_ROLE = 'ON_THE_ROLE',
  TRAINEE = 'TRAINEE'
}

/** An enumeration. */
export enum ExpenseBorneBy {
  /** Company */
  COMP = 'COMP',
  /** Other */
  OTHR = 'OTHR'
}

export type ExpenseGraphType = {
  __typename?: 'ExpenseGraphType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  expenseSet: Array<ExpenseType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ExpenseType = {
  __typename?: 'ExpenseType';
  attachments: Array<MediaEntityType>;
  borneBy: ExpenseBorneBy;
  contract?: Maybe<ContractType>;
  createdAt: Scalars['DateTime'];
  expenseType: ExpenseGraphType;
  id: Scalars['ID'];
  name: Scalars['String'];
  netAmount: Scalars['Float'];
  objectId: Scalars['Int'];
  quantity: Scalars['Float'];
  quantityRate: Scalars['Float'];
  remark: Scalars['String'];
  resourceUsed: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ExportCustomerType = {
  __typename?: 'ExportCustomerType';
  codename: Scalars['String'];
  description: Scalars['String'];
  exportcustomervalidationSet: Array<ExportCustomerValidationType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** LOT Code format are like L WWDD, L WW - DD, LYYDDD, etc. */
  lotCodeFormat?: Maybe<Scalars['String']>;
  market?: Maybe<MarketType>;
  name: Scalars['String'];
  shipmentplanSet: Array<ShipmentPlanType>;
  tradeprofileSet: Array<TradeProfileType>;
};

export type ExportCustomerValidationType = {
  __typename?: 'ExportCustomerValidationType';
  alertChemical?: Maybe<Scalars['String']>;
  bannedChemical: Array<QualityParameterType>;
  createdAt: Scalars['DateTime'];
  criticalSubstancePercent?: Maybe<Scalars['Float']>;
  exportCustomer?: Maybe<ExportCustomerType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  market?: Maybe<MarketType>;
  maxDetections?: Maybe<Scalars['Int']>;
  maxIndividualPercent?: Maybe<Scalars['Float']>;
  maxSumPercent?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  resultStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ExternalApplicationType = {
  __typename?: 'ExternalApplicationType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  externalreferenceSet: Array<ExternalReferenceType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ExternalReferenceType = {
  __typename?: 'ExternalReferenceType';
  externalApp: ExternalApplicationType;
  id: Scalars['ID'];
  objectId: Scalars['Int'];
  referenceId: Scalars['String'];
};

export type ExtraSapCodes = {
  businessPlace?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  profitCenter?: InputMaybe<Scalars['String']>;
};

export type ExtraSapCodesType = {
  __typename?: 'ExtraSAPCodesType';
  businessPlace?: Maybe<Scalars['String']>;
  costCenter?: Maybe<Scalars['String']>;
  profitCenter?: Maybe<Scalars['String']>;
};

export type FamilyGroupFilterInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
};

export type FamilyGroupHierarchyFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type FamilyGroupHierarchyType = {
  __typename?: 'FamilyGroupHierarchyType';
  baseuserSet: Array<DeliveryAgentManagementType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FamilyGroupType = {
  __typename?: 'FamilyGroupType';
  /** Vendor's Business Address */
  address?: Maybe<AddressType>;
  bankDetails?: Maybe<Array<Maybe<BankDetailType>>>;
  businessCategory?: Maybe<BusinessCategoryType>;
  category?: Maybe<GroupType>;
  certifications?: Maybe<Array<Maybe<GeneralCertificationType>>>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  leader?: Maybe<DeliveryAgentManagementType>;
  members: Array<DeliveryAgentManagementType>;
  name: Scalars['String'];
  shops: Array<ShopType>;
  totalAllowedCredits: Scalars['Float'];
};

export type FarmerCertificationType = {
  __typename?: 'FarmerCertificationType';
  certificationNumber: Scalars['String'];
  certificationType: CertificationGraphType;
  farmer: DeliveryAgentManagementType;
  id: Scalars['ID'];
  isVerified: Scalars['Boolean'];
};

export type FarmerDetailInput = {
  banks?: InputMaybe<Array<InputMaybe<BankDetailInput>>>;
  certifications?: InputMaybe<Array<InputMaybe<CertificationInput>>>;
  kycs?: InputMaybe<Array<InputMaybe<KycDetailInput>>>;
  user?: InputMaybe<PureBaseUserInput>;
};

export type FarmerInput = {
  bankDetail?: InputMaybe<BankDetailInput>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['Int']>;
  kycDetail?: InputMaybe<KycDetailInput>;
  lastName?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  secondaryNumbers?: InputMaybe<Array<InputMaybe<SecondaryNumberInput>>>;
  username?: InputMaybe<Scalars['String']>;
};

export type FarmerPlotCommodityInput = {
  agronomist?: InputMaybe<Scalars['Int']>;
  alternateCropGroupId?: InputMaybe<Scalars['ID']>;
  estimatedHarvestQuantity?: InputMaybe<Scalars['Float']>;
  generatePoPlotWise?: InputMaybe<Scalars['Boolean']>;
  growingCycle?: InputMaybe<Scalars['Int']>;
  harvestingDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  isFinishedGood?: InputMaybe<Scalars['Boolean']>;
  isRawMaterial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfSaplings?: InputMaybe<Scalars['Int']>;
  registrationCode?: InputMaybe<Scalars['String']>;
  sowingDate?: InputMaybe<Scalars['Date']>;
  variety?: InputMaybe<Scalars['Int']>;
};

export type FarmerPlotInput = {
  address?: InputMaybe<AddressInput>;
  area?: InputMaybe<Scalars['Float']>;
  codename?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['Int']>;
  crops?: InputMaybe<Array<InputMaybe<FarmerPlotCommodityInput>>>;
  farmer?: InputMaybe<Scalars['Int']>;
  gatNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  soilType?: InputMaybe<Scalars['Int']>;
};

export type FetchBatchStockMutation = {
  __typename?: 'FetchBatchStockMutation';
  success: Scalars['Boolean'];
  taskId: Scalars['String'];
};

export type FetchBatchStockStatusType = {
  __typename?: 'FetchBatchStockStatusType';
  canExecute: Scalars['Boolean'];
  executedAt?: Maybe<Scalars['DateTime']>;
  isExecuted: Scalars['Boolean'];
  requestedAt?: Maybe<Scalars['DateTime']>;
  retryAfterSeconds: Scalars['Int'];
  status: Scalars['String'];
  taskId?: Maybe<Scalars['String']>;
};

export type FilterSampleInput = {
  detectionCount?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['Int']>;
  maxDetection?: InputMaybe<Scalars['Float']>;
  sampleDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  totalDetection?: InputMaybe<Scalars['Float']>;
};

export type FormFieldDropdownOutput = {
  __typename?: 'FormFieldDropdownOutput';
  name?: Maybe<Scalars['String']>;
};

export type FormFieldInput = {
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FormFieldOutput = {
  __typename?: 'FormFieldOutput';
  dropdownItems?: Maybe<Array<Maybe<FormFieldDropdownOutput>>>;
  fieldType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  spinnerItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['String']>;
};

export type FuelDistributorItemSearchInput = {
  assetId?: InputMaybe<Scalars['Int']>;
  distributedFuelQuantity?: InputMaybe<Scalars['Float']>;
  fuelDistributorId?: InputMaybe<Scalars['Int']>;
  odometerReading?: InputMaybe<Scalars['Float']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
};

export type FuelDistributorItemType = {
  __typename?: 'FuelDistributorItemType';
  asset: VehicleType;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  /** Fuel Quantity */
  distributedFuelQuantity: Scalars['Float'];
  fuelDistributor: FuelDistributorType;
  id: Scalars['ID'];
  /** Odometer reading */
  odometerReading: Scalars['Float'];
  odometerReadingAttachment?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};

export type FuelDistributorSearchInput = {
  batchNo?: InputMaybe<Scalars['String']>;
  fuelStationName?: InputMaybe<Scalars['String']>;
  fuelTypeId?: InputMaybe<Scalars['Int']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  tankerNoId?: InputMaybe<Scalars['Int']>;
};

export type FuelDistributorType = {
  __typename?: 'FuelDistributorType';
  batchNo: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  fuelDetailAttachment?: Maybe<Scalars['String']>;
  fuelDistributor: Array<FuelDistributorItemType>;
  /** Fuel rate */
  fuelRate: Scalars['Float'];
  fuelReceiptAttachment?: Maybe<Scalars['String']>;
  fuelStationName: Scalars['String'];
  fuelType?: Maybe<FuelGraphType>;
  id: Scalars['ID'];
  /** Fuel quantity filled in tanker */
  quantityFilled: Scalars['Float'];
  remainingFuel?: Maybe<Scalars['Float']>;
  remark: Scalars['String'];
  tankerNo: VehicleType;
  /** Total Fuel Amount */
  totalFuelAmount: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};

export type FuelGraphType = {
  __typename?: 'FuelGraphType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  fueldistributorSet: Array<FuelDistributorType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  vehicleSet: Array<VehicleType>;
};

export type FundFlowInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  outstandingAmountRemaining?: InputMaybe<Scalars['Boolean']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentMethodsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** department ID */
  placedInId?: InputMaybe<Scalars['ID']>;
  targetDcId?: InputMaybe<Scalars['ID']>;
};

export type FundFlowType = {
  __typename?: 'FundFlowType';
  cashClosingSum?: Maybe<Scalars['Float']>;
  cashCollectionSum?: Maybe<Scalars['Float']>;
  cashDepositSum?: Maybe<Scalars['Float']>;
  cashOpeningSum?: Maybe<Scalars['Float']>;
  chequeClosingSum?: Maybe<Scalars['Float']>;
  chequeCollectionSum?: Maybe<Scalars['Float']>;
  chequeDepositSum?: Maybe<Scalars['Float']>;
  chequeOpeningSum?: Maybe<Scalars['Float']>;
  creditSaleClosingSum?: Maybe<Scalars['Float']>;
  creditSaleOpeningSum?: Maybe<Scalars['Float']>;
  netSaleSum?: Maybe<Scalars['Float']>;
  othersCollectionSum?: Maybe<Scalars['Float']>;
};

export type GstDetailsInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  gstin?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  registeredName?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  stateName?: InputMaybe<Scalars['String']>;
};

export type GstDetailsType = {
  __typename?: 'GSTDetailsType';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  gstin?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  registeredName?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
};

export type GateLogStatusType = {
  __typename?: 'GateLogStatusType';
  latestIn?: Maybe<GateLogType>;
  latestOut?: Maybe<GateLogType>;
  statusSummary?: Maybe<Scalars['String']>;
};

export type GateLogType = {
  __typename?: 'GateLogType';
  createdAt: Scalars['DateTime'];
  /**  Stores BAPI gate entry in `IN` */
  gateEntryNo?: Maybe<Scalars['String']>;
  gateNumber?: Maybe<GateNumberType>;
  gatePerson?: Maybe<DeliveryAgentManagementType>;
  gateStatus: GateLogsGateStatus;
  id: Scalars['ID'];
  schedule: ScheduleType;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum GateLogsGateStatus {
  /** In */
  IN = 'IN',
  /** Out */
  OUT = 'OUT'
}

export type GateNumberType = {
  __typename?: 'GateNumberType';
  codename: Scalars['String'];
  departmentSet: Array<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  gatelogsSet: Array<GateLogType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plantCode: Scalars['String'];
  tripSet: Array<TripType>;
};

export type GeneralBeatType = {
  __typename?: 'GeneralBeatType';
  attachments: Array<MediaEntityType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  objectId: Scalars['Int'];
  otp: Scalars['Int'];
  plan: BeatPlanType;
  remark?: Maybe<Scalars['String']>;
  status: BeatStatus;
  updatedAt: Scalars['DateTime'];
  visitCategory: BeatVisitCategory;
  /** Beat Completed Location */
  visitedAt?: Maybe<AddressType>;
  visitedOn?: Maybe<Scalars['DateTime']>;
};

export type GeneralCertificationInput = {
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  certificationTypeId?: InputMaybe<Scalars['ID']>;
  entityIssued?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  idNumber?: InputMaybe<Scalars['String']>;
  issuedBy?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTill?: InputMaybe<Scalars['Date']>;
};

export type GeneralCertificationType = {
  __typename?: 'GeneralCertificationType';
  attachments: Array<MediaEntityType>;
  certificationType: CertificationGraphType;
  id: Scalars['ID'];
  idNumber: Scalars['String'];
  isVerified: Scalars['Boolean'];
  issuedBy: Scalars['String'];
  objectId: Scalars['Int'];
  photo?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  validFrom?: Maybe<Scalars['Date']>;
  validTill?: Maybe<Scalars['Date']>;
};

export type GeneratePoMutation = {
  __typename?: 'GeneratePOMutation';
  pos?: Maybe<Array<Maybe<PurchaseOrderItemType>>>;
};

/** Mutation to generate trips and bookings from schedule data */
export type GenerateTripMutation = {
  __typename?: 'GenerateTripMutation';
  trips?: Maybe<Array<Maybe<TripType>>>;
};

/**
 *
 * `GeometryObjectType` represents a pair of values:
 * - Geometry `type`
 * - Geometry `coordinates`
 *
 */
export type GeometryObjectType = {
  __typename?: 'GeometryObjectType';
  coordinates?: Maybe<Scalars['GenericScalar']>;
  type?: Maybe<Scalars['String']>;
};

export type GradePriceInput = {
  grade?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  recommendedPrice?: InputMaybe<Scalars['Float']>;
};

/** An enumeration. */
export enum GradePricePricingDoneOn {
  /** SKU Count */
  SKU = 'SKU',
  /** UOM Count */
  UOM = 'UOM'
}

export type GradePriceType = {
  __typename?: 'GradePriceType';
  averageBenchmark: Array<PriceBenchmarkRecommendationType>;
  created: Scalars['DateTime'];
  demandSet: Array<DemandType>;
  grade: HarvestGradeType;
  groupSuggestedPrice: Scalars['Float'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  previousPrice?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceLimit: Scalars['Float'];
  priceUnit: SkuGraphType;
  pricebenchmarkdataSet: Array<PriceBenchmarkDataType>;
  pricingDoneOn: GradePricePricingDoneOn;
  recommendedBenchmark: Array<PriceBenchmarkRecommendationType>;
  recommendedPrice: Scalars['Float'];
  rejection: Scalars['Float'];
  remark: Scalars['String'];
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  uomType?: Maybe<SiUnitType>;
  updated: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type GroupCategoryType = {
  __typename?: 'GroupCategoryType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  groupSet: Array<GroupType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GroupType = {
  __typename?: 'GroupType';
  allowedDcs: Array<DistributionCentreType>;
  approvalrequestSet: Array<StockTakeApprovalRequestType>;
  category?: Maybe<GroupCategoryType>;
  demandSet: Array<DemandType>;
  familygroupSet: Array<FamilyGroupType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notificationSet: Array<NotificationType>;
  permissions: Array<PermissionType>;
  reporttemplateSet: Array<ReportTemplateType>;
  userCount?: Maybe<Scalars['Int']>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  userSet: Array<DeliveryAgentManagementType>;
  /** Do not change! May result in inconsistencies. */
  visibleSellableItems: Array<SellableItemStockType>;
};

export type HandoverReturnOrderInput = {
  orderItemBatchId?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
};

export type HarvestGradeInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
};

export type HarvestGradeType = {
  __typename?: 'HarvestGradeType';
  gradepriceSet: Array<GradePriceType>;
  id: Scalars['ID'];
  inwardSet: Array<InwardType>;
  kiteReferenceId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pricebenchmarkdataSet: Array<PriceBenchmarkDataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  purchaseorderitemSet: Array<PurchaseOrderItemType>;
  sellablevarietySet: Array<SellableVarietyType>;
  specifications: Scalars['String'];
  variety?: Maybe<CommodityVarietyType>;
  weighSet: Array<WeighType>;
};

export type HarvestProjectionMetricsType = {
  __typename?: 'HarvestProjectionMetricsType';
  actualContainers: Scalars['Decimal'];
  actualYieldMt: Scalars['Decimal'];
  areaAcre: Scalars['Decimal'];
  estimatedContainers: Scalars['Decimal'];
  estimatedYieldMt: Scalars['Decimal'];
  harvestPlots: Scalars['Int'];
  totalPlots: Scalars['Int'];
  varietyCount: Scalars['Int'];
  varietyGroupCount: Scalars['Int'];
};

export type HarvestProjectionPayloadType = {
  __typename?: 'HarvestProjectionPayloadType';
  count: Scalars['Int'];
  harvestWeeks: Array<Maybe<HarvestProjectionWeekType>>;
  pruningWeeks: Array<Maybe<HarvestProjectionWeekType>>;
  results: Array<Maybe<HarvestProjectionType>>;
  summary: HarvestProjectionMetricsType;
};

export type HarvestProjectionType = {
  __typename?: 'HarvestProjectionType';
  actualContainers?: Maybe<Scalars['Float']>;
  actualYieldMt?: Maybe<Scalars['Float']>;
  codename: Scalars['String'];
  company?: Maybe<CompanyType>;
  createdAt: Scalars['DateTime'];
  department?: Maybe<DepartmentType>;
  description: Scalars['String'];
  estimatedContainers?: Maybe<Scalars['Float']>;
  estimatedYieldMt: Scalars['Float'];
  harvestingDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  plotCommodity: PlotCommodityType;
  projectedAreaAcre: Scalars['Float'];
  pruningDate?: Maybe<Scalars['Date']>;
  quantityUnit?: Maybe<Scalars['String']>;
  seasonName?: Maybe<Scalars['String']>;
  tradeYear?: Maybe<TradeYearType>;
  updatedAt: Scalars['DateTime'];
};

export type HarvestProjectionVarietyType = {
  __typename?: 'HarvestProjectionVarietyType';
  actualContainers: Scalars['Decimal'];
  actualYieldMt: Scalars['Decimal'];
  areaAcre: Scalars['Decimal'];
  estimatedContainers: Scalars['Decimal'];
  estimatedYieldMt: Scalars['Decimal'];
  harvestPlots: Scalars['Int'];
  totalPlots: Scalars['Int'];
  varietyCount: Scalars['Int'];
  varietyGroupCount: Scalars['Int'];
  varietyId: Scalars['ID'];
  varietyName: Scalars['String'];
};

export type HarvestProjectionWeekType = {
  __typename?: 'HarvestProjectionWeekType';
  actualContainers: Scalars['Decimal'];
  actualYieldMt: Scalars['Decimal'];
  areaAcre: Scalars['Decimal'];
  estimatedContainers: Scalars['Decimal'];
  estimatedYieldMt: Scalars['Decimal'];
  harvestPlots: Scalars['Int'];
  totalPlots: Scalars['Int'];
  varieties: Array<Maybe<HarvestProjectionVarietyType>>;
  varietyCount: Scalars['Int'];
  varietyGroupCount: Scalars['Int'];
  weekEnd: Scalars['Date'];
  weekNumber: Scalars['Int'];
  weekStart: Scalars['Date'];
  year: Scalars['Int'];
};

export type HoldingAreaType = {
  __typename?: 'HoldingAreaType';
  codename: Scalars['String'];
  currentDepartment?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  preferredDepot?: Maybe<DepotType>;
};

export type InsuranceDetailType = {
  __typename?: 'InsuranceDetailType';
  id: Scalars['ID'];
  idNumber: Scalars['String'];
  issuedOn: Scalars['Date'];
  name: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  user?: Maybe<DeliveryAgentManagementType>;
  validTill: Scalars['Date'];
  vehicleSet: Array<VehicleType>;
};

export type InwardAllocationInput = {
  delete?: InputMaybe<Scalars['Boolean']>;
  holdingAreaId?: InputMaybe<Scalars['ID']>;
  inwardId: Scalars['ID'];
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  plotCommoditySampleId?: InputMaybe<Scalars['ID']>;
};

export type InwardAllocationType = {
  __typename?: 'InwardAllocationType';
  allottedSku?: Maybe<Scalars['Int']>;
  allottedWeight?: Maybe<Scalars['Decimal']>;
  availableSkusCount?: Maybe<Scalars['Int']>;
  availableWeight?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  ggn?: Maybe<Scalars['String']>;
  holdingArea?: Maybe<HoldingAreaType>;
  id: Scalars['ID'];
  inward: InwardType;
  metadata: Scalars['JSONString'];
  packingallotmentSet: Array<PackingAllotmentSelectorType>;
  plotCommoditySample?: Maybe<PlotCommoditySampleType>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum InwardAmcChargeKind {
  /** ZFGP */
  ZFGP = 'ZFGP',
  /** ZFGQ */
  ZFGQ = 'ZFGQ',
  /** ZFGV */
  ZFGV = 'ZFGV'
}

export type InwardBatchInput = {
  codename?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['Int']>;
  grossWeight?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  skuCount?: InputMaybe<Scalars['Int']>;
  skuTareWeight?: InputMaybe<Scalars['Float']>;
  skuType?: InputMaybe<Scalars['Int']>;
  uomCount?: InputMaybe<Scalars['Float']>;
  uomType?: InputMaybe<Scalars['ID']>;
};

export type InwardQualityInput = {
  id?: InputMaybe<Scalars['ID']>;
  qualityRejection?: InputMaybe<Scalars['Float']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum InwardStatus {
  /** Completed */
  CMP = 'CMP',
  /** On Hold */
  HLD = 'HLD',
  /** Not Started */
  NST = 'NST',
  /** Rejected */
  RJC = 'RJC'
}

export type InwardStatusLogType = {
  __typename?: 'InwardStatusLogType';
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  fromStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inward: InwardType;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type InwardSummary = {
  __typename?: 'InwardSummary';
  acceptedWeight?: Maybe<Scalars['Float']>;
  averageQualityRejection?: Maybe<Scalars['Float']>;
  averageStandardRejection?: Maybe<Scalars['Float']>;
  grossWeight?: Maybe<Scalars['Float']>;
  inwardedBookings?: Maybe<Scalars['Int']>;
  inwardedQuantity?: Maybe<Scalars['Int']>;
  inwardedTrips?: Maybe<Scalars['Int']>;
  netWeight?: Maybe<Scalars['Float']>;
  rejectedWeight?: Maybe<Scalars['Float']>;
  scheduledBookings?: Maybe<Scalars['Int']>;
  scheduledQuantity?: Maybe<Scalars['Int']>;
  scheduledTrips?: Maybe<Scalars['Int']>;
};

export type InwardType = {
  __typename?: 'InwardType';
  amcChargeAmount?: Maybe<Scalars['Float']>;
  amcChargeBournBy?: Maybe<DeliveryAgentManagementType>;
  amcChargeKind?: Maybe<InwardAmcChargeKind>;
  booking: BookingType;
  createdBy?: Maybe<DeliveryAgentManagementType>;
  date: Scalars['Date'];
  grade: HarvestGradeType;
  grn: Scalars['String'];
  id: Scalars['ID'];
  inwardallocationSet: Array<InwardAllocationType>;
  metadata: Scalars['JSONString'];
  payableAmount?: Maybe<Scalars['Float']>;
  purchaseOrder?: Maybe<PurchaseOrderItemType>;
  quality?: Maybe<QualitySampleType>;
  rstNo?: Maybe<Scalars['String']>;
  serialNo?: Maybe<Scalars['String']>;
  setuTradeItemId?: Maybe<Scalars['Int']>;
  status: InwardStatus;
  statusLogs?: Maybe<Array<Maybe<InwardStatusLogType>>>;
  weigh: WeighType;
};


export type InwardTypeStatusLogsArgs = {
  status?: InputMaybe<Scalars['String']>;
};

export type ItemAggregateType = {
  __typename?: 'ItemAggregateType';
  deliveredAmount?: Maybe<Scalars['Float']>;
  deliveredQuantity?: Maybe<Scalars['Int']>;
  rejectedAmount?: Maybe<Scalars['Float']>;
  rejectedQuantity?: Maybe<Scalars['Int']>;
  totalAmount?: Maybe<Scalars['Float']>;
  totalQuantity?: Maybe<Scalars['Int']>;
};

export type KycDetailInput = {
  id?: InputMaybe<Scalars['Int']>;
  idNumber?: InputMaybe<Scalars['String']>;
  kycType?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTill?: InputMaybe<Scalars['Date']>;
};

export type KycDetailType = {
  __typename?: 'KYCDetailType';
  id: Scalars['ID'];
  idNumber: Scalars['String'];
  kycType: KycGraphType;
  photo?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  signedPhoto?: Maybe<Scalars['String']>;
  user: DeliveryAgentManagementType;
  validFrom?: Maybe<Scalars['Date']>;
  validTill?: Maybe<Scalars['Date']>;
};

export type KycGraphType = {
  __typename?: 'KYCGraphType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  kycdetailSet: Array<KycDetailType>;
  name: Scalars['String'];
};

export type KnowYourFarmerOutput = {
  __typename?: 'KnowYourFarmerOutput';
  farmArea?: Maybe<Scalars['Float']>;
  farmLocation?: Maybe<AddressOutput>;
  farmerName?: Maybe<Scalars['String']>;
  harvestingDate?: Maybe<Scalars['Date']>;
  organisationContact?: Maybe<Scalars['String']>;
  organisationEmail?: Maybe<Scalars['String']>;
  organisationLink?: Maybe<Scalars['String']>;
  organisationName?: Maybe<Scalars['String']>;
  organisationPhoto?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  sowingDate?: Maybe<Scalars['Date']>;
  varietyName?: Maybe<Scalars['String']>;
};

export type LicenceDetailType = {
  __typename?: 'LicenceDetailType';
  id: Scalars['ID'];
  idNumber: Scalars['String'];
  issuedOn: Scalars['Date'];
  photo?: Maybe<Scalars['String']>;
  user: DeliveryAgentManagementType;
  validTill: Scalars['Date'];
};

export type LinePackingAllotmentInput = {
  assignedWt?: InputMaybe<Scalars['Decimal']>;
  availableWt?: InputMaybe<Scalars['Decimal']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  packingAllotmentId: Scalars['ID'];
  productionCreatedDate?: InputMaybe<Scalars['Date']>;
  rejectionBoxCount?: InputMaybe<Scalars['Int']>;
  rejectionWt?: InputMaybe<Scalars['Decimal']>;
};

export type LinePackingAllotmentType = {
  __typename?: 'LinePackingAllotmentType';
  assignedWt?: Maybe<Scalars['Float']>;
  availableWt: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lotCode?: Maybe<Scalars['String']>;
  packingAllotment: PackingAllotmentSelectorType;
  productionCreatedDate: Scalars['Date'];
  productionItem: ProductionItemType;
  rejectionBoxCount: Scalars['Int'];
  rejectionWt: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type LineTradeProfileInput = {
  approvedTradeProfileId: Scalars['ID'];
  assignedWt?: InputMaybe<Scalars['Decimal']>;
  availableWt?: InputMaybe<Scalars['Decimal']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type LineTradeProfileType = {
  __typename?: 'LineTradeProfileType';
  approvedTradeProfile: ApprovedTradeProfileType;
  assignedWt: Scalars['Float'];
  availableWt: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  productionItem: ProductionItemType;
  updatedAt: Scalars['DateTime'];
};

export type LoadingOrderItemBatchInput = {
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  batchStockId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
};

export type LoadingStockMovementMutation = {
  __typename?: 'LoadingStockMovementMutation';
  bookings?: Maybe<Array<Maybe<BookingType>>>;
};

export type LogBeatMutation = {
  __typename?: 'LogBeatMutation';
  beatPlan?: Maybe<BeatPlanType>;
};

export type LogTripStepMutation = {
  __typename?: 'LogTripStepMutation';
  trip?: Maybe<TripType>;
};

export type Login = {
  __typename?: 'Login';
  me?: Maybe<BaseUserType>;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type LogsFilter = {
  cashCollectionSum_Gt?: InputMaybe<Scalars['Float']>;
  chequeCollectionSum_Gt?: InputMaybe<Scalars['Float']>;
};

export type MarketType = {
  __typename?: 'MarketType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  exportcustomerSet: Array<ExportCustomerType>;
  exportcustomervalidationSet: Array<ExportCustomerValidationType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plotcommoditysampleSet: Array<PlotCommoditySampleType>;
};

export type MarketYardType = {
  __typename?: 'MarketYardType';
  address: AddressType;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  pricebenchmarkrecommendationSet: Array<PriceBenchmarkRecommendationType>;
  updatedAt: Scalars['DateTime'];
  varietiesSold: Array<CommodityVarietyType>;
};

export type Me = {
  __typename?: 'Me';
  distributionCentres?: Maybe<Array<Maybe<DistributionCentreType>>>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  user?: Maybe<BaseUserType>;
};

/** An enumeration. */
export enum MediaEntityMediaType {
  /** Folder */
  FLD = 'FLD',
  /** File */
  FLE = 'FLE',
  /** Photo */
  PHT = 'PHT',
  /** Video */
  VDO = 'VDO'
}

export type MediaEntityType = {
  __typename?: 'MediaEntityType';
  address?: Maybe<AddressType>;
  approvals: Array<StockTakeApprovalRequestType>;
  bankdetailSet: Array<BankDetailType>;
  beatSet: Array<BeatType>;
  beatplanSet: Array<BeatPlanType>;
  beatvisitSet: Array<BeatVisitType>;
  billingdocSet: Array<BillingDocType>;
  bookingSet: Array<BookingType>;
  certificationSet: Array<GeneralCertificationType>;
  contractSet: Array<ContractType>;
  createdAt: Scalars['DateTime'];
  demandSet: Array<DemandType>;
  despatchesByDriver: Array<BookingType>;
  discountImages: Array<DiscountType>;
  distributionCentres: Array<DistributionCentreType>;
  expenseSet: Array<ExpenseType>;
  id: Scalars['ID'];
  mediaType: MediaEntityMediaType;
  orderItems: Array<OrderItemType>;
  orderitembatchSet: Array<OrderItemBatchType>;
  ordertransactionSet: Array<OrderTransactionType>;
  packagingmaterialSet: Array<PackagingMaterialType>;
  paymentSet: Array<PaymentType>;
  pricebenchmarkdataSet: Array<PriceBenchmarkDataType>;
  primarySellableItems: Array<SellableItemType>;
  reviews: Array<SellableItemReviewType>;
  secondarySellableItems: Array<SellableItemType>;
  sellableItemGroups: Array<SellableItemGroupType>;
  stockentryitemSet: Array<StockEntryItemType>;
  /** Media files */
  transactionSet: Array<TransactionGraphType>;
  tripsEndOdometer: Array<TripType>;
  tripsStartOdometer: Array<TripType>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  vehicleSet: Array<VehicleType>;
};

export type MediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  mediaType: Scalars['String'];
  url: Scalars['String'];
};

export type MetabaseUrlInput = {
  dashboard?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['Int']>;
};

export type MetabaseUrlType = {
  __typename?: 'MetabaseURLType';
  iframeUrl?: Maybe<Scalars['String']>;
};

export type MigratePlotMutation = {
  __typename?: 'MigratePlotMutation';
  schedules?: Maybe<Array<Maybe<ScheduleType>>>;
};

export type MinimalVehicleInput = {
  driver?: InputMaybe<PureBaseUserInput>;
  id?: InputMaybe<Scalars['Int']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['Int']>;
};

export type MultiOrderPaymentSettleMutation = {
  __typename?: 'MultiOrderPaymentSettleMutation';
  orderTransactions: Array<Maybe<OrderTransactionType>>;
  paymentId: Scalars['UUID'];
};

export type MutationRoot = {
  __typename?: 'MutationRoot';
  addAccountTransaction?: Maybe<AddAccountTransactionMutation>;
  addBenchmark?: Maybe<AddUpdateBenchmarkData>;
  addBenchmarkRecommendation?: Maybe<AddPriceBenchmarkRecommendation>;
  addBulkApproveTradeProfile?: Maybe<BulkApproveTradeProfilesPayload>;
  addCompany?: Maybe<AddCompanyMutation>;
  addDemand?: Maybe<AddDemandMutation>;
  /** This is used only for addition of DC */
  addDistributionCentre?: Maybe<AddDistributionCentreMutation>;
  addFarmer?: Maybe<AddUpdateFarmerMutation>;
  addGroup?: Maybe<AddGroupMutation>;
  addNewBooking?: Maybe<AddNewBookingMutation>;
  addNotification?: Maybe<AddNotificationMutation>;
  addOneAssignedRoutePoint?: Maybe<AddOneAssignedRoutePointMutation>;
  /** Approve a grade price and optionally update its schedule's crop group and grade. */
  addPriceToGradePrice?: Maybe<AddPriceToGradePriceMutation>;
  addQuickVehicle?: Maybe<AddUpdateQuickVehicleMutation>;
  addRemarkProductionItem?: Maybe<AddRemarkProductionItem>;
  addStockTransaction?: Maybe<AddStockTransactionMutation>;
  addTemporaryOrder?: Maybe<AddTemporaryOrder>;
  addTransportDetail?: Maybe<AddUpdateScheduleTransportMutation>;
  addUpdateBatchInward?: Maybe<AddUpdateBatchInwardMutation>;
  addUpdateBatchStock?: Maybe<AddUpdateBatchStockMutation>;
  addUpdateBeat?: Maybe<AddUpdateBeatMutation>;
  addUpdateBeatVisit?: Maybe<AddUpdateBeatVisitMutation>;
  addUpdateBeatVisitAction?: Maybe<AddUpdateBeatVisitActionsMutation>;
  addUpdateBulkInward?: Maybe<AddUpdateBulkInwardMutation>;
  addUpdateBusiness?: Maybe<AddUpdateBusinessRegistrationMutation>;
  addUpdateBusinessPointsOfContacts?: Maybe<AddUpdateBusinessPointOfContacts>;
  addUpdateConsolidatedOrder?: Maybe<AddUpdateConsolidatedOrderMutation>;
  /** Create or update a credit facility for a user. */
  addUpdateCredit?: Maybe<AddUpdateCreditMutation>;
  addUpdateCropVariety?: Maybe<AddUpdateCropVariety>;
  addUpdateDcStockTakeConfig?: Maybe<AddUpdateDcStockTakeConfigMuation>;
  addUpdateDcStorageLocation?: Maybe<AddUpdateDcStorageLocationMutation>;
  addUpdateDeliveryBatch?: Maybe<AddUpdateDeliveryBatchMutation>;
  addUpdateDepartment?: Maybe<AddUpdateDepartmentMutation>;
  addUpdateDepotMutation?: Maybe<AddUpdateDepotMutation>;
  /** Affects VehicleTransportDetail, Schedule, Trip, Booking */
  addUpdateDispatch?: Maybe<AddUpdateDispatchMutation>;
  addUpdateDock?: Maybe<AddUpdateDockMutation>;
  addUpdateDockDetail?: Maybe<AddUpdateDockDetailMutation>;
  addUpdateInwardAllocation?: Maybe<AddUpdateInwardAllocationMutation>;
  addUpdateLoadingBatch?: Maybe<AddUpdateLoadingBatchMutation>;
  addUpdateNotificationTemplate?: Maybe<AddUpdateNotificationTemplateMutation>;
  addUpdateNotificationTemplateV1?: Maybe<AddUpdateNotificationTemplateV1>;
  /** BaseUser, Contact, KYCDetail, BankDetail */
  addUpdateOnlyFarmer?: Maybe<AddUpdateBasicFarmerMutation>;
  addUpdateOnlyPlot?: Maybe<AddUpdateBasicPlotMutation>;
  addUpdateOrderTransaction?: Maybe<AddUpdateOrderTransactionMutation>;
  addUpdateOrderTransactions?: Maybe<AddUpdateOrderTransactionsMutation>;
  addUpdatePackagingMaterial?: Maybe<AddUpdatePackagingMaterialMutation>;
  addUpdatePackingAllotment?: Maybe<AddUpdatePackingAllotmentMutation>;
  addUpdatePlotSample?: Maybe<AddPlotCommoditySampleMutation>;
  /**
   * Single mutation to create/update/delete a Production with nested items & children.
   *
   * Behavior:
   * - If input.id is present -> update that Production; else create a new one.
   * - If input.delete=True and id provided -> hard delete Production (cascade).
   * - For items and their children:
   *     - id absent & delete False -> create
   *     - id present & delete False -> update
   *     - id present & delete True  -> delete
   *     (New + delete is ignored)
   */
  addUpdateProduction?: Maybe<AddUpdateProduction>;
  addUpdateQualitySample?: Maybe<AddUpdateQualitySampleMutation>;
  addUpdateQualitySampleMinimal?: Maybe<AddUpdateQualitySampleMinimalMutation>;
  addUpdateReportTemplate?: Maybe<AddUpdateReportTemplate>;
  addUpdateReview?: Maybe<AddUpdateReviewMutation>;
  addUpdateRoute?: Maybe<AddUpdateRouteMutation>;
  addUpdateRouteAssignment?: Maybe<AddUpdateRouteAssignmentMutation>;
  addUpdateSavedAddress?: Maybe<AddUpdateAddressMutation>;
  /**
   * Add/Update Sellable Item mutaiton. The mutaiton will also populate taxes data from base
   * sellable_item if the current sellable_item is a variant.
   */
  addUpdateSellableItem?: Maybe<AddUpdateSellableItemMutation>;
  addUpdateSellableItemStock?: Maybe<AddUpdateSellableItemStockMutation>;
  addUpdateShop?: Maybe<AddUpdateShopRegistrationMutation>;
  addUpdateShopPointsOfContacts?: Maybe<AddUpdateShopPointOfContacts>;
  addUpdateSkuType?: Maybe<AddUpdateSkuTypeMutation>;
  addUpdateStockEntryItems?: Maybe<AddUpdateStockEntryItemsMutation>;
  /** Used for updating the status of the approval requests. */
  addUpdateStockTakeApproval?: Maybe<AddUpdateStockTakeApprovalMutation>;
  /** This mutation creates beat for assignee for current date if current date false in recurrence. */
  addUpdateSupBeat?: Maybe<AddUpdateSupBeatMutation>;
  addUpdateSurveyArea?: Maybe<AddUpdateSurveyAreaMutation>;
  addUpdateUnloadingBatch?: Maybe<AddUpdateUnloadingBatchMutation>;
  addUpdateVarientFromBatchStock?: Maybe<AddUpdateVariantFromBatchStockMutation>;
  addUpdateVehicle?: Maybe<AddUpdateVehicleMutation>;
  addUpdateVehicleCertifications?: Maybe<AddUpdateVehicleCertificationMutation>;
  addUpdateVehicleContract?: Maybe<AddUpdateVehicleContract>;
  addUpdateVehicleDimensions?: Maybe<AddUpdateVehicleDiemnsionsMutation>;
  addUpdateVehicleDriver?: Maybe<AddUpdateVehicleDriverMutation>;
  addUpdateVehicleOwner?: Maybe<AddUpdateVehicleOwnerMutation>;
  /** BaseUser, Contact, KYCDetail */
  addUpdateVendor?: Maybe<AddUpdateBasicVendorMutation>;
  addUser?: Maybe<AddOrUpdateUserMutation>;
  addVehicleExpense?: Maybe<AddVehicleExpenseMutation>;
  addVehiclePayment?: Maybe<AddVehiclePaymentMutation>;
  addVendorToAssignment?: Maybe<AddVendorToAssignmentMutation>;
  applyDiscount?: Maybe<ApplyDiscountMutation>;
  approveReturnRequest?: Maybe<ApproveReturnRequestMutation>;
  bulkAddGateLogs?: Maybe<BulkAddGateLogsMutation>;
  bulkAddVehicleDepartment?: Maybe<BulkAddVehicleDepartmentMutation>;
  /** Deprecated! */
  bulkAssignment?: Maybe<BulkAssignmentMutation>;
  bulkOrderItemApproval?: Maybe<BulkOrderItemApproval>;
  bulkPaymentSettle?: Maybe<BulkPaymentSettleMutation>;
  bulkSkuSettle?: Maybe<BulkSkuSettleMutation>;
  bulkStockSettle?: Maybe<BulkStockSettleMutation>;
  /** Used for creating approval requests based on stock entry items. */
  bulkStockTakeApproval?: Maybe<BulkStockTakeApprovalMutation>;
  bulkTripSettle?: Maybe<BulkTripSettleMutation>;
  bulkUpdateDepartmentMetadata?: Maybe<BulkUpdateDepartmentMetadataMutation>;
  bulkUpdateDriverApproval?: Maybe<BulkUpdateDriverApprovalMutation>;
  bulkUpdateOrder?: Maybe<BulkUpdateOrderMutation>;
  bulkUpdatePlotCommodity?: Maybe<BulkUpdatePlotCommodityMutation>;
  bulkUpdateShop?: Maybe<BulkUpdateShopMutation>;
  bulkUpdateUserRefById?: Maybe<BulkUpdateUserRefByIdMutation>;
  bulkUpdateUsers?: Maybe<BulkUpdateUsersMutation>;
  bulkUpdateVehicleStatus?: Maybe<BulkUpdateVehicleStatusMutation>;
  bulkUpdateVehicleUsers?: Maybe<BulkUpdateVehicleUsersMutation>;
  cashHandover?: Maybe<CashHandoverMutation>;
  changePassword?: Maybe<ChangePasswordMutation>;
  /** Cash deposition mutation */
  createBulkTransaction?: Maybe<CreateBulkTransactionMutation>;
  createFuelDistributor?: Maybe<CreateFuelDistributor>;
  createFuelDistributorItem?: Maybe<CreateFuelDistributorItem>;
  createReturnRequest?: Maybe<CreateReturnRequestMutation>;
  createUpdateShipmentPlan?: Maybe<CreateUpdateShipmentPlan>;
  delBaseUser?: Maybe<DelBaseUserMutation>;
  delDepartment?: Maybe<DelDepartmentMutation>;
  delGroup?: Maybe<DelGroupMutation>;
  delPlotSchedules?: Maybe<DelPlotSchedulesMutation>;
  delSchedules?: Maybe<DelScheduleMutation>;
  delSkuType?: Maybe<DelSkuTypeMutation>;
  delVehicle?: Maybe<DelVehicleMutation>;
  deleteAssignedRoutePoint?: Maybe<DeleteAssignedRoutePointMutation>;
  deleteBankDetail?: Maybe<DeleteBankDetail>;
  deleteBaseUserAddress?: Maybe<DeleteBaseUserAddressMutation>;
  deleteCertification?: Maybe<DeleteCertification>;
  deleteInwards?: Maybe<DeleteInwardsMutation>;
  deleteMedia?: Maybe<DeleteMedia>;
  deleteOrders?: Maybe<DeleteOrdersMutation>;
  deleteSurveyArea?: Maybe<DeleteSurveyArea>;
  /** Deprecated! */
  deliverBooking?: Maybe<DeliverBookingMutation>;
  deliverOrder?: Maybe<DeliverOrderMutation>;
  deliveryStockMovement?: Maybe<DeliveryStockMovementMutation>;
  /** Deprecated! */
  dockAssign?: Maybe<DockAssignMutation>;
  driverLoadingVerification?: Maybe<DriverLoadingVerificationMutation>;
  farmerGroupAndCompany?: Maybe<UpdateFarmerGroupAndCompanyMutation>;
  fetchBatchStock?: Maybe<FetchBatchStockMutation>;
  generatePo?: Maybe<GeneratePoMutation>;
  /** Mutation to generate trips and bookings from schedule data */
  generateTrip?: Maybe<GenerateTripMutation>;
  loadingStockMovement?: Maybe<LoadingStockMovementMutation>;
  logBeat?: Maybe<LogBeatMutation>;
  logTripStep?: Maybe<LogTripStepMutation>;
  login?: Maybe<Login>;
  migratePlot?: Maybe<MigratePlotMutation>;
  multiOrderPaymentSettle?: Maybe<MultiOrderPaymentSettleMutation>;
  newAccountTransaction?: Maybe<NewAccountTransactionMutation>;
  newSchedule?: Maybe<AddNewScheduleMutation>;
  newScheduleRequest?: Maybe<NewScheduleRequestMutation>;
  optimizeSchedules?: Maybe<OptimizeSchedulesMutation>;
  orderItemApproval?: Maybe<OrderItemApproval>;
  orderTransactionApproval?: Maybe<OrderTransactionApprovalMutation>;
  /** Mutation to load collected crates for a booking */
  pickupBooking?: Maybe<PickupBookingMutation>;
  /**
   * for deposit confirmation:
   *     filter: status=TransactionStatus.CREATED, transaction_type="BANK_DEPOSIT"
   *     update: status=TransactionStatus.AUTHORIZED
   * for deposit reconciliation:
   *     filter: status=TransactionStatus.AUTHORIZED, transaction_type="BANK_DEPOSIT"
   *     update: status=TransactionStatus.SUCCESS/TransactionStatus.FAILED
   */
  reconcileBulkTransaction?: Maybe<ReconcileBulkTransactionMutation>;
  /** Deprecated! */
  refreshOtp?: Maybe<RefreshOtpMutation>;
  refreshToken?: Maybe<Refresh>;
  registerTogoFarmer?: Maybe<RegisterTogoFarmerMutation>;
  rejectReturnRequest?: Maybe<RejectReturnRequestMutation>;
  removeM2mFieldLink?: Maybe<RemoveM2MFieldLink>;
  /**
   * This mutation will modify RDATE and EXDATE in rrule according to include_date, exclude_date passed.
   * NOTE: EXRULES will always override the include_date or RDATE, Reccurence will not be generated for RDATE if it falls in EXRULES condition.
   */
  replaceRrule?: Maybe<ReplaceRruleMutation>;
  /**
   * Mutation to restock (reverse) assigned weights from LineTradeProfile and LinePackingAllotment.
   *
   * Behavior:
   * - Takes lists of LineTradeProfile IDs and LinePackingAllotment IDs.
   * - For each LineTradeProfile:
   *     - Adds its assigned_wt back to ApprovedTradeProfile.available_yield.
   *     - Deletes the LineTradeProfile.
   * - For each LinePackingAllotment:
   *     - Adds its assigned_wt back to PackingAllotment.available_wt.
   *     - Deletes the LinePackingAllotment.
   */
  restockProduction?: Maybe<RestockProduction>;
  retriggerNotification?: Maybe<RetriggerNotificationMutation>;
  reverseVarientBatchStock?: Maybe<ReverseVariantBatchStockMutation>;
  salesmanHandoverReturnOrder?: Maybe<SalesmanHandoverReturnOrderMutation>;
  salesmanPickupReturnOrder?: Maybe<SalesmanPickupReturnOrderMutation>;
  sapPlatformPricing?: Maybe<SapPlatformPricingMutation>;
  scheduleRequestApproval?: Maybe<ScheduleRequestDeviationMutation>;
  sendNotification?: Maybe<SendNotificationMutation>;
  sendPackagingMaterialWhatsappApproval?: Maybe<SendPackagingMaterialWhatsappApprovalMutation>;
  stockTakeStockMovement?: Maybe<StockTakeStockMovementMutation>;
  switchDepartment?: Maybe<SwitchDepartmentMutation>;
  triggerNotification?: Maybe<TriggerNotificationMutation>;
  unloadingStockMovement?: Maybe<UnLoadingStockMovementMutation>;
  updateBooking?: Maybe<UpdateBookingMutation>;
  updateBulkDemands?: Maybe<UpdateBulkDemandMutation>;
  updateDeliveredQuantity?: Maybe<UpdateDeliveredQuantityMutation>;
  /** This is used only for updation of DC */
  updateDistributionCentre?: Maybe<UpdateDistributionCentreMutation>;
  updateFuelDistributor?: Maybe<UpdateFuelDistributor>;
  updateFuelDistributorItem?: Maybe<UpdateFuelDistributorItem>;
  updateLinePackingAllotmentLotCode?: Maybe<UpdateLinePackingAllotmentLotCode>;
  updateOrder?: Maybe<UpdateOrderMutation>;
  updatePeriodicTasks?: Maybe<UpdatePeriodicTasks>;
  updateSchedule?: Maybe<UpdateScheduleMutation>;
  updateTripDetails?: Maybe<UpdateTripDetailsMutation>;
  updateUserProfile?: Maybe<UpdateUserProfileMutation>;
  /** Deprecated! */
  vehicalLoadingList?: Maybe<VehicleLoadingMutation>;
  vehiclePickupReturnOrder?: Maybe<VehiclePickupReturnOrderMutation>;
  /** Deprecated! */
  verifyDispatchOtp?: Maybe<VerifyOtpMutation>;
  verifyToken?: Maybe<Verify>;
};


export type MutationRootAddAccountTransactionArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  orderId?: InputMaybe<Scalars['ID']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['ID']>;
  transactionType?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddBenchmarkArgs = {
  commodityGroupId: Scalars['ID'];
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['ID']>;
  marketYardId: Scalars['ID'];
  priceData?: InputMaybe<Array<InputMaybe<PriceBenchmarkDataInput>>>;
  recordedAt?: InputMaybe<AddressInput>;
  seller?: InputMaybe<SellerInput>;
};


export type MutationRootAddBenchmarkRecommendationArgs = {
  averagePrice: PriceInput;
  benchmarkType: Scalars['String'];
  benchmarkedAt: AddressInput;
  benchmarkingDoneInId?: InputMaybe<Scalars['ID']>;
  commodityGroupId: Scalars['ID'];
  date: Scalars['Date'];
  gradeId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  marketYardId: Scalars['ID'];
  recommendedPrice: PriceInput;
};


export type MutationRootAddBulkApproveTradeProfileArgs = {
  input: BulkApproveTradeProfilesInput;
};


export type MutationRootAddCompanyArgs = {
  codename?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddDemandArgs = {
  allowAggregatorVehicle?: InputMaybe<Scalars['Boolean']>;
  allowOwnVehicle?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  bookingQuantityLimit?: InputMaybe<Scalars['Float']>;
  broadcastTime?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyVisibility?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  dateRange?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  depot?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  gradePrices?: InputMaybe<Array<InputMaybe<BookingGradePriceInput>>>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<Scalars['String']>;
  plotCommodityId?: InputMaybe<Scalars['ID']>;
  shouldConsolidate?: InputMaybe<Scalars['Boolean']>;
  timeSlots?: InputMaybe<Array<InputMaybe<TimeSlotRequirementInput>>>;
  varietyGroup?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddDistributionCentreArgs = {
  address?: InputMaybe<AddressInput>;
  allowedDepartments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  alternateSalesSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  areaCatered?: InputMaybe<Scalars['Geometry']>;
  assignedCpcId?: InputMaybe<Scalars['NullableID']>;
  bankDetails?: InputMaybe<Array<InputMaybe<BankDetailInput>>>;
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  colorCode?: InputMaybe<Scalars['String']>;
  companyCode?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryConditions?: InputMaybe<DeliveryConditionInput>;
  deliverySlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maintenanceSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  name?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  pickupSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  plantCode: Scalars['String'];
  pointOfContacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  primaryPocId?: InputMaybe<Scalars['NullableID']>;
  salesOfcCode?: InputMaybe<Scalars['String']>;
  storeCode: Scalars['String'];
  useCreditFeature?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRootAddFarmerArgs = {
  farmer?: InputMaybe<FarmerDetailInput>;
  plots?: InputMaybe<Array<InputMaybe<PlotInput>>>;
};


export type MutationRootAddGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type MutationRootAddNewBookingArgs = {
  destinationDepot: Scalars['ID'];
  plotCommodityId: Scalars['ID'];
  requiredQuantity: Scalars['Int'];
  skuType: Scalars['ID'];
  sourceDepot?: InputMaybe<Scalars['ID']>;
  tripUuid: Scalars['String'];
};


export type MutationRootAddNotificationArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  instanceType?: InputMaybe<Scalars['String']>;
  messegeType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['ID']>;
  templateId: Scalars['ID'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootAddOneAssignedRoutePointArgs = {
  assignmentId: Scalars['ID'];
  sequence?: InputMaybe<Scalars['String']>;
  visiteeId: Scalars['ID'];
};


export type MutationRootAddPriceToGradePriceArgs = {
  cropGroupId?: InputMaybe<Scalars['ID']>;
  gradeId?: InputMaybe<Scalars['ID']>;
  gradePriceId: Scalars['Int'];
  price: Scalars['Float'];
};


export type MutationRootAddQuickVehicleArgs = {
  driver?: InputMaybe<PureBaseUserInput>;
  owner?: InputMaybe<Scalars['Int']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  vehicleKind?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['Int']>;
};


export type MutationRootAddRemarkProductionItemArgs = {
  input: AddRemarkProductionItemInput;
};


export type MutationRootAddStockTransactionArgs = {
  destinationBucket?: InputMaybe<Scalars['String']>;
  destinationStockId?: InputMaybe<Scalars['ID']>;
  recordedInId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  sourceBucket?: InputMaybe<Scalars['String']>;
  sourceStockId?: InputMaybe<Scalars['ID']>;
  transferAmount: Scalars['Int'];
};


export type MutationRootAddTemporaryOrderArgs = {
  billingAddress?: InputMaybe<AddressInput>;
  customDiscountFlat?: InputMaybe<Scalars['Float']>;
  customDiscountPercent?: InputMaybe<Scalars['Float']>;
  discountId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderCategory?: InputMaybe<Scalars['String']>;
  orderItems: Array<InputMaybe<OrderItemStockInput>>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  pickupSlots?: InputMaybe<Array<InputMaybe<OrderPickupSlotInput>>>;
  pocName?: InputMaybe<Scalars['String']>;
  pocNumber?: InputMaybe<Scalars['String']>;
  salesInchargeId?: InputMaybe<Scalars['ID']>;
  shippingAddress?: InputMaybe<AddressInput>;
  shippingMethod: Scalars['String'];
  skipDms?: InputMaybe<Scalars['Boolean']>;
  skipDmsWithDispatch?: InputMaybe<Scalars['Boolean']>;
  sourceStock?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddTransportDetailArgs = {
  acceptedDeduction?: InputMaybe<Scalars['Float']>;
  advanceCost?: InputMaybe<Scalars['Float']>;
  advancePaidBy?: InputMaybe<Scalars['String']>;
  gradePrices?: InputMaybe<Array<InputMaybe<GradePriceInput>>>;
  id?: InputMaybe<Scalars['Int']>;
  pricingDoneOn?: InputMaybe<Scalars['String']>;
  rejectionBourneBy?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['Int']>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
  transportCost?: InputMaybe<Scalars['Float']>;
  transportPaidBy?: InputMaybe<Scalars['String']>;
  weightApplicable?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateBatchInwardArgs = {
  batches?: InputMaybe<Array<InputMaybe<InwardBatchInput>>>;
  booking?: InputMaybe<Scalars['Int']>;
  expense?: InputMaybe<Scalars['Float']>;
  rstNo?: InputMaybe<Scalars['String']>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  unloadingLocationId?: InputMaybe<Scalars['ID']>;
  unloadingSubLocationId?: InputMaybe<Scalars['ID']>;
  unloadingTeamId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateBatchStockArgs = {
  data: BatchStockInput;
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateBeatArgs = {
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['ID']>;
  plannedEndTime?: InputMaybe<Scalars['DateTime']>;
  plannedInId: Scalars['ID'];
  plannedStartTime?: InputMaybe<Scalars['DateTime']>;
  relatedToId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  salesmanId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  visitCategory?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateBeatVisitArgs = {
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  beatId?: InputMaybe<Scalars['ID']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  leftAt?: InputMaybe<AddressInput>;
  remark?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  visitedAt?: InputMaybe<AddressInput>;
  visiteeId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateBeatVisitActionArgs = {
  actions?: InputMaybe<Array<InputMaybe<BeatVisitActionInput>>>;
  beatVisitId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateBulkInwardArgs = {
  expense?: InputMaybe<Scalars['Float']>;
  grade?: InputMaybe<Scalars['Int']>;
  grossWeight?: InputMaybe<Scalars['Float']>;
  inwardedQuantity?: InputMaybe<Scalars['Int']>;
  rstNo?: InputMaybe<Scalars['String']>;
  skuType?: InputMaybe<Scalars['ID']>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  tareWeight?: InputMaybe<Scalars['Float']>;
  trip?: InputMaybe<Scalars['Int']>;
  unloadingLocationId?: InputMaybe<Scalars['ID']>;
  unloadingSubLocationId?: InputMaybe<Scalars['ID']>;
  unloadingTeamId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateBusinessArgs = {
  address: AddressInput;
  bankDetails?: InputMaybe<BankDetailInput>;
  businessCategoryId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};


export type MutationRootAddUpdateBusinessPointsOfContactsArgs = {
  pointOfContacts: PointOfContactInput;
};


export type MutationRootAddUpdateConsolidatedOrderArgs = {
  category?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['ID']>;
  orderFilter?: InputMaybe<OrderFilterInput>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  orderItems?: InputMaybe<Array<InputMaybe<OrderItemStockInput>>>;
  orderingDcId: Scalars['ID'];
  placedInId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['ID']>;
  targetDcId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRootAddUpdateCreditArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
  paymentCycleDays?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  totalAmount?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['ID']>;
  verificationRemark?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateCropVarietyArgs = {
  commodity?: InputMaybe<Scalars['Int']>;
  estimatedProduce?: InputMaybe<Scalars['Float']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  harvestGrades?: InputMaybe<Array<InputMaybe<HarvestGradeInput>>>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  preferredCertification?: InputMaybe<Scalars['Int']>;
  preferredSku?: InputMaybe<Scalars['Int']>;
  primaryGroupId?: InputMaybe<Scalars['ID']>;
  qualityParameters?: InputMaybe<Array<InputMaybe<QualityParameterInput>>>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
};


export type MutationRootAddUpdateDcStockTakeConfigArgs = {
  distributionCentreId: Scalars['ID'];
  endDay?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['ID']>;
  itemCategory?: InputMaybe<Scalars['String']>;
  startDay?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Time']>;
};


export type MutationRootAddUpdateDcStorageLocationArgs = {
  archive?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  colorCode?: InputMaybe<Scalars['String']>;
  distributionCentreId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  responsiblePersonId: Scalars['ID'];
  subLocations?: InputMaybe<Array<InputMaybe<DcSubLocationInput>>>;
};


export type MutationRootAddUpdateDeliveryBatchArgs = {
  batches?: InputMaybe<Array<InputMaybe<DeliveryOrderItemBatchInput>>>;
  bookingId: Scalars['ID'];
  extraSkus?: InputMaybe<Array<InputMaybe<BookingExtraSkuInput>>>;
};


export type MutationRootAddUpdateDepartmentArgs = {
  allowedDepots?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  controlPricing?: InputMaybe<Scalars['Boolean']>;
  defaultPerUnit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  defaultTraderVarieties?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  departmentType?: InputMaybe<Scalars['String']>;
  generatePoAfterInward?: InputMaybe<Scalars['Boolean']>;
  generatePoPlotWise?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  newGatePass?: InputMaybe<Scalars['Boolean']>;
  photo?: InputMaybe<Scalars['String']>;
  preferredDepot?: InputMaybe<Scalars['Int']>;
  priceApprovalFlow?: InputMaybe<Scalars['Boolean']>;
  pricingDoneOn?: InputMaybe<Scalars['String']>;
  qcSubscription?: InputMaybe<Scalars['Boolean']>;
  togoSubscription?: InputMaybe<Scalars['Boolean']>;
  varieties?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type MutationRootAddUpdateDepotMutationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateDispatchArgs = {
  aggregatorId: Scalars['ID'];
  bookings?: InputMaybe<Array<InputMaybe<DispatchBookingItem>>>;
  date: Scalars['Date'];
  despatchStatus?: InputMaybe<Scalars['String']>;
  destinationDepotId: Scalars['ID'];
  dockId?: InputMaybe<Scalars['ID']>;
  dockSupervisiorId?: InputMaybe<Scalars['ID']>;
  estimatedDespatchTime?: InputMaybe<Scalars['DateTime']>;
  estimatedStartTime: Scalars['DateTime'];
  id?: InputMaybe<Scalars['ID']>;
  labourCount?: InputMaybe<Scalars['Int']>;
  loadingPattern?: InputMaybe<Scalars['String']>;
  organisationUserId: Scalars['ID'];
  sourceDepotId: Scalars['ID'];
  transportDetail?: InputMaybe<VehicleTransportInput>;
  vehicleId: Scalars['ID'];
};


export type MutationRootAddUpdateDockArgs = {
  address?: InputMaybe<AddressInput>;
  archive?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  depotId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateDockDetailArgs = {
  dockId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
  tripId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateInwardAllocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  qualities: InwardAllocationInput;
};


export type MutationRootAddUpdateLoadingBatchArgs = {
  batches?: InputMaybe<Array<InputMaybe<LoadingOrderItemBatchInput>>>;
  bookingId: Scalars['ID'];
  extraSkus?: InputMaybe<Array<InputMaybe<BookingExtraSkuInput>>>;
};


export type MutationRootAddUpdateNotificationTemplateArgs = {
  alias?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateNotificationTemplateV1Args = {
  body?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  dataSourceId?: InputMaybe<Scalars['ID']>;
  dataVariables?: InputMaybe<Scalars['JSONScalar']>;
  description?: InputMaybe<Scalars['String']>;
  extraFields?: InputMaybe<Scalars['JSONScalar']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isProgrammatic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerVariables?: InputMaybe<Scalars['JSONScalar']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateOnlyFarmerArgs = {
  user?: InputMaybe<FarmerInput>;
};


export type MutationRootAddUpdateOnlyPlotArgs = {
  plot?: InputMaybe<FarmerPlotInput>;
};


export type MutationRootAddUpdateOrderTransactionArgs = {
  amount: Scalars['Float'];
  attachment?: InputMaybe<MediaInput>;
  id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  orderId: Scalars['ID'];
  orderStatus?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentVerification?: InputMaybe<Scalars['Boolean']>;
  referenceId?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  tripId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateOrderTransactionsArgs = {
  orderId: Scalars['ID'];
  transactions: Array<InputMaybe<OrderTransactionEntryInput>>;
};


export type MutationRootAddUpdatePackagingMaterialArgs = {
  areaInchargeId?: InputMaybe<Scalars['Int']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  deductionWt?: InputMaybe<Scalars['Float']>;
  deductionWtPercent?: InputMaybe<Scalars['Float']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  farmerId?: InputMaybe<Scalars['Int']>;
  fieldSupervisorId?: InputMaybe<Scalars['Int']>;
  fruitWt?: InputMaybe<Scalars['Float']>;
  harvestingTeamId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  leafWt?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
  packagingMaterialItems?: InputMaybe<Array<InputMaybe<PackagingMaterialItemInput>>>;
  plotVisitorId?: InputMaybe<Scalars['Int']>;
  pmSupervisorId?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  sendWhatsappApproval?: InputMaybe<Scalars['Boolean']>;
  stickWt?: InputMaybe<Scalars['Float']>;
  stickWtPercent?: InputMaybe<Scalars['Float']>;
  supplierType?: InputMaybe<Scalars['String']>;
  totalHarvestWt?: InputMaybe<Scalars['Float']>;
  wasteageWt?: InputMaybe<Scalars['Float']>;
  weightSlip?: InputMaybe<Scalars['Float']>;
};


export type MutationRootAddUpdatePackingAllotmentArgs = {
  allotment: PackingAllotmentInput;
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdatePlotSampleArgs = {
  plotCommodity?: InputMaybe<Scalars['Int']>;
  samples?: InputMaybe<Array<InputMaybe<PlotCommoditySampleInput>>>;
};


export type MutationRootAddUpdateProductionArgs = {
  input: ProductionUpsertInput;
};


export type MutationRootAddUpdateQualitySampleArgs = {
  booking?: InputMaybe<Scalars['Int']>;
  observations?: InputMaybe<Array<InputMaybe<ObservationInput>>>;
  qualityRejection?: InputMaybe<Scalars['Float']>;
  reason?: InputMaybe<Scalars['String']>;
  recordedOn?: InputMaybe<Scalars['DateTime']>;
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateQualitySampleMinimalArgs = {
  qualities?: InputMaybe<Array<InputMaybe<InwardQualityInput>>>;
};


export type MutationRootAddUpdateReportTemplateArgs = {
  columns?: InputMaybe<Array<InputMaybe<ReportTemplateColumn>>>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupsShared?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  sourceId: Scalars['ID'];
  title: Scalars['String'];
  usersShared?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootAddUpdateReviewArgs = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  rating?: InputMaybe<Scalars['Float']>;
  sellableItemId: Scalars['ID'];
};


export type MutationRootAddUpdateRouteArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  colorCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  points?: InputMaybe<Array<InputMaybe<RoutePointInput>>>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateRouteAssignmentArgs = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['ID']>;
  points?: InputMaybe<Array<InputMaybe<RoutePointInput>>>;
  recurrences?: InputMaybe<Scalars['String']>;
  routeId?: InputMaybe<Scalars['ID']>;
  shouldTrack?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  startTime?: InputMaybe<Scalars['Time']>;
};


export type MutationRootAddUpdateSavedAddressArgs = {
  address: AddressInput;
  addressType: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type MutationRootAddUpdateSellableItemArgs = {
  allowedDepartments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  codename?: InputMaybe<Scalars['String']>;
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  id?: InputMaybe<Scalars['ID']>;
  itemGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  longDescription?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<SellableItemMetadataInput>;
  name?: InputMaybe<Scalars['String']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  primaryItemWeight?: InputMaybe<Scalars['Decimal']>;
  primaryPhoto?: InputMaybe<MediaInput>;
  primarySkuCount?: InputMaybe<Scalars['Int']>;
  primarySkuTareWeight?: InputMaybe<Scalars['Decimal']>;
  relatedItemId?: InputMaybe<Scalars['ID']>;
  secondarySkuCount?: InputMaybe<Scalars['Int']>;
  secondarySkuTareWeight?: InputMaybe<Scalars['Decimal']>;
  secondarySkuTypeId?: InputMaybe<Scalars['ID']>;
  sellableVarieties?: InputMaybe<Array<InputMaybe<SellableVarietyInput>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  tertiarySkuCount?: InputMaybe<Scalars['Int']>;
  tertiarySkuTareWeight?: InputMaybe<Scalars['Decimal']>;
  transportationType?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Array<InputMaybe<SellableItemUnitInput>>>;
};


export type MutationRootAddUpdateSellableItemStockArgs = {
  currentStockCount: Scalars['Int'];
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  currentStockType?: InputMaybe<Scalars['String']>;
  discountedRate: Scalars['Float'];
  distributionCentreId: Scalars['ID'];
  expiryDate?: InputMaybe<Scalars['Date']>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  holdStockCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isLive: Scalars['Boolean'];
  maxRate?: InputMaybe<Scalars['Float']>;
  minRate?: InputMaybe<Scalars['Float']>;
  offerStockCount?: InputMaybe<Scalars['Int']>;
  orderingConditions?: InputMaybe<OrderingConditionInput>;
  parentStockId?: InputMaybe<Scalars['ID']>;
  relatedStockId?: InputMaybe<Scalars['ID']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  skuId?: InputMaybe<Scalars['ID']>;
  unitRate: Scalars['Float'];
};


export type MutationRootAddUpdateShopArgs = {
  address: AddressInput;
  allowedCredits?: InputMaybe<Scalars['Float']>;
  category?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  dailySales?: InputMaybe<Scalars['Float']>;
  familyGroupId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  supplySource?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateShopPointsOfContactsArgs = {
  pointOfContacts: PointOfContactInput;
  salesmanId?: InputMaybe<Scalars['ID']>;
  shopId: Scalars['ID'];
};


export type MutationRootAddUpdateSkuTypeArgs = {
  capacity?: InputMaybe<Scalars['Float']>;
  capacityUnitId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  dimensionUnitId?: InputMaybe<Scalars['ID']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['ID']>;
  isReturnable?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
  name?: InputMaybe<Scalars['String']>;
  selfWeight?: InputMaybe<Scalars['Float']>;
  skuCategoryId?: InputMaybe<Scalars['ID']>;
  stockCount?: InputMaybe<Scalars['Int']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
};


export type MutationRootAddUpdateStockEntryItemsArgs = {
  stockEntryItems?: InputMaybe<Array<InputMaybe<StockEntryItemInput>>>;
  takenAt?: InputMaybe<AddressInput>;
};


export type MutationRootAddUpdateStockTakeApprovalArgs = {
  obj?: InputMaybe<StockTakeApprovalRequestInput>;
};


export type MutationRootAddUpdateSupBeatArgs = {
  assignmentId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddUpdateSurveyAreaArgs = {
  areaCatered?: InputMaybe<Scalars['Geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryUserId?: InputMaybe<Scalars['ID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootAddUpdateUnloadingBatchArgs = {
  batches?: InputMaybe<Array<InputMaybe<UnloadingOrderItemBatchInput>>>;
  bookingId: Scalars['ID'];
  extraSkus?: InputMaybe<Array<InputMaybe<BookingExtraSkuInput>>>;
};


export type MutationRootAddUpdateVarientFromBatchStockArgs = {
  batchStockInput: BatchStockInput;
  parentBatchStockId: Scalars['ID'];
  parentSellableItemStockId: Scalars['ID'];
  sellableItemId: Scalars['ID'];
  sellableItemStockInput: SellableItemStockInput;
};


export type MutationRootAddUpdateVehicleArgs = {
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  chassisNumber?: InputMaybe<Scalars['String']>;
  dateBought?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  depotId?: InputMaybe<Scalars['ID']>;
  dimensionUnitId?: InputMaybe<Scalars['ID']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  estimatedAverage?: InputMaybe<Scalars['Float']>;
  fuelTankCapacity?: InputMaybe<Scalars['Float']>;
  fuelTypeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  insurance?: InputMaybe<VehicleInsuranceInput>;
  loadingCapacity?: InputMaybe<Scalars['Float']>;
  modelName?: InputMaybe<Scalars['String']>;
  passengerCapacity?: InputMaybe<Scalars['Float']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  vehicleKind?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateVehicleCertificationsArgs = {
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  insurance?: InputMaybe<VehicleInsuranceInput>;
  vehicleId: Scalars['ID'];
};


export type MutationRootAddUpdateVehicleContractArgs = {
  contractTypeId: Scalars['ID'];
  dailyAllowance?: InputMaybe<Scalars['Float']>;
  endDate: Scalars['Date'];
  entityIssued: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  recurringExpenses?: InputMaybe<Array<InputMaybe<ContractRecurringExpenseInput>>>;
  resourceAmount?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  status: Scalars['String'];
};


export type MutationRootAddUpdateVehicleDimensionsArgs = {
  dimensionUnitId?: InputMaybe<Scalars['ID']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootAddUpdateVehicleDriverArgs = {
  driver?: InputMaybe<VehicleDriverInput>;
};


export type MutationRootAddUpdateVehicleOwnerArgs = {
  owner?: InputMaybe<VehicleOwnerInput>;
};


export type MutationRootAddUpdateVendorArgs = {
  address: AddressInput;
  businessId?: InputMaybe<Scalars['ID']>;
  businessName?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  deleteKycIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  education?: InputMaybe<BaseUserEducationEnum>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<BaseUserGenderEnum>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  kycDetails?: InputMaybe<Array<InputMaybe<KycDetailInput>>>;
  lastName: Scalars['String'];
  number: Scalars['String'];
  referenceId?: InputMaybe<Scalars['String']>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  secondaryNumber?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};


export type MutationRootAddUserArgs = {
  user?: InputMaybe<BaseUserInput>;
};


export type MutationRootAddVehicleExpenseArgs = {
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  borneBy?: InputMaybe<Scalars['String']>;
  contractId: Scalars['ID'];
  expenseFor: Scalars['ID'];
  expenseTypeId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  quantity: Scalars['Float'];
  quantityRate: Scalars['Float'];
  remark?: InputMaybe<Scalars['String']>;
  resourceUsed?: InputMaybe<Scalars['Int']>;
};


export type MutationRootAddVehiclePaymentArgs = {
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  contractId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  paidToId: Scalars['ID'];
  paymentFor: Scalars['ID'];
  paymentTypeId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
};


export type MutationRootAddVendorToAssignmentArgs = {
  assignmentId: Scalars['ID'];
  sequence?: InputMaybe<Scalars['String']>;
  visiteeId: Scalars['ID'];
};


export type MutationRootApplyDiscountArgs = {
  discountCode: Scalars['String'];
  orderId?: InputMaybe<Scalars['ID']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};


export type MutationRootApproveReturnRequestArgs = {
  returnOrders?: InputMaybe<Array<InputMaybe<ApproveReturnRequestInput>>>;
  timeSlotDate?: InputMaybe<Scalars['Date']>;
  timeSlotId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootBulkAddGateLogsArgs = {
  gateLogs: Array<InputMaybe<BulkAddGateLogsInput>>;
};


export type MutationRootBulkAddVehicleDepartmentArgs = {
  departments: Array<InputMaybe<Scalars['ID']>>;
  vehicles: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootBulkAssignmentArgs = {
  dockId?: InputMaybe<Scalars['Int']>;
  dockSupervisorId?: InputMaybe<Scalars['Int']>;
  tripIds: Array<InputMaybe<Scalars['Int']>>;
};


export type MutationRootBulkOrderItemApprovalArgs = {
  approvalStatus?: InputMaybe<Scalars['String']>;
  approvedAt?: InputMaybe<Scalars['DateTime']>;
  approvedBy?: InputMaybe<Scalars['String']>;
  approverRemark?: InputMaybe<Scalars['String']>;
  batchStockRateId: Array<InputMaybe<Scalars['ID']>>;
  ids: Array<InputMaybe<Scalars['ID']>>;
  orderFilter?: InputMaybe<OrderFilterInput>;
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootBulkPaymentSettleArgs = {
  aggregatorId: Scalars['ID'];
  departmentId: Scalars['ID'];
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  paymentMethod: Scalars['String'];
  paymentSettlements: Array<InputMaybe<PaymentSettleInput>>;
  settlementRemark?: InputMaybe<Scalars['String']>;
};


export type MutationRootBulkSkuSettleArgs = {
  aggregatorId: Scalars['ID'];
  settlementRemark?: InputMaybe<Scalars['String']>;
  skuSettlements: Array<InputMaybe<SkuSettleInput>>;
};


export type MutationRootBulkStockSettleArgs = {
  aggregatorId: Scalars['ID'];
  settlementRemark?: InputMaybe<Scalars['String']>;
  stockSettlements: Array<InputMaybe<StockSettleInput>>;
};


export type MutationRootBulkStockTakeApprovalArgs = {
  requestedGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  requestedToUserId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  stockTakeFilter?: InputMaybe<StockEntryItemFilterInput>;
};


export type MutationRootBulkTripSettleArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootBulkUpdateDepartmentMetadataArgs = {
  metadataExcluded: Scalars['JSONString'];
  metadataIncluded: Scalars['JSONString'];
};


export type MutationRootBulkUpdateDriverApprovalArgs = {
  bookings?: InputMaybe<Array<InputMaybe<DriverApprovalInputType>>>;
};


export type MutationRootBulkUpdateOrderArgs = {
  estimatedDelivery?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  orderFilter?: InputMaybe<OrderFilterInput>;
  status?: InputMaybe<Scalars['String']>;
};


export type MutationRootBulkUpdatePlotCommodityArgs = {
  agronomist?: InputMaybe<Scalars['Int']>;
  generatePoPlotWise?: InputMaybe<Scalars['Boolean']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  plotCommodities?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  plotStatus?: InputMaybe<Scalars['String']>;
};


export type MutationRootBulkUpdateShopArgs = {
  salesmanId: Scalars['ID'];
  shopIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootBulkUpdateUserRefByIdArgs = {
  input?: InputMaybe<Array<InputMaybe<BulkUpdateUserRefByIdInput>>>;
};


export type MutationRootBulkUpdateUsersArgs = {
  status: Scalars['String'];
  userIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootBulkUpdateVehicleStatusArgs = {
  status: Scalars['String'];
  vehicles: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootBulkUpdateVehicleUsersArgs = {
  status: Scalars['String'];
  userIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootCashHandoverArgs = {
  amount: Scalars['Float'];
  filters?: InputMaybe<OrderTransactionFilterInput>;
};


export type MutationRootChangePasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationRootCreateBulkTransactionArgs = {
  dcId?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<CreateTransactionInput>>>;
};


export type MutationRootCreateFuelDistributorArgs = {
  batchNo?: InputMaybe<Scalars['String']>;
  fuelDetailAttachment?: InputMaybe<Scalars['String']>;
  fuelRate: Scalars['Float'];
  fuelReceiptAttachment?: InputMaybe<Scalars['String']>;
  fuelStationName?: InputMaybe<Scalars['String']>;
  fuelTypeId?: InputMaybe<Scalars['Int']>;
  quantityFilled: Scalars['Float'];
  remark?: InputMaybe<Scalars['String']>;
  tankerNoId: Scalars['Int'];
};


export type MutationRootCreateFuelDistributorItemArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
  distributedFuelQuantity?: InputMaybe<Scalars['Float']>;
  fuelDistributorId?: InputMaybe<Scalars['Int']>;
  odometerReading?: InputMaybe<Scalars['Float']>;
  odometerReadingAttachment?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootCreateReturnRequestArgs = {
  returnOrders?: InputMaybe<Array<InputMaybe<CreateReturnRequestInput>>>;
  timeSlotDate?: InputMaybe<Scalars['Date']>;
  timeSlotId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootCreateUpdateShipmentPlanArgs = {
  input: ShipmentPlanInput;
};


export type MutationRootDelBaseUserArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootDelDepartmentArgs = {
  departmentId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootDelGroupArgs = {
  groupId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootDelPlotSchedulesArgs = {
  date?: InputMaybe<Scalars['Date']>;
  plotCommodityId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootDelSchedulesArgs = {
  schedules?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type MutationRootDelSkuTypeArgs = {
  skuId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootDelVehicleArgs = {
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationRootDeleteAssignedRoutePointArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationRootDeleteBankDetailArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootDeleteBaseUserAddressArgs = {
  addressId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootDeleteCertificationArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootDeleteInwardsArgs = {
  inwards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootDeleteMediaArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootDeleteOrdersArgs = {
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootDeleteSurveyAreaArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootDeliverBookingArgs = {
  deliveryStatus: Scalars['String'];
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  orderItems?: InputMaybe<Array<InputMaybe<OrderItemInput>>>;
  orderStatus: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootDeliverOrderArgs = {
  deliveryStatus: Scalars['String'];
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  orderItems?: InputMaybe<Array<InputMaybe<OrderItemInput>>>;
  orderStatus: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootDeliveryStockMovementArgs = {
  bookingIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootDockAssignArgs = {
  bookings?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  dockId?: InputMaybe<Scalars['Int']>;
  dockSupervisor?: InputMaybe<Scalars['Int']>;
  documents?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  id?: InputMaybe<Scalars['Int']>;
  loadingPattern?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootDriverLoadingVerificationArgs = {
  bookings?: InputMaybe<Array<InputMaybe<DriverVerificationInput>>>;
  tripId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootFarmerGroupAndCompanyArgs = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationRootFetchBatchStockArgs = {
  date?: InputMaybe<Scalars['String']>;
  interval: Scalars['Int'];
  movementType?: InputMaybe<Scalars['String']>;
  plant?: InputMaybe<Scalars['String']>;
  store?: InputMaybe<Scalars['String']>;
};


export type MutationRootGeneratePoArgs = {
  gradeName?: InputMaybe<Scalars['String']>;
  inwardedQuantity?: InputMaybe<Scalars['Float']>;
  netWeight?: InputMaybe<Scalars['Float']>;
  scheduleId?: InputMaybe<Scalars['ID']>;
  uomCount?: InputMaybe<Scalars['Float']>;
};


export type MutationRootGenerateTripArgs = {
  date?: InputMaybe<Scalars['Date']>;
  schedules?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  schedulesProcured?: InputMaybe<Array<InputMaybe<SchedulesProcuredInput>>>;
};


export type MutationRootLoadingStockMovementArgs = {
  bookingIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootLogBeatArgs = {
  beatAttachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  beatId?: InputMaybe<Scalars['ID']>;
  beatRemark?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  planId: Scalars['ID'];
  planRemark?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  visitLatitude?: InputMaybe<Scalars['Float']>;
  visitLongitude?: InputMaybe<Scalars['Float']>;
  visitTime?: InputMaybe<Scalars['DateTime']>;
};


export type MutationRootLogTripStepArgs = {
  booking?: InputMaybe<Scalars['Int']>;
  formFields?: InputMaybe<Array<InputMaybe<FormFieldInput>>>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  odometerPhoto?: InputMaybe<MediaInput>;
  odometerReading?: InputMaybe<Scalars['Int']>;
  procuredQuantity?: InputMaybe<Scalars['Int']>;
  stepId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  trip?: InputMaybe<Scalars['String']>;
};


export type MutationRootLoginArgs = {
  firebaseToken?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationRootMigratePlotArgs = {
  fromDate?: InputMaybe<Scalars['Date']>;
  plot?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Date']>;
};


export type MutationRootMultiOrderPaymentSettleArgs = {
  aggregatorId: Scalars['ID'];
  amount: Scalars['Decimal'];
  attachment?: InputMaybe<MediaInput>;
  departmentId: Scalars['ID'];
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  orderIds: Array<InputMaybe<Scalars['ID']>>;
  paymentMethod: Scalars['String'];
  settlementRemark?: InputMaybe<Scalars['String']>;
};


export type MutationRootNewAccountTransactionArgs = {
  accountId: Scalars['ID'];
  amount: Scalars['Float'];
  attachment?: InputMaybe<MediaInput>;
  paymentMethodId: Scalars['ID'];
  referenceId?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  transactionId?: InputMaybe<Scalars['String']>;
  transactionTypeId: Scalars['ID'];
};


export type MutationRootNewScheduleArgs = {
  date?: InputMaybe<Scalars['Date']>;
  plotCommodityRequirements?: InputMaybe<Array<InputMaybe<PlotCommodityRequirementInput>>>;
};


export type MutationRootNewScheduleRequestArgs = {
  cropGroupId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  gradePrices?: InputMaybe<Array<InputMaybe<GradePriceInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  plotCommodity?: InputMaybe<Scalars['Int']>;
  priceChangeRequested?: InputMaybe<Scalars['Boolean']>;
  pricingDoneOn?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  skuCount?: InputMaybe<Scalars['Int']>;
  skuType?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  timeSlot?: InputMaybe<Scalars['ID']>;
  totalEstimatedHarvest?: InputMaybe<Scalars['Int']>;
  transportDetail?: InputMaybe<VehicleTransportInput>;
  uomQuantity?: InputMaybe<Scalars['Float']>;
  uomType?: InputMaybe<Scalars['Int']>;
  vehicle?: InputMaybe<MinimalVehicleInput>;
};


export type MutationRootOptimizeSchedulesArgs = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  excludeVehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  scheduleDate?: InputMaybe<Scalars['Date']>;
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  skuTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootOrderItemApprovalArgs = {
  approvalStatus?: InputMaybe<Scalars['String']>;
  approvedAt?: InputMaybe<Scalars['DateTime']>;
  approvedBy?: InputMaybe<Scalars['String']>;
  approverRemark?: InputMaybe<Scalars['String']>;
  batchStockRateId: Scalars['ID'];
  id: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootOrderTransactionApprovalArgs = {
  approvalStatus: Scalars['String'];
  orderTransactionId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootPickupBookingArgs = {
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  pickupTime?: InputMaybe<Scalars['DateTime']>;
  procuredQuantity?: InputMaybe<Scalars['Int']>;
};


export type MutationRootReconcileBulkTransactionArgs = {
  status?: InputMaybe<Scalars['String']>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRootRefreshOtpArgs = {
  tripId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRootRegisterTogoFarmerArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootRejectReturnRequestArgs = {
  returnOrders?: InputMaybe<Array<InputMaybe<RejectReturnRequestInput>>>;
};


export type MutationRootRemoveM2mFieldLinkArgs = {
  field: Scalars['String'];
  fieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  model: Scalars['String'];
  modelId: Scalars['ID'];
};


export type MutationRootReplaceRruleArgs = {
  excludeDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  includeDate?: InputMaybe<Scalars['Date']>;
};


export type MutationRootRestockProductionArgs = {
  input: RestockProductionInput;
};


export type MutationRootRetriggerNotificationArgs = {
  triggerId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootReverseVarientBatchStockArgs = {
  variantBatchStockId: Scalars['ID'];
  variantUnitsToReturn: Scalars['Int'];
};


export type MutationRootSalesmanHandoverReturnOrderArgs = {
  returnOrders?: InputMaybe<Array<InputMaybe<HandoverReturnOrderInput>>>;
};


export type MutationRootSalesmanPickupReturnOrderArgs = {
  returnOrders?: InputMaybe<Array<InputMaybe<PickupReturnOrderInput>>>;
};


export type MutationRootSapPlatformPricingArgs = {
  inwardIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  scheduleIds: Array<InputMaybe<Scalars['ID']>>;
  schemaName?: InputMaybe<Scalars['String']>;
};


export type MutationRootScheduleRequestApprovalArgs = {
  scheduleApprovals?: InputMaybe<Array<InputMaybe<ScheduleRequestDeviationInput>>>;
};


export type MutationRootSendNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationRootSendPackagingMaterialWhatsappApprovalArgs = {
  departmentId?: InputMaybe<Scalars['Int']>;
  packagingMaterialId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootStockTakeStockMovementArgs = {
  approvalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRootSwitchDepartmentArgs = {
  department?: InputMaybe<Scalars['Int']>;
};


export type MutationRootTriggerNotificationArgs = {
  broadcastTime?: InputMaybe<Scalars['DateTime']>;
  content?: InputMaybe<NotificationContent>;
  dataVariables?: InputMaybe<Scalars['JSONScalar']>;
  extraVariables?: InputMaybe<Scalars['JSONScalar']>;
  filters?: InputMaybe<Array<InputMaybe<NotificationTemplateFilter>>>;
  providerUid?: InputMaybe<Scalars['String']>;
  providerVariables?: InputMaybe<Scalars['JSONScalar']>;
  templateUid?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  userQueryUid?: InputMaybe<Scalars['String']>;
};


export type MutationRootUnloadingStockMovementArgs = {
  bookingIds: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRootUpdateBookingArgs = {
  updateBookings: Array<InputMaybe<UpdateBookingInput>>;
};


export type MutationRootUpdateBulkDemandsArgs = {
  description?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DemandFilterInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


export type MutationRootUpdateDeliveredQuantityArgs = {
  orderItems?: InputMaybe<Array<InputMaybe<UpdateDeliveredQuantityInput>>>;
};


export type MutationRootUpdateDistributionCentreArgs = {
  address?: InputMaybe<AddressInput>;
  allowedDepartments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  alternateSalesSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  archive?: InputMaybe<Scalars['Boolean']>;
  areaCatered?: InputMaybe<Scalars['Geometry']>;
  assignedCpcId?: InputMaybe<Scalars['NullableID']>;
  bankDetails?: InputMaybe<Array<InputMaybe<BankDetailInput>>>;
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  colorCode?: InputMaybe<Scalars['String']>;
  companyCode?: InputMaybe<Scalars['String']>;
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  customerCode?: InputMaybe<Scalars['String']>;
  deliveryConditions?: InputMaybe<DeliveryConditionInput>;
  deliverySlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  maintenanceSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  name?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  pickupSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>>>;
  plantCode?: InputMaybe<Scalars['String']>;
  pointOfContacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  primaryPocId?: InputMaybe<Scalars['NullableID']>;
  salesOfcCode?: InputMaybe<Scalars['String']>;
  storeCode?: InputMaybe<Scalars['String']>;
  surveyAreas?: InputMaybe<Array<InputMaybe<SurveyAreaInput>>>;
  useCreditFeature?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRootUpdateFuelDistributorArgs = {
  batchNo?: InputMaybe<Scalars['String']>;
  fuelDetailAttachment?: InputMaybe<Scalars['String']>;
  fuelRate?: InputMaybe<Scalars['Float']>;
  fuelReceiptAttachment?: InputMaybe<Scalars['String']>;
  fuelStationName?: InputMaybe<Scalars['String']>;
  fuelTypeId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  quantityFilled?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  tankerNoId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootUpdateFuelDistributorItemArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
  distributedFuelQuantity?: InputMaybe<Scalars['Float']>;
  fuelDistributorId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  odometerReading?: InputMaybe<Scalars['Float']>;
  odometerReadingAttachment?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
};


export type MutationRootUpdateLinePackingAllotmentLotCodeArgs = {
  input: UpdateLinePackingAllotmentLotCodeInput;
};


export type MutationRootUpdateOrderArgs = {
  id: Scalars['ID'];
  orderCategory?: InputMaybe<Scalars['String']>;
  orderItems?: InputMaybe<Array<InputMaybe<OrderItemStockInput>>>;
  pocName?: InputMaybe<Scalars['String']>;
  pocNumber?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<AddressInput>;
  shippingMethod?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootUpdatePeriodicTasksArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids: Array<InputMaybe<Scalars['ID']>>;
  oneOff?: InputMaybe<Scalars['Boolean']>;
  queue?: InputMaybe<Scalars['String']>;
};


export type MutationRootUpdateScheduleArgs = {
  schedules?: InputMaybe<Array<InputMaybe<UpdateScheduleRowInput>>>;
};


export type MutationRootUpdateTripDetailsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  trip?: InputMaybe<Scalars['ID']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
};


export type MutationRootUpdateUserProfileArgs = {
  addressId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  kycDetails?: InputMaybe<Array<InputMaybe<KycDetailInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<BaseUserMetadataInput>;
  photo?: InputMaybe<Scalars['String']>;
};


export type MutationRootVehicalLoadingListArgs = {
  bookings?: InputMaybe<Array<InputMaybe<BookInput>>>;
  tripId?: InputMaybe<Scalars['Int']>;
};


export type MutationRootVehiclePickupReturnOrderArgs = {
  returnOrders?: InputMaybe<Array<InputMaybe<PickupReturnOrderInput>>>;
};


export type MutationRootVerifyDispatchOtpArgs = {
  otp: Scalars['Int'];
  tripId: Scalars['Int'];
};


export type MutationRootVerifyTokenArgs = {
  token: Scalars['String'];
};

export type MySellableItemStockFilterInput = {
  discountedRate_Gte?: InputMaybe<Scalars['Float']>;
  discountedRate_Lte?: InputMaybe<Scalars['Float']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  isCodAvailable?: InputMaybe<Scalars['Boolean']>;
  isHomeDeliveryAvailable?: InputMaybe<Scalars['Boolean']>;
  itemGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rejectedStockCount_Gte?: InputMaybe<Scalars['Int']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
};

export type NetSaleAmountType = {
  __typename?: 'NetSaleAmountType';
  delivery?: Maybe<Scalars['Float']>;
  fresh?: Maybe<Scalars['Float']>;
  netSale?: Maybe<Scalars['Float']>;
  resale?: Maybe<Scalars['Float']>;
};

export type NewAccountTransactionMutation = {
  __typename?: 'NewAccountTransactionMutation';
  accountTransaction?: Maybe<TransactionGraphType>;
};

export type NewNotificationTemplateType = {
  __typename?: 'NewNotificationTemplateType';
  /** Template body with custom variables */
  body: Scalars['String'];
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Optional data source to dynamically fetch users */
  dataSource?: Maybe<DataSourceType>;
  dataVariables?: Maybe<Scalars['JSONScalar']>;
  description: Scalars['String'];
  extraFields?: Maybe<Scalars['JSONScalar']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isProgrammatic: Scalars['Boolean'];
  name: Scalars['String'];
  notificationtriggerSet: Array<NotificationTriggerType>;
  provider: NotificationProviderType;
  providerVariables?: Maybe<Scalars['JSONScalar']>;
  /** Title used in notification */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NewScheduleRequestMutation = {
  __typename?: 'NewScheduleRequestMutation';
  scheduleRequest?: Maybe<ScheduleRequestType>;
};

export type NotificationContent = {
  body: Scalars['String'];
  extraFields?: InputMaybe<Scalars['JSONScalar']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationLogType = {
  __typename?: 'NotificationLogType';
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deliveryLog: Scalars['String'];
  id: Scalars['ID'];
  messegeType: Scalars['String'];
  notification?: Maybe<NotificationType>;
  sentTo?: Maybe<DeliveryAgentManagementType>;
  title: Scalars['String'];
};

/** An enumeration. */
export enum NotificationMessegeType {
  /** EMAIL */
  EML = 'EML',
  /** Notification */
  NTF = 'NTF',
  /** SMS */
  SMS = 'SMS'
}

export type NotificationProviderInput = {
  codename?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  kind_In?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum NotificationProviderKind {
  /** Email */
  EMAIL = 'EMAIL',
  /** Other */
  OTHER = 'OTHER',
  /** Push */
  PUSH = 'PUSH',
  /** SMS */
  SMS = 'SMS'
}

export type NotificationProviderType = {
  __typename?: 'NotificationProviderType';
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  kind: NotificationProviderKind;
  name: Scalars['String'];
  notificationtemplateSet: Array<NewNotificationTemplateType>;
  notificationtriggerSet: Array<NotificationTriggerType>;
  /** On turning this on the notifications will be saved against user. */
  saveAsNotification: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationTemplateFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  value: Array<InputMaybe<Scalars['CustomGenericScalar']>>;
};

export type NotificationTemplateInput = {
  codename?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isProgrammatic?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationTemplateType = {
  __typename?: 'NotificationTemplateType';
  alias: Scalars['String'];
  body: Scalars['String'];
  config?: Maybe<Scalars['JSONString']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  notificationSet: Array<NotificationType>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationTriggerInput = {
  isTriggered?: InputMaybe<Scalars['Boolean']>;
  providerId?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['ID']>;
};

export type NotificationTriggerType = {
  __typename?: 'NotificationTriggerType';
  broadcastTime?: Maybe<Scalars['DateTime']>;
  config?: Maybe<Scalars['JSONScalar']>;
  createdAt: Scalars['DateTime'];
  dataVariables?: Maybe<Scalars['JSONScalar']>;
  extraFields?: Maybe<Scalars['JSONScalar']>;
  id: Scalars['ID'];
  isTriggered: Scalars['Boolean'];
  provider: NotificationProviderType;
  providerVariables?: Maybe<Scalars['JSONScalar']>;
  sentBy: DeliveryAgentManagementType;
  template?: Maybe<NewNotificationTemplateType>;
  updatedAt: Scalars['DateTime'];
  userQuery?: Maybe<UserQueryType>;
  users: Array<DeliveryAgentManagementType>;
  usersCount?: Maybe<Scalars['Int']>;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  messegeType: NotificationMessegeType;
  notificationlogSet: Array<NotificationLogType>;
  objectId?: Maybe<Scalars['Int']>;
  sentBy?: Maybe<DeliveryAgentManagementType>;
  template: NotificationTemplateType;
  updatedAt: Scalars['DateTime'];
  userGroups: Array<GroupType>;
  users: Array<DeliveryAgentManagementType>;
};

export type OibTrackType = {
  __typename?: 'OIBTrackType';
  approvedRejectedStatus?: Maybe<TrackDetail>;
  handoverStatus?: Maybe<TrackDetail>;
  pickupStatus?: Maybe<TrackDetail>;
  refundStatus?: Maybe<TrackDetail>;
  submittedStatus?: Maybe<TrackDetail>;
};

export type ObservationInput = {
  observationId?: InputMaybe<Scalars['Int']>;
  parameterValues?: InputMaybe<Array<InputMaybe<ObservationValueInput>>>;
};

export type ObservationValueInput = {
  parameter?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OnlineTransactionKeys = {
  __typename?: 'OnlineTransactionKeys';
  paymentDetailHash?: Maybe<Scalars['String']>;
  paymentHash?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  vasDetailHash?: Maybe<Scalars['String']>;
};

export type OptimizeSchedulesMutation = {
  __typename?: 'OptimizeSchedulesMutation';
  missingDimensionsScheduleIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  missingDimensionsSkuIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  missingDimensionsVehicleIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  responseText?: Maybe<Scalars['String']>;
};

export type OrderBySellableItem = {
  __typename?: 'OrderBySellableItem';
  sellableItem?: Maybe<SellableItemType>;
  statusDetails?: Maybe<Array<Maybe<OrderStatusSummary>>>;
  totalValue?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum OrderDeliveryStatus {
  /** Arrived at DC */
  AAD = 'AAD',
  /** Delivered */
  DLV = 'DLV',
  /** Despatched to DC */
  DTD = 'DTD',
  /** Not Started */
  NST = 'NST',
  /** Out for Delivery */
  OFD = 'OFD',
  /** Ready for Pickup */
  RFP = 'RFP',
  /** Undelivered */
  UDL = 'UDL'
}

export type OrderFilterInput = {
  aggregatorId?: InputMaybe<Scalars['ID']>;
  approvalStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  approvedById?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Distribution centre ID */
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  distributionCentreIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  oibReturnStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Valid only for pickup_date, date, pickup_slot_from_time, pickup_slot_to_time */
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderCategoriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  outstandingAmountRemaining?: InputMaybe<Scalars['Boolean']>;
  /** 'COD | CHQ and more' orders will be filtered according to payment method */
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentMethodsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentStatusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pickupDate?: InputMaybe<Scalars['Date']>;
  pickupDate_Gte?: InputMaybe<Scalars['Date']>;
  pickupDate_Lte?: InputMaybe<Scalars['Date']>;
  pincodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placedById?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  placedInCodename?: InputMaybe<Scalars['String']>;
  /** department ID */
  placedInId?: InputMaybe<Scalars['ID']>;
  salesmanId?: InputMaybe<Scalars['ID']>;
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** 'settled' status shows : Settled Transactions, 'unsettled' status shows : Unsettled Transactions */
  settlementStatus?: InputMaybe<Scalars['String']>;
  supplyingDcId?: InputMaybe<Scalars['ID']>;
  targetDcId?: InputMaybe<Scalars['ID']>;
  transactionDate_Gte?: InputMaybe<Scalars['Date']>;
  transactionDate_Lte?: InputMaybe<Scalars['Date']>;
  /** 'COD | CHQ and more' orders and transactions will be filtered according to payment method */
  transactionPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionRecordedByGroup?: InputMaybe<Scalars['String']>;
  transactionRecordedByIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type OrderInput = {
  orderId?: InputMaybe<Scalars['Int']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
};

export type OrderInvoiceDetail = {
  __typename?: 'OrderInvoiceDetail';
  availablePaymentModes?: Maybe<Array<Maybe<Scalars['String']>>>;
  customDiscountFlat?: Maybe<Scalars['Float']>;
  customDiscountPercent?: Maybe<Scalars['Float']>;
  deliveryAddress?: Maybe<DeliveryAddressOutput>;
  discountCode?: Maybe<Scalars['String']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  finalAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  invoiceDocumentPath?: Maybe<Scalars['String']>;
  invoiceItems?: Maybe<Array<Maybe<OrderInvoiceItem>>>;
  paymentMethod?: Maybe<Scalars['String']>;
  payuCredentials?: Maybe<Scalars['String']>;
  pocName?: Maybe<Scalars['String']>;
  pocNumber?: Maybe<Scalars['String']>;
  trackingCode?: Maybe<Scalars['String']>;
};

export type OrderInvoiceItem = {
  __typename?: 'OrderInvoiceItem';
  actualRate?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['String']>;
  customDiscountFlat?: Maybe<Scalars['Float']>;
  customDiscountPercent?: Maybe<Scalars['Float']>;
  discountedRate?: Maybe<Scalars['Float']>;
  itemDiscountCode?: Maybe<Scalars['String']>;
  itemDiscountFlat?: Maybe<Scalars['Float']>;
  itemDiscountId?: Maybe<Scalars['Int']>;
  itemDiscountPercent?: Maybe<Scalars['Float']>;
  itemType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  stockCount?: Maybe<Scalars['Float']>;
};

export type OrderItemApproval = {
  __typename?: 'OrderItemApproval';
  orderItem?: Maybe<OrderItemType>;
};

/** An enumeration. */
export enum OrderItemApprovalStatus {
  /** Approved */
  APR = 'APR',
  /** Approved Under Deviation */
  AUD = 'AUD',
  /** Hold */
  HLD = 'HLD',
  /** Pending */
  PEN = 'PEN',
  /** Rejected */
  REJ = 'REJ'
}

export type OrderItemBatchFilterInput = {
  approvalStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  batchStockId?: InputMaybe<Scalars['ID']>;
  batchStockRateId?: InputMaybe<Scalars['ID']>;
  createdAtGte?: InputMaybe<Scalars['Date']>;
  createdAtLte?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  deliveredQuantity?: InputMaybe<Scalars['Int']>;
  orderCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderCategoriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderId?: InputMaybe<Scalars['ID']>;
  orderItemId?: InputMaybe<Scalars['ID']>;
  parentOibId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  returnOrderId?: InputMaybe<Scalars['ID']>;
  returnStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesInchargeId?: InputMaybe<Scalars['ID']>;
  supplyingDcId?: InputMaybe<Scalars['ID']>;
  targetDc?: InputMaybe<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type OrderItemBatchInput = {
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  batchStockId?: InputMaybe<Scalars['ID']>;
  deliveredQuantity?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  settledQuantity?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum OrderItemBatchReturnReason {
  /** Expiry */
  EXP = 'EXP',
  /** Quality */
  QLY = 'QLY',
  /** Wrong Delivery */
  WDL = 'WDL'
}

/** An enumeration. */
export enum OrderItemBatchReturnStatus {
  /** Approved */
  APR = 'APR',
  /** Handed over */
  HND = 'HND',
  /** Not Started */
  NST = 'NST',
  /** Picked up */
  PCK = 'PCK',
  /** Rejected */
  REJ = 'REJ',
  /** Refunded */
  RFN = 'RFN',
  /** Submited */
  SUB = 'SUB'
}

export type OrderItemBatchType = {
  __typename?: 'OrderItemBatchType';
  attachments: Array<MediaEntityType>;
  batchStock: BatchStockType;
  batchStockRate?: Maybe<BatchStockRateType>;
  childItemBatches: Array<OrderItemBatchType>;
  createdAt: Scalars['DateTime'];
  deliveredQuantity?: Maybe<Scalars['Int']>;
  deliveredTaxedItemCost?: Maybe<Scalars['Float']>;
  deliveryLocation?: Maybe<AddressType>;
  deliveryRemark?: Maybe<Scalars['String']>;
  deliveryTime?: Maybe<Scalars['DateTime']>;
  extraCharges: Scalars['Float'];
  /** to be used only for parent batch */
  hasOngoingReturnRequest?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  itemCost?: Maybe<Scalars['Float']>;
  itemFinalCost?: Maybe<Scalars['Float']>;
  loadingRemark?: Maybe<Scalars['String']>;
  orderItem: OrderItemType;
  parentItemBatch?: Maybe<OrderItemBatchType>;
  quantity: Scalars['Int'];
  requestedQuantity: Scalars['Int'];
  returnReason?: Maybe<OrderItemBatchReturnReason>;
  returnRemark?: Maybe<Scalars['String']>;
  returnStatus: OrderItemBatchReturnStatus;
  /** to be used only for parent batch */
  returnedCount?: Maybe<Scalars['Int']>;
  settledQuantity?: Maybe<Scalars['Int']>;
  taxedItemCost?: Maybe<Scalars['Float']>;
  transportCharges: Scalars['Float'];
  unloadingRemark?: Maybe<Scalars['String']>;
  unloadingTime?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type OrderItemFilterInput = {
  aggregatorId?: InputMaybe<Scalars['ID']>;
  approvalStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  approvedById?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deviation?: InputMaybe<RangeInput>;
  deviationPriceRange?: InputMaybe<RangeInput>;
  /** Distribution centre ID */
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  distributionCentreIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  oibReturnStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderCategoriesNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** 'COD | CHQ and more' orders will be filtered according to payment method */
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pickupDate?: InputMaybe<Scalars['Date']>;
  pickupDate_Gte?: InputMaybe<Scalars['Date']>;
  pickupDate_Lte?: InputMaybe<Scalars['Date']>;
  pincodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placedById?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  placedInCodename?: InputMaybe<Scalars['String']>;
  /** department ID */
  placedInId?: InputMaybe<Scalars['ID']>;
  rejectionRate_Gte?: InputMaybe<Scalars['Float']>;
  rejectionRate_Lte?: InputMaybe<Scalars['Float']>;
  requestedAt_Gte?: InputMaybe<Scalars['Date']>;
  requestedAt_Lte?: InputMaybe<Scalars['Date']>;
  requestedById?: InputMaybe<Scalars['ID']>;
  salesmanId?: InputMaybe<Scalars['ID']>;
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** 'settled' status shows : Settled Transactions, 'unsettled' status shows : Unsettled Transactions */
  settlementStatus?: InputMaybe<Scalars['String']>;
  supplyingDcId?: InputMaybe<Scalars['ID']>;
  transactionDate_Gte?: InputMaybe<Scalars['Date']>;
  transactionDate_Lte?: InputMaybe<Scalars['Date']>;
  /** 'COD | CHQ and more' orders and transactions will be filtered according to payment method */
  transactionPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionRecordedByGroup?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type OrderItemInput = {
  batches?: InputMaybe<Array<InputMaybe<OrderItemBatchInput>>>;
  bookingId?: InputMaybe<Scalars['ID']>;
  deliveredQuantity: Scalars['Int'];
  deliveryRemark?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  itemStatus?: InputMaybe<Scalars['String']>;
  leftSkus?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum OrderItemItemStatus {
  /** Cancelled by user */
  CBU = 'CBU',
  /** Cancelled by vendor */
  CBV = 'CBV',
  /** Completed */
  CMP = 'CMP',
  /** Confirmed */
  CNF = 'CNF',
  /** Despatched */
  DES = 'DES',
  /** Full Reject */
  FRJ = 'FRJ',
  /** In Process */
  IPR = 'IPR',
  /** Not Placed */
  NPL = 'NPL',
  /** Placed */
  PLC = 'PLC',
  /** Patial Reject */
  PRJ = 'PRJ',
  /** Ready for Despatch */
  RFD = 'RFD',
  /** Ready for Schedule */
  RFS = 'RFS',
  /** Scheduled for Despatch */
  SFD = 'SFD'
}

export type OrderItemStockInput = {
  actualRate?: InputMaybe<Scalars['Float']>;
  approvalStatus?: InputMaybe<Scalars['String']>;
  approverRemark?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  batchStockCodename?: InputMaybe<Scalars['String']>;
  batchStockRateId?: InputMaybe<Scalars['ID']>;
  customDiscountFlat?: InputMaybe<Scalars['Float']>;
  customDiscountPercent?: InputMaybe<Scalars['Float']>;
  discountId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderingItemStockId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  rate?: InputMaybe<Scalars['Float']>;
  rejectionRate?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  requestedAt?: InputMaybe<Scalars['Date']>;
  sellableItemStockId: Scalars['ID'];
};

export type OrderItemType = {
  __typename?: 'OrderItemType';
  actualRate: Scalars['Float'];
  approvalStatus: OrderItemApprovalStatus;
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<DeliveryAgentManagementType>;
  approvedRate: Scalars['Float'];
  approverRemark?: Maybe<Scalars['String']>;
  attachments: Array<MediaEntityType>;
  batches: Array<OrderItemBatchType>;
  bookedQuantity?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  deliveredQuantity?: Maybe<Scalars['Int']>;
  discount?: Maybe<DiscountType>;
  id: Scalars['ID'];
  itemBookings: Array<BookingType>;
  itemStatus: OrderItemItemStatus;
  itemStock?: Maybe<SellableItemStockType>;
  metadata: Scalars['JSONString'];
  order: AnnotatedOrderType;
  quantity: Scalars['Int'];
  rate: Scalars['Float'];
  rejectionRate: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  requestedAt?: Maybe<Scalars['DateTime']>;
  requestedBy?: Maybe<DeliveryAgentManagementType>;
  sellableItem: SellableItemType;
  settledQuantity?: Maybe<Scalars['Int']>;
  settlementRemark?: Maybe<Scalars['String']>;
  shipping?: Maybe<ShippingType>;
  sku?: Maybe<SkuGraphType>;
  soQuantity?: Maybe<Scalars['Float']>;
  stockTransaction?: Maybe<StockTransactionType>;
  taxRate: Scalars['Float'];
  taxRateFb?: Maybe<Scalars['Float']>;
  taxedItemCost?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum OrderOrderCategory {
  /** Type 0 */
  T0 = 'T0',
  /** Type 1 */
  T1 = 'T1',
  /** Type 2 */
  T2 = 'T2',
  /** Type 3 */
  T3 = 'T3',
  /** Type 4 */
  T4 = 'T4',
  /** Type 5 */
  T5 = 'T5',
  /** Type 6 */
  T6 = 'T6',
  /** Type 7 */
  T7 = 'T7',
  /** Type 8 */
  T8 = 'T8',
  /** Type 9 */
  T9 = 'T9',
  /** Type 10 */
  T10 = 'T10',
  /** Type 11 */
  T11 = 'T11',
  /** Type 12 */
  T12 = 'T12',
  /** Type 13 */
  T13 = 'T13',
  /** Type 14 */
  T14 = 'T14',
  /** Type 15 */
  T15 = 'T15',
  /** Type 16 */
  T16 = 'T16',
  /** Type 17 */
  T17 = 'T17',
  /** Type 18 */
  T18 = 'T18',
  /** Type 19 */
  T19 = 'T19',
  /** Type 20 */
  T20 = 'T20'
}

/** An enumeration. */
export enum OrderOrderStatus {
  /** Cancelled by user */
  CBU = 'CBU',
  /** Cancelled by vendor */
  CBV = 'CBV',
  /** Completed */
  CMP = 'CMP',
  /** Confirmed */
  CNF = 'CNF',
  /** Despatched */
  DES = 'DES',
  /** Full Reject */
  FRJ = 'FRJ',
  /** In Process */
  IPR = 'IPR',
  /** Not Placed */
  NPL = 'NPL',
  /** Placed */
  PLC = 'PLC',
  /** Patial Reject */
  PRJ = 'PRJ',
  /** Ready for Despatch */
  RFD = 'RFD',
  /** Ready for Schedule */
  RFS = 'RFS',
  /** Scheduled for Despatch */
  SFD = 'SFD'
}

/** An enumeration. */
export enum OrderPaymentMethod {
  /** Credit */
  CDT = 'CDT',
  /** Cheque */
  CHQ = 'CHQ',
  /** Cash on Delivery */
  COD = 'COD',
  /** Card On Delivery */
  CRD = 'CRD',
  /** Demand Draft (DD) */
  DMD = 'DMD',
  /** National Electronic Funds Transfer (NEFT) */
  NFT = 'NFT',
  /** Not Selected */
  NSE = 'NSE',
  /** Online Payment */
  ONL = 'ONL',
  /** Pay On Delivery */
  POD = 'POD',
  /** Real-Time Gross Settlement (RTGS) */
  RTG = 'RTG',
  /** Universal Payments Interface (UPI) */
  UPI = 'UPI'
}

/** An enumeration. */
export enum OrderPaymentStatus {
  /** Failed */
  FAL = 'FAL',
  /** In Process */
  INP = 'INP',
  /** Pay Later */
  PLT = 'PLT',
  /** Pending */
  PND = 'PND',
  /** Partial Payment */
  PRT = 'PRT',
  /** Refunded */
  RUF = 'RUF',
  /** Successful */
  SUC = 'SUC'
}

export type OrderPickupSlotInput = {
  distributionCentreId: Scalars['ID'];
  timeSlotId: Scalars['ID'];
};

/** An enumeration. */
export enum OrderPickupType {
  /** Salesman */
  SLM = 'SLM',
  /** Vehice */
  VCL = 'VCL'
}

/** An enumeration. */
export enum OrderShippingMethod {
  /** Home Delivery */
  HMD = 'HMD',
  /** Self Pickup */
  SPK = 'SPK'
}

/** An enumeration. */
export enum OrderStatusLogStatusType {
  /** Delivery Type */
  DL = 'DL',
  /** Order Type */
  OR = 'OR',
  /** Payment Type */
  PY = 'PY'
}

export type OrderStatusLogType = {
  __typename?: 'OrderStatusLogType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  order: AnnotatedOrderType;
  status: Scalars['String'];
  statusType: OrderStatusLogStatusType;
  trip?: Maybe<TripType>;
  updatedAt: Scalars['DateTime'];
};

export type OrderStatusSummary = {
  __typename?: 'OrderStatusSummary';
  orderStatus?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type OrderSummaryOfVendor = {
  __typename?: 'OrderSummaryOfVendor';
  deliveredOrderValue?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  rejectedOrderValue?: Maybe<Scalars['Float']>;
  totalOrderValue?: Maybe<Scalars['Float']>;
  undeliveredOrderValue?: Maybe<Scalars['Float']>;
  unpaid?: Maybe<Scalars['Float']>;
};

export type OrderSummaryOfVendorFilterInput = {
  orderDate_Gte?: InputMaybe<Scalars['Date']>;
  orderDate_Lte?: InputMaybe<Scalars['Date']>;
  vendorId: Scalars['ID'];
};

export type OrderTransactionApprovalMutation = {
  __typename?: 'OrderTransactionApprovalMutation';
  order?: Maybe<OrderType>;
  orderTransaction?: Maybe<OrderTransactionType>;
};

export type OrderTransactionEntryInput = {
  amount: Scalars['Float'];
  attachment?: InputMaybe<MediaInput>;
  id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentVerification?: InputMaybe<Scalars['Boolean']>;
  referenceId?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  tripId?: InputMaybe<Scalars['ID']>;
};

export type OrderTransactionFilterInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  isSettledForTransaction?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['ID']>;
  orderTrackingCode?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recordedBy?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetDcId?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum OrderTransactionPaymentMethod {
  /** Credit */
  CDT = 'CDT',
  /** Cheque */
  CHQ = 'CHQ',
  /** Cash on Delivery */
  COD = 'COD',
  /** Card On Delivery */
  CRD = 'CRD',
  /** Demand Draft (DD) */
  DMD = 'DMD',
  /** National Electronic Funds Transfer (NEFT) */
  NFT = 'NFT',
  /** Not Selected */
  NSE = 'NSE',
  /** Online Payment */
  ONL = 'ONL',
  /** Pay On Delivery */
  POD = 'POD',
  /** Real-Time Gross Settlement (RTGS) */
  RTG = 'RTG',
  /** Universal Payments Interface (UPI) */
  UPI = 'UPI'
}

/** An enumeration. */
export enum OrderTransactionStatus {
  /** Authorized */
  AUT = 'AUT',
  /** Captured */
  CAP = 'CAP',
  /** Failed */
  FAL = 'FAL',
  /** Not Started */
  NST = 'NST',
  /** Refunded */
  REF = 'REF',
  /** Settled */
  STL = 'STL'
}

export type OrderTransactionType = {
  __typename?: 'OrderTransactionType';
  amount: Scalars['Float'];
  attachment?: Maybe<MediaEntityType>;
  billingDoc?: Maybe<Array<Maybe<BillingDocType>>>;
  chequeTransaction?: Maybe<TransactionGraphType>;
  collectionLog?: Maybe<CollectionLogType>;
  createdAt: Scalars['DateTime'];
  dcCollectionLog?: Maybe<DcCollectionLogType>;
  id: Scalars['ID'];
  metadata: Scalars['JSONString'];
  order: AnnotatedOrderType;
  ordertransactionSet: Array<OrderTransactionType>;
  paymentMethod: OrderTransactionPaymentMethod;
  recordedBy?: Maybe<DeliveryAgentManagementType>;
  referenceId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  settledForTransaction?: Maybe<OrderTransactionType>;
  settlementRemark?: Maybe<Scalars['String']>;
  status: OrderTransactionStatus;
  /** use only for credit transactions */
  transaction?: Maybe<TransactionGraphType>;
  trip?: Maybe<TripType>;
  /** Only captured transaction will have unsettled amount */
  unsettledAmount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  user: DeliveryAgentManagementType;
};

export type OrderType = {
  __typename?: 'OrderType';
  billingAddress?: Maybe<AddressType>;
  billingDoc: Array<BillingDocType>;
  bookingsByTrip?: Maybe<Array<Maybe<BookingType>>>;
  collectionLog?: Maybe<CollectionLogType>;
  crateBarcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  crateCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  dcCollectionLog?: Maybe<DcCollectionLogType>;
  deliveryStatus: OrderDeliveryStatus;
  discount?: Maybe<DiscountType>;
  id: Scalars['ID'];
  isConsolidated?: Maybe<Scalars['Boolean']>;
  isParentOrder?: Maybe<Scalars['Boolean']>;
  itemAggregate?: Maybe<ItemAggregateType>;
  metadata: Scalars['JSONString'];
  orderBookings: Array<BookingType>;
  orderCategory: OrderOrderCategory;
  orderItems?: Maybe<Array<Maybe<OrderItemType>>>;
  orderStatus: OrderOrderStatus;
  orderStatusObj?: Maybe<ClientStatusType>;
  orderingDc?: Maybe<DistributionCentreType>;
  otp: Scalars['Int'];
  outstandingAmount: Scalars['Float'];
  paymentMethod: OrderPaymentMethod;
  paymentStatus: OrderPaymentStatus;
  pickupDate?: Maybe<Scalars['Date']>;
  pickupSlotFromTime?: Maybe<Scalars['Time']>;
  pickupSlotToTime?: Maybe<Scalars['Time']>;
  pickupType?: Maybe<OrderPickupType>;
  placedBy?: Maybe<DeliveryAgentManagementType>;
  placedIn?: Maybe<DepartmentType>;
  pocName: Scalars['String'];
  pocNumber: Scalars['String'];
  remark: Scalars['String'];
  salesIncharge?: Maybe<DeliveryAgentManagementType>;
  selectedPickupSlot?: Maybe<TimeSlotType>;
  shippingAddress: AddressType;
  shippingCharges: Scalars['Float'];
  shippingMethod: OrderShippingMethod;
  shop?: Maybe<ShopType>;
  soNumber?: Maybe<Scalars['String']>;
  statusLogs: Array<OrderStatusLogType>;
  subOrders: Array<AnnotatedOrderType>;
  targetDc?: Maybe<DistributionCentreType>;
  taxes: Array<TaxType>;
  totalAmount: Scalars['Float'];
  totalPaid?: Maybe<Scalars['Float']>;
  totalPaidAndSettled?: Maybe<Scalars['Float']>;
  totalWeight?: Maybe<Scalars['Float']>;
  trackingCode: Scalars['String'];
  transactionAmount?: Maybe<AggregatorPaymentsDetail>;
  transactions?: Maybe<Array<Maybe<OrderTransactionType>>>;
  transactionsPaymentMethod?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: DeliveryAgentManagementType;
};


export type OrderTypeBookingsByTripArgs = {
  isSkuUnsettled?: InputMaybe<Scalars['Boolean']>;
  isStockUnsettled?: InputMaybe<Scalars['Boolean']>;
  tripId?: InputMaybe<Scalars['ID']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type OrderTypeItemAggregateArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type OrderTypeOrderItemsArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type OrderTypeTransactionAmountArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
};


export type OrderTypeTransactionsArgs = {
  status?: InputMaybe<Scalars['String']>;
};

export type OrderValueBySellableItemFilterInput = {
  orderDate_Gte?: InputMaybe<Scalars['Date']>;
  orderDate_Lte?: InputMaybe<Scalars['Date']>;
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  totalOrderValue_Gte?: InputMaybe<Scalars['Float']>;
  totalOrderValue_Lte?: InputMaybe<Scalars['Float']>;
};

export type OrderingConditionInput = {
  isCodAvailable?: InputMaybe<Scalars['Boolean']>;
  isHomeDelivery?: InputMaybe<Scalars['Boolean']>;
  isOnlinePaymentAvailable?: InputMaybe<Scalars['Boolean']>;
  isPickUp?: InputMaybe<Scalars['Boolean']>;
  isTaxIncluded?: InputMaybe<Scalars['Boolean']>;
  orderLimit?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type OrganisationType = {
  __typename?: 'OrganisationType';
  name: Scalars['String'];
  onTrial: Scalars['Boolean'];
  photo?: Maybe<Scalars['String']>;
};

export type OutstandingOrderDateFilterInput = {
  /** First order date, inclusive */
  date_Gte?: InputMaybe<Scalars['Date']>;
  /** Last order date, inclusive */
  date_Lte?: InputMaybe<Scalars['Date']>;
};

export type OutstandingUserDetailType = {
  __typename?: 'OutstandingUserDetailType';
  grossOrderValue: Scalars['Float'];
  orders: Array<Maybe<OrderType>>;
  shops: Array<Maybe<ShopType>>;
  totalOutstandingAmount: Scalars['Float'];
  totalOutstandingOrders: Scalars['Int'];
  user: BaseUserType;
};

export type OutstandingUserSummaryType = {
  __typename?: 'OutstandingUserSummaryType';
  grossOrderValue: Scalars['Float'];
  totalOutstandingAmount: Scalars['Float'];
  totalOutstandingOrders: Scalars['Int'];
  user: BaseUserType;
};

export type PackagingMaterialItemInput = {
  cluster?: InputMaybe<Scalars['Int']>;
  fiveHand?: InputMaybe<Scalars['Int']>;
  fourHand?: InputMaybe<Scalars['Int']>;
  harvestedQuantity?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  receivedQuantity?: InputMaybe<Scalars['Int']>;
  receivedTareWt?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  sevenEightHand?: InputMaybe<Scalars['Int']>;
  sixHand?: InputMaybe<Scalars['Int']>;
  skuTypeId?: InputMaybe<Scalars['Int']>;
  whatsappApproval?: InputMaybe<Scalars['Boolean']>;
};

export type PackagingMaterialItemSearchInput = {
  packagingMaterialId?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  skuTypeId?: InputMaybe<Scalars['Int']>;
};

export type PackagingMaterialItemType = {
  __typename?: 'PackagingMaterialItemType';
  cluster?: Maybe<Scalars['Int']>;
  dispatchedBoxCount?: Maybe<Scalars['Int']>;
  dispatchedBoxWt?: Maybe<Scalars['Float']>;
  fiveHand?: Maybe<Scalars['Int']>;
  fourHand?: Maybe<Scalars['Int']>;
  harvestedBoxCount?: Maybe<Scalars['Int']>;
  harvestedBoxWt?: Maybe<Scalars['Float']>;
  harvestedGrossWt?: Maybe<Scalars['Float']>;
  harvestedNetWt?: Maybe<Scalars['Float']>;
  harvestedQuantity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  mismatchBoxCount?: Maybe<Scalars['Int']>;
  packagingMaterial?: Maybe<PackagingMaterialType>;
  quantity?: Maybe<Scalars['Int']>;
  receivedBoxCount?: Maybe<Scalars['Int']>;
  receivedQuantity?: Maybe<Scalars['Int']>;
  receivedTareWt?: Maybe<Scalars['Float']>;
  recievedTareWt?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  sevenEightHand?: Maybe<Scalars['Int']>;
  sixHand?: Maybe<Scalars['Int']>;
  skuType?: Maybe<SkuGraphType>;
  whatsappApproval?: Maybe<Scalars['Boolean']>;
};

export type PackagingMaterialRegionType = {
  __typename?: 'PackagingMaterialRegionType';
  id: Scalars['ID'];
  metadata: Scalars['JSONString'];
  percentDetail?: Maybe<RegionPercentDetailType>;
  region?: Maybe<Scalars['String']>;
};

export type PackagingMaterialSearchInput = {
  packagingMaterialRegionId?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  supplierType?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum PackagingMaterialSupplierType {
  /** Farmer */
  FARMER = 'FARMER',
  /** Vendor */
  VENDOR = 'VENDOR'
}

export type PackagingMaterialType = {
  __typename?: 'PackagingMaterialType';
  areaInchargeName?: Maybe<BaseUserType>;
  attachments: Array<MediaEntityType>;
  avgRate?: Maybe<Scalars['Float']>;
  combinedPackagingMaterialItems?: Maybe<Array<Maybe<PackagingMaterialItemType>>>;
  createdAt: Scalars['DateTime'];
  deductionAmt?: Maybe<Scalars['Float']>;
  deductionCalc?: Maybe<Scalars['Float']>;
  deductionWt: Scalars['Float'];
  deductionWtPercent: Scalars['Float'];
  farmerName?: Maybe<DeliveryAgentManagementType>;
  fieldSupervisorName?: Maybe<BaseUserType>;
  finalAmt?: Maybe<Scalars['Float']>;
  finalWt?: Maybe<Scalars['Float']>;
  fruitAmt?: Maybe<Scalars['Float']>;
  fruitAndWastagePlusStick?: Maybe<Scalars['Float']>;
  fruitAndWastageWt?: Maybe<Scalars['Float']>;
  fruitNetWt?: Maybe<Scalars['Float']>;
  fruitWt: Scalars['Float'];
  harvestingTeamName?: Maybe<BaseUserType>;
  id: Scalars['ID'];
  leafWt: Scalars['Float'];
  metadata: Scalars['JSONString'];
  netWeightAfterDeduction?: Maybe<Scalars['Float']>;
  packagingMaterialItems?: Maybe<Array<Maybe<PackagingMaterialItemType>>>;
  packagingmaterialitemSet: Array<PackagingMaterialItemType>;
  plotVisitorName?: Maybe<DeliveryAgentManagementType>;
  pmSupervisorName?: Maybe<BaseUserType>;
  region?: Maybe<PackagingMaterialRegionType>;
  remark?: Maybe<Scalars['String']>;
  schedule?: Maybe<ScheduleType>;
  scheduleSet: Array<ScheduleType>;
  sendWhatsappApproval: Scalars['Boolean'];
  stickAmt?: Maybe<Scalars['Float']>;
  stickWt: Scalars['Float'];
  stickWtCalc?: Maybe<Scalars['Float']>;
  stickWtPercent: Scalars['Float'];
  supplierType?: Maybe<PackagingMaterialSupplierType>;
  totalAmt?: Maybe<Scalars['Float']>;
  totalDispatchedBoxWt?: Maybe<Scalars['Float']>;
  totalHarvestQuantity?: Maybe<Scalars['Int']>;
  totalHarvestWt: Scalars['Float'];
  totalHarvestedBoxWt?: Maybe<Scalars['Float']>;
  totalQuantity?: Maybe<Scalars['Int']>;
  totalReceivedQuantity?: Maybe<Scalars['Int']>;
  totalReceivedTareWt?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  vendorRate?: Maybe<Scalars['Float']>;
  wastageAmt?: Maybe<Scalars['Float']>;
  wasteageWt: Scalars['Float'];
  weightSlip: Scalars['Float'];
};

export type PackingAllotmentInput = {
  allotedQuantity?: InputMaybe<Scalars['Int']>;
  allotedWeight?: InputMaybe<Scalars['Float']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  inwardAllocationId: Scalars['ID'];
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  productionLineId?: InputMaybe<Scalars['ID']>;
  reversalReason?: InputMaybe<Scalars['String']>;
  reverseQuantity?: InputMaybe<Scalars['Int']>;
  reverseWeight?: InputMaybe<Scalars['Float']>;
  sendToLine?: InputMaybe<Scalars['Boolean']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
};

export type PackingAllotmentSelectorType = {
  __typename?: 'PackingAllotmentSelectorType';
  allotedQuantity: Scalars['Int'];
  allotedWeight: Scalars['Float'];
  consumedWeight: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inwardAllocation: InwardAllocationType;
  linepackingallotmentSet: Array<LinePackingAllotmentType>;
  metadata: Scalars['JSONString'];
  productionLine?: Maybe<ProductionLineType>;
  rejectedQuantity: Scalars['Int'];
  rejectedWeight: Scalars['Float'];
  reversalReason?: Maybe<Scalars['String']>;
  reverseQuantity: Scalars['Int'];
  reverseWeight: Scalars['Float'];
  selected?: Maybe<Scalars['Boolean']>;
  sendToLine: Scalars['Boolean'];
  supervisor?: Maybe<DeliveryAgentManagementType>;
  updatedAt: Scalars['DateTime'];
};

export type PackingAllotmentType = {
  __typename?: 'PackingAllotmentType';
  allotedQuantity: Scalars['Int'];
  allotedWeight: Scalars['Float'];
  consumedWeight: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inwardAllocation: InwardAllocationType;
  linepackingallotmentSet: Array<LinePackingAllotmentType>;
  metadata: Scalars['JSONString'];
  productionLine?: Maybe<ProductionLineType>;
  rejectedQuantity: Scalars['Int'];
  rejectedWeight: Scalars['Float'];
  reversalReason?: Maybe<Scalars['String']>;
  reverseQuantity: Scalars['Int'];
  reverseWeight: Scalars['Float'];
  sendToLine: Scalars['Boolean'];
  supervisor?: Maybe<DeliveryAgentManagementType>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PackingMaterialType {
  /** Primary */
  PRIMARY = 'PRIMARY',
  /** Secondary */
  SECONDARY = 'SECONDARY'
}

export type ParameterValue = {
  __typename?: 'ParameterValue';
  averageValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  standard?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentGraphType = {
  __typename?: 'PaymentGraphType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentSet: Array<PaymentType>;
};

export type PaymentLinkDetail = {
  __typename?: 'PaymentLinkDetail';
  emailStatus?: Maybe<Scalars['String']>;
  paymentLink?: Maybe<Scalars['String']>;
  pblResponse?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  smsStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  transactionSet: Array<TransactionGraphType>;
};

export type PaymentSettleInput = {
  amount: Scalars['Int'];
  orderId: Scalars['ID'];
  settledForTransactionId?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum PaymentTransactionType {
  /** Cash */
  CASH = 'CASH',
  /** Cheque */
  CHEQ = 'CHEQ',
  /** NEFT */
  NEFT = 'NEFT',
  /** RTGS */
  RTGS = 'RTGS',
  /** UPI Payment */
  UPIP = 'UPIP'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  amount: Scalars['Float'];
  attachments: Array<MediaEntityType>;
  contract?: Maybe<ContractType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  objectId: Scalars['Int'];
  paidTo: DeliveryAgentManagementType;
  paymentType: PaymentGraphType;
  remark: Scalars['String'];
  transactionType: PaymentTransactionType;
  updatedAt: Scalars['DateTime'];
};

export type PaymentsFilterInput = {
  aggregatorId: Scalars['ID'];
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  group?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
  /** 'cash | cheque | digital' orders and transactions will be filtered according to payment method */
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
};

export type PendingPaymentStatus = {
  __typename?: 'PendingPaymentStatus';
  hasPendingPayment?: Maybe<Scalars['Boolean']>;
  pendingOrders?: Maybe<Array<Maybe<OrderType>>>;
  totalPendingAmount?: Maybe<Scalars['Float']>;
};

export type PeriodicTaskFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  isOk?: InputMaybe<Scalars['Boolean']>;
  lastRunAt_Gte?: InputMaybe<Scalars['DateTime']>;
  lastRunAt_Lte?: InputMaybe<Scalars['DateTime']>;
  oneOff?: InputMaybe<Scalars['Boolean']>;
  startTime_Gte?: InputMaybe<Scalars['DateTime']>;
  startTime_Lte?: InputMaybe<Scalars['DateTime']>;
  task?: InputMaybe<Scalars['String']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']>;
};

export type PeriodicTaskType = {
  __typename?: 'PeriodicTaskType';
  /** JSON encoded positional arguments (Example: ["arg1", "arg2"]) */
  args: Scalars['String'];
  /** Datetime that this PeriodicTask was last modified */
  dateChanged: Scalars['DateTime'];
  /** Detailed description about the details of this Periodic Task */
  description: Scalars['String'];
  /** Set to False to disable the schedule */
  enabled: Scalars['Boolean'];
  /** Datetime after which the schedule will no longer trigger the task to run */
  expires?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** JSON encoded keyword arguments (Example: {"argument": "value"}) */
  kwargs: Scalars['String'];
  /** Datetime that the schedule last triggered the task to run. Reset to None if enabled is set to False. */
  lastRunAt?: Maybe<Scalars['DateTime']>;
  latestLog?: Maybe<TaskLogType>;
  logs: Array<TaskLogType>;
  /** Short Description For This Task */
  name: Scalars['String'];
  /** If True, the schedule will only run the task a single time */
  oneOff: Scalars['Boolean'];
  /** Queue defined in CELERY_TASK_QUEUES. Leave None for default queuing. */
  queue?: Maybe<Scalars['String']>;
  scheduleName?: Maybe<Scalars['String']>;
  /** Datetime when the schedule should begin triggering the task to run */
  startTime?: Maybe<Scalars['DateTime']>;
  /** The Name of the Celery Task that Should be Run.  (Example: "proj.tasks.import_contacts") */
  task: Scalars['String'];
  /** Running count of how many times the schedule has triggered the task */
  totalRunCount: Scalars['Int'];
};

export type PermissionType = {
  __typename?: 'PermissionType';
  codename: Scalars['String'];
  groupSet: Array<GroupType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Specific permissions for this user. */
  userSet: Array<DeliveryAgentManagementType>;
};

/** Mutation to load collected crates for a booking */
export type PickupBookingMutation = {
  __typename?: 'PickupBookingMutation';
  booking?: Maybe<BookingType>;
};

export type PickupReturnOrderInput = {
  orderItemBatchId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  returnReason?: InputMaybe<Scalars['String']>;
  returnType?: InputMaybe<Scalars['String']>;
};

export type PlotCertificationType = {
  __typename?: 'PlotCertificationType';
  certificationNumber: Scalars['String'];
  certificationType: CertificationGraphType;
  id: Scalars['ID'];
  plot: PlotType;
};

export type PlotCommodityCertificationType = {
  __typename?: 'PlotCommodityCertificationType';
  certificationNumber: Scalars['String'];
  certificationType: CertificationGraphType;
  id: Scalars['ID'];
  plotCommodity: PlotCommodityType;
};

export type PlotCommodityFilterInput = {
  assignedTo?: InputMaybe<Scalars['Int']>;
  companyTags?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crop?: InputMaybe<Scalars['String']>;
  harvestingDate?: InputMaybe<Scalars['Date']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  poStatus?: InputMaybe<Scalars['Boolean']>;
  samplingStatus?: InputMaybe<FilterSampleInput>;
  sowingDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
  varietyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  village?: InputMaybe<Scalars['String']>;
};

export type PlotCommodityInput = {
  agronomist?: InputMaybe<Scalars['Int']>;
  certifications?: InputMaybe<Array<InputMaybe<CertificationInput>>>;
  growingCycle?: InputMaybe<Scalars['Int']>;
  harvestingDate?: InputMaybe<Scalars['Date']>;
  numberOfSaplings?: InputMaybe<Scalars['Int']>;
  sowingDate?: InputMaybe<Scalars['Date']>;
  variety?: InputMaybe<Scalars['Int']>;
};

export type PlotCommodityRequirementInput = {
  estimatedQuantity: Scalars['Int'];
  plotCommodity: Scalars['Int'];
  skuType?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PlotCommoditySampleChemicalStatus {
  /** Pass */
  DN = 'DN',
  /** Not Sampled */
  ND = 'ND',
  /** Fail */
  RJ = 'RJ',
  /** Waiting */
  WT = 'WT'
}

export type PlotCommoditySampleInput = {
  chemicalStatus?: InputMaybe<Scalars['String']>;
  chemicalTestDate?: InputMaybe<Scalars['Date']>;
  detectionCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  market?: InputMaybe<Scalars['Int']>;
  maxDetection?: InputMaybe<Scalars['Float']>;
  physicalStatus?: InputMaybe<Scalars['String']>;
  physicalTestDate?: InputMaybe<Scalars['Date']>;
  totalDetection?: InputMaybe<Scalars['Float']>;
};

export type PlotCommoditySampleObservationType = {
  __typename?: 'PlotCommoditySampleObservationType';
  detectionCount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isSuitable: Scalars['Boolean'];
  plotCommoditySample: PlotCommoditySampleType;
  qualityParameter: QualityParameterType;
  score?: Maybe<Scalars['Float']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum PlotCommoditySamplePhysicalStatus {
  /** Pass */
  DN = 'DN',
  /** Not Sampled */
  ND = 'ND',
  /** Fail */
  RJ = 'RJ',
  /** Waiting */
  WT = 'WT'
}

export type PlotCommoditySampleType = {
  __typename?: 'PlotCommoditySampleType';
  chemicalStatus: PlotCommoditySampleChemicalStatus;
  chemicalStatusDisplay?: Maybe<Scalars['String']>;
  chemicalTestDate: Scalars['Date'];
  created: Scalars['DateTime'];
  detectionCount: Scalars['Int'];
  id: Scalars['ID'];
  inwardallocationSet: Array<InwardAllocationType>;
  market?: Maybe<MarketType>;
  maxDetection: Scalars['Float'];
  observations?: Maybe<Array<Maybe<PlotCommoditySampleObservationType>>>;
  physicalStatus: PlotCommoditySamplePhysicalStatus;
  physicalStatusDisplay?: Maybe<Scalars['String']>;
  physicalTestDate: Scalars['Date'];
  plotCommodity: PlotCommodityType;
  resultPdfUid?: Maybe<Scalars['String']>;
  resultPdfUrl?: Maybe<Scalars['String']>;
  totalDetection: Scalars['Float'];
  updated: Scalars['DateTime'];
};


export type PlotCommoditySampleTypeObservationsArgs = {
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum PlotCommodityStatus {
  /** Harvesting Done */
  CMP = 'CMP',
  /** Hold for Alert Chemical */
  HAC = 'HAC',
  /** On Hold */
  HLD = 'HLD',
  /** Not Ready for Harvest */
  NRD = 'NRD',
  /** Ready for Harvest */
  RDY = 'RDY',
  /** Scheduled for Harvest */
  SCH = 'SCH',
  /** Harvest in Progress */
  WIP = 'WIP'
}

export type PlotCommodityType = {
  __typename?: 'PlotCommodityType';
  actualHarvestQuantity: Scalars['Float'];
  agronomist?: Maybe<DeliveryAgentManagementType>;
  alternateCropGroup?: Maybe<CommodityGroupType>;
  certifications: Array<PlotCommodityCertificationType>;
  created: Scalars['DateTime'];
  demandSet: Array<DemandType>;
  estimatedHarvestQuantity: Scalars['Float'];
  generatePoPlotWise: Scalars['Boolean'];
  governmentalCode: Scalars['String'];
  growingCycle: Scalars['Int'];
  harvestProjections: Array<HarvestProjectionType>;
  harvestingDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  isFinishedGood: Scalars['Boolean'];
  isOrganic: Scalars['Boolean'];
  isRawMaterial: Scalars['Boolean'];
  isSeed: Scalars['Boolean'];
  lastSample?: Maybe<PlotCommoditySampleType>;
  lastTradeProfile?: Maybe<TradeProfileType>;
  name: Scalars['String'];
  numberOfSaplings: Scalars['Int'];
  plot: PlotType;
  purchaseorderSet: Array<PurchaseOrderType>;
  referenceId: Scalars['String'];
  registrationCode: Scalars['String'];
  samples?: Maybe<Array<Maybe<PlotCommoditySampleType>>>;
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  sowingDate?: Maybe<Scalars['Date']>;
  status: PlotCommodityStatus;
  statusDisplay?: Maybe<Scalars['String']>;
  totalEstimatedProduce?: Maybe<Scalars['Float']>;
  tradeProfiles?: Maybe<Array<Maybe<TradeProfileType>>>;
  tradeprofileSet: Array<TradeProfileType>;
  updated: Scalars['DateTime'];
  variety: CommodityVarietyType;
};

export type PlotInput = {
  address?: InputMaybe<AddressInput>;
  certifications?: InputMaybe<Array<InputMaybe<CertificationInput>>>;
  codename?: InputMaybe<Scalars['String']>;
  crops?: InputMaybe<Array<InputMaybe<PlotCommodityInput>>>;
  gatNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  soilType?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  variety?: InputMaybe<Scalars['Int']>;
};

export type PlotInwardSummary = {
  __typename?: 'PlotInwardSummary';
  farmWeight?: Maybe<Scalars['Float']>;
  finalWeight?: Maybe<Scalars['Float']>;
  inwardQuantity?: Maybe<Scalars['Float']>;
  netWeight?: Maybe<Scalars['Float']>;
  payableAmount?: Maybe<Scalars['Float']>;
};

export type PlotType = {
  __typename?: 'PlotType';
  address: AddressType;
  area: Scalars['Float'];
  certifications: Array<PlotCertificationType>;
  codename: Scalars['String'];
  company?: Maybe<CompanyType>;
  created: Scalars['DateTime'];
  crops: Array<PlotCommodityType>;
  farmer: DeliveryAgentManagementType;
  gatNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  scheduleSet: Array<ScheduleType>;
  soilType?: Maybe<SoilGraphType>;
  updated: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type PointOfContactInput = {
  address?: InputMaybe<AddressInput>;
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>>>;
  email?: InputMaybe<Scalars['String']>;
  familyGroupHierarchyId?: InputMaybe<Scalars['ID']>;
  familyGroupId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  secondaryNumber?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type PortType = {
  __typename?: 'PortType';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  shipmentplanSet: Array<ShipmentPlanType>;
};

export type PriceBenchmarkDataInput = {
  gradeId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  prices?: InputMaybe<Array<InputMaybe<PriceInput>>>;
};

export type PriceBenchmarkDataQueryInput = {
  benchmarkDoneById?: InputMaybe<Scalars['ID']>;
  benchmarkType?: InputMaybe<Scalars['String']>;
  commodityGroupId?: InputMaybe<Scalars['ID']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  gradeId?: InputMaybe<Scalars['ID']>;
  marketYardId?: InputMaybe<Scalars['ID']>;
  pricingDoneOn?: InputMaybe<Scalars['String']>;
  recommendedBenchmarkRate?: InputMaybe<Scalars['Float']>;
  rejection?: InputMaybe<Scalars['Float']>;
};

export type PriceBenchmarkDataType = {
  __typename?: 'PriceBenchmarkDataType';
  createdAt: Scalars['DateTime'];
  grade: HarvestGradeType;
  gradePrices: Array<GradePriceType>;
  id: Scalars['ID'];
  metadata: PriceBenchmarkMetadataType;
  photos: Array<MediaEntityType>;
  updatedAt: Scalars['DateTime'];
};

export type PriceBenchmarkMetadataType = {
  __typename?: 'PriceBenchmarkMetadataType';
  benchmarkedBy: DeliveryAgentManagementType;
  benchmarkingDoneIn: DepartmentType;
  commodityGroup: CommodityGroupType;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  marketYard: MarketYardType;
  pricebenchmarkdataSet: Array<PriceBenchmarkDataType>;
  recordedAt: AddressType;
  seller: SellerType;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PriceBenchmarkRecommendationBenchmarkType {
  /** Customer Sale */
  CUS = 'CUS',
  /** Farmer Purchase */
  FRP = 'FRP',
  /** Retail Purchase */
  RTP = 'RTP',
  /** Retail Sale */
  RTS = 'RTS',
  /** Wholesale Purchase */
  WHP = 'WHP',
  /** Wholesale Sale */
  WHS = 'WHS'
}

export type PriceBenchmarkRecommendationFilterInput = {
  benchmarkTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  benchmarkingDoneIn?: InputMaybe<Scalars['ID']>;
  commodityGroup?: InputMaybe<Scalars['ID']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  grade_Name?: InputMaybe<Scalars['String']>;
  marketYard?: InputMaybe<Scalars['ID']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
};

export type PriceBenchmarkRecommendationType = {
  __typename?: 'PriceBenchmarkRecommendationType';
  averagePrice: GradePriceType;
  benchmarkType?: Maybe<PriceBenchmarkRecommendationBenchmarkType>;
  benchmarkedAt?: Maybe<AddressType>;
  benchmarkedBy?: Maybe<DeliveryAgentManagementType>;
  benchmarkingDoneIn?: Maybe<DepartmentType>;
  commodityGroup: CommodityGroupType;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  grade: HarvestGradeType;
  id: Scalars['ID'];
  marketYard: MarketYardType;
  recommendedPrice: GradePriceType;
  updatedAt: Scalars['DateTime'];
};

export type PriceBenchmarkSummary = {
  __typename?: 'PriceBenchmarkSummary';
  commodityGroup?: Maybe<CommodityGroupType>;
  date?: Maybe<Scalars['Date']>;
  grade?: Maybe<HarvestGradeType>;
  isRecommended?: Maybe<Scalars['Boolean']>;
  logCount?: Maybe<Scalars['Int']>;
  marketYard?: Maybe<MarketYardType>;
};

export type PriceInput = {
  gradeId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  isDefault: Scalars['Boolean'];
  price: Scalars['Float'];
  priceLimit: Scalars['Float'];
  priceUnitId: Scalars['ID'];
  pricingDoneOn: Scalars['String'];
  rejection?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  uomTypeId: Scalars['ID'];
};

export type ProductionBatchType = {
  __typename?: 'ProductionBatchType';
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variety: CommodityVarietyType;
};

export type ProductionItemInput = {
  boxCount?: InputMaybe<Scalars['Int']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  linePackingAllotments?: InputMaybe<Array<InputMaybe<LinePackingAllotmentInput>>>;
  lineTradeProfiles?: InputMaybe<Array<InputMaybe<LineTradeProfileInput>>>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletType?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
};

export type ProductionItemType = {
  __typename?: 'ProductionItemType';
  boxCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  id: Scalars['ID'];
  linepackingallotmentSet: Array<LinePackingAllotmentType>;
  linetradeprofileSet: Array<LineTradeProfileType>;
  metadata: Scalars['JSONString'];
  palletNo: Scalars['String'];
  palletType?: Maybe<Scalars['String']>;
  production: ProductionType;
  remark: Scalars['String'];
  sequenceNumber: Scalars['Int'];
  supervisor?: Maybe<DeliveryAgentManagementType>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};

export type ProductionLineType = {
  __typename?: 'ProductionLineType';
  codename: Scalars['String'];
  currentDepartment?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  preferredDepot?: Maybe<DepotType>;
};

export type ProductionType = {
  __typename?: 'ProductionType';
  certificateNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  department?: Maybe<DepartmentType>;
  farmerNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  gatePasses?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  metadata: Scalars['JSONString'];
  productionLine: ProductionLineType;
  productionStatus?: Maybe<Scalars['String']>;
  productionitemSet: Array<ProductionItemType>;
  sendForApproval: Scalars['Boolean'];
  shipmentPlan: ShipmentPlanType;
  supervisorNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
  weeklySrNo: Scalars['String'];
};

export type ProductionUpsertInput = {
  delete?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<ProductionItemInput>>>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  productionLineId: Scalars['ID'];
  sendForApproval?: InputMaybe<Scalars['Boolean']>;
  weeklySrNo: Scalars['String'];
};

export type PurchaseOrderItemType = {
  __typename?: 'PurchaseOrderItemType';
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  grade: HarvestGradeType;
  id: Scalars['ID'];
  po: PurchaseOrderType;
  quantity: Scalars['Float'];
  schedule: ScheduleType;
  unitPrice: Scalars['Float'];
  uomType: PurchaseOrderItemUomType;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PurchaseOrderItemUomType {
  /** Bag */
  BG = 'BG',
  /** Box */
  BX = 'BX',
  /** Crate */
  CP = 'CP',
  /** Piece */
  EA = 'EA',
  /** Kilogram */
  KG = 'KG'
}

/** An enumeration. */
export enum PurchaseOrderStatus {
  /** Closed */
  CLS = 'CLS',
  /** Cancelled */
  CNC = 'CNC',
  /** Open */
  OPN = 'OPN',
  /** Received */
  RCV = 'RCV',
  /** Sent */
  SNT = 'SNT'
}

export type PurchaseOrderType = {
  __typename?: 'PurchaseOrderType';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isSent: Scalars['Boolean'];
  items: Array<PurchaseOrderItemType>;
  plotCommodity: PlotCommodityType;
  status: PurchaseOrderStatus;
  updatedAt: Scalars['DateTime'];
};

export type PureBaseUserInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
};

export type QualityObservationGraphValueType = {
  __typename?: 'QualityObservationGraphValueType';
  id: Scalars['ID'];
  observation: QualityObservationType;
  parameter: QualityParameterType;
  value: Scalars['String'];
};

export type QualityObservationType = {
  __typename?: 'QualityObservationType';
  id: Scalars['ID'];
  isAverage: Scalars['Boolean'];
  parameterValues: Array<QualityObservationGraphValueType>;
  sample: QualitySampleType;
};

export type QualityParameterInput = {
  dropdownValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  internalExternal?: InputMaybe<Scalars['String']>;
  labelingInstructions?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  packagingMaterial?: InputMaybe<Scalars['String']>;
  parameterType?: InputMaybe<Scalars['String']>;
  shelfLife?: InputMaybe<Scalars['String']>;
  standard?: InputMaybe<Scalars['String']>;
  storageConditions?: InputMaybe<Scalars['String']>;
  transportation?: InputMaybe<Scalars['String']>;
  valueType?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum QualityParameterInternalExternal {
  /** External */
  EXTL = 'EXTL',
  /** Internal */
  INTL = 'INTL'
}

/** An enumeration. */
export enum QualityParameterParameterType {
  /** Biological */
  BIOL = 'BIOL',
  /** Chemical */
  CHEM = 'CHEM',
  /** Heavy Metal */
  HVYM = 'HVYM',
  /** Microbial */
  MCRO = 'MCRO',
  /** Physical */
  PHYS = 'PHYS'
}

export type QualityParameterType = {
  __typename?: 'QualityParameterType';
  codename: Scalars['String'];
  dropdownValues: Array<Maybe<Scalars['String']>>;
  exportcustomervalidationSet: Array<ExportCustomerValidationType>;
  frequency: Scalars['String'];
  id: Scalars['ID'];
  internalExternal: QualityParameterInternalExternal;
  labelingInstructions: Scalars['String'];
  method: Scalars['String'];
  mrl: Scalars['Float'];
  name: Scalars['String'];
  observations: Array<PlotCommoditySampleObservationType>;
  packagingMaterial: Scalars['String'];
  parameterType: QualityParameterParameterType;
  qualityobservationvalueSet: Array<QualityObservationGraphValueType>;
  shelfLife: Scalars['String'];
  spinnerItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  standard: Scalars['String'];
  storageConditions: Scalars['String'];
  transportation: Scalars['String'];
  valueType: QualityParameterValueType;
  varieties: Array<CommodityVarietyType>;
};

/** An enumeration. */
export enum QualityParameterValueType {
  /** Boolean */
  BOOL = 'BOOL',
  /** Dropdown */
  DROP = 'DROP',
  /** Number */
  NUMB = 'NUMB',
  /** Text */
  TEXT = 'TEXT'
}

export type QualitySampleReport = {
  __typename?: 'QualitySampleReport';
  crop?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  extraFields?: Maybe<Array<Maybe<SampleField>>>;
  farmRegistrationNumber?: Maybe<Scalars['String']>;
  farmSealNumber?: Maybe<Scalars['String']>;
  farmer?: Maybe<Scalars['String']>;
  gpn?: Maybe<Scalars['String']>;
  grn?: Maybe<Scalars['String']>;
  parameters?: Maybe<Array<Maybe<ParameterValue>>>;
  reason?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Time']>;
  variety?: Maybe<Scalars['String']>;
  vehicleRegistrationNumber?: Maybe<Scalars['String']>;
  weightReceived?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum QualitySampleStatus {
  /** Accepted under deviation */
  ACCD = 'ACCD',
  /** Accepted */
  ACCP = 'ACCP',
  /** Rejected */
  RJCT = 'RJCT'
}

export type QualitySampleType = {
  __typename?: 'QualitySampleType';
  bookingSet: Array<BookingType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inward?: Maybe<InwardType>;
  observations: Array<QualityObservationType>;
  qualityRejection: Scalars['Float'];
  reason: Scalars['String'];
  recordedOn: Scalars['DateTime'];
  status: QualitySampleStatus;
};

export type QueryRoot = {
  __typename?: 'QueryRoot';
  accountStatement?: Maybe<AccountStatement>;
  accountTransactionDetail?: Maybe<TransactionGraphType>;
  aggregateStockEntryItemsByBatchStockRate?: Maybe<Array<Maybe<StockEntryItemsByBatchStockRate>>>;
  aggregateStockEntryItemsByLocation?: Maybe<Array<Maybe<StockEntryItemsByLocation>>>;
  aggregateStockTakeApprovalRequestsByDc?: Maybe<Array<Maybe<StockTakeApprovalRequestByDc>>>;
  aggregatedOrderItems?: Maybe<Array<Maybe<ConsolidatedOrderItem>>>;
  aggregatorSettlementDetail?: Maybe<AggregatorDetail>;
  aggregatorTripDetail?: Maybe<TripType>;
  allAccountTransactions?: Maybe<Array<Maybe<TransactionGraphType>>>;
  allAggregatorTrips?: Maybe<Array<Maybe<TripType>>>;
  allAggregatorsSettlements?: Maybe<Array<Maybe<DeliveryAgentManagementType>>>;
  allAnnotatedOrders?: Maybe<Array<Maybe<AnnotatedOrderType>>>;
  allAreaWiseUsers?: Maybe<Array<Maybe<BaseUserType>>>;
  allAssignedRoutePoints?: Maybe<Array<Maybe<AssignedRoutePointType>>>;
  allBanks?: Maybe<Array<Maybe<BankType>>>;
  allBatchStockRates?: Maybe<Array<Maybe<BatchStockRateType>>>;
  allBatchStocks?: Maybe<Array<Maybe<BatchStockType>>>;
  allBeatVisits?: Maybe<Array<Maybe<BeatVisitType>>>;
  allBeats?: Maybe<Array<Maybe<SupBeatType>>>;
  allBookings?: Maybe<Array<Maybe<BookingType>>>;
  allBusienssCategorys?: Maybe<Array<Maybe<BusinessCategoryType>>>;
  allCertificationTypes?: Maybe<Array<Maybe<CertificationGraphType>>>;
  allColorGroups?: Maybe<Array<Maybe<ColorGroupType>>>;
  allCommodities?: Maybe<Array<Maybe<CommodityType>>>;
  allCompanies?: Maybe<Array<Maybe<CompanyType>>>;
  allContractTypes?: Maybe<Array<Maybe<ContractGraphType>>>;
  allCredits?: Maybe<Array<Maybe<CreditType>>>;
  allDataSources?: Maybe<Array<Maybe<DataSourceType>>>;
  allDcCollectionLogs?: Maybe<Array<Maybe<DcCollectionLogType>>>;
  allDcStockTakeConfigs?: Maybe<Array<Maybe<DcStockTakeConfigType>>>;
  allDcStorageLocations?: Maybe<Array<Maybe<DcStorageLocationType>>>;
  allDcSubLocations?: Maybe<Array<Maybe<DcSubLocationType>>>;
  allDemands?: Maybe<AllDemandItems>;
  allDepartments?: Maybe<Array<Maybe<DepartmentType>>>;
  allDepots?: Maybe<Array<Maybe<DepotType>>>;
  allDistributionCentreLocationApprovals?: Maybe<Array<Maybe<DistributionCentreType>>>;
  allDistributionCentreLocations?: Maybe<Array<Maybe<DistributionCentreLocationType>>>;
  allDistributionCentres?: Maybe<Array<Maybe<DistributionCentreType>>>;
  allDocks?: Maybe<Array<Maybe<DockType>>>;
  allExpenseTypes?: Maybe<Array<Maybe<ExpenseGraphType>>>;
  allExportCustomers?: Maybe<Array<Maybe<ExportCustomerType>>>;
  allFamilyGroupHierarchys?: Maybe<Array<Maybe<FamilyGroupHierarchyType>>>;
  allFamilyGroups?: Maybe<Array<Maybe<FamilyGroupType>>>;
  allFuelDistributorItems?: Maybe<Array<Maybe<FuelDistributorItemType>>>;
  allFuelDistributors?: Maybe<Array<Maybe<FuelDistributorType>>>;
  allFuelTypes?: Maybe<Array<Maybe<FuelGraphType>>>;
  allGroups?: Maybe<Array<Maybe<GroupType>>>;
  allInwards?: Maybe<Array<Maybe<InwardType>>>;
  allKycTypes?: Maybe<Array<Maybe<KycGraphType>>>;
  allMarketYards?: Maybe<Array<Maybe<MarketYardType>>>;
  allMarkets?: Maybe<Array<Maybe<MarketType>>>;
  allMyBeatPlans?: Maybe<Array<Maybe<BeatPlanType>>>;
  allMyOrders?: Maybe<Array<Maybe<OrderType>>>;
  allMySellableItemStocks?: Maybe<Array<Maybe<SellableItemStockType>>>;
  allNotificationLog?: Maybe<Array<Maybe<NotificationLogType>>>;
  allNotificationProviders?: Maybe<Array<Maybe<NotificationProviderType>>>;
  allNotificationTempletes?: Maybe<Array<Maybe<NotificationTemplateType>>>;
  allNotificationTriggers?: Maybe<Array<Maybe<NotificationTriggerType>>>;
  allNotifications?: Maybe<Array<Maybe<NotificationType>>>;
  allOrderItemBatchs?: Maybe<Array<Maybe<OrderItemBatchType>>>;
  allOrderItems?: Maybe<Array<Maybe<OrderItemType>>>;
  allOrderStatusTypes?: Maybe<Array<Maybe<StaticType>>>;
  allOrderTransactions?: Maybe<Array<Maybe<OrderTransactionType>>>;
  allOrders?: Maybe<Array<Maybe<OrderType>>>;
  allPackagingMaterialItems?: Maybe<Array<Maybe<PackagingMaterialItemType>>>;
  allPackagingMaterialRegions?: Maybe<Array<Maybe<PackagingMaterialRegionType>>>;
  allPackagingMaterials?: Maybe<Array<Maybe<PackagingMaterialType>>>;
  allPackingMaterials?: Maybe<Array<Maybe<SkuPackingMaterialType>>>;
  allPaymentMethods?: Maybe<Array<Maybe<PaymentMethodType>>>;
  allPaymentTypes?: Maybe<Array<Maybe<PaymentGraphType>>>;
  allPeriodicTasks?: Maybe<Array<Maybe<PeriodicTaskType>>>;
  allPermissions?: Maybe<Array<Maybe<PermissionType>>>;
  allPlotCommodities?: Maybe<Array<Maybe<PlotCommodityType>>>;
  allPorts?: Maybe<Array<Maybe<PortType>>>;
  allPriceBenchmarkData?: Maybe<Array<Maybe<PriceBenchmarkDataType>>>;
  allPriceBenchmarkRecommendations?: Maybe<Array<Maybe<PriceBenchmarkRecommendationType>>>;
  allProductionBatches?: Maybe<Array<Maybe<ProductionBatchType>>>;
  allPurchaseOrders?: Maybe<Array<Maybe<PurchaseOrderType>>>;
  allRegionPercentDetails?: Maybe<Array<Maybe<RegionPercentDetailType>>>;
  allReportMasters?: Maybe<Array<Maybe<ReportType>>>;
  allRouteAssignments?: Maybe<Array<Maybe<RouteAssignmentType>>>;
  allRouteCategorys?: Maybe<Array<Maybe<RouteCategoryType>>>;
  allRoutePoints?: Maybe<Array<Maybe<RoutePointType>>>;
  allRoutes?: Maybe<Array<Maybe<RouteType>>>;
  allScheduleRequests?: Maybe<Array<Maybe<ScheduleRequestObject>>>;
  allScheduleRequestsSummary?: Maybe<ScheduleRequestStatusSummary>;
  allSellableItemGroups?: Maybe<Array<Maybe<SellableItemGroupType>>>;
  allSellableItems?: Maybe<Array<Maybe<SellableItemType>>>;
  allSellers?: Maybe<Array<Maybe<SellerType>>>;
  allShopOrders?: Maybe<Array<Maybe<OrderType>>>;
  allShops?: Maybe<Array<Maybe<ShopType>>>;
  allSiUnits?: Maybe<Array<Maybe<SiUnitType>>>;
  allSkuCategories?: Maybe<Array<Maybe<SkuCategoryType>>>;
  allSkuTypes?: Maybe<Array<Maybe<SkuGraphType>>>;
  allSoilTypes?: Maybe<Array<Maybe<SoilGraphType>>>;
  allStates?: Maybe<Array<Maybe<StateType>>>;
  allStaticTypes?: Maybe<Array<Maybe<StaticType>>>;
  allStockEntryItems?: Maybe<Array<Maybe<StockEntryItemType>>>;
  allStockTakeApprovalRequests?: Maybe<Array<Maybe<StockTakeApprovalRequestType>>>;
  allSuperviseSummarys?: Maybe<Array<Maybe<SuperviseSummaryType>>>;
  allSurveyAreas?: Maybe<Array<Maybe<SurveyAreaLocationType>>>;
  allTaskLogs?: Maybe<Array<Maybe<TaskLogType>>>;
  allTasks?: Maybe<Array<Maybe<Scalars['String']>>>;
  allTimeSlots?: Maybe<Array<Maybe<TimeSlotType>>>;
  allTradeYears?: Maybe<Array<Maybe<TradeYearType>>>;
  allTransactionTypes?: Maybe<Array<Maybe<TransactionTypeType>>>;
  allTransactions?: Maybe<Array<Maybe<TransactionGraphType>>>;
  allTripSteps?: Maybe<Array<Maybe<TripStepType>>>;
  allTrips?: Maybe<Array<Maybe<TripType>>>;
  allUnloadingSubLocations?: Maybe<Array<Maybe<UnloadingSubLocationType>>>;
  allUnloadingTeams?: Maybe<Array<Maybe<UnloadingTeamType>>>;
  allUserFilters?: Maybe<Array<Maybe<UserFilterType>>>;
  allUserQuerys?: Maybe<Array<Maybe<UserQueryType>>>;
  allV1NotificationTemplates?: Maybe<Array<Maybe<NewNotificationTemplateType>>>;
  allVarieties?: Maybe<Array<Maybe<CommodityVarietyType>>>;
  allVarietyGroups?: Maybe<Array<Maybe<CommodityGroupType>>>;
  allVehicleKind?: Maybe<Array<Maybe<VehicleKindType>>>;
  allVehicleTypes?: Maybe<Array<Maybe<VehicleGraphType>>>;
  allVehicles?: Maybe<Array<Maybe<VehicleType>>>;
  allVehiclesDetail?: Maybe<Array<Maybe<VehicleType>>>;
  allVendorsBySurveyAreas?: Maybe<Array<Maybe<BaseUserType>>>;
  annotatedOrderDetail?: Maybe<AnnotatedOrderType>;
  approvedTradeProfiles?: Maybe<Array<Maybe<ApprovedTradeProfileType>>>;
  areaWiseUserDetail?: Maybe<BaseUserType>;
  assignedRoutePointDetail?: Maybe<AssignedRoutePointType>;
  assignedVehiclesTrips?: Maybe<Array<Maybe<TripType>>>;
  assigneeAggregate?: Maybe<SuperviseSummaryType>;
  batchStockDetail?: Maybe<BatchStockType>;
  batchStockRateBySellableItem?: Maybe<Array<Maybe<BatchStockBySellableItem>>>;
  batchStockRateDetail?: Maybe<BatchStockRateType>;
  batchStockWiseVisibility?: Maybe<Array<Maybe<BatchStockWiseVisibility>>>;
  batchStockWiseVisibilityDispatchDateWise?: Maybe<Array<Maybe<BatchStockWiseVisibilityDispatchDateWise>>>;
  beatDetail?: Maybe<SupBeatType>;
  beatVisitDetail?: Maybe<BeatVisitType>;
  bookingDetails?: Maybe<BookingType>;
  bookingsByOrderItem?: Maybe<Array<Maybe<BookingType>>>;
  bookingsBySellableItems?: Maybe<Array<Maybe<BookingType>>>;
  bookingsBySku?: Maybe<Array<Maybe<BookingType>>>;
  bookingsByTrip?: Maybe<Array<Maybe<BookingType>>>;
  busienssCategoryDetail?: Maybe<BusinessCategoryType>;
  cacheTest?: Maybe<Scalars['String']>;
  collectionList?: Maybe<Array<Maybe<CollectionType>>>;
  collectionTotals?: Maybe<CollectionTotalType>;
  companyBankDetails?: Maybe<BankDetailType>;
  companyDetails?: Maybe<CompanyType>;
  contractDetails?: Maybe<ContractType>;
  contractExpenses?: Maybe<Array<Maybe<ExpenseType>>>;
  contractPayments?: Maybe<Array<Maybe<PaymentType>>>;
  creditDetail?: Maybe<CreditType>;
  customInvoiceDetail?: Maybe<OrderInvoiceDetail>;
  dailyMasterOtp?: Maybe<Scalars['Int']>;
  dataSourceDetail?: Maybe<DataSourceType>;
  dcCollectionLogDetail?: Maybe<DcCollectionLogType>;
  dcStockTakeConfigDetail?: Maybe<DcStockTakeConfigType>;
  dcStorageLocationDetail?: Maybe<DcStorageLocationType>;
  dcSubLocationDetail?: Maybe<DcSubLocationType>;
  dcWiseAggregateVisibility?: Maybe<Array<Maybe<DcWiseStockVisibility>>>;
  demandDetails?: Maybe<DemandType>;
  departmentDetails?: Maybe<DepartmentType>;
  distributionCentreDetail?: Maybe<DistributionCentreType>;
  distributionCentreLocationApprovalDetail?: Maybe<DistributionCentreType>;
  distributionCentreLocationDetail?: Maybe<DistributionCentreLocationType>;
  dmsTripStepGraph?: Maybe<Array<Maybe<DmsTripStepType>>>;
  dockDetail?: Maybe<DockType>;
  driverTrips?: Maybe<Array<Maybe<TripType>>>;
  eligibleExportCustomersBySample?: Maybe<Array<Maybe<ExportCustomerType>>>;
  exportReport?: Maybe<ReportTemplateType>;
  familyGroupDetail?: Maybe<FamilyGroupType>;
  familyGroupHierarchyDetail?: Maybe<FamilyGroupHierarchyType>;
  fetchBatchStockStatus?: Maybe<FetchBatchStockStatusType>;
  filterPlots?: Maybe<Array<Maybe<PlotType>>>;
  fuelDistributor?: Maybe<FuelDistributorType>;
  fuelDistributorItem?: Maybe<FuelDistributorItemType>;
  fundFlow?: Maybe<FundFlowType>;
  gateLogStatus?: Maybe<GateLogStatusType>;
  gateNumbers?: Maybe<Array<Maybe<GateNumberType>>>;
  gatepassSelector?: Maybe<Array<Maybe<PackingAllotmentSelectorType>>>;
  generateOtp?: Maybe<UserExistsStatus>;
  generatePaymentLink?: Maybe<PaymentLinkDetail>;
  groupDetails?: Maybe<GroupType>;
  handedoverAmount?: Maybe<Scalars['Float']>;
  harvestGradesForVariety?: Maybe<Array<Maybe<HarvestGradeType>>>;
  harvestProjection?: Maybe<HarvestProjectionPayloadType>;
  hasPendingPayment?: Maybe<PendingPaymentStatus>;
  holdingArea?: Maybe<HoldingAreaType>;
  holdingAreas?: Maybe<Array<Maybe<HoldingAreaType>>>;
  inwardAllocation?: Maybe<InwardAllocationType>;
  inwardAllocations?: Maybe<Array<Maybe<InwardAllocationType>>>;
  inwardByPlotCommodity?: Maybe<Array<Maybe<InwardType>>>;
  inwardedSummary?: Maybe<InwardSummary>;
  kyfDetails?: Maybe<KnowYourFarmerOutput>;
  linePackingAllotment?: Maybe<LinePackingAllotmentType>;
  linePackingAllotments?: Maybe<Array<Maybe<LinePackingAllotmentType>>>;
  lineTradeProfile?: Maybe<LineTradeProfileType>;
  lineTradeProfiles?: Maybe<Array<Maybe<LineTradeProfileType>>>;
  matchProfilesByCustId?: Maybe<Array<Maybe<TradeProfileType>>>;
  me?: Maybe<Me>;
  metabaseUrl?: Maybe<MetabaseUrlType>;
  myBeatPlanDetail?: Maybe<BeatPlanType>;
  myBookings?: Maybe<Array<Maybe<BookingType>>>;
  myCupons?: Maybe<Array<Maybe<DiscountType>>>;
  myOrderDetail?: Maybe<OrderType>;
  myReportTemplates?: Maybe<Array<Maybe<ReportTemplateType>>>;
  mySellableItemStockDetail?: Maybe<SellableItemStockType>;
  myTrips?: Maybe<Array<Maybe<TripType>>>;
  netSaleTotals?: Maybe<NetSaleAmountType>;
  notificationById?: Maybe<NotificationType>;
  notificationProviderDetail?: Maybe<NotificationProviderType>;
  notificationTemplateById?: Maybe<NotificationTemplateType>;
  notificationTriggerDetail?: Maybe<NotificationTriggerType>;
  notifyUsers?: Maybe<Array<Maybe<ScheduleType>>>;
  orderCountFilter?: Maybe<Scalars['Int']>;
  orderDetail?: Maybe<OrderType>;
  orderInvoiceDetail?: Maybe<OrderInvoiceDetail>;
  orderItemBatchDetail?: Maybe<OrderItemBatchType>;
  orderItemBatchTrack?: Maybe<OibTrackType>;
  orderItemDetail?: Maybe<OrderItemType>;
  orderTransactionByReferenceId?: Maybe<OrderTransactionType>;
  orderTransactionDetail?: Maybe<OrderTransactionType>;
  orderValueBySellableItem?: Maybe<Array<Maybe<SellableItemType>>>;
  ordersBySellableItem?: Maybe<Array<Maybe<OrderBySellableItem>>>;
  organisationDetails?: Maybe<OrganisationType>;
  outstandingUserDetail?: Maybe<OutstandingUserDetailType>;
  outstandingUsers?: Maybe<Array<Maybe<OutstandingUserSummaryType>>>;
  packagingMaterial?: Maybe<PackagingMaterialType>;
  packagingMaterialItem?: Maybe<PackagingMaterialItemType>;
  packagingMaterialRegion?: Maybe<PackagingMaterialRegionType>;
  packingAllotment?: Maybe<PackingAllotmentType>;
  packingAllotments?: Maybe<Array<Maybe<PackingAllotmentType>>>;
  paymentMethodDetail?: Maybe<PaymentMethodType>;
  paymentVerificationOrders?: Maybe<Array<Maybe<OrderType>>>;
  paymentsByAggregator?: Maybe<Array<Maybe<OrderTransactionType>>>;
  payuTransactionKeys?: Maybe<OnlineTransactionKeys>;
  pendingPriceApprovalSchedules?: Maybe<Array<Maybe<ScheduleType>>>;
  periodicTaskDetail?: Maybe<PeriodicTaskType>;
  plotCommodityDetails?: Maybe<PlotCommodityType>;
  plotDetails?: Maybe<PlotType>;
  plotInwardSummary?: Maybe<PlotInwardSummary>;
  preTripGenerate?: Maybe<Array<Maybe<TripSummaryType>>>;
  priceBenchmarkRecommendationDetail?: Maybe<PriceBenchmarkRecommendationType>;
  priceBenchmarkSummary?: Maybe<Array<Maybe<PriceBenchmarkSummary>>>;
  production?: Maybe<ProductionType>;
  productionBatch?: Maybe<ProductionBatchType>;
  productionItem?: Maybe<ProductionItemType>;
  productionItems?: Maybe<Array<Maybe<ProductionItemType>>>;
  productionLine?: Maybe<ProductionLineType>;
  productionLines?: Maybe<Array<Maybe<ProductionLineType>>>;
  productions?: Maybe<Array<Maybe<ProductionType>>>;
  qualityParametersForVariety?: Maybe<Array<Maybe<QualityParameterType>>>;
  qualityReport?: Maybe<QualitySampleReport>;
  reconciliationSummaryFundFlow?: Maybe<Array<Maybe<ReconciliationSummaryFundFlowType>>>;
  referenceGrades?: Maybe<Array<Maybe<HarvestGradeType>>>;
  reportMasterDetail?: Maybe<ReportType>;
  reportTemplateDetail?: Maybe<ReportTemplateType>;
  reviewSummary?: Maybe<ReviewSummary>;
  routeAssignmentDetail?: Maybe<RouteAssignmentType>;
  routeCategoryDetail?: Maybe<RouteCategoryType>;
  routeDetail?: Maybe<RouteType>;
  routePointDetail?: Maybe<RoutePointType>;
  scheduleDetail?: Maybe<ScheduleType>;
  scheduleDetails?: Maybe<ScheduleType>;
  scheduleRequestDetails?: Maybe<ScheduleRequestType>;
  scheduleRequestSummary?: Maybe<Array<Maybe<ScheduleRequestSummary>>>;
  schedulesForDate?: Maybe<Array<Maybe<ScheduleType>>>;
  schedulesForDateSummary?: Maybe<ScheduleForDateSummary>;
  schedulesForPlot?: Maybe<Array<Maybe<ScheduleType>>>;
  schedulesForPlotCommodityFlat?: Maybe<Array<Maybe<ScheduleObject>>>;
  searchPlotCommodity?: Maybe<Array<Maybe<PlotCommodityType>>>;
  sellableItemByAggregator?: Maybe<Array<Maybe<SellableItemType>>>;
  sellableItemDetail?: Maybe<SellableItemType>;
  sellableItemGroupDetail?: Maybe<SellableItemGroupType>;
  sellableItemReviews?: Maybe<Array<Maybe<SellableItemReviewType>>>;
  sellableItemStock?: Maybe<Array<Maybe<SellableItemStockType>>>;
  sellableItemStockCart?: Maybe<Array<Maybe<SellableItemStockType>>>;
  sellableItemStockDetail?: Maybe<SellableItemStockType>;
  sellableItemWiseStockVisibility?: Maybe<Array<Maybe<SellableItemWiseStockVisibility>>>;
  sellableItemsByTrip?: Maybe<Array<Maybe<SellableItemByTripType>>>;
  sendCustomOtp?: Maybe<Scalars['String']>;
  sendDeliveryOtp?: Maybe<UserExistsStatus>;
  sendUserCredentials?: Maybe<Scalars['Boolean']>;
  shipmentPlanById?: Maybe<ShipmentPlanType>;
  shipmentPlanBySoNo?: Maybe<ShipmentPlanType>;
  shipmentPlans?: Maybe<ShipmentPlanList>;
  shopDetail?: Maybe<ShopType>;
  shopOrderDetail?: Maybe<OrderType>;
  siByBooking?: Maybe<Array<Maybe<SiByBooking>>>;
  skuDetails?: Maybe<SkuGraphType>;
  skusByAggregator?: Maybe<Array<Maybe<SkuGraphType>>>;
  skusByTrip?: Maybe<Array<Maybe<SkuByTripType>>>;
  stateDetail?: Maybe<StateType>;
  statementCustomers?: Maybe<StatementCustomerList>;
  stockEntryItemDetail?: Maybe<StockEntryItemType>;
  stockTakeApprovalRequestDetail?: Maybe<StockTakeApprovalRequestType>;
  stockTakeItems?: Maybe<Array<Maybe<StockTakeItem>>>;
  summaryAggregators?: Maybe<AggregatorSummary>;
  summaryAllOrders?: Maybe<SummaryAllOrders>;
  summaryAllVehicle?: Maybe<SummaryAllVehicles>;
  summaryAssignedTrips?: Maybe<TripSummary>;
  summaryBatchStocks?: Maybe<SummaryBatchStocksType>;
  summaryCredits?: Maybe<CreditSummary>;
  summaryFilterDetails?: Maybe<TripFilterSummary>;
  summaryOfOrderByVendor?: Maybe<OrderSummaryOfVendor>;
  summaryOfPaymentsByAggregator?: Maybe<SummaryOfPaymentsByAggregator>;
  summarySalesManagementCustomers?: Maybe<SummarySalesManagement>;
  summarySellableItems?: Maybe<Array<Maybe<SummarySellableItemsType>>>;
  summarySkus?: Maybe<Array<Maybe<SummarySkusType>>>;
  summaryStockTakeApprovalRequestsByDc?: Maybe<SummaryApprovalRequestByDc>;
  summaryUsersEcom?: Maybe<SummaryUsersEcom>;
  superviseSummaryDetail?: Maybe<SuperviseSummaryType>;
  surveyAreaDetail?: Maybe<SurveyAreaLocationType>;
  syncFarmerPlots?: Maybe<BaseUserType>;
  targetUserCount?: Maybe<TargetUserCountType>;
  taskLogDetail?: Maybe<TaskLogType>;
  transactionDetail?: Maybe<TransactionGraphType>;
  transactionTypeDetail?: Maybe<TransactionTypeType>;
  transportDetail?: Maybe<VehicleTransportDetailType>;
  tripByAggregator?: Maybe<Array<Maybe<TripType>>>;
  tripDateFilter?: Maybe<Array<Maybe<TripType>>>;
  tripDetails?: Maybe<TripType>;
  tripHistory?: Maybe<TripHistorySummary>;
  tripRecommendation?: Maybe<Array<Maybe<PlotCommodityType>>>;
  tripStepDetail?: Maybe<TripStepType>;
  tripStepGraph?: Maybe<Array<Maybe<TripStepOutput>>>;
  tripsForDate?: Maybe<Array<Maybe<TripType>>>;
  userDetailByNumber?: Maybe<BaseUserType>;
  userDetails?: Maybe<BaseUserType>;
  userExistsByNumber?: Maybe<Scalars['Boolean']>;
  userFilterDetail?: Maybe<UserFilterType>;
  userOrderOutstanding?: Maybe<Array<Maybe<UserOrderOutstandingType>>>;
  userQueryDetail?: Maybe<UserQueryType>;
  usersByGroup?: Maybe<Array<Maybe<BaseUserType>>>;
  v1NotificationTemplateDetail?: Maybe<NewNotificationTemplateType>;
  varietyDetails?: Maybe<CommodityVarietyType>;
  vehicleDetails?: Maybe<VehicleType>;
  vehicleList?: Maybe<Array<Maybe<VehicleType>>>;
  vendorsBySalesman?: Maybe<Array<Maybe<BaseUserType>>>;
  vendorsBySalesmanV2?: Maybe<CustomerSales>;
  vendorsBySurveyAreaDetail?: Maybe<BaseUserType>;
  verifyOtp?: Maybe<VerifyOtpStatus>;
};


export type QueryRootAccountStatementArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  userId: Scalars['ID'];
};


export type QueryRootAccountTransactionDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootAggregateStockEntryItemsByBatchStockRateArgs = {
  filter?: InputMaybe<StockEntryItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAggregateStockEntryItemsByLocationArgs = {
  filter?: InputMaybe<StockEntryItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAggregateStockTakeApprovalRequestsByDcArgs = {
  filter?: InputMaybe<StockTakeApprovalRequestInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  summaryInput?: InputMaybe<SummaryRequestInput>;
};


export type QueryRootAggregatedOrderItemsArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  orderingDcId?: InputMaybe<Scalars['ID']>;
  targetDcId: Scalars['ID'];
};


export type QueryRootAggregatorSettlementDetailArgs = {
  aggregatorId: Scalars['ID'];
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootAggregatorTripDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootAllAccountTransactionsArgs = {
  filter?: InputMaybe<TransactionDetailInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllAggregatorTripsArgs = {
  filter?: InputMaybe<AggregatorTripFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllAggregatorsSettlementsArgs = {
  filter?: InputMaybe<AllAggregatorFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  group: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllAnnotatedOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllAreaWiseUsersArgs = {
  filter?: InputMaybe<AreaWiseFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllAssignedRoutePointsArgs = {
  filter?: InputMaybe<AssignedRoutePointFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllBatchStockRatesArgs = {
  filter?: InputMaybe<BatchStockBySellableItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllBatchStocksArgs = {
  filter?: InputMaybe<BatchStockFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllBeatVisitsArgs = {
  filter?: InputMaybe<BeatVisitFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  incomplete?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllBeatsArgs = {
  filter?: InputMaybe<SupBeatFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllBookingsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  placedIn?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllBusienssCategorysArgs = {
  filter?: InputMaybe<BusinessCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllCertificationTypesArgs = {
  contentType?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllCommoditiesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllCompaniesArgs = {
  departmentId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllCreditsArgs = {
  filter?: InputMaybe<CreditFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDataSourcesArgs = {
  filter?: InputMaybe<DataSourceInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDcCollectionLogsArgs = {
  filter?: InputMaybe<DcCollectionLogFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDcStockTakeConfigsArgs = {
  filter?: InputMaybe<DcStockTakeConfigFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDcStorageLocationsArgs = {
  filter?: InputMaybe<DcSubLocationInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDcSubLocationsArgs = {
  filter?: InputMaybe<DcSubLocationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDemandsArgs = {
  filter?: InputMaybe<DemandFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDepartmentsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDepotsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDistributionCentreLocationApprovalsArgs = {
  filter?: InputMaybe<DistributionCentreLocationInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDistributionCentreLocationsArgs = {
  filter?: InputMaybe<DistributionCentreLocationInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDistributionCentresArgs = {
  filter?: InputMaybe<DistributionCentreLocationInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllDocksArgs = {
  filter?: InputMaybe<AllDockFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllExportCustomersArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllFamilyGroupHierarchysArgs = {
  filter?: InputMaybe<FamilyGroupHierarchyFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllFamilyGroupsArgs = {
  filter?: InputMaybe<FamilyGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllFuelDistributorItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FuelDistributorItemSearchInput>;
};


export type QueryRootAllFuelDistributorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FuelDistributorSearchInput>;
};


export type QueryRootAllGroupsArgs = {
  category?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AllGroupsFilterInput>;
};


export type QueryRootAllInwardsArgs = {
  department?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllMarketYardsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllMyBeatPlansArgs = {
  filter?: InputMaybe<BeatPlanFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllMyOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllMySellableItemStocksArgs = {
  filter?: InputMaybe<MySellableItemStockFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootAllNotificationProvidersArgs = {
  filter?: InputMaybe<NotificationProviderInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllNotificationTempletesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllNotificationTriggersArgs = {
  filter?: InputMaybe<NotificationTriggerInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllOrderItemBatchsArgs = {
  filter?: InputMaybe<OrderItemBatchFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllOrderItemsArgs = {
  filter?: InputMaybe<OrderItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllOrderTransactionsArgs = {
  filter?: InputMaybe<OrderTransactionFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllPackagingMaterialItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PackagingMaterialItemSearchInput>;
};


export type QueryRootAllPackagingMaterialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PackagingMaterialSearchInput>;
};


export type QueryRootAllPackingMaterialsArgs = {
  typeName: Scalars['String'];
};


export type QueryRootAllPaymentMethodsArgs = {
  filter?: InputMaybe<TransactionDetailInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllPeriodicTasksArgs = {
  filter?: InputMaybe<PeriodicTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllPlotCommoditiesArgs = {
  filter?: InputMaybe<PlotCommodityFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllPriceBenchmarkDataArgs = {
  filter?: InputMaybe<PriceBenchmarkDataQueryInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllPriceBenchmarkRecommendationsArgs = {
  filter?: InputMaybe<PriceBenchmarkRecommendationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllProductionBatchesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  varietyId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllPurchaseOrdersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  plotCommodity?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllRouteAssignmentsArgs = {
  filter?: InputMaybe<RouteAssignmentFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllRouteCategorysArgs = {
  filter?: InputMaybe<RouteCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllRoutePointsArgs = {
  filter?: InputMaybe<RoutePointFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllRoutesArgs = {
  filter?: InputMaybe<RouteInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllScheduleRequestsArgs = {
  filter?: InputMaybe<ScheduleRequestFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllScheduleRequestsSummaryArgs = {
  filter?: InputMaybe<ScheduleRequestFilterInput>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllSellableItemGroupsArgs = {
  filter?: InputMaybe<SellableItemGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllSellableItemsArgs = {
  filter?: InputMaybe<SellableItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllSellersArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllShopOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  shopId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllShopsArgs = {
  filter?: InputMaybe<ShopDetailFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllSkuTypesArgs = {
  filter?: InputMaybe<SkuTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllStatesArgs = {
  filter?: InputMaybe<StateInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllStockEntryItemsArgs = {
  filter?: InputMaybe<StockEntryItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllStockTakeApprovalRequestsArgs = {
  filter?: InputMaybe<StockTakeApprovalRequestInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllSuperviseSummarysArgs = {
  filter?: InputMaybe<SuperviseSummaryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllSurveyAreasArgs = {
  filter?: InputMaybe<SurveyAreaFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllTaskLogsArgs = {
  filter?: InputMaybe<TaskLogFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllTransactionTypesArgs = {
  filter?: InputMaybe<TransactionDetailInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllTransactionsArgs = {
  filter?: InputMaybe<TransactionDetailInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllTripStepsArgs = {
  filter?: InputMaybe<TripStepFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllUnloadingSubLocationsArgs = {
  filter?: InputMaybe<UnloadingSubLocationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllUserFiltersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllUserQuerysArgs = {
  filter?: InputMaybe<UserQueryInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllV1NotificationTemplatesArgs = {
  filter?: InputMaybe<NotificationTemplateInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllVarietiesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllVarietyGroupsArgs = {
  departmentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  isFinishedGood?: InputMaybe<Scalars['Boolean']>;
  isRawMaterial?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllVehicleKindArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllVehicleTypesArgs = {
  vehicleKind?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllVehiclesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  vehicleKind?: InputMaybe<Scalars['String']>;
};


export type QueryRootAllVehiclesDetailArgs = {
  filter?: InputMaybe<AllVehicleFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAllVendorsBySurveyAreasArgs = {
  assignemntExcl?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<VendorsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  routeId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  surveyAreaId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAnnotatedOrderDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootApprovedTradeProfilesArgs = {
  shipmentPlanId: Scalars['ID'];
};


export type QueryRootAreaWiseUserDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootAssignedRoutePointDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootAssignedVehiclesTripsArgs = {
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  filter?: InputMaybe<AssignedTripsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootAssigneeAggregateArgs = {
  filters?: InputMaybe<AggregateFilterInput>;
};


export type QueryRootBatchStockDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootBatchStockRateBySellableItemArgs = {
  filter?: InputMaybe<BatchStockBySellableItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBatchStockRateDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootBatchStockWiseVisibilityArgs = {
  date?: InputMaybe<Scalars['Date']>;
  filters?: InputMaybe<BatchStockWiseVisibilityFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBatchStockWiseVisibilityDispatchDateWiseArgs = {
  consumed?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<StockManagementWebFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBeatDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootBeatVisitDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootBookingDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBookingsByOrderItemArgs = {
  orderItemId: Scalars['ID'];
};


export type QueryRootBookingsBySellableItemsArgs = {
  filter?: InputMaybe<BookingsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBookingsBySkuArgs = {
  filter?: InputMaybe<BookingsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBookingsByTripArgs = {
  filter?: InputMaybe<BookingsByTripFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootBusienssCategoryDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootCacheTestArgs = {
  data?: InputMaybe<Scalars['String']>;
};


export type QueryRootCollectionListArgs = {
  filter: CollectionInput;
};


export type QueryRootCollectionTotalsArgs = {
  filter: ReconciliationFundFlowInput;
};


export type QueryRootCompanyDetailsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootContractDetailsArgs = {
  contractId: Scalars['ID'];
};


export type QueryRootContractExpensesArgs = {
  contractId: Scalars['ID'];
};


export type QueryRootContractPaymentsArgs = {
  contractId: Scalars['ID'];
};


export type QueryRootCreditDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootCustomInvoiceDetailArgs = {
  customDiscountFlat?: InputMaybe<Scalars['Float']>;
  customDiscountPercent?: InputMaybe<Scalars['Float']>;
  discountId?: InputMaybe<Scalars['ID']>;
  orderItems: Array<InputMaybe<OrderItemStockInput>>;
};


export type QueryRootDataSourceDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDcCollectionLogDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDcStockTakeConfigDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDcStorageLocationDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDcSubLocationDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDcWiseAggregateVisibilityArgs = {
  date?: InputMaybe<Scalars['Date']>;
  filters?: InputMaybe<StockManagementWebFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootDemandDetailsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootDepartmentDetailsArgs = {
  departmentId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootDistributionCentreDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDistributionCentreLocationApprovalDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDistributionCentreLocationDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDmsTripStepGraphArgs = {
  tripId: Scalars['ID'];
};


export type QueryRootDockDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootDriverTripsArgs = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
};


export type QueryRootEligibleExportCustomersBySampleArgs = {
  sampleId: Scalars['ID'];
};


export type QueryRootExportReportArgs = {
  emailTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<ReportTemplateFilter>>>;
  templateId: Scalars['ID'];
};


export type QueryRootFamilyGroupDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootFamilyGroupHierarchyDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootFilterPlotsArgs = {
  village?: InputMaybe<Scalars['String']>;
};


export type QueryRootFuelDistributorArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryRootFuelDistributorItemArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryRootFundFlowArgs = {
  filter?: InputMaybe<DcLogFundFlowInput>;
};


export type QueryRootGateLogStatusArgs = {
  scheduleId: Scalars['ID'];
};


export type QueryRootGatepassSelectorArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productionId?: InputMaybe<Scalars['ID']>;
  productionItemId?: InputMaybe<Scalars['ID']>;
  productionLineId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sendToLine?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
  varietyId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootGenerateOtpArgs = {
  hashKey?: InputMaybe<Scalars['String']>;
  userType: EcommerceUserType;
  username: Scalars['String'];
};


export type QueryRootGeneratePaymentLinkArgs = {
  amountForPayment: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  referenceId: Scalars['String'];
  trackingCode: Scalars['String'];
};


export type QueryRootGroupDetailsArgs = {
  groupId?: InputMaybe<Scalars['Int']>;
  groupName?: InputMaybe<Scalars['String']>;
};


export type QueryRootHandedoverAmountArgs = {
  filter?: InputMaybe<DepositPendingInput>;
};


export type QueryRootHarvestGradesForVarietyArgs = {
  variety?: InputMaybe<Scalars['Int']>;
};


export type QueryRootHarvestProjectionArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  harvestDateFrom?: InputMaybe<Scalars['Date']>;
  harvestDateTo?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pruningDateFrom?: InputMaybe<Scalars['Date']>;
  pruningDateTo?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
  seasonName?: InputMaybe<Scalars['String']>;
  tradeYearId?: InputMaybe<Scalars['ID']>;
  varietyGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  varietyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryRootHasPendingPaymentArgs = {
  customerId: Scalars['ID'];
};


export type QueryRootHoldingAreaArgs = {
  id: Scalars['ID'];
};


export type QueryRootHoldingAreasArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  depotId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryRootInwardAllocationArgs = {
  id: Scalars['ID'];
};


export type QueryRootInwardAllocationsArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  depotId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  holdingAreaId?: InputMaybe<Scalars['ID']>;
  inwardId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  plotCommoditySampleId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  varietyId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootInwardByPlotCommodityArgs = {
  first?: InputMaybe<Scalars['Int']>;
  plotCommodityId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootInwardedSummaryArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryRootKyfDetailsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootLinePackingAllotmentArgs = {
  id: Scalars['ID'];
};


export type QueryRootLinePackingAllotmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  packingAllotmentId?: InputMaybe<Scalars['ID']>;
  productionCreatedDate?: InputMaybe<Scalars['Date']>;
  productionCreatedDate_Gte?: InputMaybe<Scalars['Date']>;
  productionCreatedDate_Lte?: InputMaybe<Scalars['Date']>;
  productionItemId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootLineTradeProfileArgs = {
  id: Scalars['ID'];
};


export type QueryRootLineTradeProfilesArgs = {
  approvedTradeProfileId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productionItemId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootMatchProfilesByCustIdArgs = {
  custId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  shipmentPlanId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootMetabaseUrlArgs = {
  filter?: InputMaybe<MetabaseUrlInput>;
};


export type QueryRootMyBeatPlanDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootMyBookingsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryRootMyCuponsArgs = {
  dcId?: InputMaybe<Scalars['ID']>;
  isOrder?: InputMaybe<Scalars['Boolean']>;
  orderItems?: InputMaybe<Array<InputMaybe<OrderItemStockInput>>>;
  sellableItemStockId?: InputMaybe<Scalars['ID']>;
  totalAmount?: InputMaybe<Scalars['Float']>;
};


export type QueryRootMyOrderDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootMyReportTemplatesArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryRootMySellableItemStockDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootMyTripsArgs = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
};


export type QueryRootNetSaleTotalsArgs = {
  filter?: InputMaybe<FundFlowInput>;
};


export type QueryRootNotificationByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootNotificationProviderDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootNotificationTemplateByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootNotificationTriggerDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootNotifyUsersArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryRootOrderCountFilterArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type QueryRootOrderDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootOrderInvoiceDetailArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
  trackingCode?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootOrderItemBatchDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootOrderItemBatchTrackArgs = {
  orderItemBatchId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootOrderItemDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootOrderTransactionByReferenceIdArgs = {
  referenceId: Scalars['String'];
  trackingCode?: InputMaybe<Scalars['String']>;
};


export type QueryRootOrderTransactionDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootOrderValueBySellableItemArgs = {
  filter?: InputMaybe<OrderValueBySellableItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootOrdersBySellableItemArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootOrganisationDetailsArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type QueryRootOutstandingUserDetailArgs = {
  filter?: InputMaybe<OutstandingOrderDateFilterInput>;
  userId: Scalars['ID'];
};


export type QueryRootOutstandingUsersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootPackagingMaterialArgs = {
  id: Scalars['Int'];
};


export type QueryRootPackagingMaterialItemArgs = {
  id: Scalars['Int'];
};


export type QueryRootPackagingMaterialRegionArgs = {
  id: Scalars['Int'];
};


export type QueryRootPackingAllotmentArgs = {
  id: Scalars['ID'];
};


export type QueryRootPackingAllotmentsArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  inwardAllocationId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productionLineId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sendToLine?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  supervisorId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootPaymentMethodDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootPaymentVerificationOrdersArgs = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  verificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRootPaymentsByAggregatorArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootPayuTransactionKeysArgs = {
  orderId: Scalars['ID'];
};


export type QueryRootPendingPriceApprovalSchedulesArgs = {
  date?: InputMaybe<Scalars['Date']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootPeriodicTaskDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootPlotCommodityDetailsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRootPlotDetailsArgs = {
  plotId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootPlotInwardSummaryArgs = {
  plotCommodityId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootPreTripGenerateArgs = {
  date?: InputMaybe<Scalars['Date']>;
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryRootPriceBenchmarkRecommendationDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootPriceBenchmarkSummaryArgs = {
  filter?: InputMaybe<PriceBenchmarkDataQueryInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootProductionArgs = {
  id: Scalars['ID'];
};


export type QueryRootProductionBatchArgs = {
  id: Scalars['Int'];
};


export type QueryRootProductionItemArgs = {
  id: Scalars['ID'];
};


export type QueryRootProductionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  palletNo?: InputMaybe<Scalars['String']>;
  palletType?: InputMaybe<Scalars['String']>;
  productionId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootProductionLineArgs = {
  id: Scalars['ID'];
};


export type QueryRootProductionLinesArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  depotId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryRootProductionsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  exportCustomerId?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productionStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sendForApproval?: InputMaybe<Scalars['Boolean']>;
  toDate?: InputMaybe<Scalars['Date']>;
  varietyId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootQualityParametersForVarietyArgs = {
  variety?: InputMaybe<Scalars['Int']>;
};


export type QueryRootQualityReportArgs = {
  booking?: InputMaybe<Scalars['Int']>;
};


export type QueryRootReconciliationSummaryFundFlowArgs = {
  filter: ReconciliationSummaryFundFlowInput;
};


export type QueryRootReportMasterDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootReportTemplateDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootReviewSummaryArgs = {
  sellableItemId: Scalars['ID'];
};


export type QueryRootRouteAssignmentDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootRouteCategoryDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootRouteDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootRoutePointDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootScheduleDetailArgs = {
  scheduleId: Scalars['Int'];
};


export type QueryRootScheduleDetailsArgs = {
  scheduleId: Scalars['ID'];
};


export type QueryRootScheduleRequestDetailsArgs = {
  scheduleRequestId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootScheduleRequestSummaryArgs = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSchedulesForDateArgs = {
  date?: InputMaybe<Scalars['Date']>;
  filter?: InputMaybe<ScheduleFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSchedulesForDateSummaryArgs = {
  date: Scalars['Date'];
  filter?: InputMaybe<ScheduleFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSchedulesForPlotArgs = {
  plotId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSchedulesForPlotCommodityFlatArgs = {
  first?: InputMaybe<Scalars['Int']>;
  plotCommodityId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSearchPlotCommodityArgs = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  filter?: InputMaybe<SearchPlotCommodityFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSellableItemByAggregatorArgs = {
  aggregatorId: Scalars['ID'];
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<SettlementFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSellableItemDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootSellableItemGroupDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootSellableItemReviewsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  sellableItemId: Scalars['ID'];
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSellableItemStockArgs = {
  filter?: InputMaybe<SellableItemStockFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSellableItemStockCartArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryRootSellableItemStockDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootSellableItemWiseStockVisibilityArgs = {
  date?: InputMaybe<Scalars['Date']>;
  filters?: InputMaybe<SellableItemWiseStockVisibilityFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSellableItemsByTripArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  tripId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSendCustomOtpArgs = {
  number?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  otp?: InputMaybe<Scalars['String']>;
};


export type QueryRootSendDeliveryOtpArgs = {
  hashKey?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSendUserCredentialsArgs = {
  mType?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryRootShipmentPlanByIdArgs = {
  id: Scalars['ID'];
};


export type QueryRootShipmentPlanBySoNoArgs = {
  soNo: Scalars['String'];
};


export type QueryRootShipmentPlansArgs = {
  customerId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  portId?: InputMaybe<Scalars['ID']>;
  productionStatus?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['Date']>;
  varietyId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootShopDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootShopOrderDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootSiByBookingArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tripId: Scalars['ID'];
};


export type QueryRootSkuDetailsArgs = {
  skuId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSkusByAggregatorArgs = {
  filter?: InputMaybe<BookingsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSkusByTripArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  tripId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootStateDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootStatementCustomersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootStockEntryItemDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootStockTakeApprovalRequestDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootStockTakeItemsArgs = {
  filter?: InputMaybe<StockEntryItemFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSummaryAggregatorsArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  group: Scalars['String'];
};


export type QueryRootSummaryAllOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type QueryRootSummaryAllVehicleArgs = {
  date?: InputMaybe<Scalars['Date']>;
  departmentId: Scalars['ID'];
  distributionCenterId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSummaryAssignedTripsArgs = {
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  distributionCenterId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSummaryBatchStocksArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type QueryRootSummaryCreditsArgs = {
  filter?: InputMaybe<CreditFilterInput>;
};


export type QueryRootSummaryFilterDetailsArgs = {
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  distributionCenterId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSummaryOfOrderByVendorArgs = {
  filter?: InputMaybe<OrderSummaryOfVendorFilterInput>;
};


export type QueryRootSummaryOfPaymentsByAggregatorArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
};


export type QueryRootSummarySalesManagementCustomersArgs = {
  date_Gte: Scalars['Date'];
  date_Lte: Scalars['Date'];
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesmanId?: InputMaybe<Scalars['ID']>;
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryRootSummarySellableItemsArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
  tripId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSummarySkusArgs = {
  orderId?: InputMaybe<Scalars['ID']>;
  tripId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootSummaryStockTakeApprovalRequestsByDcArgs = {
  filter?: InputMaybe<StockTakeApprovalRequestInput>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryRootSummaryUsersEcomArgs = {
  filter?: InputMaybe<SummaryUsersEcomFilterInput>;
  latestDays?: InputMaybe<Scalars['Int']>;
};


export type QueryRootSuperviseSummaryDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootSurveyAreaDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootSyncFarmerPlotsArgs = {
  farmerId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootTargetUserCountArgs = {
  filter?: InputMaybe<TargetUserCountInput>;
};


export type QueryRootTaskLogDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootTransactionDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootTransactionTypeDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootTransportDetailArgs = {
  gradeForSuggestedPrice?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<Scalars['Int']>;
};


export type QueryRootTripByAggregatorArgs = {
  aggregatorId: Scalars['ID'];
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<AssignedTripsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootTripDateFilterArgs = {
  date?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  dockId?: InputMaybe<Scalars['ID']>;
  dockSupervisorId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootTripDetailsArgs = {
  tripId?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryRootTripHistoryArgs = {
  refresh?: InputMaybe<Scalars['Boolean']>;
  uuid: Scalars['ID'];
};


export type QueryRootTripRecommendationArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  uuid: Scalars['ID'];
  vehicleLatitude?: InputMaybe<Scalars['Float']>;
  vehicleLongitude?: InputMaybe<Scalars['Float']>;
};


export type QueryRootTripStepDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootTripStepGraphArgs = {
  id?: InputMaybe<Scalars['ID']>;
  uuid?: InputMaybe<Scalars['String']>;
  vehicleLat?: InputMaybe<Scalars['Float']>;
  vehicleLon?: InputMaybe<Scalars['Float']>;
};


export type QueryRootTripsForDateArgs = {
  commonDcId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  isWholesale?: InputMaybe<Scalars['Boolean']>;
  orderingDcId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootUserDetailByNumberArgs = {
  number?: InputMaybe<Scalars['String']>;
};


export type QueryRootUserDetailsArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootUserExistsByNumberArgs = {
  number: Scalars['String'];
};


export type QueryRootUserFilterDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootUserOrderOutstandingArgs = {
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryRootUserQueryDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootUsersByGroupArgs = {
  categoryCodename?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<UsersByGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  groupName?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryRootV1NotificationTemplateDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootVarietyDetailsArgs = {
  varietyId?: InputMaybe<Scalars['Int']>;
};


export type QueryRootVehicleDetailsArgs = {
  vehicleId?: InputMaybe<Scalars['ID']>;
};


export type QueryRootVehicleListArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  vehicleKind?: InputMaybe<Scalars['String']>;
};


export type QueryRootVendorsBySalesmanArgs = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<VendorBySalesmanFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  salesmanId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootVendorsBySalesmanV2Args = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<VendorBySalesmanFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  salesmanId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRootVendorsBySurveyAreaDetailArgs = {
  id: Scalars['ID'];
};


export type QueryRootVerifyOtpArgs = {
  firebaseToken?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otp: Scalars['Int'];
  username: Scalars['String'];
};

export type RangeInput = {
  gte?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

/**
 * for deposit confirmation:
 *     filter: status=TransactionStatus.CREATED, transaction_type="BANK_DEPOSIT"
 *     update: status=TransactionStatus.AUTHORIZED
 * for deposit reconciliation:
 *     filter: status=TransactionStatus.AUTHORIZED, transaction_type="BANK_DEPOSIT"
 *     update: status=TransactionStatus.SUCCESS/TransactionStatus.FAILED
 */
export type ReconcileBulkTransactionMutation = {
  __typename?: 'ReconcileBulkTransactionMutation';
  transactions?: Maybe<Array<Maybe<TransactionGraphType>>>;
};

export type ReconciliationFundFlowInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  orderStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** department ID */
  placedInId?: InputMaybe<Scalars['ID']>;
  targetDcId?: InputMaybe<Scalars['ID']>;
};

export type ReconciliationSummaryFundFlowInput = {
  date?: InputMaybe<Scalars['Date']>;
};

export type ReconciliationSummaryFundFlowType = {
  __typename?: 'ReconciliationSummaryFundFlowType';
  closingBalance?: Maybe<Scalars['Float']>;
  collection?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  distributionCentreId?: Maybe<Scalars['ID']>;
  distributionCentre_Name?: Maybe<Scalars['String']>;
  netSale?: Maybe<Scalars['Float']>;
  openingBalance?: Maybe<Scalars['Float']>;
  reconciliationStatus?: Maybe<Scalars['String']>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload?: Maybe<Scalars['GenericScalar']>;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** Deprecated! */
export type RefreshOtpMutation = {
  __typename?: 'RefreshOTPMutation';
  trip?: Maybe<TripType>;
};

export type RegionPercentDetailType = {
  __typename?: 'RegionPercentDetailType';
  deductionPercent: Scalars['Float'];
  id: Scalars['ID'];
  stickPercent: Scalars['Float'];
  variety?: Maybe<CommodityVarietyType>;
};

export type RegisterTogoFarmerMutation = {
  __typename?: 'RegisterTogoFarmerMutation';
  user?: Maybe<BaseUserType>;
};

export type RejectReturnRequestInput = {
  orderItemBatchId?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
};

export type RejectReturnRequestMutation = {
  __typename?: 'RejectReturnRequestMutation';
  orderItemBatches?: Maybe<Array<Maybe<OrderItemBatchType>>>;
};

export type RemoveM2MFieldLink = {
  __typename?: 'RemoveM2MFieldLink';
  response?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/**
 * This mutation will modify RDATE and EXDATE in rrule according to include_date, exclude_date passed.
 * NOTE: EXRULES will always override the include_date or RDATE, Reccurence will not be generated for RDATE if it falls in EXRULES condition.
 */
export type ReplaceRruleMutation = {
  __typename?: 'ReplaceRruleMutation';
  routeAssignment?: Maybe<RouteAssignmentType>;
};

export type ReportExportLogType = {
  __typename?: 'ReportExportLogType';
  appliedFilters: Scalars['JSONString'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isDelivered: Scalars['Boolean'];
  reportTemplate: ReportTemplateType;
  requestedBy?: Maybe<DeliveryAgentManagementType>;
  sendTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum ReportItemFieldType {
  /** Array of Items */
  ARRY = 'ARRY',
  /** Boolean */
  BOOL = 'BOOL',
  /** Date */
  DATE = 'DATE',
  /** Date Time */
  DATM = 'DATM',
  /** Formulas */
  FOMU = 'FOMU',
  /** Number */
  NUMB = 'NUMB',
  /** Relation */
  RELN = 'RELN',
  /** Text */
  TEXT = 'TEXT'
}

export type ReportItemType = {
  __typename?: 'ReportItemType';
  alias: Scalars['String'];
  defaultValue: Scalars['String'];
  fieldType: ReportItemFieldType;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isRangeValue: Scalars['Boolean'];
  referenceQuery: Scalars['String'];
  reportColumns: Array<ReportType>;
  reportFilters: Array<ReportType>;
  reportGroupings: Array<ReportType>;
  reporttemplateitemSet: Array<ReportTemplateItemType>;
  templateFilters: Array<ReportTemplateType>;
  templateGroupBy: Array<ReportTemplateType>;
};

export type ReportTemplateColumn = {
  aggregateType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  reportItemId: Scalars['ID'];
  sequence: Scalars['Int'];
};

export type ReportTemplateFilter = {
  id: Scalars['ID'];
  value: Array<InputMaybe<Scalars['String']>>;
};

/** An enumeration. */
export enum ReportTemplateItemAggregateType {
  /** Average */
  AVG = 'AVG',
  /** Maximum */
  MAX = 'MAX',
  /** Minimum */
  MIN = 'MIN',
  /** None */
  NON = 'NON',
  /** Sum */
  SUM = 'SUM'
}

export type ReportTemplateItemType = {
  __typename?: 'ReportTemplateItemType';
  aggregateType: ReportTemplateItemAggregateType;
  id: Scalars['ID'];
  reportItem: ReportItemType;
  reportTemplate: ReportTemplateType;
  sequence: Scalars['Int'];
};

export type ReportTemplateType = {
  __typename?: 'ReportTemplateType';
  columns: Array<ReportTemplateItemType>;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  emailTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  exportLogs: Array<ReportExportLogType>;
  groupBy: Array<ReportItemType>;
  groupsShared: Array<GroupType>;
  id: Scalars['ID'];
  latestDelivery?: Maybe<ReportExportLogType>;
  name: Scalars['String'];
  recommendedEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  savedFilters: Array<ReportItemType>;
  schedule?: Maybe<PeriodicTaskType>;
  source: ReportType;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  usersShared: Array<DeliveryAgentManagementType>;
};

export type ReportType = {
  __typename?: 'ReportType';
  alias: Scalars['String'];
  columns: Array<ReportItemType>;
  filters: Array<ReportItemType>;
  groupings: Array<ReportItemType>;
  id: Scalars['ID'];
  reporttemplateSet: Array<ReportTemplateType>;
};

/**
 * Mutation to restock (reverse) assigned weights from LineTradeProfile and LinePackingAllotment.
 *
 * Behavior:
 * - Takes lists of LineTradeProfile IDs and LinePackingAllotment IDs.
 * - For each LineTradeProfile:
 *     - Adds its assigned_wt back to ApprovedTradeProfile.available_yield.
 *     - Deletes the LineTradeProfile.
 * - For each LinePackingAllotment:
 *     - Adds its assigned_wt back to PackingAllotment.available_wt.
 *     - Deletes the LinePackingAllotment.
 */
export type RestockProduction = {
  __typename?: 'RestockProduction';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RestockProductionInput = {
  linePackingAllotmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lineTradeProfileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type RetriggerNotificationMutation = {
  __typename?: 'RetriggerNotificationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type ReverseVariantBatchStockMutation = {
  __typename?: 'ReverseVariantBatchStockMutation';
  message?: Maybe<Scalars['String']>;
  parentBatchStock?: Maybe<BatchStockType>;
  success?: Maybe<Scalars['Boolean']>;
  variantBatchStock?: Maybe<BatchStockType>;
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  fiveStarRating?: Maybe<Scalars['Int']>;
  fourStarRating?: Maybe<Scalars['Int']>;
  oneStarRating?: Maybe<Scalars['Int']>;
  threeStarRating?: Maybe<Scalars['Int']>;
  totalNoReviews?: Maybe<Scalars['Int']>;
  totalRating?: Maybe<Scalars['Int']>;
  totalReviews?: Maybe<Scalars['Int']>;
  twoStarRating?: Maybe<Scalars['Int']>;
};

export type RouteAssignmentFilterInput = {
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
};

export type RouteAssignmentType = {
  __typename?: 'RouteAssignmentType';
  assignedRoutePointCount?: Maybe<Scalars['Int']>;
  assignedRoutePoints: Array<AssignedRoutePointType>;
  assignee: DeliveryAgentManagementType;
  beatVisitCount?: Maybe<Scalars['Int']>;
  beats?: Maybe<Array<Maybe<SupBeatType>>>;
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  /** Daily beat completion time */
  endTime: Scalars['Time'];
  id: Scalars['ID'];
  lastVisit?: Maybe<BeatVisitType>;
  nextOccurrence?: Maybe<Scalars['String']>;
  polyline?: Maybe<GeometryObjectType>;
  recurrences?: Maybe<Array<Maybe<Scalars['String']>>>;
  returnRequestApproved?: Maybe<Array<Maybe<OrderItemBatchType>>>;
  route: RouteType;
  /** Recurrence rules */
  rrules: Scalars['JSONString'];
  shouldTrack: Scalars['Boolean'];
  /** Start date of the assignment */
  startDate: Scalars['Date'];
  /** Daily beat start time */
  startTime: Scalars['Time'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};


export type RouteAssignmentTypeBeatVisitCountArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type RouteAssignmentTypeBeatsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type RouteAssignmentTypeLastVisitArgs = {
  visiteeId?: InputMaybe<Scalars['ID']>;
  visitorId?: InputMaybe<Scalars['ID']>;
};


export type RouteAssignmentTypeRecurrencesArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type RouteCategoryFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type RouteCategoryType = {
  __typename?: 'RouteCategoryType';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  itemGroups: Array<SellableItemGroupType>;
  name: Scalars['String'];
  routes: Array<RouteType>;
  sellableItems: Array<SellableItemType>;
};

export type RouteInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  codename?: InputMaybe<Scalars['String']>;
  dcId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
};

export type RoutePointFilterInput = {
  exclRouteAssignmentId?: InputMaybe<Scalars['ID']>;
  routeId?: InputMaybe<Scalars['ID']>;
};

export type RoutePointInput = {
  sequence?: InputMaybe<Scalars['String']>;
  visiteeId?: InputMaybe<Scalars['ID']>;
};

export type RoutePointType = {
  __typename?: 'RoutePointType';
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  id: Scalars['ID'];
  lastVisit?: Maybe<BeatVisitType>;
  point?: Maybe<GeometryObjectType>;
  route: RouteType;
  sequence: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
  visitee: DeliveryAgentManagementType;
};

export type RouteType = {
  __typename?: 'RouteType';
  assignments: Array<RouteAssignmentType>;
  category: RouteCategoryType;
  codename: Scalars['String'];
  colorCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: DeliveryAgentManagementType;
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  points: Array<RoutePointType>;
  polyline?: Maybe<GeometryObjectType>;
  summary?: Maybe<SuperviseSummaryType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  surveyArea: SurveyAreaLocationType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<DeliveryAgentManagementType>;
};


export type RouteTypeSummaryArgs = {
  filters?: InputMaybe<SuperviseSummaryFilterInput>;
};

export type SiByBooking = {
  __typename?: 'SIByBooking';
  despatchedQuantity?: Maybe<Scalars['Int']>;
  itemCount?: Maybe<Scalars['Int']>;
  orders?: Maybe<Array<Maybe<OrderType>>>;
  requiredQuantity?: Maybe<Scalars['Int']>;
  sellableItem?: Maybe<SellableItemType>;
};

export type SiUnitType = {
  __typename?: 'SIUnitType';
  baseConversion: Scalars['Float'];
  baseUnit?: Maybe<SiUnitType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  commoditygroupSet: Array<CommodityGroupType>;
  gradepriceSet: Array<GradePriceType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  sellableitemSet: Array<SellableItemType>;
  sellablevarietySet: Array<SellableVarietyType>;
  siunitSet: Array<SiUnitType>;
  skuDimensionUnit: Array<SkuGraphType>;
  skuVolumes: Array<SkuGraphType>;
  skutypeSet: Array<SkuGraphType>;
  vehicleSet: Array<VehicleType>;
  vehicletypeSet: Array<VehicleGraphType>;
  weighSet: Array<WeighType>;
  weighbatchSet: Array<WeighBatchType>;
};

export type SkuCategoryType = {
  __typename?: 'SKUCategoryType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  skutypeSet: Array<SkuGraphType>;
};

export type SkuGraphType = {
  __typename?: 'SKUGraphType';
  batchstockSet: Array<BatchStockType>;
  bookingextraskuSet: Array<BookingExtraSkuType>;
  capacity: Scalars['Float'];
  capacityUnit: SiUnitType;
  codename: Scalars['UUID'];
  collected?: Maybe<Scalars['Int']>;
  commoditygroupSet: Array<CommodityGroupType>;
  commodityvarietySet: Array<CommodityVarietyType>;
  createdAt: Scalars['DateTime'];
  delivered?: Maybe<Scalars['Int']>;
  departmentSet: Array<DepartmentType>;
  description: Scalars['String'];
  dimensionUnit?: Maybe<SiUnitType>;
  dimensions?: Maybe<Array<Maybe<Scalars['Float']>>>;
  gradepriceSet: Array<GradePriceType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isReturnable: Scalars['Boolean'];
  loaded?: Maybe<Scalars['Int']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  orderitemSet: Array<OrderItemType>;
  packagingmaterialitemSet: Array<PackagingMaterialItemType>;
  photo?: Maybe<Scalars['String']>;
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  /** Own weight in (Kgs) */
  selfWeight: Scalars['Float'];
  sellableitemSet: Array<SellableItemType>;
  sellableitemstockSet: Array<SellableItemStockType>;
  sellableitemunitSet: Array<SellableItemUnitType>;
  sellablevarietySet: Array<SellableVarietyType>;
  settled?: Maybe<Scalars['Int']>;
  shipmentplanSet: Array<ShipmentPlanType>;
  skuCategory?: Maybe<SkuCategoryType>;
  stockCount: Scalars['Int'];
  stockentryitemSet: Array<StockEntryItemType>;
  timeslotrequirementSet: Array<TimeSlotRequirementType>;
  unitPrice: Scalars['Float'];
  unsettled?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  volume: Scalars['Float'];
  volumeUnit?: Maybe<SiUnitType>;
  weighSet: Array<WeighType>;
  weighbatchSet: Array<WeighBatchType>;
};

export type SkuPackingMaterialType = {
  __typename?: 'SKUPackingMaterialType';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  primaryPackagingMaterial: Array<ShipmentPlanType>;
  secondaryPackagingMaterial: Array<ShipmentPlanType>;
  type: PackingMaterialType;
};

export type SkuTypeFilterInput = {
  metadata_Labels_Contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SalesmanHandoverReturnOrderMutation = {
  __typename?: 'SalesmanHandoverReturnOrderMutation';
  orderItemBatches?: Maybe<Array<Maybe<OrderItemBatchType>>>;
};

export type SalesmanPickupReturnOrderMutation = {
  __typename?: 'SalesmanPickupReturnOrderMutation';
  orderItemBatches?: Maybe<Array<Maybe<OrderItemBatchType>>>;
};

export type SampleField = {
  __typename?: 'SampleField';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  standard?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SapPlatformPricingMutation = {
  __typename?: 'SapPlatformPricingMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['JSONString']>;
};

/** An enumeration. */
export enum ScheduleAmcChargeKind {
  /** ZFGP */
  ZFGP = 'ZFGP',
  /** ZFGQ */
  ZFGQ = 'ZFGQ',
  /** ZFGV */
  ZFGV = 'ZFGV'
}

export type ScheduleFilterInput = {
  isTripGenerated?: InputMaybe<Scalars['Boolean']>;
  scheduledBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  supplierType?: InputMaybe<Scalars['String']>;
};

export type ScheduleForDateSummary = {
  __typename?: 'ScheduleForDateSummary';
  aggregators?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  labours?: Maybe<Scalars['Int']>;
  plots?: Maybe<Scalars['Int']>;
  totalSkuCount?: Maybe<Scalars['Int']>;
  totalUomQuantity?: Maybe<Scalars['Int']>;
  transportServiceProviders?: Maybe<Scalars['Int']>;
  vehicles?: Maybe<Scalars['Int']>;
};

export type ScheduleObject = {
  __typename?: 'ScheduleObject';
  gradePrice?: Maybe<GradePriceType>;
  schedule?: Maybe<ScheduleType>;
};

/** An enumeration. */
export enum SchedulePricingDoneOn {
  /** Quantity */
  QTY = 'QTY',
  /** SKU Count */
  SKU = 'SKU'
}

export type ScheduleRequestDeviationInput = {
  finalPrice?: InputMaybe<Scalars['Float']>;
  gradePriceId?: InputMaybe<Scalars['ID']>;
  scheduleRequestId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  totalEstimatedHarvest?: InputMaybe<Scalars['Float']>;
};

export type ScheduleRequestDeviationMutation = {
  __typename?: 'ScheduleRequestDeviationMutation';
  scheduleApprovals?: Maybe<Array<Maybe<ScheduleRequestType>>>;
};

export type ScheduleRequestFilterInput = {
  agronomist?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['Date']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  plotCommodity_Variety_PrimaryGroup_Id?: InputMaybe<Scalars['ID']>;
  priceChangeRequested?: InputMaybe<Scalars['Boolean']>;
  raisedBy_Id?: InputMaybe<Scalars['ID']>;
  raisedIn_Id?: InputMaybe<Scalars['ID']>;
  requestApprovedBy_Id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ScheduleRequestObject = {
  __typename?: 'ScheduleRequestObject';
  gradePrice?: Maybe<GradePriceType>;
  requestedGradePrice?: Maybe<GradePriceType>;
  scheduleRequest?: Maybe<ScheduleRequestType>;
};

/** An enumeration. */
export enum ScheduleRequestPricingDoneOn {
  /** Quantity */
  QTY = 'QTY',
  /** SKU Count */
  SKU = 'SKU'
}

/** An enumeration. */
export enum ScheduleRequestStatus {
  /** Accept */
  AC = 'AC',
  /** Hold */
  HL = 'HL',
  /** Reject */
  RJ = 'RJ',
  /** Revise */
  RV = 'RV'
}

export type ScheduleRequestStatusSummary = {
  __typename?: 'ScheduleRequestStatusSummary';
  acceptCount?: Maybe<Scalars['Int']>;
  holdCount?: Maybe<Scalars['Int']>;
  rejectCount?: Maybe<Scalars['Int']>;
  reviseCount?: Maybe<Scalars['Int']>;
};

export type ScheduleRequestSummary = {
  __typename?: 'ScheduleRequestSummary';
  completedRequests?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  myCompletedRequests?: Maybe<Scalars['Int']>;
  totalRequests?: Maybe<Scalars['Int']>;
};

export type ScheduleRequestType = {
  __typename?: 'ScheduleRequestType';
  createdAt: Scalars['DateTime'];
  cropGroup?: Maybe<CommodityGroupType>;
  date: Scalars['Date'];
  gradePrices: Array<GradePriceType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plotCommodity: PlotCommodityType;
  priceChangeRequested: Scalars['Boolean'];
  pricingDoneOn: ScheduleRequestPricingDoneOn;
  raisedBy: DeliveryAgentManagementType;
  raisedIn: DepartmentType;
  remark: Scalars['String'];
  requestApprovedBy?: Maybe<DeliveryAgentManagementType>;
  scheduleSet: Array<ScheduleType>;
  skuCount: Scalars['Int'];
  skuType: SkuGraphType;
  source: Scalars['String'];
  status: ScheduleRequestStatus;
  timeSlot?: Maybe<TimeSlotRequirementType>;
  totalEstimatedHarvest: Scalars['Int'];
  transportDetail?: Maybe<VehicleTransportDetailType>;
  uomQuantity: Scalars['Float'];
  uomType: SiUnitType;
  updatedAt: Scalars['DateTime'];
  vehicle?: Maybe<VehicleType>;
};

export type ScheduleType = {
  __typename?: 'ScheduleType';
  aggregator?: Maybe<DeliveryAgentManagementType>;
  amcChargeAmount?: Maybe<Scalars['Float']>;
  amcChargeBournBy?: Maybe<DeliveryAgentManagementType>;
  amcChargeKind?: Maybe<ScheduleAmcChargeKind>;
  assignedPoCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  booking?: Maybe<BookingType>;
  company?: Maybe<CompanyType>;
  created: Scalars['DateTime'];
  cropGroup?: Maybe<CommodityGroupType>;
  date: Scalars['Date'];
  destinationDepot?: Maybe<DepotType>;
  estdKms?: Maybe<Scalars['String']>;
  estimatedQuantity: Scalars['Int'];
  farmQuantityUnit?: Maybe<SiUnitType>;
  farmWeight: Scalars['Float'];
  gatePass: Scalars['String'];
  gatelogsSet: Array<GateLogType>;
  gradePrices: Array<GradePriceType>;
  id: Scalars['ID'];
  isEdited: Scalars['Boolean'];
  isFromQuantum: Scalars['Boolean'];
  isFromTogo: Scalars['Boolean'];
  isNotified: Scalars['Boolean'];
  isWholesale: Scalars['Boolean'];
  labourCount: Scalars['Int'];
  metadata: Scalars['JSONString'];
  packagingMaterial?: Maybe<PackagingMaterialType>;
  plot: PlotType;
  plotCommodity: PlotCommodityType;
  pricingDoneOn: SchedulePricingDoneOn;
  purchaseorderitemSet: Array<PurchaseOrderItemType>;
  remark: Scalars['String'];
  requiredQuantity: Scalars['Int'];
  scheduleRequest?: Maybe<ScheduleRequestType>;
  scheduledBy: DeliveryAgentManagementType;
  scheduledIn?: Maybe<DepartmentType>;
  skuType?: Maybe<SkuGraphType>;
  source: Scalars['String'];
  sourceDepot?: Maybe<DepotType>;
  timeToLeave: Scalars['DateTime'];
  timeToReach: Scalars['DateTime'];
  transportDetail?: Maybe<VehicleTransportDetailType>;
  transportServiceProvider?: Maybe<DeliveryAgentManagementType>;
  unloadingLocation?: Maybe<DepotType>;
  unloadingSubLocation?: Maybe<UnloadingSubLocationType>;
  updated: Scalars['DateTime'];
  variety: CommodityVarietyType;
  vehicle?: Maybe<VehicleType>;
};

/** Input type for schedules procured */
export type SchedulesProcuredInput = {
  quantity: Scalars['Int'];
  schedule: Scalars['Int'];
};

export type SearchPlotCommodityFilterInput = {
  isArchived?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  varieties?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SecondaryNumberInput = {
  id?: InputMaybe<Scalars['Int']>;
  number: Scalars['String'];
};

export type SellableItemByTripType = {
  __typename?: 'SellableItemByTripType';
  despatchedQuantity?: Maybe<Scalars['Int']>;
  sellableItem?: Maybe<SellableItemType>;
};

export type SellableItemFilterInput = {
  department?: InputMaybe<Scalars['ID']>;
  transportationType?: InputMaybe<Scalars['String']>;
};

export type SellableItemGroupFilterInput = {
  sample?: InputMaybe<Scalars['String']>;
};

export type SellableItemGroupType = {
  __typename?: 'SellableItemGroupType';
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  primaryPhoto?: Maybe<MediaEntityType>;
  routecategorySet: Array<RouteCategoryType>;
  sellableitemSet: Array<SellableItemType>;
};

export type SellableItemMetadata = {
  __typename?: 'SellableItemMetadata';
  eanCode?: Maybe<Scalars['String']>;
  fssaiLicense?: Maybe<Scalars['String']>;
  hsnCode?: Maybe<Scalars['String']>;
  isVariant?: Maybe<Scalars['Boolean']>;
};

export type SellableItemMetadataInput = {
  eanCode?: InputMaybe<Scalars['String']>;
  fssaiLicense?: InputMaybe<Scalars['String']>;
  hsnCode?: InputMaybe<Scalars['String']>;
  isVariant?: InputMaybe<Scalars['Boolean']>;
};

export type SellableItemReviewType = {
  __typename?: 'SellableItemReviewType';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  photos: Array<MediaEntityType>;
  rating: Scalars['Float'];
  sellableItem: SellableItemType;
  updatedAt: Scalars['DateTime'];
  user: DeliveryAgentManagementType;
};

/** An enumeration. */
export enum SellableItemStockCurrentStockType {
  /** Percentage */
  PERCENTAGE = 'PERCENTAGE',
  /** Unit */
  UNIT = 'UNIT'
}

export type SellableItemStockFilterInput = {
  category?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  distributionCentres?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  maxRate?: InputMaybe<Scalars['Int']>;
  minRate?: InputMaybe<Scalars['Int']>;
  sellableItem?: InputMaybe<Scalars['ID']>;
};

export type SellableItemStockInput = {
  currentStockCount: Scalars['Int'];
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  currentStockType?: InputMaybe<Scalars['String']>;
  discountedRate: Scalars['Float'];
  distributionCentreId: Scalars['ID'];
  expiryDate?: InputMaybe<Scalars['Date']>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  holdStockCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isLive: Scalars['Boolean'];
  maxRate?: InputMaybe<Scalars['Float']>;
  minRate?: InputMaybe<Scalars['Float']>;
  offerStockCount?: InputMaybe<Scalars['Int']>;
  orderingConditions?: InputMaybe<OrderingConditionInput>;
  parentStockId?: InputMaybe<Scalars['ID']>;
  relatedStockId?: InputMaybe<Scalars['ID']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  skuId?: InputMaybe<Scalars['ID']>;
  unitRate: Scalars['Float'];
};

export type SellableItemStockType = {
  __typename?: 'SellableItemStockType';
  batchStocks?: Maybe<Array<Maybe<BatchStockType>>>;
  batchstockrateSet: Array<BatchStockRateType>;
  bookedStockCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currentStockCount: Scalars['Int'];
  currentStockPercentage?: Maybe<Scalars['Float']>;
  currentStockType: SellableItemStockCurrentStockType;
  department?: Maybe<DepartmentType>;
  destinationTransactions: Array<StockTransactionType>;
  discountedRate: Scalars['Float'];
  distributionCentre: DistributionCentreType;
  dumpedStockCount: Scalars['Int'];
  estimatedDeliveryDate?: Maybe<Scalars['Date']>;
  expiryDate?: Maybe<Scalars['Date']>;
  /** Do not change! May result in inconsistencies. */
  groupVisibility: Array<GroupType>;
  holdStockCount: Scalars['Int'];
  id: Scalars['ID'];
  intransitStockCount: Scalars['Int'];
  isLive: Scalars['Boolean'];
  isTaxIncluded?: Maybe<Scalars['Boolean']>;
  maxRate: Scalars['Float'];
  minRate: Scalars['Float'];
  offerStockCount: Scalars['Int'];
  orderingConditions: Scalars['JSONString'];
  orderitemSet: Array<OrderItemType>;
  parentSellableItemStock: Array<SellableItemStockType>;
  parentStock?: Maybe<SellableItemStockType>;
  rejectedStockCount: Scalars['Int'];
  relatedStock?: Maybe<SellableItemStockType>;
  sellableItem: SellableItemType;
  sellableitemstockSet: Array<SellableItemStockType>;
  sku?: Maybe<SkuGraphType>;
  sourcedTransactions: Array<StockTransactionType>;
  taxRate?: Maybe<Scalars['Float']>;
  totalStockCount?: Maybe<Scalars['Int']>;
  unitRate: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  variantStocks?: Maybe<Array<Maybe<SellableItemStockType>>>;
};

/** An enumeration. */
export enum SellableItemTransportationType {
  /** Normal */
  NR = 'NR',
  /** Other */
  OT = 'OT',
  /** Refrigerated */
  RF = 'RF'
}

export type SellableItemType = {
  __typename?: 'SellableItemType';
  allowedDepartments: Array<DepartmentType>;
  batchstockSet: Array<BatchStockType>;
  childSellableItems?: Maybe<Array<Maybe<SellableItemType>>>;
  codename: Scalars['String'];
  compensationPercent: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  currentStockPercentage?: Maybe<Scalars['Float']>;
  externalReferences?: Maybe<Array<Maybe<ExternalReferenceType>>>;
  hasTaxes?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isCompensable: Scalars['Boolean'];
  isRefundable: Scalars['Boolean'];
  isReplaceable: Scalars['Boolean'];
  isReturnable: Scalars['Boolean'];
  itemGroups: Array<SellableItemGroupType>;
  longDescription: Scalars['String'];
  metadata?: Maybe<SellableItemMetadata>;
  name: Scalars['String'];
  orderitemSet: Array<OrderItemType>;
  overallRating: Scalars['Float'];
  parentItem?: Maybe<SellableItemType>;
  parentSellableItem: Array<SellableItemType>;
  photos: Array<MediaEntityType>;
  postExpiryWindow: Scalars['Int'];
  preExpiryWindow: Scalars['Int'];
  primaryItemWeight: Scalars['Float'];
  primaryPhoto: MediaEntityType;
  primarySkuCount: Scalars['Int'];
  primarySkuTareWeight: Scalars['Float'];
  relatedItem?: Maybe<SellableItemType>;
  relatedQuantity: Scalars['Int'];
  returnedByVendor?: Maybe<Scalars['Int']>;
  routecategorySet: Array<RouteCategoryType>;
  secondarySkuCount: Scalars['Int'];
  secondarySkuTareWeight: Scalars['Float'];
  secondarySkuType?: Maybe<SkuGraphType>;
  sellableStocks?: Maybe<Array<Maybe<SellableItemStockType>>>;
  sellableVarieties: Array<SellableVarietyType>;
  sellableitemSet: Array<SellableItemType>;
  sellableitemreviewSet: Array<SellableItemReviewType>;
  shortDescription: Scalars['String'];
  stockDelivered?: Maybe<Scalars['Int']>;
  stockSettled?: Maybe<Scalars['Int']>;
  stockTotal?: Maybe<Scalars['Int']>;
  stockUnsettled?: Maybe<Scalars['Int']>;
  stockentryitemSet: Array<StockEntryItemType>;
  taxes: Array<TaxType>;
  tertiarySkuCount: Scalars['Int'];
  tertiarySkuTareWeight: Scalars['Float'];
  totalOrderValue?: Maybe<Scalars['Float']>;
  totalWeight?: Maybe<Scalars['Float']>;
  transportationType: SellableItemTransportationType;
  units: Array<SellableItemUnitType>;
  updatedAt: Scalars['DateTime'];
  vposCapacity: Scalars['Float'];
  vposCapacityUnit?: Maybe<SiUnitType>;
};


export type SellableItemTypeSellableStocksArgs = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type SellableItemUnitInput = {
  denominator?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  numerator?: InputMaybe<Scalars['Float']>;
  skuTypeId: Scalars['ID'];
  tag?: InputMaybe<Scalars['String']>;
};

export type SellableItemUnitType = {
  __typename?: 'SellableItemUnitType';
  baseUnit?: Maybe<SellableItemUnitType>;
  createdAt: Scalars['DateTime'];
  denominator: Scalars['Float'];
  id: Scalars['ID'];
  isBaseUnit: Scalars['Boolean'];
  numerator: Scalars['Float'];
  sellableItem: SellableItemType;
  sellableitemunitSet: Array<SellableItemUnitType>;
  skuType: SkuGraphType;
  tag: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SellableItemWiseStockVisibility = {
  __typename?: 'SellableItemWiseStockVisibility';
  activeStockCount?: Maybe<Scalars['Int']>;
  closing?: Maybe<Scalars['Float']>;
  delivered?: Maybe<Scalars['Float']>;
  directSale?: Maybe<Scalars['Float']>;
  disposal?: Maybe<Scalars['Float']>;
  inTransit?: Maybe<Scalars['Float']>;
  inwarded?: Maybe<Scalars['Float']>;
  opening?: Maybe<Scalars['Float']>;
  returned?: Maybe<Scalars['Float']>;
  sellableItem?: Maybe<SellableItemType>;
};

export type SellableItemWiseStockVisibilityFilterInput = {
  excludeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  suppliedById: Scalars['ID'];
};

export type SellableVarietyInput = {
  consumeWithin?: InputMaybe<Scalars['Int']>;
  gradeId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  skuCount?: InputMaybe<Scalars['Int']>;
  skuTypeId: Scalars['ID'];
  uomCount?: InputMaybe<Scalars['Float']>;
  uomTypeId: Scalars['ID'];
  varietyId: Scalars['ID'];
};

export type SellableVarietyType = {
  __typename?: 'SellableVarietyType';
  consumeWithin: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  grade: HarvestGradeType;
  id: Scalars['ID'];
  name: Scalars['String'];
  sellableItem: SellableItemType;
  skuCount: Scalars['Int'];
  skuType: SkuGraphType;
  uomCount: Scalars['Float'];
  uomType: SiUnitType;
  updatedAt: Scalars['DateTime'];
  variety: CommodityVarietyType;
};

/** An enumeration. */
export enum SellerCategory {
  /** Aggregator */
  AGG = 'AGG',
  /** Farmer */
  FAR = 'FAR',
  /** Retailer */
  RET = 'RET',
  /** Street Vendor */
  STV = 'STV',
  /** Trader */
  TRD = 'TRD',
  /** Vendor */
  VEN = 'VEN',
  /** Wholeseller */
  WHL = 'WHL'
}

export type SellerInput = {
  averageRating?: InputMaybe<Scalars['Int']>;
  category: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type SellerType = {
  __typename?: 'SellerType';
  averageRating: Scalars['Int'];
  category: SellerCategory;
  categoryObj?: Maybe<ClientStatusType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  pricebenchmarkmetadataSet: Array<PriceBenchmarkMetadataType>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<DeliveryAgentManagementType>;
};

export type SendNotificationMutation = {
  __typename?: 'SendNotificationMutation';
  notification?: Maybe<NotificationType>;
};

export type SendPackagingMaterialWhatsappApprovalMutation = {
  __typename?: 'SendPackagingMaterialWhatsappApprovalMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type SettlementFilterInput = {
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  settled?: InputMaybe<Scalars['Boolean']>;
  unsettled?: InputMaybe<Scalars['Boolean']>;
};

export type ShipmentPlanInput = {
  colourGroupId?: InputMaybe<Scalars['ID']>;
  eta?: InputMaybe<Scalars['String']>;
  etd?: InputMaybe<Scalars['String']>;
  exportCustomerId: Scalars['ID'];
  gtin?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceNo?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  portId?: InputMaybe<Scalars['ID']>;
  primaryPackMaterialId?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
  saleType?: InputMaybe<Scalars['String']>;
  secondaryPackMaterialId?: InputMaybe<Scalars['ID']>;
  skuFilled?: InputMaybe<Scalars['Float']>;
  skuTypeId: Scalars['ID'];
  soNo: Scalars['String'];
  specification?: InputMaybe<Scalars['String']>;
  varieties?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  varietyType?: InputMaybe<Scalars['String']>;
  weeklySrNo: Scalars['String'];
};

export type ShipmentPlanList = {
  __typename?: 'ShipmentPlanList';
  count?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<ShipmentPlanType>>>;
};

export type ShipmentPlanType = {
  __typename?: 'ShipmentPlanType';
  approvedtradeprofileSet: Array<ApprovedTradeProfileType>;
  colourGroup?: Maybe<ColorGroupType>;
  createdAt: Scalars['DateTime'];
  eta?: Maybe<Scalars['String']>;
  etd?: Maybe<Scalars['String']>;
  exportCustomer: ExportCustomerType;
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNo?: Maybe<Scalars['String']>;
  labels?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  port?: Maybe<PortType>;
  primaryPackMaterial?: Maybe<SkuPackingMaterialType>;
  production?: Maybe<ProductionType>;
  productionCreated?: Maybe<Scalars['Boolean']>;
  productionItemsCount?: Maybe<Scalars['Int']>;
  productionSet: Array<ProductionType>;
  productionStatus?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  saleType: Scalars['String'];
  secondaryPackMaterial?: Maybe<SkuPackingMaterialType>;
  skuFilled: Scalars['Float'];
  skuType: SkuGraphType;
  soNo: Scalars['String'];
  specification?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  varieties: Array<CommodityVarietyType>;
  varietyType: ShipmentPlanVarietyType;
  weeklySrNo: Scalars['String'];
};

/** An enumeration. */
export enum ShipmentPlanVarietyType {
  /** Mix */
  MIX = 'MIX',
  /** Single */
  SINGLE = 'SINGLE'
}

/** An enumeration. */
export enum ShippingDeliveryStatus {
  /** Arrived at DC */
  AAD = 'AAD',
  /** Delivered */
  DLV = 'DLV',
  /** Despatched to DC */
  DTD = 'DTD',
  /** Not Started */
  NST = 'NST',
  /** Out for Delivery */
  OFD = 'OFD',
  /** Ready for Pickup */
  RFP = 'RFP',
  /** Undelivered */
  UDL = 'UDL'
}

/** An enumeration. */
export enum ShippingShippingMethod {
  /** Home Delivery */
  HMD = 'HMD',
  /** Self Pickup */
  SPK = 'SPK'
}

export type ShippingType = {
  __typename?: 'ShippingType';
  actualDelivery?: Maybe<Scalars['DateTime']>;
  charges: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  deliveryRemark: Scalars['String'];
  deliveryStatus: ShippingDeliveryStatus;
  deliveryTaxes: Array<TaxType>;
  distributionCentre: DistributionCentreType;
  estimatedDelivery?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  orderitemSet: Array<OrderItemType>;
  pocName: Scalars['String'];
  pocNumber: Scalars['String'];
  shipmentSlotSelected?: Maybe<TimeSlotType>;
  shippingAddress?: Maybe<AddressType>;
  shippingMethod: ShippingShippingMethod;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum ShopCategory {
  /** Moving Shop */
  MV = 'MV',
  /** Permanent Shop */
  PR = 'PR',
  /** Temporary Shop */
  TP = 'TP'
}

export type ShopDetailFilterInput = {
  category?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum ShopSupplySource {
  /** APMC Trader */
  AP = 'AP',
  /** Distributor */
  DS = 'DS',
  /** Online Platform */
  OL = 'OL',
  /** Other */
  OT = 'OT',
  /** Own Farm */
  OW = 'OW'
}

export type ShopType = {
  __typename?: 'ShopType';
  /** Shop Address */
  address: AddressType;
  allowedCredits: Scalars['Float'];
  category: ShopCategory;
  certifications?: Maybe<Array<Maybe<GeneralCertificationType>>>;
  codename: Scalars['String'];
  commoditiesSupplied: Array<CommodityType>;
  companies: Array<CompanyType>;
  dailySales: Scalars['Float'];
  familyGroup?: Maybe<FamilyGroupType>;
  gstVendorCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  msmeStatusCode?: Maybe<Scalars['String']>;
  msmeTypeCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  orders: Array<AnnotatedOrderType>;
  pointOfContacts: Array<DeliveryAgentManagementType>;
  primaryPoc?: Maybe<DeliveryAgentManagementType>;
  supplySource: ShopSupplySource;
};

export type SkuByTripType = {
  __typename?: 'SkuByTripType';
  inQuantity?: Maybe<Scalars['Int']>;
  loadedQuantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<SkuGraphType>;
  unloadedQuantity?: Maybe<Scalars['Int']>;
};

export type SkuSettleInput = {
  bookingId: Scalars['ID'];
  settledSkus: Scalars['Int'];
};

export type SoilGraphType = {
  __typename?: 'SoilGraphType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  plotSet: Array<PlotType>;
};

export type StateInput = {
  codename?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StateType = {
  __typename?: 'StateType';
  addressSet: Array<AddressType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StatementCustomer = {
  __typename?: 'StatementCustomer';
  accountNumber?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gstin?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  mobileNumber?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  pocName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  vendorTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementCustomerList = {
  __typename?: 'StatementCustomerList';
  results?: Maybe<Array<Maybe<StatementCustomer>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StatementIssuer = {
  __typename?: 'StatementIssuer';
  address?: Maybe<Scalars['String']>;
  cin?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gstin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  pan?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type StatementTransaction = {
  __typename?: 'StatementTransaction';
  closingBalance?: Maybe<Scalars['Decimal']>;
  creditAmount?: Maybe<Scalars['Decimal']>;
  date?: Maybe<Scalars['Date']>;
  debitAmount?: Maybe<Scalars['Decimal']>;
  docNumber?: Maybe<Scalars['String']>;
  docType?: Maybe<Scalars['String']>;
  gstValue?: Maybe<Scalars['Decimal']>;
  invoiceNo?: Maybe<Scalars['String']>;
  order?: Maybe<OrderType>;
  orderId: Scalars['ID'];
  taxableValue?: Maybe<Scalars['Decimal']>;
  withholdingTax?: Maybe<Scalars['Decimal']>;
};

export type StaticType = {
  __typename?: 'StaticType';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StockEntryItemFilterInput = {
  addedOn?: InputMaybe<Scalars['Date']>;
  batchStockId?: InputMaybe<Scalars['ID']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  excludeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isSku?: InputMaybe<Scalars['Boolean']>;
  itemGroup?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  manufacturedOn?: InputMaybe<Scalars['Date']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  skuId?: InputMaybe<Scalars['ID']>;
  stockCount_Lte?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum StockEntryItemGrade {
  /** Fresh */
  FRS = 'FRS',
  /** NA */
  NA = 'NA',
  /** Resale */
  RSL = 'RSL'
}

export type StockEntryItemInput = {
  addedOn?: InputMaybe<Scalars['Date']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  batchStockId?: InputMaybe<Scalars['ID']>;
  grade?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  sellableItemId?: InputMaybe<Scalars['ID']>;
  skuId?: InputMaybe<Scalars['ID']>;
  subLocationId?: InputMaybe<Scalars['ID']>;
};

export type StockEntryItemType = {
  __typename?: 'StockEntryItemType';
  addedOn: Scalars['Date'];
  approvalLogs?: Maybe<Array<Maybe<StockTakeApprovalRequestType>>>;
  attachments: Array<MediaEntityType>;
  batchStock?: Maybe<BatchStockType>;
  createdAt: Scalars['DateTime'];
  grade: StockEntryItemGrade;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  remark: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  sellableItem?: Maybe<SellableItemType>;
  sku?: Maybe<SkuGraphType>;
  subLocation: DcSubLocationType;
  systemCount?: Maybe<Scalars['Int']>;
  takenAt?: Maybe<AddressType>;
  takenBy: DeliveryAgentManagementType;
  takenIn: DepartmentType;
  updatedAt: Scalars['DateTime'];
};

export type StockEntryItemsByBatchStockRate = {
  __typename?: 'StockEntryItemsByBatchStockRate';
  batchStock?: Maybe<BatchStockType>;
  stockCount?: Maybe<Scalars['Int']>;
  systemCount?: Maybe<Scalars['Int']>;
};

export type StockEntryItemsByLocation = {
  __typename?: 'StockEntryItemsByLocation';
  locations?: Maybe<Array<Maybe<StockEntryItemsByLocationCount>>>;
  stockCount?: Maybe<Scalars['Int']>;
  systemCount?: Maybe<Scalars['Int']>;
};

export type StockEntryItemsByLocationCount = {
  __typename?: 'StockEntryItemsByLocationCount';
  approvalStatus?: Maybe<StockTakeApprovalRequestType>;
  grade?: Maybe<Scalars['String']>;
  stockTake?: Maybe<Scalars['Int']>;
  subLocation?: Maybe<DcSubLocationType>;
};

export type StockManagementWebFilterInput = {
  excludeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type StockSettleInput = {
  bookingId: Scalars['ID'];
  settledQuantity: Scalars['Int'];
};

export type StockTakeApprovalRequestByDc = {
  __typename?: 'StockTakeApprovalRequestByDC';
  approvedRequests?: Maybe<Scalars['Int']>;
  distributionCentre?: Maybe<DistributionCentreType>;
  pendingRequests?: Maybe<Scalars['Int']>;
  rejectedRequests?: Maybe<Scalars['Int']>;
  requestedAt?: Maybe<Scalars['DateTime']>;
  requestedBy?: Maybe<BaseUserType>;
  totalRequests?: Maybe<Scalars['Int']>;
};

export type StockTakeApprovalRequestInput = {
  addedOn?: InputMaybe<Scalars['Date']>;
  approvedAt?: InputMaybe<Scalars['DateTime']>;
  approvedById?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  distributionCentreIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  excludeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeItemCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isSku?: InputMaybe<Scalars['Boolean']>;
  primaryContactId?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  requestedAt?: InputMaybe<Scalars['DateTime']>;
  requestedById?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StockTakeApprovalRequestType = {
  __typename?: 'StockTakeApprovalRequestType';
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<DeliveryAgentManagementType>;
  attachments: Array<MediaEntityType>;
  id: Scalars['ID'];
  objectId: Scalars['Int'];
  remark: Scalars['String'];
  requestedAt: Scalars['DateTime'];
  requestedBy: DeliveryAgentManagementType;
  requestedToGroup: Array<GroupType>;
  requestedToUser?: Maybe<DeliveryAgentManagementType>;
  status: ApprovalRequestStatus;
  stockEntryItem?: Maybe<StockEntryItemType>;
};

export type StockTakeItem = {
  __typename?: 'StockTakeItem';
  approvalRequest?: Maybe<StockTakeApprovalRequestType>;
  batchStock?: Maybe<BatchStockType>;
  id?: Maybe<Scalars['ID']>;
  sellableItem?: Maybe<SellableItemType>;
  stockCount?: Maybe<Scalars['Int']>;
  systemCount?: Maybe<Scalars['Int']>;
};

export type StockTakeStockMovementMutation = {
  __typename?: 'StockTakeStockMovementMutation';
  approvals?: Maybe<Array<Maybe<StockTakeApprovalRequestType>>>;
};

/** An enumeration. */
export enum StockTransactionTransactionType {
  /** Add Stock */
  ADD = 'ADD',
  /** Remove Stock */
  RMV = 'RMV',
  /** Shift Stock */
  SHF = 'SHF'
}

export type StockTransactionType = {
  __typename?: 'StockTransactionType';
  createdAt: Scalars['DateTime'];
  destinationBucket: Scalars['String'];
  destinationStock?: Maybe<SellableItemStockType>;
  destinationStockCopy: Scalars['JSONString'];
  id: Scalars['ID'];
  isTransferred: Scalars['Boolean'];
  orderitemSet: Array<OrderItemType>;
  recordedBy: DeliveryAgentManagementType;
  recordedIn: DepartmentType;
  remark: Scalars['String'];
  sourceBucket: Scalars['String'];
  sourceStock?: Maybe<SellableItemStockType>;
  sourceStockCopy: Scalars['JSONString'];
  transactionType?: Maybe<StockTransactionTransactionType>;
  transferAmount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SummaryAllOrders = {
  __typename?: 'SummaryAllOrders';
  itemCount?: Maybe<Scalars['Int']>;
  itemStatusCancelledByUser?: Maybe<Scalars['Int']>;
  itemStatusCancelledByVendor?: Maybe<Scalars['Int']>;
  itemStatusCompleted?: Maybe<Scalars['Int']>;
  itemStatusConfirmed?: Maybe<Scalars['Int']>;
  itemStatusDespatched?: Maybe<Scalars['Int']>;
  itemStatusFullReject?: Maybe<Scalars['Int']>;
  itemStatusInProcess?: Maybe<Scalars['Int']>;
  itemStatusNotPlaced?: Maybe<Scalars['Int']>;
  itemStatusPartialReject?: Maybe<Scalars['Int']>;
  itemStatusPlaced?: Maybe<Scalars['Int']>;
  itemStatusReadyForDespatch?: Maybe<Scalars['Int']>;
  itemStatusReadyForSchedule?: Maybe<Scalars['Int']>;
  itemStatusScheduledForDespatch?: Maybe<Scalars['Int']>;
  orderCount?: Maybe<Scalars['Int']>;
  statusCancelledByUser?: Maybe<Scalars['Int']>;
  statusCancelledByVendor?: Maybe<Scalars['Int']>;
  statusCompleted?: Maybe<Scalars['Int']>;
  statusConfirmed?: Maybe<Scalars['Int']>;
  statusDespatched?: Maybe<Scalars['Int']>;
  statusFullReject?: Maybe<Scalars['Int']>;
  statusInProcess?: Maybe<Scalars['Int']>;
  statusNotPlaced?: Maybe<Scalars['Int']>;
  statusPartialReject?: Maybe<Scalars['Int']>;
  statusPlaced?: Maybe<Scalars['Int']>;
  statusReadyForDespatch?: Maybe<Scalars['Int']>;
  statusReadyForSchedule?: Maybe<Scalars['Int']>;
  statusScheduledForDespatch?: Maybe<Scalars['Int']>;
};

export type SummaryAllVehicles = {
  __typename?: 'SummaryAllVehicles';
  archivedVehicles?: Maybe<Scalars['Int']>;
  availableVehicles?: Maybe<Scalars['Int']>;
  breakdownVehicles?: Maybe<Scalars['Int']>;
  onleaveVehicles?: Maybe<Scalars['Int']>;
  plannedVehicles?: Maybe<Scalars['Int']>;
  totalVehicles?: Maybe<Scalars['Int']>;
  unavailableVehicles?: Maybe<Scalars['Int']>;
  unplannedVehicles?: Maybe<Scalars['Int']>;
  unusableVehicles?: Maybe<Scalars['Int']>;
  usableVehicles?: Maybe<Scalars['Int']>;
};

export type SummaryApprovalRequestByDc = {
  __typename?: 'SummaryApprovalRequestByDC';
  allApproved?: Maybe<Scalars['Int']>;
  noRequests?: Maybe<Scalars['Int']>;
  requested?: Maybe<Scalars['Int']>;
  totalDc?: Maybe<Scalars['Int']>;
};

export type SummaryBatchStocksType = {
  __typename?: 'SummaryBatchStocksType';
  approvedCount?: Maybe<Scalars['Int']>;
  approvedRequestedTdelta?: Maybe<Scalars['String']>;
  deviationPercent?: Maybe<Scalars['Float']>;
  totalDeviation?: Maybe<Scalars['Float']>;
  unapprovedCount?: Maybe<Scalars['Int']>;
};

export type SummaryOfPaymentsByAggregator = {
  __typename?: 'SummaryOfPaymentsByAggregator';
  /** Cash collected */
  cashCollectedByAggregator?: Maybe<Scalars['Float']>;
  /** Cash settled */
  cashSettledByAggregator?: Maybe<Scalars['Float']>;
  /** Cheque collected */
  chequeCollectedByAggregator?: Maybe<Scalars['Float']>;
  /** Cheque collected */
  chequeSettledByAggregator?: Maybe<Scalars['Float']>;
  /** Digital modes : UPI, RTGS, NEFT collected */
  digitalCollectedByAggregator?: Maybe<Scalars['Float']>;
  /** Digital modes: UPI, RTGS,  settled */
  digitalSettledByAggregator?: Maybe<Scalars['Float']>;
};

export type SummaryOfVendorBySalesman = {
  __typename?: 'SummaryOfVendorBySalesman';
  maxDeliveredOrderValue?: Maybe<Scalars['Float']>;
  maxOrderValueFluctuation?: Maybe<Scalars['Float']>;
  maxRejectionPercentage?: Maybe<Scalars['Float']>;
  maxTotalOrderValue?: Maybe<Scalars['Float']>;
  maxVisitCount?: Maybe<Scalars['Float']>;
};

export type SummaryRequestInput = {
  approvedRequests_Gt?: InputMaybe<Scalars['Int']>;
  approvedRequests_Lte?: InputMaybe<Scalars['Int']>;
  pendingRequests_Gt?: InputMaybe<Scalars['Int']>;
  pendingRequests_Lte?: InputMaybe<Scalars['Int']>;
  rejectedRequests_Gt?: InputMaybe<Scalars['Int']>;
  rejectedRequests_Lte?: InputMaybe<Scalars['Int']>;
  totalRequests_Gt?: InputMaybe<Scalars['Int']>;
  totalRequests_Lte?: InputMaybe<Scalars['Int']>;
};

export type SummarySalesManagement = {
  __typename?: 'SummarySalesManagement';
  registeredCustomers?: Maybe<Scalars['Int']>;
  returnValue?: Maybe<Scalars['Float']>;
  totalBusiness?: Maybe<Scalars['Float']>;
  totalCustomers?: Maybe<Scalars['Int']>;
  totalOrderCount?: Maybe<Scalars['Int']>;
};

export type SummarySellableItemsType = {
  __typename?: 'SummarySellableItemsType';
  delivered?: Maybe<Scalars['Float']>;
  loaded?: Maybe<Scalars['Float']>;
  sellableItemId?: Maybe<Scalars['ID']>;
  sellableItemName?: Maybe<Scalars['String']>;
  unloaded?: Maybe<Scalars['Float']>;
};

export type SummarySkusType = {
  __typename?: 'SummarySkusType';
  bDelivered?: Maybe<Scalars['Float']>;
  bLoaded?: Maybe<Scalars['Float']>;
  bUnloaded?: Maybe<Scalars['Float']>;
  besDelivered?: Maybe<Scalars['Float']>;
  besLoaded?: Maybe<Scalars['Float']>;
  besUnloaded?: Maybe<Scalars['Float']>;
  oibQuantity?: Maybe<Scalars['Float']>;
  skuId?: Maybe<Scalars['ID']>;
  skuName?: Maybe<Scalars['String']>;
};

export type SummaryUsersEcom = {
  __typename?: 'SummaryUsersEcom';
  activeCustomers?: Maybe<Scalars['Int']>;
  inactiveCustomers?: Maybe<Scalars['Int']>;
  notVerifiedCustomers?: Maybe<Scalars['Int']>;
  totalCustomers?: Maybe<Scalars['Int']>;
  verifiedCustomers?: Maybe<Scalars['Int']>;
};

export type SummaryUsersEcomFilterInput = {
  groups?: InputMaybe<Scalars['String']>;
};

export type SupBeatFilterInput = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};

export type SupBeatType = {
  __typename?: 'SupBeatType';
  assignee: DeliveryAgentManagementType;
  assignment: RouteAssignmentType;
  createdAt: Scalars['DateTime'];
  /** Date of the beat */
  date: Scalars['Date'];
  /** Beat completion time */
  endTime?: Maybe<Scalars['Time']>;
  id: Scalars['ID'];
  metadata: Scalars['JSONString'];
  remark?: Maybe<Scalars['String']>;
  /** Beat start time */
  startTime?: Maybe<Scalars['Time']>;
  status?: Maybe<Status>;
  summary?: Maybe<SuperviseSummaryType>;
  updatedAt: Scalars['DateTime'];
  visits: Array<BeatVisitType>;
};

export type SuperviseSummaryFilterInput = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  routeId?: InputMaybe<Scalars['ID']>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
};

export type SuperviseSummaryType = {
  __typename?: 'SuperviseSummaryType';
  assignee?: Maybe<DeliveryAgentManagementType>;
  completedCalls: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  distributionCentre?: Maybe<DistributionCentreType>;
  dropSize: Scalars['Float'];
  duration?: Maybe<DurationType>;
  durationAvg?: Maybe<DurationType>;
  durationAvgSec?: Maybe<Scalars['Float']>;
  durationSec?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  linesSold: Scalars['Int'];
  placedOrderCount: Scalars['Int'];
  previousSale?: Maybe<Scalars['Float']>;
  productiveCalls: Scalars['Int'];
  route?: Maybe<RouteType>;
  scheduledCalls: Scalars['Int'];
  secondarySales: Scalars['Float'];
  surveyArea?: Maybe<SurveyAreaLocationType>;
  updatedAt: Scalars['DateTime'];
};

export type SurveyAreaFilterInput = {
  distributionCentreIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type SurveyAreaInput = {
  areaCatered?: InputMaybe<Scalars['Geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryUserId?: InputMaybe<Scalars['ID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SurveyAreaLocationType = {
  __typename?: 'SurveyAreaLocationType';
  bbox?: Maybe<Scalars['GenericScalar']>;
  geometry: GeometryObjectType;
  id: Scalars['ID'];
  properties?: Maybe<SurveyAreaProperties>;
  type?: Maybe<Scalars['String']>;
};

export type SurveyAreaProperties = {
  __typename?: 'SurveyAreaProperties';
  areaCateredFlipped?: Maybe<GeometryObjectType>;
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  distributionCentre?: Maybe<DistributionCentreType>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  primaryUser?: Maybe<DeliveryAgentManagementType>;
  routes: Array<RouteType>;
  supervisesummarySet: Array<SuperviseSummaryType>;
  updateFromAreaCateredFlipped: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  users: Array<DeliveryAgentManagementType>;
};

export type SwitchDepartmentMutation = {
  __typename?: 'SwitchDepartmentMutation';
  user?: Maybe<BaseUserType>;
};

export type TargetUserCountInput = {
  userFilters?: InputMaybe<Array<InputMaybe<UserFilterFieldsInput>>>;
  userQueryUid?: InputMaybe<Scalars['ID']>;
};

export type TargetUserCountType = {
  __typename?: 'TargetUserCountType';
  userCount?: Maybe<Scalars['Int']>;
};

export type TaskLogFilterInput = {
  createdAt_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Lte?: InputMaybe<Scalars['Date']>;
  isOk?: InputMaybe<Scalars['Boolean']>;
  periodicTaskIsNull?: InputMaybe<Scalars['Boolean']>;
  responseCode?: InputMaybe<Scalars['String']>;
};

export type TaskLogType = {
  __typename?: 'TaskLogType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isOk: Scalars['Boolean'];
  periodicTask?: Maybe<PeriodicTaskType>;
  requestData?: Maybe<Scalars['JSONString']>;
  responseCode?: Maybe<Scalars['Int']>;
  responseData?: Maybe<Scalars['JSONString']>;
  taskArgs?: Maybe<Scalars['JSONString']>;
  taskKwargs?: Maybe<Scalars['JSONString']>;
  taskName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type TaxType = {
  __typename?: 'TaxType';
  codename: Scalars['String'];
  distributioncentreSet: Array<DistributionCentreType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orderSet: Array<AnnotatedOrderType>;
  percentage: Scalars['Float'];
  sellableitemSet: Array<SellableItemType>;
  shippingSet: Array<ShippingType>;
};

export type TimeSlotInput = {
  estimatedDelivery?: InputMaybe<Scalars['String']>;
  fromTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['ID']>;
  maximumOrders?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  thresholdFrom?: InputMaybe<Scalars['Time']>;
  thresholdTo?: InputMaybe<Scalars['Time']>;
  toTime?: InputMaybe<Scalars['Time']>;
};

export type TimeSlotRequirementInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  quantityTolerance?: InputMaybe<Scalars['Int']>;
  quantityUnit?: InputMaybe<Scalars['Int']>;
  timeSlot?: InputMaybe<Scalars['Int']>;
};

export type TimeSlotRequirementType = {
  __typename?: 'TimeSlotRequirementType';
  bookedQuantity: Scalars['Float'];
  bookingSet: Array<BookingType>;
  demand: DemandType;
  id: Scalars['ID'];
  quantity: Scalars['Float'];
  quantityTolerance: Scalars['Int'];
  quantityUnit: SkuGraphType;
  schedulerequestSet: Array<ScheduleRequestType>;
  timeSlot: TimeSlotType;
  uuid: Scalars['UUID'];
};

export type TimeSlotType = {
  __typename?: 'TimeSlotType';
  contractrecurringexpenseSet: Array<ContractRecurringExpenseType>;
  dcAlternateSalesSlots: Array<DistributionCentreType>;
  dcDeliverySlots: Array<DistributionCentreType>;
  dcMaintenanceSlots: Array<DistributionCentreType>;
  dcPickupSlots: Array<DistributionCentreType>;
  estimatedDelivery: Scalars['String'];
  fromTime: Scalars['Time'];
  id: Scalars['ID'];
  maximumOrders: Scalars['Int'];
  name: Scalars['String'];
  orderSet: Array<AnnotatedOrderType>;
  shippingSet: Array<ShippingType>;
  thresholdFrom?: Maybe<Scalars['Time']>;
  thresholdTo?: Maybe<Scalars['Time']>;
  timeslotrequirementSet: Array<TimeSlotRequirementType>;
  toTime: Scalars['Time'];
};

export type TrackDetail = {
  __typename?: 'TrackDetail';
  dateTime?: Maybe<Scalars['DateTime']>;
  pickupType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  salesmanFullName?: Maybe<Scalars['String']>;
  salesmanId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  timeSlot?: Maybe<TimeSlotType>;
  timeSlotDate?: Maybe<Scalars['Date']>;
  vehicleId?: Maybe<Scalars['ID']>;
  vehicleRegistrationNumber?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum TradeProfileCategory {
  /** Default */
  DEFAULT = 'DEFAULT',
  /** Domestic */
  DOMESTIC = 'DOMESTIC',
  /** Export */
  EXPORT = 'EXPORT',
  /** Organic */
  ORGANIC = 'ORGANIC'
}

export type TradeProfileType = {
  __typename?: 'TradeProfileType';
  approvedtradeprofileSet: Array<ApprovedTradeProfileType>;
  area: Scalars['Float'];
  availableYield: Scalars['Float'];
  category: TradeProfileCategory;
  certificateNumber?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  exportCustomers: Array<ExportCustomerType>;
  extraAvailableYield?: Maybe<Scalars['Float']>;
  extraPlotYeild?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  plotCommodity: PlotCommodityType;
  plotYeild: Scalars['Float'];
  reason?: Maybe<Scalars['String']>;
  tradeYear?: Maybe<TradeYearType>;
  updatedAt: Scalars['DateTime'];
};

export type TradeYearType = {
  __typename?: 'TradeYearType';
  approvedtradeprofileSet: Array<ApprovedTradeProfileType>;
  codename: Scalars['String'];
  description: Scalars['String'];
  fromYear: Scalars['Int'];
  harvestprojectionSet: Array<HarvestProjectionType>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  toYear: Scalars['Int'];
  tradeprofileSet: Array<TradeProfileType>;
};

export type TransactionDetailInput = {
  accountId?: InputMaybe<Scalars['ID']>;
  date_Gte?: InputMaybe<Scalars['Date']>;
  date_Lte?: InputMaybe<Scalars['Date']>;
  dcId?: InputMaybe<Scalars['ID']>;
  orderTrackingCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paymentMethodsNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  statusNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TransactionGraphType = {
  __typename?: 'TransactionGraphType';
  /** Account in which the transaction took place */
  account: AccountType;
  amount: Scalars['Float'];
  /** Media files */
  attachments: Array<MediaEntityType>;
  chequeTransaction?: Maybe<OrderTransactionType>;
  createdAt: Scalars['DateTime'];
  currency: CurrencyType;
  date: Scalars['Date'];
  dcCollectionLog?: Maybe<DcCollectionLogType>;
  id: Scalars['ID'];
  metadata: Scalars['JSONString'];
  objectId?: Maybe<Scalars['Int']>;
  /** use only for credit transactions */
  orderTransactions: Array<OrderTransactionType>;
  paymentMethod: PaymentMethodType;
  /** User who recorded the transaction */
  recordedBy: DeliveryAgentManagementType;
  /** eg: DD no./cheque no. */
  referenceId: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  settledForTransaction?: Maybe<TransactionGraphType>;
  /** Status of transaction */
  status: TransactionStatus;
  transactionId: Scalars['String'];
  transactionSet: Array<TransactionGraphType>;
  transactionType: TransactionTypeType;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum TransactionStatus {
  /** Authorized */
  AUT = 'AUT',
  /** Created */
  CRT = 'CRT',
  /** Failed */
  FAL = 'FAL',
  /** Reconciliation Failed */
  RCF = 'RCF',
  /** Reconcile */
  RCN = 'RCN',
  /** Refunded */
  REF = 'REF',
  /** Successful */
  SUC = 'SUC'
}

/** An enumeration. */
export enum TransactionTypeKind {
  /** Credit */
  CREDIT = 'CREDIT',
  /** Debit */
  DEBIT = 'DEBIT'
}

export type TransactionTypeType = {
  __typename?: 'TransactionTypeType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  kind: TransactionTypeKind;
  name: Scalars['String'];
  transactionSet: Array<TransactionGraphType>;
};

export type TriggerNotificationMutation = {
  __typename?: 'TriggerNotificationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type TripCoordinate = {
  __typename?: 'TripCoordinate';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  pointType?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum TripDespatchStatus {
  /** Dock Entered */
  DET = 'DET',
  /** Dock Assigned */
  DKA = 'DKA',
  /** Despatch Planned */
  DSP = 'DSP',
  /** Loading */
  LOD = 'LOD',
  /** Not Defined */
  NOD = 'NOD',
  /** Premises Entered */
  PEN = 'PEN',
  /** Premises Exited */
  PEX = 'PEX'
}

export type TripFilterSummary = {
  __typename?: 'TripFilterSummary';
  tripStatus?: Maybe<TripStatusDetail>;
};

export type TripHistorySummary = {
  __typename?: 'TripHistorySummary';
  averageSpeed?: Maybe<Scalars['Float']>;
  averageWaitTime?: Maybe<Scalars['Time']>;
  distance?: Maybe<Scalars['Float']>;
  filteredPoints?: Maybe<Scalars['Int']>;
  isFresh?: Maybe<Scalars['Boolean']>;
  logs?: Maybe<Array<Maybe<TripCoordinate>>>;
  signalLostCount?: Maybe<Scalars['Int']>;
  speedPoints?: Maybe<Scalars['Int']>;
  totalPoints?: Maybe<Scalars['Int']>;
  totalTimeTaken?: Maybe<Scalars['Time']>;
  trip?: Maybe<TripType>;
  tripEndTime?: Maybe<Scalars['DateTime']>;
  tripStartTime?: Maybe<Scalars['DateTime']>;
  tripUuid?: Maybe<Scalars['String']>;
  waitCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum TripLoadingPattern {
  /** Not Selected */
  NOS = 'NOS',
  /** As per Order */
  ORD = 'ORD',
  /** As per Sellable Item */
  SLI = 'SLI'
}

/** An enumeration. */
export enum TripStatus {
  /** Completed */
  CP = 'CP',
  /** Discarded */
  DS = 'DS',
  /** Idle */
  IL = 'IL',
  /** Not Started */
  NS = 'NS',
  /** On Trip */
  OT = 'OT',
  /** Paused */
  PS = 'PS',
  /** Settled */
  ST = 'ST'
}

export type TripStatusDetail = {
  __typename?: 'TripStatusDetail';
  CPCount?: Maybe<Scalars['Int']>;
  DSCount?: Maybe<Scalars['Int']>;
  ILCount?: Maybe<Scalars['Int']>;
  NSCount?: Maybe<Scalars['Int']>;
  OTCount?: Maybe<Scalars['Int']>;
  PSCount?: Maybe<Scalars['Int']>;
};

export type TripStepFilterInput = {
  condition?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['Int']>;
  layer?: InputMaybe<Scalars['String']>;
};

export type TripStepFormFieldDropdownType = {
  __typename?: 'TripStepFormFieldDropdownType';
  formField: TripStepFormFieldType;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** An enumeration. */
export enum TripStepFormFieldFieldType {
  /** Boolean */
  BOOL = 'BOOL',
  /** Dropdown */
  DROP = 'DROP',
  /** Media */
  MEDI = 'MEDI',
  /** Number */
  NUMB = 'NUMB',
  /** Text */
  TEXT = 'TEXT'
}

export type TripStepFormFieldType = {
  __typename?: 'TripStepFormFieldType';
  dropdownItems: Array<TripStepFormFieldDropdownType>;
  fieldType: TripStepFormFieldFieldType;
  id: Scalars['ID'];
  name: Scalars['String'];
  spinnerItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  tripStep: TripStepType;
  values: Array<TripStepFormFieldValueType>;
};

export type TripStepFormFieldValueType = {
  __typename?: 'TripStepFormFieldValueType';
  field: TripStepFormFieldType;
  id: Scalars['ID'];
  trip: TripType;
  value: Scalars['String'];
};

/** An enumeration. */
export enum TripStepLayer {
  /** End Layer */
  END = 'END',
  /** Mid Layer */
  MID = 'MID',
  /** Start Layer */
  SRT = 'SRT'
}

export type TripStepLogType = {
  __typename?: 'TripStepLogType';
  address: AddressType;
  booking?: Maybe<BookingType>;
  id: Scalars['ID'];
  step: TripStepType;
  timestamp: Scalars['DateTime'];
  trip: TripType;
};

export type TripStepOutput = {
  __typename?: 'TripStepOutput';
  booking?: Maybe<Scalars['Int']>;
  bookingObj?: Maybe<BookingType>;
  condition?: Maybe<Scalars['String']>;
  estimatedTimestamp?: Maybe<Scalars['DateTime']>;
  formFields?: Maybe<Array<Maybe<FormFieldOutput>>>;
  layer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stepId?: Maybe<Scalars['String']>;
  stepObj?: Maybe<TripStepType>;
  stepType?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum TripStepStepType {
  /** Form */
  FOM = 'FOM',
  /** QR Code */
  QRC = 'QRC'
}

export type TripStepType = {
  __typename?: 'TripStepType';
  address?: Maybe<AddressType>;
  condition?: Maybe<Scalars['String']>;
  department: DepartmentType;
  formFields: Array<TripStepFormFieldType>;
  id: Scalars['ID'];
  layer: TripStepLayer;
  name: Scalars['String'];
  position: Scalars['Int'];
  stepId: Scalars['String'];
  stepLogs: Array<TripStepLogType>;
  stepType: TripStepStepType;
  ttr?: Maybe<Scalars['Time']>;
};

export type TripSummary = {
  __typename?: 'TripSummary';
  crateCompleted?: Maybe<Scalars['Int']>;
  crateInPremises?: Maybe<Scalars['Int']>;
  crateInTransit?: Maybe<Scalars['Int']>;
  crateInwarded?: Maybe<Scalars['Int']>;
  maxBookings?: Maybe<Scalars['Int']>;
  vehicleCompleted?: Maybe<Scalars['Int']>;
  vehicleInPremises?: Maybe<Scalars['Int']>;
  vehicleInTransit?: Maybe<Scalars['Int']>;
};

export type TripSummarySupplierType = {
  __typename?: 'TripSummarySupplierType';
  crop?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  skuCount?: Maybe<Scalars['Int']>;
  village?: Maybe<Scalars['String']>;
};

export type TripSummaryType = {
  __typename?: 'TripSummaryType';
  bookingCount?: Maybe<Scalars['Int']>;
  suppliers?: Maybe<Array<Maybe<TripSummarySupplierType>>>;
  vehicleNo?: Maybe<Scalars['String']>;
};

export type TripType = {
  __typename?: 'TripType';
  /** Use only Dispatch Management (Edit). May be Deprecated */
  DEPOrganisationUser?: Maybe<BaseUserType>;
  aggregator: DeliveryAgentManagementType;
  aggregatorSettlementDetail?: Maybe<AggregatorDetail>;
  billingdocSet: Array<BillingDocType>;
  bookings: Array<BookingType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  departmentAssigned: DepartmentType;
  despatchOtp: Scalars['Int'];
  despatchStatus: TripDespatchStatus;
  destinationDepot?: Maybe<DepotType>;
  dock?: Maybe<DockType>;
  dockDetails?: Maybe<Array<Maybe<DockDetailType>>>;
  dockSupervisor?: Maybe<DeliveryAgentManagementType>;
  endOdometer: Scalars['Int'];
  endOdometerPhoto?: Maybe<MediaEntityType>;
  endTime?: Maybe<Scalars['DateTime']>;
  estimatedDespatchTime?: Maybe<Scalars['DateTime']>;
  estimatedEndTime?: Maybe<Scalars['DateTime']>;
  estimatedStartTime?: Maybe<Scalars['DateTime']>;
  expense: Scalars['Float'];
  fieldValues: Array<TripStepFormFieldValueType>;
  gateInTime?: Maybe<Scalars['DateTime']>;
  gateInUser?: Maybe<DeliveryAgentManagementType>;
  gateNumber?: Maybe<GateNumberType>;
  gateOutTime?: Maybe<Scalars['DateTime']>;
  gateOutUser?: Maybe<DeliveryAgentManagementType>;
  id: Scalars['ID'];
  labourApprovalStatus?: Maybe<Scalars['String']>;
  labourCount?: Maybe<Scalars['Int']>;
  loadingPattern: TripLoadingPattern;
  optimisedBookings?: Maybe<Array<Maybe<BookingType>>>;
  orderStatusLogs: Array<OrderStatusLogType>;
  orderTransactions: Array<OrderTransactionType>;
  orders?: Maybe<Array<Maybe<OrderType>>>;
  remark?: Maybe<Scalars['String']>;
  scheduledVehicle?: Maybe<VehicleType>;
  sourceDepot?: Maybe<DepotType>;
  startOdometer: Scalars['Int'];
  startOdometerPhoto?: Maybe<MediaEntityType>;
  startTime?: Maybe<Scalars['DateTime']>;
  status: TripStatus;
  statusObj?: Maybe<ClientStatusType>;
  totalCrateCount?: Maybe<Scalars['Int']>;
  transportDetail?: Maybe<VehicleTransportDetailType>;
  tripLogs?: Maybe<Array<Maybe<TripStepLogType>>>;
  uniqueDestinations?: Maybe<Array<Maybe<Destination>>>;
  unloadedBy?: Maybe<UnloadingTeamType>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  vehicle: VehicleType;
  vehicleApprovalStatus?: Maybe<Scalars['String']>;
  weighDetail?: Maybe<WeighType>;
};


export type TripTypeAggregatorSettlementDetailArgs = {
  departmentId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
};


export type TripTypeDockDetailsArgs = {
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
};


export type TripTypeOptimisedBookingsArgs = {
  vehicleLat?: InputMaybe<Scalars['Float']>;
  vehicleLon?: InputMaybe<Scalars['Float']>;
};


export type TripTypeTripLogsArgs = {
  commonDc?: InputMaybe<Scalars['ID']>;
  destinationDc?: InputMaybe<Scalars['ID']>;
  sourceDc?: InputMaybe<Scalars['ID']>;
};

export type UnLoadingStockMovementMutation = {
  __typename?: 'UnLoadingStockMovementMutation';
  bookings?: Maybe<Array<Maybe<BookingType>>>;
};

export type UnloadingOrderItemBatchInput = {
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  id: Scalars['ID'];
  settledQuantity: Scalars['Int'];
};

export type UnloadingSubLocationFilterInput = {
  unloadingLocationId?: InputMaybe<Scalars['ID']>;
};

export type UnloadingSubLocationType = {
  __typename?: 'UnloadingSubLocationType';
  codename: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  scheduleSet: Array<ScheduleType>;
  unloadingLocation: DepotType;
  updatedAt: Scalars['DateTime'];
};

export type UnloadingTeamType = {
  __typename?: 'UnloadingTeamType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  contact: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  tripSet: Array<TripType>;
};

export type UnsettledDetail = {
  __typename?: 'UnsettledDetail';
  paymentCount?: Maybe<Scalars['Int']>;
  skuCount?: Maybe<Scalars['Int']>;
  stockCount?: Maybe<Scalars['Int']>;
  tripCount?: Maybe<Scalars['Int']>;
};

export type UpdateBookingInput = {
  bookingId: Scalars['ID'];
  deliveredQuantity: Scalars['Int'];
};

export type UpdateBookingMutation = {
  __typename?: 'UpdateBookingMutation';
  bookings?: Maybe<Array<Maybe<BookingType>>>;
};

export type UpdateBulkDemandMutation = {
  __typename?: 'UpdateBulkDemandMutation';
  demands?: Maybe<Array<Maybe<DemandType>>>;
};

export type UpdateDeliveredQuantityInput = {
  deliveredQuantity: Scalars['Int'];
  id: Scalars['ID'];
};

export type UpdateDeliveredQuantityMutation = {
  __typename?: 'UpdateDeliveredQuantityMutation';
  orderItems?: Maybe<Array<Maybe<OrderItemType>>>;
};

/** This is used only for updation of DC */
export type UpdateDistributionCentreMutation = {
  __typename?: 'UpdateDistributionCentreMutation';
  distributionCentre?: Maybe<DistributionCentreLocationType>;
};

export type UpdateFarmerGroupAndCompanyMutation = {
  __typename?: 'UpdateFarmerGroupAndCompanyMutation';
  user?: Maybe<BaseUserType>;
};

export type UpdateFuelDistributor = {
  __typename?: 'UpdateFuelDistributor';
  fuelDistributor?: Maybe<FuelDistributorType>;
};

export type UpdateFuelDistributorItem = {
  __typename?: 'UpdateFuelDistributorItem';
  fuelDistributorItem?: Maybe<FuelDistributorItemType>;
};

export type UpdateLinePackingAllotmentLotCode = {
  __typename?: 'UpdateLinePackingAllotmentLotCode';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateLinePackingAllotmentLotCodeInput = {
  id: Scalars['ID'];
  lotCode?: InputMaybe<Scalars['String']>;
  productionCreatedDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateOrderMutation = {
  __typename?: 'UpdateOrderMutation';
  order?: Maybe<OrderType>;
};

export type UpdatePeriodicTasks = {
  __typename?: 'UpdatePeriodicTasks';
  periodicTasks?: Maybe<Array<Maybe<PeriodicTaskType>>>;
};

export type UpdateScheduleMutation = {
  __typename?: 'UpdateScheduleMutation';
  schedules?: Maybe<Array<Maybe<ScheduleType>>>;
};

export type UpdateScheduleRowInput = {
  aggregatorId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['ID']>;
  cropGroupId?: InputMaybe<Scalars['ID']>;
  destinationDepot?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  farmQuantityUnit?: InputMaybe<Scalars['Int']>;
  farmWeight?: InputMaybe<Scalars['Float']>;
  labourCount?: InputMaybe<Scalars['Int']>;
  requiredQuantity?: InputMaybe<Scalars['Int']>;
  rowId?: InputMaybe<Scalars['Int']>;
  skuType?: InputMaybe<Scalars['Int']>;
  sourceDepot?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  transportServiceProviderId?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['Int']>;
};

export type UpdateTripDetailsMutation = {
  __typename?: 'UpdateTripDetailsMutation';
  trip?: Maybe<TripType>;
};

export type UpdateUserProfileMutation = {
  __typename?: 'UpdateUserProfileMutation';
  user?: Maybe<BaseUserType>;
};

export type UserExistsStatus = {
  __typename?: 'UserExistsStatus';
  firstName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum UserFilterFieldType {
  /** Array of Items */
  ARRY = 'ARRY',
  /** Boolean */
  BOOL = 'BOOL',
  /** Date */
  DATE = 'DATE',
  /** Date Time */
  DATM = 'DATM',
  /** Number */
  NUMB = 'NUMB',
  /** Relation */
  RELN = 'RELN',
  /** Text */
  TEXT = 'TEXT'
}

export type UserFilterFieldsInput = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['CustomGenericScalar']>>>;
};

export type UserFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  userQueryId?: InputMaybe<Scalars['ID']>;
};

export type UserFilterType = {
  __typename?: 'UserFilterType';
  displayName: Scalars['String'];
  exclude: Scalars['Boolean'];
  fieldType: UserFilterFieldType;
  id: Scalars['ID'];
  isRangeValue: Scalars['Boolean'];
  key: Scalars['String'];
  referenceQuery: Scalars['String'];
  userQuery: UserQueryType;
  value: Scalars['String'];
};

export type UserOrderOutstandingType = {
  __typename?: 'UserOrderOutstandingType';
  billingAddress?: Maybe<AddressType>;
  billingDoc: Array<BillingDocType>;
  bookingsByTrip?: Maybe<Array<Maybe<BookingType>>>;
  collectionLog?: Maybe<CollectionLogType>;
  crateBarcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  crateCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  dcCollectionLog?: Maybe<DcCollectionLogType>;
  deliveryStatus: OrderDeliveryStatus;
  discount?: Maybe<DiscountType>;
  id: Scalars['ID'];
  isConsolidated?: Maybe<Scalars['Boolean']>;
  isParentOrder?: Maybe<Scalars['Boolean']>;
  itemAggregate?: Maybe<ItemAggregateType>;
  metadata: Scalars['JSONString'];
  orderBookings: Array<BookingType>;
  orderCategory: OrderOrderCategory;
  orderItems?: Maybe<Array<Maybe<OrderItemType>>>;
  orderStatus: OrderOrderStatus;
  orderingDc?: Maybe<DistributionCentreType>;
  otp: Scalars['Int'];
  outstanding?: Maybe<Scalars['Float']>;
  outstandingAmount: Scalars['Float'];
  paymentMethod: OrderPaymentMethod;
  paymentStatus: OrderPaymentStatus;
  pickupDate?: Maybe<Scalars['Date']>;
  pickupSlotFromTime?: Maybe<Scalars['Time']>;
  pickupSlotToTime?: Maybe<Scalars['Time']>;
  pickupType?: Maybe<OrderPickupType>;
  placedBy?: Maybe<DeliveryAgentManagementType>;
  placedIn?: Maybe<DepartmentType>;
  pocName: Scalars['String'];
  pocNumber: Scalars['String'];
  remark: Scalars['String'];
  salesIncharge?: Maybe<DeliveryAgentManagementType>;
  selectedPickupSlot?: Maybe<TimeSlotType>;
  shippingAddress: AddressType;
  shippingCharges: Scalars['Float'];
  shippingMethod: OrderShippingMethod;
  shop?: Maybe<ShopType>;
  soNumber?: Maybe<Scalars['String']>;
  statusLogs: Array<OrderStatusLogType>;
  subOrders: Array<AnnotatedOrderType>;
  targetDc?: Maybe<DistributionCentreType>;
  taxes: Array<TaxType>;
  totalAmount: Scalars['Float'];
  totalPaid?: Maybe<Scalars['Float']>;
  totalPaidAndSettled?: Maybe<Scalars['Float']>;
  totalWeight?: Maybe<Scalars['Float']>;
  trackingCode: Scalars['String'];
  transactionAmount?: Maybe<AggregatorPaymentsDetail>;
  transactions?: Maybe<Array<Maybe<OrderTransactionType>>>;
  transactionsPaymentMethod?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: DeliveryAgentManagementType;
};


export type UserOrderOutstandingTypeBookingsByTripArgs = {
  isSkuUnsettled?: InputMaybe<Scalars['Boolean']>;
  isStockUnsettled?: InputMaybe<Scalars['Boolean']>;
  tripId?: InputMaybe<Scalars['ID']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type UserOrderOutstandingTypeItemAggregateArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type UserOrderOutstandingTypeOrderItemsArgs = {
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type UserOrderOutstandingTypeTransactionAmountArgs = {
  filter?: InputMaybe<PaymentsFilterInput>;
};


export type UserOrderOutstandingTypeTransactionsArgs = {
  status?: InputMaybe<Scalars['String']>;
};

export type UserQueryInput = {
  codename?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type UserQueryType = {
  __typename?: 'UserQueryType';
  codename: Scalars['String'];
  description: Scalars['String'];
  filters?: Maybe<Array<Maybe<UserFilterType>>>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  notificationtriggerSet: Array<NotificationTriggerType>;
};

export type UsersByGroupFilterInput = {
  /** Send Lastest Days, for Active Customer */
  active?: InputMaybe<Scalars['Int']>;
  distributionCenterId?: InputMaybe<Scalars['ID']>;
  /** Send Lastest Days, for InActive Customer */
  inactive?: InputMaybe<Scalars['Int']>;
  notVerified?: InputMaybe<Scalars['Boolean']>;
  pocDistributionCenterId?: InputMaybe<Scalars['ID']>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type VehicleDriverInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kycDetails?: InputMaybe<Array<InputMaybe<KycDetailInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  licenceDetail?: InputMaybe<AbstractDetailInput>;
  number?: InputMaybe<Scalars['String']>;
  secondaryNumber?: InputMaybe<Scalars['String']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
};

export type VehicleGraphType = {
  __typename?: 'VehicleGraphType';
  capacity: Scalars['Int'];
  capacityUnit?: Maybe<SiUnitType>;
  category: Scalars['String'];
  id: Scalars['ID'];
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  passengerCapacity: Scalars['Int'];
  vehicleSet: Array<VehicleType>;
};

export type VehicleInsuranceInput = {
  id?: InputMaybe<Scalars['ID']>;
  idNumber?: InputMaybe<Scalars['String']>;
  issuedOn?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  validTill?: InputMaybe<Scalars['Date']>;
};

export type VehicleKindType = {
  __typename?: 'VehicleKindType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  vehicleSet: Array<VehicleType>;
};

/** Deprecated! */
export type VehicleLoadingMutation = {
  __typename?: 'VehicleLoadingMutation';
  trip?: Maybe<TripType>;
};

export type VehicleOwnerInput = {
  address?: InputMaybe<AddressInput>;
  bankDetail?: InputMaybe<BankDetailInput>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kycDetails?: InputMaybe<Array<InputMaybe<KycDetailInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  secondaryNumber?: InputMaybe<Scalars['String']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
};

export type VehiclePickupReturnOrderMutation = {
  __typename?: 'VehiclePickupReturnOrderMutation';
  orderItemBatches?: Maybe<Array<Maybe<OrderItemBatchType>>>;
};

/** An enumeration. */
export enum VehicleStatus {
  /** Archived */
  AR = 'AR',
  /** Available */
  AV = 'AV',
  /** Broken */
  BR = 'BR',
  /** Not Available */
  NA = 'NA',
  /** On Trip */
  OT = 'OT',
  /** Repairing */
  RP = 'RP'
}

/** An enumeration. */
export enum VehicleTransportDetailAdvancePaidBy {
  /** Company */
  COMP = 'COMP',
  /** Supplier */
  SUPP = 'SUPP'
}

/** An enumeration. */
export enum VehicleTransportDetailPaymentType {
  /** Cash */
  CASH = 'CASH',
  /** Cheque */
  CHEQ = 'CHEQ',
  /** NEFT */
  NEFT = 'NEFT',
  /** RTGS */
  RTGS = 'RTGS',
  /** UPI Payment */
  UPIP = 'UPIP'
}

/** An enumeration. */
export enum VehicleTransportDetailRejectionBourneBy {
  /** Company */
  COMP = 'COMP',
  /** Supplier */
  SUPP = 'SUPP'
}

/** An enumeration. */
export enum VehicleTransportDetailTransportPaidBy {
  /** Company */
  COMP = 'COMP',
  /** Supplier */
  SUPP = 'SUPP'
}

export type VehicleTransportDetailType = {
  __typename?: 'VehicleTransportDetailType';
  /** % Acceptance of the weight loss occured in transit. */
  acceptedDeduction: Scalars['Float'];
  advanceCost: Scalars['Float'];
  advancePaidBy: VehicleTransportDetailAdvancePaidBy;
  /** Rate in Rs/Kg */
  deductionRate: Scalars['Float'];
  farmWeight?: Maybe<Scalars['Float']>;
  gradePrices?: Maybe<Array<Maybe<GradePriceType>>>;
  id: Scalars['ID'];
  oldGradePriceByCropGroup?: Maybe<GradePriceType>;
  paymentDueDate?: Maybe<Scalars['Date']>;
  paymentType: VehicleTransportDetailPaymentType;
  pricingDoneOn?: Maybe<Scalars['String']>;
  rejectionBourneBy: VehicleTransportDetailRejectionBourneBy;
  remark?: Maybe<Scalars['String']>;
  schedulerequestSet: Array<ScheduleRequestType>;
  schedules: Array<ScheduleType>;
  /** % Standard deduction for the commodity. */
  standardDeduction: Scalars['Float'];
  transportCost: Scalars['Float'];
  transportPaidBy: VehicleTransportDetailTransportPaidBy;
  trip?: Maybe<TripType>;
  weightApplicable: VehicleTransportDetailWeightApplicable;
};

/** An enumeration. */
export enum VehicleTransportDetailWeightApplicable {
  /** Factory Gate */
  FACG = 'FACG',
  /** Farm Gate */
  FRMG = 'FRMG'
}

export type VehicleTransportInput = {
  acceptedDeduction?: InputMaybe<Scalars['Float']>;
  advanceCost?: InputMaybe<Scalars['Float']>;
  advancePaidBy?: InputMaybe<Scalars['String']>;
  deductionRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  paymentDueDate?: InputMaybe<Scalars['Date']>;
  paymentType?: InputMaybe<Scalars['String']>;
  rejectionBourneBy?: InputMaybe<Scalars['String']>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
  transportCost?: InputMaybe<Scalars['Float']>;
  transportPaidBy?: InputMaybe<Scalars['String']>;
  weightApplicable?: InputMaybe<Scalars['String']>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  advanceAmount?: Maybe<Scalars['Float']>;
  alerts?: Maybe<Array<Maybe<AlertObject>>>;
  asset: Array<FuelDistributorItemType>;
  attachments: Array<MediaEntityType>;
  avgCostPerKg?: Maybe<Scalars['Float']>;
  avgMileage?: Maybe<Scalars['Float']>;
  certifications?: Maybe<Array<Maybe<GeneralCertificationType>>>;
  chassisNumber?: Maybe<Scalars['String']>;
  contracts?: Maybe<Array<Maybe<ContractType>>>;
  createdAt: Scalars['DateTime'];
  currentContract?: Maybe<ContractType>;
  dateBought: Scalars['Date'];
  departments: Array<DepartmentType>;
  depot?: Maybe<DepotType>;
  dimensionUnit?: Maybe<SiUnitType>;
  dimensions?: Maybe<Array<Maybe<Scalars['Float']>>>;
  distance?: Maybe<Scalars['Float']>;
  driver?: Maybe<DeliveryAgentManagementType>;
  estimatedAverage: Scalars['Float'];
  fuelAmount?: Maybe<Scalars['Float']>;
  fuelLiters?: Maybe<Scalars['Float']>;
  fuelTankCapacity: Scalars['Float'];
  fuelType?: Maybe<FuelGraphType>;
  id: Scalars['ID'];
  insurance?: Maybe<InsuranceDetailType>;
  loadingCapacity: Scalars['Float'];
  modelName?: Maybe<Scalars['String']>;
  myTrips: Array<TripType>;
  owner?: Maybe<DeliveryAgentManagementType>;
  passengerCapacity: Scalars['Int'];
  photo?: Maybe<Scalars['String']>;
  registrationNumber: Scalars['String'];
  scheduleSet: Array<ScheduleType>;
  schedulerequestSet: Array<ScheduleRequestType>;
  schedulesForDate?: Maybe<Array<Maybe<ScheduleType>>>;
  status: VehicleStatus;
  tankerNo: Array<FuelDistributorType>;
  totalDistance?: Maybe<Scalars['Float']>;
  totalWeight?: Maybe<Scalars['Float']>;
  tripSet: Array<TripType>;
  updatedAt: Scalars['DateTime'];
  vehicleKind?: Maybe<VehicleKindType>;
  vehicleType: VehicleGraphType;
};


export type VehicleTypeSchedulesForDateArgs = {
  date: Scalars['Date'];
};

export type VendorBySalesmanFilterInput = {
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']>;
  customStatus?: InputMaybe<Scalars['String']>;
  customStatusDate_Gte?: InputMaybe<Scalars['Date']>;
  customStatusDate_Lte?: InputMaybe<Scalars['Date']>;
  dateVisitCount_Gte?: InputMaybe<Scalars['Date']>;
  dateVisitCount_Lte?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDate_Gte?: InputMaybe<Scalars['Date']>;
  orderDate_Lte?: InputMaybe<Scalars['Date']>;
  orderValueFluctuation_Gte?: InputMaybe<Scalars['Float']>;
  orderValueFluctuation_Lte?: InputMaybe<Scalars['Float']>;
  rejectionPercentage_Gte?: InputMaybe<Scalars['Float']>;
  rejectionPercentage_Lte?: InputMaybe<Scalars['Float']>;
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalOrderValue_Gte?: InputMaybe<Scalars['Float']>;
  totalOrderValue_Lte?: InputMaybe<Scalars['Float']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  visitCount_Gte?: InputMaybe<Scalars['Int']>;
  visitCount_Lte?: InputMaybe<Scalars['Int']>;
};

export type VendorsFilterInput = {
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Verify = {
  __typename?: 'Verify';
  payload?: Maybe<Scalars['GenericScalar']>;
};

/** Deprecated! */
export type VerifyOtpMutation = {
  __typename?: 'VerifyOTPMutation';
  verification?: Maybe<Scalars['Boolean']>;
};

export type VerifyOtpStatus = {
  __typename?: 'VerifyOtpStatus';
  status?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

export type WeighBatchType = {
  __typename?: 'WeighBatchType';
  codename: Scalars['String'];
  grossWeight: Scalars['Float'];
  id: Scalars['ID'];
  netWeight: Scalars['Float'];
  skuCount: Scalars['Int'];
  skuTareWeight: Scalars['Float'];
  skuType?: Maybe<SkuGraphType>;
  /** SKU Count * SKU Tare Wt */
  tareWeight: Scalars['Float'];
  uomCount: Scalars['Float'];
  uomType?: Maybe<SiUnitType>;
  weigh: WeighType;
};

/** An enumeration. */
export enum WeighInvoicingDoneOn {
  /** Quantity */
  QTY = 'QTY',
  /** SKU Count */
  SKU = 'SKU'
}

/** An enumeration. */
export enum WeighStatus {
  /** Completed */
  CMP = 'CMP',
  /** On Hold */
  HLD = 'HLD',
  /** Not Started */
  NST = 'NST',
  /** Rejected */
  RJC = 'RJC',
  /** In Progress */
  WIP = 'WIP'
}

export type WeighType = {
  __typename?: 'WeighType';
  batches: Array<WeighBatchType>;
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  farmWeight: Scalars['Float'];
  /** Net - ((Std Deduct / 100) * Net) */
  finalWeight: Scalars['Float'];
  grade?: Maybe<HarvestGradeType>;
  grossWeight: Scalars['Float'];
  id: Scalars['ID'];
  invoicingDoneOn: WeighInvoicingDoneOn;
  inward?: Maybe<InwardType>;
  inwardedQuantity: Scalars['Int'];
  /** Gross - Tare */
  netWeight: Scalars['Float'];
  skuType?: Maybe<SkuGraphType>;
  standardDeduction: Scalars['Float'];
  status: WeighStatus;
  tareWeight: Scalars['Float'];
  tripSet: Array<TripType>;
  uomCount: Scalars['Float'];
  uomType?: Maybe<SiUnitType>;
  updatedAt: Scalars['DateTime'];
  /** Farm Wt - Net Wt */
  weightLoss: Scalars['Float'];
};

/** An enumeration. */
export enum Status {
  COMPLETED = 'completed',
  NOT_STARTED = 'not_started',
  ON_GOING = 'on_going',
  PAUSE = 'pause'
}

export type CurrentUserFragFragment = { __typename?: 'BaseUserType', id: string, number: string, username: string, fullName?: string | null, email: string, photo?: string | null, isSuperadmin: boolean, permissions?: Array<string | null> | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, currentDepartment?: { __typename?: 'DepartmentType', id: string, demandWhatsappApproval: boolean, kiteReferenceId?: string | null, pricingDoneOn?: DepartmentPricingDoneOn | null, gateEntryRequired: boolean, name: string, photo?: string | null, metadata: any, invoiceType: DepartmentInvoiceType, controlPricing: boolean, hasDynamicStock: boolean, optionalPricing: boolean, qcSubscription: boolean, isB2c?: boolean | null, generatePoAfterInward: boolean, defaultPerUnit: Array<{ __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } }>, defaultTraderVarieties?: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } | null> | null, access?: { __typename?: 'DepartmentAccessType', id: string, codename: string } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }> } | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string, photo?: string | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'QueryRoot', me?: { __typename?: 'Me', permissions?: Array<string | null> | null, distributionCentres?: Array<{ __typename?: 'DistributionCentreType', id: string, name: string, pointOfContacts?: Array<{ __typename?: 'BaseUserType', id: string, number: string, name?: string | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null> | null, address: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, district?: string | null, address?: string | null }, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, toTime: any }> } | null> | null, user?: { __typename?: 'BaseUserType', id: string, number: string, username: string, fullName?: string | null, email: string, photo?: string | null, isSuperadmin: boolean, permissions?: Array<string | null> | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, currentDepartment?: { __typename?: 'DepartmentType', id: string, demandWhatsappApproval: boolean, kiteReferenceId?: string | null, pricingDoneOn?: DepartmentPricingDoneOn | null, gateEntryRequired: boolean, name: string, photo?: string | null, metadata: any, invoiceType: DepartmentInvoiceType, controlPricing: boolean, hasDynamicStock: boolean, optionalPricing: boolean, qcSubscription: boolean, isB2c?: boolean | null, generatePoAfterInward: boolean, defaultPerUnit: Array<{ __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } }>, defaultTraderVarieties?: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } | null> | null, access?: { __typename?: 'DepartmentAccessType', id: string, codename: string } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }> } | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string, photo?: string | null }> } | null } | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'MutationRoot', login?: { __typename?: 'Login', token?: string | null, me?: { __typename?: 'BaseUserType', id: string, number: string, username: string, fullName?: string | null, email: string, photo?: string | null, isSuperadmin: boolean, permissions?: Array<string | null> | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, currentDepartment?: { __typename?: 'DepartmentType', id: string, demandWhatsappApproval: boolean, kiteReferenceId?: string | null, pricingDoneOn?: DepartmentPricingDoneOn | null, gateEntryRequired: boolean, name: string, photo?: string | null, metadata: any, invoiceType: DepartmentInvoiceType, controlPricing: boolean, hasDynamicStock: boolean, optionalPricing: boolean, qcSubscription: boolean, isB2c?: boolean | null, generatePoAfterInward: boolean, defaultPerUnit: Array<{ __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } }>, defaultTraderVarieties?: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } | null> | null, access?: { __typename?: 'DepartmentAccessType', id: string, codename: string } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }> } | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string, photo?: string | null }> } | null } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  department: Scalars['Int'];
}>;


export type UpdateDepartmentMutation = { __typename?: 'MutationRoot', switchDepartment?: { __typename?: 'SwitchDepartmentMutation', user?: { __typename?: 'BaseUserType', id: string, number: string, username: string, fullName?: string | null, email: string, photo?: string | null, isSuperadmin: boolean, permissions?: Array<string | null> | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, currentDepartment?: { __typename?: 'DepartmentType', id: string, demandWhatsappApproval: boolean, kiteReferenceId?: string | null, pricingDoneOn?: DepartmentPricingDoneOn | null, gateEntryRequired: boolean, name: string, photo?: string | null, metadata: any, invoiceType: DepartmentInvoiceType, controlPricing: boolean, hasDynamicStock: boolean, optionalPricing: boolean, qcSubscription: boolean, isB2c?: boolean | null, generatePoAfterInward: boolean, defaultPerUnit: Array<{ __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } }>, defaultTraderVarieties?: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } | null> | null, access?: { __typename?: 'DepartmentAccessType', id: string, codename: string } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }> } | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string, photo?: string | null }> } | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'MutationRoot', changePassword?: { __typename?: 'ChangePasswordMutation', user?: { __typename?: 'BaseUserType', id: string, number: string, username: string, fullName?: string | null, email: string, photo?: string | null, isSuperadmin: boolean, permissions?: Array<string | null> | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, currentDepartment?: { __typename?: 'DepartmentType', id: string, demandWhatsappApproval: boolean, kiteReferenceId?: string | null, pricingDoneOn?: DepartmentPricingDoneOn | null, gateEntryRequired: boolean, name: string, photo?: string | null, metadata: any, invoiceType: DepartmentInvoiceType, controlPricing: boolean, hasDynamicStock: boolean, optionalPricing: boolean, qcSubscription: boolean, isB2c?: boolean | null, generatePoAfterInward: boolean, defaultPerUnit: Array<{ __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } }>, defaultTraderVarieties?: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } | null> | null, access?: { __typename?: 'DepartmentAccessType', id: string, codename: string } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }> } | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string, photo?: string | null }> } | null } | null };

export type DailyMasterOtpQueryVariables = Exact<{ [key: string]: never; }>;


export type DailyMasterOtpQuery = { __typename?: 'QueryRoot', dailyMasterOtp?: number | null };

export type AllPriceBenchmarkDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PriceBenchmarkDataQueryInput>;
}>;


export type AllPriceBenchmarkDataQuery = { __typename?: 'QueryRoot', allPriceBenchmarkData?: Array<{ __typename?: 'PriceBenchmarkDataType', id: string, metadata: { __typename?: 'PriceBenchmarkMetadataType', id: string, date: any, commodityGroup: { __typename?: 'CommodityGroupType', id: string, name: string }, seller: { __typename?: 'SellerType', id: string, name: string, category: SellerCategory, categoryObj?: { __typename?: 'ClientStatusType', id?: number | null, name?: string | null } | null }, marketYard: { __typename?: 'MarketYardType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string } } }, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, photos: Array<{ __typename?: 'MediaEntityType', id: string, createdAt: any, url: string }>, gradePrices: Array<{ __typename?: 'GradePriceType', pricingDoneOn: GradePricePricingDoneOn, id: string, price?: number | null, rejection: number, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> } | null> | null };

export type VarietyGroupBenchmarkDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PriceBenchmarkRecommendationFilterInput>;
}>;


export type VarietyGroupBenchmarkDataQuery = { __typename?: 'QueryRoot', allPriceBenchmarkRecommendations?: Array<{ __typename?: 'PriceBenchmarkRecommendationType', id: string, date: any, benchmarkType?: PriceBenchmarkRecommendationBenchmarkType | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, commodityGroup: { __typename?: 'CommodityGroupType', id: string, name: string, isKeyValueProduct: boolean, codename: string }, marketYard: { __typename?: 'MarketYardType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string } }, recommendedPrice: { __typename?: 'GradePriceType', id: string, price?: number | null, pricingDoneOn: GradePricePricingDoneOn, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, name: string } | null }, averagePrice: { __typename?: 'GradePriceType', id: string, price?: number | null, pricingDoneOn: GradePricePricingDoneOn, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, name: string } | null } } | null> | null };

export type BenchmarkListFragFragment = { __typename?: 'PriceBenchmarkRecommendationType', id: string, date: any, commodityGroup: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string }, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, marketYard: { __typename?: 'MarketYardType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string } }, averagePrice: { __typename?: 'GradePriceType', id: string, price?: number | null, pricingDoneOn: GradePricePricingDoneOn, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, name: string } | null }, recommendedPrice: { __typename?: 'GradePriceType', id: string, price?: number | null, pricingDoneOn: GradePricePricingDoneOn, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, name: string } | null } };

export type AddBenchmarkRecommendationMutationVariables = Exact<{
  averagePrice: PriceInput;
  benchmarkType: Scalars['String'];
  benchmarkedAt: AddressInput;
  benchmarkingDoneInId?: InputMaybe<Scalars['ID']>;
  commodityGroupId: Scalars['ID'];
  date: Scalars['Date'];
  gradeId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  marketYardId: Scalars['ID'];
  recommendedPrice: PriceInput;
}>;


export type AddBenchmarkRecommendationMutation = { __typename?: 'MutationRoot', addBenchmarkRecommendation?: { __typename?: 'AddPriceBenchmarkRecommendation', banchmarkRecommendation?: { __typename?: 'PriceBenchmarkRecommendationType', id: string, benchmarkType?: PriceBenchmarkRecommendationBenchmarkType | null, date: any, benchmarkedAt?: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } | null, benchmarkingDoneIn?: { __typename?: 'DepartmentType', id: string, name: string } | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, marketYard: { __typename?: 'MarketYardType', id: string, name: string }, recommendedPrice: { __typename?: 'GradePriceType', id: string, isDefault: boolean, price?: number | null, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string } }, averagePrice: { __typename?: 'GradePriceType', id: string, isDefault: boolean, price?: number | null, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string } } } | null } | null };

export type BenchmarkRecommendationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PriceBenchmarkRecommendationFilterInput>;
}>;


export type BenchmarkRecommendationsQuery = { __typename?: 'QueryRoot', allPriceBenchmarkRecommendations?: Array<{ __typename?: 'PriceBenchmarkRecommendationType', id: string, date: any, commodityGroup: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string }, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, marketYard: { __typename?: 'MarketYardType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string } }, averagePrice: { __typename?: 'GradePriceType', id: string, price?: number | null, pricingDoneOn: GradePricePricingDoneOn, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, name: string } | null }, recommendedPrice: { __typename?: 'GradePriceType', id: string, price?: number | null, pricingDoneOn: GradePricePricingDoneOn, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, uomType?: { __typename?: 'SIUnitType', id: string, name: string } | null } } | null> | null };

export type BenchmarkRecommendationListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PriceBenchmarkRecommendationFilterInput>;
}>;


export type BenchmarkRecommendationListQuery = { __typename?: 'QueryRoot', allPriceBenchmarkRecommendations?: Array<{ __typename?: 'PriceBenchmarkRecommendationType', id: string, updatedAt: any, marketYard: { __typename?: 'MarketYardType', id: string, name: string }, commodityGroup: { __typename?: 'CommodityGroupType', id: string, name: string, varieties: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string }> }, averagePrice: { __typename?: 'GradePriceType', id: string, price?: number | null, rejection: number, priceUnit: { __typename?: 'SKUGraphType', id: string, codename: any, name: string } }, benchmarkedAt?: { __typename?: 'AddressType', id: string, village: string, latitude: number, longitude: number } | null } | null> | null };

export type BenchmarkDataListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PriceBenchmarkDataQueryInput>;
}>;


export type BenchmarkDataListQuery = { __typename?: 'QueryRoot', allPriceBenchmarkData?: Array<{ __typename?: 'PriceBenchmarkDataType', id: string, metadata: { __typename?: 'PriceBenchmarkMetadataType', id: string, createdAt: any, marketYard: { __typename?: 'MarketYardType', id: string, name: string }, recordedAt: { __typename?: 'AddressType', id: string, village: string, latitude: number, longitude: number }, seller: { __typename?: 'SellerType', id: string, name: string, category: SellerCategory } }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, rejection: number, isDefault: boolean, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string } }>, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }> } | null> | null };

export type CompanyDetailFragFragment = { __typename?: 'CompanyType', id: string, name: string, codename: string, displayName: string, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> };

export type AllCompaniesListQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type AllCompaniesListQuery = { __typename?: 'QueryRoot', allCompanies?: Array<{ __typename?: 'CompanyType', id: string, name: string, codename: string, kind: CompanyKind, displayName: string, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null> | null };

export type CompanyDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type CompanyDetailQuery = { __typename?: 'QueryRoot', companyDetails?: { __typename?: 'CompanyType', id: string, name: string, codename: string, displayName: string, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null };

export type AddUpdateCompanyMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type AddUpdateCompanyMutation = { __typename?: 'MutationRoot', addCompany?: { __typename?: 'AddCompanyMutation', company?: { __typename?: 'CompanyType', id: string, name: string, codename: string, displayName: string, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null } | null };

export type ContractDetailFragFragment = { __typename?: 'ContractType', id: string, resourceAmount: number, startDate: any, endDate: any, status: ContractStatus, contractCode?: string | null, dailyAllowance: number, contractType: { __typename?: 'ContractGraphType', id: string, name: string, codename: string }, contractrecurringexpenseSet: Array<{ __typename?: 'ContractRecurringExpenseType', id: string, cost: number, unitCount: number, shift: { __typename?: 'TimeSlotType', id: string, name: string } }> };

export type ContractDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ContractDetailsQuery = { __typename?: 'QueryRoot', contractDetails?: { __typename?: 'ContractType', id: string, resourceAmount: number, startDate: any, endDate: any, status: ContractStatus, contractCode?: string | null, dailyAllowance: number, contractType: { __typename?: 'ContractGraphType', id: string, name: string, codename: string }, contractrecurringexpenseSet: Array<{ __typename?: 'ContractRecurringExpenseType', id: string, cost: number, unitCount: number, shift: { __typename?: 'TimeSlotType', id: string, name: string } }> } | null };

export type AddUpdateVehicleContractMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  status: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  entityIssued: Scalars['ID'];
  contractTypeId: Scalars['ID'];
  resourceAmount?: InputMaybe<Scalars['Int']>;
  dailyAllowance?: InputMaybe<Scalars['Float']>;
  recurringExpenses?: InputMaybe<Array<InputMaybe<ContractRecurringExpenseInput>> | InputMaybe<ContractRecurringExpenseInput>>;
}>;


export type AddUpdateVehicleContractMutation = { __typename?: 'MutationRoot', addUpdateVehicleContract?: { __typename?: 'AddUpdateVehicleContract', contract?: { __typename?: 'ContractType', id: string, resourceAmount: number, startDate: any, endDate: any, status: ContractStatus, contractCode?: string | null, dailyAllowance: number, contractType: { __typename?: 'ContractGraphType', id: string, name: string, codename: string }, contractrecurringexpenseSet: Array<{ __typename?: 'ContractRecurringExpenseType', id: string, cost: number, unitCount: number, shift: { __typename?: 'TimeSlotType', id: string, name: string } }> } | null } | null };

export type MyCouponsQueryVariables = Exact<{
  totalAmount?: InputMaybe<Scalars['Float']>;
  dcId?: InputMaybe<Scalars['ID']>;
  isOrder?: InputMaybe<Scalars['Boolean']>;
  sellableItemStockId?: InputMaybe<Scalars['ID']>;
}>;


export type MyCouponsQuery = { __typename?: 'QueryRoot', myCupons?: Array<{ __typename?: 'DiscountType', id: string, name: string, flat: number, percentage: number, discountConditions: any } | null> | null };

export type AllCreditsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CreditFilterInput>;
}>;


export type AllCreditsQuery = { __typename?: 'QueryRoot', allCredits?: Array<{ __typename?: 'CreditType', id: string, totalAmount: number, usedAmount: number, remainingAmount: number, paymentCycleDays: number, startDate?: any | null, endDate?: any | null, status: CreditStatus, isActive: boolean, createdAt: any, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } | null> | null };

export type CreditDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreditDetailQuery = { __typename?: 'QueryRoot', creditDetail?: { __typename?: 'CreditType', id: string, totalAmount: number, usedAmount: number, remainingAmount: number, paymentCycleDays: number, startDate?: any | null, endDate?: any | null, status: CreditStatus, isActive: boolean, createdAt: any, updatedAt: any, verifiedOn?: any | null, verificationRemark?: string | null, isVerified: boolean, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, updatedBy?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, verifiedBy?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, unsettledCreditOrders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, date: any, orderStatus: OrderOrderStatus, paymentStatus: OrderPaymentStatus, totalAmount: number, outstandingAmount: number } | null> | null, settledCreditOrders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, date: any, orderStatus: OrderOrderStatus, paymentStatus: OrderPaymentStatus, totalAmount: number, outstandingAmount: number } | null> | null } | null };

export type SummaryCreditsQueryVariables = Exact<{
  filter?: InputMaybe<CreditFilterInput>;
}>;


export type SummaryCreditsQuery = { __typename?: 'QueryRoot', summaryCredits?: { __typename?: 'CreditSummary', totalCreditSanctioned?: number | null, totalUtilized?: number | null, remainingAmount?: number | null, activeUsers?: number | null } | null };

export type MetabaseUrlQueryVariables = Exact<{
  filter?: InputMaybe<MetabaseUrlInput>;
}>;


export type MetabaseUrlQuery = { __typename?: 'QueryRoot', metabaseUrl?: { __typename?: 'MetabaseURLType', iframeUrl?: string | null } | null };

export type DemandListFragFragment = { __typename?: 'DemandType', id: string, date: any, name: string, isLive: boolean, isVerified: boolean, dateTill?: any | null, broadcastTime: any, inwardedQuantity?: number | null, varietyGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, priceSummary?: { __typename?: 'DemandPriceSummary', minPrice?: number | null, avgPrice?: number | null, maxPrice?: number | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, depot: { __typename?: 'DepotType', id: string, name: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, priceLimit: number, isDefault: boolean, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string } }>, timeSlots: Array<{ __typename?: 'TimeSlotRequirementType', id: string, bookedQuantity: number, quantity: number, timeSlot: { __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, toTime: any }, quantityUnit: { __typename?: 'SKUGraphType', id: string, name: string } }> };

export type CreateDemandMutationVariables = Exact<{
  name: Scalars['String'];
  dateRange: Array<Scalars['Date']> | Scalars['Date'];
  varietyGroup: Scalars['ID'];
  depot: Scalars['Int'];
  broadcastTime: Scalars['DateTime'];
  gradePrices: Array<BookingGradePriceInput> | BookingGradePriceInput;
  timeSlots: Array<TimeSlotRequirementInput> | TimeSlotRequirementInput;
  description?: InputMaybe<Scalars['String']>;
  allowAggregatorVehicle?: InputMaybe<Scalars['Boolean']>;
  allowOwnVehicle?: InputMaybe<Scalars['Boolean']>;
  bookingQuantityLimit?: InputMaybe<Scalars['Float']>;
  companyVisibility?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['ID']>;
  attachments?: InputMaybe<Array<InputMaybe<MediaInput>> | InputMaybe<MediaInput>>;
  shouldConsolidate?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateDemandMutation = { __typename?: 'MutationRoot', addDemand?: { __typename?: 'AddDemandMutation', demands?: Array<{ __typename?: 'DemandType', id: string, date: any, name: string, isLive: boolean, isVerified: boolean, dateTill?: any | null, broadcastTime: any, inwardedQuantity?: number | null, varietyGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, priceSummary?: { __typename?: 'DemandPriceSummary', minPrice?: number | null, avgPrice?: number | null, maxPrice?: number | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, depot: { __typename?: 'DepotType', id: string, name: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, priceLimit: number, isDefault: boolean, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string } }>, timeSlots: Array<{ __typename?: 'TimeSlotRequirementType', id: string, bookedQuantity: number, quantity: number, timeSlot: { __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, toTime: any }, quantityUnit: { __typename?: 'SKUGraphType', id: string, name: string } }> } | null> | null } | null };

export type UpdateBulkDemandsMutationVariables = Exact<{
  filter?: InputMaybe<DemandFilterInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBulkDemandsMutation = { __typename?: 'MutationRoot', updateBulkDemands?: { __typename?: 'UpdateBulkDemandMutation', demands?: Array<{ __typename?: 'DemandType', id: string, isLive: boolean, name: string, description?: string | null } | null> | null } | null };

export type DemandDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type DemandDetailsQuery = { __typename?: 'QueryRoot', demandDetails?: { __typename?: 'DemandType', id: string, name: string, description?: string | null, isLive: boolean, isVerified: boolean, date: any, dateTill?: any | null, broadcastTime: any, attachments: Array<{ __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }>, varietyGroup?: { __typename?: 'CommodityGroupType', id: string, name: string } | null, timeSlots: Array<{ __typename?: 'TimeSlotRequirementType', id: string, quantity: number, bookedQuantity: number, quantityUnit: { __typename?: 'SKUGraphType', id: string, name: string }, timeSlot: { __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, toTime: any } }>, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, priceLimit: number, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, grade: { __typename?: 'HarvestGradeType', id: string, name: string } }>, depot: { __typename?: 'DepotType', id: string, name: string } } | null };

export type AllDemandsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DemandFilterInput>;
}>;


export type AllDemandsQuery = { __typename?: 'QueryRoot', allDemands?: { __typename?: 'AllDemandItems', totalCount?: number | null, demands?: Array<{ __typename?: 'DemandType', id: string, date: any, name: string, isLive: boolean, isVerified: boolean, dateTill?: any | null, broadcastTime: any, inwardedQuantity?: number | null, varietyGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, priceSummary?: { __typename?: 'DemandPriceSummary', minPrice?: number | null, avgPrice?: number | null, maxPrice?: number | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, depot: { __typename?: 'DepotType', id: string, name: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, priceLimit: number, isDefault: boolean, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string } }>, timeSlots: Array<{ __typename?: 'TimeSlotRequirementType', id: string, bookedQuantity: number, quantity: number, timeSlot: { __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, toTime: any }, quantityUnit: { __typename?: 'SKUGraphType', id: string, name: string } }> } | null> | null } | null };

export type DepartmentDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DepartmentDetailQuery = { __typename?: 'QueryRoot', departmentDetails?: { __typename?: 'DepartmentType', id: string, name: string, preferredDepot?: { __typename?: 'DepotType', id: string, name: string } | null } | null };

export type TripOrdersFragFragment = { __typename?: 'TripType', id: string, status: TripStatus, labourCount?: number | null, date: any, estimatedStartTime?: any | null, loadingPattern: TripLoadingPattern, estimatedDespatchTime?: any | null, DEPOrganisationUser?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, codename: string } | null }, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, advanceCost: number, transportCost: number } | null, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, bookings: Array<{ __typename?: 'BookingType', id: string, requiredQuantity: number, order?: { __typename?: 'AnnotatedOrderType', id: string, orderStatus: OrderOrderStatus, totalWeight?: number | null, shippingCharges: number, metadata: any, crateCount: number, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string, district?: string | null, address?: string | null }, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, quantity: number, rate: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null> | null } | null, orderItem?: { __typename?: 'OrderItemType', id: string, quantity: number, rate: number, metadata: any, actualRate: number, bookedQuantity?: number | null, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, taxes: Array<{ __typename?: 'TaxType', id: string, name: string, percentage: number }> } } | null, schedule: { __typename?: 'ScheduleType', id: string } }> };

export type CreateUpdateDispathMutationVariables = Exact<{
  aggregatorId: Scalars['ID'];
  bookings?: InputMaybe<Array<InputMaybe<DispatchBookingItem>> | InputMaybe<DispatchBookingItem>>;
  date: Scalars['Date'];
  destinationDepotId: Scalars['ID'];
  estimatedStartTime: Scalars['DateTime'];
  id?: InputMaybe<Scalars['ID']>;
  labourCount?: InputMaybe<Scalars['Int']>;
  organisationUserId: Scalars['ID'];
  sourceDepotId: Scalars['ID'];
  transportDetail?: InputMaybe<VehicleTransportInput>;
  vehicleId: Scalars['ID'];
  loadingPattern?: InputMaybe<Scalars['String']>;
  estimatedDespatchTime?: InputMaybe<Scalars['DateTime']>;
}>;


export type CreateUpdateDispathMutation = { __typename?: 'MutationRoot', addUpdateDispatch?: { __typename?: 'AddUpdateDispatchMutation', trip?: { __typename?: 'TripType', id: string, status: TripStatus, labourCount?: number | null, date: any, estimatedStartTime?: any | null, loadingPattern: TripLoadingPattern, estimatedDespatchTime?: any | null, DEPOrganisationUser?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, codename: string } | null }, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, advanceCost: number, transportCost: number } | null, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, bookings: Array<{ __typename?: 'BookingType', id: string, requiredQuantity: number, order?: { __typename?: 'AnnotatedOrderType', id: string, orderStatus: OrderOrderStatus, totalWeight?: number | null, shippingCharges: number, metadata: any, crateCount: number, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string, district?: string | null, address?: string | null }, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, quantity: number, rate: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null> | null } | null, orderItem?: { __typename?: 'OrderItemType', id: string, quantity: number, rate: number, metadata: any, actualRate: number, bookedQuantity?: number | null, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, taxes: Array<{ __typename?: 'TaxType', id: string, name: string, percentage: number }> } } | null, schedule: { __typename?: 'ScheduleType', id: string } }> } | null } | null };

export type DispatchesForDateQueryVariables = Exact<{
  date: Scalars['Date'];
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
}>;


export type DispatchesForDateQuery = { __typename?: 'QueryRoot', tripsForDate?: Array<{ __typename?: 'TripType', id: string, status: TripStatus, totalCrateCount?: number | null, estimatedStartTime?: any | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string }, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null }, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, bookings: Array<{ __typename?: 'BookingType', id: string, requiredQuantity: number, schedule: { __typename?: 'ScheduleType', id: string }, orderItem?: { __typename?: 'OrderItemType', id: string, quantity: number, rate: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null, order?: { __typename?: 'AnnotatedOrderType', id: string, totalAmount: number, orderStatus: OrderOrderStatus, shippingAddress: { __typename?: 'AddressType', id: string, village: string } } | null }> } | null> | null };

export type AllDispatchDepotsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDispatchDepotsSelectorQuery = { __typename?: 'QueryRoot', allDepots?: Array<{ __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null> | null };

export type SuborderOrderDetailQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type SuborderOrderDetailQuery = { __typename?: 'QueryRoot', orderDetail?: { __typename?: 'OrderType', id: string, subOrders: Array<{ __typename?: 'AnnotatedOrderType', id: string, date: any, trackingCode: string, totalWeight?: number | null, orderCategory: OrderOrderCategory, crateCount: number, orderStatus: OrderOrderStatus, shippingAddress: { __typename?: 'AddressType', id: string, address?: string | null, latitude: number, longitude: number, village: string, taluka?: string | null }, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, quantity: number, rate: number, bookedQuantity?: number | null, order: { __typename?: 'AnnotatedOrderType', id: string }, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null> | null }> } | null };

export type ConfirmedOrderListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderFilterInput>;
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type ConfirmedOrderListQuery = { __typename?: 'QueryRoot', allOrders?: Array<{ __typename?: 'OrderType', id: string, date: any, trackingCode: string, totalWeight?: number | null, orderCategory: OrderOrderCategory, shippingCharges: number, metadata: any, crateCount: number, orderStatus: OrderOrderStatus, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, shippingAddress: { __typename?: 'AddressType', id: string, address?: string | null, latitude: number, longitude: number, village: string, taluka?: string | null }, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, subOrders: Array<{ __typename?: 'AnnotatedOrderType', id: string }>, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, quantity: number, rate: number, actualRate: number, bookedQuantity?: number | null, metadata: any, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, order: { __typename?: 'AnnotatedOrderType', id: string }, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, taxes: Array<{ __typename?: 'TaxType', id: string, name: string, percentage: number }> } } | null> | null } | null> | null };

export type TripOrdersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type TripOrdersQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, status: TripStatus, labourCount?: number | null, date: any, estimatedStartTime?: any | null, loadingPattern: TripLoadingPattern, estimatedDespatchTime?: any | null, DEPOrganisationUser?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, codename: string } | null }, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, advanceCost: number, transportCost: number } | null, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, bookings: Array<{ __typename?: 'BookingType', id: string, requiredQuantity: number, order?: { __typename?: 'AnnotatedOrderType', id: string, orderStatus: OrderOrderStatus, totalWeight?: number | null, shippingCharges: number, metadata: any, crateCount: number, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string, district?: string | null, address?: string | null }, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, quantity: number, rate: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null> | null } | null, orderItem?: { __typename?: 'OrderItemType', id: string, quantity: number, rate: number, metadata: any, actualRate: number, bookedQuantity?: number | null, discount?: { __typename?: 'DiscountType', id: string, flat: number, percentage: number } | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, taxes: Array<{ __typename?: 'TaxType', id: string, name: string, percentage: number }> } } | null, schedule: { __typename?: 'ScheduleType', id: string } }> } | null };

export type AllDispatchVehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDispatchVehiclesQuery = { __typename?: 'QueryRoot', allVehicles?: Array<{ __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } } | null> | null };

export type OrderItemBookingsQueryVariables = Exact<{
  orderItemId: Scalars['ID'];
}>;


export type OrderItemBookingsQuery = { __typename?: 'QueryRoot', bookingsByOrderItem?: Array<{ __typename?: 'BookingType', id: string, requiredQuantity: number, orderItem?: { __typename?: 'OrderItemType', id: string, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null, trip?: { __typename?: 'TripType', id: string, status: TripStatus, date: any, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string }, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } | null } | null> | null };

export type TimeSlotFragFragment = { __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string };

export type DistributionCenterListFragFragment = { __typename?: 'DistributionCentreType', id: string, name: string, archive: boolean, deliveryConditions: any, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, address: { __typename?: 'AddressType', id: string, village: string, state?: string | null }, pointOfContacts?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string } | null> | null, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, deliverySlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, maintenanceSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, alternateSalesSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }> };

export type DistributionCenterDetailFragFragment = { __typename?: 'DistributionCentreProperties', currentStockPercentage?: number | null, name: string, archive: boolean, codename: string, customerCode?: string | null, plantCode?: string | null, storeCode?: string | null, colorCode: string, salesOfcCode?: string | null, partnerCode?: string | null, companyCode?: string | null, bankDetails?: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountHolderName: string, accountNumber: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string, codename: string } } | null> | null, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, assignedCpc?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, certifications?: Array<{ __typename?: 'GeneralCertificationType', id: string, idNumber: string, validFrom?: any | null, validTill?: any | null, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string, codename: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, name: string, codename: string } | null }>, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, primaryPoc?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, address: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, latitude: number, longitude: number, geofenceRadius: number, state?: string | null, district?: string | null, pincode?: string | null, address?: string | null }, pointOfContacts: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }>, deliveryConditions?: { __typename?: 'DeliveryConditionType', estimatedDelta?: string | null, minCartValue?: number | null, isManufacturingPlant?: boolean | null, deliveryCosts?: Array<{ __typename?: 'DeliveryCostType', costRange?: Array<number | null> | null, deliveryCost?: number | null } | null> | null, extraSapCodes?: { __typename?: 'ExtraSAPCodesType', businessPlace?: string | null, profitCenter?: string | null, costCenter?: string | null } | null, gstDetails?: { __typename?: 'GSTDetailsType', gstin?: string | null, registeredName?: string | null, address1?: string | null, address2?: string | null, stateName?: string | null, stateCode?: string | null, district?: string | null, pincode?: string | null } | null } | null, deliverySlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, maintenanceSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, surveyareaSet: Array<{ __typename?: 'SurveyAreaLocationType', id: string, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null }, properties?: { __typename?: 'SurveyAreaProperties', isActive: boolean, name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }> } | null }>, alternateSalesSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }> };

export type StorageLocationFragFragment = { __typename?: 'DCStorageLocationType', id: string, name: string, codename: string, archive: boolean, colorCode: string, responsiblePerson?: { __typename?: 'DeliveryAgentManagementType', id: string, firstName: string, lastName: string, fullName?: string | null, number: string } | null, subLocations: Array<{ __typename?: 'DCSubLocationType', id: string, name: string, codename: string }> };

export type AddDcMutationVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  colorCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>> | InputMaybe<MediaInput>>;
  pointOfContacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  areaCatered?: InputMaybe<Scalars['Geometry']>;
  customerCode: Scalars['String'];
  plantCode: Scalars['String'];
  storeCode: Scalars['String'];
  primaryPocId?: InputMaybe<Scalars['NullableID']>;
  companyCode?: InputMaybe<Scalars['String']>;
  salesOfcCode?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  deliveryConditions?: InputMaybe<DeliveryConditionInput>;
  assignedCpc?: InputMaybe<Scalars['NullableID']>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  allowedDepartments?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type AddDcMutation = { __typename?: 'MutationRoot', addDistributionCentre?: { __typename?: 'AddDistributionCentreMutation', distributionCentre?: { __typename?: 'DistributionCentreLocationType', id: string, geometry?: { __typename?: 'GeometryObjectType', coordinates?: any | null, type?: string | null } | null, properties?: { __typename?: 'DistributionCentreProperties', currentStockPercentage?: number | null, name: string, archive: boolean, codename: string, customerCode?: string | null, plantCode?: string | null, storeCode?: string | null, colorCode: string, salesOfcCode?: string | null, partnerCode?: string | null, companyCode?: string | null, bankDetails?: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountHolderName: string, accountNumber: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string, codename: string } } | null> | null, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, assignedCpc?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, certifications?: Array<{ __typename?: 'GeneralCertificationType', id: string, idNumber: string, validFrom?: any | null, validTill?: any | null, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string, codename: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, name: string, codename: string } | null }>, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, primaryPoc?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, address: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, latitude: number, longitude: number, geofenceRadius: number, state?: string | null, district?: string | null, pincode?: string | null, address?: string | null }, pointOfContacts: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }>, deliveryConditions?: { __typename?: 'DeliveryConditionType', estimatedDelta?: string | null, minCartValue?: number | null, isManufacturingPlant?: boolean | null, deliveryCosts?: Array<{ __typename?: 'DeliveryCostType', costRange?: Array<number | null> | null, deliveryCost?: number | null } | null> | null, extraSapCodes?: { __typename?: 'ExtraSAPCodesType', businessPlace?: string | null, profitCenter?: string | null, costCenter?: string | null } | null, gstDetails?: { __typename?: 'GSTDetailsType', gstin?: string | null, registeredName?: string | null, address1?: string | null, address2?: string | null, stateName?: string | null, stateCode?: string | null, district?: string | null, pincode?: string | null } | null } | null, deliverySlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, maintenanceSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, surveyareaSet: Array<{ __typename?: 'SurveyAreaLocationType', id: string, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null }, properties?: { __typename?: 'SurveyAreaProperties', isActive: boolean, name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }> } | null }>, alternateSalesSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }> } | null } | null } | null };

export type UpdateDcMutationVariables = Exact<{
  id: Scalars['ID'];
  address?: InputMaybe<AddressInput>;
  deliveryConditions?: InputMaybe<DeliveryConditionInput>;
  deliverySlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>> | InputMaybe<TimeSlotInput>>;
  colorCode?: InputMaybe<Scalars['String']>;
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  name?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>> | InputMaybe<MediaInput>>;
  pickupSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>> | InputMaybe<TimeSlotInput>>;
  pointOfContacts?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  maintenanceSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>> | InputMaybe<TimeSlotInput>>;
  certifications?: InputMaybe<Array<InputMaybe<GeneralCertificationInput>> | InputMaybe<GeneralCertificationInput>>;
  areaCatered?: InputMaybe<Scalars['Geometry']>;
  customerCode?: InputMaybe<Scalars['String']>;
  plantCode?: InputMaybe<Scalars['String']>;
  storeCode?: InputMaybe<Scalars['String']>;
  primaryPocId?: InputMaybe<Scalars['NullableID']>;
  companyCode?: InputMaybe<Scalars['String']>;
  salesOfcCode?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  assignedCpc?: InputMaybe<Scalars['NullableID']>;
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  bankDetails?: InputMaybe<Array<InputMaybe<BankDetailInput>> | InputMaybe<BankDetailInput>>;
  surveyAreas?: InputMaybe<Array<InputMaybe<SurveyAreaInput>> | InputMaybe<SurveyAreaInput>>;
  archive?: InputMaybe<Scalars['Boolean']>;
  allowedDepartments?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  alternateSalesSlots?: InputMaybe<Array<InputMaybe<TimeSlotInput>> | InputMaybe<TimeSlotInput>>;
}>;


export type UpdateDcMutation = { __typename?: 'MutationRoot', updateDistributionCentre?: { __typename?: 'UpdateDistributionCentreMutation', distributionCentre?: { __typename?: 'DistributionCentreLocationType', id: string, geometry?: { __typename?: 'GeometryObjectType', coordinates?: any | null, type?: string | null } | null, properties?: { __typename?: 'DistributionCentreProperties', currentStockPercentage?: number | null, name: string, archive: boolean, codename: string, customerCode?: string | null, plantCode?: string | null, storeCode?: string | null, colorCode: string, salesOfcCode?: string | null, partnerCode?: string | null, companyCode?: string | null, bankDetails?: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountHolderName: string, accountNumber: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string, codename: string } } | null> | null, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, assignedCpc?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, certifications?: Array<{ __typename?: 'GeneralCertificationType', id: string, idNumber: string, validFrom?: any | null, validTill?: any | null, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string, codename: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, name: string, codename: string } | null }>, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, primaryPoc?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, address: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, latitude: number, longitude: number, geofenceRadius: number, state?: string | null, district?: string | null, pincode?: string | null, address?: string | null }, pointOfContacts: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }>, deliveryConditions?: { __typename?: 'DeliveryConditionType', estimatedDelta?: string | null, minCartValue?: number | null, isManufacturingPlant?: boolean | null, deliveryCosts?: Array<{ __typename?: 'DeliveryCostType', costRange?: Array<number | null> | null, deliveryCost?: number | null } | null> | null, extraSapCodes?: { __typename?: 'ExtraSAPCodesType', businessPlace?: string | null, profitCenter?: string | null, costCenter?: string | null } | null, gstDetails?: { __typename?: 'GSTDetailsType', gstin?: string | null, registeredName?: string | null, address1?: string | null, address2?: string | null, stateName?: string | null, stateCode?: string | null, district?: string | null, pincode?: string | null } | null } | null, deliverySlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, maintenanceSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, surveyareaSet: Array<{ __typename?: 'SurveyAreaLocationType', id: string, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null }, properties?: { __typename?: 'SurveyAreaProperties', isActive: boolean, name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }> } | null }>, alternateSalesSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }> } | null } | null } | null };

export type AddUpdateStorageLocationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  distributionCentreId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  colorCode?: InputMaybe<Scalars['String']>;
  responsiblePersonId: Scalars['ID'];
  subLocations?: InputMaybe<Array<InputMaybe<DcSubLocationInput>> | InputMaybe<DcSubLocationInput>>;
  archive?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddUpdateStorageLocationMutation = { __typename?: 'MutationRoot', addUpdateDcStorageLocation?: { __typename?: 'AddUpdateDCStorageLocationMutation', storageLocation?: { __typename?: 'DCStorageLocationType', id: string, name: string, codename: string, archive: boolean, colorCode: string, responsiblePerson?: { __typename?: 'DeliveryAgentManagementType', id: string, firstName: string, lastName: string, fullName?: string | null, number: string } | null, subLocations: Array<{ __typename?: 'DCSubLocationType', id: string, name: string, codename: string }> } | null } | null };

export type AddUpdateDcStockTakeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  distributionCentreId: Scalars['ID'];
  itemCategory?: InputMaybe<Scalars['String']>;
  startDay?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Time']>;
  endDay?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
}>;


export type AddUpdateDcStockTakeMutation = { __typename?: 'MutationRoot', addUpdateDcStockTakeConfig?: { __typename?: 'AddUpdateDCStockTakeConfigMuation', stockConfig?: { __typename?: 'DCStockTakeConfigType', id: string, startDay: number, startTime: any, endDay: number, endTime: any, itemCategory: DcStockTakeConfigItemCategory, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null } | null };

export type DeleteDcPaymentMethodMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteDcPaymentMethodMutation = { __typename?: 'MutationRoot', deleteBankDetail?: { __typename?: 'DeleteBankDetail', response?: string | null } | null };

export type DeleteDcCertificationMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteDcCertificationMutation = { __typename?: 'MutationRoot', deleteCertification?: { __typename?: 'DeleteCertification', response?: string | null } | null };

export type DistributionCentersListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DistributionCentreLocationInput>;
}>;


export type DistributionCentersListQuery = { __typename?: 'QueryRoot', allDistributionCentres?: Array<{ __typename?: 'DistributionCentreType', id: string, name: string, archive: boolean, deliveryConditions: any, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, address: { __typename?: 'AddressType', id: string, village: string, state?: string | null }, pointOfContacts?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string } | null> | null, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, deliverySlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, maintenanceSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, alternateSalesSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }> } | null> | null };

export type DistributionCentersDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DistributionCentersDetailQuery = { __typename?: 'QueryRoot', distributionCentreLocationDetail?: { __typename?: 'DistributionCentreLocationType', id: string, geometry?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null, properties?: { __typename?: 'DistributionCentreProperties', currentStockPercentage?: number | null, name: string, archive: boolean, codename: string, customerCode?: string | null, plantCode?: string | null, storeCode?: string | null, colorCode: string, salesOfcCode?: string | null, partnerCode?: string | null, companyCode?: string | null, bankDetails?: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountHolderName: string, accountNumber: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string, codename: string } } | null> | null, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, assignedCpc?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, certifications?: Array<{ __typename?: 'GeneralCertificationType', id: string, idNumber: string, validFrom?: any | null, validTill?: any | null, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string, codename: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, name: string, codename: string } | null }>, photos: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, primaryPoc?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, address: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, latitude: number, longitude: number, geofenceRadius: number, state?: string | null, district?: string | null, pincode?: string | null, address?: string | null }, pointOfContacts: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }>, deliveryConditions?: { __typename?: 'DeliveryConditionType', estimatedDelta?: string | null, minCartValue?: number | null, isManufacturingPlant?: boolean | null, deliveryCosts?: Array<{ __typename?: 'DeliveryCostType', costRange?: Array<number | null> | null, deliveryCost?: number | null } | null> | null, extraSapCodes?: { __typename?: 'ExtraSAPCodesType', businessPlace?: string | null, profitCenter?: string | null, costCenter?: string | null } | null, gstDetails?: { __typename?: 'GSTDetailsType', gstin?: string | null, registeredName?: string | null, address1?: string | null, address2?: string | null, stateName?: string | null, stateCode?: string | null, district?: string | null, pincode?: string | null } | null } | null, deliverySlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, maintenanceSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, pickupSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }>, surveyareaSet: Array<{ __typename?: 'SurveyAreaLocationType', id: string, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null }, properties?: { __typename?: 'SurveyAreaProperties', isActive: boolean, name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }> } | null }>, alternateSalesSlots: Array<{ __typename?: 'TimeSlotType', id: string, name: string, fromTime: any, maximumOrders: number, toTime: any, thresholdFrom?: any | null, estimatedDelivery: string }> } | null } | null };

export type AllPeopleSelectorQueryVariables = Exact<{
  group?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
}>;


export type AllPeopleSelectorQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string } | null> | null };

export type AllDcLocationsQueryVariables = Exact<{
  pocId?: InputMaybe<Scalars['ID']>;
}>;


export type AllDcLocationsQuery = { __typename?: 'QueryRoot', allDistributionCentreLocations?: Array<{ __typename?: 'DistributionCentreLocationType', id: string, properties?: { __typename?: 'DistributionCentreProperties', name: string, colorCode: string, address: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, geometry?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null } | null> | null };

export type DcStorageLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DcSubLocationInput>;
}>;


export type DcStorageLocationsQuery = { __typename?: 'QueryRoot', allDcStorageLocations?: Array<{ __typename?: 'DCStorageLocationType', id: string, name: string, codename: string, archive: boolean, colorCode: string, responsiblePerson?: { __typename?: 'DeliveryAgentManagementType', id: string, firstName: string, lastName: string, fullName?: string | null, number: string } | null, subLocations: Array<{ __typename?: 'DCSubLocationType', id: string, name: string, codename: string }> } | null> | null };

export type DcStockTakeConfigsQueryVariables = Exact<{
  filter?: InputMaybe<DcStockTakeConfigFilterInput>;
}>;


export type DcStockTakeConfigsQuery = { __typename?: 'QueryRoot', allDcStockTakeConfigs?: Array<{ __typename?: 'DCStockTakeConfigType', id: string, startDay: number, endDay: number, startTime: any, endTime: any, itemCategory: DcStockTakeConfigItemCategory, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null> | null };

export type DmsBulkAssignMutationVariables = Exact<{
  tripIds: Array<Scalars['Int']> | Scalars['Int'];
  dockId?: InputMaybe<Scalars['Int']>;
  dockSupervisorId?: InputMaybe<Scalars['Int']>;
}>;


export type DmsBulkAssignMutation = { __typename?: 'MutationRoot', bulkAssignment?: { __typename?: 'BulkAssignmentMutation', trips?: Array<{ __typename?: 'TripType', id: string, dock?: { __typename?: 'DockType', id: string, name: string } | null, dockSupervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null } | null> | null } | null };

export type ArrivedDockMutationMutationVariables = Exact<{
  tripId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
}>;


export type ArrivedDockMutationMutation = { __typename?: 'MutationRoot', logTripStep?: { __typename?: 'LogTripStepMutation', trip?: { __typename?: 'TripType', id: string, tripLogs?: Array<{ __typename?: 'TripStepLogType', id: string, timestamp: any, step: { __typename?: 'TripStepType', id: string, stepId: string } } | null> | null } | null } | null };

export type SaveItemDetailsMutationVariables = Exact<{
  tripId: Scalars['Int'];
  tripIdID?: InputMaybe<Scalars['ID']>;
  bookings?: InputMaybe<Array<InputMaybe<BookInput>> | InputMaybe<BookInput>>;
}>;


export type SaveItemDetailsMutation = { __typename?: 'MutationRoot', vehicalLoadingList?: { __typename?: 'VehicleLoadingMutation', trip?: { __typename?: 'TripType', id: string, uuid: string, estimatedDespatchTime?: any | null, loadingPattern: TripLoadingPattern, despatchOtp: number, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, scheduledVehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } }, dock?: { __typename?: 'DockType', id: string, name: string } | null, dockSupervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, firstName: string, lastName: string, number: string } | null, tripLogs?: Array<{ __typename?: 'TripStepLogType', id: string, step: { __typename?: 'TripStepType', id: string, stepId: string } } | null> | null, orders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, orderStatus: OrderOrderStatus, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, address?: string | null }, bookingsByTrip?: Array<{ __typename?: 'BookingType', id: string, loadingSequence: number, despatchedQuantity?: number | null, driverDespatchRemark?: string | null, driverVerification?: boolean | null, orderItem?: { __typename?: 'OrderItemType', quantity: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, codename: string } } | null, despatchPhoto?: { __typename?: 'MediaEntityType', id: string, url: string } | null } | null> | null } | null> | null } | null } | null };

export type ResolveRemarkMutationVariables = Exact<{
  tripId: Scalars['Int'];
  tripIdID: Scalars['ID'];
  bookings?: InputMaybe<Array<InputMaybe<DriverVerificationInput>> | InputMaybe<DriverVerificationInput>>;
}>;


export type ResolveRemarkMutation = { __typename?: 'MutationRoot', driverLoadingVerification?: { __typename?: 'DriverLoadingVerificationMutation', trip?: { __typename?: 'TripType', id: string, orders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, orderStatus: OrderOrderStatus, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, address?: string | null }, bookingsByTrip?: Array<{ __typename?: 'BookingType', id: string, loadingSequence: number, despatchedQuantity?: number | null, driverDespatchRemark?: string | null, driverVerification?: boolean | null, orderItem?: { __typename?: 'OrderItemType', quantity: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, codename: string } } | null, despatchPhoto?: { __typename?: 'MediaEntityType', id: string, url: string } | null } | null> | null } | null> | null } | null } | null };

export type DispatchListQueryVariables = Exact<{
  date: Scalars['Date'];
  query?: InputMaybe<Scalars['String']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type DispatchListQuery = { __typename?: 'QueryRoot', tripsForDate?: Array<{ __typename?: 'TripType', id: string, uuid: string, status: TripStatus, loadingPattern: TripLoadingPattern, despatchStatus: TripDespatchStatus, estimatedStartTime?: any | null, estimatedEndTime?: any | null, startTime?: any | null, endTime?: any | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } }, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, dock?: { __typename?: 'DockType', id: string, name: string } | null, dockSupervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null } | null> | null };

export type AllDocksQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDocksQuery = { __typename?: 'QueryRoot', allDocks?: Array<{ __typename?: 'DockType', id: string, name: string } | null> | null };

export type AllSkusQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSkusQuery = { __typename?: 'QueryRoot', allSkuTypes?: Array<{ __typename?: 'SKUGraphType', id: string, name: string } | null> | null };

export type DmsTripDetailsQueryVariables = Exact<{
  tripIdInt: Scalars['Int'];
  tripId: Scalars['ID'];
}>;


export type DmsTripDetailsQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, uuid: string, estimatedDespatchTime?: any | null, loadingPattern: TripLoadingPattern, despatchStatus: TripDespatchStatus, despatchOtp: number, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, scheduledVehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } }, dock?: { __typename?: 'DockType', id: string, name: string } | null, dockSupervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, firstName: string, lastName: string, number: string } | null, tripLogs?: Array<{ __typename?: 'TripStepLogType', id: string, step: { __typename?: 'TripStepType', id: string, stepId: string } } | null> | null, orders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, orderStatus: OrderOrderStatus, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, address?: string | null }, bookingsByTrip?: Array<{ __typename?: 'BookingType', id: string, loadingSequence: number, despatchedQuantity?: number | null, driverDespatchRemark?: string | null, driverVerification?: boolean | null, orderItem?: { __typename?: 'OrderItemType', quantity: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, codename: string } } | null, despatchPhoto?: { __typename?: 'MediaEntityType', id: string, url: string } | null } | null> | null } | null> | null } | null };

export type ExtraSkusQueryVariables = Exact<{
  tripId: Scalars['Int'];
}>;


export type ExtraSkusQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string } | null };

export type AllItemsInTripQueryVariables = Exact<{
  tripId: Scalars['ID'];
}>;


export type AllItemsInTripQuery = { __typename?: 'QueryRoot', siByBooking?: Array<{ __typename?: 'SIByBooking', itemCount?: number | null, requiredQuantity?: number | null, despatchedQuantity?: number | null, sellableItem?: { __typename?: 'SellableItemType', id: string, name: string } | null, orders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, orderItems?: Array<{ __typename?: 'OrderItemType', quantity: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null> | null } | null> | null } | null> | null };

export type ItemDetailsQueryVariables = Exact<{
  tripId: Scalars['ID'];
  sellableItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type ItemDetailsQuery = { __typename?: 'QueryRoot', siByBooking?: Array<{ __typename?: 'SIByBooking', itemCount?: number | null, requiredQuantity?: number | null, despatchedQuantity?: number | null, sellableItem?: { __typename?: 'SellableItemType', id: string, name: string } | null, orders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, orderStatus: OrderOrderStatus, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, address?: string | null }, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, quantity: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string }, itemBookings: Array<{ __typename?: 'BookingType', id: string, loadingSequence: number, despatchedQuantity?: number | null, driverDespatchRemark?: string | null, driverVerification?: boolean | null, despatchPhoto?: { __typename?: 'MediaEntityType', id: string, url: string } | null }> } | null> | null } | null> | null } | null> | null };

export type DockFragFragment = { __typename?: 'DockType', id: string, name: string, archive: boolean, codename: string, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, depot?: { __typename?: 'DepotType', id: string, name: string } | null };

export type DockAddUpdateMutationVariables = Exact<{
  address?: InputMaybe<AddressInput>;
  archive?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  depotId?: InputMaybe<Scalars['ID']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type DockAddUpdateMutation = { __typename?: 'MutationRoot', addUpdateDock?: { __typename?: 'AddUpdateDockMutation', dock?: { __typename?: 'DockType', id: string, name: string, archive: boolean, codename: string, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, depot?: { __typename?: 'DepotType', id: string, name: string } | null } | null } | null };

export type DcDocksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AllDockFilterInput>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type DcDocksQuery = { __typename?: 'QueryRoot', allDocks?: Array<{ __typename?: 'DockType', id: string, name: string, archive: boolean, codename: string, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, depot?: { __typename?: 'DepotType', id: string, name: string } | null } | null> | null };

export type DockDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DockDetailsQuery = { __typename?: 'QueryRoot', dockDetail?: { __typename?: 'DockType', id: string, name: string, archive: boolean, codename: string, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, depot?: { __typename?: 'DepotType', id: string, name: string } | null } | null };

export type AllTaskLogsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TaskLogFilterInput>;
}>;


export type AllTaskLogsQuery = { __typename?: 'QueryRoot', allTaskLogs?: Array<{ __typename?: 'TaskLogType', id: string, createdAt: any, taskName?: string | null, responseCode?: number | null, responseData?: any | null, requestData?: any | null, isOk: boolean, periodicTask?: { __typename?: 'PeriodicTaskType', name: string } | null } | null> | null };

export type FarmerDetailsFragFragment = { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, number: string, isBlocked?: boolean | null, blockRemark?: string | null, referenceId: string, companyCode?: string | null, email: string, username: string, dateOfBirth?: any | null, gender?: BaseUserGender | null, education?: BaseUserEducation | null, secondaryNumbers: Array<{ __typename?: 'ContactType', id: string, number: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, pincode?: string | null, taluka?: string | null, state?: string | null, district?: string | null, latitude: number, longitude: number } | null, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, branchName: string, accountNumber: string, accountHolderName: string, bank: { __typename?: 'BankType', id: string, name: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> }>, companies: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, codename: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> };

export type FarmerListFragFragment = { __typename?: 'BaseUserType', id: string, fullName?: string | null, createdAt: any, username: string, isBlocked?: boolean | null, blockRemark?: string | null, companyCode?: string | null, number: string, status: BaseUserStatus, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, plots: Array<{ __typename?: 'PlotType', id: string, codename: string, crops: Array<{ __typename?: 'PlotCommodityType', id: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string } }> }> };

export type AllFarmersListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AllFarmersListQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, createdAt: any, username: string, isBlocked?: boolean | null, blockRemark?: string | null, companyCode?: string | null, number: string, status: BaseUserStatus, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, plots: Array<{ __typename?: 'PlotType', id: string, codename: string, crops: Array<{ __typename?: 'PlotCommodityType', id: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string } }> }> } | null> | null };

export type FarmerDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FarmerDetailsQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, number: string, isBlocked?: boolean | null, blockRemark?: string | null, referenceId: string, companyCode?: string | null, email: string, username: string, dateOfBirth?: any | null, gender?: BaseUserGender | null, education?: BaseUserEducation | null, secondaryNumbers: Array<{ __typename?: 'ContactType', id: string, number: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, pincode?: string | null, taluka?: string | null, state?: string | null, district?: string | null, latitude: number, longitude: number } | null, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, branchName: string, accountNumber: string, accountHolderName: string, bank: { __typename?: 'BankType', id: string, name: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> }>, companies: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, codename: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> } | null };

export type AddFarmerMutationVariables = Exact<{
  farmer?: InputMaybe<FarmerInput>;
}>;


export type AddFarmerMutation = { __typename?: 'MutationRoot', addUpdateOnlyFarmer?: { __typename?: 'AddUpdateBasicFarmerMutation', user?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, number: string, isBlocked?: boolean | null, blockRemark?: string | null, referenceId: string, companyCode?: string | null, email: string, username: string, dateOfBirth?: any | null, gender?: BaseUserGender | null, education?: BaseUserEducation | null, secondaryNumbers: Array<{ __typename?: 'ContactType', id: string, number: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, pincode?: string | null, taluka?: string | null, state?: string | null, district?: string | null, latitude: number, longitude: number } | null, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, branchName: string, accountNumber: string, accountHolderName: string, bank: { __typename?: 'BankType', id: string, name: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }> }>, companies: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, codename: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> } | null } | null };

export type ChangeTransactionStatusMutationVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ChangeTransactionStatusMutation = { __typename?: 'MutationRoot', reconcileBulkTransaction?: { __typename?: 'ReconcileBulkTransactionMutation', transactions?: Array<{ __typename?: 'TransactionGraphType', id: string, status: TransactionStatus } | null> | null } | null };

export type ApproveOrderTransactionMutationVariables = Exact<{
  orderTransactionId: Scalars['ID'];
  approvalStatus: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
}>;


export type ApproveOrderTransactionMutation = { __typename?: 'MutationRoot', orderTransactionApproval?: { __typename?: 'OrderTransactionApprovalMutation', orderTransaction?: { __typename?: 'OrderTransactionType', id: string, metadata: any } | null, order?: { __typename?: 'OrderType', id: string, metadata: any } | null } | null };

export type AllTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionDetailInput>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AllTransactionsQuery = { __typename?: 'QueryRoot', allTransactions?: Array<{ __typename?: 'TransactionGraphType', id: string, status: TransactionStatus, transactionId: string, date: any, referenceId: string, remark?: string | null, amount: number, transactionType: { __typename?: 'TransactionTypeType', id: string, codename: string }, account: { __typename?: 'AccountType', id: string, distributioncentreSet: Array<{ __typename?: 'DistributionCentreType', id: string, name: string }> }, paymentMethod: { __typename?: 'PaymentMethodType', id: string, codename: string, name: string }, recordedBy: { __typename?: 'DeliveryAgentManagementType', id: string, username: string }, currency: { __typename?: 'CurrencyType', id: string, name: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string }> } | null> | null };

export type ReconciliationSummaryFundFlowQueryVariables = Exact<{
  filter: ReconciliationSummaryFundFlowInput;
}>;


export type ReconciliationSummaryFundFlowQuery = { __typename?: 'QueryRoot', reconciliationSummaryFundFlow?: Array<{ __typename?: 'ReconciliationSummaryFundFlowType', distributionCentreId?: string | null, distributionCentre_Name?: string | null, openingBalance?: number | null, netSale?: number | null, collection?: number | null, deposit?: number | null, closingBalance?: number | null, reconciliationStatus?: string | null } | null> | null };

export type AllDcCollectionLogsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DcCollectionLogFilterInput>;
}>;


export type AllDcCollectionLogsQuery = { __typename?: 'QueryRoot', allDcCollectionLogs?: Array<{ __typename?: 'DCCollectionLogType', cashOpening: number, cashCollection: number, cashDeposit: number, cashClosing: number, chequeOpening: number, chequeCollection: number, chequeDeposit: number, chequeClosing: number, creditSaleOpening: number, creditSaleClosing: number, othersCollection: number } | null> | null };

export type PaymentVerificationOrdersQueryVariables = Exact<{
  verificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type PaymentVerificationOrdersQuery = { __typename?: 'QueryRoot', paymentVerificationOrders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, metadata: any, orderStatus: OrderOrderStatus, orderCategory: OrderOrderCategory, createdAt: any, paymentStatus: OrderPaymentStatus, paymentMethod: OrderPaymentMethod, totalAmount: number, outstandingAmount: number, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }> }, shippingAddress: { __typename?: 'AddressType', id: string, village: string }, transactions?: Array<{ __typename?: 'OrderTransactionType', id: string, amount: number, status: OrderTransactionStatus, referenceId: string, createdAt: any, metadata: any, attachment?: { __typename?: 'MediaEntityType', id: string, url: string } | null } | null> | null } | null> | null };

export type AddGateLogsMutationVariables = Exact<{
  gateLogs: Array<InputMaybe<BulkAddGateLogsInput>> | InputMaybe<BulkAddGateLogsInput>;
}>;


export type AddGateLogsMutation = { __typename?: 'MutationRoot', bulkAddGateLogs?: { __typename?: 'BulkAddGateLogsMutation', success?: boolean | null, message?: string | null, createdLogs?: Array<{ __typename?: 'GateLogType', id: string, gateStatus: GateLogsGateStatus, schedule: { __typename?: 'ScheduleType', id: string } } | null> | null } | null };

export type RemoveM2MLinksMutationVariables = Exact<{
  field: Scalars['String'];
  fieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  model: Scalars['String'];
  modelId: Scalars['ID'];
}>;


export type RemoveM2MLinksMutation = { __typename?: 'MutationRoot', removeM2mFieldLink?: { __typename?: 'RemoveM2MFieldLink', response?: Array<string | null> | null } | null };

export type GroupDetailFragFragment = { __typename?: 'GroupType', id: string, name: string, userCount?: number | null, permissions: Array<{ __typename?: 'PermissionType', id: string, name: string, codename: string }> };

export type AddGroupMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AddGroupMutationMutation = { __typename?: 'MutationRoot', addGroup?: { __typename?: 'AddGroupMutation', group?: { __typename?: 'GroupType', id: string, name: string, userCount?: number | null, permissions: Array<{ __typename?: 'PermissionType', id: string, name: string, codename: string }> } | null } | null };

export type AllGroupsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGroupsListQuery = { __typename?: 'QueryRoot', allGroups?: Array<{ __typename?: 'GroupType', id: string, name: string, userCount?: number | null, permissions: Array<{ __typename?: 'PermissionType', id: string, name: string, codename: string }> } | null> | null };

export type GetGroupDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  groupName?: InputMaybe<Scalars['String']>;
}>;


export type GetGroupDetailsQuery = { __typename?: 'QueryRoot', groupDetails?: { __typename?: 'GroupType', id: string, name: string, userCount?: number | null, permissions: Array<{ __typename?: 'PermissionType', id: string, name: string, codename: string }> } | null };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteGroupMutation = { __typename?: 'MutationRoot', delGroup?: { __typename?: 'DelGroupMutation', groupId?: number | null } | null };

export type BatchFragFragment = { __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null };

export type WeighScheduleFragFragment = { __typename?: 'ScheduleType', id: string, date: any, requiredQuantity: number, pricingDoneOn: SchedulePricingDoneOn, farmWeight: number, gatePass: string, gatelogsSet: Array<{ __typename?: 'GateLogType', id: string, createdAt: any, gateEntryNo?: string | null, gateStatus: GateLogsGateStatus, gateNumber?: { __typename?: 'GateNumberType', id: string, name: string, codename: string } | null }>, scheduledIn?: { __typename?: 'DepartmentType', id: string, packagingMaterialFlow: boolean } | null, unloadingLocation?: { __typename?: 'DepotType', id: string, name: string } | null, unloadingSubLocation?: { __typename?: 'UnloadingSubLocationType', id: string, name: string } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, createdAt: any, netWeightAfterDeduction?: number | null, totalReceivedQuantity?: number | null, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, receivedQuantity?: number | null } | null> | null } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, plotCommodity: { __typename?: 'PlotCommodityType', name: string, id: string, referenceId: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string } }>, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, standardDeduction: number } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, commodity: { __typename?: 'CommodityType', id: string, name: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, plot: { __typename?: 'PlotType', id: string, codename: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, username: string, isBlocked?: boolean | null }, address: { __typename?: 'AddressType', id: string, village: string } } };

export type BatchWeighFragFragment = { __typename?: 'WeighType', id: string, date: any, status: WeighStatus, farmWeight: number, grossWeight: number, tareWeight: number, netWeight: number, finalWeight: number, invoicingDoneOn: WeighInvoicingDoneOn, standardDeduction: number, inwardedQuantity: number, grade?: { __typename?: 'HarvestGradeType', id: string } | null, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> };

export type BulkWeighFragFragment = { __typename?: 'WeighType', id: string, status: WeighStatus, updatedAt: any, farmWeight: number, grossWeight: number, tareWeight: number, inwardedQuantity: number, standardDeduction: number, netWeight: number, weightLoss: number, finalWeight: number, grade?: { __typename?: 'HarvestGradeType', id: string, name: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null };

export type InwardFragFragment = { __typename?: 'InwardType', id: string, grn: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null, weigh: { __typename?: 'WeighType', id: string, date: any, status: WeighStatus, farmWeight: number, grossWeight: number, tareWeight: number, netWeight: number, finalWeight: number, invoicingDoneOn: WeighInvoicingDoneOn, standardDeduction: number, inwardedQuantity: number, grade?: { __typename?: 'HarvestGradeType', id: string } | null, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> } };

export type InwardQualityFragFragment = { __typename?: 'InwardType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null };

export type BatchInwardFragFragment = { __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null };

export type TripDetailFragFragment = { __typename?: 'TripType', id: string, status: TripStatus, expense: number, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string, contact: string } | null, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus, updatedAt: any, farmWeight: number, grossWeight: number, tareWeight: number, inwardedQuantity: number, standardDeduction: number, netWeight: number, weightLoss: number, finalWeight: number, grade?: { __typename?: 'HarvestGradeType', id: string, name: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null } | null, bookings: Array<{ __typename?: 'BookingType', id: string, qualitySample?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }>, schedule: { __typename?: 'ScheduleType', id: string, date: any, requiredQuantity: number, pricingDoneOn: SchedulePricingDoneOn, farmWeight: number, gatePass: string, gatelogsSet: Array<{ __typename?: 'GateLogType', id: string, createdAt: any, gateEntryNo?: string | null, gateStatus: GateLogsGateStatus, gateNumber?: { __typename?: 'GateNumberType', id: string, name: string, codename: string } | null }>, scheduledIn?: { __typename?: 'DepartmentType', id: string, packagingMaterialFlow: boolean } | null, unloadingLocation?: { __typename?: 'DepotType', id: string, name: string } | null, unloadingSubLocation?: { __typename?: 'UnloadingSubLocationType', id: string, name: string } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, createdAt: any, netWeightAfterDeduction?: number | null, totalReceivedQuantity?: number | null, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, receivedQuantity?: number | null } | null> | null } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, plotCommodity: { __typename?: 'PlotCommodityType', name: string, id: string, referenceId: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string } }>, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, standardDeduction: number } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, commodity: { __typename?: 'CommodityType', id: string, name: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, plot: { __typename?: 'PlotType', id: string, codename: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, username: string, isBlocked?: boolean | null }, address: { __typename?: 'AddressType', id: string, village: string } } } }> };

export type AddUpdateBulkInwardMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  grade?: InputMaybe<Scalars['Int']>;
  grossWeight?: InputMaybe<Scalars['Float']>;
  tareWeight?: InputMaybe<Scalars['Float']>;
  inwardedQuantity?: InputMaybe<Scalars['Int']>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  skuType?: InputMaybe<Scalars['ID']>;
  unloadingTeamId?: InputMaybe<Scalars['ID']>;
  expense?: InputMaybe<Scalars['Float']>;
  unloadingLocationId?: InputMaybe<Scalars['ID']>;
  unloadingSubLocationId?: InputMaybe<Scalars['ID']>;
  rstNo?: InputMaybe<Scalars['String']>;
}>;


export type AddUpdateBulkInwardMutationMutation = { __typename?: 'MutationRoot', addUpdateBulkInward?: { __typename?: 'AddUpdateBulkInwardMutation', trip?: { __typename?: 'TripType', id: string, status: TripStatus, expense: number, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string, contact: string } | null, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus, updatedAt: any, farmWeight: number, grossWeight: number, tareWeight: number, inwardedQuantity: number, standardDeduction: number, netWeight: number, weightLoss: number, finalWeight: number, grade?: { __typename?: 'HarvestGradeType', id: string, name: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null } | null, bookings: Array<{ __typename?: 'BookingType', id: string, qualitySample?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }>, schedule: { __typename?: 'ScheduleType', id: string, date: any, requiredQuantity: number, pricingDoneOn: SchedulePricingDoneOn, farmWeight: number, gatePass: string, gatelogsSet: Array<{ __typename?: 'GateLogType', id: string, createdAt: any, gateEntryNo?: string | null, gateStatus: GateLogsGateStatus, gateNumber?: { __typename?: 'GateNumberType', id: string, name: string, codename: string } | null }>, scheduledIn?: { __typename?: 'DepartmentType', id: string, packagingMaterialFlow: boolean } | null, unloadingLocation?: { __typename?: 'DepotType', id: string, name: string } | null, unloadingSubLocation?: { __typename?: 'UnloadingSubLocationType', id: string, name: string } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, createdAt: any, netWeightAfterDeduction?: number | null, totalReceivedQuantity?: number | null, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, receivedQuantity?: number | null } | null> | null } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, plotCommodity: { __typename?: 'PlotCommodityType', name: string, id: string, referenceId: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string } }>, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, standardDeduction: number } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, commodity: { __typename?: 'CommodityType', id: string, name: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, plot: { __typename?: 'PlotType', id: string, codename: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, username: string, isBlocked?: boolean | null }, address: { __typename?: 'AddressType', id: string, village: string } } } }> } | null } | null };

export type UpsertBatchInwardMutationVariables = Exact<{
  booking: Scalars['Int'];
  batches?: InputMaybe<Array<InputMaybe<InwardBatchInput>> | InputMaybe<InwardBatchInput>>;
  standardDeduction?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  unloadingTeamId?: InputMaybe<Scalars['ID']>;
  expense?: InputMaybe<Scalars['Float']>;
  unloadingLocationId?: InputMaybe<Scalars['ID']>;
  unloadingSubLocationId?: InputMaybe<Scalars['ID']>;
  rstNo?: InputMaybe<Scalars['String']>;
}>;


export type UpsertBatchInwardMutation = { __typename?: 'MutationRoot', addUpdateBatchInward?: { __typename?: 'AddUpdateBatchInwardMutation', response?: string | null, booking?: { __typename?: 'BookingType', id: string, trip?: { __typename?: 'TripType', id: string, expense: number, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string } | null } | null, schedule: { __typename?: 'ScheduleType', id: string, unloadingLocation?: { __typename?: 'DepotType', id: string, name: string } | null, unloadingSubLocation?: { __typename?: 'UnloadingSubLocationType', id: string, name: string } | null, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } }, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }> } | null } | null };

export type AddUpdateSampleMinimalMutationVariables = Exact<{
  qualities?: InputMaybe<Array<InputMaybe<InwardQualityInput>> | InputMaybe<InwardQualityInput>>;
}>;


export type AddUpdateSampleMinimalMutation = { __typename?: 'MutationRoot', addUpdateQualitySampleMinimal?: { __typename?: 'AddUpdateQualitySampleMinimalMutation', inwards?: Array<{ __typename?: 'InwardType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null } | null> | null } | null };

export type DeleteInwardsByIdMutationVariables = Exact<{
  inwards?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type DeleteInwardsByIdMutation = { __typename?: 'MutationRoot', deleteInwards?: { __typename?: 'DeleteInwardsMutation', inwards?: Array<{ __typename?: 'InwardType', id: string } | null> | null } | null };

export type TripsForDateQueryVariables = Exact<{
  date: Scalars['Date'];
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type TripsForDateQuery = { __typename?: 'QueryRoot', tripsForDate?: Array<{ __typename?: 'TripType', id: string, uuid: string, status: TripStatus, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus } | null, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string }, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, qualitySample?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, statusLogs?: Array<{ __typename?: 'InwardStatusLogType', createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } | null> | null, weigh: { __typename?: 'WeighType', id: string, status: WeighStatus, inwardedQuantity: number }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }>, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, gatelogsSet: Array<{ __typename?: 'GateLogType', id: string, createdAt: any, gateEntryNo?: string | null, gateStatus: GateLogsGateStatus, gateNumber?: { __typename?: 'GateNumberType', id: string, name: string, codename: string } | null }>, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, isBlocked?: boolean | null, companies: Array<{ __typename?: 'CompanyType', id: string }> } }, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null } }> } | null> | null };

export type BackendTripDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
}>;


export type BackendTripDetailsQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, status: TripStatus, expense: number, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string, contact: string } | null, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus, updatedAt: any, farmWeight: number, grossWeight: number, tareWeight: number, inwardedQuantity: number, standardDeduction: number, netWeight: number, weightLoss: number, finalWeight: number, grade?: { __typename?: 'HarvestGradeType', id: string, name: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null } | null, bookings: Array<{ __typename?: 'BookingType', id: string, qualitySample?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }>, schedule: { __typename?: 'ScheduleType', id: string, date: any, requiredQuantity: number, pricingDoneOn: SchedulePricingDoneOn, farmWeight: number, gatePass: string, gatelogsSet: Array<{ __typename?: 'GateLogType', id: string, createdAt: any, gateEntryNo?: string | null, gateStatus: GateLogsGateStatus, gateNumber?: { __typename?: 'GateNumberType', id: string, name: string, codename: string } | null }>, scheduledIn?: { __typename?: 'DepartmentType', id: string, packagingMaterialFlow: boolean } | null, unloadingLocation?: { __typename?: 'DepotType', id: string, name: string } | null, unloadingSubLocation?: { __typename?: 'UnloadingSubLocationType', id: string, name: string } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, createdAt: any, netWeightAfterDeduction?: number | null, totalReceivedQuantity?: number | null, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, receivedQuantity?: number | null } | null> | null } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, plotCommodity: { __typename?: 'PlotCommodityType', name: string, id: string, referenceId: string }, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string } }>, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, standardDeduction: number } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, commodity: { __typename?: 'CommodityType', id: string, name: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, plot: { __typename?: 'PlotType', id: string, codename: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, username: string, isBlocked?: boolean | null }, address: { __typename?: 'AddressType', id: string, village: string } } } }> } | null };

export type TripWeighStatusQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type TripWeighStatusQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus } | null, bookings: Array<{ __typename?: 'BookingType', id: string, inwards: Array<{ __typename?: 'InwardType', id: string, weigh: { __typename?: 'WeighType', id: string, status: WeighStatus } }> }> } | null };

export type BookingQualityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type BookingQualityQuery = { __typename?: 'QueryRoot', bookingDetails?: { __typename?: 'BookingType', id: string, inwards: Array<{ __typename?: 'InwardType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }> } | null };

export type InwardSummaryForDateQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']>;
}>;


export type InwardSummaryForDateQuery = { __typename?: 'QueryRoot', inwardedSummary?: { __typename?: 'InwardSummary', scheduledTrips?: number | null, inwardedTrips?: number | null, inwardedBookings?: number | null, scheduledBookings?: number | null, inwardedQuantity?: number | null, scheduledQuantity?: number | null, netWeight?: number | null, grossWeight?: number | null, acceptedWeight?: number | null, rejectedWeight?: number | null, averageQualityRejection?: number | null, averageStandardRejection?: number | null } | null };

export type BookingInfoQueryVariables = Exact<{
  scheduleId: Scalars['ID'];
  schedule?: InputMaybe<Scalars['Int']>;
}>;


export type BookingInfoQuery = { __typename?: 'QueryRoot', transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, farmWeight?: number | null, acceptedDeduction: number, standardDeduction: number, deductionRate: number, weightApplicable: VehicleTransportDetailWeightApplicable, transportPaidBy: VehicleTransportDetailTransportPaidBy, transportCost: number, advancePaidBy: VehicleTransportDetailAdvancePaidBy, advanceCost: number, rejectionBourneBy: VehicleTransportDetailRejectionBourneBy, remark?: string | null, pricingDoneOn?: string | null, gradePrices?: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string } } | null> | null } | null, scheduleDetails?: { __typename?: 'ScheduleType', id: string, date: any, gatePass: string, assignedPoCodes?: Array<string | null> | null, requiredQuantity: number, cropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string } } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, codename: string } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, companyCode?: string | null }, address: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null, district?: string | null } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string, registrationCode: string, agronomist?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null }, scheduleRequest?: { __typename?: 'ScheduleRequestType', id: string, timeSlot?: { __typename?: 'TimeSlotRequirementType', id: string, demand: { __typename?: 'DemandType', id: string, name: string } } | null } | null } | null };

export type FrontendTripDetailFragFragment = { __typename?: 'TripType', id: string, expense: number, status: TripStatus, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string, contact: string } | null, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus, updatedAt: any, farmWeight: number, grossWeight: number, tareWeight: number, inwardedQuantity: number, standardDeduction: number, netWeight: number, weightLoss: number, finalWeight: number, grade?: { __typename?: 'HarvestGradeType', id: string, name: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null } | null, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number, pickupTime?: any | null, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }>, orderItem?: { __typename?: 'OrderItemType', id: string, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, name: string, selfWeight: number } | null }, shipping?: { __typename?: 'ShippingType', id: string, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null, order: { __typename?: 'AnnotatedOrderType', id: string, trackingCode: string, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, address?: { __typename?: 'AddressType', id: string, address?: string | null, village: string } | null } } } | null, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, standardDeduction: number } | null } }> };

export type FrontendTripsForDateQueryVariables = Exact<{
  orderingDcId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FrontendTripsForDateQuery = { __typename?: 'QueryRoot', tripsForDate?: Array<{ __typename?: 'TripType', id: string, status: TripStatus, uuid: string, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus } | null, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string }, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string }, inwards: Array<{ __typename?: 'InwardType', id: string, weigh: { __typename?: 'WeighType', id: string, status: WeighStatus, inwardedQuantity: number } }>, orderItem?: { __typename?: 'OrderItemType', id: string, shipping?: { __typename?: 'ShippingType', id: string, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, name: string, selfWeight: number } | null }, order: { __typename?: 'AnnotatedOrderType', id: string, trackingCode: string, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } } | null }> } | null> | null };

export type FrontendTripDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
}>;


export type FrontendTripDetailsQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, expense: number, status: TripStatus, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string, contact: string } | null, weighDetail?: { __typename?: 'WeighType', id: string, status: WeighStatus, updatedAt: any, farmWeight: number, grossWeight: number, tareWeight: number, inwardedQuantity: number, standardDeduction: number, netWeight: number, weightLoss: number, finalWeight: number, grade?: { __typename?: 'HarvestGradeType', id: string, name: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null } | null, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number, pickupTime?: any | null, inwards: Array<{ __typename?: 'InwardType', id: string, serialNo?: string | null, rstNo?: string | null, grn: string, weigh: { __typename?: 'WeighType', id: string, inwardedQuantity: number, farmWeight: number, weightLoss: number, netWeight: number, status: WeighStatus, standardDeduction: number, batches: Array<{ __typename?: 'WeighBatchType', id: string, skuCount: number, uomCount: number, codename: string, skuTareWeight: number, grossWeight: number, netWeight: number, tareWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null, uomType?: { __typename?: 'SIUnitType', id: string, codename: string, name: string } | null }> }, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }>, orderItem?: { __typename?: 'OrderItemType', id: string, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, name: string, selfWeight: number } | null }, shipping?: { __typename?: 'ShippingType', id: string, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null, order: { __typename?: 'AnnotatedOrderType', id: string, trackingCode: string, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, address?: { __typename?: 'AddressType', id: string, address?: string | null, village: string } | null } } } | null, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, standardDeduction: number } | null } }> } | null };

export type DeleteMediaMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteMediaMutation = { __typename?: 'MutationRoot', deleteMedia?: { __typename?: 'DeleteMedia', response?: string | null } | null };

export type NotificationTemplateTypeDetailFragFragment = { __typename?: 'NotificationTemplateType', id: string, alias: string, body: string, title: string };

export type NotificationFragFragment = { __typename?: 'NotificationType', id: string, messegeType: NotificationMessegeType, template: { __typename?: 'NotificationTemplateType', id: string, name: string }, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string }> };

export type NotificationTemplateDetailV1FragFragment = { __typename?: 'NewNotificationTemplateType', id: string, body: string, codename: string, isActive: boolean, title: string, name: string, isProgrammatic: boolean, providerVariables?: any | null, dataVariables?: any | null, extraFields?: any | null, provider: { __typename?: 'NotificationProviderType', id: string, name: string, codename: string, kind: NotificationProviderKind }, dataSource?: { __typename?: 'DataSourceType', id: string, inputs?: any | null, name: string, outputs?: any | null, isActive: boolean, codename: string } | null };

export type UserQueryFragFragment = { __typename?: 'UserQueryType', id: string, name: string, codename: string, filters?: Array<{ __typename?: 'UserFilterType', id: string, referenceQuery: string, fieldType: UserFilterFieldType, value: string, isRangeValue: boolean, exclude: boolean, alias: string } | null> | null };

export type CreateUpdateNotificationTemplateMutationVariables = Exact<{
  alias?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
}>;


export type CreateUpdateNotificationTemplateMutation = { __typename?: 'MutationRoot', addUpdateNotificationTemplate?: { __typename?: 'AddUpdateNotificationTemplateMutation', template?: { __typename?: 'NotificationTemplateType', id: string, alias: string, body: string, title: string } | null } | null };

export type NotifyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NotifyMutation = { __typename?: 'MutationRoot', sendNotification?: { __typename?: 'SendNotificationMutation', notification?: { __typename?: 'NotificationType', id: string } | null } | null };

export type CreateNotificationMutationVariables = Exact<{
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  instanceType?: InputMaybe<Scalars['String']>;
  messegeType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['ID']>;
  templateId: Scalars['ID'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateNotificationMutation = { __typename?: 'MutationRoot', addNotification?: { __typename?: 'AddNotificationMutation', notification?: { __typename?: 'NotificationType', id: string, messegeType: NotificationMessegeType, template: { __typename?: 'NotificationTemplateType', id: string, name: string }, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null } | null };

export type RehitNotificationMutationVariables = Exact<{
  triggerId?: InputMaybe<Scalars['ID']>;
}>;


export type RehitNotificationMutation = { __typename?: 'MutationRoot', retriggerNotification?: { __typename?: 'RetriggerNotificationMutation', success?: boolean | null } | null };

export type MakeNotificationMutationVariables = Exact<{
  broadcastTime?: InputMaybe<Scalars['DateTime']>;
  content?: InputMaybe<NotificationContent>;
  dataVariables?: InputMaybe<Scalars['JSONScalar']>;
  extraVariables?: InputMaybe<Scalars['JSONScalar']>;
  filters?: InputMaybe<Array<InputMaybe<NotificationTemplateFilter>> | InputMaybe<NotificationTemplateFilter>>;
  providerUid?: InputMaybe<Scalars['String']>;
  providerVariables?: InputMaybe<Scalars['JSONScalar']>;
  templateUid?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  userQueryUid?: InputMaybe<Scalars['String']>;
}>;


export type MakeNotificationMutation = { __typename?: 'MutationRoot', triggerNotification?: { __typename?: 'TriggerNotificationMutation', success?: boolean | null } | null };

export type CreateUpdateNotificationTemplateNewMutationVariables = Exact<{
  body?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  dataSourceId?: InputMaybe<Scalars['ID']>;
  dataVariables?: InputMaybe<Scalars['JSONScalar']>;
  description?: InputMaybe<Scalars['String']>;
  extraFields?: InputMaybe<Scalars['JSONScalar']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isProgrammatic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerVariables?: InputMaybe<Scalars['JSONScalar']>;
  title?: InputMaybe<Scalars['String']>;
}>;


export type CreateUpdateNotificationTemplateNewMutation = { __typename?: 'MutationRoot', addUpdateNotificationTemplateV1?: { __typename?: 'AddUpdateNotificationTemplateV1', template?: { __typename?: 'NewNotificationTemplateType', id: string, body: string, codename: string, dataVariables?: any | null, description: string, extraFields?: any | null, isActive: boolean, isProgrammatic: boolean, name: string, providerVariables?: any | null, title: string, dataSource?: { __typename?: 'DataSourceType', id: string } | null, provider: { __typename?: 'NotificationProviderType', id: string } } | null } | null };

export type NotificationTemplateListNewQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NotificationTemplateInput>;
}>;


export type NotificationTemplateListNewQuery = { __typename?: 'QueryRoot', allV1NotificationTemplates?: Array<{ __typename?: 'NewNotificationTemplateType', id: string, body: string, codename: string, isActive: boolean, title: string, name: string, isProgrammatic: boolean, providerVariables?: any | null, dataVariables?: any | null, extraFields?: any | null, provider: { __typename?: 'NotificationProviderType', id: string, name: string, codename: string, kind: NotificationProviderKind }, dataSource?: { __typename?: 'DataSourceType', id: string, inputs?: any | null, name: string, outputs?: any | null, isActive: boolean, codename: string } | null } | null> | null };

export type NotificationProviderListQueryVariables = Exact<{
  filter?: InputMaybe<NotificationProviderInput>;
}>;


export type NotificationProviderListQuery = { __typename?: 'QueryRoot', allNotificationProviders?: Array<{ __typename?: 'NotificationProviderType', id: string, name: string, codename: string } | null> | null };

export type DataSourceListQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSourceListQuery = { __typename?: 'QueryRoot', allDataSources?: Array<{ __typename?: 'DataSourceType', id: string, inputs?: any | null, name: string, outputs?: any | null, isActive: boolean, codename: string } | null> | null };

export type NotificationTemplateNewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NotificationTemplateNewQuery = { __typename?: 'QueryRoot', v1NotificationTemplateDetail?: { __typename?: 'NewNotificationTemplateType', id: string, body: string, codename: string, isActive: boolean, title: string, name: string, isProgrammatic: boolean, providerVariables?: any | null, dataVariables?: any | null, extraFields?: any | null, provider: { __typename?: 'NotificationProviderType', id: string, name: string, codename: string, kind: NotificationProviderKind }, dataSource?: { __typename?: 'DataSourceType', id: string, inputs?: any | null, name: string, outputs?: any | null, isActive: boolean, codename: string } | null } | null };

export type NotificationTriggerListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NotificationTriggerInput>;
}>;


export type NotificationTriggerListQuery = { __typename?: 'QueryRoot', allNotificationTriggers?: Array<{ __typename?: 'NotificationTriggerType', id: string, isTriggered: boolean, usersCount?: number | null, broadcastTime?: any | null, template?: { __typename?: 'NewNotificationTemplateType', id: string, name: string } | null, provider: { __typename?: 'NotificationProviderType', id: string, kind: NotificationProviderKind, name: string }, sentBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } | null> | null };

export type NotificationTriggerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NotificationTriggerQuery = { __typename?: 'QueryRoot', notificationTriggerDetail?: { __typename?: 'NotificationTriggerType', id: string, isTriggered: boolean, config?: any | null, providerVariables?: any | null, dataVariables?: any | null, broadcastTime?: any | null, extraFields?: any | null, provider: { __typename?: 'NotificationProviderType', id: string, kind: NotificationProviderKind, name: string, codename: string }, userQuery?: { __typename?: 'UserQueryType', id: string, name: string, codename: string, filters?: Array<{ __typename?: 'UserFilterType', id: string, referenceQuery: string, fieldType: UserFilterFieldType, value: string, isRangeValue: boolean, exclude: boolean, alias: string } | null> | null } | null, template?: { __typename?: 'NewNotificationTemplateType', id: string, body: string, codename: string, isActive: boolean, title: string, name: string, isProgrammatic: boolean, providerVariables?: any | null, dataVariables?: any | null, extraFields?: any | null, provider: { __typename?: 'NotificationProviderType', id: string, name: string, codename: string, kind: NotificationProviderKind }, dataSource?: { __typename?: 'DataSourceType', id: string, inputs?: any | null, name: string, outputs?: any | null, isActive: boolean, codename: string } | null } | null } | null };

export type AllUserQueriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserQueriesQuery = { __typename?: 'QueryRoot', allUserQuerys?: Array<{ __typename?: 'UserQueryType', id: string, name: string, codename: string, filters?: Array<{ __typename?: 'UserFilterType', id: string, referenceQuery: string, fieldType: UserFilterFieldType, value: string, isRangeValue: boolean, exclude: boolean, alias: string } | null> | null } | null> | null };

export type EndUserCountQueryVariables = Exact<{
  filter?: InputMaybe<TargetUserCountInput>;
}>;


export type EndUserCountQuery = { __typename?: 'QueryRoot', targetUserCount?: { __typename?: 'TargetUserCountType', userCount?: number | null } | null };

export type OrderListFragFragment = { __typename?: 'OrderType', id: string, isConsolidated?: boolean | null, orderStatus: OrderOrderStatus, trackingCode: string, outstandingAmount: number, paymentMethod: OrderPaymentMethod, paymentStatus: OrderPaymentStatus, totalAmount: number, createdAt: any, metadata: any, deliveryStatus: OrderDeliveryStatus, orderCategory: OrderOrderCategory, soNumber?: string | null, totalPaid?: number | null, pickupDate?: any | null, discount?: { __typename?: 'DiscountType', id: string, percentage: number, flat: number } | null, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, metadata: any, discount?: { __typename?: 'DiscountType', id: string, percentage: number, flat: number } | null } | null> | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }> }, shippingAddress: { __typename?: 'AddressType', id: string, address?: string | null, village: string, district?: string | null }, transactions?: Array<{ __typename?: 'OrderTransactionType', id: string, referenceId: string, amount: number, createdAt: any } | null> | null };

export type OrderDetailFragFragment = { __typename?: 'OrderType', id: string, trackingCode: string, outstandingAmount: number, date: any, soNumber?: string | null, isConsolidated?: boolean | null, deliveryStatus: OrderDeliveryStatus, paymentStatus: OrderPaymentStatus, orderStatus: OrderOrderStatus, paymentMethod: OrderPaymentMethod, shippingMethod: OrderShippingMethod, pocName: string, pocNumber: string, totalAmount: number, totalPaid?: number | null, crateCount: number, billingDoc: Array<{ __typename?: 'BillingDocType', id: string, billingDocNumber: string }>, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, shipping?: { __typename?: 'ShippingType', id: string, estimatedDelivery?: any | null } | null } | null> | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, email: string }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, address?: string | null }, transactions?: Array<{ __typename?: 'OrderTransactionType', id: string, paymentMethod: OrderTransactionPaymentMethod, referenceId: string, amount: number, status: OrderTransactionStatus, attachment?: { __typename?: 'MediaEntityType', id: string, url: string } | null } | null> | null };

export type OrderInvoiceDetailQueryVariables = Exact<{
  orderId: Scalars['ID'];
  tripId?: InputMaybe<Scalars['ID']>;
}>;


export type OrderInvoiceDetailQuery = { __typename?: 'QueryRoot', orderInvoiceDetail?: { __typename?: 'OrderInvoiceDetail', id?: string | null, invoiceDocumentPath?: string | null } | null };

export type OrderListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type OrderListQuery = { __typename?: 'QueryRoot', allOrders?: Array<{ __typename?: 'OrderType', id: string, isConsolidated?: boolean | null, orderStatus: OrderOrderStatus, trackingCode: string, outstandingAmount: number, paymentMethod: OrderPaymentMethod, paymentStatus: OrderPaymentStatus, totalAmount: number, createdAt: any, metadata: any, deliveryStatus: OrderDeliveryStatus, orderCategory: OrderOrderCategory, soNumber?: string | null, totalPaid?: number | null, pickupDate?: any | null, discount?: { __typename?: 'DiscountType', id: string, percentage: number, flat: number } | null, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, metadata: any, discount?: { __typename?: 'DiscountType', id: string, percentage: number, flat: number } | null } | null> | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }> }, shippingAddress: { __typename?: 'AddressType', id: string, address?: string | null, village: string, district?: string | null }, transactions?: Array<{ __typename?: 'OrderTransactionType', id: string, referenceId: string, amount: number, createdAt: any } | null> | null } | null> | null };

export type OrderDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderDetailQuery = { __typename?: 'QueryRoot', orderDetail?: { __typename?: 'OrderType', id: string, trackingCode: string, outstandingAmount: number, date: any, soNumber?: string | null, isConsolidated?: boolean | null, deliveryStatus: OrderDeliveryStatus, paymentStatus: OrderPaymentStatus, orderStatus: OrderOrderStatus, paymentMethod: OrderPaymentMethod, shippingMethod: OrderShippingMethod, pocName: string, pocNumber: string, totalAmount: number, totalPaid?: number | null, crateCount: number, billingDoc: Array<{ __typename?: 'BillingDocType', id: string, billingDocNumber: string }>, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, shipping?: { __typename?: 'ShippingType', id: string, estimatedDelivery?: any | null } | null } | null> | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, email: string }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, address?: string | null }, transactions?: Array<{ __typename?: 'OrderTransactionType', id: string, paymentMethod: OrderTransactionPaymentMethod, referenceId: string, amount: number, status: OrderTransactionStatus, attachment?: { __typename?: 'MediaEntityType', id: string, url: string } | null } | null> | null } | null, orderInvoiceDetail?: { __typename?: 'OrderInvoiceDetail', id?: string | null, trackingCode?: string | null, pocName?: string | null, pocNumber?: string | null, discountCode?: string | null, discountPercentage?: number | null, availablePaymentModes?: Array<string | null> | null, invoiceItems?: Array<{ __typename?: 'OrderInvoiceItem', name?: string | null, quantity?: number | null, actualRate?: number | null, discountedRate?: number | null, category?: string | null, itemType?: string | null, amount?: number | null, balance?: number | null, itemDiscountId?: number | null, itemDiscountCode?: string | null, itemDiscountFlat?: number | null, itemDiscountPercent?: number | null, customDiscountFlat?: number | null, customDiscountPercent?: number | null } | null> | null, deliveryAddress?: { __typename?: 'DeliveryAddressOutput', village?: string | null, address?: string | null } | null } | null };

export type OrderInvoiceQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['ID']>;
}>;


export type OrderInvoiceQuery = { __typename?: 'QueryRoot', orderInvoiceDetail?: { __typename?: 'OrderInvoiceDetail', id?: string | null, trackingCode?: string | null, pocName?: string | null, pocNumber?: string | null, discountCode?: string | null, discountPercentage?: number | null, availablePaymentModes?: Array<string | null> | null, invoiceItems?: Array<{ __typename?: 'OrderInvoiceItem', name?: string | null, quantity?: number | null, actualRate?: number | null, discountedRate?: number | null, category?: string | null, itemType?: string | null, amount?: number | null, balance?: number | null, itemDiscountId?: number | null, itemDiscountCode?: string | null, itemDiscountFlat?: number | null, itemDiscountPercent?: number | null, customDiscountFlat?: number | null, customDiscountPercent?: number | null } | null> | null, deliveryAddress?: { __typename?: 'DeliveryAddressOutput', village?: string | null, address?: string | null } | null } | null };

export type AllVendorsSelectorQueryVariables = Exact<{
  group?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
}>;


export type AllVendorsSelectorQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string, address?: { __typename?: 'AddressType', id: string, village: string, district?: string | null, address?: string | null, latitude: number, longitude: number, taluka?: string | null, state?: string | null, pincode?: string | null, geofenceRadius: number } | null } | null> | null };

export type CartInvoiceQueryVariables = Exact<{
  orderItems: Array<InputMaybe<OrderItemStockInput>> | InputMaybe<OrderItemStockInput>;
  discountId?: InputMaybe<Scalars['ID']>;
  customDiscountPercent?: InputMaybe<Scalars['Float']>;
  customDiscountFlat?: InputMaybe<Scalars['Float']>;
}>;


export type CartInvoiceQuery = { __typename?: 'QueryRoot', customInvoiceDetail?: { __typename?: 'OrderInvoiceDetail', id?: string | null, trackingCode?: string | null, pocName?: string | null, pocNumber?: string | null, discountCode?: string | null, discountPercentage?: number | null, availablePaymentModes?: Array<string | null> | null, invoiceItems?: Array<{ __typename?: 'OrderInvoiceItem', name?: string | null, quantity?: number | null, actualRate?: number | null, discountedRate?: number | null, category?: string | null, itemType?: string | null, amount?: number | null, balance?: number | null, stockCount?: number | null, itemDiscountId?: number | null, itemDiscountCode?: string | null, itemDiscountFlat?: number | null, itemDiscountPercent?: number | null, customDiscountFlat?: number | null, customDiscountPercent?: number | null } | null> | null, deliveryAddress?: { __typename?: 'DeliveryAddressOutput', id?: string | null, village?: string | null, address?: string | null } | null } | null };

export type AggregatedOrderItemsQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  targetDcId: Scalars['ID'];
  orderingDcId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type AggregatedOrderItemsQuery = { __typename?: 'QueryRoot', aggregatedOrderItems?: Array<{ __typename?: 'ConsolidatedOrderItem', sourceDcRate?: number | null, stockCount?: number | null, quantity?: number | null, sellableItem?: { __typename?: 'SellableItemType', id: string, name: string } | null, orderingItemStock?: { __typename?: 'SellableItemStockType', id: string } | null, sellableItemStock?: { __typename?: 'SellableItemStockType', id: string, offerStockCount: number, currentStockCount: number, unitRate: number, discountedRate: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string }, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null } | null> | null };

export type OrdersBySellableItemQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type OrdersBySellableItemQuery = { __typename?: 'QueryRoot', ordersBySellableItem?: Array<{ __typename?: 'OrderBySellableItem', sellableItem?: { __typename?: 'SellableItemType', id: string, name: string, shortDescription: string, primaryPhoto: { __typename?: 'MediaEntityType', id: string, url: string }, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, name: string }> } | null, statusDetails?: Array<{ __typename?: 'OrderStatusSummary', quantity?: number | null, orderStatus?: string | null } | null> | null } | null> | null };

export type OrdersBySellableItemsSummaryQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type OrdersBySellableItemsSummaryQuery = { __typename?: 'QueryRoot', summaryAllOrders?: { __typename?: 'SummaryAllOrders', itemCount?: number | null, itemStatusConfirmed?: number | null, itemStatusCancelledByUser?: number | null, itemStatusInProcess?: number | null, itemStatusReadyForDespatch?: number | null } | null };

export type SummaryAllOrdersQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type SummaryAllOrdersQuery = { __typename?: 'QueryRoot', summaryAllOrders?: { __typename?: 'SummaryAllOrders', statusCompleted?: number | null, statusPlaced?: number | null, statusConfirmed?: number | null, statusNotPlaced?: number | null, statusInProcess?: number | null, statusPartialReject?: number | null, statusFullReject?: number | null, statusReadyForDespatch?: number | null, statusScheduledForDespatch?: number | null, statusReadyForSchedule?: number | null, statusDespatched?: number | null, statusCancelledByUser?: number | null, statusCancelledByVendor?: number | null, orderCount?: number | null } | null };

export type SummaryAllOrderItemsQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type SummaryAllOrderItemsQuery = { __typename?: 'QueryRoot', summaryAllOrders?: { __typename?: 'SummaryAllOrders', statusCompleted?: number | null, statusPlaced?: number | null, statusConfirmed?: number | null, statusNotPlaced?: number | null, statusInProcess?: number | null, statusPartialReject?: number | null, statusFullReject?: number | null, statusReadyForDespatch?: number | null, statusScheduledForDespatch?: number | null, statusReadyForSchedule?: number | null, statusDespatched?: number | null, statusCancelledByUser?: number | null, statusCancelledByVendor?: number | null, itemStatusCompleted?: number | null, itemStatusPlaced?: number | null, itemStatusConfirmed?: number | null, itemStatusNotPlaced?: number | null, itemStatusInProcess?: number | null, itemStatusPartialReject?: number | null, itemStatusFullReject?: number | null, itemStatusReadyForDespatch?: number | null, itemStatusScheduledForDespatch?: number | null, itemStatusReadyForSchedule?: number | null, itemStatusDespatched?: number | null, itemStatusCancelledByUser?: number | null, itemStatusCancelledByVendor?: number | null, orderCount?: number | null, itemCount?: number | null } | null };

export type OrderCountFilterQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type OrderCountFilterQuery = { __typename?: 'QueryRoot', orderCountFilter?: number | null };

export type PeriodicTaskDetailFragFragment = { __typename?: 'PeriodicTaskType', id: string, task: string, name: string, enabled: boolean, startTime?: any | null, oneOff: boolean, scheduleName?: string | null, logs: Array<{ __typename?: 'TaskLogType', id: string, isOk: boolean, createdAt: any, responseCode?: number | null, requestData?: any | null, responseData?: any | null }>, latestLog?: { __typename?: 'TaskLogType', id: string, isOk: boolean } | null };

export type UpdatePeriodicTasksMutationVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  oneOff?: InputMaybe<Scalars['Boolean']>;
  queue?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePeriodicTasksMutation = { __typename?: 'MutationRoot', updatePeriodicTasks?: { __typename?: 'UpdatePeriodicTasks', periodicTasks?: Array<{ __typename?: 'PeriodicTaskType', id: string, task: string, name: string, enabled: boolean, startTime?: any | null, oneOff: boolean, scheduleName?: string | null, logs: Array<{ __typename?: 'TaskLogType', id: string, isOk: boolean, createdAt: any, responseCode?: number | null, requestData?: any | null, responseData?: any | null }>, latestLog?: { __typename?: 'TaskLogType', id: string, isOk: boolean } | null } | null> | null } | null };

export type PeriodicTasksQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PeriodicTaskFilterInput>;
}>;


export type PeriodicTasksQuery = { __typename?: 'QueryRoot', allPeriodicTasks?: Array<{ __typename?: 'PeriodicTaskType', id: string, task: string, name: string, enabled: boolean, startTime?: any | null, oneOff: boolean, scheduleName?: string | null, latestLog?: { __typename?: 'TaskLogType', id: string, isOk: boolean } | null } | null> | null };

export type PeriodicTaskDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PeriodicTaskDetailQuery = { __typename?: 'QueryRoot', periodicTaskDetail?: { __typename?: 'PeriodicTaskType', id: string, task: string, name: string, enabled: boolean, startTime?: any | null, oneOff: boolean, scheduleName?: string | null, logs: Array<{ __typename?: 'TaskLogType', id: string, isOk: boolean, createdAt: any, responseCode?: number | null, requestData?: any | null, responseData?: any | null }>, latestLog?: { __typename?: 'TaskLogType', id: string, isOk: boolean } | null } | null };

export type PackingallotmentSetFragment = { __typename?: 'PackingAllotmentSelectorType', id: string, allotedQuantity: number, allotedWeight: number, sendToLine: boolean, createdAt: any, updatedAt: any, reverseWeight: number, reversalReason?: string | null, reverseQuantity: number, productionLine?: { __typename?: 'ProductionLineType', id: string, name: string } | null, supervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null };

export type CreateInwardAllocationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: InwardAllocationInput;
}>;


export type CreateInwardAllocationMutation = { __typename?: 'MutationRoot', addUpdateInwardAllocation?: { __typename?: 'AddUpdateInwardAllocationMutation', inward?: { __typename?: 'InwardAllocationType', id: string, metadata: any, inward: { __typename?: 'InwardType', id: string }, holdingArea?: { __typename?: 'HoldingAreaType', id: string } | null, plotCommoditySample?: { __typename?: 'PlotCommoditySampleType', id: string } | null } | null } | null };

export type MutationAddUpdatePackingAllotmentMutationVariables = Exact<{
  allotment: PackingAllotmentInput;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type MutationAddUpdatePackingAllotmentMutation = { __typename?: 'MutationRoot', addUpdatePackingAllotment?: { __typename?: 'AddUpdatePackingAllotmentMutation', packingAllotment?: { __typename?: 'PackingAllotmentType', id: string } | null } | null };

export type InwardAllocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  holdingAreaId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  inwardId?: InputMaybe<Scalars['ID']>;
  depotId?: InputMaybe<Scalars['ID']>;
  varietyId?: InputMaybe<Scalars['ID']>;
}>;


export type InwardAllocationsQuery = { __typename?: 'QueryRoot', inwardAllocations?: Array<{ __typename?: 'InwardAllocationType', id: string, createdAt: any, ggn?: string | null, metadata: any, allottedWeight?: any | null, allottedSku?: number | null, availableWeight?: any | null, availableSkusCount?: number | null, plotCommoditySample?: { __typename?: 'PlotCommoditySampleType', id: string, totalDetection: number, detectionCount: number, physicalStatus: PlotCommoditySamplePhysicalStatus, chemicalStatus: PlotCommoditySampleChemicalStatus, maxDetection: number, chemicalStatusDisplay?: string | null, physicalStatusDisplay?: string | null, observations?: Array<{ __typename?: 'PlotCommoditySampleObservationType', id: string, tags?: Array<string | null> | null, detectionCount?: number | null, score?: number | null, qualityParameter: { __typename?: 'QualityParameterType', id: string, name: string, mrl: number } } | null> | null } | null, inward: { __typename?: 'InwardType', id: string, grn: string, metadata: any, date: any, status: InwardStatus, weigh: { __typename?: 'WeighType', id: string, netWeight: number, inwardedQuantity: number, finalWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string } | null }, booking: { __typename?: 'BookingType', id: string, date: any, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, chassisNumber?: string | null } | null, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, registrationCode: string }, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } } } }, holdingArea?: { __typename?: 'HoldingAreaType', id: string, name: string, isActive: boolean } | null, packingallotmentSet: Array<{ __typename?: 'PackingAllotmentSelectorType', id: string, allotedQuantity: number, allotedWeight: number, sendToLine: boolean, createdAt: any, updatedAt: any, reverseWeight: number, reversalReason?: string | null, reverseQuantity: number, productionLine?: { __typename?: 'ProductionLineType', id: string, name: string } | null, supervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null }> } | null> | null };

export type InwardAllocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InwardAllocationQuery = { __typename?: 'QueryRoot', inwardAllocation?: { __typename?: 'InwardAllocationType', id: string, createdAt: any, metadata: any, ggn?: string | null, allottedWeight?: any | null, allottedSku?: number | null, availableWeight?: any | null, availableSkusCount?: number | null, packingallotmentSet: Array<{ __typename?: 'PackingAllotmentSelectorType', id: string, allotedQuantity: number, allotedWeight: number, sendToLine: boolean, createdAt: any, updatedAt: any, reverseWeight: number, reversalReason?: string | null, reverseQuantity: number, productionLine?: { __typename?: 'ProductionLineType', id: string, name: string } | null, supervisor?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null }>, plotCommoditySample?: { __typename?: 'PlotCommoditySampleType', id: string, totalDetection: number, detectionCount: number, physicalStatus: PlotCommoditySamplePhysicalStatus, chemicalStatus: PlotCommoditySampleChemicalStatus, maxDetection: number, chemicalStatusDisplay?: string | null, physicalStatusDisplay?: string | null, observations?: Array<{ __typename?: 'PlotCommoditySampleObservationType', id: string, tags?: Array<string | null> | null, detectionCount?: number | null, score?: number | null, qualityParameter: { __typename?: 'QualityParameterType', id: string, name: string, mrl: number } } | null> | null } | null, inward: { __typename?: 'InwardType', id: string, grn: string, date: any, status: InwardStatus, weigh: { __typename?: 'WeighType', id: string, netWeight: number, inwardedQuantity: number, finalWeight: number, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null }, booking: { __typename?: 'BookingType', id: string, date: any, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, chassisNumber?: string | null } | null, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, registrationCode: string }, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } } } }, holdingArea?: { __typename?: 'HoldingAreaType', id: string, name: string, isActive: boolean } | null } | null };

export type EligibleExportCustomersBySampleQueryVariables = Exact<{
  sampleId: Scalars['ID'];
}>;


export type EligibleExportCustomersBySampleQuery = { __typename?: 'QueryRoot', eligibleExportCustomersBySample?: Array<{ __typename?: 'ExportCustomerType', id: string, name: string } | null> | null };

export type AddUpdateProductionMutationVariables = Exact<{
  input: ProductionUpsertInput;
}>;


export type AddUpdateProductionMutation = { __typename?: 'MutationRoot', addUpdateProduction?: { __typename?: 'AddUpdateProduction', ok?: boolean | null, error?: string | null, production?: { __typename?: 'ProductionType', id: string } | null } | null };

export type UpdateLinePackingAllotmentLotCodeMutationVariables = Exact<{
  input: UpdateLinePackingAllotmentLotCodeInput;
}>;


export type UpdateLinePackingAllotmentLotCodeMutation = { __typename?: 'MutationRoot', updateLinePackingAllotmentLotCode?: { __typename?: 'UpdateLinePackingAllotmentLotCode', ok?: boolean | null, message?: string | null } | null };

export type ProductionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  exportCustomerId?: InputMaybe<Scalars['ID']>;
  sendForApproval?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  varietyId?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  toDate?: InputMaybe<Scalars['Date']>;
  productionStatus?: InputMaybe<Scalars['String']>;
}>;


export type ProductionsQuery = { __typename?: 'QueryRoot', productions?: Array<{ __typename?: 'ProductionType', id: string, createdAt: any, weeklySrNo: string, supervisorNames?: Array<string | null> | null, certificateNumbers?: Array<string | null> | null, farmerNames?: Array<string | null> | null, gatePasses?: Array<string | null> | null, sendForApproval: boolean, metadata: any, shipmentPlan: { __typename?: 'ShipmentPlanType', id: string, soNo: string, skuFilled: number, varietyType: ShipmentPlanVarietyType, exportCustomer: { __typename?: 'ExportCustomerType', id: string, name: string }, varieties: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string }>, skuType: { __typename?: 'SKUGraphType', id: string, name: string } }, productionLine: { __typename?: 'ProductionLineType', id: string, name: string } } | null> | null };

export type ProductionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductionQuery = { __typename?: 'QueryRoot', production?: { __typename?: 'ProductionType', id: string, sendForApproval: boolean, metadata: any, weeklySrNo: string, productionLine: { __typename?: 'ProductionLineType', id: string, name: string }, shipmentPlan: { __typename?: 'ShipmentPlanType', id: string, soNo: string, skuFilled: number, metadata: any, varietyType: ShipmentPlanVarietyType, labels?: string | null, exportCustomer: { __typename?: 'ExportCustomerType', id: string, name: string }, colourGroup?: { __typename?: 'ColorGroupType', id: string, name: string } | null, skuType: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } }, varieties: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string }>, primaryPackMaterial?: { __typename?: 'SKUPackingMaterialType', id: string, name: string } | null, secondaryPackMaterial?: { __typename?: 'SKUPackingMaterialType', id: string, name: string } | null, approvedtradeprofileSet: Array<{ __typename?: 'ApprovedTradeProfileType', id: string, boxCount?: number | null, tradeProfile: { __typename?: 'TradeProfileType', id: string, certificateNumber?: string | null, availableYield: number, plotYeild: number } }> }, productionitemSet: Array<{ __typename?: 'ProductionItemType', id: string, createdAt: any, sequenceNumber: number, palletNo: string, boxCount: number, remark: string, palletType?: string | null, metadata: any, linetradeprofileSet: Array<{ __typename?: 'LineTradeProfileType', id: string, assignedWt: number, availableWt: number, approvedTradeProfile: { __typename?: 'ApprovedTradeProfileType', id: string, tradeProfile: { __typename?: 'TradeProfileType', id: string, certificateNumber?: string | null, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plot: { __typename?: 'PlotType', id: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, documents?: Array<{ __typename?: 'GeneralCertificationType', id: string, idNumber: string, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string, codename: string } } | null> | null } } } } } }>, linepackingallotmentSet: Array<{ __typename?: 'LinePackingAllotmentType', id: string, lotCode?: string | null, createdAt: any, productionCreatedDate: any, assignedWt?: number | null, availableWt: number, rejectionWt: number, rejectionBoxCount: number, packingAllotment: { __typename?: 'PackingAllotmentSelectorType', id: string, inwardAllocation: { __typename?: 'InwardAllocationType', id: string, inward: { __typename?: 'InwardType', id: string, booking: { __typename?: 'BookingType', id: string, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, registrationCode: string }, plot: { __typename?: 'PlotType', farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } } } } } } }> }> } | null };

export type MhCodeSelectorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MhCodeSelectorQuery = { __typename?: 'QueryRoot', production?: { __typename?: 'ProductionType', id: string, weeklySrNo: string, shipmentPlan: { __typename?: 'ShipmentPlanType', id: string, metadata: any, skuType: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number }, varieties: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string }>, approvedtradeprofileSet: Array<{ __typename?: 'ApprovedTradeProfileType', id: string, boxCount?: number | null, availableYield: number, tradeProfile: { __typename?: 'TradeProfileType', id: string, certificateNumber?: string | null, availableYield: number, plotYeild: number, extraPlotYeild?: number | null, extraAvailableYield?: number | null, plotCommodity: { __typename?: 'PlotCommodityType', variety: { __typename?: 'CommodityVarietyType', id: string, name: string }, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, address?: { __typename?: 'AddressType', id: string, address?: string | null } | null } } } } }> } } | null };

export type GatepassSelectorQueryVariables = Exact<{
  productionItemId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productionLineId?: InputMaybe<Scalars['ID']>;
  productionId?: InputMaybe<Scalars['ID']>;
}>;


export type GatepassSelectorQuery = { __typename?: 'QueryRoot', gatepassSelector?: Array<{ __typename?: 'PackingAllotmentSelectorType', id: string, createdAt: any, allotedQuantity: number, allotedWeight: number, consumedWeight: number, rejectedWeight: number, rejectedQuantity: number, selected?: boolean | null, inwardAllocation: { __typename?: 'InwardAllocationType', id: string, inward: { __typename?: 'InwardType', id: string, booking: { __typename?: 'BookingType', schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, referenceId: string, parentVariety?: { __typename?: 'CommodityVarietyType', id: string, name: string } | null }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, registrationCode: string }, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, address?: { __typename?: 'AddressType', id: string, address?: string | null } | null } } } } } } } | null> | null };

export type RestockProductionMutationVariables = Exact<{
  input: RestockProductionInput;
}>;


export type RestockProductionMutation = { __typename?: 'MutationRoot', restockProduction?: { __typename?: 'RestockProduction', ok?: boolean | null, message?: string | null } | null };

export type AddRemarkProductionItemMutationVariables = Exact<{
  input: AddRemarkProductionItemInput;
}>;


export type AddRemarkProductionItemMutation = { __typename?: 'MutationRoot', addRemarkProductionItem?: { __typename?: 'AddRemarkProductionItem', ok?: boolean | null, message?: string | null } | null };

export type AddBulkApproveTradeProfileMutationVariables = Exact<{
  input: BulkApproveTradeProfilesInput;
}>;


export type AddBulkApproveTradeProfileMutation = { __typename?: 'MutationRoot', addBulkApproveTradeProfile?: { __typename?: 'BulkApproveTradeProfilesPayload', ok?: boolean | null, error?: string | null } | null };

export type CreateUpdateSalesOrderMutationVariables = Exact<{
  input: ShipmentPlanInput;
}>;


export type CreateUpdateSalesOrderMutation = { __typename?: 'MutationRoot', createUpdateShipmentPlan?: { __typename?: 'CreateUpdateShipmentPlan', success?: boolean | null, message?: string | null } | null };

export type ShipmentPlansQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  portId?: InputMaybe<Scalars['ID']>;
  soNoContains?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  varietyId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  toDate?: InputMaybe<Scalars['Date']>;
  productionStatus?: InputMaybe<Scalars['String']>;
}>;


export type ShipmentPlansQuery = { __typename?: 'QueryRoot', shipmentPlans?: { __typename?: 'ShipmentPlanList', results?: Array<{ __typename?: 'ShipmentPlanType', id: string, createdAt: any, productionCreated?: boolean | null, productionItemsCount?: number | null, productionStatus?: string | null, weeklySrNo: string, soNo: string, metadata: any, skuFilled: number, labels?: string | null, varietyType: ShipmentPlanVarietyType, production?: { __typename?: 'ProductionType', id: string, weeklySrNo: string, sendForApproval: boolean, metadata: any, productionitemSet: Array<{ __typename?: 'ProductionItemType', id: string, boxCount: number, linepackingallotmentSet: Array<{ __typename?: 'LinePackingAllotmentType', id: string }> }> } | null, colourGroup?: { __typename?: 'ColorGroupType', id: string, name: string } | null, exportCustomer: { __typename?: 'ExportCustomerType', id: string, name: string }, varieties: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string }>, skuType: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number }, primaryPackMaterial?: { __typename?: 'SKUPackingMaterialType', id: string, name: string } | null, secondaryPackMaterial?: { __typename?: 'SKUPackingMaterialType', id: string, name: string } | null, approvedtradeprofileSet: Array<{ __typename?: 'ApprovedTradeProfileType', id: string, availableYield: number, boxCount?: number | null, tradeProfile: { __typename?: 'TradeProfileType', id: string, certificateNumber?: string | null } }> } | null> | null } | null };

export type MatchProfilesByCustIdQueryVariables = Exact<{
  custId?: InputMaybe<Scalars['ID']>;
  shipmentPlanId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type MatchProfilesByCustIdQuery = { __typename?: 'QueryRoot', matchProfilesByCustId?: Array<{ __typename: 'TradeProfileType', id: string, certificateNumber?: string | null, reason?: string | null, color?: string | null, plotYeild: number, area: number, availableYield: number, extraPlotYeild?: number | null, extraAvailableYield?: number | null, plotCommodity: { __typename: 'PlotCommodityType', id: string, name: string, variety: { __typename: 'CommodityVarietyType', id: string, name: string }, plot: { __typename: 'PlotType', farmer: { __typename: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, address: { __typename: 'AddressType', id: string, village: string, taluka?: string | null, state?: string | null } }, lastSample?: { __typename: 'PlotCommoditySampleType', id: string, detectionCount: number, maxDetection: number, totalDetection: number, created: any, observations?: Array<{ __typename?: 'PlotCommoditySampleObservationType', id: string, tags?: Array<string | null> | null, detectionCount?: number | null, qualityParameter: { __typename?: 'QualityParameterType', id: string, name: string } } | null> | null } | null, samples?: Array<{ __typename: 'PlotCommoditySampleType', id: string, detectionCount: number, maxDetection: number, totalDetection: number } | null> | null }, exportCustomers: Array<{ __typename: 'ExportCustomerType', id: string, name: string }> } | null> | null };

export type ShipmentPlanBySoNoQueryVariables = Exact<{
  soNo: Scalars['ID'];
}>;


export type ShipmentPlanBySoNoQuery = { __typename?: 'QueryRoot', shipmentPlanById?: { __typename?: 'ShipmentPlanType', createdAt: any, updatedAt: any, id: string, weeklySrNo: string, soNo: string, invoiceNo?: string | null, specification?: string | null, labels?: string | null, gtin?: string | null, eta?: string | null, etd?: string | null, remark?: string | null, varietyType: ShipmentPlanVarietyType, saleType: string, metadata: any, skuFilled: number, port?: { __typename?: 'PortType', isActive: boolean, id: string, name: string } | null, exportCustomer: { __typename?: 'ExportCustomerType', isActive: boolean, id: string, name: string }, skuType: { __typename?: 'SKUGraphType', id: string, name: string, codename: any }, colourGroup?: { __typename?: 'ColorGroupType', id: string, name: string, codename: string } | null, varieties: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string }>, primaryPackMaterial?: { __typename?: 'SKUPackingMaterialType', id: string, name: string, codename: string } | null, secondaryPackMaterial?: { __typename?: 'SKUPackingMaterialType', id: string, name: string, codename: string } | null, approvedtradeprofileSet: Array<{ __typename?: 'ApprovedTradeProfileType', id: string, boxCount?: number | null }>, productionSet: Array<{ __typename?: 'ProductionType', id: string, productionLine: { __typename?: 'ProductionLineType', id: string, name: string } }> } | null };

export type AllProductionBatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  varietyId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
}>;


export type AllProductionBatchesQuery = { __typename?: 'QueryRoot', allProductionBatches?: Array<{ __typename?: 'ProductionBatchType', id: string, name: string, codename: string, description: string, date: any, isActive: boolean, variety: { __typename?: 'CommodityVarietyType', id: string, name: string } } | null> | null };

export type QualityBaseFragFragment = { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus };

export type ReportTemplateListFragFragment = { __typename?: 'ReportTemplateType', id: string, name: string, title: string, createdAt: any, emailTo?: Array<string | null> | null, recommendedEmails?: Array<string | null> | null, latestDelivery?: { __typename?: 'ReportExportLogType', id: string, createdAt: any, isDelivered: boolean } | null, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, source: { __typename?: 'ReportType', id: string, alias: string, filters: Array<{ __typename?: 'ReportItemType', id: string, alias: string, fieldType: ReportItemFieldType, isRangeValue: boolean, referenceQuery: string }> }, groupsShared: Array<{ __typename?: 'GroupType', id: string, name: string }> };

export type ReportTemplateDetailFragFragment = { __typename?: 'ReportTemplateType', id: string, name: string, title: string, createdAt: any, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, columns: Array<{ __typename?: 'ReportTemplateItemType', id: string, aggregateType: ReportTemplateItemAggregateType, reportItem: { __typename?: 'ReportItemType', id: string, alias: string, fieldType: ReportItemFieldType } }>, source: { __typename?: 'ReportType', id: string, alias: string, groupings: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, columns: Array<{ __typename?: 'ReportItemType', id: string, alias: string }> }, groupBy: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, usersShared: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }>, groupsShared: Array<{ __typename?: 'GroupType', id: string, name: string }> };

export type CreateUpdateReportTemplateMutationVariables = Exact<{
  columns?: InputMaybe<Array<InputMaybe<ReportTemplateColumn>> | InputMaybe<ReportTemplateColumn>>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  groupsShared?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  sourceId: Scalars['ID'];
  title: Scalars['String'];
  usersShared?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateUpdateReportTemplateMutation = { __typename?: 'MutationRoot', addUpdateReportTemplate?: { __typename?: 'AddUpdateReportTemplate', reportTemplate?: { __typename?: 'ReportTemplateType', id: string, name: string, title: string, createdAt: any, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, columns: Array<{ __typename?: 'ReportTemplateItemType', id: string, aggregateType: ReportTemplateItemAggregateType, reportItem: { __typename?: 'ReportItemType', id: string, alias: string, fieldType: ReportItemFieldType } }>, source: { __typename?: 'ReportType', id: string, alias: string, groupings: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, columns: Array<{ __typename?: 'ReportItemType', id: string, alias: string }> }, groupBy: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, usersShared: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }>, groupsShared: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null } | null };

export type MyReportsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type MyReportsQuery = { __typename?: 'QueryRoot', myReportTemplates?: Array<{ __typename?: 'ReportTemplateType', id: string, name: string, title: string, createdAt: any, emailTo?: Array<string | null> | null, recommendedEmails?: Array<string | null> | null, latestDelivery?: { __typename?: 'ReportExportLogType', id: string, createdAt: any, isDelivered: boolean } | null, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, source: { __typename?: 'ReportType', id: string, alias: string, filters: Array<{ __typename?: 'ReportItemType', id: string, alias: string, fieldType: ReportItemFieldType, isRangeValue: boolean, referenceQuery: string }> }, groupsShared: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null> | null };

export type ReportMasterListQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportMasterListQuery = { __typename?: 'QueryRoot', allReportMasters?: Array<{ __typename?: 'ReportType', id: string, alias: string, groupings: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, columns: Array<{ __typename?: 'ReportItemType', id: string, fieldType: ReportItemFieldType, alias: string }> } | null> | null };

export type ReportTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportTemplateQuery = { __typename?: 'QueryRoot', reportTemplateDetail?: { __typename?: 'ReportTemplateType', id: string, name: string, title: string, createdAt: any, createdBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, columns: Array<{ __typename?: 'ReportTemplateItemType', id: string, aggregateType: ReportTemplateItemAggregateType, reportItem: { __typename?: 'ReportItemType', id: string, alias: string, fieldType: ReportItemFieldType } }>, source: { __typename?: 'ReportType', id: string, alias: string, groupings: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, columns: Array<{ __typename?: 'ReportItemType', id: string, alias: string }> }, groupBy: Array<{ __typename?: 'ReportItemType', id: string, name: string }>, usersShared: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }>, groupsShared: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null };

export type ExportReportFilterQueryVariables = Exact<{
  templateId: Scalars['ID'];
  filters?: InputMaybe<Array<InputMaybe<ReportTemplateFilter>> | InputMaybe<ReportTemplateFilter>>;
  emailTo?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ExportReportFilterQuery = { __typename?: 'QueryRoot', exportReport?: { __typename?: 'ReportTemplateType', exportLogs: Array<{ __typename?: 'ReportExportLogType', id: string }> } | null };

export type CreateOrUpdateRouteMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  colorCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  points?: InputMaybe<Array<InputMaybe<RoutePointInput>> | InputMaybe<RoutePointInput>>;
  surveyAreaId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateOrUpdateRouteMutation = { __typename?: 'MutationRoot', addUpdateRoute?: { __typename?: 'AddUpdateRouteMutation', route?: { __typename?: 'RouteType', id: string, isActive: boolean, colorCode: string, name: string, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null }, points: Array<{ __typename?: 'RoutePointType', id: string, visitee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus, address?: { __typename?: 'AddressType', id: string, village: string, latitude: number, longitude: number } | null } }> } | null } | null };

export type CreateUpdateRouteAssignmentMutationVariables = Exact<{
  assigneeId?: InputMaybe<Scalars['ID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['ID']>;
  points?: InputMaybe<Array<InputMaybe<RoutePointInput>> | InputMaybe<RoutePointInput>>;
  recurrences?: InputMaybe<Scalars['String']>;
  routeId?: InputMaybe<Scalars['ID']>;
  shouldTrack?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  startTime?: InputMaybe<Scalars['Time']>;
}>;


export type CreateUpdateRouteAssignmentMutation = { __typename?: 'MutationRoot', addUpdateRouteAssignment?: { __typename?: 'AddUpdateRouteAssignmentMutation', routeAssignment?: { __typename?: 'RouteAssignmentType', id: string, rrules: any, startDate: any, startTime: any, endTime: any, shouldTrack: boolean, route: { __typename?: 'RouteType', id: string, name: string }, assignee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } | null } | null };

export type ShiftBeatMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  excludeDate?: InputMaybe<Scalars['Date']>;
  includeDate?: InputMaybe<Scalars['Date']>;
}>;


export type ShiftBeatMutation = { __typename?: 'MutationRoot', replaceRrule?: { __typename?: 'ReplaceRruleMutation', routeAssignment?: { __typename?: 'RouteAssignmentType', id: string, rrules: any } | null } | null };

export type AddUpdateBeatRemarkMutationVariables = Exact<{
  assignmentId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
}>;


export type AddUpdateBeatRemarkMutation = { __typename?: 'MutationRoot', addUpdateSupBeat?: { __typename?: 'AddUpdateSupBeatMutation', beat?: { __typename?: 'SupBeatType', id: string, remark?: string | null, date: any, assignment: { __typename?: 'RouteAssignmentType', id: string } } | null } | null };

export type AllRoutesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RouteInput>;
}>;


export type AllRoutesQuery = { __typename?: 'QueryRoot', allRoutes?: Array<{ __typename?: 'RouteType', id: string, name: string, createdAt: any, isActive: boolean, colorCode: string, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null }, points: Array<{ __typename?: 'RoutePointType', id: string, visitee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } }> } | null> | null };

export type RouteDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RouteDetailQuery = { __typename?: 'QueryRoot', routeDetail?: { __typename?: 'RouteType', id: string, isActive: boolean, colorCode: string, name: string, category: { __typename?: 'RouteCategoryType', id: string, name: string }, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null }, points: Array<{ __typename?: 'RoutePointType', id: string, sequence: string, visitee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus, routepoints: Array<{ __typename?: 'RoutePointType', id: string, route: { __typename?: 'RouteType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, latitude: number, longitude: number } | null } }> } | null };

export type SurveyAreaVendorsQueryVariables = Exact<{
  surveyAreaId: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type SurveyAreaVendorsQuery = { __typename?: 'QueryRoot', allVendorsBySurveyAreas?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string, status: BaseUserStatus, routepoints: Array<{ __typename?: 'RoutePointType', id: string, route: { __typename?: 'RouteType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, latitude: number, longitude: number } | null } | null> | null };

export type RouteAssignmentDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RouteAssignmentDetailQuery = { __typename?: 'QueryRoot', routeAssignmentDetail?: { __typename?: 'RouteAssignmentType', id: string, rrules: any, startDate: any, endTime: any, startTime: any, shouldTrack: boolean, assignee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, isStaff: boolean }, assignedRoutePoints: Array<{ __typename?: 'AssignedRoutePointType', id: string, sequence: string, visitee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, latitude: number, longitude: number } | null } }>, route: { __typename?: 'RouteType', id: string, name: string, colorCode: string, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null }, points: Array<{ __typename?: 'RoutePointType', id: string, sequence: string, visitee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, latitude: number, longitude: number } | null } }> } } | null };

export type RouteAssignmentReccurencesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RouteAssignmentFilterInput>;
  start?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
}>;


export type RouteAssignmentReccurencesQuery = { __typename?: 'QueryRoot', allRouteAssignments?: Array<{ __typename?: 'RouteAssignmentType', id: string, rrules: any, recurrences?: Array<string | null> | null, route: { __typename?: 'RouteType', id: string, name: string }, assignee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } } | null> | null };

export type RoutePolylineQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RoutePolylineQuery = { __typename?: 'QueryRoot', routeDetail?: { __typename?: 'RouteType', id: string, colorCode: string, polyline?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null } | null };

export type AllBeatsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type AllBeatsQuery = { __typename?: 'QueryRoot', allBeats?: Array<{ __typename?: 'SupBeatType', id: string, status?: Status | null, startTime?: any | null, endTime?: any | null, assignee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, assignment: { __typename?: 'RouteAssignmentType', id: string, beatVisitCount?: number | null, assignedRoutePointCount?: number | null, route: { __typename?: 'RouteType', id: string, name: string, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null } } }, summary?: { __typename?: 'SuperviseSummaryType', placedOrderCount: number, secondarySales: number, dropSize: number, durationAvg?: { __typename?: 'DurationType', seconds?: number | null, hours?: number | null, minutes?: number | null } | null } | null } | null> | null };

export type BeatDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BeatDetailQuery = { __typename?: 'QueryRoot', beatDetail?: { __typename?: 'SupBeatType', id: string, status?: Status | null, date: any, remark?: string | null, summary?: { __typename?: 'SuperviseSummaryType', durationAvg?: { __typename?: 'DurationType', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null, assignee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, referenceId: string, number: string }, assignment: { __typename?: 'RouteAssignmentType', id: string, polyline?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null, route: { __typename?: 'RouteType', id: string, name: string, colorCode: string, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null } }, assignedRoutePoints: Array<{ __typename?: 'AssignedRoutePointType', id: string, sequence: string, visitee: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, status: BaseUserStatus, number: string, address?: { __typename?: 'AddressType', id: string, address?: string | null, latitude: number, longitude: number } | null }, visitByBeat?: { __typename?: 'BeatVisitType', id: string, endTime?: any | null, duration?: { __typename?: 'DurationType', hours?: number | null, minutes?: number | null, seconds?: number | null } | null } | null }> } } | null };

export type BeatVisitDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BeatVisitDetailQuery = { __typename?: 'QueryRoot', beatVisitDetail?: { __typename?: 'BeatVisitType', id: string, remark?: string | null, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, actions: Array<{ __typename?: 'BeatVisitActionType', id: string, action: string, actionDetails: any }> } | null };

export type ScheduleSkuFragFragment = { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } };

export type ScheduleVehicleFragFragment = { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, capacity: number }, depot?: { __typename?: 'DepotType', id: string, name: string } | null };

export type GradePriceFragFragment = { __typename?: 'GradePriceType', id: string, price?: number | null, priceUnit: { __typename?: 'SKUGraphType', id: string, name: string }, grade: { __typename?: 'HarvestGradeType', id: string, name: string } };

export type TransportDetailFragFragment = { __typename?: 'VehicleTransportDetailType', id: string, farmWeight?: number | null, acceptedDeduction: number, standardDeduction: number, deductionRate: number, weightApplicable: VehicleTransportDetailWeightApplicable, transportPaidBy: VehicleTransportDetailTransportPaidBy, transportCost: number, advancePaidBy: VehicleTransportDetailAdvancePaidBy, advanceCost: number, rejectionBourneBy: VehicleTransportDetailRejectionBourneBy, remark?: string | null, pricingDoneOn?: string | null, gradePrices?: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string } } | null> | null };

export type PackagingMaterialItemsFragFragment = { __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null };

export type PackagingMaterialFragFragment = { __typename?: 'PackagingMaterialType', id: string, sendWhatsappApproval: boolean, weightSlip: number, wasteageWt: number, leafWt: number, stickWt: number, deductionWt: number, totalHarvestWt: number, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null } | null> | null };

export type ScheduleListFragFragment = { __typename?: 'ScheduleType', id: string, updated: any, gatePass: string, estimatedQuantity: number, requiredQuantity: number, farmWeight: number, labourCount: number, isNotified: boolean, isEdited: boolean, timeToLeave: any, timeToReach: any, remark: string, transportServiceProvider?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, referenceId: string } | null, scheduledIn?: { __typename?: 'DepartmentType', id: string, name: string, packagingMaterialFlow: boolean } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, sendWhatsappApproval: boolean, weightSlip: number, wasteageWt: number, leafWt: number, stickWt: number, deductionWt: number, totalHarvestWt: number, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null } | null> | null } | null, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string } }>, booking?: { __typename?: 'BookingType', inwards: Array<{ __typename?: 'InwardType', status: InwardStatus }> } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, displayName: string, codename: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, isFinishedGood: boolean, isRawMaterial: boolean, name: string } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, groups: Array<{ __typename?: 'CommodityGroupType', id: string, name: string, isFinishedGood: boolean, isRawMaterial: boolean, codename: string }>, preferredSku?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string } } | null, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string, registrationCode: string, generatePoPlotWise: boolean, isFinishedGood: boolean, isRawMaterial: boolean, alternateCropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string } | null }, plot: { __typename?: 'PlotType', id: string, name: string, company?: { __typename?: 'CompanyType', id: string } | null, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, firstName: string, lastName: string, companies: Array<{ __typename?: 'CompanyType', id: string }> }, certifications: Array<{ __typename?: 'PlotCertificationType', id: string, certificationNumber: string, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string } }>, address: { __typename?: 'AddressType', id: string, village: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, firstName: string, lastName: string } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string } | null };

export type NewScheduleMutationMutationVariables = Exact<{
  date: Scalars['Date'];
  plotCommodityRequirements?: InputMaybe<Array<PlotCommodityRequirementInput> | PlotCommodityRequirementInput>;
}>;


export type NewScheduleMutationMutation = { __typename?: 'MutationRoot', newSchedule?: { __typename?: 'AddNewScheduleMutation', schedules?: Array<{ __typename?: 'ScheduleType', id: string, updated: any, gatePass: string, estimatedQuantity: number, requiredQuantity: number, farmWeight: number, labourCount: number, isNotified: boolean, isEdited: boolean, timeToLeave: any, timeToReach: any, remark: string, transportServiceProvider?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, referenceId: string } | null, scheduledIn?: { __typename?: 'DepartmentType', id: string, name: string, packagingMaterialFlow: boolean } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, sendWhatsappApproval: boolean, weightSlip: number, wasteageWt: number, leafWt: number, stickWt: number, deductionWt: number, totalHarvestWt: number, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null } | null> | null } | null, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string } }>, booking?: { __typename?: 'BookingType', inwards: Array<{ __typename?: 'InwardType', status: InwardStatus }> } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, displayName: string, codename: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, isFinishedGood: boolean, isRawMaterial: boolean, name: string } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, groups: Array<{ __typename?: 'CommodityGroupType', id: string, name: string, isFinishedGood: boolean, isRawMaterial: boolean, codename: string }>, preferredSku?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string } } | null, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string, registrationCode: string, generatePoPlotWise: boolean, isFinishedGood: boolean, isRawMaterial: boolean, alternateCropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string } | null }, plot: { __typename?: 'PlotType', id: string, name: string, company?: { __typename?: 'CompanyType', id: string } | null, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, firstName: string, lastName: string, companies: Array<{ __typename?: 'CompanyType', id: string }> }, certifications: Array<{ __typename?: 'PlotCertificationType', id: string, certificationNumber: string, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string } }>, address: { __typename?: 'AddressType', id: string, village: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, firstName: string, lastName: string } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string } | null } | null> | null } | null };

export type DeleteScheduleMutationMutationVariables = Exact<{
  schedules?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type DeleteScheduleMutationMutation = { __typename?: 'MutationRoot', delSchedules?: { __typename?: 'DelScheduleMutation', schedules?: Array<number | null> | null } | null };

export type UpdateScheduleMutationMutationVariables = Exact<{
  schedules?: InputMaybe<Array<UpdateScheduleRowInput> | UpdateScheduleRowInput>;
}>;


export type UpdateScheduleMutationMutation = { __typename?: 'MutationRoot', updateSchedule?: { __typename?: 'UpdateScheduleMutation', schedules?: Array<{ __typename?: 'ScheduleType', id: string, updated: any, gatePass: string, estimatedQuantity: number, requiredQuantity: number, farmWeight: number, labourCount: number, isNotified: boolean, isEdited: boolean, timeToLeave: any, timeToReach: any, remark: string, transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, farmWeight?: number | null, acceptedDeduction: number, standardDeduction: number, deductionRate: number, weightApplicable: VehicleTransportDetailWeightApplicable, transportPaidBy: VehicleTransportDetailTransportPaidBy, transportCost: number, advancePaidBy: VehicleTransportDetailAdvancePaidBy, advanceCost: number, rejectionBourneBy: VehicleTransportDetailRejectionBourneBy, remark?: string | null, pricingDoneOn?: string | null, gradePrices?: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string } } | null> | null } | null, transportServiceProvider?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, referenceId: string } | null, scheduledIn?: { __typename?: 'DepartmentType', id: string, name: string, packagingMaterialFlow: boolean } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, sendWhatsappApproval: boolean, weightSlip: number, wasteageWt: number, leafWt: number, stickWt: number, deductionWt: number, totalHarvestWt: number, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null } | null> | null } | null, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string } }>, booking?: { __typename?: 'BookingType', inwards: Array<{ __typename?: 'InwardType', status: InwardStatus }> } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, displayName: string, codename: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, isFinishedGood: boolean, isRawMaterial: boolean, name: string } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, groups: Array<{ __typename?: 'CommodityGroupType', id: string, name: string, isFinishedGood: boolean, isRawMaterial: boolean, codename: string }>, preferredSku?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string } } | null, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string, registrationCode: string, generatePoPlotWise: boolean, isFinishedGood: boolean, isRawMaterial: boolean, alternateCropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string } | null }, plot: { __typename?: 'PlotType', id: string, name: string, company?: { __typename?: 'CompanyType', id: string } | null, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, firstName: string, lastName: string, companies: Array<{ __typename?: 'CompanyType', id: string }> }, certifications: Array<{ __typename?: 'PlotCertificationType', id: string, certificationNumber: string, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string } }>, address: { __typename?: 'AddressType', id: string, village: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, firstName: string, lastName: string } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string } | null } | null> | null } | null };

export type AddTransportDetailMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  schedule: Scalars['Int'];
  advanceCost?: InputMaybe<Scalars['Float']>;
  advancePaidBy?: InputMaybe<Scalars['String']>;
  transportCost?: InputMaybe<Scalars['Float']>;
  transportPaidBy?: InputMaybe<Scalars['String']>;
  rejectionBourneBy?: InputMaybe<Scalars['String']>;
  weightApplicable?: InputMaybe<Scalars['String']>;
  acceptedDeduction?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  pricingDoneOn?: InputMaybe<Scalars['String']>;
  standardDeduction: Scalars['Float'];
  gradePrices?: InputMaybe<Array<InputMaybe<GradePriceInput>> | InputMaybe<GradePriceInput>>;
}>;


export type AddTransportDetailMutationMutation = { __typename?: 'MutationRoot', addTransportDetail?: { __typename?: 'AddUpdateScheduleTransportMutation', detail?: { __typename?: 'VehicleTransportDetailType', id: string, farmWeight?: number | null, acceptedDeduction: number, standardDeduction: number, deductionRate: number, weightApplicable: VehicleTransportDetailWeightApplicable, transportPaidBy: VehicleTransportDetailTransportPaidBy, transportCost: number, advancePaidBy: VehicleTransportDetailAdvancePaidBy, advanceCost: number, rejectionBourneBy: VehicleTransportDetailRejectionBourneBy, remark?: string | null, pricingDoneOn?: string | null, gradePrices?: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string } } | null> | null } | null } | null };

export type GenerateTripMutationMutationVariables = Exact<{
  date: Scalars['Date'];
  schedules?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  schedulesProcured?: InputMaybe<Array<InputMaybe<SchedulesProcuredInput>> | InputMaybe<SchedulesProcuredInput>>;
}>;


export type GenerateTripMutationMutation = { __typename?: 'MutationRoot', generateTrip?: { __typename?: 'GenerateTripMutation', trips?: Array<{ __typename?: 'TripType', id: string, bookings: Array<{ __typename?: 'BookingType', id: string, schedule: { __typename?: 'ScheduleType', id: string, isNotified: boolean } }> } | null> | null } | null };

export type MigratePlotMutationMutationVariables = Exact<{
  fromDate: Scalars['Date'];
  toDate: Scalars['Date'];
  plot: Scalars['Int'];
}>;


export type MigratePlotMutationMutation = { __typename?: 'MutationRoot', migratePlot?: { __typename?: 'MigratePlotMutation', schedules?: Array<{ __typename?: 'ScheduleType', id: string, date: any } | null> | null } | null };

export type DelPlotSchedulesMutationMutationVariables = Exact<{
  date: Scalars['Date'];
  plotCommodityId: Scalars['Int'];
}>;


export type DelPlotSchedulesMutationMutation = { __typename?: 'MutationRoot', delPlotSchedules?: { __typename?: 'DelPlotSchedulesMutation', plotCommodityId?: number | null } | null };

export type AddUpdatePackagingMaterialMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  pmSupervisorId?: InputMaybe<Scalars['Int']>;
  areaInchargeId?: InputMaybe<Scalars['Int']>;
  fieldSupervisorId?: InputMaybe<Scalars['Int']>;
  packagingMaterialItems?: InputMaybe<Array<InputMaybe<PackagingMaterialItemInput>> | InputMaybe<PackagingMaterialItemInput>>;
}>;


export type AddUpdatePackagingMaterialMutationMutation = { __typename?: 'MutationRoot', addUpdatePackagingMaterial?: { __typename?: 'AddUpdatePackagingMaterialMutation', packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, sendWhatsappApproval: boolean, weightSlip: number, wasteageWt: number, leafWt: number, stickWt: number, deductionWt: number, totalHarvestWt: number, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null } | null> | null } | null } | null };

export type SendPackagingMaterialWhatsappApprovalMutationMutationVariables = Exact<{
  departmentId?: InputMaybe<Scalars['Int']>;
  packagingMaterialId?: InputMaybe<Scalars['Int']>;
}>;


export type SendPackagingMaterialWhatsappApprovalMutationMutation = { __typename?: 'MutationRoot', sendPackagingMaterialWhatsappApproval?: { __typename?: 'SendPackagingMaterialWhatsappApprovalMutation', success?: boolean | null } | null };

export type ScheduleListQueryVariables = Exact<{
  date: Scalars['Date'];
  filter?: InputMaybe<ScheduleFilterInput>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ScheduleListQuery = { __typename?: 'QueryRoot', schedulesForDate?: Array<{ __typename?: 'ScheduleType', id: string, updated: any, gatePass: string, estimatedQuantity: number, requiredQuantity: number, farmWeight: number, labourCount: number, isNotified: boolean, isEdited: boolean, timeToLeave: any, timeToReach: any, remark: string, transportServiceProvider?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, referenceId: string } | null, scheduledIn?: { __typename?: 'DepartmentType', id: string, name: string, packagingMaterialFlow: boolean } | null, packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, sendWhatsappApproval: boolean, weightSlip: number, wasteageWt: number, leafWt: number, stickWt: number, deductionWt: number, totalHarvestWt: number, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, whatsappApproval?: boolean | null, quantity?: number | null, receivedQuantity?: number | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, unitPrice: number, selfWeight: number } | null } | null> | null } | null, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string } }>, booking?: { __typename?: 'BookingType', inwards: Array<{ __typename?: 'InwardType', status: InwardStatus }> } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string } | null, company?: { __typename?: 'CompanyType', id: string, name: string, displayName: string, codename: string } | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null, farmQuantityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, cropGroup?: { __typename?: 'CommodityGroupType', id: string, isFinishedGood: boolean, isRawMaterial: boolean, name: string } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, packagingMaterialFlow: boolean, groups: Array<{ __typename?: 'CommodityGroupType', id: string, name: string, isFinishedGood: boolean, isRawMaterial: boolean, codename: string }>, preferredSku?: { __typename?: 'SKUGraphType', id: string, name: string, capacity: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string } } | null, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string, registrationCode: string, generatePoPlotWise: boolean, isFinishedGood: boolean, isRawMaterial: boolean, alternateCropGroup?: { __typename?: 'CommodityGroupType', id: string, name: string } | null }, plot: { __typename?: 'PlotType', id: string, name: string, company?: { __typename?: 'CompanyType', id: string } | null, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, firstName: string, lastName: string, companies: Array<{ __typename?: 'CompanyType', id: string }> }, certifications: Array<{ __typename?: 'PlotCertificationType', id: string, certificationNumber: string, certificationType: { __typename?: 'CertificationGraphType', id: string, name: string } }>, address: { __typename?: 'AddressType', id: string, village: string } }, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, firstName: string, lastName: string } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string } | null } | null> | null };

export type PlotSchedulesQueryVariables = Exact<{
  plotId: Scalars['Int'];
}>;


export type PlotSchedulesQuery = { __typename?: 'QueryRoot', schedulesForPlot?: Array<{ __typename?: 'ScheduleType', id: string, date: any, gatePass: string, labourCount: number, requiredQuantity: number, transportServiceProvider?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, aggregator?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, plot: { __typename?: 'PlotType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string } }, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string } | null } | null> | null };

export type ScheduleTransportDetailQueryVariables = Exact<{
  schedule: Scalars['Int'];
}>;


export type ScheduleTransportDetailQuery = { __typename?: 'QueryRoot', transportDetail?: { __typename?: 'VehicleTransportDetailType', id: string, farmWeight?: number | null, acceptedDeduction: number, standardDeduction: number, deductionRate: number, weightApplicable: VehicleTransportDetailWeightApplicable, transportPaidBy: VehicleTransportDetailTransportPaidBy, transportCost: number, advancePaidBy: VehicleTransportDetailAdvancePaidBy, advanceCost: number, rejectionBourneBy: VehicleTransportDetailRejectionBourneBy, remark?: string | null, pricingDoneOn?: string | null, gradePrices?: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null, grade: { __typename?: 'HarvestGradeType', id: string, name: string } } | null> | null } | null };

export type AllAgregatorsSelectorQueryVariables = Exact<{
  department?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllAgregatorsSelectorQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, number: string, fullName?: string | null, schedulesForDate?: Array<{ __typename?: 'ScheduleType', id: string, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string } } | null> | null } | null> | null };

export type AllTransportServiceProvidersSelectorQueryVariables = Exact<{
  department?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllTransportServiceProvidersSelectorQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, number: string, fullName?: string | null, schedulesForDate?: Array<{ __typename?: 'ScheduleType', id: string, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string } } | null> | null } | null> | null };

export type ScheduleListSummaryQueryVariables = Exact<{
  date: Scalars['Date'];
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ScheduleFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ScheduleListSummaryQuery = { __typename?: 'QueryRoot', schedulesForDateSummary?: { __typename?: 'ScheduleForDateSummary', plots?: number | null, labours?: number | null, count?: number | null, vehicles?: number | null, totalSkuCount?: number | null, totalUomQuantity?: number | null, aggregators?: number | null, transportServiceProviders?: number | null } | null };

export type ShedulingVehiclesQueryVariables = Exact<{
  date: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type ShedulingVehiclesQuery = { __typename?: 'QueryRoot', allVehicles?: Array<{ __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null }, schedulesForDate?: Array<{ __typename?: 'ScheduleType', id: string, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string } } | null> | null } | null> | null };

export type PreTripGenerateQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']>;
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type PreTripGenerateQuery = { __typename?: 'QueryRoot', preTripGenerate?: Array<{ __typename?: 'TripSummaryType', vehicleNo?: string | null, bookingCount?: number | null, suppliers?: Array<{ __typename?: 'TripSummarySupplierType', name?: string | null, village?: string | null, crop?: string | null, sku?: string | null, skuCount?: number | null } | null> | null } | null> | null };

export type PackagingMaterialQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PackagingMaterialQueryQuery = { __typename?: 'QueryRoot', packagingMaterial?: { __typename?: 'PackagingMaterialType', id: string, createdAt: any, supplierType?: PackagingMaterialSupplierType | null, finalWt?: number | null, leafWt: number, fruitNetWt?: number | null, totalReceivedTareWt?: number | null, weightSlip: number, wasteageWt: number, totalDispatchedBoxWt?: number | null, fruitWt: number, fruitAmt?: number | null, wastageAmt?: number | null, stickAmt?: number | null, deductionAmt?: number | null, fruitAndWastageWt?: number | null, stickWtPercent: number, stickWt: number, totalHarvestWt: number, deductionWt: number, deductionWtPercent: number, totalHarvestQuantity?: number | null, totalHarvestedBoxWt?: number | null, totalQuantity?: number | null, totalReceivedQuantity?: number | null, netWeightAfterDeduction?: number | null, remark?: string | null, totalAmt?: number | null, avgRate?: number | null, finalAmt?: number | null, schedule?: { __typename?: 'ScheduleType', gatePass: string, booking?: { __typename?: 'BookingType', id: string, status: BookingStatus } | null, vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string } | null, gradePrices: Array<{ __typename?: 'GradePriceType', id: string, price?: number | null }> } | null, fieldSupervisorName?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, fullName?: string | null } | null, pmSupervisorName?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, fullName?: string | null } | null, areaInchargeName?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, fullName?: string | null } | null, plotVisitorName?: { __typename?: 'DeliveryAgentManagementType', id: string, firstName: string, lastName: string, fullName?: string | null } | null, packagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', id?: string | null, dispatchedBoxCount?: number | null, harvestedBoxCount?: number | null, receivedQuantity?: number | null, mismatchBoxCount?: number | null, recievedTareWt?: number | null, harvestedGrossWt?: number | null, harvestedNetWt?: number | null, remark?: string | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, selfWeight: number, capacity: number } | null } | null> | null, combinedPackagingMaterialItems?: Array<{ __typename?: 'PackagingMaterialItemType', whatsappApproval?: boolean | null, dispatchedBoxCount?: number | null, dispatchedBoxWt?: number | null, harvestedBoxCount?: number | null, harvestedBoxWt?: number | null, remark?: string | null, fourHand?: number | null, fiveHand?: number | null, sixHand?: number | null, sevenEightHand?: number | null, cluster?: number | null, skuType?: { __typename?: 'SKUGraphType', id: string, name: string, selfWeight: number } | null } | null> | null, attachments: Array<{ __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }> } | null };

export type AllDepartmentSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepartmentSelectorQuery = { __typename?: 'QueryRoot', allDepartments?: Array<{ __typename?: 'DepartmentType', id: string, name: string, departmentType: DepartmentDepartmentType } | null> | null };

export type AllGroupsSelectorQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AllGroupsFilterInput>;
}>;


export type AllGroupsSelectorQuery = { __typename?: 'QueryRoot', allGroups?: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, name: string, codename: string } | null } | null> | null };

export type AllVarietyGroupsSelectorQueryVariables = Exact<{
  departmentId?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type AllVarietyGroupsSelectorQuery = { __typename?: 'QueryRoot', allVarietyGroups?: Array<{ __typename?: 'CommodityGroupType', id: string, name: string, codename: string } | null> | null };

export type AllPermissionsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPermissionsSelectorQuery = { __typename?: 'QueryRoot', allPermissions?: Array<{ __typename?: 'PermissionType', id: string, name: string } | null> | null };

export type AllVarietiesSelectorQueryVariables = Exact<{
  includeCommodity: Scalars['Boolean'];
}>;


export type AllVarietiesSelectorQuery = { __typename?: 'QueryRoot', allVarieties?: Array<{ __typename?: 'CommodityVarietyType', id: string, name: string, commodity?: { __typename?: 'CommodityType', id: string, name: string } } | null> | null };

export type AllCommoditiesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCommoditiesSelectorQuery = { __typename?: 'QueryRoot', allCommodities?: Array<{ __typename?: 'CommodityType', id: string, name: string } | null> | null };

export type AllCompaniesSelectorQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type AllCompaniesSelectorQuery = { __typename?: 'QueryRoot', allCompanies?: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, displayName: string, codename: string } | null> | null };

export type AllHarvestGradesSelectorQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type AllHarvestGradesSelectorQuery = { __typename?: 'QueryRoot', harvestGradesForVariety?: Array<{ __typename?: 'HarvestGradeType', id: string, name: string, specifications: string } | null> | null };

export type AllSkusSelectorQueryVariables = Exact<{
  filter?: InputMaybe<SkuTypeFilterInput>;
}>;


export type AllSkusSelectorQuery = { __typename?: 'QueryRoot', allSkuTypes?: Array<{ __typename?: 'SKUGraphType', id: string, name: string, capacity: number, selfWeight: number, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null> | null };

export type AllSoilTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSoilTypesSelectorQuery = { __typename?: 'QueryRoot', allSoilTypes?: Array<{ __typename?: 'SoilGraphType', id: string, name: string } | null> | null };

export type AllTimeSlotsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTimeSlotsSelectorQuery = { __typename?: 'QueryRoot', allTimeSlots?: Array<{ __typename?: 'TimeSlotType', id: string, fromTime: any, toTime: any, name: string } | null> | null };

export type AllSiUnitsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSiUnitsSelectorQuery = { __typename?: 'QueryRoot', allSiUnits?: Array<{ __typename?: 'SIUnitType', id: string, name: string, codename: string } | null> | null };

export type AllCertificationTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCertificationTypesSelectorQuery = { __typename?: 'QueryRoot', allCertificationTypes?: Array<{ __typename?: 'CertificationGraphType', id: string, name: string } | null> | null };

export type AllDepotsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepotsSelectorQuery = { __typename?: 'QueryRoot', allDepots?: Array<{ __typename?: 'DepotType', id: string, name: string } | null> | null };

export type AllVehicleTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVehicleTypesSelectorQuery = { __typename?: 'QueryRoot', allVehicleTypes?: Array<{ __typename?: 'VehicleGraphType', id: string, name: string, category: string } | null> | null };

export type AllVehicleKindsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVehicleKindsSelectorQuery = { __typename?: 'QueryRoot', allVehicleKind?: Array<{ __typename?: 'VehicleKindType', id: string, name: string } | null> | null };

export type AllBanksSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBanksSelectorQuery = { __typename?: 'QueryRoot', allBanks?: Array<{ __typename?: 'BankType', id: string, codename: string, name: string } | null> | null };

export type AllKycTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllKycTypesSelectorQuery = { __typename?: 'QueryRoot', allKycTypes?: Array<{ __typename?: 'KYCGraphType', id: string, name: string } | null> | null };

export type AllUsersByGroupSelectorQueryVariables = Exact<{
  group?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<UsersByGroupFilterInput>;
}>;


export type AllUsersByGroupSelectorQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string } | null> | null };

export type AllMarketsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMarketsSelectorQuery = { __typename?: 'QueryRoot', allMarkets?: Array<{ __typename?: 'MarketType', id: string, name: string, codename: string } | null> | null };

export type AllVehiclesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVehiclesSelectorQuery = { __typename?: 'QueryRoot', allVehicles?: Array<{ __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null } } | null> | null };

export type AllSkuCategoriesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSkuCategoriesSelectorQuery = { __typename?: 'QueryRoot', allSkuCategories?: Array<{ __typename?: 'SKUCategoryType', id: string, name: string, codename: string } | null> | null };

export type AllReferenceGradesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllReferenceGradesSelectorQuery = { __typename?: 'QueryRoot', referenceGrades?: Array<{ __typename?: 'HarvestGradeType', id: string, name: string, specifications: string } | null> | null };

export type AllUnloadingTeamsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUnloadingTeamsSelectorQuery = { __typename?: 'QueryRoot', allUnloadingTeams?: Array<{ __typename?: 'UnloadingTeamType', id: string, name: string, contact: string, codename: string } | null> | null };

export type AllExpenseTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllExpenseTypesSelectorQuery = { __typename?: 'QueryRoot', allExpenseTypes?: Array<{ __typename?: 'ExpenseGraphType', id: string, name: string, codename: string } | null> | null };

export type AllPaymentTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPaymentTypesSelectorQuery = { __typename?: 'QueryRoot', allPaymentTypes?: Array<{ __typename?: 'PaymentGraphType', id: string, name: string } | null> | null };

export type AllFuelTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFuelTypesSelectorQuery = { __typename?: 'QueryRoot', allFuelTypes?: Array<{ __typename?: 'FuelGraphType', id: string, name: string, codename: string } | null> | null };

export type AllContractTypesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllContractTypesSelectorQuery = { __typename?: 'QueryRoot', allContractTypes?: Array<{ __typename?: 'ContractGraphType', id: string, name: string, codename: string } | null> | null };

export type AllMarketYardsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMarketYardsSelectorQuery = { __typename?: 'QueryRoot', allMarketYards?: Array<{ __typename?: 'MarketYardType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string } } | null> | null };

export type AllDistributionCentersSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDistributionCentersSelectorQuery = { __typename?: 'QueryRoot', allDistributionCentres?: Array<{ __typename?: 'DistributionCentreType', id: string, name: string } | null> | null };

export type DcSurveyAreasQueryVariables = Exact<{
  dcId?: InputMaybe<Scalars['ID']>;
}>;


export type DcSurveyAreasQuery = { __typename?: 'QueryRoot', allSurveyAreas?: Array<{ __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null } | null> | null };

export type AllCpcSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCpcSelectorQuery = { __typename?: 'QueryRoot', allDistributionCentres?: Array<{ __typename?: 'DistributionCentreType', id: string, name: string } | null> | null };

export type DistributionCentersCurrentStockQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DistributionCentersCurrentStockQuery = { __typename?: 'QueryRoot', distributionCentreDetail?: { __typename?: 'DistributionCentreType', currentStockPercentage?: number | null } | null };

export type AllSellableItemGroupsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSellableItemGroupsSelectorQuery = { __typename?: 'QueryRoot', allSellableItemGroups?: Array<{ __typename?: 'SellableItemGroupType', id: string, name: string, codename: string } | null> | null };

export type AllSellableItemSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSellableItemSelectorQuery = { __typename?: 'QueryRoot', allSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string } | null> | null };

export type SearchSellableItemsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SellableItemFilterInput>;
}>;


export type SearchSellableItemsQuery = { __typename?: 'QueryRoot', allSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null } | null> | null };

export type SearchBatchStockQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BatchStockFilterInput>;
}>;


export type SearchBatchStockQuery = { __typename?: 'QueryRoot', allBatchStocks?: Array<{ __typename?: 'BatchStockType', id: string, currentStockCount: number, expiryOn?: any | null, manufacturedOn?: any | null, name: string, suppliedBy?: { __typename?: 'DistributionCentreType', id: string } | null } | null> | null };

export type AllReportMastersSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllReportMastersSelectorQuery = { __typename?: 'QueryRoot', allReportMasters?: Array<{ __typename?: 'ReportType', id: string, alias: string } | null> | null };

export type AllNotificationTempletesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllNotificationTempletesQuery = { __typename?: 'QueryRoot', allNotificationTempletes?: Array<{ __typename?: 'NotificationTemplateType', id: string, name: string } | null> | null };

export type AllStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStatesQuery = { __typename?: 'QueryRoot', allStates?: Array<{ __typename?: 'StateType', id: string, name: string, codename: string } | null> | null };

export type PeriodicTaskTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PeriodicTaskTypesQuery = { __typename?: 'QueryRoot', allTasks?: Array<string | null> | null };

export type AllRoutesSelectorQueryVariables = Exact<{
  filter?: InputMaybe<RouteInput>;
}>;


export type AllRoutesSelectorQuery = { __typename?: 'QueryRoot', allRoutes?: Array<{ __typename?: 'RouteType', id: string, name: string, surveyArea: { __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string } | null } } | null> | null };

export type AllRouteCategorysQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRouteCategorysQuery = { __typename?: 'QueryRoot', allRouteCategorys?: Array<{ __typename?: 'RouteCategoryType', id: string, name: string } | null> | null };

export type AllPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPaymentMethodsQuery = { __typename?: 'QueryRoot', allPaymentMethods?: Array<{ __typename?: 'PaymentMethodType', id: string, name: string } | null> | null };

export type AllTransactionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTransactionTypesQuery = { __typename?: 'QueryRoot', allTransactionTypes?: Array<{ __typename?: 'TransactionTypeType', id: string, name: string } | null> | null };

export type AllUnloadingSubLocationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  filter: Scalars['ID'];
}>;


export type AllUnloadingSubLocationsQuery = { __typename?: 'QueryRoot', allUnloadingSubLocations?: Array<{ __typename?: 'UnloadingSubLocationType', id: string, name: string, unloadingLocation: { __typename?: 'DepotType', id: string, name: string } } | null> | null };

export type HoldingAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type HoldingAreasQuery = { __typename?: 'QueryRoot', holdingAreas?: Array<{ __typename?: 'HoldingAreaType', id: string, name: string } | null> | null };

export type ProductionLinesQueryVariables = Exact<{
  departmentId?: InputMaybe<Scalars['ID']>;
  depotId?: InputMaybe<Scalars['ID']>;
}>;


export type ProductionLinesQuery = { __typename?: 'QueryRoot', productionLines?: Array<{ __typename?: 'ProductionLineType', id: string, name: string } | null> | null };

export type AllExportCustomersSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllExportCustomersSelectorQuery = { __typename?: 'QueryRoot', allExportCustomers?: Array<{ __typename?: 'ExportCustomerType', id: string, name: string } | null> | null };

export type AllPortsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPortsSelectorQuery = { __typename?: 'QueryRoot', allPorts?: Array<{ __typename?: 'PortType', id: string, name: string } | null> | null };

export type AllColorGroupsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllColorGroupsSelectorQuery = { __typename?: 'QueryRoot', allColorGroups?: Array<{ __typename?: 'ColorGroupType', id: string, name: string, codename: string } | null> | null };

export type AllPrimaryPackMaterialsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPrimaryPackMaterialsSelectorQuery = { __typename?: 'QueryRoot', allPackingMaterials?: Array<{ __typename?: 'SKUPackingMaterialType', id: string, name: string, codename: string } | null> | null };

export type AllSecondaryPackMaterialsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSecondaryPackMaterialsSelectorQuery = { __typename?: 'QueryRoot', allPackingMaterials?: Array<{ __typename?: 'SKUPackingMaterialType', id: string, name: string, codename: string } | null> | null };

export type AllGatesSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGatesSelectorQuery = { __typename?: 'QueryRoot', gateNumbers?: Array<{ __typename?: 'GateNumberType', id: string, name: string, codename: string } | null> | null };

export type AddUpdateVariantMutationVariables = Exact<{
  parentBatchStockId: Scalars['ID'];
  sellableItemId: Scalars['ID'];
  sellableItemStockInput: SellableItemStockInput;
  batchStockInput: BatchStockInput;
  parentSellableItemStockId: Scalars['ID'];
}>;


export type AddUpdateVariantMutation = { __typename?: 'MutationRoot', addUpdateVarientFromBatchStock?: { __typename?: 'AddUpdateVariantFromBatchStockMutation', sellableItem?: { __typename?: 'SellableItemType', id: string, name: string } | null, sellableItemStock?: { __typename?: 'SellableItemStockType', id: string, unitRate: number, currentStockCount: number } | null, batchStock?: { __typename?: 'BatchStockType', id: string, codename: string, totalQuantity: number } | null } | null };

export type SellableItemListFragFragment = { __typename?: 'SellableItemType', id: string, name: string, shortDescription: string, primaryPhoto: { __typename?: 'MediaEntityType', id: string, url: string }, itemGroups: Array<{ __typename?: 'SellableItemGroupType', id: string, name: string }>, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, name: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } }>, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> };

export type SellableItemDetailsFragFragment = { __typename?: 'SellableItemType', id: string, name: string, codename: string, currentStockPercentage?: number | null, shortDescription: string, longDescription: string, transportationType: SellableItemTransportationType, externalReferences?: Array<{ __typename?: 'ExternalReferenceType', id: string, objectId: number, referenceId: string, externalApp: { __typename?: 'ExternalApplicationType', id: string, codename: string, name: string } } | null> | null, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number, name: string } | null, itemGroups: Array<{ __typename?: 'SellableItemGroupType', id: string, name: string }>, metadata?: { __typename?: 'SellableItemMetadata', eanCode?: string | null, fssaiLicense?: string | null, hsnCode?: string | null, isVariant?: boolean | null } | null, photos: Array<{ __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }>, primaryPhoto: { __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, name: string, uomCount: number, skuCount: number, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, uomType: { __typename?: 'SIUnitType', id: string, name: string, codename: string }, skuType: { __typename?: 'SKUGraphType', id: string, name: string } }>, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> };

export type RelatedStockFragFragment = { __typename?: 'SellableItemStockType', id: string, offerStockCount: number, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }>, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } };

export type SellableItemStockDetailFragFragment = { __typename?: 'SellableItemStockType', id: string, expiryDate?: any | null, unitRate: number, isLive: boolean, orderingConditions: any, minRate: number, maxRate: number, currentStockCount: number, holdStockCount: number, offerStockCount: number, currentStockPercentage?: number | null, currentStockType: SellableItemStockCurrentStockType, discountedRate: number, variantStocks?: Array<{ __typename?: 'SellableItemStockType', id: string, currentStockCount: number, unitRate: number, discountedRate: number, offerStockCount: number, orderingConditions: any, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null }, batchStocks?: Array<{ __typename?: 'BatchStockType', id: string, totalQuantity: number, currentStockCount: number, expiryOn?: any | null, manufacturedOn?: any | null, name: string, manufacturedBy?: { __typename?: 'DistributionCentreType', id: string } | null, suppliedBy?: { __typename?: 'DistributionCentreType', id: string } | null } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string, name: string } | null }> } | null> | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, currentStockPercentage?: number | null, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null, childSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null } | null> | null }, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string, name: string } | null }>, relatedStock?: { __typename?: 'SellableItemStockType', id: string, offerStockCount: number, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }>, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string, currentStockPercentage?: number | null } };

export type SellableItemAddUpdateMutationVariables = Exact<{
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  itemGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  longDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<InputMaybe<MediaInput>> | InputMaybe<MediaInput>>;
  primaryPhoto?: InputMaybe<MediaInput>;
  sellableVarieties?: InputMaybe<Array<InputMaybe<SellableVarietyInput>> | InputMaybe<SellableVarietyInput>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  transportationType?: InputMaybe<Scalars['String']>;
  secondarySkuType?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<SellableItemMetadataInput>;
  allowedDepartments?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  parentItemId?: InputMaybe<Scalars['ID']>;
}>;


export type SellableItemAddUpdateMutation = { __typename?: 'MutationRoot', addUpdateSellableItem?: { __typename?: 'AddUpdateSellableItemMutation', sellableItem?: { __typename?: 'SellableItemType', id: string, name: string, codename: string, currentStockPercentage?: number | null, shortDescription: string, longDescription: string, transportationType: SellableItemTransportationType, externalReferences?: Array<{ __typename?: 'ExternalReferenceType', id: string, objectId: number, referenceId: string, externalApp: { __typename?: 'ExternalApplicationType', id: string, codename: string, name: string } } | null> | null, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number, name: string } | null, itemGroups: Array<{ __typename?: 'SellableItemGroupType', id: string, name: string }>, metadata?: { __typename?: 'SellableItemMetadata', eanCode?: string | null, fssaiLicense?: string | null, hsnCode?: string | null, isVariant?: boolean | null } | null, photos: Array<{ __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }>, primaryPhoto: { __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, name: string, uomCount: number, skuCount: number, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, uomType: { __typename?: 'SIUnitType', id: string, name: string, codename: string }, skuType: { __typename?: 'SKUGraphType', id: string, name: string } }>, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null } | null };

export type SellableItemStockaddUpdateMutationVariables = Exact<{
  currentStockCount: Scalars['Int'];
  discountedRate: Scalars['Float'];
  distributionCentreId: Scalars['ID'];
  groupVisibility?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  holdStockCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isLive: Scalars['Boolean'];
  offerStockCount: Scalars['Int'];
  orderingConditions?: InputMaybe<OrderingConditionInput>;
  sellableItemId: Scalars['ID'];
  unitRate: Scalars['Float'];
  minRate?: InputMaybe<Scalars['Float']>;
  maxRate?: InputMaybe<Scalars['Float']>;
  relatedStockId?: InputMaybe<Scalars['ID']>;
  expiryDate?: InputMaybe<Scalars['Date']>;
  currentStockPercentage?: InputMaybe<Scalars['CustomGenericScalar']>;
  currentStockType?: InputMaybe<Scalars['String']>;
}>;


export type SellableItemStockaddUpdateMutation = { __typename?: 'MutationRoot', addUpdateSellableItemStock?: { __typename?: 'AddUpdateSellableItemStockMutation', sellableItemStock?: { __typename?: 'SellableItemStockType', id: string, expiryDate?: any | null, unitRate: number, isLive: boolean, orderingConditions: any, minRate: number, maxRate: number, currentStockCount: number, holdStockCount: number, offerStockCount: number, currentStockPercentage?: number | null, currentStockType: SellableItemStockCurrentStockType, discountedRate: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, currentStockPercentage?: number | null, sellableStocks?: Array<{ __typename?: 'SellableItemStockType', id: string, rejectedStockCount: number, bookedStockCount: number, currentStockCount: number, holdStockCount: number, offerStockCount: number } | null> | null, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null, childSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null } | null> | null }, variantStocks?: Array<{ __typename?: 'SellableItemStockType', id: string, currentStockCount: number, unitRate: number, discountedRate: number, offerStockCount: number, orderingConditions: any, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null }, batchStocks?: Array<{ __typename?: 'BatchStockType', id: string, totalQuantity: number, currentStockCount: number, expiryOn?: any | null, manufacturedOn?: any | null, name: string, manufacturedBy?: { __typename?: 'DistributionCentreType', id: string } | null, suppliedBy?: { __typename?: 'DistributionCentreType', id: string } | null } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string, name: string } | null }> } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string, name: string } | null }>, relatedStock?: { __typename?: 'SellableItemStockType', id: string, offerStockCount: number, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }>, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string, currentStockPercentage?: number | null } } | null } | null };

export type SellableItemsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SellableItemFilterInput>;
}>;


export type SellableItemsListQuery = { __typename?: 'QueryRoot', allSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string, shortDescription: string, primaryPhoto: { __typename?: 'MediaEntityType', id: string, url: string }, itemGroups: Array<{ __typename?: 'SellableItemGroupType', id: string, name: string }>, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, name: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } } }>, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null> | null };

export type SellableItemsDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SellableItemsDetailQuery = { __typename?: 'QueryRoot', sellableItemDetail?: { __typename?: 'SellableItemType', id: string, name: string, codename: string, currentStockPercentage?: number | null, shortDescription: string, longDescription: string, transportationType: SellableItemTransportationType, externalReferences?: Array<{ __typename?: 'ExternalReferenceType', id: string, objectId: number, referenceId: string, externalApp: { __typename?: 'ExternalApplicationType', id: string, codename: string, name: string } } | null> | null, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number, name: string } | null, itemGroups: Array<{ __typename?: 'SellableItemGroupType', id: string, name: string }>, metadata?: { __typename?: 'SellableItemMetadata', eanCode?: string | null, fssaiLicense?: string | null, hsnCode?: string | null, isVariant?: boolean | null } | null, photos: Array<{ __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }>, primaryPhoto: { __typename?: 'MediaEntityType', id: string, mediaType: MediaEntityMediaType, url: string }, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, name: string, uomCount: number, skuCount: number, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, grade: { __typename?: 'HarvestGradeType', id: string, name: string }, uomType: { __typename?: 'SIUnitType', id: string, name: string, codename: string }, skuType: { __typename?: 'SKUGraphType', id: string, name: string } }>, allowedDepartments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null };

export type SellableItemsStockListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SellableItemStockFilterInput>;
}>;


export type SellableItemsStockListQuery = { __typename?: 'QueryRoot', sellableItemStock?: Array<{ __typename?: 'SellableItemStockType', id: string, offerStockCount: number, holdStockCount: number, currentStockCount: number, bookedStockCount: number, totalStockCount?: number | null, isLive: boolean, rejectedStockCount: number, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }>, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string, address: { __typename?: 'AddressType', id: string, village: string, address?: string | null, district?: string | null } }, sellableItem: { __typename?: 'SellableItemType', id: string, codename: string, shortDescription: string, name: string } } | null> | null };

export type SellableItemStockDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SellableItemStockFilterInput>;
}>;


export type SellableItemStockDetailQuery = { __typename?: 'QueryRoot', sellableItemStock?: Array<{ __typename?: 'SellableItemStockType', id: string, expiryDate?: any | null, unitRate: number, isLive: boolean, orderingConditions: any, minRate: number, maxRate: number, currentStockCount: number, holdStockCount: number, offerStockCount: number, currentStockPercentage?: number | null, currentStockType: SellableItemStockCurrentStockType, discountedRate: number, variantStocks?: Array<{ __typename?: 'SellableItemStockType', id: string, currentStockCount: number, unitRate: number, discountedRate: number, offerStockCount: number, orderingConditions: any, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null }, batchStocks?: Array<{ __typename?: 'BatchStockType', id: string, totalQuantity: number, currentStockCount: number, expiryOn?: any | null, manufacturedOn?: any | null, name: string, manufacturedBy?: { __typename?: 'DistributionCentreType', id: string } | null, suppliedBy?: { __typename?: 'DistributionCentreType', id: string } | null } | null> | null, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string, name: string } | null }> } | null> | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, currentStockPercentage?: number | null, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null, childSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string, secondarySkuType?: { __typename?: 'SKUGraphType', id: string, capacity: number } | null } | null> | null }, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string, name: string } | null }>, relatedStock?: { __typename?: 'SellableItemStockType', id: string, offerStockCount: number, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }>, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string, currentStockPercentage?: number | null } } | null> | null };

export type SellableItemsSuggestQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SellableItemFilterInput>;
  distributionCentreId?: InputMaybe<Scalars['ID']>;
}>;


export type SellableItemsSuggestQuery = { __typename?: 'QueryRoot', allSellableItems?: Array<{ __typename?: 'SellableItemType', id: string, name: string, codename: string, sellableVarieties: Array<{ __typename?: 'SellableVarietyType', id: string, variety: { __typename?: 'CommodityVarietyType', id: string, primaryGroup?: { __typename?: 'CommodityGroupType', id: string, name: string } | null } }>, sellableStocks?: Array<{ __typename?: 'SellableItemStockType', id: string, currentStockCount: number, holdStockCount: number, rejectedStockCount: number, bookedStockCount: number, offerStockCount: number } | null> | null } | null> | null };

export type RelatedStocksQueryVariables = Exact<{
  sellableItem?: InputMaybe<Scalars['ID']>;
}>;


export type RelatedStocksQuery = { __typename?: 'QueryRoot', sellableItemStock?: Array<{ __typename?: 'SellableItemStockType', id: string, offerStockCount: number, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }>, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string } } | null> | null };

export type AllBatchStocksQueryVariables = Exact<{
  filter?: InputMaybe<BatchStockFilterInput>;
}>;


export type AllBatchStocksQuery = { __typename?: 'QueryRoot', allBatchStocks?: Array<{ __typename?: 'BatchStockType', id: string, codename: string, manufacturedOn?: any | null, expiryOn?: any | null, totalQuantity: number, currentStockCount: number, holdStockCount: number, alternateStockCount: number, intransitStockCount: number, dumpedStockCount: number, coaCertificate?: string | null, manufacturedBy?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, suppliedBy?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, sku?: { __typename?: 'SKUGraphType', id: string, name: string } | null, parentBatchStock?: { __typename?: 'BatchStockType', id: string, codename: string } | null } | null> | null };

export type SkuDetailFragFragment = { __typename?: 'SKUGraphType', id: string, name: string, description: string, capacity: number, createdAt: any, dimensions?: Array<number | null> | null, unitPrice: number, isReturnable: boolean, metadata: any, stockCount: number, selfWeight: number, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, skuCategory?: { __typename?: 'SKUCategoryType', id: string, name: string, codename: string } | null, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } };

export type AllSkuTypesListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AllSkuTypesListQuery = { __typename?: 'QueryRoot', allSkuTypes?: Array<{ __typename?: 'SKUGraphType', id: string, name: string, description: string, capacity: number, createdAt: any, dimensions?: Array<number | null> | null, unitPrice: number, isReturnable: boolean, metadata: any, stockCount: number, selfWeight: number, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, skuCategory?: { __typename?: 'SKUCategoryType', id: string, name: string, codename: string } | null, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null> | null };

export type SkuDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SkuDetailsQuery = { __typename?: 'QueryRoot', skuDetails?: { __typename?: 'SKUGraphType', id: string, name: string, description: string, capacity: number, createdAt: any, dimensions?: Array<number | null> | null, unitPrice: number, isReturnable: boolean, metadata: any, stockCount: number, selfWeight: number, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, skuCategory?: { __typename?: 'SKUCategoryType', id: string, name: string, codename: string } | null, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null };

export type AddSkutypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  capacity?: InputMaybe<Scalars['Float']>;
  capacityUnit?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  selfWeight?: InputMaybe<Scalars['Float']>;
  stockCount?: InputMaybe<Scalars['Int']>;
  skuCategory?: InputMaybe<Scalars['ID']>;
  dimensionUnit?: InputMaybe<Scalars['ID']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>> | InputMaybe<Scalars['Float']>>;
  isReturnable?: InputMaybe<Scalars['Boolean']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
}>;


export type AddSkutypeMutation = { __typename?: 'MutationRoot', addUpdateSkuType?: { __typename?: 'AddUpdateSkuTypeMutation', skuType?: { __typename?: 'SKUGraphType', id: string, name: string, description: string, capacity: number, createdAt: any, dimensions?: Array<number | null> | null, unitPrice: number, isReturnable: boolean, metadata: any, stockCount: number, selfWeight: number, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string, codename: string } | null, skuCategory?: { __typename?: 'SKUCategoryType', id: string, name: string, codename: string } | null, capacityUnit: { __typename?: 'SIUnitType', id: string, name: string, codename: string } } | null } | null };

export type DcListQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']>;
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type DcListQuery = { __typename?: 'QueryRoot', dcWiseAggregateVisibility?: Array<{ __typename?: 'DCWiseStockVisibility', opening?: number | null, closing?: number | null, inwarded?: number | null, inTransit?: number | null, delivered?: number | null, returned?: number | null, directSale?: number | null, disposal?: number | null, dc?: { __typename?: 'DistributionCentreType', id: string, name: string } | null } | null> | null };

export type SellableItemListQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']>;
  filter?: InputMaybe<SellableItemWiseStockVisibilityFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SellableItemListQuery = { __typename?: 'QueryRoot', sellableItemWiseStockVisibility?: Array<{ __typename?: 'SellableItemWiseStockVisibility', opening?: number | null, closing?: number | null, inwarded?: number | null, inTransit?: number | null, delivered?: number | null, returned?: number | null, directSale?: number | null, disposal?: number | null, activeStockCount?: number | null, sellableItem?: { __typename?: 'SellableItemType', id: string, name: string } | null } | null> | null };

export type SellableListSubItemsQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']>;
}>;


export type SellableListSubItemsQuery = { __typename?: 'QueryRoot', batchStockWiseVisibility?: Array<{ __typename?: 'BatchStockWiseVisibility', opening?: number | null, closing?: number | null, inwarded?: number | null, inTransit?: number | null, delivered?: number | null, returned?: number | null, directSale?: number | null, disposal?: number | null, batchStock?: { __typename?: 'BatchStockType', id: string } | null } | null> | null };

export type ApproveRequestMutationVariables = Exact<{
  obj?: InputMaybe<StockTakeApprovalRequestInput>;
}>;


export type ApproveRequestMutation = { __typename?: 'MutationRoot', addUpdateStockTakeApproval?: { __typename?: 'AddUpdateStockTakeApprovalMutation', approvalRequest?: Array<{ __typename?: 'StockTakeApprovalRequestType', id: string, status: ApprovalRequestStatus } | null> | null } | null };

export type ApprovalListQueryVariables = Exact<{
  filter?: InputMaybe<StockTakeApprovalRequestInput>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ApprovalListQuery = { __typename?: 'QueryRoot', aggregateStockTakeApprovalRequestsByDc?: Array<{ __typename?: 'StockTakeApprovalRequestByDC', totalRequests?: number | null, pendingRequests?: number | null, approvedRequests?: number | null, rejectedRequests?: number | null, requestedAt?: any | null, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string, codename: string } | null, requestedBy?: { __typename?: 'BaseUserType', id: string, fullName?: string | null } | null } | null> | null };

export type DcRequestsListQueryVariables = Exact<{
  filter?: InputMaybe<StockTakeApprovalRequestInput>;
}>;


export type DcRequestsListQuery = { __typename?: 'QueryRoot', allStockTakeApprovalRequests?: Array<{ __typename?: 'StockTakeApprovalRequestType', id: string, status: ApprovalRequestStatus, requestedAt: any, requestedBy: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, stockEntryItem?: { __typename?: 'StockEntryItemType', id: string, grade: StockEntryItemGrade, quantity: number, addedOn: any, systemCount?: number | null, remark: string, batchStock?: { __typename?: 'BatchStockType', id: string, codename: string, suppliedBy?: { __typename?: 'DistributionCentreType', id: string } | null } | null, sellableItem?: { __typename?: 'SellableItemType', id: string, name: string, primaryPhoto: { __typename?: 'MediaEntityType', id: string, url: string } } | null, subLocation: { __typename?: 'DCSubLocationType', id: string, name: string } } | null } | null> | null };

export type AddUpdateBatchStockMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  data: BatchStockInput;
}>;


export type AddUpdateBatchStockMutationMutation = { __typename?: 'MutationRoot', addUpdateBatchStock?: { __typename?: 'AddUpdateBatchStockMutation', batchStock?: { __typename?: 'BatchStockType', id: string, codename: string, coaCertificate?: string | null } | null } | null };

export type BatchStockDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BatchStockDetailQuery = { __typename?: 'QueryRoot', batchStockDetail?: { __typename?: 'BatchStockType', id: string, codename: string, manufacturedOn?: any | null, expiryOn?: any | null, totalQuantity: number, currentStockCount: number, holdStockCount: number, alternateStockCount: number, intransitStockCount: number, dumpedStockCount: number, coaCertificate?: string | null, sku?: { __typename?: 'SKUGraphType', id: string, name: string } | null, sellableItem: { __typename?: 'SellableItemType', id: string, name: string, codename: string }, manufacturedBy?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, suppliedBy?: { __typename?: 'DistributionCentreType', id: string, name: string } | null, parentBatchStock?: { __typename?: 'BatchStockType', id: string, codename: string } | null } | null };

export type SellableItemStockSelectorQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SellableItemStockFilterInput>;
}>;


export type SellableItemStockSelectorQuery = { __typename?: 'QueryRoot', sellableItemStock?: Array<{ __typename?: 'SellableItemStockType', id: string, discountedRate: number, unitRate: number, offerStockCount: number, sellableItem: { __typename?: 'SellableItemType', id: string, name: string }, relatedStock?: { __typename?: 'SellableItemStockType', id: string, offerStockCount: number } | null, distributionCentre: { __typename?: 'DistributionCentreType', id: string, name: string }, groupVisibility: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null> | null };

export type PlotSampleFragFragment = { __typename?: 'PlotCommoditySampleType', id: string, chemicalStatus: PlotCommoditySampleChemicalStatus, chemicalStatusDisplay?: string | null, chemicalTestDate: any, detectionCount: number, maxDetection: number, totalDetection: number, market?: { __typename?: 'MarketType', id: string, name: string, codename: string } | null };

export type PlotCommodityFragFragment = { __typename?: 'PlotCommodityType', id: string, name: string, referenceId: string, isArchived: boolean, sowingDate?: any | null, harvestingDate?: any | null, growingCycle: number, statusDisplay?: string | null, status: PlotCommodityStatus, agronomist?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, samples?: Array<{ __typename?: 'PlotCommoditySampleType', id: string, chemicalStatus: PlotCommoditySampleChemicalStatus, chemicalStatusDisplay?: string | null, chemicalTestDate: any, detectionCount: number, maxDetection: number, totalDetection: number, market?: { __typename?: 'MarketType', id: string, name: string, codename: string } | null } | null> | null, plot: { __typename?: 'PlotType', id: string, codename: string, area: number, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, companyCode?: string | null, fullName?: string | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, companies: Array<{ __typename?: 'CompanyType', id: string, displayName: string, codename: string }> }, address: { __typename?: 'AddressType', id: string, village: string } } };

export type BulkUpdatePlotCommodityMutationMutationVariables = Exact<{
  agronomist?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  plotStatus?: InputMaybe<Scalars['String']>;
  plotCommodities: Array<Scalars['Int']> | Scalars['Int'];
  generatePoPlotWise?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkUpdatePlotCommodityMutationMutation = { __typename?: 'MutationRoot', bulkUpdatePlotCommodity?: { __typename?: 'BulkUpdatePlotCommodityMutation', plotCommodities?: Array<{ __typename?: 'PlotCommodityType', id: string, name: string, referenceId: string, isArchived: boolean, sowingDate?: any | null, harvestingDate?: any | null, growingCycle: number, statusDisplay?: string | null, status: PlotCommodityStatus, agronomist?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, samples?: Array<{ __typename?: 'PlotCommoditySampleType', id: string, chemicalStatus: PlotCommoditySampleChemicalStatus, chemicalStatusDisplay?: string | null, chemicalTestDate: any, detectionCount: number, maxDetection: number, totalDetection: number, market?: { __typename?: 'MarketType', id: string, name: string, codename: string } | null } | null> | null, plot: { __typename?: 'PlotType', id: string, codename: string, area: number, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, companyCode?: string | null, fullName?: string | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, companies: Array<{ __typename?: 'CompanyType', id: string, displayName: string, codename: string }> }, address: { __typename?: 'AddressType', id: string, village: string } } } | null> | null } | null };

export type AddUpdatePlotCommoditySamplesMutationMutationVariables = Exact<{
  plotCommodityId: Scalars['Int'];
  samples: Array<InputMaybe<PlotCommoditySampleInput>> | InputMaybe<PlotCommoditySampleInput>;
}>;


export type AddUpdatePlotCommoditySamplesMutationMutation = { __typename?: 'MutationRoot', addUpdatePlotSample?: { __typename?: 'AddPlotCommoditySampleMutation', plotCommodity?: { __typename?: 'PlotCommodityType', id: string, name: string, referenceId: string, isArchived: boolean, sowingDate?: any | null, harvestingDate?: any | null, growingCycle: number, statusDisplay?: string | null, status: PlotCommodityStatus, agronomist?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, samples?: Array<{ __typename?: 'PlotCommoditySampleType', id: string, chemicalStatus: PlotCommoditySampleChemicalStatus, chemicalStatusDisplay?: string | null, chemicalTestDate: any, detectionCount: number, maxDetection: number, totalDetection: number, market?: { __typename?: 'MarketType', id: string, name: string, codename: string } | null } | null> | null, plot: { __typename?: 'PlotType', id: string, codename: string, area: number, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, companyCode?: string | null, fullName?: string | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, companies: Array<{ __typename?: 'CompanyType', id: string, displayName: string, codename: string }> }, address: { __typename?: 'AddressType', id: string, village: string } } } | null } | null };

export type AllPlotCommoditiesListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  filter: PlotCommodityFilterInput;
}>;


export type AllPlotCommoditiesListQuery = { __typename?: 'QueryRoot', allPlotCommodities?: Array<{ __typename?: 'PlotCommodityType', id: string, name: string, referenceId: string, isArchived: boolean, sowingDate?: any | null, harvestingDate?: any | null, growingCycle: number, statusDisplay?: string | null, status: PlotCommodityStatus, agronomist?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, samples?: Array<{ __typename?: 'PlotCommoditySampleType', id: string, chemicalStatus: PlotCommoditySampleChemicalStatus, chemicalStatusDisplay?: string | null, chemicalTestDate: any, detectionCount: number, maxDetection: number, totalDetection: number, market?: { __typename?: 'MarketType', id: string, name: string, codename: string } | null } | null> | null, plot: { __typename?: 'PlotType', id: string, codename: string, area: number, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, companyCode?: string | null, fullName?: string | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, companies: Array<{ __typename?: 'CompanyType', id: string, displayName: string, codename: string }> }, address: { __typename?: 'AddressType', id: string, village: string } } } | null> | null };

export type PlotCommoditySamplesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type PlotCommoditySamplesQuery = { __typename?: 'QueryRoot', plotCommodityDetails?: { __typename?: 'PlotCommodityType', id: string, samples?: Array<{ __typename?: 'PlotCommoditySampleType', id: string, chemicalStatus: PlotCommoditySampleChemicalStatus, chemicalStatusDisplay?: string | null, chemicalTestDate: any, detectionCount: number, maxDetection: number, totalDetection: number, market?: { __typename?: 'MarketType', id: string, name: string, codename: string } | null } | null> | null } | null };

export type SearchPlotCommoditiesQueryVariables = Exact<{
  query: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  filter?: InputMaybe<SearchPlotCommodityFilterInput>;
}>;


export type SearchPlotCommoditiesQuery = { __typename?: 'QueryRoot', searchPlotCommodity?: Array<{ __typename?: 'PlotCommodityType', id: string, name: string, referenceId: string, status: PlotCommodityStatus, lastTradeProfile?: { __typename?: 'TradeProfileType', id: string, category: TradeProfileCategory } | null, plot: { __typename?: 'PlotType', farmer: { __typename?: 'DeliveryAgentManagementType', id: string, isBlocked?: boolean | null } }, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, preferredSku?: { __typename?: 'SKUGraphType', id: string, name: string } | null, commodity: { __typename?: 'CommodityType', id: string, name: string } } } | null> | null };

export type PlotCommodityDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlotCommodityDetailsQuery = { __typename?: 'QueryRoot', plotCommodityDetails?: { __typename?: 'PlotCommodityType', lastSample?: { __typename?: 'PlotCommoditySampleType', id: string, detectionCount: number, maxDetection: number, totalDetection: number, chemicalStatusDisplay?: string | null, physicalStatusDisplay?: string | null, resultPdfUrl?: string | null, observations?: Array<{ __typename?: 'PlotCommoditySampleObservationType', detectionCount?: number | null, id: string, score?: number | null, tags?: Array<string | null> | null, qualityParameter: { __typename?: 'QualityParameterType', id: string, name: string, codename: string, mrl: number, standard: string, valueType: QualityParameterValueType } } | null> | null } | null } | null };

export type SyncKisanhubFarmersQueryVariables = Exact<{
  farmerId?: InputMaybe<Scalars['ID']>;
}>;


export type SyncKisanhubFarmersQuery = { __typename?: 'QueryRoot', syncFarmerPlots?: { __typename?: 'BaseUserType', id: string, fullName?: string | null, customerId: string } | null };

export type SurveyAreaDetailFragFragment = { __typename?: 'SurveyAreaLocationType', id: string, type?: string | null, properties?: { __typename?: 'SurveyAreaProperties', name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string, colorCode: string, geometry?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, number: string, name?: string | null }> } | null, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } };

export type DeleteSurveyAreaMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DeleteSurveyAreaMutation = { __typename?: 'MutationRoot', deleteSurveyArea?: { __typename?: 'DeleteSurveyArea', response?: string | null } | null };

export type AllSurveyAreasQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SurveyAreaFilterInput>;
}>;


export type AllSurveyAreasQuery = { __typename?: 'QueryRoot', allSurveyAreas?: Array<{ __typename?: 'SurveyAreaLocationType', id: string, type?: string | null, properties?: { __typename?: 'SurveyAreaProperties', name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string, colorCode: string, geometry?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, number: string, name?: string | null }> } | null, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } } | null> | null };

export type AllSurveyAreasPreviewQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SurveyAreaFilterInput>;
}>;


export type AllSurveyAreasPreviewQuery = { __typename?: 'QueryRoot', allSurveyAreas?: Array<{ __typename?: 'SurveyAreaLocationType', id: string, geometry: { __typename?: 'GeometryObjectType', coordinates?: any | null } } | null> | null };

export type SurveyAreaDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SurveyAreaDetailQuery = { __typename?: 'QueryRoot', surveyAreaDetail?: { __typename?: 'SurveyAreaLocationType', id: string, type?: string | null, properties?: { __typename?: 'SurveyAreaProperties', name: string, codename: string, updatedAt: any, primaryUser?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string, colorCode: string, geometry?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null } | null, users: Array<{ __typename?: 'DeliveryAgentManagementType', id: string, number: string, name?: string | null }> } | null, geometry: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } } | null };

export type AllSalesManQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSalesManQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string } | null> | null };

export type MyDcsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDcsQuery = { __typename?: 'QueryRoot', me?: { __typename?: 'Me', distributionCentres?: Array<{ __typename?: 'DistributionCentreType', id: string, name: string, colorCode: string, geometry?: { __typename?: 'GeometryObjectType', type?: string | null, coordinates?: any | null } | null } | null> | null } | null };

export type DcPincodesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SurveyAreaFilterInput>;
}>;


export type DcPincodesQuery = { __typename?: 'QueryRoot', allSurveyAreas?: Array<{ __typename?: 'SurveyAreaLocationType', id: string, properties?: { __typename?: 'SurveyAreaProperties', name: string, id: string, distributionCentre?: { __typename?: 'DistributionCentreType', id: string, name: string } | null } | null } | null> | null };

export type SystemUserListFragFragment = { __typename?: 'BaseUserType', id: string, firstName: string, username: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, number: string, email: string, status: BaseUserStatus, createdAt: any, dateOfBirth?: any | null, isStaff: boolean, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> };

export type SystemUserDetailFragFragment = { __typename?: 'BaseUserType', id: string, firstName: string, username: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, number: string, email: string, status: BaseUserStatus, createdAt: any, dateOfBirth?: any | null, isStaff: boolean, education?: BaseUserEducation | null, customerId: string, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, metadata?: { __typename?: 'BaseUserMetadata', secondaryNumber?: string | null, personalEmail?: string | null, instituteName?: string | null, yearOfPassing?: string | null, experience?: number | null, previousOrganisation?: string | null, interviewDate?: string | null, joiningDate?: string | null, icardIssuedDate?: string | null, visitingCardIssuedDate?: string | null, employmentTypeCurrentCompany?: string | null, resignationDateCurrentCompany?: string | null, laptopIssuedDate?: string | null, resignationDate?: string | null, attachments?: Array<string | null> | null, district?: string | null, address?: string | null } | null };

export type AllGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGroupsQuery = { __typename?: 'QueryRoot', allGroups?: Array<{ __typename?: 'GroupType', id: string, name: string, userCount?: number | null, permissions: Array<{ __typename?: 'PermissionType', id: string, name: string }> } | null> | null };

export type SystemUserDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SystemUserDetailsQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, firstName: string, username: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, number: string, email: string, status: BaseUserStatus, createdAt: any, dateOfBirth?: any | null, isStaff: boolean, education?: BaseUserEducation | null, customerId: string, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, metadata?: { __typename?: 'BaseUserMetadata', secondaryNumber?: string | null, personalEmail?: string | null, instituteName?: string | null, yearOfPassing?: string | null, experience?: number | null, previousOrganisation?: string | null, interviewDate?: string | null, joiningDate?: string | null, icardIssuedDate?: string | null, visitingCardIssuedDate?: string | null, employmentTypeCurrentCompany?: string | null, resignationDateCurrentCompany?: string | null, laptopIssuedDate?: string | null, resignationDate?: string | null, attachments?: Array<string | null> | null, district?: string | null, address?: string | null } | null } | null };

export type AllSchedulingOfficersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AllSchedulingOfficersQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, firstName: string, username: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, number: string, email: string, status: BaseUserStatus, createdAt: any, dateOfBirth?: any | null, isStaff: boolean, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null> | null };

export type AddUserMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  username: Scalars['String'];
  number: Scalars['String'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  lastName: Scalars['String'];
  firstName: Scalars['String'];
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  email?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<BaseUserMetadataInput>;
  education?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
}>;


export type AddUserMutationMutation = { __typename?: 'MutationRoot', addUser?: { __typename?: 'AddOrUpdateUserMutation', user?: { __typename?: 'BaseUserType', id: string, firstName: string, username: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, number: string, email: string, status: BaseUserStatus, createdAt: any, dateOfBirth?: any | null, isStaff: boolean, education?: BaseUserEducation | null, customerId: string, groups: Array<{ __typename?: 'GroupType', id: string, name: string }>, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, metadata?: { __typename?: 'BaseUserMetadata', secondaryNumber?: string | null, personalEmail?: string | null, instituteName?: string | null, yearOfPassing?: string | null, experience?: number | null, previousOrganisation?: string | null, interviewDate?: string | null, joiningDate?: string | null, icardIssuedDate?: string | null, visitingCardIssuedDate?: string | null, employmentTypeCurrentCompany?: string | null, resignationDateCurrentCompany?: string | null, laptopIssuedDate?: string | null, resignationDate?: string | null, attachments?: Array<string | null> | null, district?: string | null, address?: string | null } | null } | null } | null };

export type DeleteBaseUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteBaseUserMutation = { __typename?: 'MutationRoot', delBaseUser?: { __typename?: 'DelBaseUserMutation', user?: { __typename?: 'BaseUserType', id: string, number: string, status: BaseUserStatus } | null } | null };

export type SendUserCredentialsQueryVariables = Exact<{
  userId: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
}>;


export type SendUserCredentialsQuery = { __typename?: 'QueryRoot', sendUserCredentials?: boolean | null };

export type CreateAccountTransactionMutationVariables = Exact<{
  accountId: Scalars['ID'];
  amount: Scalars['Float'];
  attachment?: InputMaybe<MediaInput>;
  paymentMethodId: Scalars['ID'];
  referenceId?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  transactionId?: InputMaybe<Scalars['String']>;
  transactionTypeId: Scalars['ID'];
}>;


export type CreateAccountTransactionMutation = { __typename?: 'MutationRoot', newAccountTransaction?: { __typename?: 'NewAccountTransactionMutation', accountTransaction?: { __typename?: 'TransactionGraphType', id: string, referenceId: string, remark?: string | null, status: TransactionStatus, transactionId: string, account: { __typename?: 'AccountType', id: string, balance: number, name: string, codename: string, accountType: { __typename?: 'CommonAccountCategoryType', id: string, name: string } }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string }>, paymentMethod: { __typename?: 'PaymentMethodType', id: string, name: string }, transactionType: { __typename?: 'TransactionTypeType', id: string, name: string } } | null } | null };

export type AssignedTripBookingFragFragment = { __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, plot: { __typename?: 'PlotType', id: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, address: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string, taluka?: string | null } } } };

export type AssignedTripListFragFragment = { __typename?: 'TripType', id: string, uuid: string, status: TripStatus, date: any, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string } } };

export type AssignedTripMapFragFragment = { __typename?: 'TripType', id: string, uuid: string, status: TripStatus, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string } }, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number }> };

export type AssignedTripDetailsFragFragment = { __typename?: 'TripType', id: string, uuid: string, status: TripStatus, date: any, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string } | null, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, plot: { __typename?: 'PlotType', id: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, address: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string, taluka?: string | null } } } }>, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string } } };

export type UpdateTripMutationVariables = Exact<{
  tripId?: InputMaybe<Scalars['ID']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateTripMutation = { __typename?: 'MutationRoot', updateTripDetails?: { __typename?: 'UpdateTripDetailsMutation', trip?: { __typename?: 'TripType', id: string, date: any, status: TripStatus, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string } } | null } | null };

export type AssignedTripSummaryQueryVariables = Exact<{
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  distributionCenterId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignedTripSummaryQuery = { __typename?: 'QueryRoot', summaryAssignedTrips?: { __typename?: 'TripSummary', vehicleInPremises?: number | null, vehicleInTransit?: number | null, vehicleCompleted?: number | null, maxBookings?: number | null, crateInPremises?: number | null, crateInTransit?: number | null, crateCompleted?: number | null, crateInwarded?: number | null } | null };

export type FilterStatusSummaryQueryVariables = Exact<{
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  distributionCenterId: Scalars['ID'];
}>;


export type FilterStatusSummaryQuery = { __typename?: 'QueryRoot', summaryFilterDetails?: { __typename?: 'TripFilterSummary', tripStatus?: { __typename?: 'TripStatusDetail', CPCount?: number | null, ILCount?: number | null, PSCount?: number | null, DSCount?: number | null, OTCount?: number | null, NSCount?: number | null } | null } | null };

export type AssignedVehiclesTripsListQueryVariables = Exact<{
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AssignedTripsFilterInput>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AssignedVehiclesTripsListQuery = { __typename?: 'QueryRoot', assignedVehiclesTrips?: Array<{ __typename?: 'TripType', id: string, uuid: string, status: TripStatus, date: any, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number }>, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string } } } | null> | null };

export type AssignedVehiclesTripsMapQueryVariables = Exact<{
  date: Scalars['Date'];
  departmentId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AssignedTripsFilterInput>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AssignedVehiclesTripsMapQuery = { __typename?: 'QueryRoot', assignedVehiclesTrips?: Array<{ __typename?: 'TripType', id: string, uuid: string, status: TripStatus, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string } }, bookings: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number }> } | null> | null };

export type AssignedTripDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
  vehicleLat?: InputMaybe<Scalars['Float']>;
  vehicleLon?: InputMaybe<Scalars['Float']>;
}>;


export type AssignedTripDetailsQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, uuid: string, status: TripStatus, date: any, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string } | null, optimisedBookings?: Array<{ __typename?: 'BookingType', id: string, procuredQuantity: number, requiredQuantity: number, schedule: { __typename?: 'ScheduleType', id: string, gatePass: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plotCommodity: { __typename?: 'PlotCommodityType', id: string, name: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string } } | null, plot: { __typename?: 'PlotType', id: string, name: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, address: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, village: string, taluka?: string | null } } } } | null> | null, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, number: string, fullName?: string | null } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string } } } | null };

export type TripStepGraphQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  vehicleLat?: InputMaybe<Scalars['Float']>;
  vehicleLon?: InputMaybe<Scalars['Float']>;
}>;


export type TripStepGraphQuery = { __typename?: 'QueryRoot', tripStepGraph?: Array<{ __typename?: 'TripStepOutput', stepId?: string | null, booking?: number | null, name?: string | null, timestamp?: any | null, layer?: string | null, bookingObj?: { __typename?: 'BookingType', id: string, order?: { __typename?: 'AnnotatedOrderType', id: string, trackingCode: string } | null } | null } | null> | null };

export type TripRecommendationsQueryVariables = Exact<{
  uuid: Scalars['ID'];
  vehicleLatitude: Scalars['Float'];
  vehicleLongitude: Scalars['Float'];
}>;


export type TripRecommendationsQuery = { __typename?: 'QueryRoot', tripRecommendation?: Array<{ __typename?: 'PlotCommodityType', id: string, name: string, registrationCode: string, variety: { __typename?: 'CommodityVarietyType', id: string, name: string, preferredSku?: { __typename?: 'SKUGraphType', id: string, name: string } | null, commodity: { __typename?: 'CommodityType', id: string, name: string } }, plot: { __typename?: 'PlotType', id: string, farmer: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, address: { __typename?: 'AddressType', id: string, latitude: number, longitude: number, district?: string | null, village: string } } } | null> | null };

export type FrontEndTripDetailsQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
}>;


export type FrontEndTripDetailsQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, status: TripStatus, uuid: string, vehicle: { __typename?: 'VehicleType', id: string, registrationNumber: string }, aggregator: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string }, unloadedBy?: { __typename?: 'UnloadingTeamType', id: string, name: string } | null, sourceDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, longitude: number, latitude: number } } | null, destinationDepot?: { __typename?: 'DepotType', id: string, name: string, location: { __typename?: 'AddressType', id: string, latitude: number, longitude: number } } | null, orders?: Array<{ __typename?: 'OrderType', id: string, trackingCode: string, orderStatus: OrderOrderStatus, orderStatusObj?: { __typename?: 'ClientStatusType', id?: number | null, name?: string | null, intent?: string | null } | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, shippingAddress: { __typename?: 'AddressType', id: string, village: string, district?: string | null, latitude: number, longitude: number }, bookingsByTrip?: Array<{ __typename?: 'BookingType', id: string, requiredQuantity: number, procuredQuantity: number, orderItem?: { __typename?: 'OrderItemType', id: string, sellableItem: { __typename?: 'SellableItemType', id: string, name: string } } | null } | null> | null } | null> | null } | null };

export type TripQualityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type TripQualityQuery = { __typename?: 'QueryRoot', tripDetails?: { __typename?: 'TripType', id: string, bookings: Array<{ __typename?: 'BookingType', id: string, inwards: Array<{ __typename?: 'InwardType', id: string, grade: { __typename?: 'HarvestGradeType', id: string, name: string, specifications: string }, quality?: { __typename?: 'QualitySampleType', id: string, recordedOn: any, qualityRejection: number, reason: string, status: QualitySampleStatus } | null }> }> } | null };

export type UserGroupsCompaniesFragFragment = { __typename?: 'BaseUserType', companies: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, codename: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> };

export type ToggleBaseUserStatusMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ToggleBaseUserStatusMutation = { __typename?: 'MutationRoot', delBaseUser?: { __typename?: 'DelBaseUserMutation', user?: { __typename?: 'BaseUserType', id: string, fullName?: string | null, status: BaseUserStatus, statusObj?: { __typename?: 'ClientStatusType', id?: number | null, intent?: string | null, name?: string | null } | null } | null } | null };

export type UpdateFarmerGroupsCompaniesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type UpdateFarmerGroupsCompaniesMutation = { __typename?: 'MutationRoot', farmerGroupAndCompany?: { __typename?: 'UpdateFarmerGroupAndCompanyMutation', user?: { __typename?: 'BaseUserType', id: string, companies: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, codename: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> } | null } | null };

export type FarmerGroupsAndCompaniesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FarmerGroupsAndCompaniesQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, companies: Array<{ __typename?: 'CompanyType', id: string, kind: CompanyKind, name: string, codename: string }>, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> } | null };

export type ContractFragFragment = { __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } };

export type CreateVehicleExpenseMutationVariables = Exact<{
  borneBy?: InputMaybe<Scalars['String']>;
  contractId: Scalars['ID'];
  expenseFor: Scalars['ID'];
  expenseTypeId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  netAmount: Scalars['Float'];
  quantity: Scalars['Float'];
  quantityRate: Scalars['Float'];
  remark?: InputMaybe<Scalars['String']>;
  resourceUsed?: InputMaybe<Scalars['Int']>;
}>;


export type CreateVehicleExpenseMutation = { __typename?: 'MutationRoot', addVehicleExpense?: { __typename?: 'AddVehicleExpenseMutation', expense?: { __typename?: 'ExpenseType', id: string, borneBy: ExpenseBorneBy, netAmount: number, quantity: number, quantityRate: number, remark: string, resourceUsed: number, expenseType: { __typename?: 'ExpenseGraphType', id: string, name: string }, contract?: { __typename?: 'ContractType', id: string, number: string } | null } | null } | null };

export type MakeVehiclePaymentMutationVariables = Exact<{
  amount: Scalars['Float'];
  contractId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  paidToId: Scalars['ID'];
  paymentFor: Scalars['ID'];
  paymentTypeId: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
}>;


export type MakeVehiclePaymentMutation = { __typename?: 'MutationRoot', addVehiclePayment?: { __typename?: 'AddVehiclePaymentMutation', payment?: { __typename?: 'PaymentType', id: string, name: string, amount: number, remark: string, transactionType: PaymentTransactionType, paidTo: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, contract?: { __typename?: 'ContractType', id: string } | null, paymentType: { __typename?: 'PaymentGraphType', id: string, name: string } } | null } | null };

export type VehicleManagementVehicleDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type VehicleManagementVehicleDetailsQuery = { __typename?: 'QueryRoot', vehicleDetails?: { __typename?: 'VehicleType', id: string, registrationNumber: string, modelName?: string | null, dateBought: any, chassisNumber?: string | null, fuelTankCapacity: number, estimatedAverage: number, contracts?: Array<{ __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null> | null, currentContract?: { __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, name: string } | null }, owner?: { __typename?: 'DeliveryAgentManagementType', id: string } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string } | null } | null };

export type VehicleManagementOwnerDriverDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type VehicleManagementOwnerDriverDetailsQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string, email: string, customerId: string, dateOfBirth?: any | null, address?: { __typename?: 'AddressType', id: string, village: string, taluka?: string | null } | null, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, accountNumber: string, accountHolderName: string, ifscCode: string, branchName: string, bank: { __typename?: 'BankType', id: string, name: string } }>, licenceDetails: Array<{ __typename?: 'LicenceDetailType', id: string, idNumber: string, validTill: any }> } | null };

export type ContractExpensesQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ContractExpensesQuery = { __typename?: 'QueryRoot', contractExpenses?: Array<{ __typename?: 'ExpenseType', id: string, quantity: number, createdAt: any, quantityRate: number, netAmount: number, borneBy: ExpenseBorneBy, resourceUsed: number, expenseType: { __typename?: 'ExpenseGraphType', id: string, name: string } } | null> | null };

export type ContractPaymentsQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ContractPaymentsQuery = { __typename?: 'QueryRoot', contractPayments?: Array<{ __typename?: 'PaymentType', id: string, createdAt: any, amount: number, transactionType: PaymentTransactionType, paidTo: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null }, paymentType: { __typename?: 'PaymentGraphType', id: string, name: string } } | null> | null };

export type VehicleListFragFragment = { __typename?: 'VehicleType', id: string, registrationNumber: string, estimatedAverage: number, status: VehicleStatus, createdAt: any, totalDistance?: number | null, advanceAmount?: number | null, fuelAmount?: number | null, totalWeight?: number | null, avgCostPerKg?: number | null, fuelLiters?: number | null, distance?: number | null, avgMileage?: number | null, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, alerts?: Array<{ __typename?: 'AlertObject', date?: any | null, message?: string | null } | null> | null, currentContract?: { __typename?: 'ContractType', id: string, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, codename: string } | null }, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, depot?: { __typename?: 'DepotType', id: string, name: string } | null };

export type VehicleDetailsFragFragment = { __typename?: 'VehicleType', id: string, registrationNumber: string, chassisNumber?: string | null, estimatedAverage: number, dateBought: any, status: VehicleStatus, dimensions?: Array<number | null> | null, fuelTankCapacity: number, modelName?: string | null, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, fuelType?: { __typename?: 'FuelGraphType', id: string, name: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string }, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, depot?: { __typename?: 'DepotType', id: string } | null, insurance?: { __typename?: 'InsuranceDetailType', id: string, name: string, idNumber: string, issuedOn: any, validTill: any, photo?: string | null } | null };

export type VehicleOwnerFragFragment = { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, status: BaseUserStatus, email: string, number: string, customerId: string, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, pincode?: string | null, state?: string | null, district?: string | null, taluka?: string | null, latitude: number, longitude: number, address?: string | null } | null, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountNumber: string, accountHolderName: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string } }> };

export type VehicleDriverFragFragment = { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, number: string, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, licenceDetails: Array<{ __typename?: 'LicenceDetailType', id: string, idNumber: string, issuedOn: any, validTill: any, photo?: string | null }> };

export type AllVehicleListFragFragment = { __typename?: 'VehicleType', id: string, status: VehicleStatus, registrationNumber: string, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, alerts?: Array<{ __typename?: 'AlertObject', date?: any | null, message?: string | null } | null> | null, currentContract?: { __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null, contracts?: Array<{ __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null> | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string } };

export type AddQuickVehicleMutationMutationMutationVariables = Exact<{
  driver?: InputMaybe<PureBaseUserInput>;
  owner?: InputMaybe<Scalars['Int']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['Int']>;
}>;


export type AddQuickVehicleMutationMutationMutation = { __typename?: 'MutationRoot', addQuickVehicle?: { __typename?: 'AddUpdateQuickVehicleMutation', vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, capacity: number }, depot?: { __typename?: 'DepotType', id: string, name: string } | null } | null } | null };

export type AddUpdateVehicleMutationMutationVariables = Exact<{
  chassisNumber?: InputMaybe<Scalars['String']>;
  dateBought?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  estimatedAverage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  insurance?: InputMaybe<VehicleInsuranceInput>;
  modelName?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<Scalars['ID']>;
  fuelTypeId?: InputMaybe<Scalars['ID']>;
  fuelTankCapacity?: InputMaybe<Scalars['Float']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>> | InputMaybe<Scalars['Float']>>;
  dimensionUnit?: InputMaybe<Scalars['ID']>;
  vehicleKind?: InputMaybe<Scalars['String']>;
}>;


export type AddUpdateVehicleMutationMutation = { __typename?: 'MutationRoot', addUpdateVehicle?: { __typename?: 'AddUpdateVehicleMutation', vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, chassisNumber?: string | null, estimatedAverage: number, dateBought: any, status: VehicleStatus, dimensions?: Array<number | null> | null, fuelTankCapacity: number, modelName?: string | null, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, fuelType?: { __typename?: 'FuelGraphType', id: string, name: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string }, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, depot?: { __typename?: 'DepotType', id: string } | null, insurance?: { __typename?: 'InsuranceDetailType', id: string, name: string, idNumber: string, issuedOn: any, validTill: any, photo?: string | null } | null } | null } | null };

export type AddUpdateVehicleOwnerMutationMutationVariables = Exact<{
  owner?: InputMaybe<VehicleOwnerInput>;
}>;


export type AddUpdateVehicleOwnerMutationMutation = { __typename?: 'MutationRoot', addUpdateVehicleOwner?: { __typename?: 'AddUpdateVehicleOwnerMutation', owner?: { __typename?: 'BaseUserType', fullName?: string | null, id: string, firstName: string, lastName: string, status: BaseUserStatus, email: string, number: string, customerId: string, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, pincode?: string | null, state?: string | null, district?: string | null, taluka?: string | null, latitude: number, longitude: number, address?: string | null } | null, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountNumber: string, accountHolderName: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string } }> } | null } | null };

export type AddUpdateVehicleDriverMutationMutationVariables = Exact<{
  driver?: InputMaybe<VehicleDriverInput>;
}>;


export type AddUpdateVehicleDriverMutationMutation = { __typename?: 'MutationRoot', addUpdateVehicleDriver?: { __typename?: 'AddUpdateVehicleDriverMutation', driver?: { __typename?: 'BaseUserType', fullName?: string | null, id: string, firstName: string, lastName: string, number: string, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, licenceDetails: Array<{ __typename?: 'LicenceDetailType', id: string, idNumber: string, issuedOn: any, validTill: any, photo?: string | null }> } | null } | null };

export type DeleteVehicleMutationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type DeleteVehicleMutationMutation = { __typename?: 'MutationRoot', delVehicle?: { __typename?: 'DelVehicleMutation', vehicle?: { __typename?: 'VehicleType', id: string, registrationNumber: string, status: VehicleStatus } | null } | null };

export type UpdateVehicleStatusesMutationVariables = Exact<{
  vehicles: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  status: Scalars['String'];
}>;


export type UpdateVehicleStatusesMutation = { __typename?: 'MutationRoot', bulkUpdateVehicleStatus?: { __typename?: 'BulkUpdateVehicleStatusMutation', vehicles?: Array<{ __typename?: 'VehicleType', id: string, status: VehicleStatus } | null> | null } | null };

export type BulkUpdateVehicleDepartmentsMutationVariables = Exact<{
  vehicles: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  departments: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type BulkUpdateVehicleDepartmentsMutation = { __typename?: 'MutationRoot', bulkAddVehicleDepartment?: { __typename?: 'BulkAddVehicleDepartmentMutation', vehicles?: Array<{ __typename?: 'VehicleType', id: string, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }> } | null> | null } | null };

export type BulkUpdateVehicleVendorsMutationVariables = Exact<{
  userIds: Array<Scalars['ID']> | Scalars['ID'];
  status: Scalars['String'];
}>;


export type BulkUpdateVehicleVendorsMutation = { __typename?: 'MutationRoot', bulkUpdateVehicleUsers?: { __typename: 'BulkUpdateVehicleUsersMutation', users?: Array<{ __typename: 'BaseUserType', id: string, status: BaseUserStatus } | null> | null } | null };

export type AllVehicleListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AllVehicleListQuery = { __typename?: 'QueryRoot', allVehicles?: Array<{ __typename?: 'VehicleType', id: string, registrationNumber: string, estimatedAverage: number, status: VehicleStatus, createdAt: any, totalDistance?: number | null, advanceAmount?: number | null, fuelAmount?: number | null, totalWeight?: number | null, avgCostPerKg?: number | null, fuelLiters?: number | null, distance?: number | null, avgMileage?: number | null, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, alerts?: Array<{ __typename?: 'AlertObject', date?: any | null, message?: string | null } | null> | null, currentContract?: { __typename?: 'ContractType', id: string, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, codename: string } | null }, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, depot?: { __typename?: 'DepotType', id: string, name: string } | null } | null> | null };

export type VehicleMasterListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  period?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type VehicleMasterListQuery = { __typename?: 'QueryRoot', vehicleList?: Array<{ __typename?: 'VehicleType', id: string, registrationNumber: string, estimatedAverage: number, status: VehicleStatus, createdAt: any, totalDistance?: number | null, advanceAmount?: number | null, fuelAmount?: number | null, totalWeight?: number | null, avgCostPerKg?: number | null, fuelLiters?: number | null, distance?: number | null, avgMileage?: number | null, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, status: BaseUserStatus } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string } | null, alerts?: Array<{ __typename?: 'AlertObject', date?: any | null, message?: string | null } | null> | null, currentContract?: { __typename?: 'ContractType', id: string, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string, capacity: number, capacityUnit?: { __typename?: 'SIUnitType', id: string, codename: string } | null }, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, depot?: { __typename?: 'DepotType', id: string, name: string } | null } | null> | null };

export type VehicleDetailsQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VehicleDetailsQueryQuery = { __typename?: 'QueryRoot', vehicleDetails?: { __typename?: 'VehicleType', id: string, registrationNumber: string, chassisNumber?: string | null, estimatedAverage: number, dateBought: any, status: VehicleStatus, dimensions?: Array<number | null> | null, fuelTankCapacity: number, modelName?: string | null, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, dimensionUnit?: { __typename?: 'SIUnitType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, fuelType?: { __typename?: 'FuelGraphType', id: string, name: string } | null, vehicleType: { __typename?: 'VehicleGraphType', id: string, name: string, category: string }, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, depot?: { __typename?: 'DepotType', id: string } | null, insurance?: { __typename?: 'InsuranceDetailType', id: string, name: string, idNumber: string, issuedOn: any, validTill: any, photo?: string | null } | null } | null };

export type VehicleOwnerDetailsQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type VehicleOwnerDetailsQueryQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, status: BaseUserStatus, email: string, number: string, customerId: string, companies: Array<{ __typename?: 'CompanyType', id: string, name: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, pincode?: string | null, state?: string | null, district?: string | null, taluka?: string | null, latitude: number, longitude: number, address?: string | null } | null, bankDetails: Array<{ __typename?: 'BankDetailType', id: string, ifscCode: string, accountNumber: string, accountHolderName: string, branchName: string, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string, mediaType: MediaEntityMediaType }>, bank: { __typename?: 'BankType', id: string, name: string } }> } | null };

export type VehicleDriverDetailsQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type VehicleDriverDetailsQueryQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, number: string, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, photo?: string | null, idNumber: string, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, licenceDetails: Array<{ __typename?: 'LicenceDetailType', id: string, idNumber: string, issuedOn: any, validTill: any, photo?: string | null }> } | null };

export type AllVehiclesListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AllVehicleFilterInput>;
}>;


export type AllVehiclesListQuery = { __typename?: 'QueryRoot', allVehiclesDetail?: Array<{ __typename?: 'VehicleType', id: string, status: VehicleStatus, registrationNumber: string, vehicleKind?: { __typename?: 'VehicleKindType', id: string, name: string } | null, owner?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, driver?: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null } | null, alerts?: Array<{ __typename?: 'AlertObject', date?: any | null, message?: string | null } | null> | null, currentContract?: { __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null, contracts?: Array<{ __typename?: 'ContractType', id: string, number: string, contractCode?: string | null, dailyAllowance: number, totalPaid: number, totalExpense: number, totalOutstanding?: number | null, status: ContractStatus, startDate: any, endDate: any, contractType: { __typename?: 'ContractGraphType', id: string, name: string } } | null> | null, departments: Array<{ __typename?: 'DepartmentType', id: string, name: string }>, vehicleType: { __typename?: 'VehicleGraphType', id: string, category: string, name: string } } | null> | null };

export type AllVehiclesSummaryQueryVariables = Exact<{
  departmentId: Scalars['ID'];
  date?: InputMaybe<Scalars['Date']>;
  distributionCenterId?: InputMaybe<Scalars['ID']>;
}>;


export type AllVehiclesSummaryQuery = { __typename?: 'QueryRoot', summaryAllVehicle?: { __typename?: 'SummaryAllVehicles', totalVehicles?: number | null, usableVehicles?: number | null, unusableVehicles?: number | null, availableVehicles?: number | null, unavailableVehicles?: number | null, plannedVehicles?: number | null, unplannedVehicles?: number | null, breakdownVehicles?: number | null, onleaveVehicles?: number | null, archivedVehicles?: number | null } | null };

export type VendorDetailFragFragment = { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, username: string, dateOfBirth?: any | null, number: string, gender?: BaseUserGender | null, email: string, education?: BaseUserEducation | null, customerId: string, status: BaseUserStatus, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, idNumber: string, photo?: string | null, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, pincode?: string | null, taluka?: string | null, state?: string | null, district?: string | null, latitude: number, longitude: number } | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }> };

export type AddUpdateVendorMutationVariables = Exact<{
  deleteKycIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  address: AddressInput;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  education?: InputMaybe<BaseUserEducationEnum>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<BaseUserGenderEnum>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  kycDetail?: InputMaybe<Array<InputMaybe<KycDetailInput>> | InputMaybe<KycDetailInput>>;
  lastName: Scalars['String'];
  number: Scalars['String'];
  referenceId?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['ID']>;
  username: Scalars['String'];
}>;


export type AddUpdateVendorMutation = { __typename?: 'MutationRoot', addUpdateVendor?: { __typename?: 'AddUpdateBasicVendorMutation', user?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, username: string, dateOfBirth?: any | null, number: string, gender?: BaseUserGender | null, email: string, education?: BaseUserEducation | null, customerId: string, status: BaseUserStatus, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, idNumber: string, photo?: string | null, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, pincode?: string | null, taluka?: string | null, state?: string | null, district?: string | null, latitude: number, longitude: number } | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null } | null };

export type BulkUpdateVendorsMutationVariables = Exact<{
  userIds: Array<Scalars['ID']> | Scalars['ID'];
  status: Scalars['String'];
}>;


export type BulkUpdateVendorsMutation = { __typename?: 'MutationRoot', bulkUpdateUsers?: { __typename?: 'BulkUpdateUsersMutation', users?: Array<{ __typename?: 'BaseUserType', id: string, status: BaseUserStatus, statusObj?: { __typename?: 'ClientStatusType', id?: number | null, intent?: string | null, name?: string | null } | null } | null> | null } | null };

export type AddUpdateUserCreditMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
  totalAmount: Scalars['Float'];
  paymentCycleDays?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type AddUpdateUserCreditMutation = { __typename?: 'MutationRoot', addUpdateCredit?: { __typename?: 'AddUpdateCreditMutation', credit?: { __typename?: 'CreditType', id: string, totalAmount: number, remainingAmount: number, usedAmount: number, paymentCycleDays: number, startDate?: any | null, endDate?: any | null, isActive: boolean, status: CreditStatus, user: { __typename?: 'DeliveryAgentManagementType', id: string, firstName: string } } | null } | null };

export type VendorListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  groupName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UsersByGroupFilterInput>;
}>;


export type VendorListQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string, isBlocked?: boolean | null, blockRemark?: string | null, status: BaseUserStatus, customerId: string, createdAt: any, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }>, statusObj?: { __typename?: 'ClientStatusType', id?: number | null, name?: string | null, intent?: string | null } | null, accounts?: Array<{ __typename?: 'CommonAccountType', id: string, balance: number, name: string, codename: string, accountType: { __typename?: 'CommonAccountCategoryType', id: string, name: string } } | null> | null, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, district?: string | null } | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> } | null> | null };

export type VendorDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type VendorDetailQuery = { __typename?: 'QueryRoot', userDetails?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, fullName?: string | null, isBlocked?: boolean | null, blockRemark?: string | null, username: string, dateOfBirth?: any | null, number: string, gender?: BaseUserGender | null, email: string, education?: BaseUserEducation | null, customerId: string, status: BaseUserStatus, creditSet?: Array<{ __typename?: 'CreditType', id: string, totalAmount: number, remainingAmount: number, usedAmount: number, paymentCycleDays: number, startDate?: any | null, endDate?: any | null, isActive: boolean, status: CreditStatus } | null> | null, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }>, kycDetails: Array<{ __typename?: 'KYCDetailType', id: string, idNumber: string, photo?: string | null, kycType: { __typename?: 'KYCGraphType', id: string, name: string } }>, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, pincode?: string | null, taluka?: string | null, state?: string | null, district?: string | null, latitude: number, longitude: number } | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string }> } | null };

export type VendorMapListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  groupName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UsersByGroupFilterInput>;
}>;


export type VendorMapListQuery = { __typename?: 'QueryRoot', usersByGroup?: Array<{ __typename?: 'BaseUserType', id: string, fullName?: string | null, number: string, status: BaseUserStatus, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, district?: string | null, latitude: number, longitude: number } | null } | null> | null };

export type VendorsSummaryQueryVariables = Exact<{
  latestDays?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SummaryUsersEcomFilterInput>;
}>;


export type VendorsSummaryQuery = { __typename?: 'QueryRoot', summaryUsersEcom?: { __typename?: 'SummaryUsersEcom', activeCustomers?: number | null, inactiveCustomers?: number | null, totalCustomers?: number | null, verifiedCustomers?: number | null, notVerifiedCustomers?: number | null } | null };

export type TransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionDetailInput>;
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type TransactionsQuery = { __typename?: 'QueryRoot', allAccountTransactions?: Array<{ __typename?: 'TransactionGraphType', id: string, date: any, status: TransactionStatus, amount: number, referenceId: string, remark?: string | null, account: { __typename?: 'AccountType', name: string, balance: number, codename: string, id: string }, paymentMethod: { __typename?: 'PaymentMethodType', codename: string, id: string, name: string }, transactionType: { __typename?: 'TransactionTypeType', id: string, name: string }, attachments: Array<{ __typename?: 'MediaEntityType', id: string, url: string }> } | null> | null };

export type AccountStatementQueryVariables = Exact<{
  userId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
}>;


export type AccountStatementQuery = { __typename?: 'QueryRoot', accountStatement?: { __typename?: 'AccountStatement', dateFrom?: any | null, dateTo?: any | null, statementDate?: any | null, currency?: string | null, openingBalance?: any | null, totalDebit?: any | null, totalCredit?: any | null, closingBalance?: any | null, creditLimit?: any | null, creditUsed?: any | null, customer?: { __typename?: 'StatementCustomer', id?: string | null, accountNumber?: string | null, businessName?: string | null, pocName?: string | null, mobileNumber?: string | null, email?: string | null, address?: string | null, district?: string | null, state?: string | null, pincode?: string | null, gstin?: string | null, isActive?: boolean | null, isBlocked?: boolean | null, vendorTypes?: Array<string | null> | null } | null, issuer?: { __typename?: 'StatementIssuer', name?: string | null, address?: string | null, gstin?: string | null, cin?: string | null, pan?: string | null, number?: string | null, email?: string | null, website?: string | null } | null, transactions?: Array<{ __typename?: 'StatementTransaction', date?: any | null, docNumber?: string | null, docType?: string | null, invoiceNo?: string | null, taxableValue?: any | null, gstValue?: any | null, withholdingTax?: any | null, debitAmount?: any | null, creditAmount?: any | null, closingBalance?: any | null } | null> | null } | null };

export type OutstandingUserDetailQueryVariables = Exact<{
  userId: Scalars['ID'];
  filter?: InputMaybe<OutstandingOrderDateFilterInput>;
}>;


export type OutstandingUserDetailQuery = { __typename?: 'QueryRoot', outstandingUserDetail?: { __typename?: 'OutstandingUserDetailType', totalOutstandingOrders: number, grossOrderValue: number, totalOutstandingAmount: number, user: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, number: string, address?: { __typename?: 'AddressType', id: string, village: string, address?: string | null, district?: string | null, pincode?: string | null } | null, groups: Array<{ __typename?: 'GroupType', id: string, name: string, category?: { __typename?: 'GroupCategoryType', id: string, codename: string } | null }> }, shops: Array<{ __typename?: 'ShopType', id: string, name: string, number?: string | null, address: { __typename?: 'AddressType', id: string, village: string, address?: string | null, district?: string | null, pincode?: string | null } } | null>, orders: Array<{ __typename?: 'OrderType', date: any, id: string, isConsolidated?: boolean | null, orderStatus: OrderOrderStatus, trackingCode: string, outstandingAmount: number, paymentMethod: OrderPaymentMethod, paymentStatus: OrderPaymentStatus, totalAmount: number, createdAt: any, metadata: any, deliveryStatus: OrderDeliveryStatus, orderCategory: OrderOrderCategory, soNumber?: string | null, totalPaid?: number | null, pickupDate?: any | null, shop?: { __typename?: 'ShopType', id: string, name: string } | null, discount?: { __typename?: 'DiscountType', id: string, percentage: number, flat: number } | null, orderItems?: Array<{ __typename?: 'OrderItemType', id: string, metadata: any, discount?: { __typename?: 'DiscountType', id: string, percentage: number, flat: number } | null } | null> | null, user: { __typename?: 'DeliveryAgentManagementType', id: string, fullName?: string | null, number: string, shopsManaged: Array<{ __typename?: 'ShopType', id: string, name: string }> }, shippingAddress: { __typename?: 'AddressType', id: string, address?: string | null, village: string, district?: string | null }, transactions?: Array<{ __typename?: 'OrderTransactionType', id: string, referenceId: string, amount: number, createdAt: any } | null> | null } | null> } | null };

export type FetchBatchStockStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchBatchStockStatusQuery = { __typename?: 'QueryRoot', fetchBatchStockStatus?: { __typename?: 'FetchBatchStockStatusType', taskId?: string | null, status: string, requestedAt?: any | null, executedAt?: any | null, isExecuted: boolean, canExecute: boolean, retryAfterSeconds: number } | null };

export type MutFetchBatchStockMutationVariables = Exact<{
  interval: Scalars['Int'];
}>;


export type MutFetchBatchStockMutation = { __typename?: 'MutationRoot', fetchBatchStock?: { __typename?: 'FetchBatchStockMutation', success: boolean, taskId: string } | null };

export const CurrentUserFragFragmentDoc = gql`
    fragment CurrentUserFrag on BaseUserType {
  id
  number
  username
  fullName
  email
  photo
  isSuperadmin
  permissions
  groups {
    id
    name
  }
  currentDepartment {
    id
    demandWhatsappApproval
    kiteReferenceId
    pricingDoneOn
    gateEntryRequired
    defaultPerUnit {
      id
      name
      capacity
      selfWeight
      capacityUnit {
        id
        name
        codename
      }
    }
    name
    photo
    metadata
    invoiceType
    controlPricing
    hasDynamicStock
    optionalPricing
    qcSubscription
    defaultTraderVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
    isB2c
    access {
      id
      codename
    }
    generatePoAfterInward
    companies {
      id
      name
    }
  }
  departments {
    id
    name
    photo
  }
}
    `;
export const BenchmarkListFragFragmentDoc = gql`
    fragment BenchmarkListFrag on PriceBenchmarkRecommendationType {
  id
  date
  commodityGroup {
    id
    name
    codename
  }
  grade {
    id
    name
  }
  marketYard {
    id
    name
    address {
      id
      village
    }
  }
  averagePrice {
    id
    price
    pricingDoneOn
    priceUnit {
      id
      name
    }
    uomType {
      id
      name
    }
  }
  recommendedPrice {
    id
    price
    pricingDoneOn
    priceUnit {
      id
      name
    }
    uomType {
      id
      name
    }
  }
}
    `;
export const CompanyDetailFragFragmentDoc = gql`
    fragment CompanyDetailFrag on CompanyType {
  id
  name
  codename
  displayName
  departments {
    id
    name
  }
}
    `;
export const ContractDetailFragFragmentDoc = gql`
    fragment ContractDetailFrag on ContractType {
  id
  resourceAmount
  startDate
  endDate
  status
  contractCode
  dailyAllowance
  contractType {
    id
    name
    codename
  }
  contractrecurringexpenseSet {
    id
    shift {
      id
      name
    }
    cost
    unitCount
  }
}
    `;
export const DemandListFragFragmentDoc = gql`
    fragment DemandListFrag on DemandType {
  id
  date
  name
  isLive
  isVerified
  dateTill
  broadcastTime
  varietyGroup {
    id
    name
    codename
  }
  inwardedQuantity
  priceSummary {
    minPrice
    avgPrice
    maxPrice
  }
  variety {
    id
    name
    commodity {
      id
      name
    }
  }
  depot {
    id
    name
  }
  gradePrices {
    id
    grade {
      id
      name
    }
    price
    priceLimit
    priceUnit {
      id
      name
    }
    isDefault
  }
  timeSlots {
    id
    timeSlot {
      id
      name
      fromTime
      toTime
    }
    bookedQuantity
    quantity
    quantityUnit {
      id
      name
    }
  }
}
    `;
export const TripOrdersFragFragmentDoc = gql`
    fragment TripOrdersFrag on TripType {
  id
  status
  labourCount
  DEPOrganisationUser {
    id
    fullName
  }
  date
  vehicle {
    id
    registrationNumber
    vehicleType {
      id
      name
      capacity
      capacityUnit {
        id
        codename
      }
    }
    driver {
      id
      fullName
      number
    }
  }
  sourceDepot {
    id
    name
    location {
      id
      latitude
      longitude
    }
  }
  estimatedStartTime
  destinationDepot {
    id
    name
    location {
      id
      latitude
      longitude
    }
  }
  transportDetail {
    id
    advanceCost
    transportCost
  }
  aggregator {
    id
    fullName
  }
  bookings {
    id
    requiredQuantity
    order {
      id
      orderStatus
      totalWeight
      shippingCharges
      discount {
        id
        flat
        percentage
      }
      metadata
      user {
        id
        fullName
      }
      crateCount
      shippingAddress {
        id
        latitude
        longitude
        village
        district
        address
      }
      orderItems {
        id
        quantity
        rate
        sellableItem {
          id
          name
        }
      }
    }
    orderItem {
      id
      quantity
      rate
      metadata
      discount {
        id
        flat
        percentage
      }
      actualRate
      bookedQuantity
      sellableItem {
        id
        name
        taxes {
          id
          name
          percentage
        }
      }
    }
    schedule {
      id
    }
  }
  loadingPattern
  estimatedDespatchTime
}
    `;
export const TimeSlotFragFragmentDoc = gql`
    fragment TimeSlotFrag on TimeSlotType {
  id
  name
  fromTime
  maximumOrders
  toTime
  thresholdFrom
  estimatedDelivery
}
    `;
export const DistributionCenterListFragFragmentDoc = gql`
    fragment DistributionCenterListFrag on DistributionCentreType {
  id
  name
  archive
  photos {
    id
    url
  }
  address {
    id
    village
    state
  }
  pointOfContacts {
    id
    fullName
    number
  }
  allowedDepartments {
    id
    name
  }
  deliveryConditions
  deliverySlots {
    ...TimeSlotFrag
  }
  pickupSlots {
    ...TimeSlotFrag
  }
  maintenanceSlots {
    ...TimeSlotFrag
  }
  alternateSalesSlots {
    ...TimeSlotFrag
  }
}
    ${TimeSlotFragFragmentDoc}`;
export const DistributionCenterDetailFragFragmentDoc = gql`
    fragment DistributionCenterDetailFrag on DistributionCentreProperties {
  currentStockPercentage
  name
  archive
  codename
  customerCode
  plantCode
  storeCode
  colorCode
  salesOfcCode
  partnerCode
  companyCode
  bankDetails {
    id
    ifscCode
    attachments {
      id
      url
      mediaType
    }
    bank {
      id
      name
      codename
    }
    accountHolderName
    accountNumber
    branchName
  }
  allowedDepartments {
    id
    name
  }
  assignedCpc {
    id
    name
  }
  certifications {
    id
    idNumber
    certificationType {
      id
      name
      codename
    }
    validFrom
    validTill
    attachments {
      id
      url
      mediaType
    }
  }
  groupVisibility {
    id
    name
    category {
      id
      name
      codename
    }
  }
  photos {
    id
    url
  }
  primaryPoc {
    id
    fullName
    number
  }
  address {
    id
    village
    taluka
    latitude
    longitude
    geofenceRadius
    state
    district
    pincode
    address
  }
  pointOfContacts {
    id
    fullName
    number
  }
  deliveryConditions {
    deliveryCosts {
      costRange
      deliveryCost
    }
    estimatedDelta
    minCartValue
    isManufacturingPlant
    extraSapCodes {
      businessPlace
      profitCenter
      costCenter
    }
    gstDetails {
      gstin
      registeredName
      address1
      address2
      stateName
      stateCode
      district
      pincode
    }
  }
  deliverySlots {
    ...TimeSlotFrag
  }
  maintenanceSlots {
    ...TimeSlotFrag
  }
  pickupSlots {
    ...TimeSlotFrag
  }
  surveyareaSet {
    id
    geometry {
      type
      coordinates
    }
    properties {
      isActive
      name
      codename
      primaryUser {
        id
        fullName
        number
      }
      updatedAt
      users {
        id
        fullName
        number
      }
    }
  }
  alternateSalesSlots {
    ...TimeSlotFrag
  }
}
    ${TimeSlotFragFragmentDoc}`;
export const StorageLocationFragFragmentDoc = gql`
    fragment StorageLocationFrag on DCStorageLocationType {
  id
  name
  codename
  archive
  colorCode
  responsiblePerson {
    id
    firstName
    lastName
    fullName
    number
  }
  subLocations {
    id
    name
    codename
  }
}
    `;
export const DockFragFragmentDoc = gql`
    fragment DockFrag on DockType {
  id
  name
  archive
  codename
  distributionCentre {
    id
    name
  }
  depot {
    id
    name
  }
}
    `;
export const UserGroupsCompaniesFragFragmentDoc = gql`
    fragment UserGroupsCompaniesFrag on BaseUserType {
  companies {
    id
    kind
    name
    codename
  }
  groups {
    id
    name
    category {
      id
      codename
    }
  }
}
    `;
export const FarmerDetailsFragFragmentDoc = gql`
    fragment FarmerDetailsFrag on BaseUserType {
  id
  firstName
  lastName
  number
  secondaryNumbers {
    id
    number
  }
  isBlocked
  blockRemark
  referenceId
  companyCode
  email
  username
  ...UserGroupsCompaniesFrag
  dateOfBirth
  gender
  education
  kycDetails {
    id
    kycType {
      id
      name
    }
    idNumber
  }
  address {
    id
    village
    address
    pincode
    taluka
    state
    district
    latitude
    longitude
  }
  bankDetails {
    id
    bank {
      id
      name
    }
    attachments {
      id
      url
      mediaType
    }
    ifscCode
    branchName
    accountNumber
    accountHolderName
  }
}
    ${UserGroupsCompaniesFragFragmentDoc}`;
export const FarmerListFragFragmentDoc = gql`
    fragment FarmerListFrag on BaseUserType {
  id
  fullName
  createdAt
  username
  isBlocked
  blockRemark
  companyCode
  groups {
    id
    name
  }
  plots {
    id
    codename
    crops {
      id
      variety {
        id
        name
      }
    }
  }
  number
  status
}
    `;
export const GroupDetailFragFragmentDoc = gql`
    fragment GroupDetailFrag on GroupType {
  id
  name
  userCount
  permissions {
    id
    name
    codename
  }
}
    `;
export const QualityBaseFragFragmentDoc = gql`
    fragment QualityBaseFrag on QualitySampleType {
  id
  recordedOn
  qualityRejection
  reason
  status
}
    `;
export const BatchFragFragmentDoc = gql`
    fragment BatchFrag on WeighBatchType {
  id
  skuCount
  skuType {
    id
    name
  }
  uomType {
    id
    codename
    name
  }
  uomCount
  codename
  skuTareWeight
  grossWeight
  netWeight
  tareWeight
}
    `;
export const BatchWeighFragFragmentDoc = gql`
    fragment BatchWeighFrag on WeighType {
  id
  date
  grade {
    id
  }
  status
  farmWeight
  grossWeight
  tareWeight
  netWeight
  finalWeight
  invoicingDoneOn
  standardDeduction
  inwardedQuantity
  batches {
    ...BatchFrag
  }
}
    ${BatchFragFragmentDoc}`;
export const InwardFragFragmentDoc = gql`
    fragment InwardFrag on InwardType {
  id
  grn
  grade {
    id
    name
    specifications
  }
  quality {
    ...QualityBaseFrag
  }
  weigh {
    ...BatchWeighFrag
  }
}
    ${QualityBaseFragFragmentDoc}
${BatchWeighFragFragmentDoc}`;
export const BulkWeighFragFragmentDoc = gql`
    fragment BulkWeighFrag on WeighType {
  id
  status
  updatedAt
  grade {
    id
    name
  }
  skuType {
    id
    name
  }
  farmWeight
  grossWeight
  tareWeight
  inwardedQuantity
  standardDeduction
  netWeight
  weightLoss
  finalWeight
}
    `;
export const InwardQualityFragFragmentDoc = gql`
    fragment InwardQualityFrag on InwardType {
  id
  grade {
    id
    name
    specifications
  }
  quality {
    ...QualityBaseFrag
  }
}
    ${QualityBaseFragFragmentDoc}`;
export const BatchInwardFragFragmentDoc = gql`
    fragment BatchInwardFrag on InwardType {
  id
  serialNo
  rstNo
  grn
  ...InwardQualityFrag
  weigh {
    id
    inwardedQuantity
    farmWeight
    weightLoss
    netWeight
    status
    standardDeduction
    batches {
      ...BatchFrag
    }
  }
}
    ${InwardQualityFragFragmentDoc}
${BatchFragFragmentDoc}`;
export const WeighScheduleFragFragmentDoc = gql`
    fragment WeighScheduleFrag on ScheduleType {
  id
  gatelogsSet {
    id
    createdAt
    gateEntryNo
    gateStatus
    gateNumber {
      id
      name
      codename
    }
  }
  date
  requiredQuantity
  scheduledIn {
    id
    packagingMaterialFlow
  }
  unloadingLocation {
    id
    name
  }
  unloadingSubLocation {
    id
    name
  }
  packagingMaterial {
    id
    createdAt
    fieldSupervisorName {
      id
      fullName
    }
    packagingMaterialItems {
      id
      receivedQuantity
    }
    netWeightAfterDeduction
    totalReceivedQuantity
  }
  skuType {
    id
    name
    capacity
    selfWeight
    capacityUnit {
      id
      name
      codename
    }
  }
  cropGroup {
    id
    name
    codename
  }
  farmQuantityUnit {
    id
    name
    codename
  }
  plotCommodity {
    name
    id
    referenceId
  }
  gradePrices {
    id
    grade {
      id
      name
    }
  }
  pricingDoneOn
  transportDetail {
    id
    standardDeduction
  }
  variety {
    id
    name
    packagingMaterialFlow
    commodity {
      id
      name
    }
  }
  farmWeight
  gatePass
  aggregator {
    id
    fullName
  }
  plot {
    id
    codename
    name
    farmer {
      id
      fullName
      username
      isBlocked
    }
    address {
      id
      village
    }
  }
}
    `;
export const TripDetailFragFragmentDoc = gql`
    fragment TripDetailFrag on TripType {
  id
  status
  expense
  unloadedBy {
    id
    name
    contact
  }
  weighDetail {
    ...BulkWeighFrag
  }
  bookings {
    id
    qualitySample {
      ...QualityBaseFrag
    }
    inwards {
      ...BatchInwardFrag
    }
    schedule {
      ...WeighScheduleFrag
    }
  }
}
    ${BulkWeighFragFragmentDoc}
${QualityBaseFragFragmentDoc}
${BatchInwardFragFragmentDoc}
${WeighScheduleFragFragmentDoc}`;
export const FrontendTripDetailFragFragmentDoc = gql`
    fragment FrontendTripDetailFrag on TripType {
  id
  expense
  status
  unloadedBy {
    id
    name
    contact
  }
  weighDetail {
    ...BulkWeighFrag
  }
  bookings {
    id
    procuredQuantity
    requiredQuantity
    pickupTime
    inwards {
      ...BatchInwardFrag
    }
    orderItem {
      id
      sellableItem {
        id
        name
        secondarySkuType {
          id
          name
          selfWeight
        }
      }
      shipping {
        id
        distributionCentre {
          id
          name
        }
      }
      order {
        id
        trackingCode
        user {
          id
          fullName
          address {
            id
            address
            village
          }
        }
      }
    }
    schedule {
      id
      gatePass
      transportDetail {
        id
        standardDeduction
      }
    }
  }
}
    ${BulkWeighFragFragmentDoc}
${BatchInwardFragFragmentDoc}`;
export const NotificationTemplateTypeDetailFragFragmentDoc = gql`
    fragment NotificationTemplateTypeDetailFrag on NotificationTemplateType {
  id
  alias
  body
  title
  body
}
    `;
export const NotificationFragFragmentDoc = gql`
    fragment NotificationFrag on NotificationType {
  id
  template {
    id
    name: alias
  }
  users {
    id
    fullName
    number
  }
  messegeType
  groups: userGroups {
    id
    name
  }
}
    `;
export const NotificationTemplateDetailV1FragFragmentDoc = gql`
    fragment NotificationTemplateDetailV1Frag on NewNotificationTemplateType {
  id
  body
  codename
  isActive
  title
  name
  title
  provider {
    id
    name
    codename
    kind
  }
  isProgrammatic
  providerVariables
  dataVariables
  extraFields
  dataSource {
    id
    inputs
    name
    outputs
    isActive
    codename
  }
}
    `;
export const UserQueryFragFragmentDoc = gql`
    fragment UserQueryFrag on UserQueryType {
  id
  name
  codename
  filters {
    id
    alias: displayName
    referenceQuery
    fieldType
    value
    isRangeValue
    exclude
  }
}
    `;
export const OrderListFragFragmentDoc = gql`
    fragment OrderListFrag on OrderType {
  id
  isConsolidated
  orderStatus
  trackingCode
  outstandingAmount
  paymentMethod
  paymentStatus
  totalAmount
  createdAt
  metadata
  discount {
    id
    percentage
    flat
  }
  orderItems {
    id
    metadata
    discount {
      id
      percentage
      flat
    }
  }
  deliveryStatus
  orderCategory
  soNumber
  user {
    id
    fullName
    number
    shopsManaged {
      id
      name
    }
  }
  totalPaid
  shippingAddress {
    id
    address
    village
    district
  }
  user {
    id
    number
    fullName
  }
  pickupDate
  transactions {
    id
    referenceId
    amount
    createdAt
  }
}
    `;
export const OrderDetailFragFragmentDoc = gql`
    fragment OrderDetailFrag on OrderType {
  id
  trackingCode
  outstandingAmount
  date
  soNumber
  isConsolidated
  deliveryStatus
  paymentStatus
  orderStatus
  paymentMethod
  shippingMethod
  pocName
  pocNumber
  totalAmount
  totalPaid
  crateCount
  billingDoc {
    id
    billingDocNumber
  }
  orderItems {
    id
    shipping {
      id
      estimatedDelivery
    }
  }
  user {
    id
    fullName
    number
    email
  }
  pocName
  pocNumber
  shippingAddress {
    id
    village
    address
  }
  transactions {
    id
    paymentMethod
    attachment {
      id
      url
    }
    referenceId
    amount
    status
  }
}
    `;
export const PeriodicTaskDetailFragFragmentDoc = gql`
    fragment PeriodicTaskDetailFrag on PeriodicTaskType {
  id
  task
  name
  enabled
  startTime
  oneOff
  scheduleName
  logs {
    id
    isOk
    createdAt
    responseCode
    requestData
    responseData
  }
  latestLog {
    id
    isOk
  }
}
    `;
export const PackingallotmentSetFragmentDoc = gql`
    fragment packingallotmentSet on PackingAllotmentSelectorType {
  id
  allotedQuantity
  allotedWeight
  sendToLine
  productionLine {
    id
    name
  }
  createdAt
  updatedAt
  reverseWeight
  reversalReason
  reverseQuantity
  supervisor {
    id
    fullName
  }
}
    `;
export const ReportTemplateListFragFragmentDoc = gql`
    fragment ReportTemplateListFrag on ReportTemplateType {
  id
  name
  title
  createdAt
  emailTo
  recommendedEmails
  latestDelivery {
    id
    createdAt
    isDelivered
  }
  createdBy {
    id
    fullName
  }
  source {
    id
    alias
    filters {
      id
      alias
      fieldType
      isRangeValue
      referenceQuery
    }
  }
  groupsShared {
    id
    name
  }
}
    `;
export const ReportTemplateDetailFragFragmentDoc = gql`
    fragment ReportTemplateDetailFrag on ReportTemplateType {
  id
  name
  title
  createdAt
  createdBy {
    id
    fullName
  }
  columns {
    id
    aggregateType
    reportItem {
      id
      alias
      fieldType
    }
  }
  source {
    id
    alias
    groupings {
      id
      name: alias
    }
    columns {
      id
      alias
    }
  }
  groupBy {
    id
    name: alias
  }
  usersShared {
    id
    fullName
  }
  groupsShared {
    id
    name
  }
}
    `;
export const ScheduleVehicleFragFragmentDoc = gql`
    fragment ScheduleVehicleFrag on VehicleType {
  id
  registrationNumber
  vehicleType {
    id
    category
    capacity
  }
  depot {
    id
    name
  }
}
    `;
export const GradePriceFragFragmentDoc = gql`
    fragment GradePriceFrag on GradePriceType {
  id
  price
  priceUnit {
    id
    name
  }
  grade {
    id
    name
  }
}
    `;
export const TransportDetailFragFragmentDoc = gql`
    fragment TransportDetailFrag on VehicleTransportDetailType {
  id
  farmWeight
  acceptedDeduction
  standardDeduction
  deductionRate
  weightApplicable
  transportPaidBy
  transportCost
  advancePaidBy
  advanceCost
  rejectionBourneBy
  remark
  pricingDoneOn
  gradePrices {
    id
    grade {
      id
      name
    }
    price
  }
}
    `;
export const PackagingMaterialItemsFragFragmentDoc = gql`
    fragment PackagingMaterialItemsFrag on PackagingMaterialItemType {
  id
  whatsappApproval
  skuType {
    id
    name
    unitPrice
    selfWeight
  }
  quantity
  receivedQuantity
  fourHand
  fiveHand
  sixHand
  sevenEightHand
  cluster
  remark
}
    `;
export const PackagingMaterialFragFragmentDoc = gql`
    fragment PackagingMaterialFrag on PackagingMaterialType {
  id
  sendWhatsappApproval
  fieldSupervisorName {
    id
    fullName
  }
  pmSupervisorName {
    id
    fullName
  }
  areaInchargeName {
    id
    fullName
  }
  weightSlip
  wasteageWt
  leafWt
  stickWt
  deductionWt
  totalHarvestWt
  packagingMaterialItems {
    ...PackagingMaterialItemsFrag
  }
}
    ${PackagingMaterialItemsFragFragmentDoc}`;
export const ScheduleSkuFragFragmentDoc = gql`
    fragment ScheduleSkuFrag on SKUGraphType {
  id
  name
  capacity
  capacityUnit {
    id
    name
    codename
  }
}
    `;
export const ScheduleListFragFragmentDoc = gql`
    fragment ScheduleListFrag on ScheduleType {
  id
  updated
  gatePass
  estimatedQuantity
  requiredQuantity
  farmWeight
  labourCount
  isNotified
  isEdited
  timeToLeave
  transportServiceProvider {
    id
    fullName
    referenceId
  }
  scheduledIn {
    id
    name
    packagingMaterialFlow
  }
  packagingMaterial {
    ...PackagingMaterialFrag
  }
  timeToReach
  remark
  gradePrices {
    id
    grade {
      id
    }
    price
  }
  booking {
    inwards {
      status
    }
  }
  sourceDepot {
    id
    name
  }
  destinationDepot {
    id
    name
  }
  company {
    id
    name
    displayName
    codename
  }
  skuType {
    ...ScheduleSkuFrag
  }
  farmQuantityUnit {
    id
    name
    codename
  }
  cropGroup {
    id
    isFinishedGood
    isRawMaterial
    name
  }
  variety {
    id
    name
    packagingMaterialFlow
    groups {
      id
      name
      isFinishedGood
      isRawMaterial
      codename
    }
    preferredSku {
      id
      name
      capacity
      capacityUnit {
        id
        name
      }
    }
    commodity {
      id
      name
    }
  }
  plotCommodity {
    id
    name
    registrationCode
    generatePoPlotWise
    isFinishedGood
    isRawMaterial
    alternateCropGroup {
      id
      name
    }
  }
  plot {
    id
    name
    company {
      id
    }
    farmer {
      id
      fullName
      isBlocked
      blockRemark
      firstName
      lastName
      companies {
        id
      }
    }
    certifications {
      id
      certificationType {
        id
        name
      }
      certificationNumber
    }
    address {
      id
      village
    }
  }
  aggregator {
    id
    fullName
    firstName
    lastName
  }
  vehicle {
    id
    registrationNumber
  }
}
    ${PackagingMaterialFragFragmentDoc}
${ScheduleSkuFragFragmentDoc}`;
export const SellableItemListFragFragmentDoc = gql`
    fragment SellableItemListFrag on SellableItemType {
  id
  name
  shortDescription
  primaryPhoto {
    id
    url
  }
  itemGroups {
    id
    name
  }
  sellableVarieties {
    id
    name
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  allowedDepartments {
    id
    name
  }
}
    `;
export const SellableItemDetailsFragFragmentDoc = gql`
    fragment SellableItemDetailsFrag on SellableItemType {
  id
  name
  codename
  currentStockPercentage
  shortDescription
  longDescription
  transportationType
  externalReferences {
    id
    objectId
    referenceId
    externalApp {
      id
      codename
      name
    }
  }
  secondarySkuType {
    id
    capacity
    name
  }
  itemGroups {
    id
    name
  }
  metadata {
    eanCode
    fssaiLicense
    hsnCode
    isVariant
  }
  photos {
    id
    mediaType
    url
  }
  primaryPhoto {
    id
    mediaType
    url
  }
  sellableVarieties {
    id
    name
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    grade {
      id
      name
    }
    uomCount
    uomType {
      id
      name
      codename
    }
    skuCount
    skuType {
      id
      name
    }
  }
  allowedDepartments {
    id
    name
  }
}
    `;
export const RelatedStockFragFragmentDoc = gql`
    fragment RelatedStockFrag on SellableItemStockType {
  id
  groupVisibility {
    id
    name
  }
  distributionCentre {
    id
    name
  }
  offerStockCount
}
    `;
export const SellableItemStockDetailFragFragmentDoc = gql`
    fragment SellableItemStockDetailFrag on SellableItemStockType {
  id
  expiryDate
  variantStocks {
    id
    currentStockCount
    sellableItem {
      id
      name
      secondarySkuType {
        id
        capacity
      }
    }
    batchStocks {
      id
      name: codename
      totalQuantity
      currentStockCount
      expiryOn
      manufacturedOn
      manufacturedBy {
        id
      }
      suppliedBy {
        id
      }
    }
    unitRate
    discountedRate
    offerStockCount
    orderingConditions
    groupVisibility {
      id
      name
      category {
        id
        codename
        name
      }
    }
  }
  sellableItem {
    id
    name
    secondarySkuType {
      id
      capacity
    }
    currentStockPercentage
    childSellableItems {
      id
      name
      secondarySkuType {
        id
        capacity
      }
    }
  }
  unitRate
  isLive
  orderingConditions
  groupVisibility {
    id
    name
    category {
      id
      codename
      name
    }
  }
  minRate
  maxRate
  currentStockCount
  holdStockCount
  offerStockCount
  currentStockPercentage
  currentStockType
  discountedRate
  relatedStock {
    ...RelatedStockFrag
  }
  distributionCentre {
    id
    name
    currentStockPercentage
  }
}
    ${RelatedStockFragFragmentDoc}`;
export const SkuDetailFragFragmentDoc = gql`
    fragment SkuDetailFrag on SKUGraphType {
  id
  name
  description
  capacity
  createdAt
  dimensions
  unitPrice
  isReturnable
  metadata
  dimensionUnit {
    id
    name
    codename
  }
  skuCategory {
    id
    name
    codename
  }
  capacityUnit {
    id
    name
    codename
  }
  stockCount
  selfWeight
}
    `;
export const PlotSampleFragFragmentDoc = gql`
    fragment PlotSampleFrag on PlotCommoditySampleType {
  id
  chemicalStatus
  chemicalStatusDisplay
  chemicalTestDate
  market {
    id
    name
    codename
  }
  detectionCount
  maxDetection
  totalDetection
}
    `;
export const PlotCommodityFragFragmentDoc = gql`
    fragment PlotCommodityFrag on PlotCommodityType {
  id
  name
  referenceId
  isArchived
  agronomist {
    id
    fullName
  }
  variety {
    id
    name
    commodity {
      id
      name
    }
  }
  sowingDate
  harvestingDate
  growingCycle
  samples {
    ...PlotSampleFrag
  }
  statusDisplay
  status
  plot {
    id
    codename
    area
    farmer {
      id
      companyCode
      fullName
      groups {
        id
        name
      }
      companies {
        id
        displayName
        codename
      }
    }
    address {
      id
      village
    }
  }
}
    ${PlotSampleFragFragmentDoc}`;
export const SurveyAreaDetailFragFragmentDoc = gql`
    fragment SurveyAreaDetailFrag on SurveyAreaLocationType {
  id
  type
  properties {
    name
    primaryUser {
      id
      fullName
      number
    }
    codename
    updatedAt
    distributionCentre {
      id
      name
      colorCode
      geometry {
        type
        coordinates
      }
    }
    users {
      id
      name: fullName
      number
    }
  }
  geometry {
    type
    coordinates
  }
}
    `;
export const SystemUserListFragFragmentDoc = gql`
    fragment SystemUserListFrag on BaseUserType {
  id
  firstName
  username
  lastName
  fullName
  isBlocked
  blockRemark
  number
  email
  status
  createdAt
  dateOfBirth
  isStaff
  groups {
    id
    name
  }
  departments {
    id
    name
  }
}
    `;
export const SystemUserDetailFragFragmentDoc = gql`
    fragment SystemUserDetailFrag on BaseUserType {
  id
  firstName
  username
  lastName
  fullName
  isBlocked
  blockRemark
  number
  email
  status
  createdAt
  dateOfBirth
  isStaff
  groups {
    id
    name
  }
  education
  customerId
  departments {
    id
    name
  }
  metadata {
    secondaryNumber
    personalEmail
    instituteName
    yearOfPassing
    experience
    previousOrganisation
    interviewDate
    joiningDate
    icardIssuedDate
    visitingCardIssuedDate
    employmentTypeCurrentCompany
    resignationDateCurrentCompany
    laptopIssuedDate
    resignationDate
    attachments
    district
    address
  }
}
    `;
export const AssignedTripMapFragFragmentDoc = gql`
    fragment AssignedTripMapFrag on TripType {
  id
  uuid
  status
  aggregator {
    id
    fullName
    number
  }
  vehicle {
    id
    registrationNumber
    vehicleType {
      id
      name
    }
  }
  bookings {
    id
    procuredQuantity
    requiredQuantity
  }
}
    `;
export const AssignedTripListFragFragmentDoc = gql`
    fragment AssignedTripListFrag on TripType {
  id
  uuid
  status
  date
  aggregator {
    id
    fullName
    number
  }
  sourceDepot {
    id
    name
    location {
      id
      latitude
      longitude
    }
  }
  destinationDepot {
    id
    name
    location {
      id
      latitude
      longitude
    }
  }
  vehicle {
    id
    driver {
      id
      number
      fullName
    }
    owner {
      id
      number
      fullName
    }
    registrationNumber
    vehicleType {
      id
      name
      category
    }
  }
}
    `;
export const AssignedTripBookingFragFragmentDoc = gql`
    fragment AssignedTripBookingFrag on BookingType {
  id
  schedule {
    id
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    plotCommodity {
      id
      name
    }
    gatePass
    sourceDepot {
      id
      name
      location {
        id
        latitude
        longitude
        village
      }
    }
    destinationDepot {
      id
      name
      location {
        id
        latitude
        longitude
        village
      }
    }
    plot {
      id
      name
      farmer {
        id
        fullName
      }
      address {
        id
        latitude
        longitude
        village
        taluka
      }
    }
  }
  procuredQuantity
  requiredQuantity
}
    `;
export const AssignedTripDetailsFragFragmentDoc = gql`
    fragment AssignedTripDetailsFrag on TripType {
  ...AssignedTripListFrag
  unloadedBy {
    id
    name
  }
  bookings {
    ...AssignedTripBookingFrag
  }
}
    ${AssignedTripListFragFragmentDoc}
${AssignedTripBookingFragFragmentDoc}`;
export const VehicleListFragFragmentDoc = gql`
    fragment VehicleListFrag on VehicleType {
  id
  registrationNumber
  estimatedAverage
  status
  createdAt
  totalDistance
  advanceAmount
  fuelAmount
  totalWeight
  avgCostPerKg
  fuelLiters
  distance
  avgMileage
  registrationNumber
  estimatedAverage
  vehicleKind {
    id
    name
  }
  owner {
    id
    fullName
    number
    status
  }
  driver {
    id
    fullName
    number
  }
  alerts {
    date
    message
  }
  currentContract {
    id
    totalPaid
    totalExpense
    totalOutstanding
    contractType {
      id
      name
    }
  }
  vehicleType {
    id
    name
    category
    capacity
    capacityUnit {
      id
      codename
    }
  }
  departments {
    id
    name
  }
  depot {
    id
    name
  }
}
    `;
export const VehicleDetailsFragFragmentDoc = gql`
    fragment VehicleDetailsFrag on VehicleType {
  id
  registrationNumber
  chassisNumber
  estimatedAverage
  dateBought
  status
  dimensions
  vehicleKind {
    id
    name
  }
  dimensionUnit {
    id
    name
  }
  owner {
    id
    fullName
  }
  driver {
    id
    fullName
  }
  fuelType {
    id
    name
  }
  fuelTankCapacity
  vehicleType {
    id
    name
    category
  }
  departments {
    id
    name
  }
  depot {
    id
  }
  modelName
  insurance {
    id
    name
    idNumber
    issuedOn
    validTill
    photo
  }
}
    `;
export const VehicleOwnerFragFragmentDoc = gql`
    fragment VehicleOwnerFrag on BaseUserType {
  id
  firstName
  lastName
  status
  email
  number
  customerId
  companies {
    id
    name
  }
  kycDetails {
    id
    photo
    kycType {
      id
      name
    }
    idNumber
  }
  address {
    id
    village
    pincode
    state
    district
    taluka
    latitude
    longitude
    address
  }
  bankDetails {
    id
    ifscCode
    accountNumber
    accountHolderName
    branchName
    attachments {
      id
      url
      mediaType
    }
    bank {
      id
      name
    }
  }
}
    `;
export const VehicleDriverFragFragmentDoc = gql`
    fragment VehicleDriverFrag on BaseUserType {
  id
  firstName
  lastName
  number
  kycDetails {
    id
    photo
    kycType {
      id
      name
    }
    idNumber
  }
  licenceDetails {
    id
    idNumber
    issuedOn
    validTill
    photo
  }
}
    `;
export const ContractFragFragmentDoc = gql`
    fragment ContractFrag on ContractType {
  id
  number
  contractCode
  dailyAllowance
  totalPaid
  totalExpense
  totalOutstanding
  status
  startDate
  endDate
  contractType {
    id
    name
  }
}
    `;
export const AllVehicleListFragFragmentDoc = gql`
    fragment AllVehicleListFrag on VehicleType {
  id
  status
  registrationNumber
  vehicleKind {
    id
    name
  }
  owner {
    id
    fullName
  }
  driver {
    id
    fullName
  }
  alerts {
    date
    message
  }
  currentContract {
    ...ContractFrag
  }
  contracts {
    ...ContractFrag
  }
  departments {
    id
    name
  }
  vehicleType {
    id
    category
    name
  }
}
    ${ContractFragFragmentDoc}`;
export const VendorDetailFragFragmentDoc = gql`
    fragment VendorDetailFrag on BaseUserType {
  id
  firstName
  lastName
  fullName
  shopsManaged {
    id
    name
  }
  isBlocked
  blockRemark
  username
  dateOfBirth
  number
  gender
  email
  education
  kycDetails {
    id
    idNumber
    kycType {
      id
      name
    }
    photo
  }
  address {
    id
    village
    address
    pincode
    taluka
    state
    district
    latitude
    longitude
  }
  groups {
    id
    name
  }
  customerId
  status
}
    `;
export const MeDocument = gql`
    query me {
  me {
    permissions
    distributionCentres {
      id
      name
      pointOfContacts {
        id
        name: fullName
        number
        groups {
          id
          name
        }
      }
      address {
        id
        village
        taluka
        district
        address
      }
      pickupSlots {
        id
        name
        fromTime
        toTime
      }
    }
    user {
      ...CurrentUserFrag
    }
  }
}
    ${CurrentUserFragFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LoginDocument = gql`
    mutation login($username: String!, $password: String!) {
  login(username: $username, password: $password, firebaseToken: "dashboard") {
    token
    me {
      ...CurrentUserFrag
    }
  }
}
    ${CurrentUserFragFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation updateDepartment($department: Int!) {
  switchDepartment(department: $department) {
    user {
      ...CurrentUserFrag
    }
  }
}
    ${CurrentUserFragFragmentDoc}`;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      department: // value for 'department'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($newPassword: String!) {
  changePassword(newPassword: $newPassword) {
    user {
      ...CurrentUserFrag
    }
  }
}
    ${CurrentUserFragFragmentDoc}`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const DailyMasterOtpDocument = gql`
    query dailyMasterOtp {
  dailyMasterOtp
}
    `;

/**
 * __useDailyMasterOtpQuery__
 *
 * To run a query within a React component, call `useDailyMasterOtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyMasterOtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyMasterOtpQuery({
 *   variables: {
 *   },
 * });
 */
export function useDailyMasterOtpQuery(baseOptions?: Apollo.QueryHookOptions<DailyMasterOtpQuery, DailyMasterOtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyMasterOtpQuery, DailyMasterOtpQueryVariables>(DailyMasterOtpDocument, options);
      }
export function useDailyMasterOtpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyMasterOtpQuery, DailyMasterOtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyMasterOtpQuery, DailyMasterOtpQueryVariables>(DailyMasterOtpDocument, options);
        }
export type DailyMasterOtpQueryHookResult = ReturnType<typeof useDailyMasterOtpQuery>;
export type DailyMasterOtpLazyQueryHookResult = ReturnType<typeof useDailyMasterOtpLazyQuery>;
export type DailyMasterOtpQueryResult = Apollo.QueryResult<DailyMasterOtpQuery, DailyMasterOtpQueryVariables>;
export const AllPriceBenchmarkDataDocument = gql`
    query AllPriceBenchmarkData($first: Int, $skip: Int, $query: String, $filter: PriceBenchmarkDataQueryInput) {
  allPriceBenchmarkData(
    first: $first
    skip: $skip
    filter: $filter
    query: $query
  ) {
    id
    metadata {
      id
      date
      commodityGroup {
        id
        name
      }
      seller {
        id
        name
        category
        categoryObj @client {
          id
          name
        }
      }
      marketYard {
        id
        name
        address {
          id
          village
        }
      }
    }
    grade {
      id
      name
    }
    photos {
      id
      createdAt
      url
    }
    gradePrices {
      pricingDoneOn
      id
      price
      priceUnit {
        id
        name
      }
      uomType {
        id
        codename
        name
      }
      rejection
    }
  }
}
    `;

/**
 * __useAllPriceBenchmarkDataQuery__
 *
 * To run a query within a React component, call `useAllPriceBenchmarkDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPriceBenchmarkDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPriceBenchmarkDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllPriceBenchmarkDataQuery(baseOptions?: Apollo.QueryHookOptions<AllPriceBenchmarkDataQuery, AllPriceBenchmarkDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPriceBenchmarkDataQuery, AllPriceBenchmarkDataQueryVariables>(AllPriceBenchmarkDataDocument, options);
      }
export function useAllPriceBenchmarkDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPriceBenchmarkDataQuery, AllPriceBenchmarkDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPriceBenchmarkDataQuery, AllPriceBenchmarkDataQueryVariables>(AllPriceBenchmarkDataDocument, options);
        }
export type AllPriceBenchmarkDataQueryHookResult = ReturnType<typeof useAllPriceBenchmarkDataQuery>;
export type AllPriceBenchmarkDataLazyQueryHookResult = ReturnType<typeof useAllPriceBenchmarkDataLazyQuery>;
export type AllPriceBenchmarkDataQueryResult = Apollo.QueryResult<AllPriceBenchmarkDataQuery, AllPriceBenchmarkDataQueryVariables>;
export const VarietyGroupBenchmarkDataDocument = gql`
    query VarietyGroupBenchmarkData($first: Int, $skip: Int, $query: String, $filter: PriceBenchmarkRecommendationFilterInput) {
  allPriceBenchmarkRecommendations(
    first: $first
    skip: $skip
    filter: $filter
    query: $query
  ) {
    id
    date
    benchmarkType
    grade {
      id
      name
    }
    commodityGroup {
      id
      name
      isKeyValueProduct
      codename
    }
    grade {
      id
      name
    }
    marketYard {
      id
      name
      address {
        id
        village
      }
    }
    recommendedPrice {
      id
      price
      pricingDoneOn
      priceUnit {
        id
        name
      }
      uomType {
        id
        name
      }
    }
    averagePrice {
      id
      price
      pricingDoneOn
      priceUnit {
        id
        name
      }
      uomType {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useVarietyGroupBenchmarkDataQuery__
 *
 * To run a query within a React component, call `useVarietyGroupBenchmarkDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVarietyGroupBenchmarkDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVarietyGroupBenchmarkDataQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVarietyGroupBenchmarkDataQuery(baseOptions?: Apollo.QueryHookOptions<VarietyGroupBenchmarkDataQuery, VarietyGroupBenchmarkDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VarietyGroupBenchmarkDataQuery, VarietyGroupBenchmarkDataQueryVariables>(VarietyGroupBenchmarkDataDocument, options);
      }
export function useVarietyGroupBenchmarkDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VarietyGroupBenchmarkDataQuery, VarietyGroupBenchmarkDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VarietyGroupBenchmarkDataQuery, VarietyGroupBenchmarkDataQueryVariables>(VarietyGroupBenchmarkDataDocument, options);
        }
export type VarietyGroupBenchmarkDataQueryHookResult = ReturnType<typeof useVarietyGroupBenchmarkDataQuery>;
export type VarietyGroupBenchmarkDataLazyQueryHookResult = ReturnType<typeof useVarietyGroupBenchmarkDataLazyQuery>;
export type VarietyGroupBenchmarkDataQueryResult = Apollo.QueryResult<VarietyGroupBenchmarkDataQuery, VarietyGroupBenchmarkDataQueryVariables>;
export const AddBenchmarkRecommendationDocument = gql`
    mutation AddBenchmarkRecommendation($averagePrice: PriceInput!, $benchmarkType: String!, $benchmarkedAt: AddressInput!, $benchmarkingDoneInId: ID, $commodityGroupId: ID!, $date: Date!, $gradeId: ID!, $id: ID, $marketYardId: ID!, $recommendedPrice: PriceInput!) {
  addBenchmarkRecommendation(
    averagePrice: $averagePrice
    benchmarkType: $benchmarkType
    benchmarkedAt: $benchmarkedAt
    benchmarkingDoneInId: $benchmarkingDoneInId
    commodityGroupId: $commodityGroupId
    date: $date
    gradeId: $gradeId
    id: $id
    marketYardId: $marketYardId
    recommendedPrice: $recommendedPrice
  ) {
    banchmarkRecommendation {
      id
      benchmarkType
      benchmarkedAt {
        id
        latitude
        longitude
        village
      }
      benchmarkingDoneIn {
        id
        name
      }
      date
      grade {
        id
        name
      }
      marketYard {
        id
        name
      }
      recommendedPrice {
        id
        isDefault
        price
        priceUnit {
          id
          name
        }
      }
      averagePrice {
        id
        isDefault
        price
        priceUnit {
          id
          name
        }
      }
    }
  }
}
    `;
export type AddBenchmarkRecommendationMutationFn = Apollo.MutationFunction<AddBenchmarkRecommendationMutation, AddBenchmarkRecommendationMutationVariables>;

/**
 * __useAddBenchmarkRecommendationMutation__
 *
 * To run a mutation, you first call `useAddBenchmarkRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBenchmarkRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBenchmarkRecommendationMutation, { data, loading, error }] = useAddBenchmarkRecommendationMutation({
 *   variables: {
 *      averagePrice: // value for 'averagePrice'
 *      benchmarkType: // value for 'benchmarkType'
 *      benchmarkedAt: // value for 'benchmarkedAt'
 *      benchmarkingDoneInId: // value for 'benchmarkingDoneInId'
 *      commodityGroupId: // value for 'commodityGroupId'
 *      date: // value for 'date'
 *      gradeId: // value for 'gradeId'
 *      id: // value for 'id'
 *      marketYardId: // value for 'marketYardId'
 *      recommendedPrice: // value for 'recommendedPrice'
 *   },
 * });
 */
export function useAddBenchmarkRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<AddBenchmarkRecommendationMutation, AddBenchmarkRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBenchmarkRecommendationMutation, AddBenchmarkRecommendationMutationVariables>(AddBenchmarkRecommendationDocument, options);
      }
export type AddBenchmarkRecommendationMutationHookResult = ReturnType<typeof useAddBenchmarkRecommendationMutation>;
export type AddBenchmarkRecommendationMutationResult = Apollo.MutationResult<AddBenchmarkRecommendationMutation>;
export type AddBenchmarkRecommendationMutationOptions = Apollo.BaseMutationOptions<AddBenchmarkRecommendationMutation, AddBenchmarkRecommendationMutationVariables>;
export const BenchmarkRecommendationsDocument = gql`
    query BenchmarkRecommendations($query: String, $first: Int, $skip: Int, $filter: PriceBenchmarkRecommendationFilterInput) {
  allPriceBenchmarkRecommendations(
    query: $query
    first: $first
    skip: $skip
    filter: $filter
  ) {
    ...BenchmarkListFrag
  }
}
    ${BenchmarkListFragFragmentDoc}`;

/**
 * __useBenchmarkRecommendationsQuery__
 *
 * To run a query within a React component, call `useBenchmarkRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenchmarkRecommendationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBenchmarkRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<BenchmarkRecommendationsQuery, BenchmarkRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BenchmarkRecommendationsQuery, BenchmarkRecommendationsQueryVariables>(BenchmarkRecommendationsDocument, options);
      }
export function useBenchmarkRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenchmarkRecommendationsQuery, BenchmarkRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BenchmarkRecommendationsQuery, BenchmarkRecommendationsQueryVariables>(BenchmarkRecommendationsDocument, options);
        }
export type BenchmarkRecommendationsQueryHookResult = ReturnType<typeof useBenchmarkRecommendationsQuery>;
export type BenchmarkRecommendationsLazyQueryHookResult = ReturnType<typeof useBenchmarkRecommendationsLazyQuery>;
export type BenchmarkRecommendationsQueryResult = Apollo.QueryResult<BenchmarkRecommendationsQuery, BenchmarkRecommendationsQueryVariables>;
export const BenchmarkRecommendationListDocument = gql`
    query BenchmarkRecommendationList($query: String, $first: Int, $skip: Int, $filter: PriceBenchmarkRecommendationFilterInput) {
  allPriceBenchmarkRecommendations(
    query: $query
    first: $first
    skip: $skip
    filter: $filter
  ) {
    id
    marketYard {
      id
      name
    }
    commodityGroup {
      id
      name
      varieties {
        id
        name
      }
    }
    averagePrice {
      id
      price
      rejection
      priceUnit {
        id
        codename
        name
      }
    }
    benchmarkedAt {
      id
      village
      latitude
      longitude
    }
    updatedAt
  }
}
    `;

/**
 * __useBenchmarkRecommendationListQuery__
 *
 * To run a query within a React component, call `useBenchmarkRecommendationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkRecommendationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenchmarkRecommendationListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBenchmarkRecommendationListQuery(baseOptions?: Apollo.QueryHookOptions<BenchmarkRecommendationListQuery, BenchmarkRecommendationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BenchmarkRecommendationListQuery, BenchmarkRecommendationListQueryVariables>(BenchmarkRecommendationListDocument, options);
      }
export function useBenchmarkRecommendationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenchmarkRecommendationListQuery, BenchmarkRecommendationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BenchmarkRecommendationListQuery, BenchmarkRecommendationListQueryVariables>(BenchmarkRecommendationListDocument, options);
        }
export type BenchmarkRecommendationListQueryHookResult = ReturnType<typeof useBenchmarkRecommendationListQuery>;
export type BenchmarkRecommendationListLazyQueryHookResult = ReturnType<typeof useBenchmarkRecommendationListLazyQuery>;
export type BenchmarkRecommendationListQueryResult = Apollo.QueryResult<BenchmarkRecommendationListQuery, BenchmarkRecommendationListQueryVariables>;
export const BenchmarkDataListDocument = gql`
    query BenchmarkDataList($first: Int, $skip: Int, $query: String, $filter: PriceBenchmarkDataQueryInput) {
  allPriceBenchmarkData(
    first: $first
    skip: $skip
    filter: $filter
    query: $query
  ) {
    id
    metadata {
      id
      createdAt
      marketYard {
        id
        name
      }
      recordedAt {
        id
        village
        latitude
        longitude
      }
      seller {
        id
        name
        category
      }
    }
    gradePrices {
      id
      price
      rejection
      isDefault
      priceUnit {
        id
        name
      }
    }
    photos {
      id
      url
    }
  }
}
    `;

/**
 * __useBenchmarkDataListQuery__
 *
 * To run a query within a React component, call `useBenchmarkDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenchmarkDataListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBenchmarkDataListQuery(baseOptions?: Apollo.QueryHookOptions<BenchmarkDataListQuery, BenchmarkDataListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BenchmarkDataListQuery, BenchmarkDataListQueryVariables>(BenchmarkDataListDocument, options);
      }
export function useBenchmarkDataListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BenchmarkDataListQuery, BenchmarkDataListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BenchmarkDataListQuery, BenchmarkDataListQueryVariables>(BenchmarkDataListDocument, options);
        }
export type BenchmarkDataListQueryHookResult = ReturnType<typeof useBenchmarkDataListQuery>;
export type BenchmarkDataListLazyQueryHookResult = ReturnType<typeof useBenchmarkDataListLazyQuery>;
export type BenchmarkDataListQueryResult = Apollo.QueryResult<BenchmarkDataListQuery, BenchmarkDataListQueryVariables>;
export const AllCompaniesListDocument = gql`
    query allCompaniesList($id: Int) {
  allCompanies(departmentId: $id) {
    id
    name
    codename
    kind
    displayName
    departments {
      id
      name
    }
  }
}
    `;

/**
 * __useAllCompaniesListQuery__
 *
 * To run a query within a React component, call `useAllCompaniesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllCompaniesListQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesListQuery, AllCompaniesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesListQuery, AllCompaniesListQueryVariables>(AllCompaniesListDocument, options);
      }
export function useAllCompaniesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesListQuery, AllCompaniesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesListQuery, AllCompaniesListQueryVariables>(AllCompaniesListDocument, options);
        }
export type AllCompaniesListQueryHookResult = ReturnType<typeof useAllCompaniesListQuery>;
export type AllCompaniesListLazyQueryHookResult = ReturnType<typeof useAllCompaniesListLazyQuery>;
export type AllCompaniesListQueryResult = Apollo.QueryResult<AllCompaniesListQuery, AllCompaniesListQueryVariables>;
export const CompanyDetailDocument = gql`
    query companyDetail($id: Int) {
  companyDetails(companyId: $id) {
    ...CompanyDetailFrag
  }
}
    ${CompanyDetailFragFragmentDoc}`;

/**
 * __useCompanyDetailQuery__
 *
 * To run a query within a React component, call `useCompanyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDetailQuery(baseOptions?: Apollo.QueryHookOptions<CompanyDetailQuery, CompanyDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailQuery, CompanyDetailQueryVariables>(CompanyDetailDocument, options);
      }
export function useCompanyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailQuery, CompanyDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailQuery, CompanyDetailQueryVariables>(CompanyDetailDocument, options);
        }
export type CompanyDetailQueryHookResult = ReturnType<typeof useCompanyDetailQuery>;
export type CompanyDetailLazyQueryHookResult = ReturnType<typeof useCompanyDetailLazyQuery>;
export type CompanyDetailQueryResult = Apollo.QueryResult<CompanyDetailQuery, CompanyDetailQueryVariables>;
export const AddUpdateCompanyDocument = gql`
    mutation addUpdateCompany($id: Int, $name: String, $codename: String, $displayName: String, $departments: [Int]) {
  addCompany(
    id: $id
    name: $name
    codename: $codename
    displayName: $displayName
    departments: $departments
  ) {
    company {
      ...CompanyDetailFrag
    }
  }
}
    ${CompanyDetailFragFragmentDoc}`;
export type AddUpdateCompanyMutationFn = Apollo.MutationFunction<AddUpdateCompanyMutation, AddUpdateCompanyMutationVariables>;

/**
 * __useAddUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useAddUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateCompanyMutation, { data, loading, error }] = useAddUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      codename: // value for 'codename'
 *      displayName: // value for 'displayName'
 *      departments: // value for 'departments'
 *   },
 * });
 */
export function useAddUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateCompanyMutation, AddUpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateCompanyMutation, AddUpdateCompanyMutationVariables>(AddUpdateCompanyDocument, options);
      }
export type AddUpdateCompanyMutationHookResult = ReturnType<typeof useAddUpdateCompanyMutation>;
export type AddUpdateCompanyMutationResult = Apollo.MutationResult<AddUpdateCompanyMutation>;
export type AddUpdateCompanyMutationOptions = Apollo.BaseMutationOptions<AddUpdateCompanyMutation, AddUpdateCompanyMutationVariables>;
export const ContractDetailsDocument = gql`
    query ContractDetails($id: ID!) {
  contractDetails(contractId: $id) {
    ...ContractDetailFrag
  }
}
    ${ContractDetailFragFragmentDoc}`;

/**
 * __useContractDetailsQuery__
 *
 * To run a query within a React component, call `useContractDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContractDetailsQuery, ContractDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractDetailsQuery, ContractDetailsQueryVariables>(ContractDetailsDocument, options);
      }
export function useContractDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractDetailsQuery, ContractDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractDetailsQuery, ContractDetailsQueryVariables>(ContractDetailsDocument, options);
        }
export type ContractDetailsQueryHookResult = ReturnType<typeof useContractDetailsQuery>;
export type ContractDetailsLazyQueryHookResult = ReturnType<typeof useContractDetailsLazyQuery>;
export type ContractDetailsQueryResult = Apollo.QueryResult<ContractDetailsQuery, ContractDetailsQueryVariables>;
export const AddUpdateVehicleContractDocument = gql`
    mutation AddUpdateVehicleContract($id: ID, $status: String!, $startDate: Date!, $endDate: Date!, $entityIssued: ID!, $contractTypeId: ID!, $resourceAmount: Int, $dailyAllowance: Float, $recurringExpenses: [ContractRecurringExpenseInput]) {
  addUpdateVehicleContract(
    id: $id
    status: $status
    startDate: $startDate
    endDate: $endDate
    entityIssued: $entityIssued
    contractTypeId: $contractTypeId
    resourceAmount: $resourceAmount
    dailyAllowance: $dailyAllowance
    recurringExpenses: $recurringExpenses
  ) {
    contract {
      ...ContractDetailFrag
    }
  }
}
    ${ContractDetailFragFragmentDoc}`;
export type AddUpdateVehicleContractMutationFn = Apollo.MutationFunction<AddUpdateVehicleContractMutation, AddUpdateVehicleContractMutationVariables>;

/**
 * __useAddUpdateVehicleContractMutation__
 *
 * To run a mutation, you first call `useAddUpdateVehicleContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateVehicleContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateVehicleContractMutation, { data, loading, error }] = useAddUpdateVehicleContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      entityIssued: // value for 'entityIssued'
 *      contractTypeId: // value for 'contractTypeId'
 *      resourceAmount: // value for 'resourceAmount'
 *      dailyAllowance: // value for 'dailyAllowance'
 *      recurringExpenses: // value for 'recurringExpenses'
 *   },
 * });
 */
export function useAddUpdateVehicleContractMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateVehicleContractMutation, AddUpdateVehicleContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateVehicleContractMutation, AddUpdateVehicleContractMutationVariables>(AddUpdateVehicleContractDocument, options);
      }
export type AddUpdateVehicleContractMutationHookResult = ReturnType<typeof useAddUpdateVehicleContractMutation>;
export type AddUpdateVehicleContractMutationResult = Apollo.MutationResult<AddUpdateVehicleContractMutation>;
export type AddUpdateVehicleContractMutationOptions = Apollo.BaseMutationOptions<AddUpdateVehicleContractMutation, AddUpdateVehicleContractMutationVariables>;
export const MyCouponsDocument = gql`
    query MyCoupons($totalAmount: Float, $dcId: ID, $isOrder: Boolean, $sellableItemStockId: ID) {
  myCupons(
    totalAmount: $totalAmount
    dcId: $dcId
    isOrder: $isOrder
    sellableItemStockId: $sellableItemStockId
  ) {
    id
    name
    flat
    percentage
    discountConditions
  }
}
    `;

/**
 * __useMyCouponsQuery__
 *
 * To run a query within a React component, call `useMyCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCouponsQuery({
 *   variables: {
 *      totalAmount: // value for 'totalAmount'
 *      dcId: // value for 'dcId'
 *      isOrder: // value for 'isOrder'
 *      sellableItemStockId: // value for 'sellableItemStockId'
 *   },
 * });
 */
export function useMyCouponsQuery(baseOptions?: Apollo.QueryHookOptions<MyCouponsQuery, MyCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCouponsQuery, MyCouponsQueryVariables>(MyCouponsDocument, options);
      }
export function useMyCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCouponsQuery, MyCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCouponsQuery, MyCouponsQueryVariables>(MyCouponsDocument, options);
        }
export type MyCouponsQueryHookResult = ReturnType<typeof useMyCouponsQuery>;
export type MyCouponsLazyQueryHookResult = ReturnType<typeof useMyCouponsLazyQuery>;
export type MyCouponsQueryResult = Apollo.QueryResult<MyCouponsQuery, MyCouponsQueryVariables>;
export const AllCreditsDocument = gql`
    query AllCredits($query: String, $first: Int, $skip: Int, $filter: CreditFilterInput) {
  allCredits(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    user {
      id
      fullName
    }
    totalAmount
    usedAmount
    remainingAmount
    paymentCycleDays
    startDate
    endDate
    status
    isActive
    createdAt
    createdBy {
      id
      fullName
    }
  }
}
    `;

/**
 * __useAllCreditsQuery__
 *
 * To run a query within a React component, call `useAllCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCreditsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllCreditsQuery(baseOptions?: Apollo.QueryHookOptions<AllCreditsQuery, AllCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCreditsQuery, AllCreditsQueryVariables>(AllCreditsDocument, options);
      }
export function useAllCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCreditsQuery, AllCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCreditsQuery, AllCreditsQueryVariables>(AllCreditsDocument, options);
        }
export type AllCreditsQueryHookResult = ReturnType<typeof useAllCreditsQuery>;
export type AllCreditsLazyQueryHookResult = ReturnType<typeof useAllCreditsLazyQuery>;
export type AllCreditsQueryResult = Apollo.QueryResult<AllCreditsQuery, AllCreditsQueryVariables>;
export const CreditDetailDocument = gql`
    query creditDetail($id: ID!) {
  creditDetail(id: $id) {
    id
    user {
      id
      fullName
    }
    totalAmount
    usedAmount
    remainingAmount
    paymentCycleDays
    startDate
    endDate
    status
    isActive
    createdAt
    createdBy {
      id
      fullName
    }
    updatedAt
    updatedBy {
      id
      fullName
    }
    verifiedOn
    verifiedBy {
      id
      fullName
    }
    verificationRemark
    isVerified
    unsettledCreditOrders {
      id
      trackingCode
      date
      orderStatus
      paymentStatus
      totalAmount
      outstandingAmount
    }
    settledCreditOrders {
      id
      trackingCode
      date
      orderStatus
      paymentStatus
      totalAmount
      outstandingAmount
    }
  }
}
    `;

/**
 * __useCreditDetailQuery__
 *
 * To run a query within a React component, call `useCreditDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditDetailQuery(baseOptions: Apollo.QueryHookOptions<CreditDetailQuery, CreditDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditDetailQuery, CreditDetailQueryVariables>(CreditDetailDocument, options);
      }
export function useCreditDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditDetailQuery, CreditDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditDetailQuery, CreditDetailQueryVariables>(CreditDetailDocument, options);
        }
export type CreditDetailQueryHookResult = ReturnType<typeof useCreditDetailQuery>;
export type CreditDetailLazyQueryHookResult = ReturnType<typeof useCreditDetailLazyQuery>;
export type CreditDetailQueryResult = Apollo.QueryResult<CreditDetailQuery, CreditDetailQueryVariables>;
export const SummaryCreditsDocument = gql`
    query summaryCredits($filter: CreditFilterInput) {
  summaryCredits(filter: $filter) {
    totalCreditSanctioned
    totalUtilized
    remainingAmount
    activeUsers
  }
}
    `;

/**
 * __useSummaryCreditsQuery__
 *
 * To run a query within a React component, call `useSummaryCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryCreditsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSummaryCreditsQuery(baseOptions?: Apollo.QueryHookOptions<SummaryCreditsQuery, SummaryCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryCreditsQuery, SummaryCreditsQueryVariables>(SummaryCreditsDocument, options);
      }
export function useSummaryCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryCreditsQuery, SummaryCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryCreditsQuery, SummaryCreditsQueryVariables>(SummaryCreditsDocument, options);
        }
export type SummaryCreditsQueryHookResult = ReturnType<typeof useSummaryCreditsQuery>;
export type SummaryCreditsLazyQueryHookResult = ReturnType<typeof useSummaryCreditsLazyQuery>;
export type SummaryCreditsQueryResult = Apollo.QueryResult<SummaryCreditsQuery, SummaryCreditsQueryVariables>;
export const MetabaseUrlDocument = gql`
    query MetabaseUrl($filter: MetabaseURLInput) {
  metabaseUrl(filter: $filter) {
    iframeUrl
  }
}
    `;

/**
 * __useMetabaseUrlQuery__
 *
 * To run a query within a React component, call `useMetabaseUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetabaseUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetabaseUrlQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMetabaseUrlQuery(baseOptions?: Apollo.QueryHookOptions<MetabaseUrlQuery, MetabaseUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetabaseUrlQuery, MetabaseUrlQueryVariables>(MetabaseUrlDocument, options);
      }
export function useMetabaseUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetabaseUrlQuery, MetabaseUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetabaseUrlQuery, MetabaseUrlQueryVariables>(MetabaseUrlDocument, options);
        }
export type MetabaseUrlQueryHookResult = ReturnType<typeof useMetabaseUrlQuery>;
export type MetabaseUrlLazyQueryHookResult = ReturnType<typeof useMetabaseUrlLazyQuery>;
export type MetabaseUrlQueryResult = Apollo.QueryResult<MetabaseUrlQuery, MetabaseUrlQueryVariables>;
export const CreateDemandDocument = gql`
    mutation CreateDemand($name: String!, $dateRange: [Date!]!, $varietyGroup: ID!, $depot: Int!, $broadcastTime: DateTime!, $gradePrices: [BookingGradePriceInput!]!, $timeSlots: [TimeSlotRequirementInput!]!, $description: String, $allowAggregatorVehicle: Boolean, $allowOwnVehicle: Boolean, $bookingQuantityLimit: Float, $companyVisibility: [Int], $groupVisibility: [Int], $companyId: ID, $attachments: [MediaInput], $shouldConsolidate: Boolean) {
  addDemand(
    name: $name
    dateRange: $dateRange
    varietyGroup: $varietyGroup
    depot: $depot
    broadcastTime: $broadcastTime
    gradePrices: $gradePrices
    timeSlots: $timeSlots
    description: $description
    bookingQuantityLimit: $bookingQuantityLimit
    allowAggregatorVehicle: $allowAggregatorVehicle
    allowOwnVehicle: $allowOwnVehicle
    companyVisibility: $companyVisibility
    groupVisibility: $groupVisibility
    companyId: $companyId
    attachments: $attachments
    shouldConsolidate: $shouldConsolidate
  ) {
    demands {
      ...DemandListFrag
    }
  }
}
    ${DemandListFragFragmentDoc}`;
export type CreateDemandMutationFn = Apollo.MutationFunction<CreateDemandMutation, CreateDemandMutationVariables>;

/**
 * __useCreateDemandMutation__
 *
 * To run a mutation, you first call `useCreateDemandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemandMutation, { data, loading, error }] = useCreateDemandMutation({
 *   variables: {
 *      name: // value for 'name'
 *      dateRange: // value for 'dateRange'
 *      varietyGroup: // value for 'varietyGroup'
 *      depot: // value for 'depot'
 *      broadcastTime: // value for 'broadcastTime'
 *      gradePrices: // value for 'gradePrices'
 *      timeSlots: // value for 'timeSlots'
 *      description: // value for 'description'
 *      allowAggregatorVehicle: // value for 'allowAggregatorVehicle'
 *      allowOwnVehicle: // value for 'allowOwnVehicle'
 *      bookingQuantityLimit: // value for 'bookingQuantityLimit'
 *      companyVisibility: // value for 'companyVisibility'
 *      groupVisibility: // value for 'groupVisibility'
 *      companyId: // value for 'companyId'
 *      attachments: // value for 'attachments'
 *      shouldConsolidate: // value for 'shouldConsolidate'
 *   },
 * });
 */
export function useCreateDemandMutation(baseOptions?: Apollo.MutationHookOptions<CreateDemandMutation, CreateDemandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDemandMutation, CreateDemandMutationVariables>(CreateDemandDocument, options);
      }
export type CreateDemandMutationHookResult = ReturnType<typeof useCreateDemandMutation>;
export type CreateDemandMutationResult = Apollo.MutationResult<CreateDemandMutation>;
export type CreateDemandMutationOptions = Apollo.BaseMutationOptions<CreateDemandMutation, CreateDemandMutationVariables>;
export const UpdateBulkDemandsDocument = gql`
    mutation updateBulkDemands($filter: DemandFilterInput, $ids: [ID], $isLive: Boolean, $name: String, $query: String, $description: String) {
  updateBulkDemands(
    filter: $filter
    ids: $ids
    isLive: $isLive
    name: $name
    query: $query
    description: $description
  ) {
    demands {
      id
      isLive
      name
      description
    }
  }
}
    `;
export type UpdateBulkDemandsMutationFn = Apollo.MutationFunction<UpdateBulkDemandsMutation, UpdateBulkDemandsMutationVariables>;

/**
 * __useUpdateBulkDemandsMutation__
 *
 * To run a mutation, you first call `useUpdateBulkDemandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkDemandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkDemandsMutation, { data, loading, error }] = useUpdateBulkDemandsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *      isLive: // value for 'isLive'
 *      name: // value for 'name'
 *      query: // value for 'query'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateBulkDemandsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkDemandsMutation, UpdateBulkDemandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkDemandsMutation, UpdateBulkDemandsMutationVariables>(UpdateBulkDemandsDocument, options);
      }
export type UpdateBulkDemandsMutationHookResult = ReturnType<typeof useUpdateBulkDemandsMutation>;
export type UpdateBulkDemandsMutationResult = Apollo.MutationResult<UpdateBulkDemandsMutation>;
export type UpdateBulkDemandsMutationOptions = Apollo.BaseMutationOptions<UpdateBulkDemandsMutation, UpdateBulkDemandsMutationVariables>;
export const DemandDetailsDocument = gql`
    query DemandDetails($id: ID) {
  demandDetails(id: $id) {
    id
    name
    description
    isLive
    isVerified
    attachments {
      id
      mediaType
      url
    }
    varietyGroup {
      id
      name
    }
    date
    dateTill
    broadcastTime
    timeSlots {
      id
      quantity
      bookedQuantity
      quantityUnit {
        id
        name
      }
      timeSlot {
        id
        name
        fromTime
        toTime
      }
    }
    gradePrices {
      id
      price
      priceUnit {
        id
        name
      }
      priceLimit
      grade {
        id
        name
      }
    }
    depot {
      id
      name
    }
  }
}
    `;

/**
 * __useDemandDetailsQuery__
 *
 * To run a query within a React component, call `useDemandDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDemandDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDemandDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDemandDetailsQuery(baseOptions?: Apollo.QueryHookOptions<DemandDetailsQuery, DemandDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DemandDetailsQuery, DemandDetailsQueryVariables>(DemandDetailsDocument, options);
      }
export function useDemandDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DemandDetailsQuery, DemandDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DemandDetailsQuery, DemandDetailsQueryVariables>(DemandDetailsDocument, options);
        }
export type DemandDetailsQueryHookResult = ReturnType<typeof useDemandDetailsQuery>;
export type DemandDetailsLazyQueryHookResult = ReturnType<typeof useDemandDetailsLazyQuery>;
export type DemandDetailsQueryResult = Apollo.QueryResult<DemandDetailsQuery, DemandDetailsQueryVariables>;
export const AllDemandsDocument = gql`
    query allDemands($search: String, $first: Int, $skip: Int, $filter: DemandFilterInput) {
  allDemands(query: $search, first: $first, skip: $skip, filter: $filter) {
    totalCount
    demands {
      ...DemandListFrag
    }
  }
}
    ${DemandListFragFragmentDoc}`;

/**
 * __useAllDemandsQuery__
 *
 * To run a query within a React component, call `useAllDemandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDemandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDemandsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllDemandsQuery(baseOptions?: Apollo.QueryHookOptions<AllDemandsQuery, AllDemandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDemandsQuery, AllDemandsQueryVariables>(AllDemandsDocument, options);
      }
export function useAllDemandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDemandsQuery, AllDemandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDemandsQuery, AllDemandsQueryVariables>(AllDemandsDocument, options);
        }
export type AllDemandsQueryHookResult = ReturnType<typeof useAllDemandsQuery>;
export type AllDemandsLazyQueryHookResult = ReturnType<typeof useAllDemandsLazyQuery>;
export type AllDemandsQueryResult = Apollo.QueryResult<AllDemandsQuery, AllDemandsQueryVariables>;
export const DepartmentDetailDocument = gql`
    query departmentDetail($id: Int) {
  departmentDetails(departmentId: $id) {
    id
    name
    preferredDepot {
      id
      name
    }
  }
}
    `;

/**
 * __useDepartmentDetailQuery__
 *
 * To run a query within a React component, call `useDepartmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDepartmentDetailQuery(baseOptions?: Apollo.QueryHookOptions<DepartmentDetailQuery, DepartmentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentDetailQuery, DepartmentDetailQueryVariables>(DepartmentDetailDocument, options);
      }
export function useDepartmentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentDetailQuery, DepartmentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentDetailQuery, DepartmentDetailQueryVariables>(DepartmentDetailDocument, options);
        }
export type DepartmentDetailQueryHookResult = ReturnType<typeof useDepartmentDetailQuery>;
export type DepartmentDetailLazyQueryHookResult = ReturnType<typeof useDepartmentDetailLazyQuery>;
export type DepartmentDetailQueryResult = Apollo.QueryResult<DepartmentDetailQuery, DepartmentDetailQueryVariables>;
export const CreateUpdateDispathDocument = gql`
    mutation CreateUpdateDispath($aggregatorId: ID!, $bookings: [DispatchBookingItem], $date: Date!, $destinationDepotId: ID!, $estimatedStartTime: DateTime!, $id: ID, $labourCount: Int, $organisationUserId: ID!, $sourceDepotId: ID!, $transportDetail: VehicleTransportInput, $vehicleId: ID!, $loadingPattern: String, $estimatedDespatchTime: DateTime) {
  addUpdateDispatch(
    id: $id
    aggregatorId: $aggregatorId
    date: $date
    destinationDepotId: $destinationDepotId
    estimatedStartTime: $estimatedStartTime
    organisationUserId: $organisationUserId
    sourceDepotId: $sourceDepotId
    vehicleId: $vehicleId
    labourCount: $labourCount
    transportDetail: $transportDetail
    bookings: $bookings
    loadingPattern: $loadingPattern
    estimatedDespatchTime: $estimatedDespatchTime
  ) {
    trip {
      ...TripOrdersFrag
    }
  }
}
    ${TripOrdersFragFragmentDoc}`;
export type CreateUpdateDispathMutationFn = Apollo.MutationFunction<CreateUpdateDispathMutation, CreateUpdateDispathMutationVariables>;

/**
 * __useCreateUpdateDispathMutation__
 *
 * To run a mutation, you first call `useCreateUpdateDispathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateDispathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateDispathMutation, { data, loading, error }] = useCreateUpdateDispathMutation({
 *   variables: {
 *      aggregatorId: // value for 'aggregatorId'
 *      bookings: // value for 'bookings'
 *      date: // value for 'date'
 *      destinationDepotId: // value for 'destinationDepotId'
 *      estimatedStartTime: // value for 'estimatedStartTime'
 *      id: // value for 'id'
 *      labourCount: // value for 'labourCount'
 *      organisationUserId: // value for 'organisationUserId'
 *      sourceDepotId: // value for 'sourceDepotId'
 *      transportDetail: // value for 'transportDetail'
 *      vehicleId: // value for 'vehicleId'
 *      loadingPattern: // value for 'loadingPattern'
 *      estimatedDespatchTime: // value for 'estimatedDespatchTime'
 *   },
 * });
 */
export function useCreateUpdateDispathMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateDispathMutation, CreateUpdateDispathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateDispathMutation, CreateUpdateDispathMutationVariables>(CreateUpdateDispathDocument, options);
      }
export type CreateUpdateDispathMutationHookResult = ReturnType<typeof useCreateUpdateDispathMutation>;
export type CreateUpdateDispathMutationResult = Apollo.MutationResult<CreateUpdateDispathMutation>;
export type CreateUpdateDispathMutationOptions = Apollo.BaseMutationOptions<CreateUpdateDispathMutation, CreateUpdateDispathMutationVariables>;
export const DispatchesForDateDocument = gql`
    query DispatchesForDate($date: Date!, $query: String, $first: Int, $skip: Int, $distributionCentreId: ID) {
  tripsForDate(
    date: $date
    query: $query
    first: $first
    skip: $skip
    distributionCentreId: $distributionCentreId
  ) {
    id
    status
    totalCrateCount
    destinationDepot {
      id
      name
    }
    sourceDepot {
      id
      name
    }
    vehicle {
      id
      registrationNumber
      vehicleType {
        id
        name
        category
      }
      driver {
        id
        fullName
        number
      }
    }
    aggregator {
      id
      fullName
      number
    }
    estimatedStartTime
    bookings {
      id
      schedule {
        id
      }
      requiredQuantity
      orderItem {
        id
        sellableItem {
          id
          name
        }
        quantity
        rate
      }
      order {
        id
        totalAmount
        orderStatus
        shippingAddress {
          id
          village
        }
      }
    }
  }
}
    `;

/**
 * __useDispatchesForDateQuery__
 *
 * To run a query within a React component, call `useDispatchesForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchesForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchesForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      distributionCentreId: // value for 'distributionCentreId'
 *   },
 * });
 */
export function useDispatchesForDateQuery(baseOptions: Apollo.QueryHookOptions<DispatchesForDateQuery, DispatchesForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispatchesForDateQuery, DispatchesForDateQueryVariables>(DispatchesForDateDocument, options);
      }
export function useDispatchesForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispatchesForDateQuery, DispatchesForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispatchesForDateQuery, DispatchesForDateQueryVariables>(DispatchesForDateDocument, options);
        }
export type DispatchesForDateQueryHookResult = ReturnType<typeof useDispatchesForDateQuery>;
export type DispatchesForDateLazyQueryHookResult = ReturnType<typeof useDispatchesForDateLazyQuery>;
export type DispatchesForDateQueryResult = Apollo.QueryResult<DispatchesForDateQuery, DispatchesForDateQueryVariables>;
export const AllDispatchDepotsSelectorDocument = gql`
    query allDispatchDepotsSelector {
  allDepots {
    id
    name
    location {
      id
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useAllDispatchDepotsSelectorQuery__
 *
 * To run a query within a React component, call `useAllDispatchDepotsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDispatchDepotsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDispatchDepotsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDispatchDepotsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllDispatchDepotsSelectorQuery, AllDispatchDepotsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDispatchDepotsSelectorQuery, AllDispatchDepotsSelectorQueryVariables>(AllDispatchDepotsSelectorDocument, options);
      }
export function useAllDispatchDepotsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDispatchDepotsSelectorQuery, AllDispatchDepotsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDispatchDepotsSelectorQuery, AllDispatchDepotsSelectorQueryVariables>(AllDispatchDepotsSelectorDocument, options);
        }
export type AllDispatchDepotsSelectorQueryHookResult = ReturnType<typeof useAllDispatchDepotsSelectorQuery>;
export type AllDispatchDepotsSelectorLazyQueryHookResult = ReturnType<typeof useAllDispatchDepotsSelectorLazyQuery>;
export type AllDispatchDepotsSelectorQueryResult = Apollo.QueryResult<AllDispatchDepotsSelectorQuery, AllDispatchDepotsSelectorQueryVariables>;
export const SuborderOrderDetailDocument = gql`
    query SuborderOrderDetail($orderId: ID!) {
  orderDetail(id: $orderId) {
    id
    subOrders {
      id
      date
      trackingCode
      totalWeight
      orderCategory
      shippingAddress {
        id
        address
        latitude
        longitude
        village
        taluka
      }
      user {
        id
        fullName
      }
      crateCount
      orderStatus
      orderItems {
        id
        quantity
        rate
        bookedQuantity
        order {
          id
        }
        sellableItem {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSuborderOrderDetailQuery__
 *
 * To run a query within a React component, call `useSuborderOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuborderOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuborderOrderDetailQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSuborderOrderDetailQuery(baseOptions: Apollo.QueryHookOptions<SuborderOrderDetailQuery, SuborderOrderDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuborderOrderDetailQuery, SuborderOrderDetailQueryVariables>(SuborderOrderDetailDocument, options);
      }
export function useSuborderOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuborderOrderDetailQuery, SuborderOrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuborderOrderDetailQuery, SuborderOrderDetailQueryVariables>(SuborderOrderDetailDocument, options);
        }
export type SuborderOrderDetailQueryHookResult = ReturnType<typeof useSuborderOrderDetailQuery>;
export type SuborderOrderDetailLazyQueryHookResult = ReturnType<typeof useSuborderOrderDetailLazyQuery>;
export type SuborderOrderDetailQueryResult = Apollo.QueryResult<SuborderOrderDetailQuery, SuborderOrderDetailQueryVariables>;
export const ConfirmedOrderListDocument = gql`
    query ConfirmedOrderList($query: String, $first: Int, $skip: Int, $filter: OrderFilterInput, $sellableItemIds: [ID]) {
  allOrders(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    date
    trackingCode
    totalWeight
    orderCategory
    shippingCharges
    discount {
      id
      flat
      percentage
    }
    metadata
    shippingAddress {
      id
      address
      latitude
      longitude
      village
      taluka
    }
    user {
      id
      fullName
    }
    crateCount
    subOrders {
      id
    }
    orderStatus
    orderItems(sellableItemIds: $sellableItemIds) {
      id
      quantity
      rate
      actualRate
      bookedQuantity
      metadata
      discount {
        id
        flat
        percentage
      }
      order {
        id
      }
      sellableItem {
        id
        name
        taxes {
          id
          name
          percentage
        }
      }
    }
  }
}
    `;

/**
 * __useConfirmedOrderListQuery__
 *
 * To run a query within a React component, call `useConfirmedOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmedOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmedOrderListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      sellableItemIds: // value for 'sellableItemIds'
 *   },
 * });
 */
export function useConfirmedOrderListQuery(baseOptions?: Apollo.QueryHookOptions<ConfirmedOrderListQuery, ConfirmedOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmedOrderListQuery, ConfirmedOrderListQueryVariables>(ConfirmedOrderListDocument, options);
      }
export function useConfirmedOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmedOrderListQuery, ConfirmedOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmedOrderListQuery, ConfirmedOrderListQueryVariables>(ConfirmedOrderListDocument, options);
        }
export type ConfirmedOrderListQueryHookResult = ReturnType<typeof useConfirmedOrderListQuery>;
export type ConfirmedOrderListLazyQueryHookResult = ReturnType<typeof useConfirmedOrderListLazyQuery>;
export type ConfirmedOrderListQueryResult = Apollo.QueryResult<ConfirmedOrderListQuery, ConfirmedOrderListQueryVariables>;
export const TripOrdersDocument = gql`
    query TripOrders($id: Int) {
  tripDetails(tripId: $id) {
    ...TripOrdersFrag
  }
}
    ${TripOrdersFragFragmentDoc}`;

/**
 * __useTripOrdersQuery__
 *
 * To run a query within a React component, call `useTripOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTripOrdersQuery(baseOptions?: Apollo.QueryHookOptions<TripOrdersQuery, TripOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripOrdersQuery, TripOrdersQueryVariables>(TripOrdersDocument, options);
      }
export function useTripOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripOrdersQuery, TripOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripOrdersQuery, TripOrdersQueryVariables>(TripOrdersDocument, options);
        }
export type TripOrdersQueryHookResult = ReturnType<typeof useTripOrdersQuery>;
export type TripOrdersLazyQueryHookResult = ReturnType<typeof useTripOrdersLazyQuery>;
export type TripOrdersQueryResult = Apollo.QueryResult<TripOrdersQuery, TripOrdersQueryVariables>;
export const AllDispatchVehiclesDocument = gql`
    query allDispatchVehicles {
  allVehicles {
    id
    driver {
      id
      fullName
      number
    }
    registrationNumber
    vehicleType {
      id
      category
      name
      capacity
      capacityUnit {
        id
        name
        codename
      }
    }
  }
}
    `;

/**
 * __useAllDispatchVehiclesQuery__
 *
 * To run a query within a React component, call `useAllDispatchVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDispatchVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDispatchVehiclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDispatchVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<AllDispatchVehiclesQuery, AllDispatchVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDispatchVehiclesQuery, AllDispatchVehiclesQueryVariables>(AllDispatchVehiclesDocument, options);
      }
export function useAllDispatchVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDispatchVehiclesQuery, AllDispatchVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDispatchVehiclesQuery, AllDispatchVehiclesQueryVariables>(AllDispatchVehiclesDocument, options);
        }
export type AllDispatchVehiclesQueryHookResult = ReturnType<typeof useAllDispatchVehiclesQuery>;
export type AllDispatchVehiclesLazyQueryHookResult = ReturnType<typeof useAllDispatchVehiclesLazyQuery>;
export type AllDispatchVehiclesQueryResult = Apollo.QueryResult<AllDispatchVehiclesQuery, AllDispatchVehiclesQueryVariables>;
export const OrderItemBookingsDocument = gql`
    query OrderItemBookings($orderItemId: ID!) {
  bookingsByOrderItem(orderItemId: $orderItemId) {
    id
    orderItem {
      id
      sellableItem {
        id
        name
      }
    }
    requiredQuantity
    trip {
      id
      status
      date
      vehicle {
        id
        registrationNumber
      }
      aggregator {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useOrderItemBookingsQuery__
 *
 * To run a query within a React component, call `useOrderItemBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderItemBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderItemBookingsQuery({
 *   variables: {
 *      orderItemId: // value for 'orderItemId'
 *   },
 * });
 */
export function useOrderItemBookingsQuery(baseOptions: Apollo.QueryHookOptions<OrderItemBookingsQuery, OrderItemBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderItemBookingsQuery, OrderItemBookingsQueryVariables>(OrderItemBookingsDocument, options);
      }
export function useOrderItemBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderItemBookingsQuery, OrderItemBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderItemBookingsQuery, OrderItemBookingsQueryVariables>(OrderItemBookingsDocument, options);
        }
export type OrderItemBookingsQueryHookResult = ReturnType<typeof useOrderItemBookingsQuery>;
export type OrderItemBookingsLazyQueryHookResult = ReturnType<typeof useOrderItemBookingsLazyQuery>;
export type OrderItemBookingsQueryResult = Apollo.QueryResult<OrderItemBookingsQuery, OrderItemBookingsQueryVariables>;
export const AddDcDocument = gql`
    mutation AddDC($address: AddressInput, $colorCode: String, $name: String, $photos: [MediaInput], $pointOfContacts: [ID], $areaCatered: Geometry, $customerCode: String!, $plantCode: String!, $storeCode: String!, $primaryPocId: NullableID, $companyCode: String, $salesOfcCode: String, $partnerCode: String, $deliveryConditions: DeliveryConditionInput, $assignedCpc: NullableID, $groupVisibility: [ID], $allowedDepartments: [Int]) {
  addDistributionCentre(
    address: $address
    areaCatered: $areaCatered
    name: $name
    photos: $photos
    pointOfContacts: $pointOfContacts
    colorCode: $colorCode
    customerCode: $customerCode
    plantCode: $plantCode
    storeCode: $storeCode
    primaryPocId: $primaryPocId
    companyCode: $companyCode
    salesOfcCode: $salesOfcCode
    partnerCode: $partnerCode
    assignedCpcId: $assignedCpc
    deliveryConditions: $deliveryConditions
    groupVisibility: $groupVisibility
    allowedDepartments: $allowedDepartments
  ) {
    distributionCentre {
      id
      geometry {
        coordinates
        type
      }
      properties {
        ...DistributionCenterDetailFrag
      }
    }
  }
}
    ${DistributionCenterDetailFragFragmentDoc}`;
export type AddDcMutationFn = Apollo.MutationFunction<AddDcMutation, AddDcMutationVariables>;

/**
 * __useAddDcMutation__
 *
 * To run a mutation, you first call `useAddDcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDcMutation, { data, loading, error }] = useAddDcMutation({
 *   variables: {
 *      address: // value for 'address'
 *      colorCode: // value for 'colorCode'
 *      name: // value for 'name'
 *      photos: // value for 'photos'
 *      pointOfContacts: // value for 'pointOfContacts'
 *      areaCatered: // value for 'areaCatered'
 *      customerCode: // value for 'customerCode'
 *      plantCode: // value for 'plantCode'
 *      storeCode: // value for 'storeCode'
 *      primaryPocId: // value for 'primaryPocId'
 *      companyCode: // value for 'companyCode'
 *      salesOfcCode: // value for 'salesOfcCode'
 *      partnerCode: // value for 'partnerCode'
 *      deliveryConditions: // value for 'deliveryConditions'
 *      assignedCpc: // value for 'assignedCpc'
 *      groupVisibility: // value for 'groupVisibility'
 *      allowedDepartments: // value for 'allowedDepartments'
 *   },
 * });
 */
export function useAddDcMutation(baseOptions?: Apollo.MutationHookOptions<AddDcMutation, AddDcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDcMutation, AddDcMutationVariables>(AddDcDocument, options);
      }
export type AddDcMutationHookResult = ReturnType<typeof useAddDcMutation>;
export type AddDcMutationResult = Apollo.MutationResult<AddDcMutation>;
export type AddDcMutationOptions = Apollo.BaseMutationOptions<AddDcMutation, AddDcMutationVariables>;
export const UpdateDcDocument = gql`
    mutation UpdateDC($id: ID!, $address: AddressInput, $deliveryConditions: DeliveryConditionInput, $deliverySlots: [TimeSlotInput], $colorCode: String, $currentStockPercentage: CustomGenericScalar, $name: String, $photos: [MediaInput], $pickupSlots: [TimeSlotInput], $pointOfContacts: [ID], $maintenanceSlots: [TimeSlotInput], $certifications: [GeneralCertificationInput], $areaCatered: Geometry, $customerCode: String, $plantCode: String, $storeCode: String, $primaryPocId: NullableID, $companyCode: String, $salesOfcCode: String, $partnerCode: String, $assignedCpc: NullableID, $groupVisibility: [ID], $bankDetails: [BankDetailInput], $surveyAreas: [SurveyAreaInput], $archive: Boolean, $allowedDepartments: [Int], $alternateSalesSlots: [TimeSlotInput]) {
  updateDistributionCentre(
    id: $id
    address: $address
    areaCatered: $areaCatered
    deliveryConditions: $deliveryConditions
    deliverySlots: $deliverySlots
    certifications: $certifications
    name: $name
    photos: $photos
    bankDetails: $bankDetails
    pickupSlots: $pickupSlots
    pointOfContacts: $pointOfContacts
    colorCode: $colorCode
    maintenanceSlots: $maintenanceSlots
    customerCode: $customerCode
    plantCode: $plantCode
    storeCode: $storeCode
    primaryPocId: $primaryPocId
    companyCode: $companyCode
    salesOfcCode: $salesOfcCode
    partnerCode: $partnerCode
    assignedCpcId: $assignedCpc
    groupVisibility: $groupVisibility
    surveyAreas: $surveyAreas
    archive: $archive
    allowedDepartments: $allowedDepartments
    alternateSalesSlots: $alternateSalesSlots
    currentStockPercentage: $currentStockPercentage
  ) {
    distributionCentre {
      id
      geometry {
        coordinates
        type
      }
      properties {
        ...DistributionCenterDetailFrag
      }
    }
  }
}
    ${DistributionCenterDetailFragFragmentDoc}`;
export type UpdateDcMutationFn = Apollo.MutationFunction<UpdateDcMutation, UpdateDcMutationVariables>;

/**
 * __useUpdateDcMutation__
 *
 * To run a mutation, you first call `useUpdateDcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDcMutation, { data, loading, error }] = useUpdateDcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      deliveryConditions: // value for 'deliveryConditions'
 *      deliverySlots: // value for 'deliverySlots'
 *      colorCode: // value for 'colorCode'
 *      currentStockPercentage: // value for 'currentStockPercentage'
 *      name: // value for 'name'
 *      photos: // value for 'photos'
 *      pickupSlots: // value for 'pickupSlots'
 *      pointOfContacts: // value for 'pointOfContacts'
 *      maintenanceSlots: // value for 'maintenanceSlots'
 *      certifications: // value for 'certifications'
 *      areaCatered: // value for 'areaCatered'
 *      customerCode: // value for 'customerCode'
 *      plantCode: // value for 'plantCode'
 *      storeCode: // value for 'storeCode'
 *      primaryPocId: // value for 'primaryPocId'
 *      companyCode: // value for 'companyCode'
 *      salesOfcCode: // value for 'salesOfcCode'
 *      partnerCode: // value for 'partnerCode'
 *      assignedCpc: // value for 'assignedCpc'
 *      groupVisibility: // value for 'groupVisibility'
 *      bankDetails: // value for 'bankDetails'
 *      surveyAreas: // value for 'surveyAreas'
 *      archive: // value for 'archive'
 *      allowedDepartments: // value for 'allowedDepartments'
 *      alternateSalesSlots: // value for 'alternateSalesSlots'
 *   },
 * });
 */
export function useUpdateDcMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDcMutation, UpdateDcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDcMutation, UpdateDcMutationVariables>(UpdateDcDocument, options);
      }
export type UpdateDcMutationHookResult = ReturnType<typeof useUpdateDcMutation>;
export type UpdateDcMutationResult = Apollo.MutationResult<UpdateDcMutation>;
export type UpdateDcMutationOptions = Apollo.BaseMutationOptions<UpdateDcMutation, UpdateDcMutationVariables>;
export const AddUpdateStorageLocationDocument = gql`
    mutation AddUpdateStorageLocation($id: ID, $distributionCentreId: ID!, $name: String, $codename: String, $colorCode: String, $responsiblePersonId: ID!, $subLocations: [DCSubLocationInput], $archive: Boolean) {
  addUpdateDcStorageLocation(
    id: $id
    distributionCentreId: $distributionCentreId
    name: $name
    codename: $codename
    colorCode: $colorCode
    responsiblePersonId: $responsiblePersonId
    subLocations: $subLocations
    archive: $archive
  ) {
    storageLocation {
      ...StorageLocationFrag
    }
  }
}
    ${StorageLocationFragFragmentDoc}`;
export type AddUpdateStorageLocationMutationFn = Apollo.MutationFunction<AddUpdateStorageLocationMutation, AddUpdateStorageLocationMutationVariables>;

/**
 * __useAddUpdateStorageLocationMutation__
 *
 * To run a mutation, you first call `useAddUpdateStorageLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateStorageLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateStorageLocationMutation, { data, loading, error }] = useAddUpdateStorageLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      distributionCentreId: // value for 'distributionCentreId'
 *      name: // value for 'name'
 *      codename: // value for 'codename'
 *      colorCode: // value for 'colorCode'
 *      responsiblePersonId: // value for 'responsiblePersonId'
 *      subLocations: // value for 'subLocations'
 *      archive: // value for 'archive'
 *   },
 * });
 */
export function useAddUpdateStorageLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateStorageLocationMutation, AddUpdateStorageLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateStorageLocationMutation, AddUpdateStorageLocationMutationVariables>(AddUpdateStorageLocationDocument, options);
      }
export type AddUpdateStorageLocationMutationHookResult = ReturnType<typeof useAddUpdateStorageLocationMutation>;
export type AddUpdateStorageLocationMutationResult = Apollo.MutationResult<AddUpdateStorageLocationMutation>;
export type AddUpdateStorageLocationMutationOptions = Apollo.BaseMutationOptions<AddUpdateStorageLocationMutation, AddUpdateStorageLocationMutationVariables>;
export const AddUpdateDcStockTakeDocument = gql`
    mutation AddUpdateDCStockTake($id: ID, $distributionCentreId: ID!, $itemCategory: String, $startDay: Int, $startTime: Time, $endDay: Int, $endTime: Time) {
  addUpdateDcStockTakeConfig(
    id: $id
    distributionCentreId: $distributionCentreId
    itemCategory: $itemCategory
    startDay: $startDay
    startTime: $startTime
    endDay: $endDay
    endTime: $endTime
  ) {
    stockConfig {
      id
      startDay
      startTime
      endDay
      endTime
      itemCategory
      distributionCentre {
        id
        name
      }
    }
  }
}
    `;
export type AddUpdateDcStockTakeMutationFn = Apollo.MutationFunction<AddUpdateDcStockTakeMutation, AddUpdateDcStockTakeMutationVariables>;

/**
 * __useAddUpdateDcStockTakeMutation__
 *
 * To run a mutation, you first call `useAddUpdateDcStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateDcStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateDcStockTakeMutation, { data, loading, error }] = useAddUpdateDcStockTakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      distributionCentreId: // value for 'distributionCentreId'
 *      itemCategory: // value for 'itemCategory'
 *      startDay: // value for 'startDay'
 *      startTime: // value for 'startTime'
 *      endDay: // value for 'endDay'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useAddUpdateDcStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateDcStockTakeMutation, AddUpdateDcStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateDcStockTakeMutation, AddUpdateDcStockTakeMutationVariables>(AddUpdateDcStockTakeDocument, options);
      }
export type AddUpdateDcStockTakeMutationHookResult = ReturnType<typeof useAddUpdateDcStockTakeMutation>;
export type AddUpdateDcStockTakeMutationResult = Apollo.MutationResult<AddUpdateDcStockTakeMutation>;
export type AddUpdateDcStockTakeMutationOptions = Apollo.BaseMutationOptions<AddUpdateDcStockTakeMutation, AddUpdateDcStockTakeMutationVariables>;
export const DeleteDcPaymentMethodDocument = gql`
    mutation DeleteDCPaymentMethod($ids: [ID]!) {
  deleteBankDetail(ids: $ids) {
    response
  }
}
    `;
export type DeleteDcPaymentMethodMutationFn = Apollo.MutationFunction<DeleteDcPaymentMethodMutation, DeleteDcPaymentMethodMutationVariables>;

/**
 * __useDeleteDcPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteDcPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDcPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDcPaymentMethodMutation, { data, loading, error }] = useDeleteDcPaymentMethodMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDcPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDcPaymentMethodMutation, DeleteDcPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDcPaymentMethodMutation, DeleteDcPaymentMethodMutationVariables>(DeleteDcPaymentMethodDocument, options);
      }
export type DeleteDcPaymentMethodMutationHookResult = ReturnType<typeof useDeleteDcPaymentMethodMutation>;
export type DeleteDcPaymentMethodMutationResult = Apollo.MutationResult<DeleteDcPaymentMethodMutation>;
export type DeleteDcPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteDcPaymentMethodMutation, DeleteDcPaymentMethodMutationVariables>;
export const DeleteDcCertificationDocument = gql`
    mutation DeleteDCCertification($ids: [ID]!) {
  deleteCertification(ids: $ids) {
    response
  }
}
    `;
export type DeleteDcCertificationMutationFn = Apollo.MutationFunction<DeleteDcCertificationMutation, DeleteDcCertificationMutationVariables>;

/**
 * __useDeleteDcCertificationMutation__
 *
 * To run a mutation, you first call `useDeleteDcCertificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDcCertificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDcCertificationMutation, { data, loading, error }] = useDeleteDcCertificationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDcCertificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDcCertificationMutation, DeleteDcCertificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDcCertificationMutation, DeleteDcCertificationMutationVariables>(DeleteDcCertificationDocument, options);
      }
export type DeleteDcCertificationMutationHookResult = ReturnType<typeof useDeleteDcCertificationMutation>;
export type DeleteDcCertificationMutationResult = Apollo.MutationResult<DeleteDcCertificationMutation>;
export type DeleteDcCertificationMutationOptions = Apollo.BaseMutationOptions<DeleteDcCertificationMutation, DeleteDcCertificationMutationVariables>;
export const DistributionCentersListDocument = gql`
    query DistributionCentersList($query: String, $first: Int, $skip: Int, $filter: DistributionCentreLocationInput) {
  allDistributionCentres(
    query: $query
    first: $first
    skip: $skip
    filter: $filter
  ) {
    ...DistributionCenterListFrag
  }
}
    ${DistributionCenterListFragFragmentDoc}`;

/**
 * __useDistributionCentersListQuery__
 *
 * To run a query within a React component, call `useDistributionCentersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionCentersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionCentersListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDistributionCentersListQuery(baseOptions?: Apollo.QueryHookOptions<DistributionCentersListQuery, DistributionCentersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributionCentersListQuery, DistributionCentersListQueryVariables>(DistributionCentersListDocument, options);
      }
export function useDistributionCentersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributionCentersListQuery, DistributionCentersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributionCentersListQuery, DistributionCentersListQueryVariables>(DistributionCentersListDocument, options);
        }
export type DistributionCentersListQueryHookResult = ReturnType<typeof useDistributionCentersListQuery>;
export type DistributionCentersListLazyQueryHookResult = ReturnType<typeof useDistributionCentersListLazyQuery>;
export type DistributionCentersListQueryResult = Apollo.QueryResult<DistributionCentersListQuery, DistributionCentersListQueryVariables>;
export const DistributionCentersDetailDocument = gql`
    query DistributionCentersDetail($id: ID!) {
  distributionCentreLocationDetail(id: $id) {
    id
    geometry {
      type
      coordinates
    }
    properties {
      ...DistributionCenterDetailFrag
    }
  }
}
    ${DistributionCenterDetailFragFragmentDoc}`;

/**
 * __useDistributionCentersDetailQuery__
 *
 * To run a query within a React component, call `useDistributionCentersDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionCentersDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionCentersDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDistributionCentersDetailQuery(baseOptions: Apollo.QueryHookOptions<DistributionCentersDetailQuery, DistributionCentersDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributionCentersDetailQuery, DistributionCentersDetailQueryVariables>(DistributionCentersDetailDocument, options);
      }
export function useDistributionCentersDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributionCentersDetailQuery, DistributionCentersDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributionCentersDetailQuery, DistributionCentersDetailQueryVariables>(DistributionCentersDetailDocument, options);
        }
export type DistributionCentersDetailQueryHookResult = ReturnType<typeof useDistributionCentersDetailQuery>;
export type DistributionCentersDetailLazyQueryHookResult = ReturnType<typeof useDistributionCentersDetailLazyQuery>;
export type DistributionCentersDetailQueryResult = Apollo.QueryResult<DistributionCentersDetailQuery, DistributionCentersDetailQueryVariables>;
export const AllPeopleSelectorDocument = gql`
    query allPeopleSelector($group: String, $first: Int, $skip: Int, $query: String, $departmentId: ID) {
  usersByGroup(
    groupName: $group
    first: $first
    skip: $skip
    query: $query
    departmentId: $departmentId
  ) {
    id
    fullName
    number
  }
}
    `;

/**
 * __useAllPeopleSelectorQuery__
 *
 * To run a query within a React component, call `useAllPeopleSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPeopleSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPeopleSelectorQuery({
 *   variables: {
 *      group: // value for 'group'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useAllPeopleSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllPeopleSelectorQuery, AllPeopleSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPeopleSelectorQuery, AllPeopleSelectorQueryVariables>(AllPeopleSelectorDocument, options);
      }
export function useAllPeopleSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPeopleSelectorQuery, AllPeopleSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPeopleSelectorQuery, AllPeopleSelectorQueryVariables>(AllPeopleSelectorDocument, options);
        }
export type AllPeopleSelectorQueryHookResult = ReturnType<typeof useAllPeopleSelectorQuery>;
export type AllPeopleSelectorLazyQueryHookResult = ReturnType<typeof useAllPeopleSelectorLazyQuery>;
export type AllPeopleSelectorQueryResult = Apollo.QueryResult<AllPeopleSelectorQuery, AllPeopleSelectorQueryVariables>;
export const AllDcLocationsDocument = gql`
    query AllDCLocations($pocId: ID) {
  allDistributionCentreLocations(filter: {pointOfContacts: $pocId}) {
    id
    properties {
      name
      colorCode
      address {
        id
        latitude
        longitude
        village
      }
    }
    geometry {
      type
      coordinates
    }
  }
}
    `;

/**
 * __useAllDcLocationsQuery__
 *
 * To run a query within a React component, call `useAllDcLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDcLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDcLocationsQuery({
 *   variables: {
 *      pocId: // value for 'pocId'
 *   },
 * });
 */
export function useAllDcLocationsQuery(baseOptions?: Apollo.QueryHookOptions<AllDcLocationsQuery, AllDcLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDcLocationsQuery, AllDcLocationsQueryVariables>(AllDcLocationsDocument, options);
      }
export function useAllDcLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDcLocationsQuery, AllDcLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDcLocationsQuery, AllDcLocationsQueryVariables>(AllDcLocationsDocument, options);
        }
export type AllDcLocationsQueryHookResult = ReturnType<typeof useAllDcLocationsQuery>;
export type AllDcLocationsLazyQueryHookResult = ReturnType<typeof useAllDcLocationsLazyQuery>;
export type AllDcLocationsQueryResult = Apollo.QueryResult<AllDcLocationsQuery, AllDcLocationsQueryVariables>;
export const DcStorageLocationsDocument = gql`
    query DCStorageLocations($first: Int, $skip: Int, $filter: DCSubLocationInput) {
  allDcStorageLocations(first: $first, skip: $skip, filter: $filter) {
    ...StorageLocationFrag
  }
}
    ${StorageLocationFragFragmentDoc}`;

/**
 * __useDcStorageLocationsQuery__
 *
 * To run a query within a React component, call `useDcStorageLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcStorageLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcStorageLocationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDcStorageLocationsQuery(baseOptions?: Apollo.QueryHookOptions<DcStorageLocationsQuery, DcStorageLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcStorageLocationsQuery, DcStorageLocationsQueryVariables>(DcStorageLocationsDocument, options);
      }
export function useDcStorageLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcStorageLocationsQuery, DcStorageLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcStorageLocationsQuery, DcStorageLocationsQueryVariables>(DcStorageLocationsDocument, options);
        }
export type DcStorageLocationsQueryHookResult = ReturnType<typeof useDcStorageLocationsQuery>;
export type DcStorageLocationsLazyQueryHookResult = ReturnType<typeof useDcStorageLocationsLazyQuery>;
export type DcStorageLocationsQueryResult = Apollo.QueryResult<DcStorageLocationsQuery, DcStorageLocationsQueryVariables>;
export const DcStockTakeConfigsDocument = gql`
    query DCStockTakeConfigs($filter: DCStockTakeConfigFilterInput) {
  allDcStockTakeConfigs(filter: $filter) {
    id
    distributionCentre {
      id
      name
    }
    startDay
    endDay
    startTime
    endTime
    itemCategory
  }
}
    `;

/**
 * __useDcStockTakeConfigsQuery__
 *
 * To run a query within a React component, call `useDcStockTakeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcStockTakeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcStockTakeConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDcStockTakeConfigsQuery(baseOptions?: Apollo.QueryHookOptions<DcStockTakeConfigsQuery, DcStockTakeConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcStockTakeConfigsQuery, DcStockTakeConfigsQueryVariables>(DcStockTakeConfigsDocument, options);
      }
export function useDcStockTakeConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcStockTakeConfigsQuery, DcStockTakeConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcStockTakeConfigsQuery, DcStockTakeConfigsQueryVariables>(DcStockTakeConfigsDocument, options);
        }
export type DcStockTakeConfigsQueryHookResult = ReturnType<typeof useDcStockTakeConfigsQuery>;
export type DcStockTakeConfigsLazyQueryHookResult = ReturnType<typeof useDcStockTakeConfigsLazyQuery>;
export type DcStockTakeConfigsQueryResult = Apollo.QueryResult<DcStockTakeConfigsQuery, DcStockTakeConfigsQueryVariables>;
export const DmsBulkAssignDocument = gql`
    mutation DMSBulkAssign($tripIds: [Int!]!, $dockId: Int, $dockSupervisorId: Int) {
  bulkAssignment(
    tripIds: $tripIds
    dockId: $dockId
    dockSupervisorId: $dockSupervisorId
  ) {
    trips {
      id
      dock {
        id
        name
      }
      dockSupervisor {
        id
        fullName
      }
    }
  }
}
    `;
export type DmsBulkAssignMutationFn = Apollo.MutationFunction<DmsBulkAssignMutation, DmsBulkAssignMutationVariables>;

/**
 * __useDmsBulkAssignMutation__
 *
 * To run a mutation, you first call `useDmsBulkAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDmsBulkAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dmsBulkAssignMutation, { data, loading, error }] = useDmsBulkAssignMutation({
 *   variables: {
 *      tripIds: // value for 'tripIds'
 *      dockId: // value for 'dockId'
 *      dockSupervisorId: // value for 'dockSupervisorId'
 *   },
 * });
 */
export function useDmsBulkAssignMutation(baseOptions?: Apollo.MutationHookOptions<DmsBulkAssignMutation, DmsBulkAssignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DmsBulkAssignMutation, DmsBulkAssignMutationVariables>(DmsBulkAssignDocument, options);
      }
export type DmsBulkAssignMutationHookResult = ReturnType<typeof useDmsBulkAssignMutation>;
export type DmsBulkAssignMutationResult = Apollo.MutationResult<DmsBulkAssignMutation>;
export type DmsBulkAssignMutationOptions = Apollo.BaseMutationOptions<DmsBulkAssignMutation, DmsBulkAssignMutationVariables>;
export const ArrivedDockMutationDocument = gql`
    mutation ArrivedDockMutation($tripId: String, $stepId: String, $timestamp: DateTime) {
  logTripStep(
    trip: $tripId
    timestamp: $timestamp
    stepId: $stepId
    latitude: 12.412
    longitude: 23.24
  ) {
    trip {
      id
      tripLogs {
        id
        step {
          id
          stepId
        }
        timestamp
      }
    }
  }
}
    `;
export type ArrivedDockMutationMutationFn = Apollo.MutationFunction<ArrivedDockMutationMutation, ArrivedDockMutationMutationVariables>;

/**
 * __useArrivedDockMutationMutation__
 *
 * To run a mutation, you first call `useArrivedDockMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArrivedDockMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arrivedDockMutationMutation, { data, loading, error }] = useArrivedDockMutationMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      stepId: // value for 'stepId'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useArrivedDockMutationMutation(baseOptions?: Apollo.MutationHookOptions<ArrivedDockMutationMutation, ArrivedDockMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArrivedDockMutationMutation, ArrivedDockMutationMutationVariables>(ArrivedDockMutationDocument, options);
      }
export type ArrivedDockMutationMutationHookResult = ReturnType<typeof useArrivedDockMutationMutation>;
export type ArrivedDockMutationMutationResult = Apollo.MutationResult<ArrivedDockMutationMutation>;
export type ArrivedDockMutationMutationOptions = Apollo.BaseMutationOptions<ArrivedDockMutationMutation, ArrivedDockMutationMutationVariables>;
export const SaveItemDetailsDocument = gql`
    mutation SaveItemDetails($tripId: Int!, $tripIdID: ID, $bookings: [BookInput]) {
  vehicalLoadingList(tripId: $tripId, bookings: $bookings) {
    trip {
      id
      uuid
      estimatedDespatchTime
      loadingPattern
      despatchOtp
      aggregator {
        id
        fullName
      }
      scheduledVehicle {
        id
        driver {
          id
          fullName
          number
        }
        registrationNumber
        vehicleType {
          id
          category
          name
          capacity
          capacityUnit {
            id
            name
            codename
          }
        }
      }
      vehicle {
        id
        driver {
          id
          fullName
          number
        }
        registrationNumber
        vehicleType {
          id
          category
          name
          capacity
          capacityUnit {
            id
            name
            codename
          }
        }
      }
      dock {
        id
        name
      }
      dockSupervisor {
        id
        fullName
        firstName
        lastName
        number
      }
      tripLogs {
        id
        step {
          id
          stepId
        }
      }
      orders {
        id
        trackingCode
        user {
          id
          fullName
        }
        shippingAddress {
          id
          village
          taluka
          address
        }
        orderStatus
        bookingsByTrip(tripId: $tripIdID) {
          id
          loadingSequence
          orderItem {
            sellableItem {
              id
              name
              codename
            }
            quantity
          }
          despatchedQuantity
          despatchPhoto {
            id
            url
          }
          driverDespatchRemark
          driverVerification
        }
      }
    }
  }
}
    `;
export type SaveItemDetailsMutationFn = Apollo.MutationFunction<SaveItemDetailsMutation, SaveItemDetailsMutationVariables>;

/**
 * __useSaveItemDetailsMutation__
 *
 * To run a mutation, you first call `useSaveItemDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemDetailsMutation, { data, loading, error }] = useSaveItemDetailsMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      tripIdID: // value for 'tripIdID'
 *      bookings: // value for 'bookings'
 *   },
 * });
 */
export function useSaveItemDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SaveItemDetailsMutation, SaveItemDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveItemDetailsMutation, SaveItemDetailsMutationVariables>(SaveItemDetailsDocument, options);
      }
export type SaveItemDetailsMutationHookResult = ReturnType<typeof useSaveItemDetailsMutation>;
export type SaveItemDetailsMutationResult = Apollo.MutationResult<SaveItemDetailsMutation>;
export type SaveItemDetailsMutationOptions = Apollo.BaseMutationOptions<SaveItemDetailsMutation, SaveItemDetailsMutationVariables>;
export const ResolveRemarkDocument = gql`
    mutation ResolveRemark($tripId: Int!, $tripIdID: ID!, $bookings: [DriverVerificationInput]) {
  driverLoadingVerification(tripId: $tripId, bookings: $bookings) {
    trip {
      id
      orders {
        id
        trackingCode
        user {
          id
          fullName
        }
        shippingAddress {
          id
          village
          taluka
          address
        }
        orderStatus
        bookingsByTrip(tripId: $tripIdID) {
          id
          loadingSequence
          orderItem {
            sellableItem {
              id
              name
              codename
            }
            quantity
          }
          despatchedQuantity
          despatchPhoto {
            id
            url
          }
          driverDespatchRemark
          driverVerification
        }
      }
    }
  }
}
    `;
export type ResolveRemarkMutationFn = Apollo.MutationFunction<ResolveRemarkMutation, ResolveRemarkMutationVariables>;

/**
 * __useResolveRemarkMutation__
 *
 * To run a mutation, you first call `useResolveRemarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveRemarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveRemarkMutation, { data, loading, error }] = useResolveRemarkMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      tripIdID: // value for 'tripIdID'
 *      bookings: // value for 'bookings'
 *   },
 * });
 */
export function useResolveRemarkMutation(baseOptions?: Apollo.MutationHookOptions<ResolveRemarkMutation, ResolveRemarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveRemarkMutation, ResolveRemarkMutationVariables>(ResolveRemarkDocument, options);
      }
export type ResolveRemarkMutationHookResult = ReturnType<typeof useResolveRemarkMutation>;
export type ResolveRemarkMutationResult = Apollo.MutationResult<ResolveRemarkMutation>;
export type ResolveRemarkMutationOptions = Apollo.BaseMutationOptions<ResolveRemarkMutation, ResolveRemarkMutationVariables>;
export const DispatchListDocument = gql`
    query DispatchList($date: Date!, $query: String, $distributionCentreId: ID, $first: Int, $skip: Int) {
  tripsForDate(
    date: $date
    query: $query
    distributionCentreId: $distributionCentreId
    first: $first
    skip: $skip
  ) {
    id
    uuid
    status
    loadingPattern
    despatchStatus
    vehicle {
      id
      driver {
        id
        fullName
        number
      }
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
    }
    aggregator {
      id
      fullName
    }
    estimatedStartTime
    estimatedEndTime
    startTime
    endTime
    dock {
      id
      name
    }
    dockSupervisor {
      id
      fullName
    }
  }
}
    `;

/**
 * __useDispatchListQuery__
 *
 * To run a query within a React component, call `useDispatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      query: // value for 'query'
 *      distributionCentreId: // value for 'distributionCentreId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useDispatchListQuery(baseOptions: Apollo.QueryHookOptions<DispatchListQuery, DispatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispatchListQuery, DispatchListQueryVariables>(DispatchListDocument, options);
      }
export function useDispatchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispatchListQuery, DispatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispatchListQuery, DispatchListQueryVariables>(DispatchListDocument, options);
        }
export type DispatchListQueryHookResult = ReturnType<typeof useDispatchListQuery>;
export type DispatchListLazyQueryHookResult = ReturnType<typeof useDispatchListLazyQuery>;
export type DispatchListQueryResult = Apollo.QueryResult<DispatchListQuery, DispatchListQueryVariables>;
export const AllDocksDocument = gql`
    query AllDocks {
  allDocks {
    id
    name
  }
}
    `;

/**
 * __useAllDocksQuery__
 *
 * To run a query within a React component, call `useAllDocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDocksQuery(baseOptions?: Apollo.QueryHookOptions<AllDocksQuery, AllDocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDocksQuery, AllDocksQueryVariables>(AllDocksDocument, options);
      }
export function useAllDocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDocksQuery, AllDocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDocksQuery, AllDocksQueryVariables>(AllDocksDocument, options);
        }
export type AllDocksQueryHookResult = ReturnType<typeof useAllDocksQuery>;
export type AllDocksLazyQueryHookResult = ReturnType<typeof useAllDocksLazyQuery>;
export type AllDocksQueryResult = Apollo.QueryResult<AllDocksQuery, AllDocksQueryVariables>;
export const AllSkusDocument = gql`
    query AllSkus {
  allSkuTypes {
    id
    name
  }
}
    `;

/**
 * __useAllSkusQuery__
 *
 * To run a query within a React component, call `useAllSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSkusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSkusQuery(baseOptions?: Apollo.QueryHookOptions<AllSkusQuery, AllSkusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSkusQuery, AllSkusQueryVariables>(AllSkusDocument, options);
      }
export function useAllSkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSkusQuery, AllSkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSkusQuery, AllSkusQueryVariables>(AllSkusDocument, options);
        }
export type AllSkusQueryHookResult = ReturnType<typeof useAllSkusQuery>;
export type AllSkusLazyQueryHookResult = ReturnType<typeof useAllSkusLazyQuery>;
export type AllSkusQueryResult = Apollo.QueryResult<AllSkusQuery, AllSkusQueryVariables>;
export const DmsTripDetailsDocument = gql`
    query DmsTripDetails($tripIdInt: Int!, $tripId: ID!) {
  tripDetails(tripId: $tripIdInt) {
    id
    uuid
    estimatedDespatchTime
    loadingPattern
    despatchStatus
    despatchOtp
    aggregator {
      id
      fullName
    }
    scheduledVehicle {
      id
      driver {
        id
        fullName
        number
      }
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
    }
    vehicle {
      id
      driver {
        id
        fullName
        number
      }
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
    }
    dock {
      id
      name
    }
    dockSupervisor {
      id
      fullName
      firstName
      lastName
      number
    }
    tripLogs {
      id
      step {
        id
        stepId
      }
    }
    orders {
      id
      trackingCode
      user {
        id
        fullName
      }
      shippingAddress {
        id
        village
        taluka
        address
      }
      orderStatus
      bookingsByTrip(tripId: $tripId) {
        id
        loadingSequence
        orderItem {
          sellableItem {
            id
            name
            codename
          }
          quantity
        }
        despatchedQuantity
        despatchPhoto {
          id
          url
        }
        driverDespatchRemark
        driverVerification
      }
    }
  }
}
    `;

/**
 * __useDmsTripDetailsQuery__
 *
 * To run a query within a React component, call `useDmsTripDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDmsTripDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDmsTripDetailsQuery({
 *   variables: {
 *      tripIdInt: // value for 'tripIdInt'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useDmsTripDetailsQuery(baseOptions: Apollo.QueryHookOptions<DmsTripDetailsQuery, DmsTripDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DmsTripDetailsQuery, DmsTripDetailsQueryVariables>(DmsTripDetailsDocument, options);
      }
export function useDmsTripDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DmsTripDetailsQuery, DmsTripDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DmsTripDetailsQuery, DmsTripDetailsQueryVariables>(DmsTripDetailsDocument, options);
        }
export type DmsTripDetailsQueryHookResult = ReturnType<typeof useDmsTripDetailsQuery>;
export type DmsTripDetailsLazyQueryHookResult = ReturnType<typeof useDmsTripDetailsLazyQuery>;
export type DmsTripDetailsQueryResult = Apollo.QueryResult<DmsTripDetailsQuery, DmsTripDetailsQueryVariables>;
export const ExtraSkusDocument = gql`
    query ExtraSkus($tripId: Int!) {
  tripDetails(tripId: $tripId) {
    id
  }
}
    `;

/**
 * __useExtraSkusQuery__
 *
 * To run a query within a React component, call `useExtraSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtraSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtraSkusQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useExtraSkusQuery(baseOptions: Apollo.QueryHookOptions<ExtraSkusQuery, ExtraSkusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtraSkusQuery, ExtraSkusQueryVariables>(ExtraSkusDocument, options);
      }
export function useExtraSkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtraSkusQuery, ExtraSkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtraSkusQuery, ExtraSkusQueryVariables>(ExtraSkusDocument, options);
        }
export type ExtraSkusQueryHookResult = ReturnType<typeof useExtraSkusQuery>;
export type ExtraSkusLazyQueryHookResult = ReturnType<typeof useExtraSkusLazyQuery>;
export type ExtraSkusQueryResult = Apollo.QueryResult<ExtraSkusQuery, ExtraSkusQueryVariables>;
export const AllItemsInTripDocument = gql`
    query AllItemsInTrip($tripId: ID!) {
  siByBooking(tripId: $tripId) {
    sellableItem {
      id
      name
    }
    itemCount
    requiredQuantity
    despatchedQuantity
    orders {
      id
      trackingCode
      orderItems {
        quantity
        sellableItem {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAllItemsInTripQuery__
 *
 * To run a query within a React component, call `useAllItemsInTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllItemsInTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllItemsInTripQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useAllItemsInTripQuery(baseOptions: Apollo.QueryHookOptions<AllItemsInTripQuery, AllItemsInTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllItemsInTripQuery, AllItemsInTripQueryVariables>(AllItemsInTripDocument, options);
      }
export function useAllItemsInTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllItemsInTripQuery, AllItemsInTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllItemsInTripQuery, AllItemsInTripQueryVariables>(AllItemsInTripDocument, options);
        }
export type AllItemsInTripQueryHookResult = ReturnType<typeof useAllItemsInTripQuery>;
export type AllItemsInTripLazyQueryHookResult = ReturnType<typeof useAllItemsInTripLazyQuery>;
export type AllItemsInTripQueryResult = Apollo.QueryResult<AllItemsInTripQuery, AllItemsInTripQueryVariables>;
export const ItemDetailsDocument = gql`
    query ItemDetails($tripId: ID!, $sellableItemIds: [ID]) {
  siByBooking(tripId: $tripId, sellableItemIds: $sellableItemIds) {
    sellableItem {
      id
      name
    }
    itemCount
    requiredQuantity
    despatchedQuantity
    orders {
      id
      trackingCode
      user {
        id
        fullName
      }
      shippingAddress {
        id
        village
        taluka
        address
      }
      orderStatus
      orderItems(sellableItemIds: $sellableItemIds) {
        id
        quantity
        sellableItem {
          id
          name
        }
        itemBookings {
          id
          loadingSequence
          despatchedQuantity
          despatchPhoto {
            id
            url
          }
          driverDespatchRemark
          driverVerification
        }
      }
    }
  }
}
    `;

/**
 * __useItemDetailsQuery__
 *
 * To run a query within a React component, call `useItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemDetailsQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      sellableItemIds: // value for 'sellableItemIds'
 *   },
 * });
 */
export function useItemDetailsQuery(baseOptions: Apollo.QueryHookOptions<ItemDetailsQuery, ItemDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemDetailsQuery, ItemDetailsQueryVariables>(ItemDetailsDocument, options);
      }
export function useItemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemDetailsQuery, ItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemDetailsQuery, ItemDetailsQueryVariables>(ItemDetailsDocument, options);
        }
export type ItemDetailsQueryHookResult = ReturnType<typeof useItemDetailsQuery>;
export type ItemDetailsLazyQueryHookResult = ReturnType<typeof useItemDetailsLazyQuery>;
export type ItemDetailsQueryResult = Apollo.QueryResult<ItemDetailsQuery, ItemDetailsQueryVariables>;
export const DockAddUpdateDocument = gql`
    mutation DockAddUpdate($address: AddressInput, $archive: Boolean, $codename: String, $depotId: ID, $distributionCentreId: ID, $id: ID, $name: String) {
  addUpdateDock(
    address: $address
    archive: $archive
    codename: $codename
    depotId: $depotId
    distributionCentreId: $distributionCentreId
    id: $id
    name: $name
  ) {
    dock {
      ...DockFrag
    }
  }
}
    ${DockFragFragmentDoc}`;
export type DockAddUpdateMutationFn = Apollo.MutationFunction<DockAddUpdateMutation, DockAddUpdateMutationVariables>;

/**
 * __useDockAddUpdateMutation__
 *
 * To run a mutation, you first call `useDockAddUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDockAddUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dockAddUpdateMutation, { data, loading, error }] = useDockAddUpdateMutation({
 *   variables: {
 *      address: // value for 'address'
 *      archive: // value for 'archive'
 *      codename: // value for 'codename'
 *      depotId: // value for 'depotId'
 *      distributionCentreId: // value for 'distributionCentreId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDockAddUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DockAddUpdateMutation, DockAddUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DockAddUpdateMutation, DockAddUpdateMutationVariables>(DockAddUpdateDocument, options);
      }
export type DockAddUpdateMutationHookResult = ReturnType<typeof useDockAddUpdateMutation>;
export type DockAddUpdateMutationResult = Apollo.MutationResult<DockAddUpdateMutation>;
export type DockAddUpdateMutationOptions = Apollo.BaseMutationOptions<DockAddUpdateMutation, DockAddUpdateMutationVariables>;
export const DcDocksDocument = gql`
    query DcDocks($first: Int, $skip: Int, $filter: AllDockFilterInput, $query: String) {
  allDocks(first: $first, skip: $skip, filter: $filter, query: $query) {
    ...DockFrag
  }
}
    ${DockFragFragmentDoc}`;

/**
 * __useDcDocksQuery__
 *
 * To run a query within a React component, call `useDcDocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcDocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcDocksQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDcDocksQuery(baseOptions?: Apollo.QueryHookOptions<DcDocksQuery, DcDocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcDocksQuery, DcDocksQueryVariables>(DcDocksDocument, options);
      }
export function useDcDocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcDocksQuery, DcDocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcDocksQuery, DcDocksQueryVariables>(DcDocksDocument, options);
        }
export type DcDocksQueryHookResult = ReturnType<typeof useDcDocksQuery>;
export type DcDocksLazyQueryHookResult = ReturnType<typeof useDcDocksLazyQuery>;
export type DcDocksQueryResult = Apollo.QueryResult<DcDocksQuery, DcDocksQueryVariables>;
export const DockDetailsDocument = gql`
    query DockDetails($id: ID!) {
  dockDetail(id: $id) {
    ...DockFrag
  }
}
    ${DockFragFragmentDoc}`;

/**
 * __useDockDetailsQuery__
 *
 * To run a query within a React component, call `useDockDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDockDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDockDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDockDetailsQuery(baseOptions: Apollo.QueryHookOptions<DockDetailsQuery, DockDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DockDetailsQuery, DockDetailsQueryVariables>(DockDetailsDocument, options);
      }
export function useDockDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DockDetailsQuery, DockDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DockDetailsQuery, DockDetailsQueryVariables>(DockDetailsDocument, options);
        }
export type DockDetailsQueryHookResult = ReturnType<typeof useDockDetailsQuery>;
export type DockDetailsLazyQueryHookResult = ReturnType<typeof useDockDetailsLazyQuery>;
export type DockDetailsQueryResult = Apollo.QueryResult<DockDetailsQuery, DockDetailsQueryVariables>;
export const AllTaskLogsDocument = gql`
    query AllTaskLogs($query: String, $first: Int, $skip: Int, $filter: TaskLogFilterInput) {
  allTaskLogs(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    createdAt
    taskName
    responseCode
    responseData
    requestData
    isOk
    periodicTask {
      name
    }
  }
}
    `;

/**
 * __useAllTaskLogsQuery__
 *
 * To run a query within a React component, call `useAllTaskLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTaskLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTaskLogsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllTaskLogsQuery(baseOptions?: Apollo.QueryHookOptions<AllTaskLogsQuery, AllTaskLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTaskLogsQuery, AllTaskLogsQueryVariables>(AllTaskLogsDocument, options);
      }
export function useAllTaskLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTaskLogsQuery, AllTaskLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTaskLogsQuery, AllTaskLogsQueryVariables>(AllTaskLogsDocument, options);
        }
export type AllTaskLogsQueryHookResult = ReturnType<typeof useAllTaskLogsQuery>;
export type AllTaskLogsLazyQueryHookResult = ReturnType<typeof useAllTaskLogsLazyQuery>;
export type AllTaskLogsQueryResult = Apollo.QueryResult<AllTaskLogsQuery, AllTaskLogsQueryVariables>;
export const AllFarmersListDocument = gql`
    query allFarmersList($query: String, $group: String, $first: Int, $skip: Int) {
  usersByGroup(query: $query, groupName: $group, first: $first, skip: $skip) {
    ...FarmerListFrag
  }
}
    ${FarmerListFragFragmentDoc}`;

/**
 * __useAllFarmersListQuery__
 *
 * To run a query within a React component, call `useAllFarmersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFarmersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFarmersListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      group: // value for 'group'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAllFarmersListQuery(baseOptions?: Apollo.QueryHookOptions<AllFarmersListQuery, AllFarmersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFarmersListQuery, AllFarmersListQueryVariables>(AllFarmersListDocument, options);
      }
export function useAllFarmersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFarmersListQuery, AllFarmersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFarmersListQuery, AllFarmersListQueryVariables>(AllFarmersListDocument, options);
        }
export type AllFarmersListQueryHookResult = ReturnType<typeof useAllFarmersListQuery>;
export type AllFarmersListLazyQueryHookResult = ReturnType<typeof useAllFarmersListLazyQuery>;
export type AllFarmersListQueryResult = Apollo.QueryResult<AllFarmersListQuery, AllFarmersListQueryVariables>;
export const FarmerDetailsDocument = gql`
    query farmerDetails($id: Int!) {
  userDetails(userId: $id) {
    ...FarmerDetailsFrag
  }
}
    ${FarmerDetailsFragFragmentDoc}`;

/**
 * __useFarmerDetailsQuery__
 *
 * To run a query within a React component, call `useFarmerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFarmerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFarmerDetailsQuery(baseOptions: Apollo.QueryHookOptions<FarmerDetailsQuery, FarmerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FarmerDetailsQuery, FarmerDetailsQueryVariables>(FarmerDetailsDocument, options);
      }
export function useFarmerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FarmerDetailsQuery, FarmerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FarmerDetailsQuery, FarmerDetailsQueryVariables>(FarmerDetailsDocument, options);
        }
export type FarmerDetailsQueryHookResult = ReturnType<typeof useFarmerDetailsQuery>;
export type FarmerDetailsLazyQueryHookResult = ReturnType<typeof useFarmerDetailsLazyQuery>;
export type FarmerDetailsQueryResult = Apollo.QueryResult<FarmerDetailsQuery, FarmerDetailsQueryVariables>;
export const AddFarmerDocument = gql`
    mutation addFarmer($farmer: FarmerInput) {
  addUpdateOnlyFarmer(user: $farmer) {
    user {
      ...FarmerDetailsFrag
    }
  }
}
    ${FarmerDetailsFragFragmentDoc}`;
export type AddFarmerMutationFn = Apollo.MutationFunction<AddFarmerMutation, AddFarmerMutationVariables>;

/**
 * __useAddFarmerMutation__
 *
 * To run a mutation, you first call `useAddFarmerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFarmerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFarmerMutation, { data, loading, error }] = useAddFarmerMutation({
 *   variables: {
 *      farmer: // value for 'farmer'
 *   },
 * });
 */
export function useAddFarmerMutation(baseOptions?: Apollo.MutationHookOptions<AddFarmerMutation, AddFarmerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFarmerMutation, AddFarmerMutationVariables>(AddFarmerDocument, options);
      }
export type AddFarmerMutationHookResult = ReturnType<typeof useAddFarmerMutation>;
export type AddFarmerMutationResult = Apollo.MutationResult<AddFarmerMutation>;
export type AddFarmerMutationOptions = Apollo.BaseMutationOptions<AddFarmerMutation, AddFarmerMutationVariables>;
export const ChangeTransactionStatusDocument = gql`
    mutation changeTransactionStatus($status: String, $transactionIds: [String]) {
  reconcileBulkTransaction(status: $status, transactionIds: $transactionIds) {
    transactions {
      id
      status
    }
  }
}
    `;
export type ChangeTransactionStatusMutationFn = Apollo.MutationFunction<ChangeTransactionStatusMutation, ChangeTransactionStatusMutationVariables>;

/**
 * __useChangeTransactionStatusMutation__
 *
 * To run a mutation, you first call `useChangeTransactionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTransactionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTransactionStatusMutation, { data, loading, error }] = useChangeTransactionStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      transactionIds: // value for 'transactionIds'
 *   },
 * });
 */
export function useChangeTransactionStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTransactionStatusMutation, ChangeTransactionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTransactionStatusMutation, ChangeTransactionStatusMutationVariables>(ChangeTransactionStatusDocument, options);
      }
export type ChangeTransactionStatusMutationHookResult = ReturnType<typeof useChangeTransactionStatusMutation>;
export type ChangeTransactionStatusMutationResult = Apollo.MutationResult<ChangeTransactionStatusMutation>;
export type ChangeTransactionStatusMutationOptions = Apollo.BaseMutationOptions<ChangeTransactionStatusMutation, ChangeTransactionStatusMutationVariables>;
export const ApproveOrderTransactionDocument = gql`
    mutation ApproveOrderTransaction($orderTransactionId: ID!, $approvalStatus: String!, $remark: String) {
  orderTransactionApproval(
    orderTransactionId: $orderTransactionId
    approvalStatus: $approvalStatus
    remark: $remark
  ) {
    orderTransaction {
      id
      metadata
    }
    order {
      id
      metadata
    }
  }
}
    `;
export type ApproveOrderTransactionMutationFn = Apollo.MutationFunction<ApproveOrderTransactionMutation, ApproveOrderTransactionMutationVariables>;

/**
 * __useApproveOrderTransactionMutation__
 *
 * To run a mutation, you first call `useApproveOrderTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrderTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrderTransactionMutation, { data, loading, error }] = useApproveOrderTransactionMutation({
 *   variables: {
 *      orderTransactionId: // value for 'orderTransactionId'
 *      approvalStatus: // value for 'approvalStatus'
 *      remark: // value for 'remark'
 *   },
 * });
 */
export function useApproveOrderTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrderTransactionMutation, ApproveOrderTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrderTransactionMutation, ApproveOrderTransactionMutationVariables>(ApproveOrderTransactionDocument, options);
      }
export type ApproveOrderTransactionMutationHookResult = ReturnType<typeof useApproveOrderTransactionMutation>;
export type ApproveOrderTransactionMutationResult = Apollo.MutationResult<ApproveOrderTransactionMutation>;
export type ApproveOrderTransactionMutationOptions = Apollo.BaseMutationOptions<ApproveOrderTransactionMutation, ApproveOrderTransactionMutationVariables>;
export const AllTransactionsDocument = gql`
    query allTransactions($filter: TransactionDetailInput, $query: String, $first: Int, $skip: Int) {
  allTransactions(filter: $filter, query: $query, first: $first, skip: $skip) {
    id
    status
    transactionId
    transactionType {
      id
      codename
    }
    account {
      id
      distributioncentreSet {
        id
        name
      }
    }
    date
    paymentMethod {
      id
      codename
      name
    }
    referenceId
    recordedBy {
      id
      username
    }
    remark
    amount
    currency {
      id
      name
    }
    attachments {
      id
      url
    }
  }
}
    `;

/**
 * __useAllTransactionsQuery__
 *
 * To run a query within a React component, call `useAllTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAllTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<AllTransactionsQuery, AllTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTransactionsQuery, AllTransactionsQueryVariables>(AllTransactionsDocument, options);
      }
export function useAllTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTransactionsQuery, AllTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTransactionsQuery, AllTransactionsQueryVariables>(AllTransactionsDocument, options);
        }
export type AllTransactionsQueryHookResult = ReturnType<typeof useAllTransactionsQuery>;
export type AllTransactionsLazyQueryHookResult = ReturnType<typeof useAllTransactionsLazyQuery>;
export type AllTransactionsQueryResult = Apollo.QueryResult<AllTransactionsQuery, AllTransactionsQueryVariables>;
export const ReconciliationSummaryFundFlowDocument = gql`
    query reconciliationSummaryFundFlow($filter: ReconciliationSummaryFundFlowInput!) {
  reconciliationSummaryFundFlow(filter: $filter) {
    distributionCentreId
    distributionCentre_Name
    openingBalance
    netSale
    collection
    deposit
    closingBalance
    reconciliationStatus
  }
}
    `;

/**
 * __useReconciliationSummaryFundFlowQuery__
 *
 * To run a query within a React component, call `useReconciliationSummaryFundFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useReconciliationSummaryFundFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconciliationSummaryFundFlowQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReconciliationSummaryFundFlowQuery(baseOptions: Apollo.QueryHookOptions<ReconciliationSummaryFundFlowQuery, ReconciliationSummaryFundFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReconciliationSummaryFundFlowQuery, ReconciliationSummaryFundFlowQueryVariables>(ReconciliationSummaryFundFlowDocument, options);
      }
export function useReconciliationSummaryFundFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReconciliationSummaryFundFlowQuery, ReconciliationSummaryFundFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReconciliationSummaryFundFlowQuery, ReconciliationSummaryFundFlowQueryVariables>(ReconciliationSummaryFundFlowDocument, options);
        }
export type ReconciliationSummaryFundFlowQueryHookResult = ReturnType<typeof useReconciliationSummaryFundFlowQuery>;
export type ReconciliationSummaryFundFlowLazyQueryHookResult = ReturnType<typeof useReconciliationSummaryFundFlowLazyQuery>;
export type ReconciliationSummaryFundFlowQueryResult = Apollo.QueryResult<ReconciliationSummaryFundFlowQuery, ReconciliationSummaryFundFlowQueryVariables>;
export const AllDcCollectionLogsDocument = gql`
    query allDcCollectionLogs($query: String, $first: Int, $skip: Int, $filter: DCCollectionLogFilterInput) {
  allDcCollectionLogs(query: $query, first: $first, skip: $skip, filter: $filter) {
    cashOpening
    cashCollection
    cashDeposit
    cashClosing
    chequeOpening
    chequeCollection
    chequeDeposit
    cashDeposit
    chequeClosing
    creditSaleOpening
    creditSaleClosing
    othersCollection
  }
}
    `;

/**
 * __useAllDcCollectionLogsQuery__
 *
 * To run a query within a React component, call `useAllDcCollectionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDcCollectionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDcCollectionLogsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllDcCollectionLogsQuery(baseOptions?: Apollo.QueryHookOptions<AllDcCollectionLogsQuery, AllDcCollectionLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDcCollectionLogsQuery, AllDcCollectionLogsQueryVariables>(AllDcCollectionLogsDocument, options);
      }
export function useAllDcCollectionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDcCollectionLogsQuery, AllDcCollectionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDcCollectionLogsQuery, AllDcCollectionLogsQueryVariables>(AllDcCollectionLogsDocument, options);
        }
export type AllDcCollectionLogsQueryHookResult = ReturnType<typeof useAllDcCollectionLogsQuery>;
export type AllDcCollectionLogsLazyQueryHookResult = ReturnType<typeof useAllDcCollectionLogsLazyQuery>;
export type AllDcCollectionLogsQueryResult = Apollo.QueryResult<AllDcCollectionLogsQuery, AllDcCollectionLogsQueryVariables>;
export const PaymentVerificationOrdersDocument = gql`
    query PaymentVerificationOrders($verificationStatuses: [String], $search: String, $startDate: Date, $endDate: Date, $distributionCentreId: ID, $skip: Int, $first: Int) {
  paymentVerificationOrders(
    verificationStatuses: $verificationStatuses
    search: $search
    startDate: $startDate
    endDate: $endDate
    distributionCentreId: $distributionCentreId
    skip: $skip
    first: $first
  ) {
    id
    trackingCode
    metadata
    orderStatus
    orderCategory
    createdAt
    paymentStatus
    paymentMethod
    totalAmount
    outstandingAmount
    user {
      id
      fullName
      shopsManaged {
        id
        name
      }
    }
    shippingAddress {
      id
      village
    }
    transactions {
      id
      amount
      status
      referenceId
      createdAt
      metadata
      attachment {
        id
        url
      }
    }
  }
}
    `;

/**
 * __usePaymentVerificationOrdersQuery__
 *
 * To run a query within a React component, call `usePaymentVerificationOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentVerificationOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentVerificationOrdersQuery({
 *   variables: {
 *      verificationStatuses: // value for 'verificationStatuses'
 *      search: // value for 'search'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      distributionCentreId: // value for 'distributionCentreId'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePaymentVerificationOrdersQuery(baseOptions?: Apollo.QueryHookOptions<PaymentVerificationOrdersQuery, PaymentVerificationOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentVerificationOrdersQuery, PaymentVerificationOrdersQueryVariables>(PaymentVerificationOrdersDocument, options);
      }
export function usePaymentVerificationOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentVerificationOrdersQuery, PaymentVerificationOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentVerificationOrdersQuery, PaymentVerificationOrdersQueryVariables>(PaymentVerificationOrdersDocument, options);
        }
export type PaymentVerificationOrdersQueryHookResult = ReturnType<typeof usePaymentVerificationOrdersQuery>;
export type PaymentVerificationOrdersLazyQueryHookResult = ReturnType<typeof usePaymentVerificationOrdersLazyQuery>;
export type PaymentVerificationOrdersQueryResult = Apollo.QueryResult<PaymentVerificationOrdersQuery, PaymentVerificationOrdersQueryVariables>;
export const AddGateLogsDocument = gql`
    mutation AddGateLogs($gateLogs: [BulkAddGateLogsInput]!) {
  bulkAddGateLogs(gateLogs: $gateLogs) {
    success
    message
    createdLogs {
      id
      gateStatus
      schedule {
        id
      }
    }
  }
}
    `;
export type AddGateLogsMutationFn = Apollo.MutationFunction<AddGateLogsMutation, AddGateLogsMutationVariables>;

/**
 * __useAddGateLogsMutation__
 *
 * To run a mutation, you first call `useAddGateLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGateLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGateLogsMutation, { data, loading, error }] = useAddGateLogsMutation({
 *   variables: {
 *      gateLogs: // value for 'gateLogs'
 *   },
 * });
 */
export function useAddGateLogsMutation(baseOptions?: Apollo.MutationHookOptions<AddGateLogsMutation, AddGateLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGateLogsMutation, AddGateLogsMutationVariables>(AddGateLogsDocument, options);
      }
export type AddGateLogsMutationHookResult = ReturnType<typeof useAddGateLogsMutation>;
export type AddGateLogsMutationResult = Apollo.MutationResult<AddGateLogsMutation>;
export type AddGateLogsMutationOptions = Apollo.BaseMutationOptions<AddGateLogsMutation, AddGateLogsMutationVariables>;
export const RemoveM2MLinksDocument = gql`
    mutation RemoveM2MLinks($field: String!, $fieldIds: [ID], $model: String!, $modelId: ID!) {
  removeM2mFieldLink(
    field: $field
    fieldIds: $fieldIds
    model: $model
    modelId: $modelId
  ) {
    response
  }
}
    `;
export type RemoveM2MLinksMutationFn = Apollo.MutationFunction<RemoveM2MLinksMutation, RemoveM2MLinksMutationVariables>;

/**
 * __useRemoveM2MLinksMutation__
 *
 * To run a mutation, you first call `useRemoveM2MLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveM2MLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeM2MLinksMutation, { data, loading, error }] = useRemoveM2MLinksMutation({
 *   variables: {
 *      field: // value for 'field'
 *      fieldIds: // value for 'fieldIds'
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRemoveM2MLinksMutation(baseOptions?: Apollo.MutationHookOptions<RemoveM2MLinksMutation, RemoveM2MLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveM2MLinksMutation, RemoveM2MLinksMutationVariables>(RemoveM2MLinksDocument, options);
      }
export type RemoveM2MLinksMutationHookResult = ReturnType<typeof useRemoveM2MLinksMutation>;
export type RemoveM2MLinksMutationResult = Apollo.MutationResult<RemoveM2MLinksMutation>;
export type RemoveM2MLinksMutationOptions = Apollo.BaseMutationOptions<RemoveM2MLinksMutation, RemoveM2MLinksMutationVariables>;
export const AddGroupMutationDocument = gql`
    mutation AddGroupMutation($id: Int, $name: String!, $permissions: [Int!]) {
  addGroup(id: $id, name: $name, permissions: $permissions) {
    group {
      ...GroupDetailFrag
    }
  }
}
    ${GroupDetailFragFragmentDoc}`;
export type AddGroupMutationMutationFn = Apollo.MutationFunction<AddGroupMutationMutation, AddGroupMutationMutationVariables>;

/**
 * __useAddGroupMutationMutation__
 *
 * To run a mutation, you first call `useAddGroupMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupMutationMutation, { data, loading, error }] = useAddGroupMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAddGroupMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddGroupMutationMutation, AddGroupMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGroupMutationMutation, AddGroupMutationMutationVariables>(AddGroupMutationDocument, options);
      }
export type AddGroupMutationMutationHookResult = ReturnType<typeof useAddGroupMutationMutation>;
export type AddGroupMutationMutationResult = Apollo.MutationResult<AddGroupMutationMutation>;
export type AddGroupMutationMutationOptions = Apollo.BaseMutationOptions<AddGroupMutationMutation, AddGroupMutationMutationVariables>;
export const AllGroupsListDocument = gql`
    query allGroupsList {
  allGroups {
    ...GroupDetailFrag
  }
}
    ${GroupDetailFragFragmentDoc}`;

/**
 * __useAllGroupsListQuery__
 *
 * To run a query within a React component, call `useAllGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<AllGroupsListQuery, AllGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGroupsListQuery, AllGroupsListQueryVariables>(AllGroupsListDocument, options);
      }
export function useAllGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGroupsListQuery, AllGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGroupsListQuery, AllGroupsListQueryVariables>(AllGroupsListDocument, options);
        }
export type AllGroupsListQueryHookResult = ReturnType<typeof useAllGroupsListQuery>;
export type AllGroupsListLazyQueryHookResult = ReturnType<typeof useAllGroupsListLazyQuery>;
export type AllGroupsListQueryResult = Apollo.QueryResult<AllGroupsListQuery, AllGroupsListQueryVariables>;
export const GetGroupDetailsDocument = gql`
    query getGroupDetails($id: Int, $groupName: String) {
  groupDetails(groupId: $id, groupName: $groupName) {
    ...GroupDetailFrag
  }
}
    ${GroupDetailFragFragmentDoc}`;

/**
 * __useGetGroupDetailsQuery__
 *
 * To run a query within a React component, call `useGetGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useGetGroupDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>(GetGroupDetailsDocument, options);
      }
export function useGetGroupDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>(GetGroupDetailsDocument, options);
        }
export type GetGroupDetailsQueryHookResult = ReturnType<typeof useGetGroupDetailsQuery>;
export type GetGroupDetailsLazyQueryHookResult = ReturnType<typeof useGetGroupDetailsLazyQuery>;
export type GetGroupDetailsQueryResult = Apollo.QueryResult<GetGroupDetailsQuery, GetGroupDetailsQueryVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: Int!) {
  delGroup(groupId: $id) {
    groupId
  }
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const AddUpdateBulkInwardMutationDocument = gql`
    mutation AddUpdateBulkInwardMutation($id: Int, $grade: Int, $grossWeight: Float, $tareWeight: Float, $inwardedQuantity: Int, $standardDeduction: Float, $status: String, $skuType: ID, $unloadingTeamId: ID, $expense: Float, $unloadingLocationId: ID, $unloadingSubLocationId: ID, $rstNo: String) {
  addUpdateBulkInward(
    trip: $id
    grade: $grade
    grossWeight: $grossWeight
    tareWeight: $tareWeight
    status: $status
    inwardedQuantity: $inwardedQuantity
    standardDeduction: $standardDeduction
    skuType: $skuType
    unloadingTeamId: $unloadingTeamId
    expense: $expense
    unloadingLocationId: $unloadingLocationId
    unloadingSubLocationId: $unloadingSubLocationId
    rstNo: $rstNo
  ) {
    trip {
      ...TripDetailFrag
    }
  }
}
    ${TripDetailFragFragmentDoc}`;
export type AddUpdateBulkInwardMutationMutationFn = Apollo.MutationFunction<AddUpdateBulkInwardMutationMutation, AddUpdateBulkInwardMutationMutationVariables>;

/**
 * __useAddUpdateBulkInwardMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdateBulkInwardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateBulkInwardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateBulkInwardMutationMutation, { data, loading, error }] = useAddUpdateBulkInwardMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      grade: // value for 'grade'
 *      grossWeight: // value for 'grossWeight'
 *      tareWeight: // value for 'tareWeight'
 *      inwardedQuantity: // value for 'inwardedQuantity'
 *      standardDeduction: // value for 'standardDeduction'
 *      status: // value for 'status'
 *      skuType: // value for 'skuType'
 *      unloadingTeamId: // value for 'unloadingTeamId'
 *      expense: // value for 'expense'
 *      unloadingLocationId: // value for 'unloadingLocationId'
 *      unloadingSubLocationId: // value for 'unloadingSubLocationId'
 *      rstNo: // value for 'rstNo'
 *   },
 * });
 */
export function useAddUpdateBulkInwardMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateBulkInwardMutationMutation, AddUpdateBulkInwardMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateBulkInwardMutationMutation, AddUpdateBulkInwardMutationMutationVariables>(AddUpdateBulkInwardMutationDocument, options);
      }
export type AddUpdateBulkInwardMutationMutationHookResult = ReturnType<typeof useAddUpdateBulkInwardMutationMutation>;
export type AddUpdateBulkInwardMutationMutationResult = Apollo.MutationResult<AddUpdateBulkInwardMutationMutation>;
export type AddUpdateBulkInwardMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdateBulkInwardMutationMutation, AddUpdateBulkInwardMutationMutationVariables>;
export const UpsertBatchInwardDocument = gql`
    mutation UpsertBatchInward($booking: Int!, $batches: [InwardBatchInput], $standardDeduction: Float, $status: String, $unloadingTeamId: ID, $expense: Float, $unloadingLocationId: ID, $unloadingSubLocationId: ID, $rstNo: String) {
  addUpdateBatchInward(
    booking: $booking
    batches: $batches
    status: $status
    standardDeduction: $standardDeduction
    unloadingTeamId: $unloadingTeamId
    expense: $expense
    unloadingLocationId: $unloadingLocationId
    unloadingSubLocationId: $unloadingSubLocationId
    rstNo: $rstNo
  ) {
    response
    booking {
      id
      trip {
        id
        expense
        unloadedBy {
          id
          name
        }
      }
      schedule {
        id
        unloadingLocation {
          id
          name
        }
        unloadingSubLocation {
          id
          name
        }
        plot {
          id
          farmer {
            id
            fullName
          }
        }
      }
      inwards {
        ...BatchInwardFrag
      }
    }
  }
}
    ${BatchInwardFragFragmentDoc}`;
export type UpsertBatchInwardMutationFn = Apollo.MutationFunction<UpsertBatchInwardMutation, UpsertBatchInwardMutationVariables>;

/**
 * __useUpsertBatchInwardMutation__
 *
 * To run a mutation, you first call `useUpsertBatchInwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBatchInwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBatchInwardMutation, { data, loading, error }] = useUpsertBatchInwardMutation({
 *   variables: {
 *      booking: // value for 'booking'
 *      batches: // value for 'batches'
 *      standardDeduction: // value for 'standardDeduction'
 *      status: // value for 'status'
 *      unloadingTeamId: // value for 'unloadingTeamId'
 *      expense: // value for 'expense'
 *      unloadingLocationId: // value for 'unloadingLocationId'
 *      unloadingSubLocationId: // value for 'unloadingSubLocationId'
 *      rstNo: // value for 'rstNo'
 *   },
 * });
 */
export function useUpsertBatchInwardMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBatchInwardMutation, UpsertBatchInwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBatchInwardMutation, UpsertBatchInwardMutationVariables>(UpsertBatchInwardDocument, options);
      }
export type UpsertBatchInwardMutationHookResult = ReturnType<typeof useUpsertBatchInwardMutation>;
export type UpsertBatchInwardMutationResult = Apollo.MutationResult<UpsertBatchInwardMutation>;
export type UpsertBatchInwardMutationOptions = Apollo.BaseMutationOptions<UpsertBatchInwardMutation, UpsertBatchInwardMutationVariables>;
export const AddUpdateSampleMinimalDocument = gql`
    mutation AddUpdateSampleMinimal($qualities: [InwardQualityInput]) {
  addUpdateQualitySampleMinimal(qualities: $qualities) {
    inwards {
      ...InwardQualityFrag
    }
  }
}
    ${InwardQualityFragFragmentDoc}`;
export type AddUpdateSampleMinimalMutationFn = Apollo.MutationFunction<AddUpdateSampleMinimalMutation, AddUpdateSampleMinimalMutationVariables>;

/**
 * __useAddUpdateSampleMinimalMutation__
 *
 * To run a mutation, you first call `useAddUpdateSampleMinimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateSampleMinimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateSampleMinimalMutation, { data, loading, error }] = useAddUpdateSampleMinimalMutation({
 *   variables: {
 *      qualities: // value for 'qualities'
 *   },
 * });
 */
export function useAddUpdateSampleMinimalMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateSampleMinimalMutation, AddUpdateSampleMinimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateSampleMinimalMutation, AddUpdateSampleMinimalMutationVariables>(AddUpdateSampleMinimalDocument, options);
      }
export type AddUpdateSampleMinimalMutationHookResult = ReturnType<typeof useAddUpdateSampleMinimalMutation>;
export type AddUpdateSampleMinimalMutationResult = Apollo.MutationResult<AddUpdateSampleMinimalMutation>;
export type AddUpdateSampleMinimalMutationOptions = Apollo.BaseMutationOptions<AddUpdateSampleMinimalMutation, AddUpdateSampleMinimalMutationVariables>;
export const DeleteInwardsByIdDocument = gql`
    mutation DeleteInwardsById($inwards: [ID]) {
  deleteInwards(inwards: $inwards) {
    inwards {
      id
    }
  }
}
    `;
export type DeleteInwardsByIdMutationFn = Apollo.MutationFunction<DeleteInwardsByIdMutation, DeleteInwardsByIdMutationVariables>;

/**
 * __useDeleteInwardsByIdMutation__
 *
 * To run a mutation, you first call `useDeleteInwardsByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInwardsByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInwardsByIdMutation, { data, loading, error }] = useDeleteInwardsByIdMutation({
 *   variables: {
 *      inwards: // value for 'inwards'
 *   },
 * });
 */
export function useDeleteInwardsByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInwardsByIdMutation, DeleteInwardsByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInwardsByIdMutation, DeleteInwardsByIdMutationVariables>(DeleteInwardsByIdDocument, options);
      }
export type DeleteInwardsByIdMutationHookResult = ReturnType<typeof useDeleteInwardsByIdMutation>;
export type DeleteInwardsByIdMutationResult = Apollo.MutationResult<DeleteInwardsByIdMutation>;
export type DeleteInwardsByIdMutationOptions = Apollo.BaseMutationOptions<DeleteInwardsByIdMutation, DeleteInwardsByIdMutationVariables>;
export const TripsForDateDocument = gql`
    query TripsForDate($date: Date!, $query: String, $first: Int, $skip: Int) {
  tripsForDate(
    date: $date
    query: $query
    first: $first
    skip: $skip
    isWholesale: false
  ) {
    id
    uuid
    status
    weighDetail {
      id
      status
    }
    aggregator {
      id
      fullName
    }
    vehicle {
      id
      registrationNumber
    }
    bookings {
      id
      procuredQuantity
      qualitySample {
        ...QualityBaseFrag
      }
      inwards {
        id
        serialNo
        rstNo
        statusLogs(status: "CMP") {
          createdBy {
            id
            fullName
          }
        }
        weigh {
          id
          status
          inwardedQuantity
        }
        ...InwardQualityFrag
      }
      schedule {
        id
        gatelogsSet {
          id
          createdAt
          gateEntryNo
          gateStatus
          gateNumber {
            id
            name
            codename
          }
        }
        plot {
          id
          farmer {
            id
            fullName
            isBlocked
            companies {
              id
            }
          }
        }
        skuType {
          id
          name
        }
        gatePass
      }
    }
  }
}
    ${QualityBaseFragFragmentDoc}
${InwardQualityFragFragmentDoc}`;

/**
 * __useTripsForDateQuery__
 *
 * To run a query within a React component, call `useTripsForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripsForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripsForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useTripsForDateQuery(baseOptions: Apollo.QueryHookOptions<TripsForDateQuery, TripsForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripsForDateQuery, TripsForDateQueryVariables>(TripsForDateDocument, options);
      }
export function useTripsForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripsForDateQuery, TripsForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripsForDateQuery, TripsForDateQueryVariables>(TripsForDateDocument, options);
        }
export type TripsForDateQueryHookResult = ReturnType<typeof useTripsForDateQuery>;
export type TripsForDateLazyQueryHookResult = ReturnType<typeof useTripsForDateLazyQuery>;
export type TripsForDateQueryResult = Apollo.QueryResult<TripsForDateQuery, TripsForDateQueryVariables>;
export const BackendTripDetailsDocument = gql`
    query BackendTripDetails($id: Int, $uuid: String) {
  tripDetails(tripId: $id, uuid: $uuid) {
    ...TripDetailFrag
  }
}
    ${TripDetailFragFragmentDoc}`;

/**
 * __useBackendTripDetailsQuery__
 *
 * To run a query within a React component, call `useBackendTripDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendTripDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendTripDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useBackendTripDetailsQuery(baseOptions?: Apollo.QueryHookOptions<BackendTripDetailsQuery, BackendTripDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackendTripDetailsQuery, BackendTripDetailsQueryVariables>(BackendTripDetailsDocument, options);
      }
export function useBackendTripDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackendTripDetailsQuery, BackendTripDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackendTripDetailsQuery, BackendTripDetailsQueryVariables>(BackendTripDetailsDocument, options);
        }
export type BackendTripDetailsQueryHookResult = ReturnType<typeof useBackendTripDetailsQuery>;
export type BackendTripDetailsLazyQueryHookResult = ReturnType<typeof useBackendTripDetailsLazyQuery>;
export type BackendTripDetailsQueryResult = Apollo.QueryResult<BackendTripDetailsQuery, BackendTripDetailsQueryVariables>;
export const TripWeighStatusDocument = gql`
    query tripWeighStatus($id: Int) {
  tripDetails(tripId: $id) {
    weighDetail {
      id
      status
    }
    bookings {
      id
      inwards {
        id
        weigh {
          id
          status
        }
      }
    }
  }
}
    `;

/**
 * __useTripWeighStatusQuery__
 *
 * To run a query within a React component, call `useTripWeighStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripWeighStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripWeighStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTripWeighStatusQuery(baseOptions?: Apollo.QueryHookOptions<TripWeighStatusQuery, TripWeighStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripWeighStatusQuery, TripWeighStatusQueryVariables>(TripWeighStatusDocument, options);
      }
export function useTripWeighStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripWeighStatusQuery, TripWeighStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripWeighStatusQuery, TripWeighStatusQueryVariables>(TripWeighStatusDocument, options);
        }
export type TripWeighStatusQueryHookResult = ReturnType<typeof useTripWeighStatusQuery>;
export type TripWeighStatusLazyQueryHookResult = ReturnType<typeof useTripWeighStatusLazyQuery>;
export type TripWeighStatusQueryResult = Apollo.QueryResult<TripWeighStatusQuery, TripWeighStatusQueryVariables>;
export const BookingQualityDocument = gql`
    query bookingQuality($id: Int) {
  bookingDetails(id: $id) {
    id
    inwards {
      ...InwardQualityFrag
    }
  }
}
    ${InwardQualityFragFragmentDoc}`;

/**
 * __useBookingQualityQuery__
 *
 * To run a query within a React component, call `useBookingQualityQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQualityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQualityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingQualityQuery(baseOptions?: Apollo.QueryHookOptions<BookingQualityQuery, BookingQualityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQualityQuery, BookingQualityQueryVariables>(BookingQualityDocument, options);
      }
export function useBookingQualityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQualityQuery, BookingQualityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQualityQuery, BookingQualityQueryVariables>(BookingQualityDocument, options);
        }
export type BookingQualityQueryHookResult = ReturnType<typeof useBookingQualityQuery>;
export type BookingQualityLazyQueryHookResult = ReturnType<typeof useBookingQualityLazyQuery>;
export type BookingQualityQueryResult = Apollo.QueryResult<BookingQualityQuery, BookingQualityQueryVariables>;
export const InwardSummaryForDateDocument = gql`
    query inwardSummaryForDate($date: Date) {
  inwardedSummary(date: $date) {
    scheduledTrips
    inwardedTrips
    inwardedBookings
    scheduledBookings
    inwardedQuantity
    scheduledQuantity
    netWeight
    grossWeight
    acceptedWeight
    rejectedWeight
    averageQualityRejection
    averageStandardRejection
  }
}
    `;

/**
 * __useInwardSummaryForDateQuery__
 *
 * To run a query within a React component, call `useInwardSummaryForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useInwardSummaryForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInwardSummaryForDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useInwardSummaryForDateQuery(baseOptions?: Apollo.QueryHookOptions<InwardSummaryForDateQuery, InwardSummaryForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InwardSummaryForDateQuery, InwardSummaryForDateQueryVariables>(InwardSummaryForDateDocument, options);
      }
export function useInwardSummaryForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InwardSummaryForDateQuery, InwardSummaryForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InwardSummaryForDateQuery, InwardSummaryForDateQueryVariables>(InwardSummaryForDateDocument, options);
        }
export type InwardSummaryForDateQueryHookResult = ReturnType<typeof useInwardSummaryForDateQuery>;
export type InwardSummaryForDateLazyQueryHookResult = ReturnType<typeof useInwardSummaryForDateLazyQuery>;
export type InwardSummaryForDateQueryResult = Apollo.QueryResult<InwardSummaryForDateQuery, InwardSummaryForDateQueryVariables>;
export const BookingInfoDocument = gql`
    query BookingInfo($scheduleId: ID!, $schedule: Int) {
  transportDetail(schedule: $schedule) {
    ...TransportDetailFrag
  }
  scheduleDetails(scheduleId: $scheduleId) {
    id
    date
    gatePass
    cropGroup {
      id
      name
      codename
    }
    assignedPoCodes
    aggregator {
      id
      fullName
    }
    vehicle {
      id
      driver {
        id
        fullName
      }
      registrationNumber
      vehicleType {
        id
        name
      }
    }
    sourceDepot {
      id
      name
    }
    destinationDepot {
      id
      name
    }
    company {
      id
      name
      codename
    }
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    requiredQuantity
    skuType {
      id
      name
    }
    plot {
      farmer {
        id
        fullName
        companyCode
      }
      id
      address {
        id
        village
        taluka
        district
      }
    }
    plotCommodity {
      id
      name
      registrationCode
      agronomist {
        id
        fullName
      }
    }
    scheduleRequest {
      id
      timeSlot {
        id
        demand {
          id
          name
        }
      }
    }
  }
}
    ${TransportDetailFragFragmentDoc}`;

/**
 * __useBookingInfoQuery__
 *
 * To run a query within a React component, call `useBookingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingInfoQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useBookingInfoQuery(baseOptions: Apollo.QueryHookOptions<BookingInfoQuery, BookingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingInfoQuery, BookingInfoQueryVariables>(BookingInfoDocument, options);
      }
export function useBookingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingInfoQuery, BookingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingInfoQuery, BookingInfoQueryVariables>(BookingInfoDocument, options);
        }
export type BookingInfoQueryHookResult = ReturnType<typeof useBookingInfoQuery>;
export type BookingInfoLazyQueryHookResult = ReturnType<typeof useBookingInfoLazyQuery>;
export type BookingInfoQueryResult = Apollo.QueryResult<BookingInfoQuery, BookingInfoQueryVariables>;
export const FrontendTripsForDateDocument = gql`
    query FrontendTripsForDate($orderingDcId: ID, $date: Date!, $query: String, $first: Int, $skip: Int) {
  tripsForDate(
    date: $date
    query: $query
    first: $first
    skip: $skip
    orderingDcId: $orderingDcId
  ) {
    id
    status
    uuid
    weighDetail {
      id
      status
    }
    aggregator {
      id
      fullName
    }
    vehicle {
      id
      registrationNumber
    }
    bookings {
      id
      procuredQuantity
      requiredQuantity
      schedule {
        id
        gatePass
      }
      inwards {
        id
        weigh {
          id
          status
          inwardedQuantity
        }
      }
      orderItem {
        id
        shipping {
          id
          distributionCentre {
            id
            name
          }
        }
        sellableItem {
          id
          name
          secondarySkuType {
            id
            name
            selfWeight
          }
        }
        order {
          id
          trackingCode
          user {
            id
            fullName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFrontendTripsForDateQuery__
 *
 * To run a query within a React component, call `useFrontendTripsForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontendTripsForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontendTripsForDateQuery({
 *   variables: {
 *      orderingDcId: // value for 'orderingDcId'
 *      date: // value for 'date'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useFrontendTripsForDateQuery(baseOptions: Apollo.QueryHookOptions<FrontendTripsForDateQuery, FrontendTripsForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrontendTripsForDateQuery, FrontendTripsForDateQueryVariables>(FrontendTripsForDateDocument, options);
      }
export function useFrontendTripsForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrontendTripsForDateQuery, FrontendTripsForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrontendTripsForDateQuery, FrontendTripsForDateQueryVariables>(FrontendTripsForDateDocument, options);
        }
export type FrontendTripsForDateQueryHookResult = ReturnType<typeof useFrontendTripsForDateQuery>;
export type FrontendTripsForDateLazyQueryHookResult = ReturnType<typeof useFrontendTripsForDateLazyQuery>;
export type FrontendTripsForDateQueryResult = Apollo.QueryResult<FrontendTripsForDateQuery, FrontendTripsForDateQueryVariables>;
export const FrontendTripDetailsDocument = gql`
    query FrontendTripDetails($id: Int, $uuid: String) {
  tripDetails(tripId: $id, uuid: $uuid) {
    ...FrontendTripDetailFrag
  }
}
    ${FrontendTripDetailFragFragmentDoc}`;

/**
 * __useFrontendTripDetailsQuery__
 *
 * To run a query within a React component, call `useFrontendTripDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontendTripDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontendTripDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useFrontendTripDetailsQuery(baseOptions?: Apollo.QueryHookOptions<FrontendTripDetailsQuery, FrontendTripDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrontendTripDetailsQuery, FrontendTripDetailsQueryVariables>(FrontendTripDetailsDocument, options);
      }
export function useFrontendTripDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrontendTripDetailsQuery, FrontendTripDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrontendTripDetailsQuery, FrontendTripDetailsQueryVariables>(FrontendTripDetailsDocument, options);
        }
export type FrontendTripDetailsQueryHookResult = ReturnType<typeof useFrontendTripDetailsQuery>;
export type FrontendTripDetailsLazyQueryHookResult = ReturnType<typeof useFrontendTripDetailsLazyQuery>;
export type FrontendTripDetailsQueryResult = Apollo.QueryResult<FrontendTripDetailsQuery, FrontendTripDetailsQueryVariables>;
export const DeleteMediaDocument = gql`
    mutation DeleteMedia($ids: [ID]!) {
  deleteMedia(ids: $ids) {
    response
  }
}
    `;
export type DeleteMediaMutationFn = Apollo.MutationFunction<DeleteMediaMutation, DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaMutation, DeleteMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, options);
      }
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const CreateUpdateNotificationTemplateDocument = gql`
    mutation CreateUpdateNotificationTemplate($alias: String, $body: String, $id: ID, $title: String) {
  addUpdateNotificationTemplate(
    alias: $alias
    body: $body
    id: $id
    title: $title
  ) {
    template {
      ...NotificationTemplateTypeDetailFrag
    }
  }
}
    ${NotificationTemplateTypeDetailFragFragmentDoc}`;
export type CreateUpdateNotificationTemplateMutationFn = Apollo.MutationFunction<CreateUpdateNotificationTemplateMutation, CreateUpdateNotificationTemplateMutationVariables>;

/**
 * __useCreateUpdateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateUpdateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateNotificationTemplateMutation, { data, loading, error }] = useCreateUpdateNotificationTemplateMutation({
 *   variables: {
 *      alias: // value for 'alias'
 *      body: // value for 'body'
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateUpdateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateNotificationTemplateMutation, CreateUpdateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateNotificationTemplateMutation, CreateUpdateNotificationTemplateMutationVariables>(CreateUpdateNotificationTemplateDocument, options);
      }
export type CreateUpdateNotificationTemplateMutationHookResult = ReturnType<typeof useCreateUpdateNotificationTemplateMutation>;
export type CreateUpdateNotificationTemplateMutationResult = Apollo.MutationResult<CreateUpdateNotificationTemplateMutation>;
export type CreateUpdateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateUpdateNotificationTemplateMutation, CreateUpdateNotificationTemplateMutationVariables>;
export const NotifyDocument = gql`
    mutation Notify($id: ID!) {
  sendNotification(id: $id) {
    notification {
      id
    }
  }
}
    `;
export type NotifyMutationFn = Apollo.MutationFunction<NotifyMutation, NotifyMutationVariables>;

/**
 * __useNotifyMutation__
 *
 * To run a mutation, you first call `useNotifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyMutation, { data, loading, error }] = useNotifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotifyMutation(baseOptions?: Apollo.MutationHookOptions<NotifyMutation, NotifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyMutation, NotifyMutationVariables>(NotifyDocument, options);
      }
export type NotifyMutationHookResult = ReturnType<typeof useNotifyMutation>;
export type NotifyMutationResult = Apollo.MutationResult<NotifyMutation>;
export type NotifyMutationOptions = Apollo.BaseMutationOptions<NotifyMutation, NotifyMutationVariables>;
export const CreateNotificationDocument = gql`
    mutation CreateNotification($groupIds: [ID], $instanceType: String, $messegeType: String, $objectId: ID, $templateId: ID!, $userIds: [ID]) {
  addNotification(
    groupIds: $groupIds
    instanceType: $instanceType
    messegeType: $messegeType
    objectId: $objectId
    templateId: $templateId
    userIds: $userIds
  ) {
    notification {
      ...NotificationFrag
    }
  }
}
    ${NotificationFragFragmentDoc}`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      groupIds: // value for 'groupIds'
 *      instanceType: // value for 'instanceType'
 *      messegeType: // value for 'messegeType'
 *      objectId: // value for 'objectId'
 *      templateId: // value for 'templateId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const RehitNotificationDocument = gql`
    mutation rehitNotification($triggerId: ID) {
  retriggerNotification(triggerId: $triggerId) {
    success
  }
}
    `;
export type RehitNotificationMutationFn = Apollo.MutationFunction<RehitNotificationMutation, RehitNotificationMutationVariables>;

/**
 * __useRehitNotificationMutation__
 *
 * To run a mutation, you first call `useRehitNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRehitNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rehitNotificationMutation, { data, loading, error }] = useRehitNotificationMutation({
 *   variables: {
 *      triggerId: // value for 'triggerId'
 *   },
 * });
 */
export function useRehitNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RehitNotificationMutation, RehitNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RehitNotificationMutation, RehitNotificationMutationVariables>(RehitNotificationDocument, options);
      }
export type RehitNotificationMutationHookResult = ReturnType<typeof useRehitNotificationMutation>;
export type RehitNotificationMutationResult = Apollo.MutationResult<RehitNotificationMutation>;
export type RehitNotificationMutationOptions = Apollo.BaseMutationOptions<RehitNotificationMutation, RehitNotificationMutationVariables>;
export const MakeNotificationDocument = gql`
    mutation MakeNotification($broadcastTime: DateTime, $content: NotificationContent, $dataVariables: JSONScalar, $extraVariables: JSONScalar, $filters: [NotificationTemplateFilter], $providerUid: String, $providerVariables: JSONScalar, $templateUid: String, $userId: ID, $userQueryUid: String) {
  triggerNotification(
    broadcastTime: $broadcastTime
    content: $content
    dataVariables: $dataVariables
    extraVariables: $extraVariables
    filters: $filters
    providerUid: $providerUid
    providerVariables: $providerVariables
    templateUid: $templateUid
    userId: $userId
    userQueryUid: $userQueryUid
  ) {
    success
  }
}
    `;
export type MakeNotificationMutationFn = Apollo.MutationFunction<MakeNotificationMutation, MakeNotificationMutationVariables>;

/**
 * __useMakeNotificationMutation__
 *
 * To run a mutation, you first call `useMakeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeNotificationMutation, { data, loading, error }] = useMakeNotificationMutation({
 *   variables: {
 *      broadcastTime: // value for 'broadcastTime'
 *      content: // value for 'content'
 *      dataVariables: // value for 'dataVariables'
 *      extraVariables: // value for 'extraVariables'
 *      filters: // value for 'filters'
 *      providerUid: // value for 'providerUid'
 *      providerVariables: // value for 'providerVariables'
 *      templateUid: // value for 'templateUid'
 *      userId: // value for 'userId'
 *      userQueryUid: // value for 'userQueryUid'
 *   },
 * });
 */
export function useMakeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<MakeNotificationMutation, MakeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeNotificationMutation, MakeNotificationMutationVariables>(MakeNotificationDocument, options);
      }
export type MakeNotificationMutationHookResult = ReturnType<typeof useMakeNotificationMutation>;
export type MakeNotificationMutationResult = Apollo.MutationResult<MakeNotificationMutation>;
export type MakeNotificationMutationOptions = Apollo.BaseMutationOptions<MakeNotificationMutation, MakeNotificationMutationVariables>;
export const CreateUpdateNotificationTemplateNewDocument = gql`
    mutation CreateUpdateNotificationTemplateNew($body: String, $codename: String, $dataSourceId: ID, $dataVariables: JSONScalar, $description: String, $extraFields: JSONScalar, $id: ID, $isActive: Boolean, $isProgrammatic: Boolean, $name: String, $providerId: ID, $providerVariables: JSONScalar, $title: String) {
  addUpdateNotificationTemplateV1(
    body: $body
    codename: $codename
    dataSourceId: $dataSourceId
    dataVariables: $dataVariables
    description: $description
    extraFields: $extraFields
    id: $id
    isActive: $isActive
    isProgrammatic: $isProgrammatic
    name: $name
    providerId: $providerId
    providerVariables: $providerVariables
    title: $title
  ) {
    template {
      id
      body
      codename
      dataSource {
        id
      }
      dataVariables
      description
      extraFields
      id
      isActive
      isProgrammatic
      name
      provider {
        id
      }
      providerVariables
      title
    }
  }
}
    `;
export type CreateUpdateNotificationTemplateNewMutationFn = Apollo.MutationFunction<CreateUpdateNotificationTemplateNewMutation, CreateUpdateNotificationTemplateNewMutationVariables>;

/**
 * __useCreateUpdateNotificationTemplateNewMutation__
 *
 * To run a mutation, you first call `useCreateUpdateNotificationTemplateNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateNotificationTemplateNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateNotificationTemplateNewMutation, { data, loading, error }] = useCreateUpdateNotificationTemplateNewMutation({
 *   variables: {
 *      body: // value for 'body'
 *      codename: // value for 'codename'
 *      dataSourceId: // value for 'dataSourceId'
 *      dataVariables: // value for 'dataVariables'
 *      description: // value for 'description'
 *      extraFields: // value for 'extraFields'
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      isProgrammatic: // value for 'isProgrammatic'
 *      name: // value for 'name'
 *      providerId: // value for 'providerId'
 *      providerVariables: // value for 'providerVariables'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateUpdateNotificationTemplateNewMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateNotificationTemplateNewMutation, CreateUpdateNotificationTemplateNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateNotificationTemplateNewMutation, CreateUpdateNotificationTemplateNewMutationVariables>(CreateUpdateNotificationTemplateNewDocument, options);
      }
export type CreateUpdateNotificationTemplateNewMutationHookResult = ReturnType<typeof useCreateUpdateNotificationTemplateNewMutation>;
export type CreateUpdateNotificationTemplateNewMutationResult = Apollo.MutationResult<CreateUpdateNotificationTemplateNewMutation>;
export type CreateUpdateNotificationTemplateNewMutationOptions = Apollo.BaseMutationOptions<CreateUpdateNotificationTemplateNewMutation, CreateUpdateNotificationTemplateNewMutationVariables>;
export const NotificationTemplateListNewDocument = gql`
    query NotificationTemplateListNew($query: String, $first: Int, $skip: Int, $filter: NotificationTemplateInput) {
  allV1NotificationTemplates(
    query: $query
    first: $first
    skip: $skip
    filter: $filter
  ) {
    ...NotificationTemplateDetailV1Frag
  }
}
    ${NotificationTemplateDetailV1FragFragmentDoc}`;

/**
 * __useNotificationTemplateListNewQuery__
 *
 * To run a query within a React component, call `useNotificationTemplateListNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateListNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTemplateListNewQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationTemplateListNewQuery(baseOptions?: Apollo.QueryHookOptions<NotificationTemplateListNewQuery, NotificationTemplateListNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTemplateListNewQuery, NotificationTemplateListNewQueryVariables>(NotificationTemplateListNewDocument, options);
      }
export function useNotificationTemplateListNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTemplateListNewQuery, NotificationTemplateListNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTemplateListNewQuery, NotificationTemplateListNewQueryVariables>(NotificationTemplateListNewDocument, options);
        }
export type NotificationTemplateListNewQueryHookResult = ReturnType<typeof useNotificationTemplateListNewQuery>;
export type NotificationTemplateListNewLazyQueryHookResult = ReturnType<typeof useNotificationTemplateListNewLazyQuery>;
export type NotificationTemplateListNewQueryResult = Apollo.QueryResult<NotificationTemplateListNewQuery, NotificationTemplateListNewQueryVariables>;
export const NotificationProviderListDocument = gql`
    query NotificationProviderList($filter: NotificationProviderInput) {
  allNotificationProviders(filter: $filter) {
    id
    name
    codename
  }
}
    `;

/**
 * __useNotificationProviderListQuery__
 *
 * To run a query within a React component, call `useNotificationProviderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationProviderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationProviderListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationProviderListQuery(baseOptions?: Apollo.QueryHookOptions<NotificationProviderListQuery, NotificationProviderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationProviderListQuery, NotificationProviderListQueryVariables>(NotificationProviderListDocument, options);
      }
export function useNotificationProviderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationProviderListQuery, NotificationProviderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationProviderListQuery, NotificationProviderListQueryVariables>(NotificationProviderListDocument, options);
        }
export type NotificationProviderListQueryHookResult = ReturnType<typeof useNotificationProviderListQuery>;
export type NotificationProviderListLazyQueryHookResult = ReturnType<typeof useNotificationProviderListLazyQuery>;
export type NotificationProviderListQueryResult = Apollo.QueryResult<NotificationProviderListQuery, NotificationProviderListQueryVariables>;
export const DataSourceListDocument = gql`
    query DataSourceList {
  allDataSources {
    id
    inputs
    name
    outputs
    isActive
    codename
  }
}
    `;

/**
 * __useDataSourceListQuery__
 *
 * To run a query within a React component, call `useDataSourceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataSourceListQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceListQuery, DataSourceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceListQuery, DataSourceListQueryVariables>(DataSourceListDocument, options);
      }
export function useDataSourceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceListQuery, DataSourceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceListQuery, DataSourceListQueryVariables>(DataSourceListDocument, options);
        }
export type DataSourceListQueryHookResult = ReturnType<typeof useDataSourceListQuery>;
export type DataSourceListLazyQueryHookResult = ReturnType<typeof useDataSourceListLazyQuery>;
export type DataSourceListQueryResult = Apollo.QueryResult<DataSourceListQuery, DataSourceListQueryVariables>;
export const NotificationTemplateNewDocument = gql`
    query NotificationTemplateNew($id: ID!) {
  v1NotificationTemplateDetail(id: $id) {
    ...NotificationTemplateDetailV1Frag
  }
}
    ${NotificationTemplateDetailV1FragFragmentDoc}`;

/**
 * __useNotificationTemplateNewQuery__
 *
 * To run a query within a React component, call `useNotificationTemplateNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTemplateNewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationTemplateNewQuery(baseOptions: Apollo.QueryHookOptions<NotificationTemplateNewQuery, NotificationTemplateNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTemplateNewQuery, NotificationTemplateNewQueryVariables>(NotificationTemplateNewDocument, options);
      }
export function useNotificationTemplateNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTemplateNewQuery, NotificationTemplateNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTemplateNewQuery, NotificationTemplateNewQueryVariables>(NotificationTemplateNewDocument, options);
        }
export type NotificationTemplateNewQueryHookResult = ReturnType<typeof useNotificationTemplateNewQuery>;
export type NotificationTemplateNewLazyQueryHookResult = ReturnType<typeof useNotificationTemplateNewLazyQuery>;
export type NotificationTemplateNewQueryResult = Apollo.QueryResult<NotificationTemplateNewQuery, NotificationTemplateNewQueryVariables>;
export const NotificationTriggerListDocument = gql`
    query NotificationTriggerList($query: String, $first: Int, $skip: Int, $filter: NotificationTriggerInput) {
  allNotificationTriggers(
    query: $query
    first: $first
    skip: $skip
    filter: $filter
  ) {
    id
    isTriggered
    usersCount
    template {
      id
      name
    }
    provider {
      id
      kind
      name
    }
    broadcastTime
    sentBy {
      id
      fullName
    }
  }
}
    `;

/**
 * __useNotificationTriggerListQuery__
 *
 * To run a query within a React component, call `useNotificationTriggerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTriggerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTriggerListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationTriggerListQuery(baseOptions?: Apollo.QueryHookOptions<NotificationTriggerListQuery, NotificationTriggerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTriggerListQuery, NotificationTriggerListQueryVariables>(NotificationTriggerListDocument, options);
      }
export function useNotificationTriggerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTriggerListQuery, NotificationTriggerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTriggerListQuery, NotificationTriggerListQueryVariables>(NotificationTriggerListDocument, options);
        }
export type NotificationTriggerListQueryHookResult = ReturnType<typeof useNotificationTriggerListQuery>;
export type NotificationTriggerListLazyQueryHookResult = ReturnType<typeof useNotificationTriggerListLazyQuery>;
export type NotificationTriggerListQueryResult = Apollo.QueryResult<NotificationTriggerListQuery, NotificationTriggerListQueryVariables>;
export const NotificationTriggerDocument = gql`
    query NotificationTrigger($id: ID!) {
  notificationTriggerDetail(id: $id) {
    id
    isTriggered
    provider {
      id
      kind
      name
      codename
    }
    config
    providerVariables
    dataVariables
    broadcastTime
    extraFields
    userQuery {
      ...UserQueryFrag
    }
    template {
      ...NotificationTemplateDetailV1Frag
    }
  }
}
    ${UserQueryFragFragmentDoc}
${NotificationTemplateDetailV1FragFragmentDoc}`;

/**
 * __useNotificationTriggerQuery__
 *
 * To run a query within a React component, call `useNotificationTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationTriggerQuery(baseOptions: Apollo.QueryHookOptions<NotificationTriggerQuery, NotificationTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTriggerQuery, NotificationTriggerQueryVariables>(NotificationTriggerDocument, options);
      }
export function useNotificationTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTriggerQuery, NotificationTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTriggerQuery, NotificationTriggerQueryVariables>(NotificationTriggerDocument, options);
        }
export type NotificationTriggerQueryHookResult = ReturnType<typeof useNotificationTriggerQuery>;
export type NotificationTriggerLazyQueryHookResult = ReturnType<typeof useNotificationTriggerLazyQuery>;
export type NotificationTriggerQueryResult = Apollo.QueryResult<NotificationTriggerQuery, NotificationTriggerQueryVariables>;
export const AllUserQueriesDocument = gql`
    query allUserQueries {
  allUserQuerys {
    ...UserQueryFrag
  }
}
    ${UserQueryFragFragmentDoc}`;

/**
 * __useAllUserQueriesQuery__
 *
 * To run a query within a React component, call `useAllUserQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserQueriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserQueriesQuery(baseOptions?: Apollo.QueryHookOptions<AllUserQueriesQuery, AllUserQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserQueriesQuery, AllUserQueriesQueryVariables>(AllUserQueriesDocument, options);
      }
export function useAllUserQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserQueriesQuery, AllUserQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserQueriesQuery, AllUserQueriesQueryVariables>(AllUserQueriesDocument, options);
        }
export type AllUserQueriesQueryHookResult = ReturnType<typeof useAllUserQueriesQuery>;
export type AllUserQueriesLazyQueryHookResult = ReturnType<typeof useAllUserQueriesLazyQuery>;
export type AllUserQueriesQueryResult = Apollo.QueryResult<AllUserQueriesQuery, AllUserQueriesQueryVariables>;
export const EndUserCountDocument = gql`
    query EndUserCount($filter: TargetUserCountInput) {
  targetUserCount(filter: $filter) {
    userCount
  }
}
    `;

/**
 * __useEndUserCountQuery__
 *
 * To run a query within a React component, call `useEndUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndUserCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEndUserCountQuery(baseOptions?: Apollo.QueryHookOptions<EndUserCountQuery, EndUserCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndUserCountQuery, EndUserCountQueryVariables>(EndUserCountDocument, options);
      }
export function useEndUserCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndUserCountQuery, EndUserCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndUserCountQuery, EndUserCountQueryVariables>(EndUserCountDocument, options);
        }
export type EndUserCountQueryHookResult = ReturnType<typeof useEndUserCountQuery>;
export type EndUserCountLazyQueryHookResult = ReturnType<typeof useEndUserCountLazyQuery>;
export type EndUserCountQueryResult = Apollo.QueryResult<EndUserCountQuery, EndUserCountQueryVariables>;
export const OrderInvoiceDetailDocument = gql`
    query OrderInvoiceDetail($orderId: ID!, $tripId: ID) {
  orderInvoiceDetail(orderId: $orderId, tripId: $tripId) {
    id
    invoiceDocumentPath
  }
}
    `;

/**
 * __useOrderInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useOrderInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderInvoiceDetailQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useOrderInvoiceDetailQuery(baseOptions: Apollo.QueryHookOptions<OrderInvoiceDetailQuery, OrderInvoiceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderInvoiceDetailQuery, OrderInvoiceDetailQueryVariables>(OrderInvoiceDetailDocument, options);
      }
export function useOrderInvoiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderInvoiceDetailQuery, OrderInvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderInvoiceDetailQuery, OrderInvoiceDetailQueryVariables>(OrderInvoiceDetailDocument, options);
        }
export type OrderInvoiceDetailQueryHookResult = ReturnType<typeof useOrderInvoiceDetailQuery>;
export type OrderInvoiceDetailLazyQueryHookResult = ReturnType<typeof useOrderInvoiceDetailLazyQuery>;
export type OrderInvoiceDetailQueryResult = Apollo.QueryResult<OrderInvoiceDetailQuery, OrderInvoiceDetailQueryVariables>;
export const OrderListDocument = gql`
    query OrderList($query: String, $first: Int, $skip: Int, $filter: OrderFilterInput) {
  allOrders(query: $query, first: $first, skip: $skip, filter: $filter) {
    ...OrderListFrag
  }
}
    ${OrderListFragFragmentDoc}`;

/**
 * __useOrderListQuery__
 *
 * To run a query within a React component, call `useOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderListQuery(baseOptions?: Apollo.QueryHookOptions<OrderListQuery, OrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderListQuery, OrderListQueryVariables>(OrderListDocument, options);
      }
export function useOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderListQuery, OrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderListQuery, OrderListQueryVariables>(OrderListDocument, options);
        }
export type OrderListQueryHookResult = ReturnType<typeof useOrderListQuery>;
export type OrderListLazyQueryHookResult = ReturnType<typeof useOrderListLazyQuery>;
export type OrderListQueryResult = Apollo.QueryResult<OrderListQuery, OrderListQueryVariables>;
export const OrderDetailDocument = gql`
    query OrderDetail($id: ID!) {
  orderDetail(id: $id) {
    ...OrderDetailFrag
  }
  orderInvoiceDetail(orderId: $id) {
    id
    trackingCode
    pocName
    pocNumber
    invoiceItems {
      name
      quantity
      actualRate
      discountedRate
      category
      itemType
      amount
      balance
      itemDiscountId
      itemDiscountCode
      itemDiscountFlat
      itemDiscountPercent
      customDiscountFlat
      customDiscountPercent
    }
    discountCode
    discountPercentage
    deliveryAddress {
      village
      address
    }
    availablePaymentModes
  }
}
    ${OrderDetailFragFragmentDoc}`;

/**
 * __useOrderDetailQuery__
 *
 * To run a query within a React component, call `useOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderDetailQuery(baseOptions: Apollo.QueryHookOptions<OrderDetailQuery, OrderDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailQuery, OrderDetailQueryVariables>(OrderDetailDocument, options);
      }
export function useOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailQuery, OrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailQuery, OrderDetailQueryVariables>(OrderDetailDocument, options);
        }
export type OrderDetailQueryHookResult = ReturnType<typeof useOrderDetailQuery>;
export type OrderDetailLazyQueryHookResult = ReturnType<typeof useOrderDetailLazyQuery>;
export type OrderDetailQueryResult = Apollo.QueryResult<OrderDetailQuery, OrderDetailQueryVariables>;
export const OrderInvoiceDocument = gql`
    query OrderInvoice($orderId: ID) {
  orderInvoiceDetail(orderId: $orderId) {
    id
    trackingCode
    pocName
    pocNumber
    invoiceItems {
      name
      quantity
      actualRate
      discountedRate
      category
      itemType
      amount
      balance
      itemDiscountId
      itemDiscountCode
      itemDiscountFlat
      itemDiscountPercent
      customDiscountFlat
      customDiscountPercent
    }
    discountCode
    discountPercentage
    deliveryAddress {
      village
      address
    }
    availablePaymentModes
  }
}
    `;

/**
 * __useOrderInvoiceQuery__
 *
 * To run a query within a React component, call `useOrderInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderInvoiceQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<OrderInvoiceQuery, OrderInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderInvoiceQuery, OrderInvoiceQueryVariables>(OrderInvoiceDocument, options);
      }
export function useOrderInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderInvoiceQuery, OrderInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderInvoiceQuery, OrderInvoiceQueryVariables>(OrderInvoiceDocument, options);
        }
export type OrderInvoiceQueryHookResult = ReturnType<typeof useOrderInvoiceQuery>;
export type OrderInvoiceLazyQueryHookResult = ReturnType<typeof useOrderInvoiceLazyQuery>;
export type OrderInvoiceQueryResult = Apollo.QueryResult<OrderInvoiceQuery, OrderInvoiceQueryVariables>;
export const AllVendorsSelectorDocument = gql`
    query allVendorsSelector($group: String, $first: Int, $skip: Int, $query: String, $departmentId: ID) {
  usersByGroup(
    groupName: $group
    first: $first
    skip: $skip
    query: $query
    departmentId: $departmentId
  ) {
    id
    fullName
    number
    address {
      id
      village
      district
      address
      latitude
      longitude
      taluka
      state
      pincode
      geofenceRadius
    }
  }
}
    `;

/**
 * __useAllVendorsSelectorQuery__
 *
 * To run a query within a React component, call `useAllVendorsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVendorsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVendorsSelectorQuery({
 *   variables: {
 *      group: // value for 'group'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useAllVendorsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllVendorsSelectorQuery, AllVendorsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVendorsSelectorQuery, AllVendorsSelectorQueryVariables>(AllVendorsSelectorDocument, options);
      }
export function useAllVendorsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVendorsSelectorQuery, AllVendorsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVendorsSelectorQuery, AllVendorsSelectorQueryVariables>(AllVendorsSelectorDocument, options);
        }
export type AllVendorsSelectorQueryHookResult = ReturnType<typeof useAllVendorsSelectorQuery>;
export type AllVendorsSelectorLazyQueryHookResult = ReturnType<typeof useAllVendorsSelectorLazyQuery>;
export type AllVendorsSelectorQueryResult = Apollo.QueryResult<AllVendorsSelectorQuery, AllVendorsSelectorQueryVariables>;
export const CartInvoiceDocument = gql`
    query cartInvoice($orderItems: [OrderItemStockInput]!, $discountId: ID, $customDiscountPercent: Float, $customDiscountFlat: Float) {
  customInvoiceDetail(
    orderItems: $orderItems
    discountId: $discountId
    customDiscountPercent: $customDiscountPercent
    customDiscountFlat: $customDiscountFlat
  ) {
    id
    trackingCode
    pocName
    pocNumber
    invoiceItems {
      name
      quantity
      actualRate
      discountedRate
      category
      itemType
      amount
      balance
      stockCount
      itemDiscountId
      itemDiscountCode
      itemDiscountFlat
      itemDiscountPercent
      customDiscountFlat
      customDiscountPercent
    }
    discountCode
    discountPercentage
    deliveryAddress {
      id
      village
      address
    }
    availablePaymentModes
  }
}
    `;

/**
 * __useCartInvoiceQuery__
 *
 * To run a query within a React component, call `useCartInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartInvoiceQuery({
 *   variables: {
 *      orderItems: // value for 'orderItems'
 *      discountId: // value for 'discountId'
 *      customDiscountPercent: // value for 'customDiscountPercent'
 *      customDiscountFlat: // value for 'customDiscountFlat'
 *   },
 * });
 */
export function useCartInvoiceQuery(baseOptions: Apollo.QueryHookOptions<CartInvoiceQuery, CartInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartInvoiceQuery, CartInvoiceQueryVariables>(CartInvoiceDocument, options);
      }
export function useCartInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartInvoiceQuery, CartInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartInvoiceQuery, CartInvoiceQueryVariables>(CartInvoiceDocument, options);
        }
export type CartInvoiceQueryHookResult = ReturnType<typeof useCartInvoiceQuery>;
export type CartInvoiceLazyQueryHookResult = ReturnType<typeof useCartInvoiceLazyQuery>;
export type CartInvoiceQueryResult = Apollo.QueryResult<CartInvoiceQuery, CartInvoiceQueryVariables>;
export const AggregatedOrderItemsDocument = gql`
    query AggregatedOrderItems($orderIds: [ID], $targetDcId: ID!, $orderingDcId: ID, $filter: OrderFilterInput) {
  aggregatedOrderItems(
    orderIds: $orderIds
    targetDcId: $targetDcId
    orderingDcId: $orderingDcId
    filter: $filter
  ) {
    sourceDcRate
    quantity: totalQuantity
    sellableItem {
      id
      name
    }
    stockCount
    orderingItemStock {
      id
    }
    sellableItemStock {
      id
      offerStockCount
      currentStockCount
      unitRate
      discountedRate
      sellableItem {
        id
        name
      }
      distributionCentre {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAggregatedOrderItemsQuery__
 *
 * To run a query within a React component, call `useAggregatedOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregatedOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregatedOrderItemsQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      targetDcId: // value for 'targetDcId'
 *      orderingDcId: // value for 'orderingDcId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAggregatedOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<AggregatedOrderItemsQuery, AggregatedOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregatedOrderItemsQuery, AggregatedOrderItemsQueryVariables>(AggregatedOrderItemsDocument, options);
      }
export function useAggregatedOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregatedOrderItemsQuery, AggregatedOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregatedOrderItemsQuery, AggregatedOrderItemsQueryVariables>(AggregatedOrderItemsDocument, options);
        }
export type AggregatedOrderItemsQueryHookResult = ReturnType<typeof useAggregatedOrderItemsQuery>;
export type AggregatedOrderItemsLazyQueryHookResult = ReturnType<typeof useAggregatedOrderItemsLazyQuery>;
export type AggregatedOrderItemsQueryResult = Apollo.QueryResult<AggregatedOrderItemsQuery, AggregatedOrderItemsQueryVariables>;
export const OrdersBySellableItemDocument = gql`
    query OrdersBySellableItem($query: String, $first: Int, $skip: Int, $filter: OrderFilterInput) {
  ordersBySellableItem(query: $query, first: $first, skip: $skip, filter: $filter) {
    sellableItem {
      id
      name
      primaryPhoto {
        id
        url
      }
      shortDescription
      sellableVarieties {
        id
        name
      }
    }
    statusDetails {
      quantity
      orderStatus
    }
  }
}
    `;

/**
 * __useOrdersBySellableItemQuery__
 *
 * To run a query within a React component, call `useOrdersBySellableItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersBySellableItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersBySellableItemQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrdersBySellableItemQuery(baseOptions?: Apollo.QueryHookOptions<OrdersBySellableItemQuery, OrdersBySellableItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersBySellableItemQuery, OrdersBySellableItemQueryVariables>(OrdersBySellableItemDocument, options);
      }
export function useOrdersBySellableItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersBySellableItemQuery, OrdersBySellableItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersBySellableItemQuery, OrdersBySellableItemQueryVariables>(OrdersBySellableItemDocument, options);
        }
export type OrdersBySellableItemQueryHookResult = ReturnType<typeof useOrdersBySellableItemQuery>;
export type OrdersBySellableItemLazyQueryHookResult = ReturnType<typeof useOrdersBySellableItemLazyQuery>;
export type OrdersBySellableItemQueryResult = Apollo.QueryResult<OrdersBySellableItemQuery, OrdersBySellableItemQueryVariables>;
export const OrdersBySellableItemsSummaryDocument = gql`
    query OrdersBySellableItemsSummary($filter: OrderFilterInput) {
  summaryAllOrders(filter: $filter) {
    itemCount
    itemStatusConfirmed
    itemStatusCancelledByUser
    itemStatusInProcess
    itemStatusReadyForDespatch
  }
}
    `;

/**
 * __useOrdersBySellableItemsSummaryQuery__
 *
 * To run a query within a React component, call `useOrdersBySellableItemsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersBySellableItemsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersBySellableItemsSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrdersBySellableItemsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<OrdersBySellableItemsSummaryQuery, OrdersBySellableItemsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersBySellableItemsSummaryQuery, OrdersBySellableItemsSummaryQueryVariables>(OrdersBySellableItemsSummaryDocument, options);
      }
export function useOrdersBySellableItemsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersBySellableItemsSummaryQuery, OrdersBySellableItemsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersBySellableItemsSummaryQuery, OrdersBySellableItemsSummaryQueryVariables>(OrdersBySellableItemsSummaryDocument, options);
        }
export type OrdersBySellableItemsSummaryQueryHookResult = ReturnType<typeof useOrdersBySellableItemsSummaryQuery>;
export type OrdersBySellableItemsSummaryLazyQueryHookResult = ReturnType<typeof useOrdersBySellableItemsSummaryLazyQuery>;
export type OrdersBySellableItemsSummaryQueryResult = Apollo.QueryResult<OrdersBySellableItemsSummaryQuery, OrdersBySellableItemsSummaryQueryVariables>;
export const SummaryAllOrdersDocument = gql`
    query SummaryAllOrders($filter: OrderFilterInput) {
  summaryAllOrders(filter: $filter) {
    statusCompleted
    statusPlaced
    statusConfirmed
    statusNotPlaced
    statusInProcess
    statusPartialReject
    statusFullReject
    statusReadyForDespatch
    statusScheduledForDespatch
    statusReadyForSchedule
    statusDespatched
    statusCancelledByUser
    statusCancelledByVendor
    orderCount
  }
}
    `;

/**
 * __useSummaryAllOrdersQuery__
 *
 * To run a query within a React component, call `useSummaryAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryAllOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSummaryAllOrdersQuery(baseOptions?: Apollo.QueryHookOptions<SummaryAllOrdersQuery, SummaryAllOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryAllOrdersQuery, SummaryAllOrdersQueryVariables>(SummaryAllOrdersDocument, options);
      }
export function useSummaryAllOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryAllOrdersQuery, SummaryAllOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryAllOrdersQuery, SummaryAllOrdersQueryVariables>(SummaryAllOrdersDocument, options);
        }
export type SummaryAllOrdersQueryHookResult = ReturnType<typeof useSummaryAllOrdersQuery>;
export type SummaryAllOrdersLazyQueryHookResult = ReturnType<typeof useSummaryAllOrdersLazyQuery>;
export type SummaryAllOrdersQueryResult = Apollo.QueryResult<SummaryAllOrdersQuery, SummaryAllOrdersQueryVariables>;
export const SummaryAllOrderItemsDocument = gql`
    query SummaryAllOrderItems($filter: OrderFilterInput) {
  summaryAllOrders(filter: $filter) {
    statusCompleted
    statusPlaced
    statusConfirmed
    statusNotPlaced
    statusInProcess
    statusPartialReject
    statusFullReject
    statusReadyForDespatch
    statusScheduledForDespatch
    statusReadyForSchedule
    statusDespatched
    statusCancelledByUser
    statusCancelledByVendor
    itemStatusCompleted
    itemStatusPlaced
    itemStatusConfirmed
    itemStatusNotPlaced
    itemStatusInProcess
    itemStatusPartialReject
    itemStatusFullReject
    itemStatusReadyForDespatch
    itemStatusScheduledForDespatch
    itemStatusReadyForSchedule
    itemStatusDespatched
    itemStatusCancelledByUser
    itemStatusCancelledByVendor
    orderCount
    itemCount
  }
}
    `;

/**
 * __useSummaryAllOrderItemsQuery__
 *
 * To run a query within a React component, call `useSummaryAllOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryAllOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryAllOrderItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSummaryAllOrderItemsQuery(baseOptions?: Apollo.QueryHookOptions<SummaryAllOrderItemsQuery, SummaryAllOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryAllOrderItemsQuery, SummaryAllOrderItemsQueryVariables>(SummaryAllOrderItemsDocument, options);
      }
export function useSummaryAllOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummaryAllOrderItemsQuery, SummaryAllOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryAllOrderItemsQuery, SummaryAllOrderItemsQueryVariables>(SummaryAllOrderItemsDocument, options);
        }
export type SummaryAllOrderItemsQueryHookResult = ReturnType<typeof useSummaryAllOrderItemsQuery>;
export type SummaryAllOrderItemsLazyQueryHookResult = ReturnType<typeof useSummaryAllOrderItemsLazyQuery>;
export type SummaryAllOrderItemsQueryResult = Apollo.QueryResult<SummaryAllOrderItemsQuery, SummaryAllOrderItemsQueryVariables>;
export const OrderCountFilterDocument = gql`
    query OrderCountFilter($filter: OrderFilterInput) {
  orderCountFilter(filter: $filter)
}
    `;

/**
 * __useOrderCountFilterQuery__
 *
 * To run a query within a React component, call `useOrderCountFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderCountFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCountFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderCountFilterQuery(baseOptions?: Apollo.QueryHookOptions<OrderCountFilterQuery, OrderCountFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderCountFilterQuery, OrderCountFilterQueryVariables>(OrderCountFilterDocument, options);
      }
export function useOrderCountFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderCountFilterQuery, OrderCountFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderCountFilterQuery, OrderCountFilterQueryVariables>(OrderCountFilterDocument, options);
        }
export type OrderCountFilterQueryHookResult = ReturnType<typeof useOrderCountFilterQuery>;
export type OrderCountFilterLazyQueryHookResult = ReturnType<typeof useOrderCountFilterLazyQuery>;
export type OrderCountFilterQueryResult = Apollo.QueryResult<OrderCountFilterQuery, OrderCountFilterQueryVariables>;
export const UpdatePeriodicTasksDocument = gql`
    mutation UpdatePeriodicTasks($enabled: Boolean, $ids: [ID]!, $oneOff: Boolean, $queue: String) {
  updatePeriodicTasks(
    enabled: $enabled
    ids: $ids
    oneOff: $oneOff
    queue: $queue
  ) {
    periodicTasks {
      ...PeriodicTaskDetailFrag
    }
  }
}
    ${PeriodicTaskDetailFragFragmentDoc}`;
export type UpdatePeriodicTasksMutationFn = Apollo.MutationFunction<UpdatePeriodicTasksMutation, UpdatePeriodicTasksMutationVariables>;

/**
 * __useUpdatePeriodicTasksMutation__
 *
 * To run a mutation, you first call `useUpdatePeriodicTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeriodicTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeriodicTasksMutation, { data, loading, error }] = useUpdatePeriodicTasksMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      ids: // value for 'ids'
 *      oneOff: // value for 'oneOff'
 *      queue: // value for 'queue'
 *   },
 * });
 */
export function useUpdatePeriodicTasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePeriodicTasksMutation, UpdatePeriodicTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePeriodicTasksMutation, UpdatePeriodicTasksMutationVariables>(UpdatePeriodicTasksDocument, options);
      }
export type UpdatePeriodicTasksMutationHookResult = ReturnType<typeof useUpdatePeriodicTasksMutation>;
export type UpdatePeriodicTasksMutationResult = Apollo.MutationResult<UpdatePeriodicTasksMutation>;
export type UpdatePeriodicTasksMutationOptions = Apollo.BaseMutationOptions<UpdatePeriodicTasksMutation, UpdatePeriodicTasksMutationVariables>;
export const PeriodicTasksDocument = gql`
    query PeriodicTasks($query: String, $first: Int, $skip: Int, $filter: PeriodicTaskFilterInput) {
  allPeriodicTasks(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    task
    name
    enabled
    startTime
    oneOff
    scheduleName
    latestLog {
      id
      isOk
    }
  }
}
    `;

/**
 * __usePeriodicTasksQuery__
 *
 * To run a query within a React component, call `usePeriodicTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicTasksQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePeriodicTasksQuery(baseOptions?: Apollo.QueryHookOptions<PeriodicTasksQuery, PeriodicTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicTasksQuery, PeriodicTasksQueryVariables>(PeriodicTasksDocument, options);
      }
export function usePeriodicTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicTasksQuery, PeriodicTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicTasksQuery, PeriodicTasksQueryVariables>(PeriodicTasksDocument, options);
        }
export type PeriodicTasksQueryHookResult = ReturnType<typeof usePeriodicTasksQuery>;
export type PeriodicTasksLazyQueryHookResult = ReturnType<typeof usePeriodicTasksLazyQuery>;
export type PeriodicTasksQueryResult = Apollo.QueryResult<PeriodicTasksQuery, PeriodicTasksQueryVariables>;
export const PeriodicTaskDetailDocument = gql`
    query PeriodicTaskDetail($id: ID!) {
  periodicTaskDetail(id: $id) {
    ...PeriodicTaskDetailFrag
  }
}
    ${PeriodicTaskDetailFragFragmentDoc}`;

/**
 * __usePeriodicTaskDetailQuery__
 *
 * To run a query within a React component, call `usePeriodicTaskDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicTaskDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicTaskDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeriodicTaskDetailQuery(baseOptions: Apollo.QueryHookOptions<PeriodicTaskDetailQuery, PeriodicTaskDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicTaskDetailQuery, PeriodicTaskDetailQueryVariables>(PeriodicTaskDetailDocument, options);
      }
export function usePeriodicTaskDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicTaskDetailQuery, PeriodicTaskDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicTaskDetailQuery, PeriodicTaskDetailQueryVariables>(PeriodicTaskDetailDocument, options);
        }
export type PeriodicTaskDetailQueryHookResult = ReturnType<typeof usePeriodicTaskDetailQuery>;
export type PeriodicTaskDetailLazyQueryHookResult = ReturnType<typeof usePeriodicTaskDetailLazyQuery>;
export type PeriodicTaskDetailQueryResult = Apollo.QueryResult<PeriodicTaskDetailQuery, PeriodicTaskDetailQueryVariables>;
export const CreateInwardAllocationDocument = gql`
    mutation CreateInwardAllocation($id: ID, $input: InwardAllocationInput!) {
  addUpdateInwardAllocation(id: $id, qualities: $input) {
    inward {
      id
      inward {
        id
      }
      holdingArea {
        id
      }
      plotCommoditySample {
        id
      }
      metadata
    }
  }
}
    `;
export type CreateInwardAllocationMutationFn = Apollo.MutationFunction<CreateInwardAllocationMutation, CreateInwardAllocationMutationVariables>;

/**
 * __useCreateInwardAllocationMutation__
 *
 * To run a mutation, you first call `useCreateInwardAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInwardAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInwardAllocationMutation, { data, loading, error }] = useCreateInwardAllocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInwardAllocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInwardAllocationMutation, CreateInwardAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInwardAllocationMutation, CreateInwardAllocationMutationVariables>(CreateInwardAllocationDocument, options);
      }
export type CreateInwardAllocationMutationHookResult = ReturnType<typeof useCreateInwardAllocationMutation>;
export type CreateInwardAllocationMutationResult = Apollo.MutationResult<CreateInwardAllocationMutation>;
export type CreateInwardAllocationMutationOptions = Apollo.BaseMutationOptions<CreateInwardAllocationMutation, CreateInwardAllocationMutationVariables>;
export const MutationAddUpdatePackingAllotmentDocument = gql`
    mutation MutationAddUpdatePackingAllotment($allotment: PackingAllotmentInput!, $id: ID) {
  addUpdatePackingAllotment(allotment: $allotment, id: $id) {
    packingAllotment {
      id
    }
  }
}
    `;
export type MutationAddUpdatePackingAllotmentMutationFn = Apollo.MutationFunction<MutationAddUpdatePackingAllotmentMutation, MutationAddUpdatePackingAllotmentMutationVariables>;

/**
 * __useMutationAddUpdatePackingAllotmentMutation__
 *
 * To run a mutation, you first call `useMutationAddUpdatePackingAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutationAddUpdatePackingAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutationAddUpdatePackingAllotmentMutation, { data, loading, error }] = useMutationAddUpdatePackingAllotmentMutation({
 *   variables: {
 *      allotment: // value for 'allotment'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMutationAddUpdatePackingAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<MutationAddUpdatePackingAllotmentMutation, MutationAddUpdatePackingAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutationAddUpdatePackingAllotmentMutation, MutationAddUpdatePackingAllotmentMutationVariables>(MutationAddUpdatePackingAllotmentDocument, options);
      }
export type MutationAddUpdatePackingAllotmentMutationHookResult = ReturnType<typeof useMutationAddUpdatePackingAllotmentMutation>;
export type MutationAddUpdatePackingAllotmentMutationResult = Apollo.MutationResult<MutationAddUpdatePackingAllotmentMutation>;
export type MutationAddUpdatePackingAllotmentMutationOptions = Apollo.BaseMutationOptions<MutationAddUpdatePackingAllotmentMutation, MutationAddUpdatePackingAllotmentMutationVariables>;
export const InwardAllocationsDocument = gql`
    query InwardAllocations($search: String, $offset: Int, $limit: Int, $holdingAreaId: ID, $startDate: Date, $endDate: Date, $inwardId: ID, $depotId: ID, $varietyId: ID) {
  inwardAllocations(
    search: $search
    offset: $offset
    limit: $limit
    holdingAreaId: $holdingAreaId
    startDate: $startDate
    endDate: $endDate
    inwardId: $inwardId
    depotId: $depotId
    varietyId: $varietyId
  ) {
    id
    createdAt
    ggn
    metadata
    allottedWeight
    allottedSku
    availableWeight
    availableSkusCount
    plotCommoditySample {
      id
      totalDetection
      detectionCount
      physicalStatus
      chemicalStatus
      maxDetection
      chemicalStatusDisplay
      physicalStatusDisplay
      observations {
        id
        tags
        qualityParameter {
          id
          name
          mrl
        }
        detectionCount
        score
      }
    }
    inward {
      id
      grn
      metadata
      date
      status
      weigh {
        id
        skuType {
          id
          name
        }
        netWeight
        inwardedQuantity
        finalWeight
      }
      booking {
        id
        date
        schedule {
          id
          vehicle {
            id
            registrationNumber
            chassisNumber
          }
          gatePass
          aggregator {
            id
            fullName
          }
          variety {
            id
            name
          }
          plotCommodity {
            id
            registrationCode
          }
          plot {
            id
            farmer {
              id
              fullName
            }
          }
        }
      }
    }
    holdingArea {
      id
      name
      isActive
    }
    packingallotmentSet {
      ...packingallotmentSet
    }
  }
}
    ${PackingallotmentSetFragmentDoc}`;

/**
 * __useInwardAllocationsQuery__
 *
 * To run a query within a React component, call `useInwardAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInwardAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInwardAllocationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      holdingAreaId: // value for 'holdingAreaId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      inwardId: // value for 'inwardId'
 *      depotId: // value for 'depotId'
 *      varietyId: // value for 'varietyId'
 *   },
 * });
 */
export function useInwardAllocationsQuery(baseOptions?: Apollo.QueryHookOptions<InwardAllocationsQuery, InwardAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InwardAllocationsQuery, InwardAllocationsQueryVariables>(InwardAllocationsDocument, options);
      }
export function useInwardAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InwardAllocationsQuery, InwardAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InwardAllocationsQuery, InwardAllocationsQueryVariables>(InwardAllocationsDocument, options);
        }
export type InwardAllocationsQueryHookResult = ReturnType<typeof useInwardAllocationsQuery>;
export type InwardAllocationsLazyQueryHookResult = ReturnType<typeof useInwardAllocationsLazyQuery>;
export type InwardAllocationsQueryResult = Apollo.QueryResult<InwardAllocationsQuery, InwardAllocationsQueryVariables>;
export const InwardAllocationDocument = gql`
    query InwardAllocation($id: ID!) {
  inwardAllocation(id: $id) {
    id
    createdAt
    metadata
    ggn
    allottedWeight
    allottedSku
    availableWeight
    availableSkusCount
    packingallotmentSet {
      ...packingallotmentSet
    }
    plotCommoditySample {
      id
      totalDetection
      detectionCount
      physicalStatus
      chemicalStatus
      maxDetection
      chemicalStatusDisplay
      physicalStatusDisplay
      observations {
        id
        tags
        qualityParameter {
          id
          name
          mrl
        }
        detectionCount
        score
      }
    }
    inward {
      id
      grn
      date
      status
      weigh {
        id
        skuType {
          id
          name
          capacity
          capacityUnit {
            id
            name
            codename
          }
        }
        netWeight
        inwardedQuantity
        finalWeight
      }
      booking {
        id
        date
        schedule {
          id
          destinationDepot {
            id
            name
          }
          vehicle {
            id
            registrationNumber
            chassisNumber
          }
          gatePass
          aggregator {
            id
            fullName
          }
          variety {
            id
            name
          }
          plotCommodity {
            id
            registrationCode
          }
          plot {
            id
            farmer {
              id
              fullName
            }
          }
        }
      }
    }
    holdingArea {
      id
      name
      isActive
    }
  }
}
    ${PackingallotmentSetFragmentDoc}`;

/**
 * __useInwardAllocationQuery__
 *
 * To run a query within a React component, call `useInwardAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInwardAllocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInwardAllocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInwardAllocationQuery(baseOptions: Apollo.QueryHookOptions<InwardAllocationQuery, InwardAllocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InwardAllocationQuery, InwardAllocationQueryVariables>(InwardAllocationDocument, options);
      }
export function useInwardAllocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InwardAllocationQuery, InwardAllocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InwardAllocationQuery, InwardAllocationQueryVariables>(InwardAllocationDocument, options);
        }
export type InwardAllocationQueryHookResult = ReturnType<typeof useInwardAllocationQuery>;
export type InwardAllocationLazyQueryHookResult = ReturnType<typeof useInwardAllocationLazyQuery>;
export type InwardAllocationQueryResult = Apollo.QueryResult<InwardAllocationQuery, InwardAllocationQueryVariables>;
export const EligibleExportCustomersBySampleDocument = gql`
    query eligibleExportCustomersBySample($sampleId: ID!) {
  eligibleExportCustomersBySample(sampleId: $sampleId) {
    id
    name
  }
}
    `;

/**
 * __useEligibleExportCustomersBySampleQuery__
 *
 * To run a query within a React component, call `useEligibleExportCustomersBySampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleExportCustomersBySampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleExportCustomersBySampleQuery({
 *   variables: {
 *      sampleId: // value for 'sampleId'
 *   },
 * });
 */
export function useEligibleExportCustomersBySampleQuery(baseOptions: Apollo.QueryHookOptions<EligibleExportCustomersBySampleQuery, EligibleExportCustomersBySampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibleExportCustomersBySampleQuery, EligibleExportCustomersBySampleQueryVariables>(EligibleExportCustomersBySampleDocument, options);
      }
export function useEligibleExportCustomersBySampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibleExportCustomersBySampleQuery, EligibleExportCustomersBySampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibleExportCustomersBySampleQuery, EligibleExportCustomersBySampleQueryVariables>(EligibleExportCustomersBySampleDocument, options);
        }
export type EligibleExportCustomersBySampleQueryHookResult = ReturnType<typeof useEligibleExportCustomersBySampleQuery>;
export type EligibleExportCustomersBySampleLazyQueryHookResult = ReturnType<typeof useEligibleExportCustomersBySampleLazyQuery>;
export type EligibleExportCustomersBySampleQueryResult = Apollo.QueryResult<EligibleExportCustomersBySampleQuery, EligibleExportCustomersBySampleQueryVariables>;
export const AddUpdateProductionDocument = gql`
    mutation AddUpdateProduction($input: ProductionUpsertInput!) {
  addUpdateProduction(input: $input) {
    ok
    error
    production {
      id
    }
  }
}
    `;
export type AddUpdateProductionMutationFn = Apollo.MutationFunction<AddUpdateProductionMutation, AddUpdateProductionMutationVariables>;

/**
 * __useAddUpdateProductionMutation__
 *
 * To run a mutation, you first call `useAddUpdateProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateProductionMutation, { data, loading, error }] = useAddUpdateProductionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateProductionMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateProductionMutation, AddUpdateProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateProductionMutation, AddUpdateProductionMutationVariables>(AddUpdateProductionDocument, options);
      }
export type AddUpdateProductionMutationHookResult = ReturnType<typeof useAddUpdateProductionMutation>;
export type AddUpdateProductionMutationResult = Apollo.MutationResult<AddUpdateProductionMutation>;
export type AddUpdateProductionMutationOptions = Apollo.BaseMutationOptions<AddUpdateProductionMutation, AddUpdateProductionMutationVariables>;
export const UpdateLinePackingAllotmentLotCodeDocument = gql`
    mutation updateLinePackingAllotmentLotCode($input: UpdateLinePackingAllotmentLotCodeInput!) {
  updateLinePackingAllotmentLotCode(input: $input) {
    ok
    message
  }
}
    `;
export type UpdateLinePackingAllotmentLotCodeMutationFn = Apollo.MutationFunction<UpdateLinePackingAllotmentLotCodeMutation, UpdateLinePackingAllotmentLotCodeMutationVariables>;

/**
 * __useUpdateLinePackingAllotmentLotCodeMutation__
 *
 * To run a mutation, you first call `useUpdateLinePackingAllotmentLotCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinePackingAllotmentLotCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinePackingAllotmentLotCodeMutation, { data, loading, error }] = useUpdateLinePackingAllotmentLotCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLinePackingAllotmentLotCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinePackingAllotmentLotCodeMutation, UpdateLinePackingAllotmentLotCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinePackingAllotmentLotCodeMutation, UpdateLinePackingAllotmentLotCodeMutationVariables>(UpdateLinePackingAllotmentLotCodeDocument, options);
      }
export type UpdateLinePackingAllotmentLotCodeMutationHookResult = ReturnType<typeof useUpdateLinePackingAllotmentLotCodeMutation>;
export type UpdateLinePackingAllotmentLotCodeMutationResult = Apollo.MutationResult<UpdateLinePackingAllotmentLotCodeMutation>;
export type UpdateLinePackingAllotmentLotCodeMutationOptions = Apollo.BaseMutationOptions<UpdateLinePackingAllotmentLotCodeMutation, UpdateLinePackingAllotmentLotCodeMutationVariables>;
export const ProductionsDocument = gql`
    query Productions($search: String, $exportCustomerId: ID, $sendForApproval: Boolean, $limit: Int, $offset: Int, $varietyId: ID, $fromDate: Date, $toDate: Date, $productionStatus: String) {
  productions(
    search: $search
    exportCustomerId: $exportCustomerId
    sendForApproval: $sendForApproval
    limit: $limit
    offset: $offset
    varietyId: $varietyId
    fromDate: $fromDate
    toDate: $toDate
    productionStatus: $productionStatus
  ) {
    id
    createdAt
    weeklySrNo
    supervisorNames
    certificateNumbers
    farmerNames
    gatePasses
    shipmentPlan {
      id
      soNo
      skuFilled
      exportCustomer {
        id
        name
      }
      varieties {
        id
        name
      }
      varietyType
      skuType {
        id
        name
      }
    }
    productionLine {
      id
      name
    }
    sendForApproval
    metadata
  }
}
    `;

/**
 * __useProductionsQuery__
 *
 * To run a query within a React component, call `useProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      exportCustomerId: // value for 'exportCustomerId'
 *      sendForApproval: // value for 'sendForApproval'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      varietyId: // value for 'varietyId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      productionStatus: // value for 'productionStatus'
 *   },
 * });
 */
export function useProductionsQuery(baseOptions?: Apollo.QueryHookOptions<ProductionsQuery, ProductionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionsQuery, ProductionsQueryVariables>(ProductionsDocument, options);
      }
export function useProductionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionsQuery, ProductionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionsQuery, ProductionsQueryVariables>(ProductionsDocument, options);
        }
export type ProductionsQueryHookResult = ReturnType<typeof useProductionsQuery>;
export type ProductionsLazyQueryHookResult = ReturnType<typeof useProductionsLazyQuery>;
export type ProductionsQueryResult = Apollo.QueryResult<ProductionsQuery, ProductionsQueryVariables>;
export const ProductionDocument = gql`
    query Production($id: ID!) {
  production(id: $id) {
    id
    sendForApproval
    metadata
    productionLine {
      id
      name
    }
    weeklySrNo
    shipmentPlan {
      id
      soNo
      skuFilled
      metadata
      exportCustomer {
        id
        name
      }
      colourGroup {
        id
        name
      }
      skuType {
        id
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
      varietyType
      varieties {
        id
        name
      }
      primaryPackMaterial {
        id
        name
      }
      secondaryPackMaterial {
        id
        name
      }
      labels
      approvedtradeprofileSet {
        id
        tradeProfile {
          id
          certificateNumber
          availableYield
          plotYeild
        }
        boxCount
      }
    }
    productionitemSet {
      id
      createdAt
      sequenceNumber
      palletNo
      boxCount
      remark
      palletType
      metadata
      linetradeprofileSet {
        id
        assignedWt
        availableWt
        approvedTradeProfile {
          id
          tradeProfile {
            id
            certificateNumber
            plotCommodity {
              id
              name
              variety {
                id
                name
                commodity {
                  id
                  name
                }
              }
              plot {
                id
                name
                farmer {
                  id
                  fullName
                  documents {
                    id
                    certificationType {
                      id
                      name
                      codename
                    }
                    idNumber
                  }
                }
              }
            }
          }
        }
      }
      linepackingallotmentSet {
        id
        lotCode
        createdAt
        productionCreatedDate
        assignedWt
        availableWt
        rejectionWt
        rejectionBoxCount
        packingAllotment {
          id
          inwardAllocation {
            id
            inward {
              id
              booking {
                id
                schedule {
                  id
                  gatePass
                  variety {
                    id
                    name
                  }
                  plotCommodity {
                    id
                    registrationCode
                  }
                  plot {
                    farmer {
                      id
                      fullName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProductionQuery__
 *
 * To run a query within a React component, call `useProductionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductionQuery(baseOptions: Apollo.QueryHookOptions<ProductionQuery, ProductionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionQuery, ProductionQueryVariables>(ProductionDocument, options);
      }
export function useProductionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionQuery, ProductionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionQuery, ProductionQueryVariables>(ProductionDocument, options);
        }
export type ProductionQueryHookResult = ReturnType<typeof useProductionQuery>;
export type ProductionLazyQueryHookResult = ReturnType<typeof useProductionLazyQuery>;
export type ProductionQueryResult = Apollo.QueryResult<ProductionQuery, ProductionQueryVariables>;
export const MhCodeSelectorDocument = gql`
    query MhCodeSelector($id: ID!) {
  production(id: $id) {
    id
    weeklySrNo
    shipmentPlan {
      id
      metadata
      skuType {
        id
        name
        capacity
      }
      varieties {
        id
        name
      }
      approvedtradeprofileSet {
        id
        tradeProfile {
          id
          certificateNumber
          availableYield
          plotYeild
          extraPlotYeild
          extraAvailableYield
          plotCommodity {
            variety {
              id
              name
            }
            plot {
              id
              farmer {
                id
                fullName
                address {
                  id
                  address
                }
              }
            }
          }
        }
        boxCount
        availableYield
      }
    }
  }
}
    `;

/**
 * __useMhCodeSelectorQuery__
 *
 * To run a query within a React component, call `useMhCodeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMhCodeSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMhCodeSelectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMhCodeSelectorQuery(baseOptions: Apollo.QueryHookOptions<MhCodeSelectorQuery, MhCodeSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MhCodeSelectorQuery, MhCodeSelectorQueryVariables>(MhCodeSelectorDocument, options);
      }
export function useMhCodeSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MhCodeSelectorQuery, MhCodeSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MhCodeSelectorQuery, MhCodeSelectorQueryVariables>(MhCodeSelectorDocument, options);
        }
export type MhCodeSelectorQueryHookResult = ReturnType<typeof useMhCodeSelectorQuery>;
export type MhCodeSelectorLazyQueryHookResult = ReturnType<typeof useMhCodeSelectorLazyQuery>;
export type MhCodeSelectorQueryResult = Apollo.QueryResult<MhCodeSelectorQuery, MhCodeSelectorQueryVariables>;
export const GatepassSelectorDocument = gql`
    query GatepassSelector($productionItemId: ID, $search: String, $limit: Int, $offset: Int, $productionLineId: ID, $productionId: ID) {
  gatepassSelector(
    productionId: $productionId
    productionItemId: $productionItemId
    search: $search
    limit: $limit
    offset: $offset
    productionLineId: $productionLineId
  ) {
    id
    createdAt
    id
    allotedQuantity
    allotedWeight
    consumedWeight
    rejectedWeight
    rejectedQuantity
    inwardAllocation {
      id
      inward {
        id
        booking {
          schedule {
            id
            gatePass
            variety {
              id
              name
              referenceId
              parentVariety {
                id
                name
              }
            }
            plotCommodity {
              id
              registrationCode
            }
            plot {
              id
              farmer {
                id
                fullName
                address {
                  id
                  address
                }
              }
            }
          }
        }
      }
    }
    selected
  }
}
    `;

/**
 * __useGatepassSelectorQuery__
 *
 * To run a query within a React component, call `useGatepassSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatepassSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatepassSelectorQuery({
 *   variables: {
 *      productionItemId: // value for 'productionItemId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      productionLineId: // value for 'productionLineId'
 *      productionId: // value for 'productionId'
 *   },
 * });
 */
export function useGatepassSelectorQuery(baseOptions?: Apollo.QueryHookOptions<GatepassSelectorQuery, GatepassSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatepassSelectorQuery, GatepassSelectorQueryVariables>(GatepassSelectorDocument, options);
      }
export function useGatepassSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatepassSelectorQuery, GatepassSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatepassSelectorQuery, GatepassSelectorQueryVariables>(GatepassSelectorDocument, options);
        }
export type GatepassSelectorQueryHookResult = ReturnType<typeof useGatepassSelectorQuery>;
export type GatepassSelectorLazyQueryHookResult = ReturnType<typeof useGatepassSelectorLazyQuery>;
export type GatepassSelectorQueryResult = Apollo.QueryResult<GatepassSelectorQuery, GatepassSelectorQueryVariables>;
export const RestockProductionDocument = gql`
    mutation RestockProduction($input: RestockProductionInput!) {
  restockProduction(input: $input) {
    ok
    message
  }
}
    `;
export type RestockProductionMutationFn = Apollo.MutationFunction<RestockProductionMutation, RestockProductionMutationVariables>;

/**
 * __useRestockProductionMutation__
 *
 * To run a mutation, you first call `useRestockProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestockProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restockProductionMutation, { data, loading, error }] = useRestockProductionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestockProductionMutation(baseOptions?: Apollo.MutationHookOptions<RestockProductionMutation, RestockProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestockProductionMutation, RestockProductionMutationVariables>(RestockProductionDocument, options);
      }
export type RestockProductionMutationHookResult = ReturnType<typeof useRestockProductionMutation>;
export type RestockProductionMutationResult = Apollo.MutationResult<RestockProductionMutation>;
export type RestockProductionMutationOptions = Apollo.BaseMutationOptions<RestockProductionMutation, RestockProductionMutationVariables>;
export const AddRemarkProductionItemDocument = gql`
    mutation AddRemarkProductionItem($input: AddRemarkProductionItemInput!) {
  addRemarkProductionItem(input: $input) {
    ok
    message
  }
}
    `;
export type AddRemarkProductionItemMutationFn = Apollo.MutationFunction<AddRemarkProductionItemMutation, AddRemarkProductionItemMutationVariables>;

/**
 * __useAddRemarkProductionItemMutation__
 *
 * To run a mutation, you first call `useAddRemarkProductionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRemarkProductionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRemarkProductionItemMutation, { data, loading, error }] = useAddRemarkProductionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRemarkProductionItemMutation(baseOptions?: Apollo.MutationHookOptions<AddRemarkProductionItemMutation, AddRemarkProductionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRemarkProductionItemMutation, AddRemarkProductionItemMutationVariables>(AddRemarkProductionItemDocument, options);
      }
export type AddRemarkProductionItemMutationHookResult = ReturnType<typeof useAddRemarkProductionItemMutation>;
export type AddRemarkProductionItemMutationResult = Apollo.MutationResult<AddRemarkProductionItemMutation>;
export type AddRemarkProductionItemMutationOptions = Apollo.BaseMutationOptions<AddRemarkProductionItemMutation, AddRemarkProductionItemMutationVariables>;
export const AddBulkApproveTradeProfileDocument = gql`
    mutation AddBulkApproveTradeProfile($input: BulkApproveTradeProfilesInput!) {
  addBulkApproveTradeProfile(input: $input) {
    ok
    error
  }
}
    `;
export type AddBulkApproveTradeProfileMutationFn = Apollo.MutationFunction<AddBulkApproveTradeProfileMutation, AddBulkApproveTradeProfileMutationVariables>;

/**
 * __useAddBulkApproveTradeProfileMutation__
 *
 * To run a mutation, you first call `useAddBulkApproveTradeProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBulkApproveTradeProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBulkApproveTradeProfileMutation, { data, loading, error }] = useAddBulkApproveTradeProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBulkApproveTradeProfileMutation(baseOptions?: Apollo.MutationHookOptions<AddBulkApproveTradeProfileMutation, AddBulkApproveTradeProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBulkApproveTradeProfileMutation, AddBulkApproveTradeProfileMutationVariables>(AddBulkApproveTradeProfileDocument, options);
      }
export type AddBulkApproveTradeProfileMutationHookResult = ReturnType<typeof useAddBulkApproveTradeProfileMutation>;
export type AddBulkApproveTradeProfileMutationResult = Apollo.MutationResult<AddBulkApproveTradeProfileMutation>;
export type AddBulkApproveTradeProfileMutationOptions = Apollo.BaseMutationOptions<AddBulkApproveTradeProfileMutation, AddBulkApproveTradeProfileMutationVariables>;
export const CreateUpdateSalesOrderDocument = gql`
    mutation CreateUpdateSalesOrder($input: ShipmentPlanInput!) {
  createUpdateShipmentPlan(input: $input) {
    success
    message
  }
}
    `;
export type CreateUpdateSalesOrderMutationFn = Apollo.MutationFunction<CreateUpdateSalesOrderMutation, CreateUpdateSalesOrderMutationVariables>;

/**
 * __useCreateUpdateSalesOrderMutation__
 *
 * To run a mutation, you first call `useCreateUpdateSalesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateSalesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateSalesOrderMutation, { data, loading, error }] = useCreateUpdateSalesOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateSalesOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateSalesOrderMutation, CreateUpdateSalesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateSalesOrderMutation, CreateUpdateSalesOrderMutationVariables>(CreateUpdateSalesOrderDocument, options);
      }
export type CreateUpdateSalesOrderMutationHookResult = ReturnType<typeof useCreateUpdateSalesOrderMutation>;
export type CreateUpdateSalesOrderMutationResult = Apollo.MutationResult<CreateUpdateSalesOrderMutation>;
export type CreateUpdateSalesOrderMutationOptions = Apollo.BaseMutationOptions<CreateUpdateSalesOrderMutation, CreateUpdateSalesOrderMutationVariables>;
export const ShipmentPlansDocument = gql`
    query ShipmentPlans($customerId: ID, $portId: ID, $soNoContains: String, $limit: Int, $offset: Int, $varietyId: ID, $date: Date, $fromDate: Date, $toDate: Date, $productionStatus: String) {
  shipmentPlans(
    customerId: $customerId
    portId: $portId
    query: $soNoContains
    limit: $limit
    offset: $offset
    varietyId: $varietyId
    date: $date
    fromDate: $fromDate
    toDate: $toDate
    productionStatus: $productionStatus
  ) {
    results {
      id
      createdAt
      productionCreated
      productionItemsCount
      productionStatus
      production {
        id
        weeklySrNo
        sendForApproval
        metadata
        productionitemSet {
          id
          boxCount
          linepackingallotmentSet {
            id
          }
        }
      }
      weeklySrNo
      soNo
      metadata
      skuFilled
      colourGroup {
        id
        name
      }
      labels
      exportCustomer {
        id
        name
      }
      varieties {
        id
        name
      }
      varietyType
      skuType {
        id
        name
        capacity
      }
      primaryPackMaterial {
        id
        name
      }
      secondaryPackMaterial {
        id
        name
      }
      approvedtradeprofileSet {
        id
        availableYield
        boxCount
        tradeProfile {
          id
          certificateNumber
        }
      }
    }
  }
}
    `;

/**
 * __useShipmentPlansQuery__
 *
 * To run a query within a React component, call `useShipmentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentPlansQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      portId: // value for 'portId'
 *      soNoContains: // value for 'soNoContains'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      varietyId: // value for 'varietyId'
 *      date: // value for 'date'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      productionStatus: // value for 'productionStatus'
 *   },
 * });
 */
export function useShipmentPlansQuery(baseOptions?: Apollo.QueryHookOptions<ShipmentPlansQuery, ShipmentPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentPlansQuery, ShipmentPlansQueryVariables>(ShipmentPlansDocument, options);
      }
export function useShipmentPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentPlansQuery, ShipmentPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentPlansQuery, ShipmentPlansQueryVariables>(ShipmentPlansDocument, options);
        }
export type ShipmentPlansQueryHookResult = ReturnType<typeof useShipmentPlansQuery>;
export type ShipmentPlansLazyQueryHookResult = ReturnType<typeof useShipmentPlansLazyQuery>;
export type ShipmentPlansQueryResult = Apollo.QueryResult<ShipmentPlansQuery, ShipmentPlansQueryVariables>;
export const MatchProfilesByCustIdDocument = gql`
    query MatchProfilesByCustId($custId: ID, $shipmentPlanId: ID, $search: String, $limit: Int, $offset: Int) {
  matchProfilesByCustId(
    custId: $custId
    shipmentPlanId: $shipmentPlanId
    search: $search
    limit: $limit
    offset: $offset
  ) {
    id
    certificateNumber
    reason
    color
    plotCommodity {
      id
      name
      variety {
        id
        name
        __typename
      }
      plot {
        farmer {
          id
          fullName
          __typename
        }
        address {
          id
          village
          taluka
          state
          __typename
        }
        __typename
      }
      lastSample {
        id
        detectionCount
        maxDetection
        totalDetection
        created
        observations {
          id
          tags
          detectionCount
          qualityParameter {
            id
            name
          }
        }
        __typename
      }
      samples {
        id
        detectionCount
        maxDetection
        totalDetection
        __typename
      }
      __typename
    }
    exportCustomers {
      id
      name
      __typename
    }
    plotYeild
    area
    availableYield
    extraPlotYeild
    extraAvailableYield
    __typename
  }
}
    `;

/**
 * __useMatchProfilesByCustIdQuery__
 *
 * To run a query within a React component, call `useMatchProfilesByCustIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchProfilesByCustIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchProfilesByCustIdQuery({
 *   variables: {
 *      custId: // value for 'custId'
 *      shipmentPlanId: // value for 'shipmentPlanId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMatchProfilesByCustIdQuery(baseOptions?: Apollo.QueryHookOptions<MatchProfilesByCustIdQuery, MatchProfilesByCustIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchProfilesByCustIdQuery, MatchProfilesByCustIdQueryVariables>(MatchProfilesByCustIdDocument, options);
      }
export function useMatchProfilesByCustIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchProfilesByCustIdQuery, MatchProfilesByCustIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchProfilesByCustIdQuery, MatchProfilesByCustIdQueryVariables>(MatchProfilesByCustIdDocument, options);
        }
export type MatchProfilesByCustIdQueryHookResult = ReturnType<typeof useMatchProfilesByCustIdQuery>;
export type MatchProfilesByCustIdLazyQueryHookResult = ReturnType<typeof useMatchProfilesByCustIdLazyQuery>;
export type MatchProfilesByCustIdQueryResult = Apollo.QueryResult<MatchProfilesByCustIdQuery, MatchProfilesByCustIdQueryVariables>;
export const ShipmentPlanBySoNoDocument = gql`
    query shipmentPlanBySoNo($soNo: ID!) {
  shipmentPlanById(id: $soNo) {
    createdAt
    updatedAt
    id
    weeklySrNo
    soNo
    invoiceNo
    specification
    labels
    gtin
    port {
      isActive
      id
      name
    }
    eta
    etd
    remark
    varietyType
    saleType
    metadata
    exportCustomer {
      isActive
      id
      name
    }
    skuType {
      id
      name
      codename
    }
    colourGroup {
      id
      name
      codename
    }
    varieties {
      id
      name
    }
    primaryPackMaterial {
      id
      name
      codename
    }
    secondaryPackMaterial {
      id
      name
      codename
    }
    skuFilled
    approvedtradeprofileSet {
      id
      boxCount
    }
    productionSet {
      id
      productionLine {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useShipmentPlanBySoNoQuery__
 *
 * To run a query within a React component, call `useShipmentPlanBySoNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentPlanBySoNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentPlanBySoNoQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useShipmentPlanBySoNoQuery(baseOptions: Apollo.QueryHookOptions<ShipmentPlanBySoNoQuery, ShipmentPlanBySoNoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentPlanBySoNoQuery, ShipmentPlanBySoNoQueryVariables>(ShipmentPlanBySoNoDocument, options);
      }
export function useShipmentPlanBySoNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentPlanBySoNoQuery, ShipmentPlanBySoNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentPlanBySoNoQuery, ShipmentPlanBySoNoQueryVariables>(ShipmentPlanBySoNoDocument, options);
        }
export type ShipmentPlanBySoNoQueryHookResult = ReturnType<typeof useShipmentPlanBySoNoQuery>;
export type ShipmentPlanBySoNoLazyQueryHookResult = ReturnType<typeof useShipmentPlanBySoNoLazyQuery>;
export type ShipmentPlanBySoNoQueryResult = Apollo.QueryResult<ShipmentPlanBySoNoQuery, ShipmentPlanBySoNoQueryVariables>;
export const AllProductionBatchesDocument = gql`
    query AllProductionBatches($first: Int, $skip: Int, $search: String, $isActive: Boolean, $varietyId: Int, $dateFrom: Date, $dateTo: Date) {
  allProductionBatches(
    first: $first
    skip: $skip
    search: $search
    isActive: $isActive
    varietyId: $varietyId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    id
    name
    codename
    variety {
      id
      name
    }
    description
    date
    isActive
  }
}
    `;

/**
 * __useAllProductionBatchesQuery__
 *
 * To run a query within a React component, call `useAllProductionBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductionBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductionBatchesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      isActive: // value for 'isActive'
 *      varietyId: // value for 'varietyId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useAllProductionBatchesQuery(baseOptions?: Apollo.QueryHookOptions<AllProductionBatchesQuery, AllProductionBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProductionBatchesQuery, AllProductionBatchesQueryVariables>(AllProductionBatchesDocument, options);
      }
export function useAllProductionBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProductionBatchesQuery, AllProductionBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProductionBatchesQuery, AllProductionBatchesQueryVariables>(AllProductionBatchesDocument, options);
        }
export type AllProductionBatchesQueryHookResult = ReturnType<typeof useAllProductionBatchesQuery>;
export type AllProductionBatchesLazyQueryHookResult = ReturnType<typeof useAllProductionBatchesLazyQuery>;
export type AllProductionBatchesQueryResult = Apollo.QueryResult<AllProductionBatchesQuery, AllProductionBatchesQueryVariables>;
export const CreateUpdateReportTemplateDocument = gql`
    mutation CreateUpdateReportTemplate($columns: [ReportTemplateColumn], $groupBy: [ID], $groupsShared: [ID], $id: ID, $name: String!, $sourceId: ID!, $title: String!, $usersShared: [ID]) {
  addUpdateReportTemplate(
    columns: $columns
    groupBy: $groupBy
    groupsShared: $groupsShared
    id: $id
    name: $name
    sourceId: $sourceId
    title: $title
    usersShared: $usersShared
  ) {
    reportTemplate {
      ...ReportTemplateDetailFrag
    }
  }
}
    ${ReportTemplateDetailFragFragmentDoc}`;
export type CreateUpdateReportTemplateMutationFn = Apollo.MutationFunction<CreateUpdateReportTemplateMutation, CreateUpdateReportTemplateMutationVariables>;

/**
 * __useCreateUpdateReportTemplateMutation__
 *
 * To run a mutation, you first call `useCreateUpdateReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateReportTemplateMutation, { data, loading, error }] = useCreateUpdateReportTemplateMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      groupBy: // value for 'groupBy'
 *      groupsShared: // value for 'groupsShared'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      sourceId: // value for 'sourceId'
 *      title: // value for 'title'
 *      usersShared: // value for 'usersShared'
 *   },
 * });
 */
export function useCreateUpdateReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateReportTemplateMutation, CreateUpdateReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateReportTemplateMutation, CreateUpdateReportTemplateMutationVariables>(CreateUpdateReportTemplateDocument, options);
      }
export type CreateUpdateReportTemplateMutationHookResult = ReturnType<typeof useCreateUpdateReportTemplateMutation>;
export type CreateUpdateReportTemplateMutationResult = Apollo.MutationResult<CreateUpdateReportTemplateMutation>;
export type CreateUpdateReportTemplateMutationOptions = Apollo.BaseMutationOptions<CreateUpdateReportTemplateMutation, CreateUpdateReportTemplateMutationVariables>;
export const MyReportsDocument = gql`
    query myReports($query: String) {
  myReportTemplates(query: $query) {
    ...ReportTemplateListFrag
  }
}
    ${ReportTemplateListFragFragmentDoc}`;

/**
 * __useMyReportsQuery__
 *
 * To run a query within a React component, call `useMyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReportsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMyReportsQuery(baseOptions?: Apollo.QueryHookOptions<MyReportsQuery, MyReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReportsQuery, MyReportsQueryVariables>(MyReportsDocument, options);
      }
export function useMyReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReportsQuery, MyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReportsQuery, MyReportsQueryVariables>(MyReportsDocument, options);
        }
export type MyReportsQueryHookResult = ReturnType<typeof useMyReportsQuery>;
export type MyReportsLazyQueryHookResult = ReturnType<typeof useMyReportsLazyQuery>;
export type MyReportsQueryResult = Apollo.QueryResult<MyReportsQuery, MyReportsQueryVariables>;
export const ReportMasterListDocument = gql`
    query ReportMasterList {
  allReportMasters {
    id
    alias
    groupings {
      id
      name: alias
    }
    columns {
      id
      fieldType
      alias
    }
  }
}
    `;

/**
 * __useReportMasterListQuery__
 *
 * To run a query within a React component, call `useReportMasterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportMasterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportMasterListQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportMasterListQuery(baseOptions?: Apollo.QueryHookOptions<ReportMasterListQuery, ReportMasterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportMasterListQuery, ReportMasterListQueryVariables>(ReportMasterListDocument, options);
      }
export function useReportMasterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportMasterListQuery, ReportMasterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportMasterListQuery, ReportMasterListQueryVariables>(ReportMasterListDocument, options);
        }
export type ReportMasterListQueryHookResult = ReturnType<typeof useReportMasterListQuery>;
export type ReportMasterListLazyQueryHookResult = ReturnType<typeof useReportMasterListLazyQuery>;
export type ReportMasterListQueryResult = Apollo.QueryResult<ReportMasterListQuery, ReportMasterListQueryVariables>;
export const ReportTemplateDocument = gql`
    query ReportTemplate($id: ID!) {
  reportTemplateDetail(id: $id) {
    ...ReportTemplateDetailFrag
  }
}
    ${ReportTemplateDetailFragFragmentDoc}`;

/**
 * __useReportTemplateQuery__
 *
 * To run a query within a React component, call `useReportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportTemplateQuery(baseOptions: Apollo.QueryHookOptions<ReportTemplateQuery, ReportTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportTemplateQuery, ReportTemplateQueryVariables>(ReportTemplateDocument, options);
      }
export function useReportTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportTemplateQuery, ReportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportTemplateQuery, ReportTemplateQueryVariables>(ReportTemplateDocument, options);
        }
export type ReportTemplateQueryHookResult = ReturnType<typeof useReportTemplateQuery>;
export type ReportTemplateLazyQueryHookResult = ReturnType<typeof useReportTemplateLazyQuery>;
export type ReportTemplateQueryResult = Apollo.QueryResult<ReportTemplateQuery, ReportTemplateQueryVariables>;
export const ExportReportFilterDocument = gql`
    query exportReportFilter($templateId: ID!, $filters: [ReportTemplateFilter], $emailTo: [String]) {
  exportReport(templateId: $templateId, filters: $filters, emailTo: $emailTo) {
    exportLogs {
      id
    }
  }
}
    `;

/**
 * __useExportReportFilterQuery__
 *
 * To run a query within a React component, call `useExportReportFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportReportFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportReportFilterQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      filters: // value for 'filters'
 *      emailTo: // value for 'emailTo'
 *   },
 * });
 */
export function useExportReportFilterQuery(baseOptions: Apollo.QueryHookOptions<ExportReportFilterQuery, ExportReportFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportReportFilterQuery, ExportReportFilterQueryVariables>(ExportReportFilterDocument, options);
      }
export function useExportReportFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportReportFilterQuery, ExportReportFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportReportFilterQuery, ExportReportFilterQueryVariables>(ExportReportFilterDocument, options);
        }
export type ExportReportFilterQueryHookResult = ReturnType<typeof useExportReportFilterQuery>;
export type ExportReportFilterLazyQueryHookResult = ReturnType<typeof useExportReportFilterLazyQuery>;
export type ExportReportFilterQueryResult = Apollo.QueryResult<ExportReportFilterQuery, ExportReportFilterQueryVariables>;
export const CreateOrUpdateRouteDocument = gql`
    mutation createOrUpdateRoute($categoryId: ID, $colorCode: String, $description: String, $id: ID, $name: String, $points: [RoutePointInput], $surveyAreaId: ID) {
  addUpdateRoute(
    categoryId: $categoryId
    colorCode: $colorCode
    description: $description
    id: $id
    name: $name
    points: $points
    surveyAreaId: $surveyAreaId
  ) {
    route {
      id
      isActive
      colorCode
      name
      surveyArea {
        id
        properties {
          name
        }
      }
      points {
        id
        visitee {
          id
          fullName
          address {
            id
            village
            latitude
            longitude
          }
          number
          status
        }
      }
    }
  }
}
    `;
export type CreateOrUpdateRouteMutationFn = Apollo.MutationFunction<CreateOrUpdateRouteMutation, CreateOrUpdateRouteMutationVariables>;

/**
 * __useCreateOrUpdateRouteMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateRouteMutation, { data, loading, error }] = useCreateOrUpdateRouteMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      colorCode: // value for 'colorCode'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      points: // value for 'points'
 *      surveyAreaId: // value for 'surveyAreaId'
 *   },
 * });
 */
export function useCreateOrUpdateRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateRouteMutation, CreateOrUpdateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateRouteMutation, CreateOrUpdateRouteMutationVariables>(CreateOrUpdateRouteDocument, options);
      }
export type CreateOrUpdateRouteMutationHookResult = ReturnType<typeof useCreateOrUpdateRouteMutation>;
export type CreateOrUpdateRouteMutationResult = Apollo.MutationResult<CreateOrUpdateRouteMutation>;
export type CreateOrUpdateRouteMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateRouteMutation, CreateOrUpdateRouteMutationVariables>;
export const CreateUpdateRouteAssignmentDocument = gql`
    mutation createUpdateRouteAssignment($assigneeId: ID, $endTime: Time, $id: ID, $points: [RoutePointInput], $recurrences: String, $routeId: ID, $shouldTrack: Boolean, $startDate: Date, $startTime: Time) {
  addUpdateRouteAssignment(
    assigneeId: $assigneeId
    endTime: $endTime
    id: $id
    points: $points
    recurrences: $recurrences
    routeId: $routeId
    shouldTrack: $shouldTrack
    startDate: $startDate
    startTime: $startTime
  ) {
    routeAssignment {
      id
      route {
        id
        name
      }
      assignee {
        id
        fullName
      }
      rrules
      startDate
      startTime
      endTime
      shouldTrack
    }
  }
}
    `;
export type CreateUpdateRouteAssignmentMutationFn = Apollo.MutationFunction<CreateUpdateRouteAssignmentMutation, CreateUpdateRouteAssignmentMutationVariables>;

/**
 * __useCreateUpdateRouteAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateUpdateRouteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateRouteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateRouteAssignmentMutation, { data, loading, error }] = useCreateUpdateRouteAssignmentMutation({
 *   variables: {
 *      assigneeId: // value for 'assigneeId'
 *      endTime: // value for 'endTime'
 *      id: // value for 'id'
 *      points: // value for 'points'
 *      recurrences: // value for 'recurrences'
 *      routeId: // value for 'routeId'
 *      shouldTrack: // value for 'shouldTrack'
 *      startDate: // value for 'startDate'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useCreateUpdateRouteAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateRouteAssignmentMutation, CreateUpdateRouteAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateRouteAssignmentMutation, CreateUpdateRouteAssignmentMutationVariables>(CreateUpdateRouteAssignmentDocument, options);
      }
export type CreateUpdateRouteAssignmentMutationHookResult = ReturnType<typeof useCreateUpdateRouteAssignmentMutation>;
export type CreateUpdateRouteAssignmentMutationResult = Apollo.MutationResult<CreateUpdateRouteAssignmentMutation>;
export type CreateUpdateRouteAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateUpdateRouteAssignmentMutation, CreateUpdateRouteAssignmentMutationVariables>;
export const ShiftBeatDocument = gql`
    mutation ShiftBeat($id: ID, $excludeDate: Date, $includeDate: Date) {
  replaceRrule(id: $id, excludeDate: $excludeDate, includeDate: $includeDate) {
    routeAssignment {
      id
      rrules
    }
  }
}
    `;
export type ShiftBeatMutationFn = Apollo.MutationFunction<ShiftBeatMutation, ShiftBeatMutationVariables>;

/**
 * __useShiftBeatMutation__
 *
 * To run a mutation, you first call `useShiftBeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShiftBeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shiftBeatMutation, { data, loading, error }] = useShiftBeatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      excludeDate: // value for 'excludeDate'
 *      includeDate: // value for 'includeDate'
 *   },
 * });
 */
export function useShiftBeatMutation(baseOptions?: Apollo.MutationHookOptions<ShiftBeatMutation, ShiftBeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShiftBeatMutation, ShiftBeatMutationVariables>(ShiftBeatDocument, options);
      }
export type ShiftBeatMutationHookResult = ReturnType<typeof useShiftBeatMutation>;
export type ShiftBeatMutationResult = Apollo.MutationResult<ShiftBeatMutation>;
export type ShiftBeatMutationOptions = Apollo.BaseMutationOptions<ShiftBeatMutation, ShiftBeatMutationVariables>;
export const AddUpdateBeatRemarkDocument = gql`
    mutation addUpdateBeatRemark($assignmentId: ID, $date: Date, $id: ID, $remark: String) {
  addUpdateSupBeat(
    assignmentId: $assignmentId
    date: $date
    id: $id
    remark: $remark
  ) {
    beat {
      id
      remark
      date
      assignment {
        id
      }
    }
  }
}
    `;
export type AddUpdateBeatRemarkMutationFn = Apollo.MutationFunction<AddUpdateBeatRemarkMutation, AddUpdateBeatRemarkMutationVariables>;

/**
 * __useAddUpdateBeatRemarkMutation__
 *
 * To run a mutation, you first call `useAddUpdateBeatRemarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateBeatRemarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateBeatRemarkMutation, { data, loading, error }] = useAddUpdateBeatRemarkMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      date: // value for 'date'
 *      id: // value for 'id'
 *      remark: // value for 'remark'
 *   },
 * });
 */
export function useAddUpdateBeatRemarkMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateBeatRemarkMutation, AddUpdateBeatRemarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateBeatRemarkMutation, AddUpdateBeatRemarkMutationVariables>(AddUpdateBeatRemarkDocument, options);
      }
export type AddUpdateBeatRemarkMutationHookResult = ReturnType<typeof useAddUpdateBeatRemarkMutation>;
export type AddUpdateBeatRemarkMutationResult = Apollo.MutationResult<AddUpdateBeatRemarkMutation>;
export type AddUpdateBeatRemarkMutationOptions = Apollo.BaseMutationOptions<AddUpdateBeatRemarkMutation, AddUpdateBeatRemarkMutationVariables>;
export const AllRoutesDocument = gql`
    query allRoutes($query: String, $first: Int, $skip: Int, $filter: RouteInput) {
  allRoutes(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    name
    createdAt
    isActive
    surveyArea {
      id
      properties {
        name
      }
    }
    colorCode
    points {
      id
      visitee {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useAllRoutesQuery__
 *
 * To run a query within a React component, call `useAllRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRoutesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllRoutesQuery(baseOptions?: Apollo.QueryHookOptions<AllRoutesQuery, AllRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRoutesQuery, AllRoutesQueryVariables>(AllRoutesDocument, options);
      }
export function useAllRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRoutesQuery, AllRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRoutesQuery, AllRoutesQueryVariables>(AllRoutesDocument, options);
        }
export type AllRoutesQueryHookResult = ReturnType<typeof useAllRoutesQuery>;
export type AllRoutesLazyQueryHookResult = ReturnType<typeof useAllRoutesLazyQuery>;
export type AllRoutesQueryResult = Apollo.QueryResult<AllRoutesQuery, AllRoutesQueryVariables>;
export const RouteDetailDocument = gql`
    query routeDetail($id: ID!) {
  routeDetail(id: $id) {
    id
    isActive
    colorCode
    name
    category {
      id
      name
    }
    surveyArea {
      id
      properties {
        name
      }
    }
    points {
      id
      sequence
      visitee {
        id
        fullName
        number
        status
        routepoints {
          id
          route {
            id
            name
          }
        }
        address {
          id
          village
          address
          latitude
          longitude
        }
      }
    }
  }
}
    `;

/**
 * __useRouteDetailQuery__
 *
 * To run a query within a React component, call `useRouteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouteDetailQuery(baseOptions: Apollo.QueryHookOptions<RouteDetailQuery, RouteDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteDetailQuery, RouteDetailQueryVariables>(RouteDetailDocument, options);
      }
export function useRouteDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteDetailQuery, RouteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteDetailQuery, RouteDetailQueryVariables>(RouteDetailDocument, options);
        }
export type RouteDetailQueryHookResult = ReturnType<typeof useRouteDetailQuery>;
export type RouteDetailLazyQueryHookResult = ReturnType<typeof useRouteDetailLazyQuery>;
export type RouteDetailQueryResult = Apollo.QueryResult<RouteDetailQuery, RouteDetailQueryVariables>;
export const SurveyAreaVendorsDocument = gql`
    query surveyAreaVendors($surveyAreaId: Int!, $query: String, $first: Int, $skip: Int) {
  allVendorsBySurveyAreas(
    surveyAreaId: $surveyAreaId
    query: $query
    first: $first
    skip: $skip
  ) {
    id
    fullName
    number
    status
    routepoints {
      id
      route {
        id
        name
      }
    }
    address {
      id
      village
      address
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useSurveyAreaVendorsQuery__
 *
 * To run a query within a React component, call `useSurveyAreaVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyAreaVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyAreaVendorsQuery({
 *   variables: {
 *      surveyAreaId: // value for 'surveyAreaId'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSurveyAreaVendorsQuery(baseOptions: Apollo.QueryHookOptions<SurveyAreaVendorsQuery, SurveyAreaVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyAreaVendorsQuery, SurveyAreaVendorsQueryVariables>(SurveyAreaVendorsDocument, options);
      }
export function useSurveyAreaVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyAreaVendorsQuery, SurveyAreaVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyAreaVendorsQuery, SurveyAreaVendorsQueryVariables>(SurveyAreaVendorsDocument, options);
        }
export type SurveyAreaVendorsQueryHookResult = ReturnType<typeof useSurveyAreaVendorsQuery>;
export type SurveyAreaVendorsLazyQueryHookResult = ReturnType<typeof useSurveyAreaVendorsLazyQuery>;
export type SurveyAreaVendorsQueryResult = Apollo.QueryResult<SurveyAreaVendorsQuery, SurveyAreaVendorsQueryVariables>;
export const RouteAssignmentDetailDocument = gql`
    query routeAssignmentDetail($id: ID!) {
  routeAssignmentDetail(id: $id) {
    id
    rrules
    startDate
    endTime
    startTime
    shouldTrack
    assignee {
      id
      fullName
      isStaff
    }
    assignedRoutePoints {
      id
      sequence
      visitee {
        id
        fullName
        number
        status
        address {
          id
          village
          address
          latitude
          longitude
        }
      }
    }
    route {
      id
      name
      colorCode
      surveyArea {
        id
        properties {
          name
        }
      }
      points {
        id
        sequence
        visitee {
          id
          fullName
          number
          status
          address {
            id
            village
            address
            latitude
            longitude
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRouteAssignmentDetailQuery__
 *
 * To run a query within a React component, call `useRouteAssignmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteAssignmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteAssignmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouteAssignmentDetailQuery(baseOptions: Apollo.QueryHookOptions<RouteAssignmentDetailQuery, RouteAssignmentDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteAssignmentDetailQuery, RouteAssignmentDetailQueryVariables>(RouteAssignmentDetailDocument, options);
      }
export function useRouteAssignmentDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteAssignmentDetailQuery, RouteAssignmentDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteAssignmentDetailQuery, RouteAssignmentDetailQueryVariables>(RouteAssignmentDetailDocument, options);
        }
export type RouteAssignmentDetailQueryHookResult = ReturnType<typeof useRouteAssignmentDetailQuery>;
export type RouteAssignmentDetailLazyQueryHookResult = ReturnType<typeof useRouteAssignmentDetailLazyQuery>;
export type RouteAssignmentDetailQueryResult = Apollo.QueryResult<RouteAssignmentDetailQuery, RouteAssignmentDetailQueryVariables>;
export const RouteAssignmentReccurencesDocument = gql`
    query routeAssignmentReccurences($query: String, $first: Int, $skip: Int, $filter: RouteAssignmentFilterInput, $start: DateTime, $end: DateTime) {
  allRouteAssignments(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    route {
      id
      name
    }
    assignee {
      id
      fullName
    }
    rrules
    recurrences(start: $start, end: $end)
  }
}
    `;

/**
 * __useRouteAssignmentReccurencesQuery__
 *
 * To run a query within a React component, call `useRouteAssignmentReccurencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteAssignmentReccurencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteAssignmentReccurencesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useRouteAssignmentReccurencesQuery(baseOptions?: Apollo.QueryHookOptions<RouteAssignmentReccurencesQuery, RouteAssignmentReccurencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteAssignmentReccurencesQuery, RouteAssignmentReccurencesQueryVariables>(RouteAssignmentReccurencesDocument, options);
      }
export function useRouteAssignmentReccurencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteAssignmentReccurencesQuery, RouteAssignmentReccurencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteAssignmentReccurencesQuery, RouteAssignmentReccurencesQueryVariables>(RouteAssignmentReccurencesDocument, options);
        }
export type RouteAssignmentReccurencesQueryHookResult = ReturnType<typeof useRouteAssignmentReccurencesQuery>;
export type RouteAssignmentReccurencesLazyQueryHookResult = ReturnType<typeof useRouteAssignmentReccurencesLazyQuery>;
export type RouteAssignmentReccurencesQueryResult = Apollo.QueryResult<RouteAssignmentReccurencesQuery, RouteAssignmentReccurencesQueryVariables>;
export const RoutePolylineDocument = gql`
    query routePolyline($id: ID!) {
  routeDetail(id: $id) {
    id
    colorCode
    polyline {
      type
      coordinates
    }
  }
}
    `;

/**
 * __useRoutePolylineQuery__
 *
 * To run a query within a React component, call `useRoutePolylineQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutePolylineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutePolylineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoutePolylineQuery(baseOptions: Apollo.QueryHookOptions<RoutePolylineQuery, RoutePolylineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoutePolylineQuery, RoutePolylineQueryVariables>(RoutePolylineDocument, options);
      }
export function useRoutePolylineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoutePolylineQuery, RoutePolylineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoutePolylineQuery, RoutePolylineQueryVariables>(RoutePolylineDocument, options);
        }
export type RoutePolylineQueryHookResult = ReturnType<typeof useRoutePolylineQuery>;
export type RoutePolylineLazyQueryHookResult = ReturnType<typeof useRoutePolylineLazyQuery>;
export type RoutePolylineQueryResult = Apollo.QueryResult<RoutePolylineQuery, RoutePolylineQueryVariables>;
export const AllBeatsDocument = gql`
    query allBeats($query: String, $first: Int, $skip: Int, $date: Date) {
  allBeats(query: $query, first: $first, skip: $skip, filter: {date: $date}) {
    id
    assignee {
      id
      fullName
    }
    assignment {
      id
      route {
        id
        name
        surveyArea {
          id
          properties {
            name
          }
        }
      }
      beatVisitCount(date: $date)
      assignedRoutePointCount
    }
    summary {
      durationAvg {
        seconds
        hours
        minutes
      }
      placedOrderCount
      secondarySales
      dropSize
    }
    status
    startTime
    endTime
  }
}
    `;

/**
 * __useAllBeatsQuery__
 *
 * To run a query within a React component, call `useAllBeatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBeatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBeatsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAllBeatsQuery(baseOptions?: Apollo.QueryHookOptions<AllBeatsQuery, AllBeatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBeatsQuery, AllBeatsQueryVariables>(AllBeatsDocument, options);
      }
export function useAllBeatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBeatsQuery, AllBeatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBeatsQuery, AllBeatsQueryVariables>(AllBeatsDocument, options);
        }
export type AllBeatsQueryHookResult = ReturnType<typeof useAllBeatsQuery>;
export type AllBeatsLazyQueryHookResult = ReturnType<typeof useAllBeatsLazyQuery>;
export type AllBeatsQueryResult = Apollo.QueryResult<AllBeatsQuery, AllBeatsQueryVariables>;
export const BeatDetailDocument = gql`
    query beatDetail($id: ID!) {
  beatDetail(id: $id) {
    id
    summary {
      durationAvg {
        hours
        minutes
        seconds
      }
    }
    assignee {
      id
      fullName
      referenceId
      number
    }
    status
    date
    assignment {
      id
      polyline {
        type
        coordinates
      }
      route {
        id
        name
        colorCode
        surveyArea {
          id
          properties {
            name
          }
        }
      }
      assignedRoutePoints {
        id
        visitee {
          id
          fullName
          status
          address {
            id
            address
            latitude
            longitude
          }
          fullName
          number
        }
        sequence
        visitByBeat(beatId: $id) {
          id
          endTime
          duration {
            hours
            minutes
            seconds
          }
        }
      }
    }
    remark
  }
}
    `;

/**
 * __useBeatDetailQuery__
 *
 * To run a query within a React component, call `useBeatDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeatDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeatDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBeatDetailQuery(baseOptions: Apollo.QueryHookOptions<BeatDetailQuery, BeatDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeatDetailQuery, BeatDetailQueryVariables>(BeatDetailDocument, options);
      }
export function useBeatDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeatDetailQuery, BeatDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeatDetailQuery, BeatDetailQueryVariables>(BeatDetailDocument, options);
        }
export type BeatDetailQueryHookResult = ReturnType<typeof useBeatDetailQuery>;
export type BeatDetailLazyQueryHookResult = ReturnType<typeof useBeatDetailLazyQuery>;
export type BeatDetailQueryResult = Apollo.QueryResult<BeatDetailQuery, BeatDetailQueryVariables>;
export const BeatVisitDetailDocument = gql`
    query beatVisitDetail($id: ID!) {
  beatVisitDetail(id: $id) {
    id
    remark
    attachments {
      id
      url
    }
    actions {
      id
      action
      actionDetails
    }
  }
}
    `;

/**
 * __useBeatVisitDetailQuery__
 *
 * To run a query within a React component, call `useBeatVisitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeatVisitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeatVisitDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBeatVisitDetailQuery(baseOptions: Apollo.QueryHookOptions<BeatVisitDetailQuery, BeatVisitDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeatVisitDetailQuery, BeatVisitDetailQueryVariables>(BeatVisitDetailDocument, options);
      }
export function useBeatVisitDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeatVisitDetailQuery, BeatVisitDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeatVisitDetailQuery, BeatVisitDetailQueryVariables>(BeatVisitDetailDocument, options);
        }
export type BeatVisitDetailQueryHookResult = ReturnType<typeof useBeatVisitDetailQuery>;
export type BeatVisitDetailLazyQueryHookResult = ReturnType<typeof useBeatVisitDetailLazyQuery>;
export type BeatVisitDetailQueryResult = Apollo.QueryResult<BeatVisitDetailQuery, BeatVisitDetailQueryVariables>;
export const NewScheduleMutationDocument = gql`
    mutation NewScheduleMutation($date: Date!, $plotCommodityRequirements: [PlotCommodityRequirementInput!]) {
  newSchedule(date: $date, plotCommodityRequirements: $plotCommodityRequirements) {
    schedules {
      ...ScheduleListFrag
    }
  }
}
    ${ScheduleListFragFragmentDoc}`;
export type NewScheduleMutationMutationFn = Apollo.MutationFunction<NewScheduleMutationMutation, NewScheduleMutationMutationVariables>;

/**
 * __useNewScheduleMutationMutation__
 *
 * To run a mutation, you first call `useNewScheduleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewScheduleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newScheduleMutationMutation, { data, loading, error }] = useNewScheduleMutationMutation({
 *   variables: {
 *      date: // value for 'date'
 *      plotCommodityRequirements: // value for 'plotCommodityRequirements'
 *   },
 * });
 */
export function useNewScheduleMutationMutation(baseOptions?: Apollo.MutationHookOptions<NewScheduleMutationMutation, NewScheduleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewScheduleMutationMutation, NewScheduleMutationMutationVariables>(NewScheduleMutationDocument, options);
      }
export type NewScheduleMutationMutationHookResult = ReturnType<typeof useNewScheduleMutationMutation>;
export type NewScheduleMutationMutationResult = Apollo.MutationResult<NewScheduleMutationMutation>;
export type NewScheduleMutationMutationOptions = Apollo.BaseMutationOptions<NewScheduleMutationMutation, NewScheduleMutationMutationVariables>;
export const DeleteScheduleMutationDocument = gql`
    mutation DeleteScheduleMutation($schedules: [Int]) {
  delSchedules(schedules: $schedules) {
    schedules
  }
}
    `;
export type DeleteScheduleMutationMutationFn = Apollo.MutationFunction<DeleteScheduleMutationMutation, DeleteScheduleMutationMutationVariables>;

/**
 * __useDeleteScheduleMutationMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutationMutation, { data, loading, error }] = useDeleteScheduleMutationMutation({
 *   variables: {
 *      schedules: // value for 'schedules'
 *   },
 * });
 */
export function useDeleteScheduleMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutationMutation, DeleteScheduleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutationMutation, DeleteScheduleMutationMutationVariables>(DeleteScheduleMutationDocument, options);
      }
export type DeleteScheduleMutationMutationHookResult = ReturnType<typeof useDeleteScheduleMutationMutation>;
export type DeleteScheduleMutationMutationResult = Apollo.MutationResult<DeleteScheduleMutationMutation>;
export type DeleteScheduleMutationMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutationMutation, DeleteScheduleMutationMutationVariables>;
export const UpdateScheduleMutationDocument = gql`
    mutation UpdateScheduleMutation($schedules: [UpdateScheduleRowInput!]) {
  updateSchedule(schedules: $schedules) {
    schedules {
      transportDetail {
        ...TransportDetailFrag
      }
      ...ScheduleListFrag
    }
  }
}
    ${TransportDetailFragFragmentDoc}
${ScheduleListFragFragmentDoc}`;
export type UpdateScheduleMutationMutationFn = Apollo.MutationFunction<UpdateScheduleMutationMutation, UpdateScheduleMutationMutationVariables>;

/**
 * __useUpdateScheduleMutationMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutationMutation, { data, loading, error }] = useUpdateScheduleMutationMutation({
 *   variables: {
 *      schedules: // value for 'schedules'
 *   },
 * });
 */
export function useUpdateScheduleMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutationMutation, UpdateScheduleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutationMutation, UpdateScheduleMutationMutationVariables>(UpdateScheduleMutationDocument, options);
      }
export type UpdateScheduleMutationMutationHookResult = ReturnType<typeof useUpdateScheduleMutationMutation>;
export type UpdateScheduleMutationMutationResult = Apollo.MutationResult<UpdateScheduleMutationMutation>;
export type UpdateScheduleMutationMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutationMutation, UpdateScheduleMutationMutationVariables>;
export const AddTransportDetailMutationDocument = gql`
    mutation AddTransportDetailMutation($id: Int, $schedule: Int!, $advanceCost: Float, $advancePaidBy: String, $transportCost: Float, $transportPaidBy: String, $rejectionBourneBy: String, $weightApplicable: String, $acceptedDeduction: Float, $remark: String, $pricingDoneOn: String, $standardDeduction: Float!, $gradePrices: [GradePriceInput]) {
  addTransportDetail(
    id: $id
    schedule: $schedule
    advanceCost: $advanceCost
    advancePaidBy: $advancePaidBy
    transportCost: $transportCost
    transportPaidBy: $transportPaidBy
    rejectionBourneBy: $rejectionBourneBy
    weightApplicable: $weightApplicable
    acceptedDeduction: $acceptedDeduction
    gradePrices: $gradePrices
    pricingDoneOn: $pricingDoneOn
    standardDeduction: $standardDeduction
    remark: $remark
  ) {
    detail {
      ...TransportDetailFrag
    }
  }
}
    ${TransportDetailFragFragmentDoc}`;
export type AddTransportDetailMutationMutationFn = Apollo.MutationFunction<AddTransportDetailMutationMutation, AddTransportDetailMutationMutationVariables>;

/**
 * __useAddTransportDetailMutationMutation__
 *
 * To run a mutation, you first call `useAddTransportDetailMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTransportDetailMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTransportDetailMutationMutation, { data, loading, error }] = useAddTransportDetailMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      schedule: // value for 'schedule'
 *      advanceCost: // value for 'advanceCost'
 *      advancePaidBy: // value for 'advancePaidBy'
 *      transportCost: // value for 'transportCost'
 *      transportPaidBy: // value for 'transportPaidBy'
 *      rejectionBourneBy: // value for 'rejectionBourneBy'
 *      weightApplicable: // value for 'weightApplicable'
 *      acceptedDeduction: // value for 'acceptedDeduction'
 *      remark: // value for 'remark'
 *      pricingDoneOn: // value for 'pricingDoneOn'
 *      standardDeduction: // value for 'standardDeduction'
 *      gradePrices: // value for 'gradePrices'
 *   },
 * });
 */
export function useAddTransportDetailMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddTransportDetailMutationMutation, AddTransportDetailMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTransportDetailMutationMutation, AddTransportDetailMutationMutationVariables>(AddTransportDetailMutationDocument, options);
      }
export type AddTransportDetailMutationMutationHookResult = ReturnType<typeof useAddTransportDetailMutationMutation>;
export type AddTransportDetailMutationMutationResult = Apollo.MutationResult<AddTransportDetailMutationMutation>;
export type AddTransportDetailMutationMutationOptions = Apollo.BaseMutationOptions<AddTransportDetailMutationMutation, AddTransportDetailMutationMutationVariables>;
export const GenerateTripMutationDocument = gql`
    mutation GenerateTripMutation($date: Date!, $schedules: [ID], $schedulesProcured: [SchedulesProcuredInput]) {
  generateTrip(
    date: $date
    schedules: $schedules
    schedulesProcured: $schedulesProcured
  ) {
    trips {
      id
      bookings {
        id
        schedule {
          id
          isNotified
        }
      }
    }
  }
}
    `;
export type GenerateTripMutationMutationFn = Apollo.MutationFunction<GenerateTripMutationMutation, GenerateTripMutationMutationVariables>;

/**
 * __useGenerateTripMutationMutation__
 *
 * To run a mutation, you first call `useGenerateTripMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTripMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTripMutationMutation, { data, loading, error }] = useGenerateTripMutationMutation({
 *   variables: {
 *      date: // value for 'date'
 *      schedules: // value for 'schedules'
 *      schedulesProcured: // value for 'schedulesProcured'
 *   },
 * });
 */
export function useGenerateTripMutationMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTripMutationMutation, GenerateTripMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTripMutationMutation, GenerateTripMutationMutationVariables>(GenerateTripMutationDocument, options);
      }
export type GenerateTripMutationMutationHookResult = ReturnType<typeof useGenerateTripMutationMutation>;
export type GenerateTripMutationMutationResult = Apollo.MutationResult<GenerateTripMutationMutation>;
export type GenerateTripMutationMutationOptions = Apollo.BaseMutationOptions<GenerateTripMutationMutation, GenerateTripMutationMutationVariables>;
export const MigratePlotMutationDocument = gql`
    mutation MigratePlotMutation($fromDate: Date!, $toDate: Date!, $plot: Int!) {
  migratePlot(fromDate: $fromDate, toDate: $toDate, plot: $plot) {
    schedules {
      id
      date
    }
  }
}
    `;
export type MigratePlotMutationMutationFn = Apollo.MutationFunction<MigratePlotMutationMutation, MigratePlotMutationMutationVariables>;

/**
 * __useMigratePlotMutationMutation__
 *
 * To run a mutation, you first call `useMigratePlotMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigratePlotMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migratePlotMutationMutation, { data, loading, error }] = useMigratePlotMutationMutation({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      plot: // value for 'plot'
 *   },
 * });
 */
export function useMigratePlotMutationMutation(baseOptions?: Apollo.MutationHookOptions<MigratePlotMutationMutation, MigratePlotMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigratePlotMutationMutation, MigratePlotMutationMutationVariables>(MigratePlotMutationDocument, options);
      }
export type MigratePlotMutationMutationHookResult = ReturnType<typeof useMigratePlotMutationMutation>;
export type MigratePlotMutationMutationResult = Apollo.MutationResult<MigratePlotMutationMutation>;
export type MigratePlotMutationMutationOptions = Apollo.BaseMutationOptions<MigratePlotMutationMutation, MigratePlotMutationMutationVariables>;
export const DelPlotSchedulesMutationDocument = gql`
    mutation DelPlotSchedulesMutation($date: Date!, $plotCommodityId: Int!) {
  delPlotSchedules(date: $date, plotCommodityId: $plotCommodityId) {
    plotCommodityId
  }
}
    `;
export type DelPlotSchedulesMutationMutationFn = Apollo.MutationFunction<DelPlotSchedulesMutationMutation, DelPlotSchedulesMutationMutationVariables>;

/**
 * __useDelPlotSchedulesMutationMutation__
 *
 * To run a mutation, you first call `useDelPlotSchedulesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelPlotSchedulesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delPlotSchedulesMutationMutation, { data, loading, error }] = useDelPlotSchedulesMutationMutation({
 *   variables: {
 *      date: // value for 'date'
 *      plotCommodityId: // value for 'plotCommodityId'
 *   },
 * });
 */
export function useDelPlotSchedulesMutationMutation(baseOptions?: Apollo.MutationHookOptions<DelPlotSchedulesMutationMutation, DelPlotSchedulesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DelPlotSchedulesMutationMutation, DelPlotSchedulesMutationMutationVariables>(DelPlotSchedulesMutationDocument, options);
      }
export type DelPlotSchedulesMutationMutationHookResult = ReturnType<typeof useDelPlotSchedulesMutationMutation>;
export type DelPlotSchedulesMutationMutationResult = Apollo.MutationResult<DelPlotSchedulesMutationMutation>;
export type DelPlotSchedulesMutationMutationOptions = Apollo.BaseMutationOptions<DelPlotSchedulesMutationMutation, DelPlotSchedulesMutationMutationVariables>;
export const AddUpdatePackagingMaterialMutationDocument = gql`
    mutation AddUpdatePackagingMaterialMutation($id: Int, $scheduleId: Int, $pmSupervisorId: Int, $areaInchargeId: Int, $fieldSupervisorId: Int, $packagingMaterialItems: [PackagingMaterialItemInput]) {
  addUpdatePackagingMaterial(
    id: $id
    scheduleId: $scheduleId
    sendWhatsappApproval: false
    pmSupervisorId: $pmSupervisorId
    areaInchargeId: $areaInchargeId
    fieldSupervisorId: $fieldSupervisorId
    packagingMaterialItems: $packagingMaterialItems
  ) {
    packagingMaterial {
      ...PackagingMaterialFrag
    }
  }
}
    ${PackagingMaterialFragFragmentDoc}`;
export type AddUpdatePackagingMaterialMutationMutationFn = Apollo.MutationFunction<AddUpdatePackagingMaterialMutationMutation, AddUpdatePackagingMaterialMutationMutationVariables>;

/**
 * __useAddUpdatePackagingMaterialMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdatePackagingMaterialMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdatePackagingMaterialMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdatePackagingMaterialMutationMutation, { data, loading, error }] = useAddUpdatePackagingMaterialMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduleId: // value for 'scheduleId'
 *      pmSupervisorId: // value for 'pmSupervisorId'
 *      areaInchargeId: // value for 'areaInchargeId'
 *      fieldSupervisorId: // value for 'fieldSupervisorId'
 *      packagingMaterialItems: // value for 'packagingMaterialItems'
 *   },
 * });
 */
export function useAddUpdatePackagingMaterialMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdatePackagingMaterialMutationMutation, AddUpdatePackagingMaterialMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdatePackagingMaterialMutationMutation, AddUpdatePackagingMaterialMutationMutationVariables>(AddUpdatePackagingMaterialMutationDocument, options);
      }
export type AddUpdatePackagingMaterialMutationMutationHookResult = ReturnType<typeof useAddUpdatePackagingMaterialMutationMutation>;
export type AddUpdatePackagingMaterialMutationMutationResult = Apollo.MutationResult<AddUpdatePackagingMaterialMutationMutation>;
export type AddUpdatePackagingMaterialMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdatePackagingMaterialMutationMutation, AddUpdatePackagingMaterialMutationMutationVariables>;
export const SendPackagingMaterialWhatsappApprovalMutationDocument = gql`
    mutation SendPackagingMaterialWhatsappApprovalMutation($departmentId: Int, $packagingMaterialId: Int) {
  sendPackagingMaterialWhatsappApproval(
    departmentId: $departmentId
    packagingMaterialId: $packagingMaterialId
  ) {
    success
  }
}
    `;
export type SendPackagingMaterialWhatsappApprovalMutationMutationFn = Apollo.MutationFunction<SendPackagingMaterialWhatsappApprovalMutationMutation, SendPackagingMaterialWhatsappApprovalMutationMutationVariables>;

/**
 * __useSendPackagingMaterialWhatsappApprovalMutationMutation__
 *
 * To run a mutation, you first call `useSendPackagingMaterialWhatsappApprovalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPackagingMaterialWhatsappApprovalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPackagingMaterialWhatsappApprovalMutationMutation, { data, loading, error }] = useSendPackagingMaterialWhatsappApprovalMutationMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      packagingMaterialId: // value for 'packagingMaterialId'
 *   },
 * });
 */
export function useSendPackagingMaterialWhatsappApprovalMutationMutation(baseOptions?: Apollo.MutationHookOptions<SendPackagingMaterialWhatsappApprovalMutationMutation, SendPackagingMaterialWhatsappApprovalMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPackagingMaterialWhatsappApprovalMutationMutation, SendPackagingMaterialWhatsappApprovalMutationMutationVariables>(SendPackagingMaterialWhatsappApprovalMutationDocument, options);
      }
export type SendPackagingMaterialWhatsappApprovalMutationMutationHookResult = ReturnType<typeof useSendPackagingMaterialWhatsappApprovalMutationMutation>;
export type SendPackagingMaterialWhatsappApprovalMutationMutationResult = Apollo.MutationResult<SendPackagingMaterialWhatsappApprovalMutationMutation>;
export type SendPackagingMaterialWhatsappApprovalMutationMutationOptions = Apollo.BaseMutationOptions<SendPackagingMaterialWhatsappApprovalMutationMutation, SendPackagingMaterialWhatsappApprovalMutationMutationVariables>;
export const ScheduleListDocument = gql`
    query ScheduleList($date: Date!, $filter: ScheduleFilterInput, $query: String, $first: Int, $skip: Int) {
  schedulesForDate(
    date: $date
    filter: $filter
    query: $query
    first: $first
    skip: $skip
  ) {
    ...ScheduleListFrag
  }
}
    ${ScheduleListFragFragmentDoc}`;

/**
 * __useScheduleListQuery__
 *
 * To run a query within a React component, call `useScheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useScheduleListQuery(baseOptions: Apollo.QueryHookOptions<ScheduleListQuery, ScheduleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleListQuery, ScheduleListQueryVariables>(ScheduleListDocument, options);
      }
export function useScheduleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleListQuery, ScheduleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleListQuery, ScheduleListQueryVariables>(ScheduleListDocument, options);
        }
export type ScheduleListQueryHookResult = ReturnType<typeof useScheduleListQuery>;
export type ScheduleListLazyQueryHookResult = ReturnType<typeof useScheduleListLazyQuery>;
export type ScheduleListQueryResult = Apollo.QueryResult<ScheduleListQuery, ScheduleListQueryVariables>;
export const PlotSchedulesDocument = gql`
    query PlotSchedules($plotId: Int!) {
  schedulesForPlot(plotId: $plotId) {
    id
    date
    gatePass
    labourCount
    requiredQuantity
    transportServiceProvider {
      id
      fullName
    }
    aggregator {
      id
      fullName
    }
    plot {
      id
      name
      address {
        id
        village
      }
    }
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    vehicle {
      id
      registrationNumber
    }
  }
}
    `;

/**
 * __usePlotSchedulesQuery__
 *
 * To run a query within a React component, call `usePlotSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlotSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlotSchedulesQuery({
 *   variables: {
 *      plotId: // value for 'plotId'
 *   },
 * });
 */
export function usePlotSchedulesQuery(baseOptions: Apollo.QueryHookOptions<PlotSchedulesQuery, PlotSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlotSchedulesQuery, PlotSchedulesQueryVariables>(PlotSchedulesDocument, options);
      }
export function usePlotSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlotSchedulesQuery, PlotSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlotSchedulesQuery, PlotSchedulesQueryVariables>(PlotSchedulesDocument, options);
        }
export type PlotSchedulesQueryHookResult = ReturnType<typeof usePlotSchedulesQuery>;
export type PlotSchedulesLazyQueryHookResult = ReturnType<typeof usePlotSchedulesLazyQuery>;
export type PlotSchedulesQueryResult = Apollo.QueryResult<PlotSchedulesQuery, PlotSchedulesQueryVariables>;
export const ScheduleTransportDetailDocument = gql`
    query ScheduleTransportDetail($schedule: Int!) {
  transportDetail(schedule: $schedule) {
    ...TransportDetailFrag
  }
}
    ${TransportDetailFragFragmentDoc}`;

/**
 * __useScheduleTransportDetailQuery__
 *
 * To run a query within a React component, call `useScheduleTransportDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTransportDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTransportDetailQuery({
 *   variables: {
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useScheduleTransportDetailQuery(baseOptions: Apollo.QueryHookOptions<ScheduleTransportDetailQuery, ScheduleTransportDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleTransportDetailQuery, ScheduleTransportDetailQueryVariables>(ScheduleTransportDetailDocument, options);
      }
export function useScheduleTransportDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleTransportDetailQuery, ScheduleTransportDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleTransportDetailQuery, ScheduleTransportDetailQueryVariables>(ScheduleTransportDetailDocument, options);
        }
export type ScheduleTransportDetailQueryHookResult = ReturnType<typeof useScheduleTransportDetailQuery>;
export type ScheduleTransportDetailLazyQueryHookResult = ReturnType<typeof useScheduleTransportDetailLazyQuery>;
export type ScheduleTransportDetailQueryResult = Apollo.QueryResult<ScheduleTransportDetailQuery, ScheduleTransportDetailQueryVariables>;
export const AllAgregatorsSelectorDocument = gql`
    query AllAgregatorsSelector($department: ID, $date: Date!, $first: Int, $skip: Int, $query: String) {
  usersByGroup(
    groupName: "Aggregator"
    departmentId: $department
    status: "AV"
    first: $first
    skip: $skip
    query: $query
  ) {
    id
    number
    fullName
    schedulesForDate(date: $date) {
      id
      plotCommodity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllAgregatorsSelectorQuery__
 *
 * To run a query within a React component, call `useAllAgregatorsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAgregatorsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAgregatorsSelectorQuery({
 *   variables: {
 *      department: // value for 'department'
 *      date: // value for 'date'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllAgregatorsSelectorQuery(baseOptions: Apollo.QueryHookOptions<AllAgregatorsSelectorQuery, AllAgregatorsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAgregatorsSelectorQuery, AllAgregatorsSelectorQueryVariables>(AllAgregatorsSelectorDocument, options);
      }
export function useAllAgregatorsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAgregatorsSelectorQuery, AllAgregatorsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAgregatorsSelectorQuery, AllAgregatorsSelectorQueryVariables>(AllAgregatorsSelectorDocument, options);
        }
export type AllAgregatorsSelectorQueryHookResult = ReturnType<typeof useAllAgregatorsSelectorQuery>;
export type AllAgregatorsSelectorLazyQueryHookResult = ReturnType<typeof useAllAgregatorsSelectorLazyQuery>;
export type AllAgregatorsSelectorQueryResult = Apollo.QueryResult<AllAgregatorsSelectorQuery, AllAgregatorsSelectorQueryVariables>;
export const AllTransportServiceProvidersSelectorDocument = gql`
    query AllTransportServiceProvidersSelector($department: ID, $date: Date!, $first: Int, $skip: Int, $query: String) {
  usersByGroup(
    groupName: "Transport Service Provider"
    departmentId: $department
    status: "AV"
    first: $first
    skip: $skip
    query: $query
  ) {
    id
    number
    fullName
    schedulesForDate(date: $date) {
      id
      plotCommodity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllTransportServiceProvidersSelectorQuery__
 *
 * To run a query within a React component, call `useAllTransportServiceProvidersSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTransportServiceProvidersSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTransportServiceProvidersSelectorQuery({
 *   variables: {
 *      department: // value for 'department'
 *      date: // value for 'date'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllTransportServiceProvidersSelectorQuery(baseOptions: Apollo.QueryHookOptions<AllTransportServiceProvidersSelectorQuery, AllTransportServiceProvidersSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTransportServiceProvidersSelectorQuery, AllTransportServiceProvidersSelectorQueryVariables>(AllTransportServiceProvidersSelectorDocument, options);
      }
export function useAllTransportServiceProvidersSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTransportServiceProvidersSelectorQuery, AllTransportServiceProvidersSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTransportServiceProvidersSelectorQuery, AllTransportServiceProvidersSelectorQueryVariables>(AllTransportServiceProvidersSelectorDocument, options);
        }
export type AllTransportServiceProvidersSelectorQueryHookResult = ReturnType<typeof useAllTransportServiceProvidersSelectorQuery>;
export type AllTransportServiceProvidersSelectorLazyQueryHookResult = ReturnType<typeof useAllTransportServiceProvidersSelectorLazyQuery>;
export type AllTransportServiceProvidersSelectorQueryResult = Apollo.QueryResult<AllTransportServiceProvidersSelectorQuery, AllTransportServiceProvidersSelectorQueryVariables>;
export const ScheduleListSummaryDocument = gql`
    query ScheduleListSummary($date: Date!, $query: String, $filter: ScheduleFilterInput, $first: Int, $skip: Int) {
  schedulesForDateSummary(
    date: $date
    query: $query
    filter: $filter
    first: $first
    skip: $skip
  ) {
    plots
    labours
    count
    vehicles
    totalSkuCount
    totalUomQuantity
    aggregators
    transportServiceProviders
  }
}
    `;

/**
 * __useScheduleListSummaryQuery__
 *
 * To run a query within a React component, call `useScheduleListSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleListSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleListSummaryQuery({
 *   variables: {
 *      date: // value for 'date'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useScheduleListSummaryQuery(baseOptions: Apollo.QueryHookOptions<ScheduleListSummaryQuery, ScheduleListSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleListSummaryQuery, ScheduleListSummaryQueryVariables>(ScheduleListSummaryDocument, options);
      }
export function useScheduleListSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleListSummaryQuery, ScheduleListSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleListSummaryQuery, ScheduleListSummaryQueryVariables>(ScheduleListSummaryDocument, options);
        }
export type ScheduleListSummaryQueryHookResult = ReturnType<typeof useScheduleListSummaryQuery>;
export type ScheduleListSummaryLazyQueryHookResult = ReturnType<typeof useScheduleListSummaryLazyQuery>;
export type ScheduleListSummaryQueryResult = Apollo.QueryResult<ScheduleListSummaryQuery, ScheduleListSummaryQueryVariables>;
export const ShedulingVehiclesDocument = gql`
    query ShedulingVehicles($date: Date!, $first: Int, $skip: Int, $query: String) {
  allVehicles(first: $first, skip: $skip, query: $query) {
    id
    registrationNumber
    vehicleType {
      id
      category
      name
      capacity
      capacityUnit {
        id
        name
        codename
      }
    }
    schedulesForDate(date: $date) {
      id
      plotCommodity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useShedulingVehiclesQuery__
 *
 * To run a query within a React component, call `useShedulingVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShedulingVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShedulingVehiclesQuery({
 *   variables: {
 *      date: // value for 'date'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useShedulingVehiclesQuery(baseOptions: Apollo.QueryHookOptions<ShedulingVehiclesQuery, ShedulingVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShedulingVehiclesQuery, ShedulingVehiclesQueryVariables>(ShedulingVehiclesDocument, options);
      }
export function useShedulingVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShedulingVehiclesQuery, ShedulingVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShedulingVehiclesQuery, ShedulingVehiclesQueryVariables>(ShedulingVehiclesDocument, options);
        }
export type ShedulingVehiclesQueryHookResult = ReturnType<typeof useShedulingVehiclesQuery>;
export type ShedulingVehiclesLazyQueryHookResult = ReturnType<typeof useShedulingVehiclesLazyQuery>;
export type ShedulingVehiclesQueryResult = Apollo.QueryResult<ShedulingVehiclesQuery, ShedulingVehiclesQueryVariables>;
export const PreTripGenerateDocument = gql`
    query PreTripGenerate($date: Date, $scheduleIds: [ID]) {
  preTripGenerate(date: $date, scheduleIds: $scheduleIds) {
    vehicleNo
    bookingCount
    suppliers {
      name
      village
      crop
      sku
      skuCount
    }
  }
}
    `;

/**
 * __usePreTripGenerateQuery__
 *
 * To run a query within a React component, call `usePreTripGenerateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreTripGenerateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreTripGenerateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      scheduleIds: // value for 'scheduleIds'
 *   },
 * });
 */
export function usePreTripGenerateQuery(baseOptions?: Apollo.QueryHookOptions<PreTripGenerateQuery, PreTripGenerateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreTripGenerateQuery, PreTripGenerateQueryVariables>(PreTripGenerateDocument, options);
      }
export function usePreTripGenerateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreTripGenerateQuery, PreTripGenerateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreTripGenerateQuery, PreTripGenerateQueryVariables>(PreTripGenerateDocument, options);
        }
export type PreTripGenerateQueryHookResult = ReturnType<typeof usePreTripGenerateQuery>;
export type PreTripGenerateLazyQueryHookResult = ReturnType<typeof usePreTripGenerateLazyQuery>;
export type PreTripGenerateQueryResult = Apollo.QueryResult<PreTripGenerateQuery, PreTripGenerateQueryVariables>;
export const PackagingMaterialQueryDocument = gql`
    query PackagingMaterialQuery($id: Int!) {
  packagingMaterial(id: $id) {
    id
    createdAt
    schedule {
      gatePass
      booking {
        id
        status
      }
      vehicle {
        id
        registrationNumber
      }
      gradePrices {
        id
        price
      }
    }
    fieldSupervisorName {
      id
      firstName
      lastName
      fullName
    }
    pmSupervisorName {
      id
      firstName
      lastName
      fullName
    }
    areaInchargeName {
      id
      firstName
      lastName
      fullName
    }
    plotVisitorName {
      id
      firstName
      lastName
      fullName
    }
    supplierType
    packagingMaterialItems {
      id
      skuType {
        id
        name
        selfWeight
        capacity
      }
      dispatchedBoxCount
      harvestedBoxCount
      receivedQuantity
      mismatchBoxCount
      recievedTareWt
      harvestedGrossWt
      harvestedNetWt
      remark
    }
    combinedPackagingMaterialItems {
      skuType {
        id
        name
        selfWeight
      }
      whatsappApproval
      dispatchedBoxCount
      dispatchedBoxWt
      harvestedBoxCount
      harvestedBoxWt
      remark
      fourHand
      fiveHand
      sixHand
      sevenEightHand
      cluster
    }
    finalWt
    leafWt
    fruitNetWt
    totalReceivedTareWt
    weightSlip
    wasteageWt
    totalDispatchedBoxWt
    fruitWt
    fruitAmt
    wastageAmt
    stickAmt
    deductionAmt
    fruitAndWastageWt
    stickWtPercent
    stickWt
    totalHarvestWt
    deductionWt
    deductionWtPercent
    totalHarvestQuantity
    totalHarvestedBoxWt
    totalQuantity
    totalReceivedQuantity
    netWeightAfterDeduction
    remark
    totalAmt
    avgRate
    finalAmt
    attachments {
      id
      mediaType
      url
    }
  }
}
    `;

/**
 * __usePackagingMaterialQueryQuery__
 *
 * To run a query within a React component, call `usePackagingMaterialQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingMaterialQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingMaterialQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackagingMaterialQueryQuery(baseOptions: Apollo.QueryHookOptions<PackagingMaterialQueryQuery, PackagingMaterialQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingMaterialQueryQuery, PackagingMaterialQueryQueryVariables>(PackagingMaterialQueryDocument, options);
      }
export function usePackagingMaterialQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingMaterialQueryQuery, PackagingMaterialQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingMaterialQueryQuery, PackagingMaterialQueryQueryVariables>(PackagingMaterialQueryDocument, options);
        }
export type PackagingMaterialQueryQueryHookResult = ReturnType<typeof usePackagingMaterialQueryQuery>;
export type PackagingMaterialQueryLazyQueryHookResult = ReturnType<typeof usePackagingMaterialQueryLazyQuery>;
export type PackagingMaterialQueryQueryResult = Apollo.QueryResult<PackagingMaterialQueryQuery, PackagingMaterialQueryQueryVariables>;
export const AllDepartmentSelectorDocument = gql`
    query AllDepartmentSelector {
  allDepartments {
    id
    name
    departmentType
  }
}
    `;

/**
 * __useAllDepartmentSelectorQuery__
 *
 * To run a query within a React component, call `useAllDepartmentSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDepartmentSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDepartmentSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDepartmentSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllDepartmentSelectorQuery, AllDepartmentSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDepartmentSelectorQuery, AllDepartmentSelectorQueryVariables>(AllDepartmentSelectorDocument, options);
      }
export function useAllDepartmentSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDepartmentSelectorQuery, AllDepartmentSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDepartmentSelectorQuery, AllDepartmentSelectorQueryVariables>(AllDepartmentSelectorDocument, options);
        }
export type AllDepartmentSelectorQueryHookResult = ReturnType<typeof useAllDepartmentSelectorQuery>;
export type AllDepartmentSelectorLazyQueryHookResult = ReturnType<typeof useAllDepartmentSelectorLazyQuery>;
export type AllDepartmentSelectorQueryResult = Apollo.QueryResult<AllDepartmentSelectorQuery, AllDepartmentSelectorQueryVariables>;
export const AllGroupsSelectorDocument = gql`
    query allGroupsSelector($category: String, $filter: AllGroupsFilterInput) {
  allGroups(category: $category, filter: $filter) {
    id
    name
    category {
      id
      name
      codename
    }
  }
}
    `;

/**
 * __useAllGroupsSelectorQuery__
 *
 * To run a query within a React component, call `useAllGroupsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupsSelectorQuery({
 *   variables: {
 *      category: // value for 'category'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllGroupsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllGroupsSelectorQuery, AllGroupsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGroupsSelectorQuery, AllGroupsSelectorQueryVariables>(AllGroupsSelectorDocument, options);
      }
export function useAllGroupsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGroupsSelectorQuery, AllGroupsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGroupsSelectorQuery, AllGroupsSelectorQueryVariables>(AllGroupsSelectorDocument, options);
        }
export type AllGroupsSelectorQueryHookResult = ReturnType<typeof useAllGroupsSelectorQuery>;
export type AllGroupsSelectorLazyQueryHookResult = ReturnType<typeof useAllGroupsSelectorLazyQuery>;
export type AllGroupsSelectorQueryResult = Apollo.QueryResult<AllGroupsSelectorQuery, AllGroupsSelectorQueryVariables>;
export const AllVarietyGroupsSelectorDocument = gql`
    query allVarietyGroupsSelector($departmentId: Int, $query: String, $first: Int) {
  allVarietyGroups(departmentId: $departmentId, query: $query, first: $first) {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllVarietyGroupsSelectorQuery__
 *
 * To run a query within a React component, call `useAllVarietyGroupsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVarietyGroupsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVarietyGroupsSelectorQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllVarietyGroupsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllVarietyGroupsSelectorQuery, AllVarietyGroupsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVarietyGroupsSelectorQuery, AllVarietyGroupsSelectorQueryVariables>(AllVarietyGroupsSelectorDocument, options);
      }
export function useAllVarietyGroupsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVarietyGroupsSelectorQuery, AllVarietyGroupsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVarietyGroupsSelectorQuery, AllVarietyGroupsSelectorQueryVariables>(AllVarietyGroupsSelectorDocument, options);
        }
export type AllVarietyGroupsSelectorQueryHookResult = ReturnType<typeof useAllVarietyGroupsSelectorQuery>;
export type AllVarietyGroupsSelectorLazyQueryHookResult = ReturnType<typeof useAllVarietyGroupsSelectorLazyQuery>;
export type AllVarietyGroupsSelectorQueryResult = Apollo.QueryResult<AllVarietyGroupsSelectorQuery, AllVarietyGroupsSelectorQueryVariables>;
export const AllPermissionsSelectorDocument = gql`
    query allPermissionsSelector {
  allPermissions {
    id
    name
  }
}
    `;

/**
 * __useAllPermissionsSelectorQuery__
 *
 * To run a query within a React component, call `useAllPermissionsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPermissionsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPermissionsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPermissionsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllPermissionsSelectorQuery, AllPermissionsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPermissionsSelectorQuery, AllPermissionsSelectorQueryVariables>(AllPermissionsSelectorDocument, options);
      }
export function useAllPermissionsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPermissionsSelectorQuery, AllPermissionsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPermissionsSelectorQuery, AllPermissionsSelectorQueryVariables>(AllPermissionsSelectorDocument, options);
        }
export type AllPermissionsSelectorQueryHookResult = ReturnType<typeof useAllPermissionsSelectorQuery>;
export type AllPermissionsSelectorLazyQueryHookResult = ReturnType<typeof useAllPermissionsSelectorLazyQuery>;
export type AllPermissionsSelectorQueryResult = Apollo.QueryResult<AllPermissionsSelectorQuery, AllPermissionsSelectorQueryVariables>;
export const AllVarietiesSelectorDocument = gql`
    query allVarietiesSelector($includeCommodity: Boolean!) {
  allVarieties {
    id
    name
    commodity @include(if: $includeCommodity) {
      id
      name
    }
  }
}
    `;

/**
 * __useAllVarietiesSelectorQuery__
 *
 * To run a query within a React component, call `useAllVarietiesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVarietiesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVarietiesSelectorQuery({
 *   variables: {
 *      includeCommodity: // value for 'includeCommodity'
 *   },
 * });
 */
export function useAllVarietiesSelectorQuery(baseOptions: Apollo.QueryHookOptions<AllVarietiesSelectorQuery, AllVarietiesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVarietiesSelectorQuery, AllVarietiesSelectorQueryVariables>(AllVarietiesSelectorDocument, options);
      }
export function useAllVarietiesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVarietiesSelectorQuery, AllVarietiesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVarietiesSelectorQuery, AllVarietiesSelectorQueryVariables>(AllVarietiesSelectorDocument, options);
        }
export type AllVarietiesSelectorQueryHookResult = ReturnType<typeof useAllVarietiesSelectorQuery>;
export type AllVarietiesSelectorLazyQueryHookResult = ReturnType<typeof useAllVarietiesSelectorLazyQuery>;
export type AllVarietiesSelectorQueryResult = Apollo.QueryResult<AllVarietiesSelectorQuery, AllVarietiesSelectorQueryVariables>;
export const AllCommoditiesSelectorDocument = gql`
    query allCommoditiesSelector {
  allCommodities {
    id
    name
  }
}
    `;

/**
 * __useAllCommoditiesSelectorQuery__
 *
 * To run a query within a React component, call `useAllCommoditiesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommoditiesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommoditiesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCommoditiesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllCommoditiesSelectorQuery, AllCommoditiesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommoditiesSelectorQuery, AllCommoditiesSelectorQueryVariables>(AllCommoditiesSelectorDocument, options);
      }
export function useAllCommoditiesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommoditiesSelectorQuery, AllCommoditiesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommoditiesSelectorQuery, AllCommoditiesSelectorQueryVariables>(AllCommoditiesSelectorDocument, options);
        }
export type AllCommoditiesSelectorQueryHookResult = ReturnType<typeof useAllCommoditiesSelectorQuery>;
export type AllCommoditiesSelectorLazyQueryHookResult = ReturnType<typeof useAllCommoditiesSelectorLazyQuery>;
export type AllCommoditiesSelectorQueryResult = Apollo.QueryResult<AllCommoditiesSelectorQuery, AllCommoditiesSelectorQueryVariables>;
export const AllCompaniesSelectorDocument = gql`
    query allCompaniesSelector($id: Int) {
  allCompanies(departmentId: $id) {
    id
    kind
    name
    displayName
    codename
  }
}
    `;

/**
 * __useAllCompaniesSelectorQuery__
 *
 * To run a query within a React component, call `useAllCompaniesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesSelectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllCompaniesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesSelectorQuery, AllCompaniesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesSelectorQuery, AllCompaniesSelectorQueryVariables>(AllCompaniesSelectorDocument, options);
      }
export function useAllCompaniesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesSelectorQuery, AllCompaniesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesSelectorQuery, AllCompaniesSelectorQueryVariables>(AllCompaniesSelectorDocument, options);
        }
export type AllCompaniesSelectorQueryHookResult = ReturnType<typeof useAllCompaniesSelectorQuery>;
export type AllCompaniesSelectorLazyQueryHookResult = ReturnType<typeof useAllCompaniesSelectorLazyQuery>;
export type AllCompaniesSelectorQueryResult = Apollo.QueryResult<AllCompaniesSelectorQuery, AllCompaniesSelectorQueryVariables>;
export const AllHarvestGradesSelectorDocument = gql`
    query allHarvestGradesSelector($id: Int) {
  harvestGradesForVariety(variety: $id) {
    id
    name
    specifications
  }
}
    `;

/**
 * __useAllHarvestGradesSelectorQuery__
 *
 * To run a query within a React component, call `useAllHarvestGradesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHarvestGradesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHarvestGradesSelectorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllHarvestGradesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllHarvestGradesSelectorQuery, AllHarvestGradesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllHarvestGradesSelectorQuery, AllHarvestGradesSelectorQueryVariables>(AllHarvestGradesSelectorDocument, options);
      }
export function useAllHarvestGradesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllHarvestGradesSelectorQuery, AllHarvestGradesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllHarvestGradesSelectorQuery, AllHarvestGradesSelectorQueryVariables>(AllHarvestGradesSelectorDocument, options);
        }
export type AllHarvestGradesSelectorQueryHookResult = ReturnType<typeof useAllHarvestGradesSelectorQuery>;
export type AllHarvestGradesSelectorLazyQueryHookResult = ReturnType<typeof useAllHarvestGradesSelectorLazyQuery>;
export type AllHarvestGradesSelectorQueryResult = Apollo.QueryResult<AllHarvestGradesSelectorQuery, AllHarvestGradesSelectorQueryVariables>;
export const AllSkusSelectorDocument = gql`
    query allSkusSelector($filter: SKUTypeFilterInput) {
  allSkuTypes(filter: $filter) {
    id
    name
    capacity
    selfWeight
    capacityUnit {
      id
      name
      codename
    }
  }
}
    `;

/**
 * __useAllSkusSelectorQuery__
 *
 * To run a query within a React component, call `useAllSkusSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSkusSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSkusSelectorQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllSkusSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSkusSelectorQuery, AllSkusSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSkusSelectorQuery, AllSkusSelectorQueryVariables>(AllSkusSelectorDocument, options);
      }
export function useAllSkusSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSkusSelectorQuery, AllSkusSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSkusSelectorQuery, AllSkusSelectorQueryVariables>(AllSkusSelectorDocument, options);
        }
export type AllSkusSelectorQueryHookResult = ReturnType<typeof useAllSkusSelectorQuery>;
export type AllSkusSelectorLazyQueryHookResult = ReturnType<typeof useAllSkusSelectorLazyQuery>;
export type AllSkusSelectorQueryResult = Apollo.QueryResult<AllSkusSelectorQuery, AllSkusSelectorQueryVariables>;
export const AllSoilTypesSelectorDocument = gql`
    query allSoilTypesSelector {
  allSoilTypes {
    id
    name
  }
}
    `;

/**
 * __useAllSoilTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllSoilTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSoilTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSoilTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSoilTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSoilTypesSelectorQuery, AllSoilTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSoilTypesSelectorQuery, AllSoilTypesSelectorQueryVariables>(AllSoilTypesSelectorDocument, options);
      }
export function useAllSoilTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSoilTypesSelectorQuery, AllSoilTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSoilTypesSelectorQuery, AllSoilTypesSelectorQueryVariables>(AllSoilTypesSelectorDocument, options);
        }
export type AllSoilTypesSelectorQueryHookResult = ReturnType<typeof useAllSoilTypesSelectorQuery>;
export type AllSoilTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllSoilTypesSelectorLazyQuery>;
export type AllSoilTypesSelectorQueryResult = Apollo.QueryResult<AllSoilTypesSelectorQuery, AllSoilTypesSelectorQueryVariables>;
export const AllTimeSlotsSelectorDocument = gql`
    query allTimeSlotsSelector {
  allTimeSlots {
    id
    fromTime
    toTime
    name
  }
}
    `;

/**
 * __useAllTimeSlotsSelectorQuery__
 *
 * To run a query within a React component, call `useAllTimeSlotsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTimeSlotsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTimeSlotsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTimeSlotsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllTimeSlotsSelectorQuery, AllTimeSlotsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTimeSlotsSelectorQuery, AllTimeSlotsSelectorQueryVariables>(AllTimeSlotsSelectorDocument, options);
      }
export function useAllTimeSlotsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTimeSlotsSelectorQuery, AllTimeSlotsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTimeSlotsSelectorQuery, AllTimeSlotsSelectorQueryVariables>(AllTimeSlotsSelectorDocument, options);
        }
export type AllTimeSlotsSelectorQueryHookResult = ReturnType<typeof useAllTimeSlotsSelectorQuery>;
export type AllTimeSlotsSelectorLazyQueryHookResult = ReturnType<typeof useAllTimeSlotsSelectorLazyQuery>;
export type AllTimeSlotsSelectorQueryResult = Apollo.QueryResult<AllTimeSlotsSelectorQuery, AllTimeSlotsSelectorQueryVariables>;
export const AllSiUnitsSelectorDocument = gql`
    query allSiUnitsSelector {
  allSiUnits {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllSiUnitsSelectorQuery__
 *
 * To run a query within a React component, call `useAllSiUnitsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSiUnitsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSiUnitsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSiUnitsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSiUnitsSelectorQuery, AllSiUnitsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSiUnitsSelectorQuery, AllSiUnitsSelectorQueryVariables>(AllSiUnitsSelectorDocument, options);
      }
export function useAllSiUnitsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSiUnitsSelectorQuery, AllSiUnitsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSiUnitsSelectorQuery, AllSiUnitsSelectorQueryVariables>(AllSiUnitsSelectorDocument, options);
        }
export type AllSiUnitsSelectorQueryHookResult = ReturnType<typeof useAllSiUnitsSelectorQuery>;
export type AllSiUnitsSelectorLazyQueryHookResult = ReturnType<typeof useAllSiUnitsSelectorLazyQuery>;
export type AllSiUnitsSelectorQueryResult = Apollo.QueryResult<AllSiUnitsSelectorQuery, AllSiUnitsSelectorQueryVariables>;
export const AllCertificationTypesSelectorDocument = gql`
    query allCertificationTypesSelector {
  allCertificationTypes {
    id
    name
  }
}
    `;

/**
 * __useAllCertificationTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllCertificationTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCertificationTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCertificationTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCertificationTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllCertificationTypesSelectorQuery, AllCertificationTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCertificationTypesSelectorQuery, AllCertificationTypesSelectorQueryVariables>(AllCertificationTypesSelectorDocument, options);
      }
export function useAllCertificationTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCertificationTypesSelectorQuery, AllCertificationTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCertificationTypesSelectorQuery, AllCertificationTypesSelectorQueryVariables>(AllCertificationTypesSelectorDocument, options);
        }
export type AllCertificationTypesSelectorQueryHookResult = ReturnType<typeof useAllCertificationTypesSelectorQuery>;
export type AllCertificationTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllCertificationTypesSelectorLazyQuery>;
export type AllCertificationTypesSelectorQueryResult = Apollo.QueryResult<AllCertificationTypesSelectorQuery, AllCertificationTypesSelectorQueryVariables>;
export const AllDepotsSelectorDocument = gql`
    query allDepotsSelector {
  allDepots {
    id
    name
  }
}
    `;

/**
 * __useAllDepotsSelectorQuery__
 *
 * To run a query within a React component, call `useAllDepotsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDepotsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDepotsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDepotsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllDepotsSelectorQuery, AllDepotsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDepotsSelectorQuery, AllDepotsSelectorQueryVariables>(AllDepotsSelectorDocument, options);
      }
export function useAllDepotsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDepotsSelectorQuery, AllDepotsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDepotsSelectorQuery, AllDepotsSelectorQueryVariables>(AllDepotsSelectorDocument, options);
        }
export type AllDepotsSelectorQueryHookResult = ReturnType<typeof useAllDepotsSelectorQuery>;
export type AllDepotsSelectorLazyQueryHookResult = ReturnType<typeof useAllDepotsSelectorLazyQuery>;
export type AllDepotsSelectorQueryResult = Apollo.QueryResult<AllDepotsSelectorQuery, AllDepotsSelectorQueryVariables>;
export const AllVehicleTypesSelectorDocument = gql`
    query allVehicleTypesSelector {
  allVehicleTypes {
    id
    name
    category
  }
}
    `;

/**
 * __useAllVehicleTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllVehicleTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehicleTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehicleTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVehicleTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllVehicleTypesSelectorQuery, AllVehicleTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehicleTypesSelectorQuery, AllVehicleTypesSelectorQueryVariables>(AllVehicleTypesSelectorDocument, options);
      }
export function useAllVehicleTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehicleTypesSelectorQuery, AllVehicleTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehicleTypesSelectorQuery, AllVehicleTypesSelectorQueryVariables>(AllVehicleTypesSelectorDocument, options);
        }
export type AllVehicleTypesSelectorQueryHookResult = ReturnType<typeof useAllVehicleTypesSelectorQuery>;
export type AllVehicleTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllVehicleTypesSelectorLazyQuery>;
export type AllVehicleTypesSelectorQueryResult = Apollo.QueryResult<AllVehicleTypesSelectorQuery, AllVehicleTypesSelectorQueryVariables>;
export const AllVehicleKindsSelectorDocument = gql`
    query allVehicleKindsSelector {
  allVehicleKind {
    id
    name
  }
}
    `;

/**
 * __useAllVehicleKindsSelectorQuery__
 *
 * To run a query within a React component, call `useAllVehicleKindsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehicleKindsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehicleKindsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVehicleKindsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllVehicleKindsSelectorQuery, AllVehicleKindsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehicleKindsSelectorQuery, AllVehicleKindsSelectorQueryVariables>(AllVehicleKindsSelectorDocument, options);
      }
export function useAllVehicleKindsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehicleKindsSelectorQuery, AllVehicleKindsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehicleKindsSelectorQuery, AllVehicleKindsSelectorQueryVariables>(AllVehicleKindsSelectorDocument, options);
        }
export type AllVehicleKindsSelectorQueryHookResult = ReturnType<typeof useAllVehicleKindsSelectorQuery>;
export type AllVehicleKindsSelectorLazyQueryHookResult = ReturnType<typeof useAllVehicleKindsSelectorLazyQuery>;
export type AllVehicleKindsSelectorQueryResult = Apollo.QueryResult<AllVehicleKindsSelectorQuery, AllVehicleKindsSelectorQueryVariables>;
export const AllBanksSelectorDocument = gql`
    query allBanksSelector {
  allBanks {
    id
    codename
    name
  }
}
    `;

/**
 * __useAllBanksSelectorQuery__
 *
 * To run a query within a React component, call `useAllBanksSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBanksSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBanksSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBanksSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllBanksSelectorQuery, AllBanksSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBanksSelectorQuery, AllBanksSelectorQueryVariables>(AllBanksSelectorDocument, options);
      }
export function useAllBanksSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBanksSelectorQuery, AllBanksSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBanksSelectorQuery, AllBanksSelectorQueryVariables>(AllBanksSelectorDocument, options);
        }
export type AllBanksSelectorQueryHookResult = ReturnType<typeof useAllBanksSelectorQuery>;
export type AllBanksSelectorLazyQueryHookResult = ReturnType<typeof useAllBanksSelectorLazyQuery>;
export type AllBanksSelectorQueryResult = Apollo.QueryResult<AllBanksSelectorQuery, AllBanksSelectorQueryVariables>;
export const AllKycTypesSelectorDocument = gql`
    query allKycTypesSelector {
  allKycTypes {
    id
    name
  }
}
    `;

/**
 * __useAllKycTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllKycTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKycTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKycTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllKycTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllKycTypesSelectorQuery, AllKycTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllKycTypesSelectorQuery, AllKycTypesSelectorQueryVariables>(AllKycTypesSelectorDocument, options);
      }
export function useAllKycTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllKycTypesSelectorQuery, AllKycTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllKycTypesSelectorQuery, AllKycTypesSelectorQueryVariables>(AllKycTypesSelectorDocument, options);
        }
export type AllKycTypesSelectorQueryHookResult = ReturnType<typeof useAllKycTypesSelectorQuery>;
export type AllKycTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllKycTypesSelectorLazyQuery>;
export type AllKycTypesSelectorQueryResult = Apollo.QueryResult<AllKycTypesSelectorQuery, AllKycTypesSelectorQueryVariables>;
export const AllUsersByGroupSelectorDocument = gql`
    query allUsersByGroupSelector($group: String, $first: Int, $skip: Int, $query: String, $departmentId: ID, $filter: UsersByGroupFilterInput) {
  usersByGroup(
    groupName: $group
    first: $first
    skip: $skip
    query: $query
    departmentId: $departmentId
    filter: $filter
  ) {
    id
    fullName
    number
  }
}
    `;

/**
 * __useAllUsersByGroupSelectorQuery__
 *
 * To run a query within a React component, call `useAllUsersByGroupSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersByGroupSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersByGroupSelectorQuery({
 *   variables: {
 *      group: // value for 'group'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      departmentId: // value for 'departmentId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllUsersByGroupSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersByGroupSelectorQuery, AllUsersByGroupSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersByGroupSelectorQuery, AllUsersByGroupSelectorQueryVariables>(AllUsersByGroupSelectorDocument, options);
      }
export function useAllUsersByGroupSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersByGroupSelectorQuery, AllUsersByGroupSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersByGroupSelectorQuery, AllUsersByGroupSelectorQueryVariables>(AllUsersByGroupSelectorDocument, options);
        }
export type AllUsersByGroupSelectorQueryHookResult = ReturnType<typeof useAllUsersByGroupSelectorQuery>;
export type AllUsersByGroupSelectorLazyQueryHookResult = ReturnType<typeof useAllUsersByGroupSelectorLazyQuery>;
export type AllUsersByGroupSelectorQueryResult = Apollo.QueryResult<AllUsersByGroupSelectorQuery, AllUsersByGroupSelectorQueryVariables>;
export const AllMarketsSelectorDocument = gql`
    query allMarketsSelector {
  allMarkets {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllMarketsSelectorQuery__
 *
 * To run a query within a React component, call `useAllMarketsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMarketsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMarketsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMarketsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllMarketsSelectorQuery, AllMarketsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMarketsSelectorQuery, AllMarketsSelectorQueryVariables>(AllMarketsSelectorDocument, options);
      }
export function useAllMarketsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMarketsSelectorQuery, AllMarketsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMarketsSelectorQuery, AllMarketsSelectorQueryVariables>(AllMarketsSelectorDocument, options);
        }
export type AllMarketsSelectorQueryHookResult = ReturnType<typeof useAllMarketsSelectorQuery>;
export type AllMarketsSelectorLazyQueryHookResult = ReturnType<typeof useAllMarketsSelectorLazyQuery>;
export type AllMarketsSelectorQueryResult = Apollo.QueryResult<AllMarketsSelectorQuery, AllMarketsSelectorQueryVariables>;
export const AllVehiclesSelectorDocument = gql`
    query allVehiclesSelector {
  allVehicles {
    id
    registrationNumber
    vehicleType {
      id
      category
      name
      capacity
      capacityUnit {
        id
        name
        codename
      }
    }
  }
}
    `;

/**
 * __useAllVehiclesSelectorQuery__
 *
 * To run a query within a React component, call `useAllVehiclesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehiclesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehiclesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllVehiclesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllVehiclesSelectorQuery, AllVehiclesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehiclesSelectorQuery, AllVehiclesSelectorQueryVariables>(AllVehiclesSelectorDocument, options);
      }
export function useAllVehiclesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehiclesSelectorQuery, AllVehiclesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehiclesSelectorQuery, AllVehiclesSelectorQueryVariables>(AllVehiclesSelectorDocument, options);
        }
export type AllVehiclesSelectorQueryHookResult = ReturnType<typeof useAllVehiclesSelectorQuery>;
export type AllVehiclesSelectorLazyQueryHookResult = ReturnType<typeof useAllVehiclesSelectorLazyQuery>;
export type AllVehiclesSelectorQueryResult = Apollo.QueryResult<AllVehiclesSelectorQuery, AllVehiclesSelectorQueryVariables>;
export const AllSkuCategoriesSelectorDocument = gql`
    query allSkuCategoriesSelector {
  allSkuCategories {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllSkuCategoriesSelectorQuery__
 *
 * To run a query within a React component, call `useAllSkuCategoriesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSkuCategoriesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSkuCategoriesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSkuCategoriesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSkuCategoriesSelectorQuery, AllSkuCategoriesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSkuCategoriesSelectorQuery, AllSkuCategoriesSelectorQueryVariables>(AllSkuCategoriesSelectorDocument, options);
      }
export function useAllSkuCategoriesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSkuCategoriesSelectorQuery, AllSkuCategoriesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSkuCategoriesSelectorQuery, AllSkuCategoriesSelectorQueryVariables>(AllSkuCategoriesSelectorDocument, options);
        }
export type AllSkuCategoriesSelectorQueryHookResult = ReturnType<typeof useAllSkuCategoriesSelectorQuery>;
export type AllSkuCategoriesSelectorLazyQueryHookResult = ReturnType<typeof useAllSkuCategoriesSelectorLazyQuery>;
export type AllSkuCategoriesSelectorQueryResult = Apollo.QueryResult<AllSkuCategoriesSelectorQuery, AllSkuCategoriesSelectorQueryVariables>;
export const AllReferenceGradesSelectorDocument = gql`
    query allReferenceGradesSelector {
  referenceGrades {
    id
    name
    specifications
  }
}
    `;

/**
 * __useAllReferenceGradesSelectorQuery__
 *
 * To run a query within a React component, call `useAllReferenceGradesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReferenceGradesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReferenceGradesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReferenceGradesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllReferenceGradesSelectorQuery, AllReferenceGradesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReferenceGradesSelectorQuery, AllReferenceGradesSelectorQueryVariables>(AllReferenceGradesSelectorDocument, options);
      }
export function useAllReferenceGradesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReferenceGradesSelectorQuery, AllReferenceGradesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReferenceGradesSelectorQuery, AllReferenceGradesSelectorQueryVariables>(AllReferenceGradesSelectorDocument, options);
        }
export type AllReferenceGradesSelectorQueryHookResult = ReturnType<typeof useAllReferenceGradesSelectorQuery>;
export type AllReferenceGradesSelectorLazyQueryHookResult = ReturnType<typeof useAllReferenceGradesSelectorLazyQuery>;
export type AllReferenceGradesSelectorQueryResult = Apollo.QueryResult<AllReferenceGradesSelectorQuery, AllReferenceGradesSelectorQueryVariables>;
export const AllUnloadingTeamsSelectorDocument = gql`
    query allUnloadingTeamsSelector {
  allUnloadingTeams {
    id
    name
    contact
    codename
  }
}
    `;

/**
 * __useAllUnloadingTeamsSelectorQuery__
 *
 * To run a query within a React component, call `useAllUnloadingTeamsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUnloadingTeamsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUnloadingTeamsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUnloadingTeamsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllUnloadingTeamsSelectorQuery, AllUnloadingTeamsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUnloadingTeamsSelectorQuery, AllUnloadingTeamsSelectorQueryVariables>(AllUnloadingTeamsSelectorDocument, options);
      }
export function useAllUnloadingTeamsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUnloadingTeamsSelectorQuery, AllUnloadingTeamsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUnloadingTeamsSelectorQuery, AllUnloadingTeamsSelectorQueryVariables>(AllUnloadingTeamsSelectorDocument, options);
        }
export type AllUnloadingTeamsSelectorQueryHookResult = ReturnType<typeof useAllUnloadingTeamsSelectorQuery>;
export type AllUnloadingTeamsSelectorLazyQueryHookResult = ReturnType<typeof useAllUnloadingTeamsSelectorLazyQuery>;
export type AllUnloadingTeamsSelectorQueryResult = Apollo.QueryResult<AllUnloadingTeamsSelectorQuery, AllUnloadingTeamsSelectorQueryVariables>;
export const AllExpenseTypesSelectorDocument = gql`
    query allExpenseTypesSelector {
  allExpenseTypes {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllExpenseTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllExpenseTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExpenseTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllExpenseTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllExpenseTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllExpenseTypesSelectorQuery, AllExpenseTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllExpenseTypesSelectorQuery, AllExpenseTypesSelectorQueryVariables>(AllExpenseTypesSelectorDocument, options);
      }
export function useAllExpenseTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllExpenseTypesSelectorQuery, AllExpenseTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllExpenseTypesSelectorQuery, AllExpenseTypesSelectorQueryVariables>(AllExpenseTypesSelectorDocument, options);
        }
export type AllExpenseTypesSelectorQueryHookResult = ReturnType<typeof useAllExpenseTypesSelectorQuery>;
export type AllExpenseTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllExpenseTypesSelectorLazyQuery>;
export type AllExpenseTypesSelectorQueryResult = Apollo.QueryResult<AllExpenseTypesSelectorQuery, AllExpenseTypesSelectorQueryVariables>;
export const AllPaymentTypesSelectorDocument = gql`
    query allPaymentTypesSelector {
  allPaymentTypes {
    id
    name
  }
}
    `;

/**
 * __useAllPaymentTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllPaymentTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaymentTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaymentTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPaymentTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllPaymentTypesSelectorQuery, AllPaymentTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaymentTypesSelectorQuery, AllPaymentTypesSelectorQueryVariables>(AllPaymentTypesSelectorDocument, options);
      }
export function useAllPaymentTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaymentTypesSelectorQuery, AllPaymentTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaymentTypesSelectorQuery, AllPaymentTypesSelectorQueryVariables>(AllPaymentTypesSelectorDocument, options);
        }
export type AllPaymentTypesSelectorQueryHookResult = ReturnType<typeof useAllPaymentTypesSelectorQuery>;
export type AllPaymentTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllPaymentTypesSelectorLazyQuery>;
export type AllPaymentTypesSelectorQueryResult = Apollo.QueryResult<AllPaymentTypesSelectorQuery, AllPaymentTypesSelectorQueryVariables>;
export const AllFuelTypesSelectorDocument = gql`
    query allFuelTypesSelector {
  allFuelTypes {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllFuelTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllFuelTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFuelTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFuelTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFuelTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllFuelTypesSelectorQuery, AllFuelTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFuelTypesSelectorQuery, AllFuelTypesSelectorQueryVariables>(AllFuelTypesSelectorDocument, options);
      }
export function useAllFuelTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFuelTypesSelectorQuery, AllFuelTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFuelTypesSelectorQuery, AllFuelTypesSelectorQueryVariables>(AllFuelTypesSelectorDocument, options);
        }
export type AllFuelTypesSelectorQueryHookResult = ReturnType<typeof useAllFuelTypesSelectorQuery>;
export type AllFuelTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllFuelTypesSelectorLazyQuery>;
export type AllFuelTypesSelectorQueryResult = Apollo.QueryResult<AllFuelTypesSelectorQuery, AllFuelTypesSelectorQueryVariables>;
export const AllContractTypesSelectorDocument = gql`
    query allContractTypesSelector {
  allContractTypes {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllContractTypesSelectorQuery__
 *
 * To run a query within a React component, call `useAllContractTypesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContractTypesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContractTypesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllContractTypesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllContractTypesSelectorQuery, AllContractTypesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllContractTypesSelectorQuery, AllContractTypesSelectorQueryVariables>(AllContractTypesSelectorDocument, options);
      }
export function useAllContractTypesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllContractTypesSelectorQuery, AllContractTypesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllContractTypesSelectorQuery, AllContractTypesSelectorQueryVariables>(AllContractTypesSelectorDocument, options);
        }
export type AllContractTypesSelectorQueryHookResult = ReturnType<typeof useAllContractTypesSelectorQuery>;
export type AllContractTypesSelectorLazyQueryHookResult = ReturnType<typeof useAllContractTypesSelectorLazyQuery>;
export type AllContractTypesSelectorQueryResult = Apollo.QueryResult<AllContractTypesSelectorQuery, AllContractTypesSelectorQueryVariables>;
export const AllMarketYardsSelectorDocument = gql`
    query allMarketYardsSelector {
  allMarketYards {
    id
    name
    address {
      id
      village
    }
  }
}
    `;

/**
 * __useAllMarketYardsSelectorQuery__
 *
 * To run a query within a React component, call `useAllMarketYardsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMarketYardsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMarketYardsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMarketYardsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllMarketYardsSelectorQuery, AllMarketYardsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMarketYardsSelectorQuery, AllMarketYardsSelectorQueryVariables>(AllMarketYardsSelectorDocument, options);
      }
export function useAllMarketYardsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMarketYardsSelectorQuery, AllMarketYardsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMarketYardsSelectorQuery, AllMarketYardsSelectorQueryVariables>(AllMarketYardsSelectorDocument, options);
        }
export type AllMarketYardsSelectorQueryHookResult = ReturnType<typeof useAllMarketYardsSelectorQuery>;
export type AllMarketYardsSelectorLazyQueryHookResult = ReturnType<typeof useAllMarketYardsSelectorLazyQuery>;
export type AllMarketYardsSelectorQueryResult = Apollo.QueryResult<AllMarketYardsSelectorQuery, AllMarketYardsSelectorQueryVariables>;
export const AllDistributionCentersSelectorDocument = gql`
    query allDistributionCentersSelector {
  allDistributionCentres {
    id
    name
  }
}
    `;

/**
 * __useAllDistributionCentersSelectorQuery__
 *
 * To run a query within a React component, call `useAllDistributionCentersSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDistributionCentersSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDistributionCentersSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDistributionCentersSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllDistributionCentersSelectorQuery, AllDistributionCentersSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDistributionCentersSelectorQuery, AllDistributionCentersSelectorQueryVariables>(AllDistributionCentersSelectorDocument, options);
      }
export function useAllDistributionCentersSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDistributionCentersSelectorQuery, AllDistributionCentersSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDistributionCentersSelectorQuery, AllDistributionCentersSelectorQueryVariables>(AllDistributionCentersSelectorDocument, options);
        }
export type AllDistributionCentersSelectorQueryHookResult = ReturnType<typeof useAllDistributionCentersSelectorQuery>;
export type AllDistributionCentersSelectorLazyQueryHookResult = ReturnType<typeof useAllDistributionCentersSelectorLazyQuery>;
export type AllDistributionCentersSelectorQueryResult = Apollo.QueryResult<AllDistributionCentersSelectorQuery, AllDistributionCentersSelectorQueryVariables>;
export const DcSurveyAreasDocument = gql`
    query dcSurveyAreas($dcId: ID) {
  allSurveyAreas(filter: {distributionCentreIds: [$dcId]}) {
    id
    properties {
      name
    }
  }
}
    `;

/**
 * __useDcSurveyAreasQuery__
 *
 * To run a query within a React component, call `useDcSurveyAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcSurveyAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcSurveyAreasQuery({
 *   variables: {
 *      dcId: // value for 'dcId'
 *   },
 * });
 */
export function useDcSurveyAreasQuery(baseOptions?: Apollo.QueryHookOptions<DcSurveyAreasQuery, DcSurveyAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcSurveyAreasQuery, DcSurveyAreasQueryVariables>(DcSurveyAreasDocument, options);
      }
export function useDcSurveyAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcSurveyAreasQuery, DcSurveyAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcSurveyAreasQuery, DcSurveyAreasQueryVariables>(DcSurveyAreasDocument, options);
        }
export type DcSurveyAreasQueryHookResult = ReturnType<typeof useDcSurveyAreasQuery>;
export type DcSurveyAreasLazyQueryHookResult = ReturnType<typeof useDcSurveyAreasLazyQuery>;
export type DcSurveyAreasQueryResult = Apollo.QueryResult<DcSurveyAreasQuery, DcSurveyAreasQueryVariables>;
export const AllCpcSelectorDocument = gql`
    query allCPCSelector {
  allDistributionCentres(filter: {isManufacturingPlant: true}) {
    id
    name
  }
}
    `;

/**
 * __useAllCpcSelectorQuery__
 *
 * To run a query within a React component, call `useAllCpcSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCpcSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCpcSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCpcSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllCpcSelectorQuery, AllCpcSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCpcSelectorQuery, AllCpcSelectorQueryVariables>(AllCpcSelectorDocument, options);
      }
export function useAllCpcSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCpcSelectorQuery, AllCpcSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCpcSelectorQuery, AllCpcSelectorQueryVariables>(AllCpcSelectorDocument, options);
        }
export type AllCpcSelectorQueryHookResult = ReturnType<typeof useAllCpcSelectorQuery>;
export type AllCpcSelectorLazyQueryHookResult = ReturnType<typeof useAllCpcSelectorLazyQuery>;
export type AllCpcSelectorQueryResult = Apollo.QueryResult<AllCpcSelectorQuery, AllCpcSelectorQueryVariables>;
export const DistributionCentersCurrentStockDocument = gql`
    query DistributionCentersCurrentStock($id: ID!) {
  distributionCentreDetail(id: $id) {
    currentStockPercentage
  }
}
    `;

/**
 * __useDistributionCentersCurrentStockQuery__
 *
 * To run a query within a React component, call `useDistributionCentersCurrentStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionCentersCurrentStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionCentersCurrentStockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDistributionCentersCurrentStockQuery(baseOptions: Apollo.QueryHookOptions<DistributionCentersCurrentStockQuery, DistributionCentersCurrentStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributionCentersCurrentStockQuery, DistributionCentersCurrentStockQueryVariables>(DistributionCentersCurrentStockDocument, options);
      }
export function useDistributionCentersCurrentStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributionCentersCurrentStockQuery, DistributionCentersCurrentStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributionCentersCurrentStockQuery, DistributionCentersCurrentStockQueryVariables>(DistributionCentersCurrentStockDocument, options);
        }
export type DistributionCentersCurrentStockQueryHookResult = ReturnType<typeof useDistributionCentersCurrentStockQuery>;
export type DistributionCentersCurrentStockLazyQueryHookResult = ReturnType<typeof useDistributionCentersCurrentStockLazyQuery>;
export type DistributionCentersCurrentStockQueryResult = Apollo.QueryResult<DistributionCentersCurrentStockQuery, DistributionCentersCurrentStockQueryVariables>;
export const AllSellableItemGroupsSelectorDocument = gql`
    query allSellableItemGroupsSelector {
  allSellableItemGroups {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllSellableItemGroupsSelectorQuery__
 *
 * To run a query within a React component, call `useAllSellableItemGroupsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSellableItemGroupsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSellableItemGroupsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSellableItemGroupsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSellableItemGroupsSelectorQuery, AllSellableItemGroupsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSellableItemGroupsSelectorQuery, AllSellableItemGroupsSelectorQueryVariables>(AllSellableItemGroupsSelectorDocument, options);
      }
export function useAllSellableItemGroupsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSellableItemGroupsSelectorQuery, AllSellableItemGroupsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSellableItemGroupsSelectorQuery, AllSellableItemGroupsSelectorQueryVariables>(AllSellableItemGroupsSelectorDocument, options);
        }
export type AllSellableItemGroupsSelectorQueryHookResult = ReturnType<typeof useAllSellableItemGroupsSelectorQuery>;
export type AllSellableItemGroupsSelectorLazyQueryHookResult = ReturnType<typeof useAllSellableItemGroupsSelectorLazyQuery>;
export type AllSellableItemGroupsSelectorQueryResult = Apollo.QueryResult<AllSellableItemGroupsSelectorQuery, AllSellableItemGroupsSelectorQueryVariables>;
export const AllSellableItemSelectorDocument = gql`
    query allSellableItemSelector {
  allSellableItems {
    id
    name
  }
}
    `;

/**
 * __useAllSellableItemSelectorQuery__
 *
 * To run a query within a React component, call `useAllSellableItemSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSellableItemSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSellableItemSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSellableItemSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSellableItemSelectorQuery, AllSellableItemSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSellableItemSelectorQuery, AllSellableItemSelectorQueryVariables>(AllSellableItemSelectorDocument, options);
      }
export function useAllSellableItemSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSellableItemSelectorQuery, AllSellableItemSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSellableItemSelectorQuery, AllSellableItemSelectorQueryVariables>(AllSellableItemSelectorDocument, options);
        }
export type AllSellableItemSelectorQueryHookResult = ReturnType<typeof useAllSellableItemSelectorQuery>;
export type AllSellableItemSelectorLazyQueryHookResult = ReturnType<typeof useAllSellableItemSelectorLazyQuery>;
export type AllSellableItemSelectorQueryResult = Apollo.QueryResult<AllSellableItemSelectorQuery, AllSellableItemSelectorQueryVariables>;
export const SearchSellableItemsDocument = gql`
    query searchSellableItems($query: String, $first: Int, $skip: Int, $filter: SellableItemFilterInput) {
  allSellableItems(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    name
    secondarySkuType {
      id
      capacity
    }
  }
}
    `;

/**
 * __useSearchSellableItemsQuery__
 *
 * To run a query within a React component, call `useSearchSellableItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSellableItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSellableItemsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSellableItemsQuery(baseOptions?: Apollo.QueryHookOptions<SearchSellableItemsQuery, SearchSellableItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSellableItemsQuery, SearchSellableItemsQueryVariables>(SearchSellableItemsDocument, options);
      }
export function useSearchSellableItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSellableItemsQuery, SearchSellableItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSellableItemsQuery, SearchSellableItemsQueryVariables>(SearchSellableItemsDocument, options);
        }
export type SearchSellableItemsQueryHookResult = ReturnType<typeof useSearchSellableItemsQuery>;
export type SearchSellableItemsLazyQueryHookResult = ReturnType<typeof useSearchSellableItemsLazyQuery>;
export type SearchSellableItemsQueryResult = Apollo.QueryResult<SearchSellableItemsQuery, SearchSellableItemsQueryVariables>;
export const SearchBatchStockDocument = gql`
    query searchBatchStock($query: String, $first: Int, $skip: Int, $filter: BatchStockFilterInput) {
  allBatchStocks(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    name: codename
    currentStockCount
    suppliedBy {
      id
    }
    expiryOn
    manufacturedOn
  }
}
    `;

/**
 * __useSearchBatchStockQuery__
 *
 * To run a query within a React component, call `useSearchBatchStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBatchStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBatchStockQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchBatchStockQuery(baseOptions?: Apollo.QueryHookOptions<SearchBatchStockQuery, SearchBatchStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBatchStockQuery, SearchBatchStockQueryVariables>(SearchBatchStockDocument, options);
      }
export function useSearchBatchStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBatchStockQuery, SearchBatchStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBatchStockQuery, SearchBatchStockQueryVariables>(SearchBatchStockDocument, options);
        }
export type SearchBatchStockQueryHookResult = ReturnType<typeof useSearchBatchStockQuery>;
export type SearchBatchStockLazyQueryHookResult = ReturnType<typeof useSearchBatchStockLazyQuery>;
export type SearchBatchStockQueryResult = Apollo.QueryResult<SearchBatchStockQuery, SearchBatchStockQueryVariables>;
export const AllReportMastersSelectorDocument = gql`
    query allReportMastersSelector {
  allReportMasters {
    id
    alias
  }
}
    `;

/**
 * __useAllReportMastersSelectorQuery__
 *
 * To run a query within a React component, call `useAllReportMastersSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportMastersSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportMastersSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReportMastersSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllReportMastersSelectorQuery, AllReportMastersSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportMastersSelectorQuery, AllReportMastersSelectorQueryVariables>(AllReportMastersSelectorDocument, options);
      }
export function useAllReportMastersSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportMastersSelectorQuery, AllReportMastersSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportMastersSelectorQuery, AllReportMastersSelectorQueryVariables>(AllReportMastersSelectorDocument, options);
        }
export type AllReportMastersSelectorQueryHookResult = ReturnType<typeof useAllReportMastersSelectorQuery>;
export type AllReportMastersSelectorLazyQueryHookResult = ReturnType<typeof useAllReportMastersSelectorLazyQuery>;
export type AllReportMastersSelectorQueryResult = Apollo.QueryResult<AllReportMastersSelectorQuery, AllReportMastersSelectorQueryVariables>;
export const AllNotificationTempletesDocument = gql`
    query allNotificationTempletes {
  allNotificationTempletes {
    id
    name: alias
  }
}
    `;

/**
 * __useAllNotificationTempletesQuery__
 *
 * To run a query within a React component, call `useAllNotificationTempletesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNotificationTempletesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNotificationTempletesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllNotificationTempletesQuery(baseOptions?: Apollo.QueryHookOptions<AllNotificationTempletesQuery, AllNotificationTempletesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllNotificationTempletesQuery, AllNotificationTempletesQueryVariables>(AllNotificationTempletesDocument, options);
      }
export function useAllNotificationTempletesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllNotificationTempletesQuery, AllNotificationTempletesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllNotificationTempletesQuery, AllNotificationTempletesQueryVariables>(AllNotificationTempletesDocument, options);
        }
export type AllNotificationTempletesQueryHookResult = ReturnType<typeof useAllNotificationTempletesQuery>;
export type AllNotificationTempletesLazyQueryHookResult = ReturnType<typeof useAllNotificationTempletesLazyQuery>;
export type AllNotificationTempletesQueryResult = Apollo.QueryResult<AllNotificationTempletesQuery, AllNotificationTempletesQueryVariables>;
export const AllStatesDocument = gql`
    query allStates {
  allStates {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllStatesQuery__
 *
 * To run a query within a React component, call `useAllStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStatesQuery(baseOptions?: Apollo.QueryHookOptions<AllStatesQuery, AllStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStatesQuery, AllStatesQueryVariables>(AllStatesDocument, options);
      }
export function useAllStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStatesQuery, AllStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStatesQuery, AllStatesQueryVariables>(AllStatesDocument, options);
        }
export type AllStatesQueryHookResult = ReturnType<typeof useAllStatesQuery>;
export type AllStatesLazyQueryHookResult = ReturnType<typeof useAllStatesLazyQuery>;
export type AllStatesQueryResult = Apollo.QueryResult<AllStatesQuery, AllStatesQueryVariables>;
export const PeriodicTaskTypesDocument = gql`
    query periodicTaskTypes {
  allTasks
}
    `;

/**
 * __usePeriodicTaskTypesQuery__
 *
 * To run a query within a React component, call `usePeriodicTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicTaskTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeriodicTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<PeriodicTaskTypesQuery, PeriodicTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeriodicTaskTypesQuery, PeriodicTaskTypesQueryVariables>(PeriodicTaskTypesDocument, options);
      }
export function usePeriodicTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeriodicTaskTypesQuery, PeriodicTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeriodicTaskTypesQuery, PeriodicTaskTypesQueryVariables>(PeriodicTaskTypesDocument, options);
        }
export type PeriodicTaskTypesQueryHookResult = ReturnType<typeof usePeriodicTaskTypesQuery>;
export type PeriodicTaskTypesLazyQueryHookResult = ReturnType<typeof usePeriodicTaskTypesLazyQuery>;
export type PeriodicTaskTypesQueryResult = Apollo.QueryResult<PeriodicTaskTypesQuery, PeriodicTaskTypesQueryVariables>;
export const AllRoutesSelectorDocument = gql`
    query allRoutesSelector($filter: RouteInput) {
  allRoutes(filter: $filter) {
    id
    name
    surveyArea {
      id
      properties {
        name
      }
    }
  }
}
    `;

/**
 * __useAllRoutesSelectorQuery__
 *
 * To run a query within a React component, call `useAllRoutesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRoutesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRoutesSelectorQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllRoutesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllRoutesSelectorQuery, AllRoutesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRoutesSelectorQuery, AllRoutesSelectorQueryVariables>(AllRoutesSelectorDocument, options);
      }
export function useAllRoutesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRoutesSelectorQuery, AllRoutesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRoutesSelectorQuery, AllRoutesSelectorQueryVariables>(AllRoutesSelectorDocument, options);
        }
export type AllRoutesSelectorQueryHookResult = ReturnType<typeof useAllRoutesSelectorQuery>;
export type AllRoutesSelectorLazyQueryHookResult = ReturnType<typeof useAllRoutesSelectorLazyQuery>;
export type AllRoutesSelectorQueryResult = Apollo.QueryResult<AllRoutesSelectorQuery, AllRoutesSelectorQueryVariables>;
export const AllRouteCategorysDocument = gql`
    query allRouteCategorys {
  allRouteCategorys {
    id
    name
  }
}
    `;

/**
 * __useAllRouteCategorysQuery__
 *
 * To run a query within a React component, call `useAllRouteCategorysQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRouteCategorysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRouteCategorysQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRouteCategorysQuery(baseOptions?: Apollo.QueryHookOptions<AllRouteCategorysQuery, AllRouteCategorysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRouteCategorysQuery, AllRouteCategorysQueryVariables>(AllRouteCategorysDocument, options);
      }
export function useAllRouteCategorysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRouteCategorysQuery, AllRouteCategorysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRouteCategorysQuery, AllRouteCategorysQueryVariables>(AllRouteCategorysDocument, options);
        }
export type AllRouteCategorysQueryHookResult = ReturnType<typeof useAllRouteCategorysQuery>;
export type AllRouteCategorysLazyQueryHookResult = ReturnType<typeof useAllRouteCategorysLazyQuery>;
export type AllRouteCategorysQueryResult = Apollo.QueryResult<AllRouteCategorysQuery, AllRouteCategorysQueryVariables>;
export const AllPaymentMethodsDocument = gql`
    query allPaymentMethods {
  allPaymentMethods {
    id
    name
  }
}
    `;

/**
 * __useAllPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAllPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<AllPaymentMethodsQuery, AllPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaymentMethodsQuery, AllPaymentMethodsQueryVariables>(AllPaymentMethodsDocument, options);
      }
export function useAllPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaymentMethodsQuery, AllPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaymentMethodsQuery, AllPaymentMethodsQueryVariables>(AllPaymentMethodsDocument, options);
        }
export type AllPaymentMethodsQueryHookResult = ReturnType<typeof useAllPaymentMethodsQuery>;
export type AllPaymentMethodsLazyQueryHookResult = ReturnType<typeof useAllPaymentMethodsLazyQuery>;
export type AllPaymentMethodsQueryResult = Apollo.QueryResult<AllPaymentMethodsQuery, AllPaymentMethodsQueryVariables>;
export const AllTransactionTypesDocument = gql`
    query allTransactionTypes {
  allTransactionTypes {
    id
    name
  }
}
    `;

/**
 * __useAllTransactionTypesQuery__
 *
 * To run a query within a React component, call `useAllTransactionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTransactionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTransactionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTransactionTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllTransactionTypesQuery, AllTransactionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTransactionTypesQuery, AllTransactionTypesQueryVariables>(AllTransactionTypesDocument, options);
      }
export function useAllTransactionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTransactionTypesQuery, AllTransactionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTransactionTypesQuery, AllTransactionTypesQueryVariables>(AllTransactionTypesDocument, options);
        }
export type AllTransactionTypesQueryHookResult = ReturnType<typeof useAllTransactionTypesQuery>;
export type AllTransactionTypesLazyQueryHookResult = ReturnType<typeof useAllTransactionTypesLazyQuery>;
export type AllTransactionTypesQueryResult = Apollo.QueryResult<AllTransactionTypesQuery, AllTransactionTypesQueryVariables>;
export const AllUnloadingSubLocationsDocument = gql`
    query AllUnloadingSubLocations($query: String, $filter: ID!) {
  allUnloadingSubLocations(query: $query, filter: {unloadingLocationId: $filter}) {
    id
    name
    unloadingLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useAllUnloadingSubLocationsQuery__
 *
 * To run a query within a React component, call `useAllUnloadingSubLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUnloadingSubLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUnloadingSubLocationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllUnloadingSubLocationsQuery(baseOptions: Apollo.QueryHookOptions<AllUnloadingSubLocationsQuery, AllUnloadingSubLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUnloadingSubLocationsQuery, AllUnloadingSubLocationsQueryVariables>(AllUnloadingSubLocationsDocument, options);
      }
export function useAllUnloadingSubLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUnloadingSubLocationsQuery, AllUnloadingSubLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUnloadingSubLocationsQuery, AllUnloadingSubLocationsQueryVariables>(AllUnloadingSubLocationsDocument, options);
        }
export type AllUnloadingSubLocationsQueryHookResult = ReturnType<typeof useAllUnloadingSubLocationsQuery>;
export type AllUnloadingSubLocationsLazyQueryHookResult = ReturnType<typeof useAllUnloadingSubLocationsLazyQuery>;
export type AllUnloadingSubLocationsQueryResult = Apollo.QueryResult<AllUnloadingSubLocationsQuery, AllUnloadingSubLocationsQueryVariables>;
export const HoldingAreasDocument = gql`
    query holdingAreas {
  holdingAreas {
    id
    name
  }
}
    `;

/**
 * __useHoldingAreasQuery__
 *
 * To run a query within a React component, call `useHoldingAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useHoldingAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHoldingAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useHoldingAreasQuery(baseOptions?: Apollo.QueryHookOptions<HoldingAreasQuery, HoldingAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HoldingAreasQuery, HoldingAreasQueryVariables>(HoldingAreasDocument, options);
      }
export function useHoldingAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HoldingAreasQuery, HoldingAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HoldingAreasQuery, HoldingAreasQueryVariables>(HoldingAreasDocument, options);
        }
export type HoldingAreasQueryHookResult = ReturnType<typeof useHoldingAreasQuery>;
export type HoldingAreasLazyQueryHookResult = ReturnType<typeof useHoldingAreasLazyQuery>;
export type HoldingAreasQueryResult = Apollo.QueryResult<HoldingAreasQuery, HoldingAreasQueryVariables>;
export const ProductionLinesDocument = gql`
    query productionLines($departmentId: ID, $depotId: ID) {
  productionLines(departmentId: $departmentId, depotId: $depotId) {
    id
    name
  }
}
    `;

/**
 * __useProductionLinesQuery__
 *
 * To run a query within a React component, call `useProductionLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionLinesQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      depotId: // value for 'depotId'
 *   },
 * });
 */
export function useProductionLinesQuery(baseOptions?: Apollo.QueryHookOptions<ProductionLinesQuery, ProductionLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductionLinesQuery, ProductionLinesQueryVariables>(ProductionLinesDocument, options);
      }
export function useProductionLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductionLinesQuery, ProductionLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductionLinesQuery, ProductionLinesQueryVariables>(ProductionLinesDocument, options);
        }
export type ProductionLinesQueryHookResult = ReturnType<typeof useProductionLinesQuery>;
export type ProductionLinesLazyQueryHookResult = ReturnType<typeof useProductionLinesLazyQuery>;
export type ProductionLinesQueryResult = Apollo.QueryResult<ProductionLinesQuery, ProductionLinesQueryVariables>;
export const AllExportCustomersSelectorDocument = gql`
    query allExportCustomersSelector {
  allExportCustomers {
    id
    name
  }
}
    `;

/**
 * __useAllExportCustomersSelectorQuery__
 *
 * To run a query within a React component, call `useAllExportCustomersSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllExportCustomersSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllExportCustomersSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllExportCustomersSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllExportCustomersSelectorQuery, AllExportCustomersSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllExportCustomersSelectorQuery, AllExportCustomersSelectorQueryVariables>(AllExportCustomersSelectorDocument, options);
      }
export function useAllExportCustomersSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllExportCustomersSelectorQuery, AllExportCustomersSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllExportCustomersSelectorQuery, AllExportCustomersSelectorQueryVariables>(AllExportCustomersSelectorDocument, options);
        }
export type AllExportCustomersSelectorQueryHookResult = ReturnType<typeof useAllExportCustomersSelectorQuery>;
export type AllExportCustomersSelectorLazyQueryHookResult = ReturnType<typeof useAllExportCustomersSelectorLazyQuery>;
export type AllExportCustomersSelectorQueryResult = Apollo.QueryResult<AllExportCustomersSelectorQuery, AllExportCustomersSelectorQueryVariables>;
export const AllPortsSelectorDocument = gql`
    query allPortsSelector {
  allPorts {
    id
    name
  }
}
    `;

/**
 * __useAllPortsSelectorQuery__
 *
 * To run a query within a React component, call `useAllPortsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPortsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPortsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPortsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllPortsSelectorQuery, AllPortsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPortsSelectorQuery, AllPortsSelectorQueryVariables>(AllPortsSelectorDocument, options);
      }
export function useAllPortsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPortsSelectorQuery, AllPortsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPortsSelectorQuery, AllPortsSelectorQueryVariables>(AllPortsSelectorDocument, options);
        }
export type AllPortsSelectorQueryHookResult = ReturnType<typeof useAllPortsSelectorQuery>;
export type AllPortsSelectorLazyQueryHookResult = ReturnType<typeof useAllPortsSelectorLazyQuery>;
export type AllPortsSelectorQueryResult = Apollo.QueryResult<AllPortsSelectorQuery, AllPortsSelectorQueryVariables>;
export const AllColorGroupsSelectorDocument = gql`
    query allColorGroupsSelector {
  allColorGroups {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllColorGroupsSelectorQuery__
 *
 * To run a query within a React component, call `useAllColorGroupsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllColorGroupsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllColorGroupsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllColorGroupsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllColorGroupsSelectorQuery, AllColorGroupsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllColorGroupsSelectorQuery, AllColorGroupsSelectorQueryVariables>(AllColorGroupsSelectorDocument, options);
      }
export function useAllColorGroupsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllColorGroupsSelectorQuery, AllColorGroupsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllColorGroupsSelectorQuery, AllColorGroupsSelectorQueryVariables>(AllColorGroupsSelectorDocument, options);
        }
export type AllColorGroupsSelectorQueryHookResult = ReturnType<typeof useAllColorGroupsSelectorQuery>;
export type AllColorGroupsSelectorLazyQueryHookResult = ReturnType<typeof useAllColorGroupsSelectorLazyQuery>;
export type AllColorGroupsSelectorQueryResult = Apollo.QueryResult<AllColorGroupsSelectorQuery, AllColorGroupsSelectorQueryVariables>;
export const AllPrimaryPackMaterialsSelectorDocument = gql`
    query allPrimaryPackMaterialsSelector {
  allPackingMaterials(typeName: "PRIMARY") {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllPrimaryPackMaterialsSelectorQuery__
 *
 * To run a query within a React component, call `useAllPrimaryPackMaterialsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPrimaryPackMaterialsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPrimaryPackMaterialsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPrimaryPackMaterialsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllPrimaryPackMaterialsSelectorQuery, AllPrimaryPackMaterialsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPrimaryPackMaterialsSelectorQuery, AllPrimaryPackMaterialsSelectorQueryVariables>(AllPrimaryPackMaterialsSelectorDocument, options);
      }
export function useAllPrimaryPackMaterialsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPrimaryPackMaterialsSelectorQuery, AllPrimaryPackMaterialsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPrimaryPackMaterialsSelectorQuery, AllPrimaryPackMaterialsSelectorQueryVariables>(AllPrimaryPackMaterialsSelectorDocument, options);
        }
export type AllPrimaryPackMaterialsSelectorQueryHookResult = ReturnType<typeof useAllPrimaryPackMaterialsSelectorQuery>;
export type AllPrimaryPackMaterialsSelectorLazyQueryHookResult = ReturnType<typeof useAllPrimaryPackMaterialsSelectorLazyQuery>;
export type AllPrimaryPackMaterialsSelectorQueryResult = Apollo.QueryResult<AllPrimaryPackMaterialsSelectorQuery, AllPrimaryPackMaterialsSelectorQueryVariables>;
export const AllSecondaryPackMaterialsSelectorDocument = gql`
    query allSecondaryPackMaterialsSelector {
  allPackingMaterials(typeName: "SECONDARY") {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllSecondaryPackMaterialsSelectorQuery__
 *
 * To run a query within a React component, call `useAllSecondaryPackMaterialsSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSecondaryPackMaterialsSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSecondaryPackMaterialsSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSecondaryPackMaterialsSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllSecondaryPackMaterialsSelectorQuery, AllSecondaryPackMaterialsSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSecondaryPackMaterialsSelectorQuery, AllSecondaryPackMaterialsSelectorQueryVariables>(AllSecondaryPackMaterialsSelectorDocument, options);
      }
export function useAllSecondaryPackMaterialsSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSecondaryPackMaterialsSelectorQuery, AllSecondaryPackMaterialsSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSecondaryPackMaterialsSelectorQuery, AllSecondaryPackMaterialsSelectorQueryVariables>(AllSecondaryPackMaterialsSelectorDocument, options);
        }
export type AllSecondaryPackMaterialsSelectorQueryHookResult = ReturnType<typeof useAllSecondaryPackMaterialsSelectorQuery>;
export type AllSecondaryPackMaterialsSelectorLazyQueryHookResult = ReturnType<typeof useAllSecondaryPackMaterialsSelectorLazyQuery>;
export type AllSecondaryPackMaterialsSelectorQueryResult = Apollo.QueryResult<AllSecondaryPackMaterialsSelectorQuery, AllSecondaryPackMaterialsSelectorQueryVariables>;
export const AllGatesSelectorDocument = gql`
    query allGatesSelector {
  gateNumbers {
    id
    name
    codename
  }
}
    `;

/**
 * __useAllGatesSelectorQuery__
 *
 * To run a query within a React component, call `useAllGatesSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGatesSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGatesSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGatesSelectorQuery(baseOptions?: Apollo.QueryHookOptions<AllGatesSelectorQuery, AllGatesSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGatesSelectorQuery, AllGatesSelectorQueryVariables>(AllGatesSelectorDocument, options);
      }
export function useAllGatesSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGatesSelectorQuery, AllGatesSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGatesSelectorQuery, AllGatesSelectorQueryVariables>(AllGatesSelectorDocument, options);
        }
export type AllGatesSelectorQueryHookResult = ReturnType<typeof useAllGatesSelectorQuery>;
export type AllGatesSelectorLazyQueryHookResult = ReturnType<typeof useAllGatesSelectorLazyQuery>;
export type AllGatesSelectorQueryResult = Apollo.QueryResult<AllGatesSelectorQuery, AllGatesSelectorQueryVariables>;
export const AddUpdateVariantDocument = gql`
    mutation AddUpdateVariant($parentBatchStockId: ID!, $sellableItemId: ID!, $sellableItemStockInput: SellableItemStockInput!, $batchStockInput: BatchStockInput!, $parentSellableItemStockId: ID!) {
  addUpdateVarientFromBatchStock(
    parentSellableItemStockId: $parentSellableItemStockId
    parentBatchStockId: $parentBatchStockId
    sellableItemId: $sellableItemId
    sellableItemStockInput: $sellableItemStockInput
    batchStockInput: $batchStockInput
  ) {
    sellableItem {
      id
      name
    }
    sellableItemStock {
      id
      unitRate
      currentStockCount
    }
    batchStock {
      id
      codename
      totalQuantity
    }
  }
}
    `;
export type AddUpdateVariantMutationFn = Apollo.MutationFunction<AddUpdateVariantMutation, AddUpdateVariantMutationVariables>;

/**
 * __useAddUpdateVariantMutation__
 *
 * To run a mutation, you first call `useAddUpdateVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateVariantMutation, { data, loading, error }] = useAddUpdateVariantMutation({
 *   variables: {
 *      parentBatchStockId: // value for 'parentBatchStockId'
 *      sellableItemId: // value for 'sellableItemId'
 *      sellableItemStockInput: // value for 'sellableItemStockInput'
 *      batchStockInput: // value for 'batchStockInput'
 *      parentSellableItemStockId: // value for 'parentSellableItemStockId'
 *   },
 * });
 */
export function useAddUpdateVariantMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateVariantMutation, AddUpdateVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateVariantMutation, AddUpdateVariantMutationVariables>(AddUpdateVariantDocument, options);
      }
export type AddUpdateVariantMutationHookResult = ReturnType<typeof useAddUpdateVariantMutation>;
export type AddUpdateVariantMutationResult = Apollo.MutationResult<AddUpdateVariantMutation>;
export type AddUpdateVariantMutationOptions = Apollo.BaseMutationOptions<AddUpdateVariantMutation, AddUpdateVariantMutationVariables>;
export const SellableItemAddUpdateDocument = gql`
    mutation SellableItemAddUpdate($codename: String, $id: ID, $itemGroups: [ID], $longDescription: String, $name: String, $photos: [MediaInput], $primaryPhoto: MediaInput, $sellableVarieties: [SellableVarietyInput], $shortDescription: String, $transportationType: String, $secondarySkuType: ID, $metadata: SellableItemMetadataInput, $allowedDepartments: [Int], $currentStockPercentage: CustomGenericScalar, $parentItemId: ID) {
  addUpdateSellableItem(
    codename: $codename
    id: $id
    itemGroups: $itemGroups
    longDescription: $longDescription
    name: $name
    photos: $photos
    primaryPhoto: $primaryPhoto
    sellableVarieties: $sellableVarieties
    shortDescription: $shortDescription
    transportationType: $transportationType
    secondarySkuTypeId: $secondarySkuType
    allowedDepartments: $allowedDepartments
    metadata: $metadata
    currentStockPercentage: $currentStockPercentage
    parentItemId: $parentItemId
  ) {
    sellableItem {
      ...SellableItemDetailsFrag
    }
  }
}
    ${SellableItemDetailsFragFragmentDoc}`;
export type SellableItemAddUpdateMutationFn = Apollo.MutationFunction<SellableItemAddUpdateMutation, SellableItemAddUpdateMutationVariables>;

/**
 * __useSellableItemAddUpdateMutation__
 *
 * To run a mutation, you first call `useSellableItemAddUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellableItemAddUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellableItemAddUpdateMutation, { data, loading, error }] = useSellableItemAddUpdateMutation({
 *   variables: {
 *      codename: // value for 'codename'
 *      id: // value for 'id'
 *      itemGroups: // value for 'itemGroups'
 *      longDescription: // value for 'longDescription'
 *      name: // value for 'name'
 *      photos: // value for 'photos'
 *      primaryPhoto: // value for 'primaryPhoto'
 *      sellableVarieties: // value for 'sellableVarieties'
 *      shortDescription: // value for 'shortDescription'
 *      transportationType: // value for 'transportationType'
 *      secondarySkuType: // value for 'secondarySkuType'
 *      metadata: // value for 'metadata'
 *      allowedDepartments: // value for 'allowedDepartments'
 *      currentStockPercentage: // value for 'currentStockPercentage'
 *      parentItemId: // value for 'parentItemId'
 *   },
 * });
 */
export function useSellableItemAddUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellableItemAddUpdateMutation, SellableItemAddUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellableItemAddUpdateMutation, SellableItemAddUpdateMutationVariables>(SellableItemAddUpdateDocument, options);
      }
export type SellableItemAddUpdateMutationHookResult = ReturnType<typeof useSellableItemAddUpdateMutation>;
export type SellableItemAddUpdateMutationResult = Apollo.MutationResult<SellableItemAddUpdateMutation>;
export type SellableItemAddUpdateMutationOptions = Apollo.BaseMutationOptions<SellableItemAddUpdateMutation, SellableItemAddUpdateMutationVariables>;
export const SellableItemStockaddUpdateDocument = gql`
    mutation SellableItemStockaddUpdate($currentStockCount: Int!, $discountedRate: Float!, $distributionCentreId: ID!, $groupVisibility: [ID], $holdStockCount: Int, $id: ID, $isLive: Boolean!, $offerStockCount: Int!, $orderingConditions: OrderingConditionInput, $sellableItemId: ID!, $unitRate: Float!, $minRate: Float, $maxRate: Float, $relatedStockId: ID, $expiryDate: Date, $currentStockPercentage: CustomGenericScalar, $currentStockType: String) {
  addUpdateSellableItemStock(
    currentStockCount: $currentStockCount
    discountedRate: $discountedRate
    distributionCentreId: $distributionCentreId
    groupVisibility: $groupVisibility
    holdStockCount: $holdStockCount
    relatedStockId: $relatedStockId
    id: $id
    isLive: $isLive
    offerStockCount: $offerStockCount
    orderingConditions: $orderingConditions
    sellableItemId: $sellableItemId
    unitRate: $unitRate
    minRate: $minRate
    expiryDate: $expiryDate
    maxRate: $maxRate
    currentStockPercentage: $currentStockPercentage
    currentStockType: $currentStockType
  ) {
    sellableItemStock {
      sellableItem {
        id
        sellableStocks {
          id
          rejectedStockCount
          bookedStockCount
          currentStockCount
          holdStockCount
          offerStockCount
        }
      }
      ...SellableItemStockDetailFrag
    }
  }
}
    ${SellableItemStockDetailFragFragmentDoc}`;
export type SellableItemStockaddUpdateMutationFn = Apollo.MutationFunction<SellableItemStockaddUpdateMutation, SellableItemStockaddUpdateMutationVariables>;

/**
 * __useSellableItemStockaddUpdateMutation__
 *
 * To run a mutation, you first call `useSellableItemStockaddUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellableItemStockaddUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellableItemStockaddUpdateMutation, { data, loading, error }] = useSellableItemStockaddUpdateMutation({
 *   variables: {
 *      currentStockCount: // value for 'currentStockCount'
 *      discountedRate: // value for 'discountedRate'
 *      distributionCentreId: // value for 'distributionCentreId'
 *      groupVisibility: // value for 'groupVisibility'
 *      holdStockCount: // value for 'holdStockCount'
 *      id: // value for 'id'
 *      isLive: // value for 'isLive'
 *      offerStockCount: // value for 'offerStockCount'
 *      orderingConditions: // value for 'orderingConditions'
 *      sellableItemId: // value for 'sellableItemId'
 *      unitRate: // value for 'unitRate'
 *      minRate: // value for 'minRate'
 *      maxRate: // value for 'maxRate'
 *      relatedStockId: // value for 'relatedStockId'
 *      expiryDate: // value for 'expiryDate'
 *      currentStockPercentage: // value for 'currentStockPercentage'
 *      currentStockType: // value for 'currentStockType'
 *   },
 * });
 */
export function useSellableItemStockaddUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SellableItemStockaddUpdateMutation, SellableItemStockaddUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SellableItemStockaddUpdateMutation, SellableItemStockaddUpdateMutationVariables>(SellableItemStockaddUpdateDocument, options);
      }
export type SellableItemStockaddUpdateMutationHookResult = ReturnType<typeof useSellableItemStockaddUpdateMutation>;
export type SellableItemStockaddUpdateMutationResult = Apollo.MutationResult<SellableItemStockaddUpdateMutation>;
export type SellableItemStockaddUpdateMutationOptions = Apollo.BaseMutationOptions<SellableItemStockaddUpdateMutation, SellableItemStockaddUpdateMutationVariables>;
export const SellableItemsListDocument = gql`
    query SellableItemsList($first: Int, $skip: Int, $query: String, $filter: SellableItemFilterInput) {
  allSellableItems(query: $query, first: $first, skip: $skip, filter: $filter) {
    ...SellableItemListFrag
  }
}
    ${SellableItemListFragFragmentDoc}`;

/**
 * __useSellableItemsListQuery__
 *
 * To run a query within a React component, call `useSellableItemsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSellableItemsListQuery(baseOptions?: Apollo.QueryHookOptions<SellableItemsListQuery, SellableItemsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemsListQuery, SellableItemsListQueryVariables>(SellableItemsListDocument, options);
      }
export function useSellableItemsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemsListQuery, SellableItemsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemsListQuery, SellableItemsListQueryVariables>(SellableItemsListDocument, options);
        }
export type SellableItemsListQueryHookResult = ReturnType<typeof useSellableItemsListQuery>;
export type SellableItemsListLazyQueryHookResult = ReturnType<typeof useSellableItemsListLazyQuery>;
export type SellableItemsListQueryResult = Apollo.QueryResult<SellableItemsListQuery, SellableItemsListQueryVariables>;
export const SellableItemsDetailDocument = gql`
    query SellableItemsDetail($id: ID!) {
  sellableItemDetail(id: $id) {
    ...SellableItemDetailsFrag
  }
}
    ${SellableItemDetailsFragFragmentDoc}`;

/**
 * __useSellableItemsDetailQuery__
 *
 * To run a query within a React component, call `useSellableItemsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemsDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSellableItemsDetailQuery(baseOptions: Apollo.QueryHookOptions<SellableItemsDetailQuery, SellableItemsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemsDetailQuery, SellableItemsDetailQueryVariables>(SellableItemsDetailDocument, options);
      }
export function useSellableItemsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemsDetailQuery, SellableItemsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemsDetailQuery, SellableItemsDetailQueryVariables>(SellableItemsDetailDocument, options);
        }
export type SellableItemsDetailQueryHookResult = ReturnType<typeof useSellableItemsDetailQuery>;
export type SellableItemsDetailLazyQueryHookResult = ReturnType<typeof useSellableItemsDetailLazyQuery>;
export type SellableItemsDetailQueryResult = Apollo.QueryResult<SellableItemsDetailQuery, SellableItemsDetailQueryVariables>;
export const SellableItemsStockListDocument = gql`
    query SellableItemsStockList($first: Int, $skip: Int, $query: String, $filter: SellableItemStockFilterInput) {
  sellableItemStock(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    offerStockCount
    holdStockCount
    currentStockCount
    bookedStockCount
    totalStockCount @client
    isLive
    rejectedStockCount
    groupVisibility {
      id
      name
    }
    distributionCentre {
      id
      name
      address {
        id
        village
        address
        district
      }
    }
    sellableItem {
      id
      codename
      shortDescription
      name
    }
  }
}
    `;

/**
 * __useSellableItemsStockListQuery__
 *
 * To run a query within a React component, call `useSellableItemsStockListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemsStockListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemsStockListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSellableItemsStockListQuery(baseOptions?: Apollo.QueryHookOptions<SellableItemsStockListQuery, SellableItemsStockListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemsStockListQuery, SellableItemsStockListQueryVariables>(SellableItemsStockListDocument, options);
      }
export function useSellableItemsStockListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemsStockListQuery, SellableItemsStockListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemsStockListQuery, SellableItemsStockListQueryVariables>(SellableItemsStockListDocument, options);
        }
export type SellableItemsStockListQueryHookResult = ReturnType<typeof useSellableItemsStockListQuery>;
export type SellableItemsStockListLazyQueryHookResult = ReturnType<typeof useSellableItemsStockListLazyQuery>;
export type SellableItemsStockListQueryResult = Apollo.QueryResult<SellableItemsStockListQuery, SellableItemsStockListQueryVariables>;
export const SellableItemStockDetailDocument = gql`
    query SellableItemStockDetail($first: Int, $skip: Int, $query: String, $filter: SellableItemStockFilterInput) {
  sellableItemStock(query: $query, first: $first, skip: $skip, filter: $filter) {
    ...SellableItemStockDetailFrag
  }
}
    ${SellableItemStockDetailFragFragmentDoc}`;

/**
 * __useSellableItemStockDetailQuery__
 *
 * To run a query within a React component, call `useSellableItemStockDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemStockDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemStockDetailQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSellableItemStockDetailQuery(baseOptions?: Apollo.QueryHookOptions<SellableItemStockDetailQuery, SellableItemStockDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemStockDetailQuery, SellableItemStockDetailQueryVariables>(SellableItemStockDetailDocument, options);
      }
export function useSellableItemStockDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemStockDetailQuery, SellableItemStockDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemStockDetailQuery, SellableItemStockDetailQueryVariables>(SellableItemStockDetailDocument, options);
        }
export type SellableItemStockDetailQueryHookResult = ReturnType<typeof useSellableItemStockDetailQuery>;
export type SellableItemStockDetailLazyQueryHookResult = ReturnType<typeof useSellableItemStockDetailLazyQuery>;
export type SellableItemStockDetailQueryResult = Apollo.QueryResult<SellableItemStockDetailQuery, SellableItemStockDetailQueryVariables>;
export const SellableItemsSuggestDocument = gql`
    query SellableItemsSuggest($first: Int, $skip: Int, $query: String, $filter: SellableItemFilterInput, $distributionCentreId: ID) {
  allSellableItems(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    name
    codename
    sellableVarieties {
      id
      variety {
        id
        primaryGroup {
          id
          name
        }
      }
    }
    sellableStocks(distributionCentreId: $distributionCentreId) {
      id
      currentStockCount
      holdStockCount
      rejectedStockCount
      bookedStockCount
      offerStockCount
    }
  }
}
    `;

/**
 * __useSellableItemsSuggestQuery__
 *
 * To run a query within a React component, call `useSellableItemsSuggestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemsSuggestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemsSuggestQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *      distributionCentreId: // value for 'distributionCentreId'
 *   },
 * });
 */
export function useSellableItemsSuggestQuery(baseOptions?: Apollo.QueryHookOptions<SellableItemsSuggestQuery, SellableItemsSuggestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemsSuggestQuery, SellableItemsSuggestQueryVariables>(SellableItemsSuggestDocument, options);
      }
export function useSellableItemsSuggestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemsSuggestQuery, SellableItemsSuggestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemsSuggestQuery, SellableItemsSuggestQueryVariables>(SellableItemsSuggestDocument, options);
        }
export type SellableItemsSuggestQueryHookResult = ReturnType<typeof useSellableItemsSuggestQuery>;
export type SellableItemsSuggestLazyQueryHookResult = ReturnType<typeof useSellableItemsSuggestLazyQuery>;
export type SellableItemsSuggestQueryResult = Apollo.QueryResult<SellableItemsSuggestQuery, SellableItemsSuggestQueryVariables>;
export const RelatedStocksDocument = gql`
    query RelatedStocks($sellableItem: ID) {
  sellableItemStock(filter: {sellableItem: $sellableItem}) {
    ...RelatedStockFrag
  }
}
    ${RelatedStockFragFragmentDoc}`;

/**
 * __useRelatedStocksQuery__
 *
 * To run a query within a React component, call `useRelatedStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedStocksQuery({
 *   variables: {
 *      sellableItem: // value for 'sellableItem'
 *   },
 * });
 */
export function useRelatedStocksQuery(baseOptions?: Apollo.QueryHookOptions<RelatedStocksQuery, RelatedStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedStocksQuery, RelatedStocksQueryVariables>(RelatedStocksDocument, options);
      }
export function useRelatedStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedStocksQuery, RelatedStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedStocksQuery, RelatedStocksQueryVariables>(RelatedStocksDocument, options);
        }
export type RelatedStocksQueryHookResult = ReturnType<typeof useRelatedStocksQuery>;
export type RelatedStocksLazyQueryHookResult = ReturnType<typeof useRelatedStocksLazyQuery>;
export type RelatedStocksQueryResult = Apollo.QueryResult<RelatedStocksQuery, RelatedStocksQueryVariables>;
export const AllBatchStocksDocument = gql`
    query allBatchStocks($filter: BatchStockFilterInput) {
  allBatchStocks(filter: $filter) {
    id
    codename
    manufacturedOn
    manufacturedBy {
      id
      name
    }
    suppliedBy {
      id
      name
    }
    expiryOn
    sku {
      id
      name
    }
    totalQuantity
    currentStockCount
    holdStockCount
    alternateStockCount
    intransitStockCount
    dumpedStockCount
    parentBatchStock {
      id
      codename
    }
    coaCertificate
  }
}
    `;

/**
 * __useAllBatchStocksQuery__
 *
 * To run a query within a React component, call `useAllBatchStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBatchStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBatchStocksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllBatchStocksQuery(baseOptions?: Apollo.QueryHookOptions<AllBatchStocksQuery, AllBatchStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBatchStocksQuery, AllBatchStocksQueryVariables>(AllBatchStocksDocument, options);
      }
export function useAllBatchStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBatchStocksQuery, AllBatchStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBatchStocksQuery, AllBatchStocksQueryVariables>(AllBatchStocksDocument, options);
        }
export type AllBatchStocksQueryHookResult = ReturnType<typeof useAllBatchStocksQuery>;
export type AllBatchStocksLazyQueryHookResult = ReturnType<typeof useAllBatchStocksLazyQuery>;
export type AllBatchStocksQueryResult = Apollo.QueryResult<AllBatchStocksQuery, AllBatchStocksQueryVariables>;
export const AllSkuTypesListDocument = gql`
    query allSkuTypesList($query: String, $first: Int, $skip: Int) {
  allSkuTypes(query: $query, first: $first, skip: $skip) {
    ...SkuDetailFrag
  }
}
    ${SkuDetailFragFragmentDoc}`;

/**
 * __useAllSkuTypesListQuery__
 *
 * To run a query within a React component, call `useAllSkuTypesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSkuTypesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSkuTypesListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAllSkuTypesListQuery(baseOptions?: Apollo.QueryHookOptions<AllSkuTypesListQuery, AllSkuTypesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSkuTypesListQuery, AllSkuTypesListQueryVariables>(AllSkuTypesListDocument, options);
      }
export function useAllSkuTypesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSkuTypesListQuery, AllSkuTypesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSkuTypesListQuery, AllSkuTypesListQueryVariables>(AllSkuTypesListDocument, options);
        }
export type AllSkuTypesListQueryHookResult = ReturnType<typeof useAllSkuTypesListQuery>;
export type AllSkuTypesListLazyQueryHookResult = ReturnType<typeof useAllSkuTypesListLazyQuery>;
export type AllSkuTypesListQueryResult = Apollo.QueryResult<AllSkuTypesListQuery, AllSkuTypesListQueryVariables>;
export const SkuDetailsDocument = gql`
    query skuDetails($id: Int!) {
  skuDetails(skuId: $id) {
    ...SkuDetailFrag
  }
}
    ${SkuDetailFragFragmentDoc}`;

/**
 * __useSkuDetailsQuery__
 *
 * To run a query within a React component, call `useSkuDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkuDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkuDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkuDetailsQuery(baseOptions: Apollo.QueryHookOptions<SkuDetailsQuery, SkuDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkuDetailsQuery, SkuDetailsQueryVariables>(SkuDetailsDocument, options);
      }
export function useSkuDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkuDetailsQuery, SkuDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkuDetailsQuery, SkuDetailsQueryVariables>(SkuDetailsDocument, options);
        }
export type SkuDetailsQueryHookResult = ReturnType<typeof useSkuDetailsQuery>;
export type SkuDetailsLazyQueryHookResult = ReturnType<typeof useSkuDetailsLazyQuery>;
export type SkuDetailsQueryResult = Apollo.QueryResult<SkuDetailsQuery, SkuDetailsQueryVariables>;
export const AddSkutypeDocument = gql`
    mutation addSkutype($id: ID, $capacity: Float, $capacityUnit: Int, $description: String, $name: String, $selfWeight: Float, $stockCount: Int, $skuCategory: ID, $dimensionUnit: ID, $dimensions: [Float], $isReturnable: Boolean, $unitPrice: Float, $metadata: JSONString) {
  addUpdateSkuType(
    id: $id
    capacity: $capacity
    capacityUnitId: $capacityUnit
    isReturnable: $isReturnable
    unitPrice: $unitPrice
    name: $name
    description: $description
    selfWeight: $selfWeight
    stockCount: $stockCount
    skuCategoryId: $skuCategory
    dimensionUnitId: $dimensionUnit
    dimensions: $dimensions
    metadata: $metadata
  ) {
    skuType {
      ...SkuDetailFrag
    }
  }
}
    ${SkuDetailFragFragmentDoc}`;
export type AddSkutypeMutationFn = Apollo.MutationFunction<AddSkutypeMutation, AddSkutypeMutationVariables>;

/**
 * __useAddSkutypeMutation__
 *
 * To run a mutation, you first call `useAddSkutypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSkutypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSkutypeMutation, { data, loading, error }] = useAddSkutypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      capacity: // value for 'capacity'
 *      capacityUnit: // value for 'capacityUnit'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      selfWeight: // value for 'selfWeight'
 *      stockCount: // value for 'stockCount'
 *      skuCategory: // value for 'skuCategory'
 *      dimensionUnit: // value for 'dimensionUnit'
 *      dimensions: // value for 'dimensions'
 *      isReturnable: // value for 'isReturnable'
 *      unitPrice: // value for 'unitPrice'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAddSkutypeMutation(baseOptions?: Apollo.MutationHookOptions<AddSkutypeMutation, AddSkutypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSkutypeMutation, AddSkutypeMutationVariables>(AddSkutypeDocument, options);
      }
export type AddSkutypeMutationHookResult = ReturnType<typeof useAddSkutypeMutation>;
export type AddSkutypeMutationResult = Apollo.MutationResult<AddSkutypeMutation>;
export type AddSkutypeMutationOptions = Apollo.BaseMutationOptions<AddSkutypeMutation, AddSkutypeMutationVariables>;
export const DcListDocument = gql`
    query DCList($date: Date, $skip: Int, $first: Int) {
  dcWiseAggregateVisibility(date: $date, skip: $skip, first: $first) {
    dc {
      id
      name
    }
    opening
    closing
    inwarded
    inTransit
    delivered
    returned
    directSale
    disposal
  }
}
    `;

/**
 * __useDcListQuery__
 *
 * To run a query within a React component, call `useDcListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDcListQuery(baseOptions?: Apollo.QueryHookOptions<DcListQuery, DcListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcListQuery, DcListQueryVariables>(DcListDocument, options);
      }
export function useDcListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcListQuery, DcListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcListQuery, DcListQueryVariables>(DcListDocument, options);
        }
export type DcListQueryHookResult = ReturnType<typeof useDcListQuery>;
export type DcListLazyQueryHookResult = ReturnType<typeof useDcListLazyQuery>;
export type DcListQueryResult = Apollo.QueryResult<DcListQuery, DcListQueryVariables>;
export const SellableItemListDocument = gql`
    query SellableItemList($date: Date, $filter: SellableItemWiseStockVisibilityFilterInput, $skip: Int, $first: Int) {
  sellableItemWiseStockVisibility(
    date: $date
    filters: $filter
    skip: $skip
    first: $first
  ) {
    sellableItem {
      id
      name
    }
    opening
    closing
    inwarded
    inTransit
    delivered
    returned
    directSale
    disposal
    activeStockCount
  }
}
    `;

/**
 * __useSellableItemListQuery__
 *
 * To run a query within a React component, call `useSellableItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSellableItemListQuery(baseOptions?: Apollo.QueryHookOptions<SellableItemListQuery, SellableItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemListQuery, SellableItemListQueryVariables>(SellableItemListDocument, options);
      }
export function useSellableItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemListQuery, SellableItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemListQuery, SellableItemListQueryVariables>(SellableItemListDocument, options);
        }
export type SellableItemListQueryHookResult = ReturnType<typeof useSellableItemListQuery>;
export type SellableItemListLazyQueryHookResult = ReturnType<typeof useSellableItemListLazyQuery>;
export type SellableItemListQueryResult = Apollo.QueryResult<SellableItemListQuery, SellableItemListQueryVariables>;
export const SellableListSubItemsDocument = gql`
    query SellableListSubItems($date: Date) {
  batchStockWiseVisibility(date: $date) {
    batchStock {
      id
    }
    opening
    closing
    inwarded
    inTransit
    delivered
    returned
    directSale
    disposal
  }
}
    `;

/**
 * __useSellableListSubItemsQuery__
 *
 * To run a query within a React component, call `useSellableListSubItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableListSubItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableListSubItemsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSellableListSubItemsQuery(baseOptions?: Apollo.QueryHookOptions<SellableListSubItemsQuery, SellableListSubItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableListSubItemsQuery, SellableListSubItemsQueryVariables>(SellableListSubItemsDocument, options);
      }
export function useSellableListSubItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableListSubItemsQuery, SellableListSubItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableListSubItemsQuery, SellableListSubItemsQueryVariables>(SellableListSubItemsDocument, options);
        }
export type SellableListSubItemsQueryHookResult = ReturnType<typeof useSellableListSubItemsQuery>;
export type SellableListSubItemsLazyQueryHookResult = ReturnType<typeof useSellableListSubItemsLazyQuery>;
export type SellableListSubItemsQueryResult = Apollo.QueryResult<SellableListSubItemsQuery, SellableListSubItemsQueryVariables>;
export const ApproveRequestDocument = gql`
    mutation ApproveRequest($obj: StockTakeApprovalRequestInput) {
  addUpdateStockTakeApproval(obj: $obj) {
    approvalRequest {
      id
      status
    }
  }
}
    `;
export type ApproveRequestMutationFn = Apollo.MutationFunction<ApproveRequestMutation, ApproveRequestMutationVariables>;

/**
 * __useApproveRequestMutation__
 *
 * To run a mutation, you first call `useApproveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRequestMutation, { data, loading, error }] = useApproveRequestMutation({
 *   variables: {
 *      obj: // value for 'obj'
 *   },
 * });
 */
export function useApproveRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRequestMutation, ApproveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRequestMutation, ApproveRequestMutationVariables>(ApproveRequestDocument, options);
      }
export type ApproveRequestMutationHookResult = ReturnType<typeof useApproveRequestMutation>;
export type ApproveRequestMutationResult = Apollo.MutationResult<ApproveRequestMutation>;
export type ApproveRequestMutationOptions = Apollo.BaseMutationOptions<ApproveRequestMutation, ApproveRequestMutationVariables>;
export const ApprovalListDocument = gql`
    query ApprovalList($filter: StockTakeApprovalRequestInput, $query: String, $first: Int, $skip: Int) {
  aggregateStockTakeApprovalRequestsByDc(
    filter: $filter
    query: $query
    first: $first
    skip: $skip
  ) {
    distributionCentre {
      id
      name
      codename
    }
    totalRequests
    pendingRequests
    approvedRequests
    rejectedRequests
    requestedBy {
      id
      fullName
    }
    requestedAt
    requestedBy {
      id
      fullName
    }
  }
}
    `;

/**
 * __useApprovalListQuery__
 *
 * To run a query within a React component, call `useApprovalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useApprovalListQuery(baseOptions?: Apollo.QueryHookOptions<ApprovalListQuery, ApprovalListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalListQuery, ApprovalListQueryVariables>(ApprovalListDocument, options);
      }
export function useApprovalListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalListQuery, ApprovalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalListQuery, ApprovalListQueryVariables>(ApprovalListDocument, options);
        }
export type ApprovalListQueryHookResult = ReturnType<typeof useApprovalListQuery>;
export type ApprovalListLazyQueryHookResult = ReturnType<typeof useApprovalListLazyQuery>;
export type ApprovalListQueryResult = Apollo.QueryResult<ApprovalListQuery, ApprovalListQueryVariables>;
export const DcRequestsListDocument = gql`
    query DCRequestsList($filter: StockTakeApprovalRequestInput) {
  allStockTakeApprovalRequests(filter: $filter) {
    id
    status
    requestedAt
    requestedBy {
      id
      fullName
      number
    }
    stockEntryItem {
      id
      batchStock {
        id
        codename
        suppliedBy {
          id
        }
      }
      sellableItem {
        id
        name
        primaryPhoto {
          id
          url
        }
      }
      subLocation {
        id
        name
      }
      grade
      quantity
      addedOn
      systemCount
      remark
    }
  }
}
    `;

/**
 * __useDcRequestsListQuery__
 *
 * To run a query within a React component, call `useDcRequestsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcRequestsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcRequestsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDcRequestsListQuery(baseOptions?: Apollo.QueryHookOptions<DcRequestsListQuery, DcRequestsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcRequestsListQuery, DcRequestsListQueryVariables>(DcRequestsListDocument, options);
      }
export function useDcRequestsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcRequestsListQuery, DcRequestsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcRequestsListQuery, DcRequestsListQueryVariables>(DcRequestsListDocument, options);
        }
export type DcRequestsListQueryHookResult = ReturnType<typeof useDcRequestsListQuery>;
export type DcRequestsListLazyQueryHookResult = ReturnType<typeof useDcRequestsListLazyQuery>;
export type DcRequestsListQueryResult = Apollo.QueryResult<DcRequestsListQuery, DcRequestsListQueryVariables>;
export const AddUpdateBatchStockMutationDocument = gql`
    mutation addUpdateBatchStockMutation($id: ID, $data: BatchStockInput!) {
  addUpdateBatchStock(id: $id, data: $data) {
    batchStock {
      id
      codename
      coaCertificate
    }
  }
}
    `;
export type AddUpdateBatchStockMutationMutationFn = Apollo.MutationFunction<AddUpdateBatchStockMutationMutation, AddUpdateBatchStockMutationMutationVariables>;

/**
 * __useAddUpdateBatchStockMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdateBatchStockMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateBatchStockMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateBatchStockMutationMutation, { data, loading, error }] = useAddUpdateBatchStockMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUpdateBatchStockMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateBatchStockMutationMutation, AddUpdateBatchStockMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateBatchStockMutationMutation, AddUpdateBatchStockMutationMutationVariables>(AddUpdateBatchStockMutationDocument, options);
      }
export type AddUpdateBatchStockMutationMutationHookResult = ReturnType<typeof useAddUpdateBatchStockMutationMutation>;
export type AddUpdateBatchStockMutationMutationResult = Apollo.MutationResult<AddUpdateBatchStockMutationMutation>;
export type AddUpdateBatchStockMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdateBatchStockMutationMutation, AddUpdateBatchStockMutationMutationVariables>;
export const BatchStockDetailDocument = gql`
    query batchStockDetail($id: ID!) {
  batchStockDetail(id: $id) {
    id
    codename
    manufacturedOn
    expiryOn
    totalQuantity
    currentStockCount
    holdStockCount
    alternateStockCount
    intransitStockCount
    dumpedStockCount
    coaCertificate
    sku {
      id
      name
    }
    sellableItem {
      id
      name
      codename
    }
    manufacturedBy {
      id
      name
    }
    suppliedBy {
      id
      name
    }
    parentBatchStock {
      id
      codename
    }
  }
}
    `;

/**
 * __useBatchStockDetailQuery__
 *
 * To run a query within a React component, call `useBatchStockDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchStockDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchStockDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBatchStockDetailQuery(baseOptions: Apollo.QueryHookOptions<BatchStockDetailQuery, BatchStockDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BatchStockDetailQuery, BatchStockDetailQueryVariables>(BatchStockDetailDocument, options);
      }
export function useBatchStockDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BatchStockDetailQuery, BatchStockDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BatchStockDetailQuery, BatchStockDetailQueryVariables>(BatchStockDetailDocument, options);
        }
export type BatchStockDetailQueryHookResult = ReturnType<typeof useBatchStockDetailQuery>;
export type BatchStockDetailLazyQueryHookResult = ReturnType<typeof useBatchStockDetailLazyQuery>;
export type BatchStockDetailQueryResult = Apollo.QueryResult<BatchStockDetailQuery, BatchStockDetailQueryVariables>;
export const SellableItemStockSelectorDocument = gql`
    query sellableItemStockSelector($skip: Int, $first: Int, $query: String, $filter: SellableItemStockFilterInput) {
  sellableItemStock(skip: $skip, first: $first, query: $query, filter: $filter) {
    id
    discountedRate
    unitRate
    offerStockCount
    sellableItem {
      id
      name
    }
    relatedStock {
      id
      offerStockCount
    }
    distributionCentre {
      id
      name
    }
    groupVisibility {
      id
      name
    }
  }
}
    `;

/**
 * __useSellableItemStockSelectorQuery__
 *
 * To run a query within a React component, call `useSellableItemStockSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSellableItemStockSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSellableItemStockSelectorQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSellableItemStockSelectorQuery(baseOptions?: Apollo.QueryHookOptions<SellableItemStockSelectorQuery, SellableItemStockSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SellableItemStockSelectorQuery, SellableItemStockSelectorQueryVariables>(SellableItemStockSelectorDocument, options);
      }
export function useSellableItemStockSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SellableItemStockSelectorQuery, SellableItemStockSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SellableItemStockSelectorQuery, SellableItemStockSelectorQueryVariables>(SellableItemStockSelectorDocument, options);
        }
export type SellableItemStockSelectorQueryHookResult = ReturnType<typeof useSellableItemStockSelectorQuery>;
export type SellableItemStockSelectorLazyQueryHookResult = ReturnType<typeof useSellableItemStockSelectorLazyQuery>;
export type SellableItemStockSelectorQueryResult = Apollo.QueryResult<SellableItemStockSelectorQuery, SellableItemStockSelectorQueryVariables>;
export const BulkUpdatePlotCommodityMutationDocument = gql`
    mutation BulkUpdatePlotCommodityMutation($agronomist: Int, $isArchived: Boolean, $plotStatus: String, $plotCommodities: [Int!]!, $generatePoPlotWise: Boolean) {
  bulkUpdatePlotCommodity(
    agronomist: $agronomist
    isArchived: $isArchived
    plotStatus: $plotStatus
    plotCommodities: $plotCommodities
    generatePoPlotWise: $generatePoPlotWise
  ) {
    plotCommodities {
      ...PlotCommodityFrag
    }
  }
}
    ${PlotCommodityFragFragmentDoc}`;
export type BulkUpdatePlotCommodityMutationMutationFn = Apollo.MutationFunction<BulkUpdatePlotCommodityMutationMutation, BulkUpdatePlotCommodityMutationMutationVariables>;

/**
 * __useBulkUpdatePlotCommodityMutationMutation__
 *
 * To run a mutation, you first call `useBulkUpdatePlotCommodityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdatePlotCommodityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdatePlotCommodityMutationMutation, { data, loading, error }] = useBulkUpdatePlotCommodityMutationMutation({
 *   variables: {
 *      agronomist: // value for 'agronomist'
 *      isArchived: // value for 'isArchived'
 *      plotStatus: // value for 'plotStatus'
 *      plotCommodities: // value for 'plotCommodities'
 *      generatePoPlotWise: // value for 'generatePoPlotWise'
 *   },
 * });
 */
export function useBulkUpdatePlotCommodityMutationMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdatePlotCommodityMutationMutation, BulkUpdatePlotCommodityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdatePlotCommodityMutationMutation, BulkUpdatePlotCommodityMutationMutationVariables>(BulkUpdatePlotCommodityMutationDocument, options);
      }
export type BulkUpdatePlotCommodityMutationMutationHookResult = ReturnType<typeof useBulkUpdatePlotCommodityMutationMutation>;
export type BulkUpdatePlotCommodityMutationMutationResult = Apollo.MutationResult<BulkUpdatePlotCommodityMutationMutation>;
export type BulkUpdatePlotCommodityMutationMutationOptions = Apollo.BaseMutationOptions<BulkUpdatePlotCommodityMutationMutation, BulkUpdatePlotCommodityMutationMutationVariables>;
export const AddUpdatePlotCommoditySamplesMutationDocument = gql`
    mutation AddUpdatePlotCommoditySamplesMutation($plotCommodityId: Int!, $samples: [PlotCommoditySampleInput]!) {
  addUpdatePlotSample(plotCommodity: $plotCommodityId, samples: $samples) {
    plotCommodity {
      ...PlotCommodityFrag
    }
  }
}
    ${PlotCommodityFragFragmentDoc}`;
export type AddUpdatePlotCommoditySamplesMutationMutationFn = Apollo.MutationFunction<AddUpdatePlotCommoditySamplesMutationMutation, AddUpdatePlotCommoditySamplesMutationMutationVariables>;

/**
 * __useAddUpdatePlotCommoditySamplesMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdatePlotCommoditySamplesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdatePlotCommoditySamplesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdatePlotCommoditySamplesMutationMutation, { data, loading, error }] = useAddUpdatePlotCommoditySamplesMutationMutation({
 *   variables: {
 *      plotCommodityId: // value for 'plotCommodityId'
 *      samples: // value for 'samples'
 *   },
 * });
 */
export function useAddUpdatePlotCommoditySamplesMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdatePlotCommoditySamplesMutationMutation, AddUpdatePlotCommoditySamplesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdatePlotCommoditySamplesMutationMutation, AddUpdatePlotCommoditySamplesMutationMutationVariables>(AddUpdatePlotCommoditySamplesMutationDocument, options);
      }
export type AddUpdatePlotCommoditySamplesMutationMutationHookResult = ReturnType<typeof useAddUpdatePlotCommoditySamplesMutationMutation>;
export type AddUpdatePlotCommoditySamplesMutationMutationResult = Apollo.MutationResult<AddUpdatePlotCommoditySamplesMutationMutation>;
export type AddUpdatePlotCommoditySamplesMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdatePlotCommoditySamplesMutationMutation, AddUpdatePlotCommoditySamplesMutationMutationVariables>;
export const AllPlotCommoditiesListDocument = gql`
    query AllPlotCommoditiesList($first: Int, $skip: Int, $query: String, $filter: PlotCommodityFilterInput!) {
  allPlotCommodities(first: $first, skip: $skip, query: $query, filter: $filter) {
    ...PlotCommodityFrag
  }
}
    ${PlotCommodityFragFragmentDoc}`;

/**
 * __useAllPlotCommoditiesListQuery__
 *
 * To run a query within a React component, call `useAllPlotCommoditiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlotCommoditiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlotCommoditiesListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllPlotCommoditiesListQuery(baseOptions: Apollo.QueryHookOptions<AllPlotCommoditiesListQuery, AllPlotCommoditiesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlotCommoditiesListQuery, AllPlotCommoditiesListQueryVariables>(AllPlotCommoditiesListDocument, options);
      }
export function useAllPlotCommoditiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlotCommoditiesListQuery, AllPlotCommoditiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlotCommoditiesListQuery, AllPlotCommoditiesListQueryVariables>(AllPlotCommoditiesListDocument, options);
        }
export type AllPlotCommoditiesListQueryHookResult = ReturnType<typeof useAllPlotCommoditiesListQuery>;
export type AllPlotCommoditiesListLazyQueryHookResult = ReturnType<typeof useAllPlotCommoditiesListLazyQuery>;
export type AllPlotCommoditiesListQueryResult = Apollo.QueryResult<AllPlotCommoditiesListQuery, AllPlotCommoditiesListQueryVariables>;
export const PlotCommoditySamplesDocument = gql`
    query PlotCommoditySamples($id: ID) {
  plotCommodityDetails(id: $id) {
    id
    samples {
      ...PlotSampleFrag
    }
  }
}
    ${PlotSampleFragFragmentDoc}`;

/**
 * __usePlotCommoditySamplesQuery__
 *
 * To run a query within a React component, call `usePlotCommoditySamplesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlotCommoditySamplesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlotCommoditySamplesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlotCommoditySamplesQuery(baseOptions?: Apollo.QueryHookOptions<PlotCommoditySamplesQuery, PlotCommoditySamplesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlotCommoditySamplesQuery, PlotCommoditySamplesQueryVariables>(PlotCommoditySamplesDocument, options);
      }
export function usePlotCommoditySamplesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlotCommoditySamplesQuery, PlotCommoditySamplesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlotCommoditySamplesQuery, PlotCommoditySamplesQueryVariables>(PlotCommoditySamplesDocument, options);
        }
export type PlotCommoditySamplesQueryHookResult = ReturnType<typeof usePlotCommoditySamplesQuery>;
export type PlotCommoditySamplesLazyQueryHookResult = ReturnType<typeof usePlotCommoditySamplesLazyQuery>;
export type PlotCommoditySamplesQueryResult = Apollo.QueryResult<PlotCommoditySamplesQuery, PlotCommoditySamplesQueryVariables>;
export const SearchPlotCommoditiesDocument = gql`
    query SearchPlotCommodities($query: String!, $first: Int, $skip: Int, $companies: [Int], $filter: SearchPlotCommodityFilterInput) {
  searchPlotCommodity(
    query: $query
    first: $first
    skip: $skip
    companies: $companies
    filter: $filter
  ) {
    id
    name
    referenceId
    status
    lastTradeProfile {
      id
      category
    }
    plot {
      farmer {
        id
        isBlocked
      }
    }
    variety {
      id
      name
      preferredSku {
        id
        name
      }
      commodity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchPlotCommoditiesQuery__
 *
 * To run a query within a React component, call `useSearchPlotCommoditiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPlotCommoditiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPlotCommoditiesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      companies: // value for 'companies'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchPlotCommoditiesQuery(baseOptions: Apollo.QueryHookOptions<SearchPlotCommoditiesQuery, SearchPlotCommoditiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPlotCommoditiesQuery, SearchPlotCommoditiesQueryVariables>(SearchPlotCommoditiesDocument, options);
      }
export function useSearchPlotCommoditiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPlotCommoditiesQuery, SearchPlotCommoditiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPlotCommoditiesQuery, SearchPlotCommoditiesQueryVariables>(SearchPlotCommoditiesDocument, options);
        }
export type SearchPlotCommoditiesQueryHookResult = ReturnType<typeof useSearchPlotCommoditiesQuery>;
export type SearchPlotCommoditiesLazyQueryHookResult = ReturnType<typeof useSearchPlotCommoditiesLazyQuery>;
export type SearchPlotCommoditiesQueryResult = Apollo.QueryResult<SearchPlotCommoditiesQuery, SearchPlotCommoditiesQueryVariables>;
export const PlotCommodityDetailsDocument = gql`
    query PlotCommodityDetails($id: ID!) {
  plotCommodityDetails(id: $id) {
    lastSample {
      id
      detectionCount
      maxDetection
      totalDetection
      chemicalStatusDisplay
      physicalStatusDisplay
      resultPdfUrl
      observations {
        detectionCount
        id
        score
        tags
        qualityParameter {
          id
          name
          codename
          mrl
          standard
          valueType
        }
      }
    }
  }
}
    `;

/**
 * __usePlotCommodityDetailsQuery__
 *
 * To run a query within a React component, call `usePlotCommodityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlotCommodityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlotCommodityDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlotCommodityDetailsQuery(baseOptions: Apollo.QueryHookOptions<PlotCommodityDetailsQuery, PlotCommodityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlotCommodityDetailsQuery, PlotCommodityDetailsQueryVariables>(PlotCommodityDetailsDocument, options);
      }
export function usePlotCommodityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlotCommodityDetailsQuery, PlotCommodityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlotCommodityDetailsQuery, PlotCommodityDetailsQueryVariables>(PlotCommodityDetailsDocument, options);
        }
export type PlotCommodityDetailsQueryHookResult = ReturnType<typeof usePlotCommodityDetailsQuery>;
export type PlotCommodityDetailsLazyQueryHookResult = ReturnType<typeof usePlotCommodityDetailsLazyQuery>;
export type PlotCommodityDetailsQueryResult = Apollo.QueryResult<PlotCommodityDetailsQuery, PlotCommodityDetailsQueryVariables>;
export const SyncKisanhubFarmersDocument = gql`
    query SyncKisanhubFarmers($farmerId: ID) {
  syncFarmerPlots(farmerId: $farmerId) {
    id
    fullName
    customerId
  }
}
    `;

/**
 * __useSyncKisanhubFarmersQuery__
 *
 * To run a query within a React component, call `useSyncKisanhubFarmersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncKisanhubFarmersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncKisanhubFarmersQuery({
 *   variables: {
 *      farmerId: // value for 'farmerId'
 *   },
 * });
 */
export function useSyncKisanhubFarmersQuery(baseOptions?: Apollo.QueryHookOptions<SyncKisanhubFarmersQuery, SyncKisanhubFarmersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncKisanhubFarmersQuery, SyncKisanhubFarmersQueryVariables>(SyncKisanhubFarmersDocument, options);
      }
export function useSyncKisanhubFarmersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncKisanhubFarmersQuery, SyncKisanhubFarmersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncKisanhubFarmersQuery, SyncKisanhubFarmersQueryVariables>(SyncKisanhubFarmersDocument, options);
        }
export type SyncKisanhubFarmersQueryHookResult = ReturnType<typeof useSyncKisanhubFarmersQuery>;
export type SyncKisanhubFarmersLazyQueryHookResult = ReturnType<typeof useSyncKisanhubFarmersLazyQuery>;
export type SyncKisanhubFarmersQueryResult = Apollo.QueryResult<SyncKisanhubFarmersQuery, SyncKisanhubFarmersQueryVariables>;
export const DeleteSurveyAreaDocument = gql`
    mutation DeleteSurveyArea($ids: [ID]!) {
  deleteSurveyArea(ids: $ids) {
    response
  }
}
    `;
export type DeleteSurveyAreaMutationFn = Apollo.MutationFunction<DeleteSurveyAreaMutation, DeleteSurveyAreaMutationVariables>;

/**
 * __useDeleteSurveyAreaMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyAreaMutation, { data, loading, error }] = useDeleteSurveyAreaMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteSurveyAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyAreaMutation, DeleteSurveyAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyAreaMutation, DeleteSurveyAreaMutationVariables>(DeleteSurveyAreaDocument, options);
      }
export type DeleteSurveyAreaMutationHookResult = ReturnType<typeof useDeleteSurveyAreaMutation>;
export type DeleteSurveyAreaMutationResult = Apollo.MutationResult<DeleteSurveyAreaMutation>;
export type DeleteSurveyAreaMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyAreaMutation, DeleteSurveyAreaMutationVariables>;
export const AllSurveyAreasDocument = gql`
    query AllSurveyAreas($query: String, $first: Int, $skip: Int, $filter: SurveyAreaFilterInput) {
  allSurveyAreas(query: $query, first: $first, skip: $skip, filter: $filter) {
    ...SurveyAreaDetailFrag
  }
}
    ${SurveyAreaDetailFragFragmentDoc}`;

/**
 * __useAllSurveyAreasQuery__
 *
 * To run a query within a React component, call `useAllSurveyAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSurveyAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSurveyAreasQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllSurveyAreasQuery(baseOptions?: Apollo.QueryHookOptions<AllSurveyAreasQuery, AllSurveyAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSurveyAreasQuery, AllSurveyAreasQueryVariables>(AllSurveyAreasDocument, options);
      }
export function useAllSurveyAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSurveyAreasQuery, AllSurveyAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSurveyAreasQuery, AllSurveyAreasQueryVariables>(AllSurveyAreasDocument, options);
        }
export type AllSurveyAreasQueryHookResult = ReturnType<typeof useAllSurveyAreasQuery>;
export type AllSurveyAreasLazyQueryHookResult = ReturnType<typeof useAllSurveyAreasLazyQuery>;
export type AllSurveyAreasQueryResult = Apollo.QueryResult<AllSurveyAreasQuery, AllSurveyAreasQueryVariables>;
export const AllSurveyAreasPreviewDocument = gql`
    query AllSurveyAreasPreview($query: String, $first: Int, $skip: Int, $filter: SurveyAreaFilterInput) {
  allSurveyAreas(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    geometry {
      coordinates
    }
  }
}
    `;

/**
 * __useAllSurveyAreasPreviewQuery__
 *
 * To run a query within a React component, call `useAllSurveyAreasPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSurveyAreasPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSurveyAreasPreviewQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllSurveyAreasPreviewQuery(baseOptions?: Apollo.QueryHookOptions<AllSurveyAreasPreviewQuery, AllSurveyAreasPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSurveyAreasPreviewQuery, AllSurveyAreasPreviewQueryVariables>(AllSurveyAreasPreviewDocument, options);
      }
export function useAllSurveyAreasPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSurveyAreasPreviewQuery, AllSurveyAreasPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSurveyAreasPreviewQuery, AllSurveyAreasPreviewQueryVariables>(AllSurveyAreasPreviewDocument, options);
        }
export type AllSurveyAreasPreviewQueryHookResult = ReturnType<typeof useAllSurveyAreasPreviewQuery>;
export type AllSurveyAreasPreviewLazyQueryHookResult = ReturnType<typeof useAllSurveyAreasPreviewLazyQuery>;
export type AllSurveyAreasPreviewQueryResult = Apollo.QueryResult<AllSurveyAreasPreviewQuery, AllSurveyAreasPreviewQueryVariables>;
export const SurveyAreaDetailDocument = gql`
    query SurveyAreaDetail($id: ID!) {
  surveyAreaDetail(id: $id) {
    ...SurveyAreaDetailFrag
  }
}
    ${SurveyAreaDetailFragFragmentDoc}`;

/**
 * __useSurveyAreaDetailQuery__
 *
 * To run a query within a React component, call `useSurveyAreaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyAreaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyAreaDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyAreaDetailQuery(baseOptions: Apollo.QueryHookOptions<SurveyAreaDetailQuery, SurveyAreaDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyAreaDetailQuery, SurveyAreaDetailQueryVariables>(SurveyAreaDetailDocument, options);
      }
export function useSurveyAreaDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyAreaDetailQuery, SurveyAreaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyAreaDetailQuery, SurveyAreaDetailQueryVariables>(SurveyAreaDetailDocument, options);
        }
export type SurveyAreaDetailQueryHookResult = ReturnType<typeof useSurveyAreaDetailQuery>;
export type SurveyAreaDetailLazyQueryHookResult = ReturnType<typeof useSurveyAreaDetailLazyQuery>;
export type SurveyAreaDetailQueryResult = Apollo.QueryResult<SurveyAreaDetailQuery, SurveyAreaDetailQueryVariables>;
export const AllSalesManDocument = gql`
    query AllSalesMan {
  usersByGroup(groupName: "Salesman") {
    id
    fullName
    number
  }
}
    `;

/**
 * __useAllSalesManQuery__
 *
 * To run a query within a React component, call `useAllSalesManQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSalesManQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSalesManQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSalesManQuery(baseOptions?: Apollo.QueryHookOptions<AllSalesManQuery, AllSalesManQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSalesManQuery, AllSalesManQueryVariables>(AllSalesManDocument, options);
      }
export function useAllSalesManLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSalesManQuery, AllSalesManQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSalesManQuery, AllSalesManQueryVariables>(AllSalesManDocument, options);
        }
export type AllSalesManQueryHookResult = ReturnType<typeof useAllSalesManQuery>;
export type AllSalesManLazyQueryHookResult = ReturnType<typeof useAllSalesManLazyQuery>;
export type AllSalesManQueryResult = Apollo.QueryResult<AllSalesManQuery, AllSalesManQueryVariables>;
export const MyDcsDocument = gql`
    query MyDcs {
  me {
    distributionCentres {
      id
      name
      colorCode
      geometry {
        type
        coordinates
      }
    }
  }
}
    `;

/**
 * __useMyDcsQuery__
 *
 * To run a query within a React component, call `useMyDcsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDcsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDcsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDcsQuery(baseOptions?: Apollo.QueryHookOptions<MyDcsQuery, MyDcsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDcsQuery, MyDcsQueryVariables>(MyDcsDocument, options);
      }
export function useMyDcsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDcsQuery, MyDcsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDcsQuery, MyDcsQueryVariables>(MyDcsDocument, options);
        }
export type MyDcsQueryHookResult = ReturnType<typeof useMyDcsQuery>;
export type MyDcsLazyQueryHookResult = ReturnType<typeof useMyDcsLazyQuery>;
export type MyDcsQueryResult = Apollo.QueryResult<MyDcsQuery, MyDcsQueryVariables>;
export const DcPincodesDocument = gql`
    query DcPincodes($query: String, $first: Int, $skip: Int, $filter: SurveyAreaFilterInput) {
  allSurveyAreas(query: $query, first: $first, skip: $skip, filter: $filter) {
    id
    properties {
      id: codename
      name
      distributionCentre {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDcPincodesQuery__
 *
 * To run a query within a React component, call `useDcPincodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcPincodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcPincodesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDcPincodesQuery(baseOptions?: Apollo.QueryHookOptions<DcPincodesQuery, DcPincodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcPincodesQuery, DcPincodesQueryVariables>(DcPincodesDocument, options);
      }
export function useDcPincodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcPincodesQuery, DcPincodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcPincodesQuery, DcPincodesQueryVariables>(DcPincodesDocument, options);
        }
export type DcPincodesQueryHookResult = ReturnType<typeof useDcPincodesQuery>;
export type DcPincodesLazyQueryHookResult = ReturnType<typeof useDcPincodesLazyQuery>;
export type DcPincodesQueryResult = Apollo.QueryResult<DcPincodesQuery, DcPincodesQueryVariables>;
export const AllGroupsDocument = gql`
    query allGroups {
  allGroups {
    id
    name
    userCount
    permissions {
      id
      name
    }
  }
}
    `;

/**
 * __useAllGroupsQuery__
 *
 * To run a query within a React component, call `useAllGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AllGroupsQuery, AllGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGroupsQuery, AllGroupsQueryVariables>(AllGroupsDocument, options);
      }
export function useAllGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGroupsQuery, AllGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGroupsQuery, AllGroupsQueryVariables>(AllGroupsDocument, options);
        }
export type AllGroupsQueryHookResult = ReturnType<typeof useAllGroupsQuery>;
export type AllGroupsLazyQueryHookResult = ReturnType<typeof useAllGroupsLazyQuery>;
export type AllGroupsQueryResult = Apollo.QueryResult<AllGroupsQuery, AllGroupsQueryVariables>;
export const SystemUserDetailsDocument = gql`
    query systemUserDetails($id: Int!) {
  userDetails(userId: $id) {
    ...SystemUserDetailFrag
  }
}
    ${SystemUserDetailFragFragmentDoc}`;

/**
 * __useSystemUserDetailsQuery__
 *
 * To run a query within a React component, call `useSystemUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemUserDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<SystemUserDetailsQuery, SystemUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemUserDetailsQuery, SystemUserDetailsQueryVariables>(SystemUserDetailsDocument, options);
      }
export function useSystemUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemUserDetailsQuery, SystemUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemUserDetailsQuery, SystemUserDetailsQueryVariables>(SystemUserDetailsDocument, options);
        }
export type SystemUserDetailsQueryHookResult = ReturnType<typeof useSystemUserDetailsQuery>;
export type SystemUserDetailsLazyQueryHookResult = ReturnType<typeof useSystemUserDetailsLazyQuery>;
export type SystemUserDetailsQueryResult = Apollo.QueryResult<SystemUserDetailsQuery, SystemUserDetailsQueryVariables>;
export const AllSchedulingOfficersDocument = gql`
    query allSchedulingOfficers($query: String, $groupName: String, $first: Int, $skip: Int) {
  usersByGroup(groupName: $groupName, query: $query, first: $first, skip: $skip) {
    ...SystemUserListFrag
  }
}
    ${SystemUserListFragFragmentDoc}`;

/**
 * __useAllSchedulingOfficersQuery__
 *
 * To run a query within a React component, call `useAllSchedulingOfficersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSchedulingOfficersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSchedulingOfficersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      groupName: // value for 'groupName'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAllSchedulingOfficersQuery(baseOptions?: Apollo.QueryHookOptions<AllSchedulingOfficersQuery, AllSchedulingOfficersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSchedulingOfficersQuery, AllSchedulingOfficersQueryVariables>(AllSchedulingOfficersDocument, options);
      }
export function useAllSchedulingOfficersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSchedulingOfficersQuery, AllSchedulingOfficersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSchedulingOfficersQuery, AllSchedulingOfficersQueryVariables>(AllSchedulingOfficersDocument, options);
        }
export type AllSchedulingOfficersQueryHookResult = ReturnType<typeof useAllSchedulingOfficersQuery>;
export type AllSchedulingOfficersLazyQueryHookResult = ReturnType<typeof useAllSchedulingOfficersLazyQuery>;
export type AllSchedulingOfficersQueryResult = Apollo.QueryResult<AllSchedulingOfficersQuery, AllSchedulingOfficersQueryVariables>;
export const AddUserMutationDocument = gql`
    mutation addUserMutation($id: Int, $username: String!, $number: String!, $groups: [Int], $lastName: String!, $firstName: String!, $dateOfBirth: Date, $departments: [Int], $email: String, $metadata: BaseUserMetadataInput, $education: String, $customerId: String) {
  addUser(
    user: {id: $id, number: $number, groups: $groups, username: $username, lastName: $lastName, firstName: $firstName, dateOfBirth: $dateOfBirth, departments: $departments, email: $email, education: $education, customerId: $customerId, metadata: $metadata}
  ) {
    user {
      ...SystemUserDetailFrag
    }
  }
}
    ${SystemUserDetailFragFragmentDoc}`;
export type AddUserMutationMutationFn = Apollo.MutationFunction<AddUserMutationMutation, AddUserMutationMutationVariables>;

/**
 * __useAddUserMutationMutation__
 *
 * To run a mutation, you first call `useAddUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutationMutation, { data, loading, error }] = useAddUserMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      username: // value for 'username'
 *      number: // value for 'number'
 *      groups: // value for 'groups'
 *      lastName: // value for 'lastName'
 *      firstName: // value for 'firstName'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      departments: // value for 'departments'
 *      email: // value for 'email'
 *      metadata: // value for 'metadata'
 *      education: // value for 'education'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useAddUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutationMutation, AddUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutationMutation, AddUserMutationMutationVariables>(AddUserMutationDocument, options);
      }
export type AddUserMutationMutationHookResult = ReturnType<typeof useAddUserMutationMutation>;
export type AddUserMutationMutationResult = Apollo.MutationResult<AddUserMutationMutation>;
export type AddUserMutationMutationOptions = Apollo.BaseMutationOptions<AddUserMutationMutation, AddUserMutationMutationVariables>;
export const DeleteBaseUserDocument = gql`
    mutation deleteBaseUser($id: Int!) {
  delBaseUser(userId: $id) {
    user {
      id
      number
      status
    }
  }
}
    `;
export type DeleteBaseUserMutationFn = Apollo.MutationFunction<DeleteBaseUserMutation, DeleteBaseUserMutationVariables>;

/**
 * __useDeleteBaseUserMutation__
 *
 * To run a mutation, you first call `useDeleteBaseUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBaseUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBaseUserMutation, { data, loading, error }] = useDeleteBaseUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBaseUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBaseUserMutation, DeleteBaseUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBaseUserMutation, DeleteBaseUserMutationVariables>(DeleteBaseUserDocument, options);
      }
export type DeleteBaseUserMutationHookResult = ReturnType<typeof useDeleteBaseUserMutation>;
export type DeleteBaseUserMutationResult = Apollo.MutationResult<DeleteBaseUserMutation>;
export type DeleteBaseUserMutationOptions = Apollo.BaseMutationOptions<DeleteBaseUserMutation, DeleteBaseUserMutationVariables>;
export const SendUserCredentialsDocument = gql`
    query sendUserCredentials($userId: ID!, $type: String) {
  sendUserCredentials(userId: $userId, mType: $type)
}
    `;

/**
 * __useSendUserCredentialsQuery__
 *
 * To run a query within a React component, call `useSendUserCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendUserCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendUserCredentialsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendUserCredentialsQuery(baseOptions: Apollo.QueryHookOptions<SendUserCredentialsQuery, SendUserCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendUserCredentialsQuery, SendUserCredentialsQueryVariables>(SendUserCredentialsDocument, options);
      }
export function useSendUserCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendUserCredentialsQuery, SendUserCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendUserCredentialsQuery, SendUserCredentialsQueryVariables>(SendUserCredentialsDocument, options);
        }
export type SendUserCredentialsQueryHookResult = ReturnType<typeof useSendUserCredentialsQuery>;
export type SendUserCredentialsLazyQueryHookResult = ReturnType<typeof useSendUserCredentialsLazyQuery>;
export type SendUserCredentialsQueryResult = Apollo.QueryResult<SendUserCredentialsQuery, SendUserCredentialsQueryVariables>;
export const CreateAccountTransactionDocument = gql`
    mutation createAccountTransaction($accountId: ID!, $amount: Float!, $attachment: MediaInput, $paymentMethodId: ID!, $referenceId: String, $remark: String, $status: String!, $transactionId: String, $transactionTypeId: ID!) {
  newAccountTransaction(
    accountId: $accountId
    amount: $amount
    attachment: $attachment
    paymentMethodId: $paymentMethodId
    referenceId: $referenceId
    remark: $remark
    status: $status
    transactionId: $transactionId
    transactionTypeId: $transactionTypeId
  ) {
    accountTransaction {
      id
      account {
        id
        balance
        name
        codename
        accountType {
          id
          name
        }
      }
      attachments {
        id
        url
      }
      paymentMethod {
        id
        name
      }
      referenceId
      remark
      status
      transactionId
      transactionType {
        id
        name
      }
    }
  }
}
    `;
export type CreateAccountTransactionMutationFn = Apollo.MutationFunction<CreateAccountTransactionMutation, CreateAccountTransactionMutationVariables>;

/**
 * __useCreateAccountTransactionMutation__
 *
 * To run a mutation, you first call `useCreateAccountTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountTransactionMutation, { data, loading, error }] = useCreateAccountTransactionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      amount: // value for 'amount'
 *      attachment: // value for 'attachment'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      referenceId: // value for 'referenceId'
 *      remark: // value for 'remark'
 *      status: // value for 'status'
 *      transactionId: // value for 'transactionId'
 *      transactionTypeId: // value for 'transactionTypeId'
 *   },
 * });
 */
export function useCreateAccountTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountTransactionMutation, CreateAccountTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountTransactionMutation, CreateAccountTransactionMutationVariables>(CreateAccountTransactionDocument, options);
      }
export type CreateAccountTransactionMutationHookResult = ReturnType<typeof useCreateAccountTransactionMutation>;
export type CreateAccountTransactionMutationResult = Apollo.MutationResult<CreateAccountTransactionMutation>;
export type CreateAccountTransactionMutationOptions = Apollo.BaseMutationOptions<CreateAccountTransactionMutation, CreateAccountTransactionMutationVariables>;
export const UpdateTripDocument = gql`
    mutation updateTrip($tripId: ID, $vehicleId: ID, $status: String, $date: Date) {
  updateTripDetails(
    trip: $tripId
    vehicleId: $vehicleId
    status: $status
    date: $date
  ) {
    trip {
      id
      date
      status
      vehicle {
        id
        registrationNumber
      }
    }
  }
}
    `;
export type UpdateTripMutationFn = Apollo.MutationFunction<UpdateTripMutation, UpdateTripMutationVariables>;

/**
 * __useUpdateTripMutation__
 *
 * To run a mutation, you first call `useUpdateTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripMutation, { data, loading, error }] = useUpdateTripMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      vehicleId: // value for 'vehicleId'
 *      status: // value for 'status'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateTripMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripMutation, UpdateTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripMutation, UpdateTripMutationVariables>(UpdateTripDocument, options);
      }
export type UpdateTripMutationHookResult = ReturnType<typeof useUpdateTripMutation>;
export type UpdateTripMutationResult = Apollo.MutationResult<UpdateTripMutation>;
export type UpdateTripMutationOptions = Apollo.BaseMutationOptions<UpdateTripMutation, UpdateTripMutationVariables>;
export const AssignedTripSummaryDocument = gql`
    query AssignedTripSummary($date: Date!, $departmentId: ID!, $distributionCenterId: ID) {
  summaryAssignedTrips(
    date: $date
    departmentId: $departmentId
    distributionCenterId: $distributionCenterId
  ) {
    vehicleInPremises
    vehicleInTransit
    vehicleCompleted
    maxBookings
    crateInPremises
    crateInTransit
    crateCompleted
    crateInwarded
  }
}
    `;

/**
 * __useAssignedTripSummaryQuery__
 *
 * To run a query within a React component, call `useAssignedTripSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedTripSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedTripSummaryQuery({
 *   variables: {
 *      date: // value for 'date'
 *      departmentId: // value for 'departmentId'
 *      distributionCenterId: // value for 'distributionCenterId'
 *   },
 * });
 */
export function useAssignedTripSummaryQuery(baseOptions: Apollo.QueryHookOptions<AssignedTripSummaryQuery, AssignedTripSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedTripSummaryQuery, AssignedTripSummaryQueryVariables>(AssignedTripSummaryDocument, options);
      }
export function useAssignedTripSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedTripSummaryQuery, AssignedTripSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedTripSummaryQuery, AssignedTripSummaryQueryVariables>(AssignedTripSummaryDocument, options);
        }
export type AssignedTripSummaryQueryHookResult = ReturnType<typeof useAssignedTripSummaryQuery>;
export type AssignedTripSummaryLazyQueryHookResult = ReturnType<typeof useAssignedTripSummaryLazyQuery>;
export type AssignedTripSummaryQueryResult = Apollo.QueryResult<AssignedTripSummaryQuery, AssignedTripSummaryQueryVariables>;
export const FilterStatusSummaryDocument = gql`
    query FilterStatusSummary($date: Date!, $departmentId: ID!, $distributionCenterId: ID!) {
  summaryFilterDetails(
    date: $date
    departmentId: $departmentId
    distributionCenterId: $distributionCenterId
  ) {
    tripStatus {
      CPCount
      ILCount
      PSCount
      DSCount
      OTCount
      NSCount
    }
  }
}
    `;

/**
 * __useFilterStatusSummaryQuery__
 *
 * To run a query within a React component, call `useFilterStatusSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterStatusSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterStatusSummaryQuery({
 *   variables: {
 *      date: // value for 'date'
 *      departmentId: // value for 'departmentId'
 *      distributionCenterId: // value for 'distributionCenterId'
 *   },
 * });
 */
export function useFilterStatusSummaryQuery(baseOptions: Apollo.QueryHookOptions<FilterStatusSummaryQuery, FilterStatusSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterStatusSummaryQuery, FilterStatusSummaryQueryVariables>(FilterStatusSummaryDocument, options);
      }
export function useFilterStatusSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterStatusSummaryQuery, FilterStatusSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterStatusSummaryQuery, FilterStatusSummaryQueryVariables>(FilterStatusSummaryDocument, options);
        }
export type FilterStatusSummaryQueryHookResult = ReturnType<typeof useFilterStatusSummaryQuery>;
export type FilterStatusSummaryLazyQueryHookResult = ReturnType<typeof useFilterStatusSummaryLazyQuery>;
export type FilterStatusSummaryQueryResult = Apollo.QueryResult<FilterStatusSummaryQuery, FilterStatusSummaryQueryVariables>;
export const AssignedVehiclesTripsListDocument = gql`
    query AssignedVehiclesTripsList($date: Date!, $departmentId: ID!, $first: Int, $skip: Int, $filter: AssignedTripsFilterInput, $query: String) {
  assignedVehiclesTrips(
    date: $date
    departmentId: $departmentId
    first: $first
    skip: $skip
    filter: $filter
    query: $query
  ) {
    ...AssignedTripListFrag
    bookings {
      id
      procuredQuantity
      requiredQuantity
    }
  }
}
    ${AssignedTripListFragFragmentDoc}`;

/**
 * __useAssignedVehiclesTripsListQuery__
 *
 * To run a query within a React component, call `useAssignedVehiclesTripsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedVehiclesTripsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedVehiclesTripsListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      departmentId: // value for 'departmentId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAssignedVehiclesTripsListQuery(baseOptions: Apollo.QueryHookOptions<AssignedVehiclesTripsListQuery, AssignedVehiclesTripsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedVehiclesTripsListQuery, AssignedVehiclesTripsListQueryVariables>(AssignedVehiclesTripsListDocument, options);
      }
export function useAssignedVehiclesTripsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedVehiclesTripsListQuery, AssignedVehiclesTripsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedVehiclesTripsListQuery, AssignedVehiclesTripsListQueryVariables>(AssignedVehiclesTripsListDocument, options);
        }
export type AssignedVehiclesTripsListQueryHookResult = ReturnType<typeof useAssignedVehiclesTripsListQuery>;
export type AssignedVehiclesTripsListLazyQueryHookResult = ReturnType<typeof useAssignedVehiclesTripsListLazyQuery>;
export type AssignedVehiclesTripsListQueryResult = Apollo.QueryResult<AssignedVehiclesTripsListQuery, AssignedVehiclesTripsListQueryVariables>;
export const AssignedVehiclesTripsMapDocument = gql`
    query AssignedVehiclesTripsMap($date: Date!, $departmentId: ID!, $first: Int, $skip: Int, $filter: AssignedTripsFilterInput, $query: String) {
  assignedVehiclesTrips(
    date: $date
    departmentId: $departmentId
    first: $first
    skip: $skip
    filter: $filter
    query: $query
  ) {
    ...AssignedTripMapFrag
  }
}
    ${AssignedTripMapFragFragmentDoc}`;

/**
 * __useAssignedVehiclesTripsMapQuery__
 *
 * To run a query within a React component, call `useAssignedVehiclesTripsMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedVehiclesTripsMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedVehiclesTripsMapQuery({
 *   variables: {
 *      date: // value for 'date'
 *      departmentId: // value for 'departmentId'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAssignedVehiclesTripsMapQuery(baseOptions: Apollo.QueryHookOptions<AssignedVehiclesTripsMapQuery, AssignedVehiclesTripsMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedVehiclesTripsMapQuery, AssignedVehiclesTripsMapQueryVariables>(AssignedVehiclesTripsMapDocument, options);
      }
export function useAssignedVehiclesTripsMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedVehiclesTripsMapQuery, AssignedVehiclesTripsMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedVehiclesTripsMapQuery, AssignedVehiclesTripsMapQueryVariables>(AssignedVehiclesTripsMapDocument, options);
        }
export type AssignedVehiclesTripsMapQueryHookResult = ReturnType<typeof useAssignedVehiclesTripsMapQuery>;
export type AssignedVehiclesTripsMapLazyQueryHookResult = ReturnType<typeof useAssignedVehiclesTripsMapLazyQuery>;
export type AssignedVehiclesTripsMapQueryResult = Apollo.QueryResult<AssignedVehiclesTripsMapQuery, AssignedVehiclesTripsMapQueryVariables>;
export const AssignedTripDetailsDocument = gql`
    query AssignedTripDetails($id: Int, $uuid: String, $vehicleLat: Float, $vehicleLon: Float) {
  tripDetails(tripId: $id, uuid: $uuid) {
    ...AssignedTripListFrag
    unloadedBy {
      id
      name
    }
    optimisedBookings(vehicleLat: $vehicleLat, vehicleLon: $vehicleLon) {
      ...AssignedTripBookingFrag
    }
  }
}
    ${AssignedTripListFragFragmentDoc}
${AssignedTripBookingFragFragmentDoc}`;

/**
 * __useAssignedTripDetailsQuery__
 *
 * To run a query within a React component, call `useAssignedTripDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedTripDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedTripDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *      vehicleLat: // value for 'vehicleLat'
 *      vehicleLon: // value for 'vehicleLon'
 *   },
 * });
 */
export function useAssignedTripDetailsQuery(baseOptions?: Apollo.QueryHookOptions<AssignedTripDetailsQuery, AssignedTripDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedTripDetailsQuery, AssignedTripDetailsQueryVariables>(AssignedTripDetailsDocument, options);
      }
export function useAssignedTripDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedTripDetailsQuery, AssignedTripDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedTripDetailsQuery, AssignedTripDetailsQueryVariables>(AssignedTripDetailsDocument, options);
        }
export type AssignedTripDetailsQueryHookResult = ReturnType<typeof useAssignedTripDetailsQuery>;
export type AssignedTripDetailsLazyQueryHookResult = ReturnType<typeof useAssignedTripDetailsLazyQuery>;
export type AssignedTripDetailsQueryResult = Apollo.QueryResult<AssignedTripDetailsQuery, AssignedTripDetailsQueryVariables>;
export const TripStepGraphDocument = gql`
    query TripStepGraph($uuid: String, $vehicleLat: Float, $vehicleLon: Float) {
  tripStepGraph(uuid: $uuid, vehicleLat: $vehicleLat, vehicleLon: $vehicleLon) {
    stepId
    booking
    bookingObj {
      id
      order {
        id
        trackingCode
      }
    }
    name
    timestamp
    layer
  }
}
    `;

/**
 * __useTripStepGraphQuery__
 *
 * To run a query within a React component, call `useTripStepGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripStepGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripStepGraphQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      vehicleLat: // value for 'vehicleLat'
 *      vehicleLon: // value for 'vehicleLon'
 *   },
 * });
 */
export function useTripStepGraphQuery(baseOptions?: Apollo.QueryHookOptions<TripStepGraphQuery, TripStepGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripStepGraphQuery, TripStepGraphQueryVariables>(TripStepGraphDocument, options);
      }
export function useTripStepGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripStepGraphQuery, TripStepGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripStepGraphQuery, TripStepGraphQueryVariables>(TripStepGraphDocument, options);
        }
export type TripStepGraphQueryHookResult = ReturnType<typeof useTripStepGraphQuery>;
export type TripStepGraphLazyQueryHookResult = ReturnType<typeof useTripStepGraphLazyQuery>;
export type TripStepGraphQueryResult = Apollo.QueryResult<TripStepGraphQuery, TripStepGraphQueryVariables>;
export const TripRecommendationsDocument = gql`
    query TripRecommendations($uuid: ID!, $vehicleLatitude: Float!, $vehicleLongitude: Float!) {
  tripRecommendation(
    uuid: $uuid
    vehicleLatitude: $vehicleLatitude
    vehicleLongitude: $vehicleLongitude
  ) {
    id
    name
    registrationCode
    variety {
      id
      name
      preferredSku {
        id
        name
      }
      commodity {
        id
        name
      }
    }
    plot {
      id
      farmer {
        id
        fullName
        number
      }
      address {
        id
        latitude
        longitude
        district
        village
      }
    }
  }
}
    `;

/**
 * __useTripRecommendationsQuery__
 *
 * To run a query within a React component, call `useTripRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripRecommendationsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      vehicleLatitude: // value for 'vehicleLatitude'
 *      vehicleLongitude: // value for 'vehicleLongitude'
 *   },
 * });
 */
export function useTripRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<TripRecommendationsQuery, TripRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripRecommendationsQuery, TripRecommendationsQueryVariables>(TripRecommendationsDocument, options);
      }
export function useTripRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripRecommendationsQuery, TripRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripRecommendationsQuery, TripRecommendationsQueryVariables>(TripRecommendationsDocument, options);
        }
export type TripRecommendationsQueryHookResult = ReturnType<typeof useTripRecommendationsQuery>;
export type TripRecommendationsLazyQueryHookResult = ReturnType<typeof useTripRecommendationsLazyQuery>;
export type TripRecommendationsQueryResult = Apollo.QueryResult<TripRecommendationsQuery, TripRecommendationsQueryVariables>;
export const FrontEndTripDetailsDocument = gql`
    query frontEndTripDetails($uuid: String) {
  tripDetails(uuid: $uuid) {
    id
    status
    uuid
    vehicle {
      id
      registrationNumber
    }
    aggregator {
      id
      fullName
      number
    }
    unloadedBy {
      id
      name
    }
    sourceDepot {
      id
      name
      location {
        id
        longitude
        latitude
      }
    }
    destinationDepot {
      id
      name
      location {
        id
        latitude
        longitude
      }
    }
    orders {
      id
      trackingCode
      orderStatus
      orderStatusObj @client {
        id
        name
        intent
      }
      user {
        id
        fullName
      }
      shippingAddress {
        id
        village
        district
        latitude
        longitude
      }
      bookingsByTrip(uuid: $uuid) {
        id
        requiredQuantity
        procuredQuantity
        orderItem {
          id
          sellableItem {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFrontEndTripDetailsQuery__
 *
 * To run a query within a React component, call `useFrontEndTripDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontEndTripDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontEndTripDetailsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useFrontEndTripDetailsQuery(baseOptions?: Apollo.QueryHookOptions<FrontEndTripDetailsQuery, FrontEndTripDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrontEndTripDetailsQuery, FrontEndTripDetailsQueryVariables>(FrontEndTripDetailsDocument, options);
      }
export function useFrontEndTripDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrontEndTripDetailsQuery, FrontEndTripDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrontEndTripDetailsQuery, FrontEndTripDetailsQueryVariables>(FrontEndTripDetailsDocument, options);
        }
export type FrontEndTripDetailsQueryHookResult = ReturnType<typeof useFrontEndTripDetailsQuery>;
export type FrontEndTripDetailsLazyQueryHookResult = ReturnType<typeof useFrontEndTripDetailsLazyQuery>;
export type FrontEndTripDetailsQueryResult = Apollo.QueryResult<FrontEndTripDetailsQuery, FrontEndTripDetailsQueryVariables>;
export const TripQualityDocument = gql`
    query TripQuality($id: Int) {
  tripDetails(tripId: $id) {
    id
    bookings {
      id
      inwards {
        ...InwardQualityFrag
      }
    }
  }
}
    ${InwardQualityFragFragmentDoc}`;

/**
 * __useTripQualityQuery__
 *
 * To run a query within a React component, call `useTripQualityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripQualityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripQualityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTripQualityQuery(baseOptions?: Apollo.QueryHookOptions<TripQualityQuery, TripQualityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripQualityQuery, TripQualityQueryVariables>(TripQualityDocument, options);
      }
export function useTripQualityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripQualityQuery, TripQualityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripQualityQuery, TripQualityQueryVariables>(TripQualityDocument, options);
        }
export type TripQualityQueryHookResult = ReturnType<typeof useTripQualityQuery>;
export type TripQualityLazyQueryHookResult = ReturnType<typeof useTripQualityLazyQuery>;
export type TripQualityQueryResult = Apollo.QueryResult<TripQualityQuery, TripQualityQueryVariables>;
export const ToggleBaseUserStatusDocument = gql`
    mutation toggleBaseUserStatus($userId: Int!) {
  delBaseUser(userId: $userId) {
    user {
      id
      fullName
      status
      statusObj @client {
        id
        intent
        name
      }
    }
  }
}
    `;
export type ToggleBaseUserStatusMutationFn = Apollo.MutationFunction<ToggleBaseUserStatusMutation, ToggleBaseUserStatusMutationVariables>;

/**
 * __useToggleBaseUserStatusMutation__
 *
 * To run a mutation, you first call `useToggleBaseUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBaseUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBaseUserStatusMutation, { data, loading, error }] = useToggleBaseUserStatusMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleBaseUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleBaseUserStatusMutation, ToggleBaseUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleBaseUserStatusMutation, ToggleBaseUserStatusMutationVariables>(ToggleBaseUserStatusDocument, options);
      }
export type ToggleBaseUserStatusMutationHookResult = ReturnType<typeof useToggleBaseUserStatusMutation>;
export type ToggleBaseUserStatusMutationResult = Apollo.MutationResult<ToggleBaseUserStatusMutation>;
export type ToggleBaseUserStatusMutationOptions = Apollo.BaseMutationOptions<ToggleBaseUserStatusMutation, ToggleBaseUserStatusMutationVariables>;
export const UpdateFarmerGroupsCompaniesDocument = gql`
    mutation UpdateFarmerGroupsCompanies($id: ID, $companies: [ID], $groups: [ID]) {
  farmerGroupAndCompany(id: $id, companies: $companies, groups: $groups) {
    user {
      id
      ...UserGroupsCompaniesFrag
    }
  }
}
    ${UserGroupsCompaniesFragFragmentDoc}`;
export type UpdateFarmerGroupsCompaniesMutationFn = Apollo.MutationFunction<UpdateFarmerGroupsCompaniesMutation, UpdateFarmerGroupsCompaniesMutationVariables>;

/**
 * __useUpdateFarmerGroupsCompaniesMutation__
 *
 * To run a mutation, you first call `useUpdateFarmerGroupsCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFarmerGroupsCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFarmerGroupsCompaniesMutation, { data, loading, error }] = useUpdateFarmerGroupsCompaniesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companies: // value for 'companies'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useUpdateFarmerGroupsCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFarmerGroupsCompaniesMutation, UpdateFarmerGroupsCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFarmerGroupsCompaniesMutation, UpdateFarmerGroupsCompaniesMutationVariables>(UpdateFarmerGroupsCompaniesDocument, options);
      }
export type UpdateFarmerGroupsCompaniesMutationHookResult = ReturnType<typeof useUpdateFarmerGroupsCompaniesMutation>;
export type UpdateFarmerGroupsCompaniesMutationResult = Apollo.MutationResult<UpdateFarmerGroupsCompaniesMutation>;
export type UpdateFarmerGroupsCompaniesMutationOptions = Apollo.BaseMutationOptions<UpdateFarmerGroupsCompaniesMutation, UpdateFarmerGroupsCompaniesMutationVariables>;
export const FarmerGroupsAndCompaniesDocument = gql`
    query FarmerGroupsAndCompanies($id: Int!) {
  userDetails(userId: $id) {
    id
    ...UserGroupsCompaniesFrag
  }
}
    ${UserGroupsCompaniesFragFragmentDoc}`;

/**
 * __useFarmerGroupsAndCompaniesQuery__
 *
 * To run a query within a React component, call `useFarmerGroupsAndCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFarmerGroupsAndCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmerGroupsAndCompaniesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFarmerGroupsAndCompaniesQuery(baseOptions: Apollo.QueryHookOptions<FarmerGroupsAndCompaniesQuery, FarmerGroupsAndCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FarmerGroupsAndCompaniesQuery, FarmerGroupsAndCompaniesQueryVariables>(FarmerGroupsAndCompaniesDocument, options);
      }
export function useFarmerGroupsAndCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FarmerGroupsAndCompaniesQuery, FarmerGroupsAndCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FarmerGroupsAndCompaniesQuery, FarmerGroupsAndCompaniesQueryVariables>(FarmerGroupsAndCompaniesDocument, options);
        }
export type FarmerGroupsAndCompaniesQueryHookResult = ReturnType<typeof useFarmerGroupsAndCompaniesQuery>;
export type FarmerGroupsAndCompaniesLazyQueryHookResult = ReturnType<typeof useFarmerGroupsAndCompaniesLazyQuery>;
export type FarmerGroupsAndCompaniesQueryResult = Apollo.QueryResult<FarmerGroupsAndCompaniesQuery, FarmerGroupsAndCompaniesQueryVariables>;
export const CreateVehicleExpenseDocument = gql`
    mutation CreateVehicleExpense($borneBy: String, $contractId: ID!, $expenseFor: ID!, $expenseTypeId: ID!, $name: String, $netAmount: Float!, $quantity: Float!, $quantityRate: Float!, $remark: String, $resourceUsed: Int) {
  addVehicleExpense(
    borneBy: $borneBy
    contractId: $contractId
    expenseFor: $expenseFor
    expenseTypeId: $expenseTypeId
    name: $name
    netAmount: $netAmount
    quantity: $quantity
    quantityRate: $quantityRate
    remark: $remark
    resourceUsed: $resourceUsed
  ) {
    expense {
      id
      borneBy
      netAmount
      quantity
      quantityRate
      expenseType {
        id
        name
      }
      remark
      resourceUsed
      contract {
        id
        number
      }
    }
  }
}
    `;
export type CreateVehicleExpenseMutationFn = Apollo.MutationFunction<CreateVehicleExpenseMutation, CreateVehicleExpenseMutationVariables>;

/**
 * __useCreateVehicleExpenseMutation__
 *
 * To run a mutation, you first call `useCreateVehicleExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleExpenseMutation, { data, loading, error }] = useCreateVehicleExpenseMutation({
 *   variables: {
 *      borneBy: // value for 'borneBy'
 *      contractId: // value for 'contractId'
 *      expenseFor: // value for 'expenseFor'
 *      expenseTypeId: // value for 'expenseTypeId'
 *      name: // value for 'name'
 *      netAmount: // value for 'netAmount'
 *      quantity: // value for 'quantity'
 *      quantityRate: // value for 'quantityRate'
 *      remark: // value for 'remark'
 *      resourceUsed: // value for 'resourceUsed'
 *   },
 * });
 */
export function useCreateVehicleExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateVehicleExpenseMutation, CreateVehicleExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVehicleExpenseMutation, CreateVehicleExpenseMutationVariables>(CreateVehicleExpenseDocument, options);
      }
export type CreateVehicleExpenseMutationHookResult = ReturnType<typeof useCreateVehicleExpenseMutation>;
export type CreateVehicleExpenseMutationResult = Apollo.MutationResult<CreateVehicleExpenseMutation>;
export type CreateVehicleExpenseMutationOptions = Apollo.BaseMutationOptions<CreateVehicleExpenseMutation, CreateVehicleExpenseMutationVariables>;
export const MakeVehiclePaymentDocument = gql`
    mutation MakeVehiclePayment($amount: Float!, $contractId: ID!, $name: String, $paidToId: ID!, $paymentFor: ID!, $paymentTypeId: ID!, $remark: String, $transactionType: String) {
  addVehiclePayment(
    name: $name
    amount: $amount
    paymentTypeId: $paymentTypeId
    paidToId: $paidToId
    contractId: $contractId
    remark: $remark
    transactionType: $transactionType
    paymentFor: $paymentFor
  ) {
    payment {
      id
      name
      amount
      paidTo {
        id
        fullName
      }
      contract {
        id
      }
      remark
      paymentType {
        id
        name
      }
      transactionType
    }
  }
}
    `;
export type MakeVehiclePaymentMutationFn = Apollo.MutationFunction<MakeVehiclePaymentMutation, MakeVehiclePaymentMutationVariables>;

/**
 * __useMakeVehiclePaymentMutation__
 *
 * To run a mutation, you first call `useMakeVehiclePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeVehiclePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeVehiclePaymentMutation, { data, loading, error }] = useMakeVehiclePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      contractId: // value for 'contractId'
 *      name: // value for 'name'
 *      paidToId: // value for 'paidToId'
 *      paymentFor: // value for 'paymentFor'
 *      paymentTypeId: // value for 'paymentTypeId'
 *      remark: // value for 'remark'
 *      transactionType: // value for 'transactionType'
 *   },
 * });
 */
export function useMakeVehiclePaymentMutation(baseOptions?: Apollo.MutationHookOptions<MakeVehiclePaymentMutation, MakeVehiclePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeVehiclePaymentMutation, MakeVehiclePaymentMutationVariables>(MakeVehiclePaymentDocument, options);
      }
export type MakeVehiclePaymentMutationHookResult = ReturnType<typeof useMakeVehiclePaymentMutation>;
export type MakeVehiclePaymentMutationResult = Apollo.MutationResult<MakeVehiclePaymentMutation>;
export type MakeVehiclePaymentMutationOptions = Apollo.BaseMutationOptions<MakeVehiclePaymentMutation, MakeVehiclePaymentMutationVariables>;
export const VehicleManagementVehicleDetailsDocument = gql`
    query VehicleManagementVehicleDetails($id: ID) {
  vehicleDetails(vehicleId: $id) {
    id
    registrationNumber
    modelName
    dateBought
    chassisNumber
    fuelTankCapacity
    estimatedAverage
    contracts {
      ...ContractFrag
    }
    currentContract {
      ...ContractFrag
    }
    vehicleType {
      id
      name
      category
      capacity
      capacityUnit {
        id
        name
      }
    }
    owner {
      id
    }
    driver {
      id
    }
  }
}
    ${ContractFragFragmentDoc}`;

/**
 * __useVehicleManagementVehicleDetailsQuery__
 *
 * To run a query within a React component, call `useVehicleManagementVehicleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleManagementVehicleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleManagementVehicleDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleManagementVehicleDetailsQuery(baseOptions?: Apollo.QueryHookOptions<VehicleManagementVehicleDetailsQuery, VehicleManagementVehicleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleManagementVehicleDetailsQuery, VehicleManagementVehicleDetailsQueryVariables>(VehicleManagementVehicleDetailsDocument, options);
      }
export function useVehicleManagementVehicleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleManagementVehicleDetailsQuery, VehicleManagementVehicleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleManagementVehicleDetailsQuery, VehicleManagementVehicleDetailsQueryVariables>(VehicleManagementVehicleDetailsDocument, options);
        }
export type VehicleManagementVehicleDetailsQueryHookResult = ReturnType<typeof useVehicleManagementVehicleDetailsQuery>;
export type VehicleManagementVehicleDetailsLazyQueryHookResult = ReturnType<typeof useVehicleManagementVehicleDetailsLazyQuery>;
export type VehicleManagementVehicleDetailsQueryResult = Apollo.QueryResult<VehicleManagementVehicleDetailsQuery, VehicleManagementVehicleDetailsQueryVariables>;
export const VehicleManagementOwnerDriverDetailsDocument = gql`
    query VehicleManagementOwnerDriverDetails($id: Int) {
  userDetails(userId: $id) {
    id
    fullName
    number
    email
    customerId
    dateOfBirth
    address {
      id
      village
      taluka
    }
    kycDetails {
      id
      photo
      idNumber
      kycType {
        id
        name
      }
    }
    bankDetails {
      id
      accountNumber
      accountHolderName
      ifscCode
      branchName
      bank {
        id
        name
      }
    }
    licenceDetails {
      id
      idNumber
      validTill
    }
  }
}
    `;

/**
 * __useVehicleManagementOwnerDriverDetailsQuery__
 *
 * To run a query within a React component, call `useVehicleManagementOwnerDriverDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleManagementOwnerDriverDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleManagementOwnerDriverDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleManagementOwnerDriverDetailsQuery(baseOptions?: Apollo.QueryHookOptions<VehicleManagementOwnerDriverDetailsQuery, VehicleManagementOwnerDriverDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleManagementOwnerDriverDetailsQuery, VehicleManagementOwnerDriverDetailsQueryVariables>(VehicleManagementOwnerDriverDetailsDocument, options);
      }
export function useVehicleManagementOwnerDriverDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleManagementOwnerDriverDetailsQuery, VehicleManagementOwnerDriverDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleManagementOwnerDriverDetailsQuery, VehicleManagementOwnerDriverDetailsQueryVariables>(VehicleManagementOwnerDriverDetailsDocument, options);
        }
export type VehicleManagementOwnerDriverDetailsQueryHookResult = ReturnType<typeof useVehicleManagementOwnerDriverDetailsQuery>;
export type VehicleManagementOwnerDriverDetailsLazyQueryHookResult = ReturnType<typeof useVehicleManagementOwnerDriverDetailsLazyQuery>;
export type VehicleManagementOwnerDriverDetailsQueryResult = Apollo.QueryResult<VehicleManagementOwnerDriverDetailsQuery, VehicleManagementOwnerDriverDetailsQueryVariables>;
export const ContractExpensesDocument = gql`
    query ContractExpenses($contractId: ID!) {
  contractExpenses(contractId: $contractId) {
    id
    quantity
    createdAt
    quantityRate
    netAmount
    borneBy
    resourceUsed
    expenseType {
      id
      name
    }
  }
}
    `;

/**
 * __useContractExpensesQuery__
 *
 * To run a query within a React component, call `useContractExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractExpensesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractExpensesQuery(baseOptions: Apollo.QueryHookOptions<ContractExpensesQuery, ContractExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractExpensesQuery, ContractExpensesQueryVariables>(ContractExpensesDocument, options);
      }
export function useContractExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractExpensesQuery, ContractExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractExpensesQuery, ContractExpensesQueryVariables>(ContractExpensesDocument, options);
        }
export type ContractExpensesQueryHookResult = ReturnType<typeof useContractExpensesQuery>;
export type ContractExpensesLazyQueryHookResult = ReturnType<typeof useContractExpensesLazyQuery>;
export type ContractExpensesQueryResult = Apollo.QueryResult<ContractExpensesQuery, ContractExpensesQueryVariables>;
export const ContractPaymentsDocument = gql`
    query ContractPayments($contractId: ID!) {
  contractPayments(contractId: $contractId) {
    id
    createdAt
    amount
    transactionType
    paidTo {
      id
      fullName
    }
    paymentType {
      id
      name
    }
  }
}
    `;

/**
 * __useContractPaymentsQuery__
 *
 * To run a query within a React component, call `useContractPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractPaymentsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractPaymentsQuery(baseOptions: Apollo.QueryHookOptions<ContractPaymentsQuery, ContractPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractPaymentsQuery, ContractPaymentsQueryVariables>(ContractPaymentsDocument, options);
      }
export function useContractPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractPaymentsQuery, ContractPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractPaymentsQuery, ContractPaymentsQueryVariables>(ContractPaymentsDocument, options);
        }
export type ContractPaymentsQueryHookResult = ReturnType<typeof useContractPaymentsQuery>;
export type ContractPaymentsLazyQueryHookResult = ReturnType<typeof useContractPaymentsLazyQuery>;
export type ContractPaymentsQueryResult = Apollo.QueryResult<ContractPaymentsQuery, ContractPaymentsQueryVariables>;
export const AddQuickVehicleMutationMutationDocument = gql`
    mutation AddQuickVehicleMutationMutation($driver: PureBaseUserInput, $owner: Int, $registrationNumber: String, $vehicleType: Int) {
  addQuickVehicle(
    driver: $driver
    owner: $owner
    registrationNumber: $registrationNumber
    vehicleType: $vehicleType
  ) {
    vehicle {
      ...ScheduleVehicleFrag
    }
  }
}
    ${ScheduleVehicleFragFragmentDoc}`;
export type AddQuickVehicleMutationMutationMutationFn = Apollo.MutationFunction<AddQuickVehicleMutationMutationMutation, AddQuickVehicleMutationMutationMutationVariables>;

/**
 * __useAddQuickVehicleMutationMutationMutation__
 *
 * To run a mutation, you first call `useAddQuickVehicleMutationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuickVehicleMutationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuickVehicleMutationMutationMutation, { data, loading, error }] = useAddQuickVehicleMutationMutationMutation({
 *   variables: {
 *      driver: // value for 'driver'
 *      owner: // value for 'owner'
 *      registrationNumber: // value for 'registrationNumber'
 *      vehicleType: // value for 'vehicleType'
 *   },
 * });
 */
export function useAddQuickVehicleMutationMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddQuickVehicleMutationMutationMutation, AddQuickVehicleMutationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuickVehicleMutationMutationMutation, AddQuickVehicleMutationMutationMutationVariables>(AddQuickVehicleMutationMutationDocument, options);
      }
export type AddQuickVehicleMutationMutationMutationHookResult = ReturnType<typeof useAddQuickVehicleMutationMutationMutation>;
export type AddQuickVehicleMutationMutationMutationResult = Apollo.MutationResult<AddQuickVehicleMutationMutationMutation>;
export type AddQuickVehicleMutationMutationMutationOptions = Apollo.BaseMutationOptions<AddQuickVehicleMutationMutationMutation, AddQuickVehicleMutationMutationMutationVariables>;
export const AddUpdateVehicleMutationDocument = gql`
    mutation AddUpdateVehicleMutation($chassisNumber: String, $dateBought: Date, $departments: [Int], $estimatedAverage: Float, $id: ID, $insurance: VehicleInsuranceInput, $modelName: String, $registrationNumber: String, $vehicleType: ID, $fuelTypeId: ID, $fuelTankCapacity: Float, $dimensions: [Float], $dimensionUnit: ID, $vehicleKind: String) {
  addUpdateVehicle(
    dimensions: $dimensions
    dimensionUnitId: $dimensionUnit
    chassisNumber: $chassisNumber
    dateBought: $dateBought
    departments: $departments
    estimatedAverage: $estimatedAverage
    id: $id
    insurance: $insurance
    modelName: $modelName
    registrationNumber: $registrationNumber
    vehicleTypeId: $vehicleType
    fuelTypeId: $fuelTypeId
    fuelTankCapacity: $fuelTankCapacity
    vehicleKind: $vehicleKind
  ) {
    vehicle {
      ...VehicleDetailsFrag
    }
  }
}
    ${VehicleDetailsFragFragmentDoc}`;
export type AddUpdateVehicleMutationMutationFn = Apollo.MutationFunction<AddUpdateVehicleMutationMutation, AddUpdateVehicleMutationMutationVariables>;

/**
 * __useAddUpdateVehicleMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdateVehicleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateVehicleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateVehicleMutationMutation, { data, loading, error }] = useAddUpdateVehicleMutationMutation({
 *   variables: {
 *      chassisNumber: // value for 'chassisNumber'
 *      dateBought: // value for 'dateBought'
 *      departments: // value for 'departments'
 *      estimatedAverage: // value for 'estimatedAverage'
 *      id: // value for 'id'
 *      insurance: // value for 'insurance'
 *      modelName: // value for 'modelName'
 *      registrationNumber: // value for 'registrationNumber'
 *      vehicleType: // value for 'vehicleType'
 *      fuelTypeId: // value for 'fuelTypeId'
 *      fuelTankCapacity: // value for 'fuelTankCapacity'
 *      dimensions: // value for 'dimensions'
 *      dimensionUnit: // value for 'dimensionUnit'
 *      vehicleKind: // value for 'vehicleKind'
 *   },
 * });
 */
export function useAddUpdateVehicleMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateVehicleMutationMutation, AddUpdateVehicleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateVehicleMutationMutation, AddUpdateVehicleMutationMutationVariables>(AddUpdateVehicleMutationDocument, options);
      }
export type AddUpdateVehicleMutationMutationHookResult = ReturnType<typeof useAddUpdateVehicleMutationMutation>;
export type AddUpdateVehicleMutationMutationResult = Apollo.MutationResult<AddUpdateVehicleMutationMutation>;
export type AddUpdateVehicleMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdateVehicleMutationMutation, AddUpdateVehicleMutationMutationVariables>;
export const AddUpdateVehicleOwnerMutationDocument = gql`
    mutation addUpdateVehicleOwnerMutation($owner: VehicleOwnerInput) {
  addUpdateVehicleOwner(owner: $owner) {
    owner {
      ...VehicleOwnerFrag
      fullName
    }
  }
}
    ${VehicleOwnerFragFragmentDoc}`;
export type AddUpdateVehicleOwnerMutationMutationFn = Apollo.MutationFunction<AddUpdateVehicleOwnerMutationMutation, AddUpdateVehicleOwnerMutationMutationVariables>;

/**
 * __useAddUpdateVehicleOwnerMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdateVehicleOwnerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateVehicleOwnerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateVehicleOwnerMutationMutation, { data, loading, error }] = useAddUpdateVehicleOwnerMutationMutation({
 *   variables: {
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useAddUpdateVehicleOwnerMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateVehicleOwnerMutationMutation, AddUpdateVehicleOwnerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateVehicleOwnerMutationMutation, AddUpdateVehicleOwnerMutationMutationVariables>(AddUpdateVehicleOwnerMutationDocument, options);
      }
export type AddUpdateVehicleOwnerMutationMutationHookResult = ReturnType<typeof useAddUpdateVehicleOwnerMutationMutation>;
export type AddUpdateVehicleOwnerMutationMutationResult = Apollo.MutationResult<AddUpdateVehicleOwnerMutationMutation>;
export type AddUpdateVehicleOwnerMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdateVehicleOwnerMutationMutation, AddUpdateVehicleOwnerMutationMutationVariables>;
export const AddUpdateVehicleDriverMutationDocument = gql`
    mutation AddUpdateVehicleDriverMutation($driver: VehicleDriverInput) {
  addUpdateVehicleDriver(driver: $driver) {
    driver {
      ...VehicleDriverFrag
      fullName
    }
  }
}
    ${VehicleDriverFragFragmentDoc}`;
export type AddUpdateVehicleDriverMutationMutationFn = Apollo.MutationFunction<AddUpdateVehicleDriverMutationMutation, AddUpdateVehicleDriverMutationMutationVariables>;

/**
 * __useAddUpdateVehicleDriverMutationMutation__
 *
 * To run a mutation, you first call `useAddUpdateVehicleDriverMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateVehicleDriverMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateVehicleDriverMutationMutation, { data, loading, error }] = useAddUpdateVehicleDriverMutationMutation({
 *   variables: {
 *      driver: // value for 'driver'
 *   },
 * });
 */
export function useAddUpdateVehicleDriverMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateVehicleDriverMutationMutation, AddUpdateVehicleDriverMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateVehicleDriverMutationMutation, AddUpdateVehicleDriverMutationMutationVariables>(AddUpdateVehicleDriverMutationDocument, options);
      }
export type AddUpdateVehicleDriverMutationMutationHookResult = ReturnType<typeof useAddUpdateVehicleDriverMutationMutation>;
export type AddUpdateVehicleDriverMutationMutationResult = Apollo.MutationResult<AddUpdateVehicleDriverMutationMutation>;
export type AddUpdateVehicleDriverMutationMutationOptions = Apollo.BaseMutationOptions<AddUpdateVehicleDriverMutationMutation, AddUpdateVehicleDriverMutationMutationVariables>;
export const DeleteVehicleMutationDocument = gql`
    mutation DeleteVehicleMutation($id: String) {
  delVehicle(vehicleId: $id) {
    vehicle {
      id
      registrationNumber
      status
    }
  }
}
    `;
export type DeleteVehicleMutationMutationFn = Apollo.MutationFunction<DeleteVehicleMutationMutation, DeleteVehicleMutationMutationVariables>;

/**
 * __useDeleteVehicleMutationMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleMutationMutation, { data, loading, error }] = useDeleteVehicleMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleMutationMutation, DeleteVehicleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleMutationMutation, DeleteVehicleMutationMutationVariables>(DeleteVehicleMutationDocument, options);
      }
export type DeleteVehicleMutationMutationHookResult = ReturnType<typeof useDeleteVehicleMutationMutation>;
export type DeleteVehicleMutationMutationResult = Apollo.MutationResult<DeleteVehicleMutationMutation>;
export type DeleteVehicleMutationMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleMutationMutation, DeleteVehicleMutationMutationVariables>;
export const UpdateVehicleStatusesDocument = gql`
    mutation UpdateVehicleStatuses($vehicles: [ID]!, $status: String!) {
  bulkUpdateVehicleStatus(status: $status, vehicles: $vehicles) {
    vehicles {
      id
      status
    }
  }
}
    `;
export type UpdateVehicleStatusesMutationFn = Apollo.MutationFunction<UpdateVehicleStatusesMutation, UpdateVehicleStatusesMutationVariables>;

/**
 * __useUpdateVehicleStatusesMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleStatusesMutation, { data, loading, error }] = useUpdateVehicleStatusesMutation({
 *   variables: {
 *      vehicles: // value for 'vehicles'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateVehicleStatusesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleStatusesMutation, UpdateVehicleStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleStatusesMutation, UpdateVehicleStatusesMutationVariables>(UpdateVehicleStatusesDocument, options);
      }
export type UpdateVehicleStatusesMutationHookResult = ReturnType<typeof useUpdateVehicleStatusesMutation>;
export type UpdateVehicleStatusesMutationResult = Apollo.MutationResult<UpdateVehicleStatusesMutation>;
export type UpdateVehicleStatusesMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleStatusesMutation, UpdateVehicleStatusesMutationVariables>;
export const BulkUpdateVehicleDepartmentsDocument = gql`
    mutation BulkUpdateVehicleDepartments($vehicles: [ID]!, $departments: [ID]!) {
  bulkAddVehicleDepartment(departments: $departments, vehicles: $vehicles) {
    vehicles {
      id
      departments {
        id
        name
      }
    }
  }
}
    `;
export type BulkUpdateVehicleDepartmentsMutationFn = Apollo.MutationFunction<BulkUpdateVehicleDepartmentsMutation, BulkUpdateVehicleDepartmentsMutationVariables>;

/**
 * __useBulkUpdateVehicleDepartmentsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateVehicleDepartmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateVehicleDepartmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateVehicleDepartmentsMutation, { data, loading, error }] = useBulkUpdateVehicleDepartmentsMutation({
 *   variables: {
 *      vehicles: // value for 'vehicles'
 *      departments: // value for 'departments'
 *   },
 * });
 */
export function useBulkUpdateVehicleDepartmentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateVehicleDepartmentsMutation, BulkUpdateVehicleDepartmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateVehicleDepartmentsMutation, BulkUpdateVehicleDepartmentsMutationVariables>(BulkUpdateVehicleDepartmentsDocument, options);
      }
export type BulkUpdateVehicleDepartmentsMutationHookResult = ReturnType<typeof useBulkUpdateVehicleDepartmentsMutation>;
export type BulkUpdateVehicleDepartmentsMutationResult = Apollo.MutationResult<BulkUpdateVehicleDepartmentsMutation>;
export type BulkUpdateVehicleDepartmentsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateVehicleDepartmentsMutation, BulkUpdateVehicleDepartmentsMutationVariables>;
export const BulkUpdateVehicleVendorsDocument = gql`
    mutation BulkUpdateVehicleVendors($userIds: [ID!]!, $status: String!) {
  bulkUpdateVehicleUsers(userIds: $userIds, status: $status) {
    users {
      id
      status
      __typename
    }
    __typename
  }
}
    `;
export type BulkUpdateVehicleVendorsMutationFn = Apollo.MutationFunction<BulkUpdateVehicleVendorsMutation, BulkUpdateVehicleVendorsMutationVariables>;

/**
 * __useBulkUpdateVehicleVendorsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateVehicleVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateVehicleVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateVehicleVendorsMutation, { data, loading, error }] = useBulkUpdateVehicleVendorsMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkUpdateVehicleVendorsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateVehicleVendorsMutation, BulkUpdateVehicleVendorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateVehicleVendorsMutation, BulkUpdateVehicleVendorsMutationVariables>(BulkUpdateVehicleVendorsDocument, options);
      }
export type BulkUpdateVehicleVendorsMutationHookResult = ReturnType<typeof useBulkUpdateVehicleVendorsMutation>;
export type BulkUpdateVehicleVendorsMutationResult = Apollo.MutationResult<BulkUpdateVehicleVendorsMutation>;
export type BulkUpdateVehicleVendorsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateVehicleVendorsMutation, BulkUpdateVehicleVendorsMutationVariables>;
export const AllVehicleListDocument = gql`
    query allVehicleList($query: String, $first: Int, $skip: Int) {
  allVehicles(query: $query, first: $first, skip: $skip) {
    ...VehicleListFrag
  }
}
    ${VehicleListFragFragmentDoc}`;

/**
 * __useAllVehicleListQuery__
 *
 * To run a query within a React component, call `useAllVehicleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehicleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehicleListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAllVehicleListQuery(baseOptions?: Apollo.QueryHookOptions<AllVehicleListQuery, AllVehicleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehicleListQuery, AllVehicleListQueryVariables>(AllVehicleListDocument, options);
      }
export function useAllVehicleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehicleListQuery, AllVehicleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehicleListQuery, AllVehicleListQueryVariables>(AllVehicleListDocument, options);
        }
export type AllVehicleListQueryHookResult = ReturnType<typeof useAllVehicleListQuery>;
export type AllVehicleListLazyQueryHookResult = ReturnType<typeof useAllVehicleListLazyQuery>;
export type AllVehicleListQueryResult = Apollo.QueryResult<AllVehicleListQuery, AllVehicleListQueryVariables>;
export const VehicleMasterListDocument = gql`
    query vehicleMasterList($query: String, $first: Int, $skip: Int, $departmentId: ID, $period: String, $startDate: Date, $endDate: Date) {
  vehicleList(
    query: $query
    first: $first
    skip: $skip
    departmentId: $departmentId
    period: $period
    startDate: $startDate
    endDate: $endDate
  ) {
    ...VehicleListFrag
  }
}
    ${VehicleListFragFragmentDoc}`;

/**
 * __useVehicleMasterListQuery__
 *
 * To run a query within a React component, call `useVehicleMasterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleMasterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleMasterListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      departmentId: // value for 'departmentId'
 *      period: // value for 'period'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useVehicleMasterListQuery(baseOptions?: Apollo.QueryHookOptions<VehicleMasterListQuery, VehicleMasterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleMasterListQuery, VehicleMasterListQueryVariables>(VehicleMasterListDocument, options);
      }
export function useVehicleMasterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleMasterListQuery, VehicleMasterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleMasterListQuery, VehicleMasterListQueryVariables>(VehicleMasterListDocument, options);
        }
export type VehicleMasterListQueryHookResult = ReturnType<typeof useVehicleMasterListQuery>;
export type VehicleMasterListLazyQueryHookResult = ReturnType<typeof useVehicleMasterListLazyQuery>;
export type VehicleMasterListQueryResult = Apollo.QueryResult<VehicleMasterListQuery, VehicleMasterListQueryVariables>;
export const VehicleDetailsQueryDocument = gql`
    query vehicleDetailsQuery($id: ID!) {
  vehicleDetails(vehicleId: $id) {
    ...VehicleDetailsFrag
  }
}
    ${VehicleDetailsFragFragmentDoc}`;

/**
 * __useVehicleDetailsQueryQuery__
 *
 * To run a query within a React component, call `useVehicleDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleDetailsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<VehicleDetailsQueryQuery, VehicleDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleDetailsQueryQuery, VehicleDetailsQueryQueryVariables>(VehicleDetailsQueryDocument, options);
      }
export function useVehicleDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleDetailsQueryQuery, VehicleDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleDetailsQueryQuery, VehicleDetailsQueryQueryVariables>(VehicleDetailsQueryDocument, options);
        }
export type VehicleDetailsQueryQueryHookResult = ReturnType<typeof useVehicleDetailsQueryQuery>;
export type VehicleDetailsQueryLazyQueryHookResult = ReturnType<typeof useVehicleDetailsQueryLazyQuery>;
export type VehicleDetailsQueryQueryResult = Apollo.QueryResult<VehicleDetailsQueryQuery, VehicleDetailsQueryQueryVariables>;
export const VehicleOwnerDetailsQueryDocument = gql`
    query vehicleOwnerDetailsQuery($id: Int) {
  userDetails(userId: $id) {
    ...VehicleOwnerFrag
  }
}
    ${VehicleOwnerFragFragmentDoc}`;

/**
 * __useVehicleOwnerDetailsQueryQuery__
 *
 * To run a query within a React component, call `useVehicleOwnerDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleOwnerDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleOwnerDetailsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleOwnerDetailsQueryQuery(baseOptions?: Apollo.QueryHookOptions<VehicleOwnerDetailsQueryQuery, VehicleOwnerDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleOwnerDetailsQueryQuery, VehicleOwnerDetailsQueryQueryVariables>(VehicleOwnerDetailsQueryDocument, options);
      }
export function useVehicleOwnerDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleOwnerDetailsQueryQuery, VehicleOwnerDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleOwnerDetailsQueryQuery, VehicleOwnerDetailsQueryQueryVariables>(VehicleOwnerDetailsQueryDocument, options);
        }
export type VehicleOwnerDetailsQueryQueryHookResult = ReturnType<typeof useVehicleOwnerDetailsQueryQuery>;
export type VehicleOwnerDetailsQueryLazyQueryHookResult = ReturnType<typeof useVehicleOwnerDetailsQueryLazyQuery>;
export type VehicleOwnerDetailsQueryQueryResult = Apollo.QueryResult<VehicleOwnerDetailsQueryQuery, VehicleOwnerDetailsQueryQueryVariables>;
export const VehicleDriverDetailsQueryDocument = gql`
    query vehicleDriverDetailsQuery($id: Int) {
  userDetails(userId: $id) {
    ...VehicleDriverFrag
  }
}
    ${VehicleDriverFragFragmentDoc}`;

/**
 * __useVehicleDriverDetailsQueryQuery__
 *
 * To run a query within a React component, call `useVehicleDriverDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleDriverDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleDriverDetailsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleDriverDetailsQueryQuery(baseOptions?: Apollo.QueryHookOptions<VehicleDriverDetailsQueryQuery, VehicleDriverDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleDriverDetailsQueryQuery, VehicleDriverDetailsQueryQueryVariables>(VehicleDriverDetailsQueryDocument, options);
      }
export function useVehicleDriverDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleDriverDetailsQueryQuery, VehicleDriverDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleDriverDetailsQueryQuery, VehicleDriverDetailsQueryQueryVariables>(VehicleDriverDetailsQueryDocument, options);
        }
export type VehicleDriverDetailsQueryQueryHookResult = ReturnType<typeof useVehicleDriverDetailsQueryQuery>;
export type VehicleDriverDetailsQueryLazyQueryHookResult = ReturnType<typeof useVehicleDriverDetailsQueryLazyQuery>;
export type VehicleDriverDetailsQueryQueryResult = Apollo.QueryResult<VehicleDriverDetailsQueryQuery, VehicleDriverDetailsQueryQueryVariables>;
export const AllVehiclesListDocument = gql`
    query AllVehiclesList($query: String, $first: Int, $skip: Int, $filter: AllVehicleFilterInput) {
  allVehiclesDetail(query: $query, first: $first, skip: $skip, filter: $filter) {
    ...AllVehicleListFrag
  }
}
    ${AllVehicleListFragFragmentDoc}`;

/**
 * __useAllVehiclesListQuery__
 *
 * To run a query within a React component, call `useAllVehiclesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehiclesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehiclesListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllVehiclesListQuery(baseOptions?: Apollo.QueryHookOptions<AllVehiclesListQuery, AllVehiclesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehiclesListQuery, AllVehiclesListQueryVariables>(AllVehiclesListDocument, options);
      }
export function useAllVehiclesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehiclesListQuery, AllVehiclesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehiclesListQuery, AllVehiclesListQueryVariables>(AllVehiclesListDocument, options);
        }
export type AllVehiclesListQueryHookResult = ReturnType<typeof useAllVehiclesListQuery>;
export type AllVehiclesListLazyQueryHookResult = ReturnType<typeof useAllVehiclesListLazyQuery>;
export type AllVehiclesListQueryResult = Apollo.QueryResult<AllVehiclesListQuery, AllVehiclesListQueryVariables>;
export const AllVehiclesSummaryDocument = gql`
    query AllVehiclesSummary($departmentId: ID!, $date: Date, $distributionCenterId: ID) {
  summaryAllVehicle(
    departmentId: $departmentId
    date: $date
    distributionCenterId: $distributionCenterId
  ) {
    totalVehicles
    usableVehicles
    unusableVehicles
    availableVehicles
    unavailableVehicles
    plannedVehicles
    unplannedVehicles
    breakdownVehicles
    onleaveVehicles
    archivedVehicles
  }
}
    `;

/**
 * __useAllVehiclesSummaryQuery__
 *
 * To run a query within a React component, call `useAllVehiclesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehiclesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehiclesSummaryQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      date: // value for 'date'
 *      distributionCenterId: // value for 'distributionCenterId'
 *   },
 * });
 */
export function useAllVehiclesSummaryQuery(baseOptions: Apollo.QueryHookOptions<AllVehiclesSummaryQuery, AllVehiclesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehiclesSummaryQuery, AllVehiclesSummaryQueryVariables>(AllVehiclesSummaryDocument, options);
      }
export function useAllVehiclesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehiclesSummaryQuery, AllVehiclesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehiclesSummaryQuery, AllVehiclesSummaryQueryVariables>(AllVehiclesSummaryDocument, options);
        }
export type AllVehiclesSummaryQueryHookResult = ReturnType<typeof useAllVehiclesSummaryQuery>;
export type AllVehiclesSummaryLazyQueryHookResult = ReturnType<typeof useAllVehiclesSummaryLazyQuery>;
export type AllVehiclesSummaryQueryResult = Apollo.QueryResult<AllVehiclesSummaryQuery, AllVehiclesSummaryQueryVariables>;
export const AddUpdateVendorDocument = gql`
    mutation AddUpdateVendor($deleteKycIds: [ID], $address: AddressInput!, $dateOfBirth: Date, $education: BaseUserEducationEnum, $email: String, $firstName: String!, $gender: BaseUserGenderEnum, $groups: [ID], $id: ID, $kycDetail: [KYCDetailInput], $lastName: String!, $number: String!, $referenceId: String, $businessName: String, $businessId: ID, $username: String!) {
  addUpdateVendor(
    address: $address
    dateOfBirth: $dateOfBirth
    education: $education
    email: $email
    firstName: $firstName
    gender: $gender
    groups: $groups
    id: $id
    kycDetails: $kycDetail
    lastName: $lastName
    number: $number
    referenceId: $referenceId
    businessName: $businessName
    businessId: $businessId
    username: $username
    deleteKycIds: $deleteKycIds
  ) {
    user {
      ...VendorDetailFrag
    }
  }
}
    ${VendorDetailFragFragmentDoc}`;
export type AddUpdateVendorMutationFn = Apollo.MutationFunction<AddUpdateVendorMutation, AddUpdateVendorMutationVariables>;

/**
 * __useAddUpdateVendorMutation__
 *
 * To run a mutation, you first call `useAddUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateVendorMutation, { data, loading, error }] = useAddUpdateVendorMutation({
 *   variables: {
 *      deleteKycIds: // value for 'deleteKycIds'
 *      address: // value for 'address'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      education: // value for 'education'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      gender: // value for 'gender'
 *      groups: // value for 'groups'
 *      id: // value for 'id'
 *      kycDetail: // value for 'kycDetail'
 *      lastName: // value for 'lastName'
 *      number: // value for 'number'
 *      referenceId: // value for 'referenceId'
 *      businessName: // value for 'businessName'
 *      businessId: // value for 'businessId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useAddUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateVendorMutation, AddUpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateVendorMutation, AddUpdateVendorMutationVariables>(AddUpdateVendorDocument, options);
      }
export type AddUpdateVendorMutationHookResult = ReturnType<typeof useAddUpdateVendorMutation>;
export type AddUpdateVendorMutationResult = Apollo.MutationResult<AddUpdateVendorMutation>;
export type AddUpdateVendorMutationOptions = Apollo.BaseMutationOptions<AddUpdateVendorMutation, AddUpdateVendorMutationVariables>;
export const BulkUpdateVendorsDocument = gql`
    mutation bulkUpdateVendors($userIds: [ID!]!, $status: String!) {
  bulkUpdateUsers(userIds: $userIds, status: $status) {
    users {
      id
      status
      statusObj @client {
        id
        intent
        name
      }
    }
  }
}
    `;
export type BulkUpdateVendorsMutationFn = Apollo.MutationFunction<BulkUpdateVendorsMutation, BulkUpdateVendorsMutationVariables>;

/**
 * __useBulkUpdateVendorsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateVendorsMutation, { data, loading, error }] = useBulkUpdateVendorsMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBulkUpdateVendorsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateVendorsMutation, BulkUpdateVendorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateVendorsMutation, BulkUpdateVendorsMutationVariables>(BulkUpdateVendorsDocument, options);
      }
export type BulkUpdateVendorsMutationHookResult = ReturnType<typeof useBulkUpdateVendorsMutation>;
export type BulkUpdateVendorsMutationResult = Apollo.MutationResult<BulkUpdateVendorsMutation>;
export type BulkUpdateVendorsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateVendorsMutation, BulkUpdateVendorsMutationVariables>;
export const AddUpdateUserCreditDocument = gql`
    mutation AddUpdateUserCredit($id: ID, $userId: ID!, $totalAmount: Float!, $paymentCycleDays: Int, $startDate: Date, $endDate: Date, $isActive: Boolean, $status: String) {
  addUpdateCredit(
    id: $id
    userId: $userId
    totalAmount: $totalAmount
    paymentCycleDays: $paymentCycleDays
    startDate: $startDate
    endDate: $endDate
    isActive: $isActive
    status: $status
  ) {
    credit {
      id
      totalAmount
      remainingAmount
      usedAmount
      paymentCycleDays
      startDate
      endDate
      isActive
      status
      user {
        id
        firstName
      }
    }
  }
}
    `;
export type AddUpdateUserCreditMutationFn = Apollo.MutationFunction<AddUpdateUserCreditMutation, AddUpdateUserCreditMutationVariables>;

/**
 * __useAddUpdateUserCreditMutation__
 *
 * To run a mutation, you first call `useAddUpdateUserCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateUserCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateUserCreditMutation, { data, loading, error }] = useAddUpdateUserCreditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      totalAmount: // value for 'totalAmount'
 *      paymentCycleDays: // value for 'paymentCycleDays'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isActive: // value for 'isActive'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAddUpdateUserCreditMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateUserCreditMutation, AddUpdateUserCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateUserCreditMutation, AddUpdateUserCreditMutationVariables>(AddUpdateUserCreditDocument, options);
      }
export type AddUpdateUserCreditMutationHookResult = ReturnType<typeof useAddUpdateUserCreditMutation>;
export type AddUpdateUserCreditMutationResult = Apollo.MutationResult<AddUpdateUserCreditMutation>;
export type AddUpdateUserCreditMutationOptions = Apollo.BaseMutationOptions<AddUpdateUserCreditMutation, AddUpdateUserCreditMutationVariables>;
export const VendorListDocument = gql`
    query VendorList($query: String, $departmentId: ID, $groupName: String, $status: String, $first: Int, $skip: Int, $filter: UsersByGroupFilterInput) {
  usersByGroup(
    query: $query
    departmentId: $departmentId
    groupName: $groupName
    status: $status
    first: $first
    skip: $skip
    filter: $filter
  ) {
    id
    fullName
    number
    isBlocked
    shopsManaged {
      id
      name
    }
    blockRemark
    status
    statusObj @client {
      id
      name
      intent
    }
    accounts(first: 1, accountType_Codename: "d2f-wallet") {
      id
      balance
      name
      codename
      accountType {
        id
        name
      }
    }
    address {
      id
      village
      address
      district
    }
    groups {
      id
      category {
        id
        codename
      }
      name
    }
    customerId
    createdAt
  }
}
    `;

/**
 * __useVendorListQuery__
 *
 * To run a query within a React component, call `useVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      departmentId: // value for 'departmentId'
 *      groupName: // value for 'groupName'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVendorListQuery(baseOptions?: Apollo.QueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
      }
export function useVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
        }
export type VendorListQueryHookResult = ReturnType<typeof useVendorListQuery>;
export type VendorListLazyQueryHookResult = ReturnType<typeof useVendorListLazyQuery>;
export type VendorListQueryResult = Apollo.QueryResult<VendorListQuery, VendorListQueryVariables>;
export const VendorDetailDocument = gql`
    query VendorDetail($id: Int) {
  userDetails(userId: $id) {
    ...VendorDetailFrag
    creditSet {
      id
      totalAmount
      remainingAmount
      usedAmount
      paymentCycleDays
      startDate
      endDate
      isActive
      status
    }
  }
}
    ${VendorDetailFragFragmentDoc}`;

/**
 * __useVendorDetailQuery__
 *
 * To run a query within a React component, call `useVendorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVendorDetailQuery(baseOptions?: Apollo.QueryHookOptions<VendorDetailQuery, VendorDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorDetailQuery, VendorDetailQueryVariables>(VendorDetailDocument, options);
      }
export function useVendorDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorDetailQuery, VendorDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorDetailQuery, VendorDetailQueryVariables>(VendorDetailDocument, options);
        }
export type VendorDetailQueryHookResult = ReturnType<typeof useVendorDetailQuery>;
export type VendorDetailLazyQueryHookResult = ReturnType<typeof useVendorDetailLazyQuery>;
export type VendorDetailQueryResult = Apollo.QueryResult<VendorDetailQuery, VendorDetailQueryVariables>;
export const VendorMapListDocument = gql`
    query VendorMapList($query: String, $departmentId: ID, $groupName: String, $status: String, $first: Int, $skip: Int, $filter: UsersByGroupFilterInput) {
  usersByGroup(
    query: $query
    departmentId: $departmentId
    groupName: $groupName
    status: $status
    first: $first
    skip: $skip
    filter: $filter
  ) {
    id
    fullName
    number
    address {
      id
      village
      address
      district
      latitude
      longitude
    }
    status
  }
}
    `;

/**
 * __useVendorMapListQuery__
 *
 * To run a query within a React component, call `useVendorMapListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorMapListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorMapListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      departmentId: // value for 'departmentId'
 *      groupName: // value for 'groupName'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVendorMapListQuery(baseOptions?: Apollo.QueryHookOptions<VendorMapListQuery, VendorMapListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorMapListQuery, VendorMapListQueryVariables>(VendorMapListDocument, options);
      }
export function useVendorMapListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorMapListQuery, VendorMapListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorMapListQuery, VendorMapListQueryVariables>(VendorMapListDocument, options);
        }
export type VendorMapListQueryHookResult = ReturnType<typeof useVendorMapListQuery>;
export type VendorMapListLazyQueryHookResult = ReturnType<typeof useVendorMapListLazyQuery>;
export type VendorMapListQueryResult = Apollo.QueryResult<VendorMapListQuery, VendorMapListQueryVariables>;
export const VendorsSummaryDocument = gql`
    query VendorsSummary($latestDays: Int, $filter: SummaryUsersEcomFilterInput) {
  summaryUsersEcom(latestDays: $latestDays, filter: $filter) {
    activeCustomers
    inactiveCustomers
    totalCustomers
    verifiedCustomers
    notVerifiedCustomers
  }
}
    `;

/**
 * __useVendorsSummaryQuery__
 *
 * To run a query within a React component, call `useVendorsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsSummaryQuery({
 *   variables: {
 *      latestDays: // value for 'latestDays'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useVendorsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<VendorsSummaryQuery, VendorsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorsSummaryQuery, VendorsSummaryQueryVariables>(VendorsSummaryDocument, options);
      }
export function useVendorsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsSummaryQuery, VendorsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorsSummaryQuery, VendorsSummaryQueryVariables>(VendorsSummaryDocument, options);
        }
export type VendorsSummaryQueryHookResult = ReturnType<typeof useVendorsSummaryQuery>;
export type VendorsSummaryLazyQueryHookResult = ReturnType<typeof useVendorsSummaryLazyQuery>;
export type VendorsSummaryQueryResult = Apollo.QueryResult<VendorsSummaryQuery, VendorsSummaryQueryVariables>;
export const TransactionsDocument = gql`
    query Transactions($filter: TransactionDetailInput, $skip: Int, $first: Int, $query: String) {
  allAccountTransactions(
    first: $first
    skip: $skip
    query: $query
    filter: $filter
  ) {
    id
    date
    account {
      name
      balance
      codename
      id
    }
    status
    amount
    paymentMethod {
      codename
      id
      name
    }
    transactionType {
      id
      name
    }
    referenceId
    remark
    attachments {
      id
      url
    }
  }
}
    `;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const AccountStatementDocument = gql`
    query AccountStatement($userId: ID!, $dateFrom: Date, $dateTo: Date) {
  accountStatement(userId: $userId, dateFrom: $dateFrom, dateTo: $dateTo) {
    customer {
      id
      accountNumber
      businessName
      pocName
      mobileNumber
      email
      address
      district
      state
      pincode
      gstin
      isActive
      isBlocked
      vendorTypes
    }
    issuer {
      name
      address
      gstin
      cin
      pan
      number
      email
      website
    }
    dateFrom
    dateTo
    statementDate
    currency
    openingBalance
    totalDebit
    totalCredit
    closingBalance
    creditLimit
    creditUsed
    transactions {
      date
      docNumber
      docType
      invoiceNo
      taxableValue
      gstValue
      withholdingTax
      debitAmount
      creditAmount
      closingBalance
    }
  }
}
    `;

/**
 * __useAccountStatementQuery__
 *
 * To run a query within a React component, call `useAccountStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStatementQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useAccountStatementQuery(baseOptions: Apollo.QueryHookOptions<AccountStatementQuery, AccountStatementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountStatementQuery, AccountStatementQueryVariables>(AccountStatementDocument, options);
      }
export function useAccountStatementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountStatementQuery, AccountStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountStatementQuery, AccountStatementQueryVariables>(AccountStatementDocument, options);
        }
export type AccountStatementQueryHookResult = ReturnType<typeof useAccountStatementQuery>;
export type AccountStatementLazyQueryHookResult = ReturnType<typeof useAccountStatementLazyQuery>;
export type AccountStatementQueryResult = Apollo.QueryResult<AccountStatementQuery, AccountStatementQueryVariables>;
export const OutstandingUserDetailDocument = gql`
    query OutstandingUserDetail($userId: ID!, $filter: OutstandingOrderDateFilterInput) {
  outstandingUserDetail(userId: $userId, filter: $filter) {
    user {
      id
      firstName
      lastName
      number
      address {
        id
        village
        address
        district
        pincode
      }
      groups {
        id
        category {
          id
          codename
        }
        name
      }
    }
    shops {
      id
      name
      number
      address {
        id
        village
        address
        district
        pincode
      }
    }
    orders {
      ...OrderListFrag
      date
      shop {
        id
        name
      }
    }
    totalOutstandingOrders
    grossOrderValue
    totalOutstandingAmount
  }
}
    ${OrderListFragFragmentDoc}`;

/**
 * __useOutstandingUserDetailQuery__
 *
 * To run a query within a React component, call `useOutstandingUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingUserDetailQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOutstandingUserDetailQuery(baseOptions: Apollo.QueryHookOptions<OutstandingUserDetailQuery, OutstandingUserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutstandingUserDetailQuery, OutstandingUserDetailQueryVariables>(OutstandingUserDetailDocument, options);
      }
export function useOutstandingUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutstandingUserDetailQuery, OutstandingUserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutstandingUserDetailQuery, OutstandingUserDetailQueryVariables>(OutstandingUserDetailDocument, options);
        }
export type OutstandingUserDetailQueryHookResult = ReturnType<typeof useOutstandingUserDetailQuery>;
export type OutstandingUserDetailLazyQueryHookResult = ReturnType<typeof useOutstandingUserDetailLazyQuery>;
export type OutstandingUserDetailQueryResult = Apollo.QueryResult<OutstandingUserDetailQuery, OutstandingUserDetailQueryVariables>;
export const FetchBatchStockStatusDocument = gql`
    query FetchBatchStockStatus {
  fetchBatchStockStatus {
    taskId
    status
    requestedAt
    executedAt
    isExecuted
    canExecute
    retryAfterSeconds
  }
}
    `;

/**
 * __useFetchBatchStockStatusQuery__
 *
 * To run a query within a React component, call `useFetchBatchStockStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBatchStockStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBatchStockStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchBatchStockStatusQuery(baseOptions?: Apollo.QueryHookOptions<FetchBatchStockStatusQuery, FetchBatchStockStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBatchStockStatusQuery, FetchBatchStockStatusQueryVariables>(FetchBatchStockStatusDocument, options);
      }
export function useFetchBatchStockStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBatchStockStatusQuery, FetchBatchStockStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBatchStockStatusQuery, FetchBatchStockStatusQueryVariables>(FetchBatchStockStatusDocument, options);
        }
export type FetchBatchStockStatusQueryHookResult = ReturnType<typeof useFetchBatchStockStatusQuery>;
export type FetchBatchStockStatusLazyQueryHookResult = ReturnType<typeof useFetchBatchStockStatusLazyQuery>;
export type FetchBatchStockStatusQueryResult = Apollo.QueryResult<FetchBatchStockStatusQuery, FetchBatchStockStatusQueryVariables>;
export const MutFetchBatchStockDocument = gql`
    mutation MutFetchBatchStock($interval: Int!) {
  fetchBatchStock(interval: $interval) {
    success
    taskId
  }
}
    `;
export type MutFetchBatchStockMutationFn = Apollo.MutationFunction<MutFetchBatchStockMutation, MutFetchBatchStockMutationVariables>;

/**
 * __useMutFetchBatchStockMutation__
 *
 * To run a mutation, you first call `useMutFetchBatchStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutFetchBatchStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutFetchBatchStockMutation, { data, loading, error }] = useMutFetchBatchStockMutation({
 *   variables: {
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useMutFetchBatchStockMutation(baseOptions?: Apollo.MutationHookOptions<MutFetchBatchStockMutation, MutFetchBatchStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutFetchBatchStockMutation, MutFetchBatchStockMutationVariables>(MutFetchBatchStockDocument, options);
      }
export type MutFetchBatchStockMutationHookResult = ReturnType<typeof useMutFetchBatchStockMutation>;
export type MutFetchBatchStockMutationResult = Apollo.MutationResult<MutFetchBatchStockMutation>;
export type MutFetchBatchStockMutationOptions = Apollo.BaseMutationOptions<MutFetchBatchStockMutation, MutFetchBatchStockMutationVariables>;